webpackJsonp([2],{

/***/ "+7Ds":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/fmQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1ZJi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginbac.40c578d.png";

/***/ }),

/***/ "1qEj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2P/j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3Yhd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "6pZO":
/***/ (function(module, exports) {

window._iconfont_svg_string_2473442 = '<svg><symbol id="iconzhifu" viewBox="0 0 1024 1024"><path d="M353.745455 812.218182c-93.090909-53.527273-155.927273-144.290909-169.89091-251.345455-25.6-186.181818 107.054545-358.4 293.236364-381.672727 20.945455-2.327273 34.909091-20.945455 32.581818-39.563636s-20.945455-32.581818-39.563636-30.254546C246.690909 139.636364 86.109091 346.763636 116.363636 570.181818c13.963636 100.072727 60.509091 188.509091 132.654546 251.345455H165.236364c-18.618182 0-34.909091 16.290909-34.909091 34.909091s16.290909 34.909091 34.909091 34.909091H337.454545c18.618182-2.327273 32.581818-16.290909 37.236364-34.909091 4.654545-16.290909-4.654545-34.909091-20.945454-44.218182zM930.909091 463.127273c-13.963636-102.4-65.163636-195.490909-141.963636-260.654546h74.472727c18.618182 0 34.909091-16.290909 34.909091-34.909091s-16.290909-34.909091-34.909091-34.909091H695.854545c-18.618182 2.327273-32.581818 16.290909-37.236363 34.909091-2.327273 18.618182 4.654545 37.236364 23.272727 46.545455 97.745455 51.2 165.236364 148.945455 181.527273 258.327273 25.6 186.181818-107.054545 358.4-293.236364 381.672727-18.618182 2.327273-32.581818 20.945455-30.254545 39.563636 2.327273 18.618182 16.290909 30.254545 34.909091 30.254546h4.654545c223.418182-30.254545 381.672727-237.381818 351.418182-460.8z" fill="#1296db" ></path><path d="M553.890909 702.836364v-86.109091h55.854546c16.290909 0 30.254545-13.963636 30.254545-30.254546 0-16.290909-13.963636-30.254545-30.254545-30.254545h-55.854546v-25.6h58.181818c16.290909 0 30.254545-13.963636 30.254546-30.254546 0-16.290909-13.963636-30.254545-30.254546-30.254545h-46.545454l79.127272-114.036364c13.963636-20.945455 0-48.872727-25.6-48.872727-11.636364 0-20.945455 4.654545-25.6 13.963636l-67.490909 100.072728-76.8-100.072728c-6.981818-6.981818-16.290909-11.636364-25.6-11.636363-25.6 0-39.563636 27.927273-25.6 48.872727l81.454546 111.709091h-46.545455c-16.290909 0-30.254545 13.963636-30.254545 30.254545 0 16.290909 13.963636 30.254545 30.254545 30.254546H488.727273v25.6h-55.854546c-16.290909 0-30.254545 13.963636-30.254545 30.254545s13.963636 30.254545 30.254545 30.254546H488.727273v86.109091c0 18.618182 16.290909 34.909091 34.909091 34.909091 13.963636 0 30.254545-16.290909 30.254545-34.909091z" fill="#1296db" ></path></symbol><symbol id="icongongzuo" viewBox="0 0 1024 1024"><path d="M812 896h-600A100.144 100.144 0 0 1 112 795.744v-451.2a100.128 100.128 0 0 1 100-100.272h150v-50.128A50.064 50.064 0 0 1 412 144h200a50.064 50.064 0 0 1 50 50.128v50.128h150A100.128 100.128 0 0 1 912 344.544v451.2A100.144 100.144 0 0 1 812 896z m-200-676.8a25.04 25.04 0 0 0-24.992-25.072h-150A25.04 25.04 0 0 0 412 219.2v25.072h200V219.2z m250 125.328A50.064 50.064 0 0 0 812 294.4h-600a50.064 50.064 0 0 0-50 50.128v125.328h700v-125.312z m-400 200.528a50 50 0 1 0 93.072-25.056h-86.128a49.712 49.712 0 0 0-6.944 25.072z m400-25.072H608.464a100 100 0 1 1-192.928 0H162v275.76a50.064 50.064 0 0 0 50 50.128h600a50.064 50.064 0 0 0 50-50.128V520z" fill="#1296db" ></path></symbol><symbol id="icondefault" viewBox="0 0 1024 1024"><path d="M739.2 938.2c-3.1 0-6.2-1.4-8.1-4.1-0.5-0.6-43.9-60.9-76.1-112.2-45.8 44.1-114.2 69-198.7 72.1-71.7 2.7-154.1-10.7-231.8-37.6-75.1-26-139.5-62.2-181.4-101.7-2.1-2-3.2-4.7-3.1-7.6 1.8-62 16.2-133.8 42.7-213.3C106.3 463 139.3 387.7 178 316c36.9-68.3 77.4-130.5 117.2-179.9 41.2-51.2 79.4-85.7 110.5-99.8 0.4-0.2 0.8-0.3 1.1-0.4 93.5-29.3 191.3 0.2 251.6 37.5 1.8 1.1 3.1 2.7 3.9 4.6 10 23.3 2 59.6-21.3 97.2-15.1 24.2-35.2 46.6-56.8 62.9-24.8 18.9-51.2 29.5-76.3 30.9-2.4 0.1-4.7-0.6-6.6-2-35.8-27.1-45.6-46.6-54.1-63.8-2.2-4.5-4.4-8.8-6.9-12.9-5.1-5.2-11.9-10.7-16.7-8.8-3.4 1.4-15.2 9.9-24.6 62.9-8.5 48.4-13 122.3-13.5 220 51.7-25.1 114.2-31.5 167.2-16.3 40.4 11.6 71.8 35 88.5 66 17.4 19.4 46.5 57.9 80.2 102.3 41.4 54.7 88.4 116.7 131.2 167.1 59.6 70 85.5 86.9 96.8 88.7 5.5 0.9 9.2 6 8.3 11.4-0.9 5.5-6 9.2-11.4 8.3-43.6-7-131.1-118.4-240.9-263.4-33.9-44.8-63.2-83.4-79.9-101.8-0.6-0.6-1.1-1.3-1.5-2.1-14.2-27.1-40.8-46.9-76.9-57.2-53.2-15.2-117.1-6.6-166.7 22.4-3.1 1.8-6.9 1.8-10 0s-5-5.1-5-8.7c0-107.2 4.7-188 13.8-240.2 8.2-46.5 19.9-71.2 36.8-78 12.3-4.9 25.6-0.1 39.3 14.3 0.5 0.5 0.9 1 1.2 1.6 3.2 5.2 5.8 10.4 8.3 15.4 7.7 15.5 15.7 31.5 45.3 54.5 48.3-4.6 91.3-47.8 113.8-84.1 18.3-29.4 26.2-58.7 20.9-76-56.7-34.1-146.2-60.3-231.6-33.8-28.2 13-63.7 45.4-102.6 93.8-39 48.4-78.8 109.6-115.2 176.8C114 476.8 64.7 628.6 60.2 743.2c86 78.7 258.4 135.9 395.4 130.8 84.9-3.2 151.9-29.1 193.8-75.1 2.1-2.3 5.2-3.5 8.3-3.2 3.1 0.3 5.9 2.1 7.6 4.7 32.1 52.7 81.6 121.2 82 121.9 3.2 4.5 2.2 10.7-2.3 14-1.7 1.3-3.7 1.9-5.8 1.9z" fill="#1296db" ></path><path d="M974 548.3c-3.5 0-6.9-1.8-8.7-5.1-0.1-0.2-12.9-22.8-36.5-46.6-21.4-21.5-56.3-48.5-101.3-54.7-59.3-8.2-122.3 20.4-187.4 85.1-3.9 3.9-10.2 3.9-14.1 0-3.9-3.9-3.9-10.2 0-14.1 69.8-69.4 138.6-99.9 204.4-90.7 40.2 5.6 79.3 26.7 113.1 60.9 25.3 25.6 38.8 49.4 39.3 50.4 2.7 4.8 1 10.9-3.8 13.6-1.7 0.8-3.3 1.2-5 1.2z" fill="#1296db" ></path><path d="M465.1 732c-19.6 0-37.7-3.6-53.4-8.6-48.1-15.2-81.8-45-83.2-46.2l13.3-14.9c0.3 0.3 32.3 28.5 76.4 42.3 57.6 18 108.4 4 150.8-41.6l14.6 13.6c-39.2 42.3-81.4 55.4-118.5 55.4z" fill="#1296db" ></path></symbol><symbol id="iconmycar" viewBox="0 0 1024 1024"><path d="M604.8 321.6L768 512H416V288h115.84c28.16 0 54.72 12.16 72.96 33.6zM352 736c0 53.12-42.88 96-96 96s-96-42.88-96-96 42.88-96 96-96 96 42.88 96 96zM768 640c53.12 0 96 42.88 96 96s-42.88 96-96 96-96-42.88-96-96 42.88-96 96-96z" fill="#E0EBFE" ></path><path d="M800 480h-17.28l-153.536-179.136A127.488 127.488 0 0 0 531.84 256H311.68a128 128 0 0 0-110.976 64.416L109.44 480H64c-35.296 0-64 28.704-64 64v192a32 32 0 0 0 32 32h100.544c14.304 55.04 64 96 123.456 96s109.12-40.96 123.456-96h265.088c14.304 55.04 64 96 123.456 96s109.12-40.96 123.456-96H992a32 32 0 0 0 32-32v-32c0-123.52-100.48-224-224-224z m-352-160h83.84a63.68 63.68 0 0 1 48.64 22.4l117.952 137.6H448v-160z m-191.712 32.16A63.904 63.904 0 0 1 311.68 320H384v160H183.168l73.12-127.84zM256 800c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64z m512 0c-35.296 0-64-28.704-64-64s28.704-64 64-64 64 28.704 64 64-28.704 64-64 64z m123.456-96c-14.304-55.04-64-96-123.456-96s-109.12 40.96-123.456 96h-265.088c-14.304-55.04-64-96-123.456-96s-109.12 40.96-123.456 96H64v-160h736c88.224 0 160 71.776 160 160h-68.544z" fill="#1296db" ></path></symbol><symbol id="iconicon-test" viewBox="0 0 1024 1024"><path d="M555.5 842.2h-388c-36.2 0-65.7-29.5-65.7-65.7V275.6c0-36.2 29.5-65.7 65.7-65.7h129.3v73.2c0 10.2 8.3 18.6 18.6 18.6s18.6-8.3 18.6-18.6v-73.2h291v73.2c0 10.2 8.3 18.6 18.6 18.6 10.2 0 18.6-8.3 18.6-18.6v-73.2h119.1c36.2 0 65.7 29.5 65.7 65.7v256.7c0 10.2 8.3 18.6 18.6 18.6 10.2 0 18.6-8.3 18.6-18.6V275.6c0-56.7-46.1-102.8-102.8-102.8H662.1v-64.6c0-10.2-8.3-18.6-18.6-18.6-10.2 0-18.6 8.3-18.6 18.6v64.6h-291v-64.6c0-10.2-8.3-18.6-18.6-18.6s-18.6 8.3-18.6 18.6v64.6H167.5c-56.7 0-102.8 46.1-102.8 102.8v500.9c0 56.7 46.1 102.8 102.8 102.8h388c10.2 0 18.6-8.3 18.6-18.6 0-10.2-8.3-18.5-18.6-18.5z" fill="#3B71B7" ></path><path d="M449.8 728.8c2.8 1.5 5.8 2.2 8.7 2.2 6.6 0 13-3.6 16.4-9.8l160.6-301.1c2.2-4.1 2.7-8.7 1.7-12.9-0.5-9.8-8.6-17.6-18.5-17.6H360.1c-10.2 0-18.6 8.3-18.6 18.6s8.3 18.6 18.6 18.6h229.8l-147.8 277c-4.7 9-1.3 20.2 7.7 25z" fill="#499DD7" ></path><path d="M781.3 577c-98.9 0-179.4 80.5-179.4 179.4s80.5 179.4 179.4 179.4 179.4-80.5 179.4-179.4S880.2 577 781.3 577z m0 324.3c-79.9 0-144.9-65-144.9-144.9s65-144.9 144.9-144.9 144.9 65 144.9 144.9-65 144.9-144.9 144.9z" fill="#3B71B7" ></path><path d="M864.9 751.2h-66.8v-45.7c0-9.5-7.7-17.2-17.2-17.2s-17.2 7.7-17.2 17.2v62.2c0 3.3 0.9 6.3 2.5 8.9 2.9 5.4 8.6 9.1 15.2 9.1H865c9.5 0 17.2-7.7 17.2-17.2-0.1-9.5-7.8-17.3-17.3-17.3z" fill="#3B71B7" ></path></symbol><symbol id="iconshenqingzhong" viewBox="0 0 1030 1024"><path d="M36.35485127 147.96964978"  ></path><path d="M686.04472547 1018.95071971h-0.69228544"  ></path><path d="M333.41977344 395.09120563h352.91077969v23.67603092H333.41977344zM333.41977344 534.94622187h352.91077969v23.67603188H333.41977344zM333.41977344 674.80123906h212.64807655v23.67603093H333.41977344z" fill="#e61616" ></path><path d="M252.05019219 387.3300575h39.19832719v39.19832719H252.05019219zM252.05019219 527.18507374h39.19832719v39.19832813H252.05019219zM252.05019219 667.04009094h39.19832719v39.19832718H252.05019219z" fill="#e61616" ></path><path d="M656.34795969 201.00881469c-9.80629312 0-17.75702345-7.95073125-17.75702344-17.75702344s7.95073125-17.75702345 17.75702344-17.75702344h97.84650281c23.35223063 0 44.57543156 9.54624563 59.94673219 24.91754625 15.37465687 15.37465687 24.91922437 36.59785687 24.91922437 59.94841032v284.58885281c0 9.80629312-7.95073125 17.75702345-17.75702344 17.75702438s-17.75702345-7.95073125-17.75702437-17.75702438V250.36072438c0-13.54761562-5.55997499-25.88559281-14.51398406-34.83960282-8.95233188-8.95233188-21.28695375-14.51230688-34.83792469-14.51230687H656.34795969z m-113.57515876 620.90527219c9.80629312 0 17.75702345 7.95073125 17.75702438 17.75702343s-7.95073125 17.75702345-17.75702438 17.75702344H231.99300969c-23.35558688 0-44.57878687-9.54456844-59.9500875-24.91586906-15.37130156-15.37130156-24.91586906-36.59450156-24.91587-59.9500875V250.36072438c0-23.35558688 9.54456844-44.57878687 24.91587-59.95008751 15.37130156-15.37130156 36.59450156-24.91586906 59.9500875-24.91586906h109.92946593c9.80629312 0 17.75702345 7.95073125 17.75702344 17.75702344s-7.95073125 17.75702345-17.75702344 17.75702344h-109.92946593c-13.55264906 0-25.88894906 5.55829781-34.84128094 14.51062968-8.95233188 8.95233188-14.51062875 21.28863094-14.51062875 34.84128v522.20145282c0 13.55264906 5.55829781 25.88894906 14.51062875 34.84128 8.95233188 8.95233188 21.28863094 14.51062875 34.84128094 14.51062969h310.77979124z" fill="#e61616" ></path><path d="M1068.30866205 230.61839531"  ></path><path d="M1117.83763968 1017.74736384h0.69228544"  ></path><path d="M1004.45140423 54.95290653"  ></path><path d="M971.06897579 1040.15909888h0.69228544M952.74376306 1094.54222222h0.69228544"  ></path><path d="M804.98921375 864.92084656c0 10.52771344-8.53625625 19.0622925-19.0622925 19.0622925-10.52771344 0-19.0622925-8.53457812-19.0622925-19.0622925V642.003425c0-10.52771344 8.53457812-19.0622925 19.0622925-19.0622925 10.52603625 0 19.0622925 8.53457812 19.0622925 19.0622925v222.91742156z" fill="#e61616" ></path><path d="M893.88002844 723.00726313c7.44405844 7.40043751 7.47593531 19.43642437 0.07549781 26.88048281-7.40211563 7.44238031-19.4381025 7.47425719-26.88048282 0.07382062l-81.2437528-81.19845375-81.057525 81.01390406c-7.44405844 7.40043751-19.48004532 7.36856062-26.88048282-0.07549781-7.40211563-7.44238031-7.37023875-19.47836812 0.07381969-26.88048281l94.35012656-94.2947625c5.825055-5.79317906 14.46197531-7.03133812 21.48995813-3.72957844 2.07534375 0.91603689 4.01982469 2.21962781 5.72439281 3.91412814l94.34844844 94.29643968zM412.06976562 140.46481344h172.11595876c7.84839001 0 14.99213531 3.21787313 20.17294499 8.39700469l0.04529813 0.04529906c5.17913156 5.18080969 8.39700563 12.32455594 8.39700562 20.172945v26.86873969c0 7.87858875-3.21787313 15.03743437-8.39700562 20.21656593-5.18080969 5.18080969-12.33965531 8.39868281-20.21824313 8.39868282H412.06976562c-7.87858875 0-15.03743437-3.21787313-20.21824406-8.39868282-5.17913156-5.17913156-8.39700563-12.33797719-8.39700562-20.21656593V169.08006219c0-7.84839001 3.21787313-14.99213531 8.39700562-20.172945l0.04529813-0.04529906c5.18080969-5.17913156 12.32455594-8.39700563 20.17294593-8.39700469z m172.11595876 23.67603186H412.06976562c-1.36566655 0-2.60550469 0.55029281-3.50308687 1.43613095a4.97679844 4.97679844 0 0 0-1.43613094 3.50308594v26.86873969c0 1.34721187 0.56035969 2.58201657 1.45794188 3.47959781 0.89925937 0.89925937 2.13406406 1.45961906 3.48127593 1.45961906h172.11595876c1.34721187 0 2.58201657-0.56035969 3.48127593-1.45961906 0.89758219-0.89758219 1.45794187-2.13238594 1.45794094-3.47959781V169.08006219c0-1.36566655-0.55029281-2.60550469-1.43613094-3.50308594a4.97679844 4.97679844 0 0 0-3.50308594-1.43613093z" fill="#e61616" ></path></symbol><symbol id="iconqindai" viewBox="0 0 1024 1024"><path d="M888.875 495.4765625c-9.140625 0-16.5234375 7.3828125-16.5234375 16.5234375 0 198.72070313-161.63085938 360.3515625-360.3515625 360.3515625S151.6484375 710.72070313 151.6484375 512s161.63085938-360.3515625 360.3515625-360.3515625c139.30664063 0 267.45117188 81.5625 326.51367188 207.7734375 3.33984375 7.11914063 11.16210938 10.8984375 18.72070312 9.05273438 7.64648438-1.7578125 12.91992188-8.70117188 12.74414062-16.52343751l-3.60351562-133.41796874c-0.26367188-9.140625-7.82226563-16.69921875-16.96289063-16.08398438-9.140625 0.26367188-16.34765625 7.82226563-16.08398437 16.96289062l1.84570312 68.37890626C762.48828125 183.37695312 641.63867188 118.6015625 512 118.6015625 295.0859375 118.6015625 118.6015625 295.0859375 118.6015625 512S295.0859375 905.3984375 512 905.3984375 905.3984375 728.9140625 905.3984375 512c0-9.140625-7.47070313-16.5234375-16.5234375-16.5234375z" fill="#1296db" ></path><path d="M512 247.36132812c-9.140625 0-16.5234375 7.3828125-16.5234375 16.52343751V512c0 9.140625 7.3828125 16.5234375 16.5234375 16.5234375h248.11523438c9.140625 0 16.5234375-7.3828125 16.52343749-16.5234375s-7.3828125-16.5234375-16.5234375-16.5234375H528.5234375V263.88476562c0-9.140625-7.3828125-16.5234375-16.5234375-16.52343749z" fill="#1296db" ></path></symbol><symbol id="iconjibenxinxi" viewBox="0 0 1024 1024"><path d="M417.12 398.24a113.76 113.76 0 0 0-107.2 75.84h214.56a113.76 113.76 0 0 0-107.36-75.84z m0-56.96a37.92 37.92 0 1 0 0-75.84 37.92 37.92 0 0 0 0 75.84z" fill="#1296db" ></path><path d="M284.48 777.44a19.04 19.04 0 1 1 0-37.92h94.72a19.04 19.04 0 1 1 0 37.92z m0-132.64a19.04 19.04 0 1 1 0-37.92h208a19.04 19.04 0 1 1 0 37.92z m132.64-246.56a113.76 113.76 0 0 0-107.2 75.84h214.56a113.76 113.76 0 0 0-107.36-75.84zM265.44 512a151.84 151.84 0 0 1 304 0h-304z m151.68-170.72A37.92 37.92 0 1 0 379.2 304a37.92 37.92 0 0 0 37.92 37.28z m0 37.92a75.84 75.84 0 1 1 75.84-75.2 75.84 75.84 0 0 1-75.84 75.2z m379.36-58.24a19.04 19.04 0 0 1-37.92 0V208a19.04 19.04 0 0 0-19.04-19.04H246.56A19.04 19.04 0 0 0 227.52 208v645.28a19.04 19.04 0 0 0 19.04 19.04h492.96a19.04 19.04 0 1 1 0 37.92H246.56a56.96 56.96 0 0 1-56.96-56.96V208a56.96 56.96 0 0 1 56.96-56.96h492.96A56.96 56.96 0 0 1 796.48 208zM682.4 475.04A132.96 132.96 0 0 1 829.92 448a17.76 17.76 0 0 1 9.28 23.52 18.08 18.08 0 0 1-3.68 5.44l-46.24 46.24a24 24 0 0 0 33.92 33.92l46.24-46.24a17.76 17.76 0 0 1 25.28 0 20.96 20.96 0 0 1 3.84 5.44A132.96 132.96 0 0 1 734.72 695.2l-116 115.84a59.84 59.84 0 0 1-84.64-84.48l116-115.84a132.8 132.8 0 0 1 32-135.68z m106.08-2.4a97.12 97.12 0 0 0-108.48 84 96 96 0 0 0 8 51.36 17.92 17.92 0 0 1-3.84 19.84L560 752a24 24 0 0 0 33.92 33.92l124.16-124a17.92 17.92 0 0 1 19.84-3.68A97.28 97.28 0 0 0 873.6 557.28L848 581.76a59.84 59.84 0 0 1-84.64-84.48z" fill="#1296db" ></path></symbol><symbol id="iconhuikuan" viewBox="0 0 1024 1024"><path d="M524.65625 937.390625c-187.734375 0-356.484375-125.859375-410.625-305.15625l26.71875-8.4375c50.625 168.046875 208.125 285.46875 383.90625 285.46875s333.28125-117.421875 383.90625-285.46875l26.71875 8.4375c-54.140625 179.296875-222.890625 305.15625-410.625 305.15625z" fill="#1296db" ></path><path d="M100.671875 580.203125l14.765625 56.25c1.40625 4.921875 6.328125 7.734375 11.25 6.328125l66.09375-5.625c4.921875-1.40625 5.625-7.734375 1.40625-10.546875L114.734375 569.65625c-7.03125-4.21875-16.171875 2.109375-14.0625 10.546875z" fill="#1296db" ></path><path d="M921.921875 627.3125m-14.0625 0a14.0625 14.0625 0 1 0 28.125 0 14.0625 14.0625 0 1 0-28.125 0Z" fill="#1296db" ></path><path d="M128.09375 396.6875l-26.71875-8.4375C155.515625 208.25 324.265625 83.09375 512 83.09375s356.484375 125.859375 410.625 305.15625l-26.71875 8.4375C845.28125 228.640625 687.78125 111.21875 512 111.21875S178.71875 228.640625 128.09375 396.6875z" fill="#1296db" ></path><path d="M935.984375 440.28125l-14.765625-56.25c-1.40625-4.921875-6.328125-7.734375-11.25-6.328125l-66.09375 5.625c-4.921875 1.40625-5.625 7.734375-1.40625 10.546875l79.453125 56.953125c7.03125 4.21875 16.171875-2.8125 14.0625-10.546875z" fill="#1296db" ></path><path d="M114.734375 393.171875m-14.0625 0a14.0625 14.0625 0 1 0 28.125 0 14.0625 14.0625 0 1 0-28.125 0Z" fill="#1296db" ></path><path d="M479.65625 440.28125h-60.46875l-29.53125-74.53125c-7.03125-18.28125 6.328125-38.671875 26.015625-38.671875 11.25 0 21.796875 7.03125 26.015625 17.578125l37.96875 95.625zM549.265625 440.28125h60.46875l29.53125-74.53125c7.03125-18.28125-6.328125-38.671875-26.015625-38.671875-11.25 0-21.796875 7.03125-26.015625 17.578125l-37.96875 95.625zM512 763.015625c-16.875 0-30.234375-13.359375-30.234375-30.234375V496.53125h60.46875v235.546875c0 16.875-13.359375 30.9375-30.234375 30.9375z" fill="#1296db" ></path><path d="M649.8125 499.34375H374.1875c-16.875 0-30.234375-13.359375-30.234375-30.234375s13.359375-30.234375 30.234375-30.234375h276.328125c16.875 0 30.234375 13.359375 30.234375 30.234375-0.703125 16.875-14.0625 30.234375-30.9375 30.234375zM649.8125 594.96875H374.1875c-16.875 0-30.234375-13.359375-30.234375-30.234375s13.359375-30.234375 30.234375-30.234375h276.328125c16.875 0 30.234375 13.359375 30.234375 30.234375-0.703125 16.171875-14.0625 30.234375-30.9375 30.234375z" fill="#1296db" ></path></symbol><symbol id="icongeiyu" viewBox="0 0 1024 1024"><path d="M42.666667 42.666667h938.666666v938.666666H42.666667z" fill="#1296db" fill-opacity="0" ></path><path d="M85.333333 448a21.333333 21.333333 0 0 1 21.333334 21.333333 362.666667 362.666667 0 0 0 362.666666 362.666667 362.922667 362.922667 0 0 0 341.674667-240.64l-27.306667 13.269333a21.333333 21.333333 0 0 1-26.538666-6.485333l-2.005334-3.285333a21.333333 21.333333 0 0 1 6.485334-26.538667l3.285333-2.005333 70.485333-34.474667a25.6 25.6 0 0 1 32.128 8.149333l2.56 4.48 28.970667 73.088a21.333333 21.333333 0 0 1-37.973333 19.157334l-1.706667-3.413334-9.514667-24.064A405.589333 405.589333 0 0 1 469.333333 874.666667 405.333333 405.333333 0 0 1 64 469.333333a21.333333 21.333333 0 0 1 21.333333-21.333333zM476.842667 64a405.333333 405.333333 0 0 1 405.333333 405.333333 21.333333 21.333333 0 1 1-42.666667 0 362.666667 362.666667 0 0 0-362.666666-362.666666A362.922667 362.922667 0 0 0 135.253333 347.306667l27.306667-13.269334a21.333333 21.333333 0 0 1 26.538667 6.485334l2.005333 3.285333a21.333333 21.333333 0 0 1-6.528 26.538667l-3.285333 2.005333-70.442667 34.474667a25.6 25.6 0 0 1-32.128-8.149334l-2.56-4.48-29.013333-73.088a21.333333 21.333333 0 0 1 37.973333-19.157333l1.706667 3.413333 9.514666 24.064a405.589333 405.589333 0 0 1 380.586667-265.429333z" fill="#1296db" ></path><path d="M724.010667 749.866667a21.333333 21.333333 0 0 1 27.050666-3.797334l3.072 2.346667 220.16 195.797333a21.333333 21.333333 0 0 1-25.557333 33.92l-3.072-2.346666-220.202667-195.754667a21.333333 21.333333 0 0 1-1.450666-30.165333z" fill="#1296db" ></path><path d="M362.666667 443.264c-11.776 0-21.333333-10.624-21.333334-23.722667 0-11.605333 7.552-21.333333 17.493334-23.296l3.84-0.426666h68.010666L348.885333 319.146667a25.6 25.6 0 0 1-2.56-33.408 19.882667 19.882667 0 0 1 26.965334-5.290667l3.157333 2.474667 87.978667 82.56 98.645333-83.328a19.754667 19.754667 0 0 1 27.306667 1.365333l2.602666 3.157333a25.770667 25.770667 0 0 1-1.237333 30.336l-2.816 2.901334-89.941333 75.946666H576c11.776 0 21.333333 10.624 21.333333 23.68 0 11.648-7.552 21.333333-17.493333 23.338667l-3.84 0.384h-85.333333V490.666667h85.333333c11.776 0 21.333333 10.624 21.333333 23.722666 0 11.605333-7.552 21.333333-17.493333 23.296l-3.84 0.426667h-85.333333v142.165333c0 13.098667-9.557333 23.722667-21.333334 23.722667-10.453333 0-19.2-8.405333-20.992-19.456l-0.341333-4.266667v-142.208h-85.333333c-11.776 0-21.333333-10.624-21.333334-23.68 0-11.648 7.552-21.333333 17.493334-23.338666l3.84-0.384h85.333333v-47.402667h-85.333333z" fill="#1296db" ></path></symbol><symbol id="iconjinjilianluo" viewBox="0 0 1024 1024"><path d="M514.5088 898.6112c-215.0912 0-390.0416-174.9504-390.0416-390.0416 0-215.0912 174.9504-390.0416 390.0416-390.0416s390.0416 174.9504 390.0416 390.0416c0 215.0912-175.0016 390.0416-390.0416 390.0416z m0-739.1232c-192.4608 0-349.0816 156.6208-349.0816 349.0816s156.6208 349.0816 349.0816 349.0816 349.0816-156.6208 349.0816-349.0816c0-192.512-156.6208-349.0816-349.0816-349.0816z" fill="#1296db" ></path><path d="M514.5088 596.736c-82.4832 0-149.6064-67.1232-149.6064-149.6064s67.1232-149.6064 149.6064-149.6064 149.6064 67.1232 149.6064 149.6064-67.1232 149.6064-149.6064 149.6064z m0-258.2528c-59.904 0-108.6464 48.7424-108.6464 108.6464s48.7424 108.6464 108.6464 108.6464 108.6464-48.7424 108.6464-108.6464-48.7424-108.6464-108.6464-108.6464z" fill="#1296db" ></path><path d="M755.3536 807.7824c-10.1376 0-18.944-7.5264-20.2752-17.8176-14.4896-110.1312-109.312-193.2288-220.5696-193.2288-110.2336 0-202.6496 78.8992-219.8016 187.5968a20.51072 20.51072 0 0 1-23.3984 17.0496 20.48 20.48 0 0 1-17.0496-23.3984c20.2752-128.7168 129.7408-222.1568 260.2496-222.1568 131.7888 0 244.0704 98.4064 261.2224 228.864a20.48 20.48 0 0 1-17.664 22.9888c-0.9216 0.0512-1.792 0.1024-2.7136 0.1024z" fill="#1296db" ></path></symbol><symbol id="iconguoji" viewBox="0 0 1024 1024"><path d="M886.8 353.6c-20.5-48.4-49.8-92-87.2-129.3-37.4-37.4-80.9-66.7-129.3-87.2-50.2-21.2-103.5-32-158.4-32s-108.2 10.8-158.4 32c-48.4 20.5-92 49.8-129.3 87.2-37.4 37.4-66.7 80.9-87.2 129.3-21.2 50.2-32 103.5-32 158.4s10.8 108.2 32 158.4c20.5 48.4 49.8 92 87.2 129.3 37.4 37.4 80.9 66.7 129.3 87.2 50.2 21.2 103.5 32 158.4 32s108.2-10.8 158.4-32c48.4-20.5 92-49.8 129.3-87.2 37.4-37.4 66.7-80.9 87.2-129.3 21.2-50.2 32-103.5 32-158.4s-10.7-108.2-32-158.4zM713.9 543.3l21.2 43.8-38.9 33.6 2.8 13.2c3.2 15.4 6.6 33.5 8.2 44.2-3 2.7-6.9 6.3-12.1 11-7.5 6.8-20.6 18.7-31.8 28.6-2-8.2-4.3-19.3-7-34.3-4.4-25-7.4-47.8-7.4-48.1l-0.4-3.4-0.7-1.5-19.2-70.8-49.1 8.8-27.6-23.3 22.6-36.7-4.7-48.8c8.8-8.6 17.7-16.9 21.1-19.5 11.8-6.3 13.8-19.9 14.8-26.6 0.8-5.4 1.5-12.6 2-21.4 0.5-7.3 0.7-14.4 0.9-19.8l38.1-40.5 143.8-49.3c42.8 51.9 71.4 115.8 79.9 185.9L752.9 472l-39 71.3z m29.8 163.9c-0.2 0.2-0.5 0.3-0.6 0.4 0.2-0.1 0.4-0.2 0.6-0.4zM232.6 284c1.3 3.4 2.7 7.1 4 10.5 8.9 24 17.3 46.7 34.4 55.8 10 5.3 46 19.8 73.4 30.6-8.3 8.9-18 19.5-27.7 30.7-43.9 50.7-53.7 73-52 89.3-3.9 3.2-12.7 7.2-22.4 10.5l-41.9-67-33.2-38.5c13.8-45.1 36.3-86.3 65.4-121.9z m117 550.2l-2.7-68.1 20.1-78-23.3-54.3 4.8-11.7 39.4 14.4 71.8 51.2-53 36.9-40.2 117.5c-5.8-2.5-11.4-5.1-16.9-7.9zM512 872.8c-35.6 0-69.9-5.2-102.4-14.8l35.7-104.2 94.2-65.6-130-92.7-86.6-31.6-29.2 70.3 24.7 57.7-17.9 69.3 1.8 44.4C210.9 740.1 151.2 632.9 151.2 512c0-17 1.2-33.8 3.5-50.2l8.5 9.9 57.6 92.1 15.7-3.3c0.5-0.1 12.5-2.6 26-7.6 21.2-7.8 35.1-17.2 42.6-29 5.1-8.1 7.1-17.1 5.7-26.1 1.5-4.1 9-20.3 45.2-61.4 22.6-25.7 44.9-48 45.1-48.2l25-25-33-12.7c-32.4-12.5-86.7-34-99.3-40.3-4.1-4.9-10.5-22.3-14-31.8-4.3-11.5-8.3-22.5-13.1-30.8 64.4-59.9 150.7-96.6 245.5-96.6 93.8 0 179.3 35.9 243.5 94.8l-134.6 46.1-58 61.6-0.2 8.9c-0.3 14.9-1.3 33.9-2.5 43.2-6 4.9-15.3 13.5-30.7 28.9l-7.7 7.7 5.3 55.1-35.4 57.3 74.4 62.7 28.9-5.2 8.3 30.6c0.8 6.2 3.9 28.6 8.3 52.6 10.4 57 18.1 68.6 24.6 75.1 3.8 3.8 9.7 6.9 16.6 6.9 3.9 0 8.2-1 12.7-3.3 2.2-1.2 4.6-2.7 7.6-4.9 4-3 9.2-7.2 16-13 11.7-10 25.7-22.8 37-33.1 7.3-6.7 15.6-14.2 18-16.1 5.1-3.6 10.6-10.3 10.1-22.7-0.1-2.4-0.4-5.3-0.9-9-0.7-5.3-1.9-12.5-3.5-21.3-1-5.7-2.1-11.3-3.1-16.1l45.2-39.1-26.2-54.2 15-27.4 92.2-2.7c-1.6 197.9-163 358.4-361.1 358.4z" fill="#1296db" ></path></symbol><symbol id="icontongyi" viewBox="0 0 1024 1024"><path d="M512.2 923.1c-55.5 0-109.4-10.9-160.1-32.3-49-20.7-92.9-50.4-130.7-88.1C183.7 765 154 721 133.3 672 111.9 621.3 101 567.5 101 512s10.9-109.4 32.3-160.1c20.7-49 50.4-92.9 88.1-130.7 37.8-37.8 81.7-67.4 130.7-88.1 50.7-21.4 104.6-32.3 160.1-32.3s109.4 10.9 160.1 32.3c49 20.7 92.9 50.4 130.7 88.1 37.8 37.8 67.4 81.7 88.1 130.7 21.4 50.7 32.3 104.6 32.3 160.1s-10.9 109.4-32.3 160.1c-20.7 49-50.4 92.9-88.1 130.7-37.8 37.8-81.7 67.4-130.7 88.1-50.8 21.4-104.6 32.2-160.1 32.2z m0-781.5C308 141.6 141.9 307.8 141.9 512S308 882.3 512.2 882.3c204.2 0 370.3-166.1 370.3-370.3 0-204.2-166.1-370.4-370.3-370.4z" fill="#1296db" ></path><path d="M748.9 349.2L423.4 674.7" fill="#333333" ></path><path d="M423.4 695.2c-5.2 0-10.5-2-14.4-6-8-8-8-20.9 0-28.9l325.5-325.5c8-8 20.9-8 28.9 0s8 20.9 0 28.9L437.9 689.2c-4 4-9.2 6-14.5 6z" fill="#1296db" ></path><path d="M275.4 526.7l148 148" fill="#333333" ></path><path d="M423.4 695.2c-5.2 0-10.5-2-14.4-6l-148-148c-8-8-8-20.9 0-28.9s20.9-8 28.9 0l148 148c8 8 8 20.9 0 28.9-4 4-9.3 6-14.5 6z" fill="#1296db" ></path></symbol><symbol id="iconqiche" viewBox="0 0 1024 1024"><path d="M882.6 444.9h-21.9L787 199.7c-7.1-23.6-28.4-39.4-53-39.4H288.1c-24.6 0-45.9 15.8-53 39.4l-73.8 245.2h-21.9c-30.5 0-55.3 24.8-55.3 55.3v221.4c0 30.5 24.8 55.3 55.3 55.3h24.4v44.5c0 21.8 17.7 39.5 39.5 39.5s39.5-17.7 39.5-39.5V777h536.4v44.5c0 21.8 17.7 39.5 39.5 39.5s39.5-17.7 39.5-39.5V777h24.3c30.5 0 55.3-24.8 55.3-55.3V500.3c0.2-30.5-24.6-55.4-55.2-55.4zM280.5 213.4c1-3.4 4.1-5.6 7.6-5.6H734c3.5 0 6.6 2.3 7.6 5.6L811.2 445H210.8l69.7-231.6z m610.1 508.2c0 4.4-3.6 7.9-7.9 7.9H139.4c-4.4 0-7.9-3.5-7.9-7.9V500.3c0-4.4 3.6-7.9 7.9-7.9h743.2c4.4 0 7.9 3.5 7.9 7.9v221.3zM250.7 563.5c-26.2 0-47.4 21.2-47.4 47.4s21.2 47.4 47.4 47.4 47.4-21.2 47.4-47.4c0.1-26.1-21.2-47.4-47.4-47.4z m528.5 0c-26.2 0-47.4 21.2-47.4 47.4s21.2 47.4 47.4 47.4 47.4-21.2 47.4-47.4c0.1-26.1-21.2-47.4-47.4-47.4z" fill="#5F9BEB" ></path></symbol><symbol id="iconyoujian" viewBox="0 0 1024 1024"><path d="M512 563.2L115.873684 266.778947a26.947368 26.947368 0 1 1 32.336842-43.115789L512 495.831579 875.789474 223.663158a26.947368 26.947368 0 1 1 32.336842 43.115789z" fill="#1296db" ></path><path d="M854.231579 859.621053H169.768421a79.386947 79.386947 0 0 1-80.842105-80.842106V280.252632a79.386947 79.386947 0 0 1 80.842105-80.842106h684.463158a79.386947 79.386947 0 0 1 80.842105 80.842106v495.831579a83.536842 83.536842 0 0 1-80.842105 83.536842zM169.768421 253.305263a25.465263 25.465263 0 0 0-26.947368 26.947369v495.831579a25.465263 25.465263 0 0 0 26.947368 26.947368h684.463158a25.465263 25.465263 0 0 0 26.947368-26.947368V280.252632a25.465263 25.465263 0 0 0-26.947368-26.947369z" fill="#1296db" ></path></symbol><symbol id="iconoffice" viewBox="0 0 1024 1024"><path d="M817.956 400.467h-36.287v-13.471c0-72.697-28.521-141.145-80.221-192.967-51.7-51.7-120.271-80.221-192.967-80.221s-141.145 28.521-192.967 80.221c-51.7 51.7-80.221 120.271-80.221 192.967v13.471h-35.195c-52.914 0-89.808 36.895-89.808 89.808v154.01c0 49.516 40.292 89.808 89.808 89.808h46.239v0.242c0 69.541 56.676 126.218 126.218 126.218h41.991c1.942 24.88 22.938 44.661 48.423 44.661h92.479c26.7 0 48.545-21.845 48.545-48.545v-31.312c0-26.7-21.845-48.545-48.545-48.545h-92.479c-25.486 0-46.482 19.903-48.423 44.905h-41.991c-48.181 0-87.381-39.2-87.381-87.381v-8.738l0.85-0.85c0.485-0.485 0.971-1.092 1.334-1.578 0.122-0.122 0.122-0.242 0.242-0.364 0.485-0.607 0.85-1.092 1.214-1.699 0-0.122 0.122-0.122 0.122-0.242 0.364-0.607 0.729-1.092 1.092-1.699 0-0.122 0.122-0.122 0.122-0.242 0.364-0.607 0.607-1.214 0.971-1.942 0-0.122 0.122-0.242 0.122-0.364 0.242-0.607 0.485-1.334 0.729-1.942 0-0.122 0.122-0.242 0.122-0.242 0.242-0.607 0.485-1.334 0.607-2.063v-0.122c0.242-0.729 0.364-1.456 0.485-2.185 0-0.122 0-0.242 0.122-0.364 0.122-0.729 0.242-1.456 0.242-2.185v-0.364c0-0.729 0.122-1.578 0.122-2.306v-317.85c0-118.45 96.362-214.813 214.813-214.813s214.813 96.362 214.813 214.813v317.971a29.057 29.057 0 0 0 29.127 29.127h65.294c49.516 0 89.808-40.292 89.808-89.808v-154.01c0.242-52.914-36.652-89.808-89.566-89.808zM168.543 644.286v-154.01c0-26.093 17.113-31.554 31.554-31.554h35.316v217.119h-35.316c-17.476 0-31.554-14.199-31.554-31.554z m680.967 0c0 17.355-14.199 31.554-31.554 31.554h-36.287V458.721h36.287c14.442 0 31.554 5.461 31.554 31.554v154.01z" fill="#1296db" ></path></symbol><symbol id="iconse_xitong" viewBox="0 0 1024 1024"><path d="M918.72 773.76H105.28A73.44 73.44 0 0 1 32 700.32V187.2a73.44 73.44 0 0 1 73.28-73.44h813.44A73.44 73.44 0 0 1 992 187.2v513.12a73.44 73.44 0 0 1-73.28 73.44zM105.28 170.08a17.12 17.12 0 0 0-17.12 17.12v512.96a17.12 17.12 0 0 0 17.12 17.12h813.44a16.96 16.96 0 0 0 17.12-16.96V187.2a17.28 17.28 0 0 0-17.12-17.12H105.28z" fill="#4592D8" ></path><path d="M61.6 594.88h900.8v56.48H61.6zM483.84 752h56.32v128h-56.32zM339.2 880h345.6a28.16 28.16 0 0 1 28.16 28.16 28.16 28.16 0 0 1-28.16 28.16H339.2a28 28 0 0 1-28-28.32A28 28 0 0 1 339.2 880z" fill="#4592D8" ></path></symbol><symbol id="iconjinggao" viewBox="0 0 1024 1024"><path d="M513.2 212.8l372.3 598.1H147l366.2-598.1m0-61c-18.3 0-42.7 12.2-48.8 30.5L92.1 780.4c-24.4 42.7 6.1 91.5 48.8 91.5h738.5c48.8 0 79.3-54.9 48.8-91.5L562 182.3c-6.1-18.3-30.5-30.5-48.8-30.5z m0 0" fill="#FF262B" ></path><path d="M513.2 652.2c-18.3 0-30.5-12.2-30.5-30.5V438.6c0-18.3 12.2-30.5 30.5-30.5s30.5 12.2 30.5 30.5v183.1c0 18.3-12.2 30.5-30.5 30.5z m0 0M482.6 731.5c0 16.9 13.7 30.5 30.5 30.5 16.9 0 30.5-13.7 30.5-30.5 0-16.9-13.7-30.5-30.5-30.5s-30.5 13.7-30.5 30.5z m0 0" fill="#FF262B" ></path></symbol><symbol id="iconform" viewBox="0 0 1024 1024"><path d="M766.442016 64.47136 258.495332 64.47136c-78.104869 0-141.650137 65.192791-141.650137 145.320737l0 133.710304c0 17.253966 13.980409 31.233352 31.233352 31.233352s31.234375-13.980409 31.234375-31.233352L179.312922 209.792097c0-45.681412 35.524075-82.85301 79.18241-82.85301l507.946684 0c43.668569 0 79.192643 37.171598 79.192643 82.85301l0 132.784212c0 17.253966 13.980409 31.233352 31.234375 31.233352s31.233352-13.980409 31.233352-31.233352l0-132.784212C908.102387 129.663128 844.557118 64.47136 766.442016 64.47136z" fill="#1296db" ></path><path d="M876.869035 415.44492c-17.253966 0-31.234375 13.980409-31.234375 31.233352l0 236.897432c0 45.681412-35.524075 82.85301-79.192643 82.85301L572.684104 766.428713c-8.700149 0-16.554024 3.567245-22.215978 9.302877l-117.940133 89.827865 0-67.287499c0-0.104377-0.029676-0.200568-0.030699-0.304945 0.001023-0.104377 0.030699-0.200568 0.030699-0.304945 0-17.253966-13.980409-31.234375-31.233352-31.234375L258.495332 766.42769c-43.658336 0-79.18241-37.171598-79.18241-82.85301L179.312922 449.15979c0-17.253966-13.980409-31.233352-31.234375-31.233352s-31.233352 13.980409-31.233352 31.233352l0 234.416937c0 80.127945 63.545268 145.320737 141.650137 145.320737l111.565958 0 0 99.710956c0 11.875468 6.730285 22.713304 17.365506 27.990494 4.39203 2.175549 9.140171 3.242857 13.867846 3.242857 6.710842 0 13.379729-2.165316 18.920932-6.385431l163.54275-124.558877 182.683692 0c78.115102 0 141.66037-65.192791 141.66037-145.320737L908.102387 446.679295C908.102387 429.42533 894.123001 415.44492 876.869035 415.44492z" fill="#1296db" ></path><path d="M390.583696 281.796014c-17.253966 0-31.233352 13.980409-31.233352 31.234375l0 30.470989c0 17.253966 13.980409 31.234375 31.233352 31.234375s31.234375-13.980409 31.234375-31.234375l0-30.470989C421.817048 295.776424 407.837662 281.796014 390.583696 281.796014z" fill="#1296db" ></path><path d="M634.363885 281.796014c-17.253966 0-31.233352 13.980409-31.233352 31.234375l0 30.470989c0 17.253966 13.980409 31.234375 31.233352 31.234375s31.234375-13.980409 31.234375-31.234375l0-30.470989C665.59826 295.776424 651.617851 281.796014 634.363885 281.796014z" fill="#1296db" ></path><path d="M589.498048 423.243537c-14.316054-9.405207-33.593096-5.38873-43.159986 8.764618-0.132006 0.193405-13.614066 19.754926-34.172287 19.754926-19.989263 0-32.43369-18.117636-33.267685-19.378349-9.181103-14.407128-28.285207-18.819624-42.834574-9.750061-14.650675 9.099239-19.155269 28.356838-10.044774 43.007513 11.214413 18.047028 41.970904 48.589648 86.147032 48.589648 43.963281 0 75.105558-30.318516 86.574774-48.223305C607.961562 451.610608 603.772146 432.647721 589.498048 423.243537z" fill="#1296db" ></path></symbol><symbol id="iconshenfenzheng" viewBox="0 0 1024 1024"><path d="M984.160195 203.17917H57.988624a22.378321 22.378321 0 0 0-22.378321 22.378321v569.048734a22.378321 22.378321 0 0 0 22.378321 22.378321h926.171571a22.378321 22.378321 0 0 0 22.378321-22.378321v-569.048734a22.378321 22.378321 0 0 0-22.378321-22.378321z m-22.378321 569.048734H80.366945v-524.292092h881.414929v524.292092z" fill="#009FE8" ></path><path d="M121.188199 709.146614a22.378321 22.378321 0 1 0 44.756642 0c0-80.117586 65.181655-145.296044 145.296044-145.296044s145.296044 65.181655 145.296045 145.296044a22.378321 22.378321 0 1 0 44.756642 0c0-77.569654-46.735525-144.391321-113.506041-173.898735 35.175524-24.354007 58.276345-64.97066 58.276345-110.900565 0-74.343979-60.482208-134.826187-134.826188-134.826188s-134.826187 60.482208-134.826187 134.826188c0 45.929905 23.100821 86.546558 58.276345 110.900565-66.764122 29.510612-113.499647 96.332278-113.499647 173.898735z m190.052686-374.868846c49.663888 0 90.069545 40.405657 90.069546 90.069546s-40.405657 90.069545-90.069546 90.069545-90.069545-40.405657-90.069545-90.069545 40.405657-90.069545 90.069545-90.069546zM579.656058 398.215828h319.6903a22.378321 22.378321 0 1 0 0-44.756642h-319.6903a22.378321 22.378321 0 1 0 0 44.756642zM579.656058 535.682657h319.6903a22.378321 22.378321 0 1 0 0-44.756642h-319.6903a22.378321 22.378321 0 1 0 0 44.756642zM579.656058 673.149486h319.6903a22.378321 22.378321 0 1 0 0-44.756642h-319.6903a22.378321 22.378321 0 1 0 0 44.756642z" fill="#009FE8" ></path></symbol><symbol id="iconjingfei" viewBox="0 0 1024 1024"><path d="M512 924.66C284.46 924.66 99.34 739.54 99.34 512S284.46 99.34 512 99.34 924.66 284.46 924.66 512 739.54 924.66 512 924.66z m0-788.36c-207.16 0-375.7 168.54-375.7 375.7S304.84 887.7 512 887.7 887.7 719.16 887.7 512 719.16 136.3 512 136.3z" fill="#0897EA" ></path><path d="M513.62 768.07a18.48 18.48 0 0 1-18.48-18.48V473.34a18.48 18.48 0 0 1 37 0v276.25a18.48 18.48 0 0 1-18.52 18.48z" fill="#1296db" ></path><path d="M703.42 601.28H323.81a18.48 18.48 0 0 1 0-37h379.61a18.48 18.48 0 1 1 0 37zM703.42 485.91H323.81a18.48 18.48 0 1 1 0-37h379.61a18.48 18.48 0 1 1 0 37z" fill="#1296db" ></path><path d="M506 478.43a18.42 18.42 0 0 1-13.67-6l-127.46-140a18.48 18.48 0 0 1 27.33-24.88l127.46 140A18.48 18.48 0 0 1 506 478.43z" fill="#1296db" ></path><path d="M521.24 478.43a18.48 18.48 0 0 1-13.67-30.92l127.43-140a18.48 18.48 0 1 1 27.33 24.88l-127.46 140a18.42 18.42 0 0 1-13.63 6.04z" fill="#1296db" ></path></symbol><symbol id="iconskill" viewBox="0 0 1024 1024"><path d="M256 298.666667v560.682666l278.186667-126.805333 276.48 126.72V170.666667H256v85.333333h554.666667v42.666667H256z m0-170.666667h554.666667a42.666667 42.666667 0 0 1 42.666666 42.666667v688.554666a42.666667 42.666667 0 0 1-60.458666 38.826667l-258.773334-118.613333-260.394666 118.741333A42.666667 42.666667 0 0 1 213.333333 859.349333V170.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z" fill="#1296db" ></path><path d="M85.333333 256h42.666667v512H85.333333z" fill="#1296db" ></path></symbol><symbol id="iconqiyue" viewBox="0 0 1024 1024"><path d="M373.077333 921.6H102.4V125.155556h757.76v210.147555H807.822222V177.493333H154.737778v691.768889h218.339555V921.6z" fill="#0590DF" ></path><path d="M253.724444 589.596444h159.288889v52.337778h-159.288889zM253.724444 436.906667h238.933334V489.244444h-238.933334zM253.724444 282.965333h455.111112v52.337778h-455.111112zM673.564444 876.088889A201.841778 201.841778 0 1 1 876.088889 674.247111 202.410667 202.410667 0 0 1 673.564444 876.088889z m0-351.459556a149.617778 149.617778 0 1 0 150.186667 149.617778 150.072889 150.072889 0 0 0-150.186667-149.617778z" fill="#0590DF" ></path><path d="M790.994489 828.2112l36.943644-37.091556L921.6 884.451556l-36.932267 37.080177z" fill="#0590DF" ></path></symbol><symbol id="iconsch" viewBox="0 0 1024 1024"><path d="M261.12 577.28h271.36c8.96 0 15.36-6.4 15.36-15.36s-6.4-15.36-15.36-15.36H261.12c-8.96 0-15.36 6.4-15.36 15.36s6.4 15.36 15.36 15.36zM762.88 687.36H261.12c-8.96 0-15.36 6.4-15.36 15.36s6.4 15.36 15.36 15.36h501.76c8.96 0 15.36-6.4 15.36-15.36s-6.4-15.36-15.36-15.36z" fill="#1296db" ></path><path d="M872.96 218.88c0-3.84-1.28-7.68-3.84-11.52-2.56-2.56-6.4-5.12-11.52-5.12H718.08v-49.92c0-8.96-6.4-15.36-15.36-15.36s-15.36 6.4-15.36 15.36v49.92H353.28v-49.92c0-8.96-6.4-15.36-15.36-15.36s-15.36 6.4-15.36 15.36v49.92H166.4c-8.96 0-15.36 6.4-15.36 15.36v652.8c0 3.84 1.28 7.68 5.12 11.52 2.56 2.56 6.4 3.84 10.24 3.84 257.28-2.56 647.68-5.12 684.8-1.28 1.28 1.28 3.84 1.28 5.12 1.28 3.84 0 7.68-1.28 11.52-5.12 3.84-3.84 5.12-11.52 3.84-16.64-3.84-34.56-1.28-401.92 1.28-645.12z m-550.4 15.36v88.32c0 8.96 6.4 15.36 15.36 15.36s15.36-6.4 15.36-15.36v-88.32h334.08v88.32c0 8.96 6.4 15.36 15.36 15.36s15.36-6.4 15.36-15.36v-88.32h122.88c0 29.44-1.28 96-1.28 175.36-1.28 0-2.56-1.28-5.12-1.28h-652.8V234.24h140.8z m188.16 619.52c-142.08 1.28-282.88 1.28-328.96 2.56V439.04h654.08c1.28 0 2.56 0 5.12-1.28v104.96c-1.28 192-1.28 275.2 1.28 311.04-39.68-1.28-125.44-1.28-331.52 0z" fill="#1296db" ></path></symbol></svg>', function (a) {
  var l = (l = document.getElementsByTagName("script"))[l.length - 1],
      c = l.getAttribute("data-injectcss"),
      l = l.getAttribute("data-disable-injectsvg");if (!l) {
    var h,
        _t,
        i,
        d,
        o,
        s = function s(l, c) {
      c.parentNode.insertBefore(l, c);
    };if (c && !a.__iconfont__svg__cssinject__) {
      a.__iconfont__svg__cssinject__ = !0;try {
        document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
      } catch (l) {
        console && console.log(l);
      }
    }h = function h() {
      var l,
          c = document.createElement("div");c.innerHTML = a._iconfont_svg_string_2473442, (c = c.getElementsByTagName("svg")[0]) && (c.setAttribute("aria-hidden", "true"), c.style.position = "absolute", c.style.width = 0, c.style.height = 0, c.style.overflow = "hidden", c = c, (l = document.body).firstChild ? s(c, l.firstChild) : l.appendChild(c));
    }, document.addEventListener ? ~["complete", "loaded", "interactive"].indexOf(document.readyState) ? setTimeout(h, 0) : (_t = function t() {
      document.removeEventListener("DOMContentLoaded", _t, !1), h();
    }, document.addEventListener("DOMContentLoaded", _t, !1)) : document.attachEvent && (i = h, d = a.document, o = !1, e(), d.onreadystatechange = function () {
      "complete" == d.readyState && (d.onreadystatechange = null, p());
    });
  }function p() {
    o || (o = !0, i());
  }function e() {
    try {
      d.documentElement.doScroll("left");
    } catch (l) {
      return void setTimeout(e, 50);
    }p();
  }
}(window);

/***/ }),

/***/ "71Nj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Y90":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8hJ6":
/***/ (function(module, exports) {

module.exports = {"_from":"encoding-japanese","_id":"encoding-japanese@2.0.0","_inBundle":false,"_integrity":"sha512-++P0RhebUC8MJAwJOsT93dT+5oc5oPImp1HubZpAuCZ5kTLnhuuBhKHj2jJeO/Gj93idPBWmIuQ9QWMe5rX3pQ==","_location":"/encoding-japanese","_phantomChildren":{},"_requested":{"type":"tag","registry":true,"raw":"encoding-japanese","name":"encoding-japanese","escapedName":"encoding-japanese","rawSpec":"","saveSpec":null,"fetchSpec":"latest"},"_requiredBy":["#USER","/"],"_resolved":"https://registry.npmjs.org/encoding-japanese/-/encoding-japanese-2.0.0.tgz","_shasum":"fa0226e5469e7b5b69a04fea7d5481bd1fa56936","_spec":"encoding-japanese","_where":"D:\\SVN\\大連\\AMS勤怠\\00_SRC\\AMS3.0_BO\\05_amsMobelAttnWeb","author":{"name":"polygonplanet","email":"polygon.planet.aqua@gmail.com"},"browserify":{"transform":["package-json-versionify"]},"bugs":{"url":"https://github.com/polygonplanet/encoding.js/issues"},"bundleDependencies":false,"dependencies":{},"deprecated":false,"description":"Convert or detect character encoding in JavaScript","devDependencies":{"bannerify":"^1.0.1","browserify":"^17.0.0","eslint":"^8.12.0","mocha":"^9.2.2","package-json-versionify":"^1.0.4","power-assert":"^1.6.1","uglify-js":"^3.15.3","uglifyify":"^5.0.2","watchify":"^4.0.0"},"engines":{"node":">=8.10.0"},"files":["encoding.js","encoding.min.js","encoding.min.js.map","src/*"],"homepage":"https://github.com/polygonplanet/encoding.js","keywords":["base64","charset","convert","detect","encoding","euc-jp","eucjp","iconv","iso-2022-jp","japanese","jis","shift_jis","sjis","unicode","urldecode","urlencode","utf-16","utf-32","utf-8"],"license":"MIT","main":"src/index.js","name":"encoding-japanese","repository":{"type":"git","url":"git+https://github.com/polygonplanet/encoding.js.git"},"scripts":{"build":"npm run compile && npm run minify","compile":"browserify src/index.js -o encoding.js -s Encoding -p [ bannerify --file src/banner.js ] --no-bundle-external --bare","minify":"uglifyjs encoding.js -o encoding.min.js --source-map \"url='encoding.min.js.map'\" --comments -c -m -b ascii_only=true,beautify=false","test":"eslint . && npm run build && mocha tests/test","watch":"watchify src/index.js -o encoding.js -s Encoding -p [ bannerify --file src/banner.js ] --no-bundle-external --bare --poll=300 -v"},"version":"2.0.0"}

/***/ }),

/***/ "8uC3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9UvG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AsIs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Au8q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Avw6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B1Vh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EuE6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "EvRM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FJkM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FwHB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GTAJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "GYi8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hap8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I5KZ":
/***/ (function(module, exports) {

!function (e) {
  var t,
      _n,
      c,
      o,
      l,
      _i,
      d = '<svg><symbol id="icon-EXCEL" viewBox="0 0 1024 1024"><path d="M259.020805 5.094415h508.932022C767.989216 4.11192 1000.258135 241.729975 1000.767576 239.364711v707.250306A72.595409 72.595409 0 0 1 927.990224 1018.882928H257.23776a73.032073 73.032073 0 0 1-50.398317-20.159327 71.17625 71.17625 0 0 1-22.379035-50.689426v-48.396939h60.114092v45.231125c-0.291109 7.386901 5.349135 13.718531 12.808814 1.237215h666.385824c0.218332 13.099923 0.400275 13.099923 0.618607 13.099923 8.078286 0 14.701025-6.33163 3.602479-14.337138V293.147174h-218.914275v-228.156999c-4.766917-0.618607-9.642999-0.618607-14.446304 7.787177H259.675801c-5.749411-6.04052-9.824943-1.018883-10.225218 4.912471v144.463044H189.300102V77.180382A72.413465 72.413465 0 0 1 259.020805 5.058026z m301.298237 300.570463V800.550872H18.273325V305.664878h542.082106zM199.998372 720.968837l51.67192-99.886915 1.819434-4.293864 2.365264-6.622739c0.072777-2.183321 0.072777-4.439418 0.363887-6.768294 0.291109 0.873328 0.727774 1.710268 1.455547 2.47443-0.145555 2.183321-0.145555 4.439418 0 6.622739a23.870971 23.870971 0 0 0 3.420535 8.005509l59.568263 106.145768 87.332822 4.694139-100.978576-167.497076 98.322203-166.441804-82.383962 4.293864-50.107207 98.831644c-2.692762 4.366641-4.621362 9.133558-5.713022 13.973252 0 4.730528-2.656373 9.315501-4.184698 13.973251-0.982494-4.584973-1.601102-9.206335-3.384147-13.645753a112.441009 112.441009 0 0 0-5.349135-12.954369l-44.758072-92.936678-79.6912 3.675256L214.772175 565.116138l-92.609181 152.213832 77.79899 3.638867z m666.49499-41.48309v67.428216l-237.690832-0.363887v-67.027941h237.690832z m0-134.67449v67.282662l-237.690832-0.363887v-66.955164h237.690832z m0-134.201437v67.391828l-237.690832-1.018883v-66.372945h237.690832z m-102.834399-172.846211h135.51143L763.622575 101.888293v135.838927zM255.818601 603.506191v-4.330252a11.607988 11.607988 0 0 1 0 4.330252z" fill="#07BD7C" ></path></symbol><symbol id="icon-word" viewBox="0 0 1024 1024"><path d="M562.176 277.593043H44.521739v526.380522h517.654261V277.593043z m-149.23687 404.123827H350.742261L305.953391 507.547826a146.788174 146.788174 0 0 1-4.229565-29.473391h-0.667826c-1.157565 11.931826-2.715826 21.815652-4.763826 29.473391l-45.768348 174.169044H185.922783l-70.032696-267.130435h61.395478l39.001044 181.069913c1.691826 7.969391 2.849391 17.942261 3.561739 30.007652h1.157565c0.578783-9.394087 2.31513-19.678609 5.253565-30.853565L275.144348 414.586435h59.525565l44.432696 182.450087c1.78087 7.257043 3.205565 16.695652 4.229565 28.315826h0.890435c0.400696-9.883826 1.691826-19.678609 3.873391-29.339826l38.15513-181.426087h56.80974l-70.077218 267.130435zM930.726957 174.970435l-123.236174-125.373218C780.644174 22.349913 727.752348 0 689.775304 0H275.812174c-37.977043 0-68.964174 31.610435-68.964174 70.166261v141.57913h55.206957v-141.57913c0-7.657739 6.41113-14.024348 13.801739-14.024348h413.96313c4.051478 0 8.815304 0.534261 13.801739 1.513739v222.96487h219.314087c0.979478 5.075478 1.513739 32.768 1.513739 37.042087v599.084521a14.157913 14.157913 0 0 1-13.890782 14.024348H275.812174a14.157913 14.157913 0 0 1-13.801739-14.024348v-47.059478h-55.206957v47.059478c0 38.64487 30.98713 70.166261 68.964174 70.166261H910.469565c37.977043 0 68.964174-31.521391 68.964174-70.166261V317.751652c0.044522-38.64487-21.904696-115.533913-48.795826-142.781217z m-171.987479 49.597217v-143.36c3.472696 2.404174 6.678261 5.12 9.616696 8.147478l123.191652 125.284174c2.982957 3.072 5.698783 6.41113 8.102957 9.928348h-140.911305zM625.530435 592.13913h226.437565v-65.80313H625.530435v65.80313z m0 131.606261h226.437565v-65.80313H625.530435v65.80313z m226.437565-329.015652H625.530435v65.803131h226.437565V394.774261z" fill="#0070D2" ></path></symbol></svg>',
      a = (a = document.getElementsByTagName("script"))[a.length - 1].getAttribute("data-injectcss");if (a && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (e) {
      console && console.log(e);
    }
  }function v() {
    l || (l = !0, c());
  }t = function t() {
    var e, t, n, c;(c = document.createElement("div")).innerHTML = d, d = null, (n = c.getElementsByTagName("svg")[0]) && (n.setAttribute("aria-hidden", "true"), n.style.position = "absolute", n.style.width = 0, n.style.height = 0, n.style.overflow = "hidden", e = n, (t = document.body).firstChild ? (c = e, (n = t.firstChild).parentNode.insertBefore(c, n)) : t.appendChild(e));
  }, document.addEventListener ? ~["complete", "loaded", "interactive"].indexOf(document.readyState) ? setTimeout(t, 0) : (_n = function n() {
    document.removeEventListener("DOMContentLoaded", _n, !1), t();
  }, document.addEventListener("DOMContentLoaded", _n, !1)) : document.attachEvent && (c = t, o = e.document, l = !1, (_i = function i() {
    try {
      o.documentElement.doScroll("left");
    } catch (e) {
      return void setTimeout(_i, 50);
    }v();
  })(), o.onreadystatechange = function () {
    "complete" == o.readyState && (o.onreadystatechange = null, v());
  });
}(window);

/***/ }),

/***/ "IJCh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IbRq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4+u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JH3r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KYqx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KqMY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LIDY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LT+B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LgX+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MPkl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NFlY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var actions_namespaceObject = {};
__webpack_require__.d(actions_namespaceObject, "increment", function() { return increment; });
__webpack_require__.d(actions_namespaceObject, "decrement", function() { return decrement; });
var getters_namespaceObject = {};
__webpack_require__.d(getters_namespaceObject, "getCount", function() { return getCount; });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol.js
var symbol = __webpack_require__("5QVw");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/vuex/actions.js
//test
var increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};
// CONCATENATED MODULE: ./src/vuex/getters.js
//test
var getCount = function getCount(state) {
    return state.count;
};
// CONCATENATED MODULE: ./src/vuex/store.js





vue_esm["default"].use(vuex_esm["a" /* default */]);

// 应用初始状态
var state = {
    count: 10,
    routerObj: null,
    menuLockStatus: '0',
    oneTimePwFlag: '0',
    mailNum: 0,
    hostname: ''

    // 定义所需的 mutations
};var mutations = {
    // お知らせ未確認件数变更
    mailNum: function mailNum(state, newState) {
        state.mailNum = newState < 0 ? 0 : newState;
    },
    increment: function increment(state, newState) {
        state.menuLockStatus = newState;
    },


    // pw变更
    passwordUpdate: function passwordUpdate(state, newState) {
        state.oneTimePwFlag = newState;
    },
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    },
    set_router: function set_router(state, routerObj) {
        state.routerObj = routerObj;
    },
    set_hostname: function set_hostname(state, hostname) {
        state.hostname = hostname;
    }
};

// 创建 store 实例
/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
    actions: actions_namespaceObject,
    getters: getters_namespaceObject,
    state: state,
    mutations: mutations
}));
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/message/i18n.js



vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

var _lang = localStorage.getItem('lang');
var ams_ja = __webpack_require__("zHK8");

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: _lang,
  messages: {
    'ja': ams_ja,
    'en': ams_ja
  }
});

/* harmony default export */ var message_i18n = (i18n);
// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// CONCATENATED MODULE: ./src/base/api/public.js

__webpack_require__("hKoQ").polyfill();




var public_url = __webpack_require__("kspH");

var Service = axios_default.a.create({
  //baseURL: url.axiosBaseURL,
  baseURL:  false ? "/" : public_url.axiosBaseURL,
  crossDomain: true,
  withCredentials: true,
  timeout: 300000
});
Service.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded';

Service.interceptors.request.use(function (config) {
  config.headers['Authorization'] = $cookies.get('token');
  config.headers['FrontendVersion'] = message_i18n.t('COMMON.LBL_VER').replace("Ver.", "");
  return config;
}, function (error) {
  return promise_default.a.reject(error);
});
Service.interceptors.response.use(function (response) {
  //hostnameを取得
  store.commit('set_hostname', response.headers['hostname']);
  return response;
}, function (error) {
  console.log('response異常');
  // 判断请求异常信息中是否含有超时timeout字符串
  if (error.message.includes('401')) {
    store.state.routerObj.replace({ path: '/login' });
  } else if (error.message.includes('400') || error.message.includes('405') || error.message.includes('500')) {
    store.state.routerObj.replace({ path: '/error' });
  } else if (error.message.includes('302')) {
    //弹出升级重刷新确认框
    element_ui_common["MessageBox"].alert(message_i18n.t('COMMON.MSG_VER_UPDATE_CONFIRM'), {
      confirmButtonText: message_i18n.t('COMMON.BTN_CONFIRM'),
      type: 'warning',
      center: 'true'
    }).then(function () {
      //this.$router.push({ path: "/login"});
      window.location.reload(true);
    }).catch(function () {
      //this.$router.push({ path: "/login"});
      window.location.reload(true);
    });
  } else if (error.message.includes('timeout')) {
    alert(message_i18n.t('COMMON.MSG_ERROR_TIMEOUT'));
  } else if (error.message.includes('Network Error')) {
    alert(message_i18n.t('COMMON.MSG_NETWORK_ERROR'));
  }
  return promise_default.a.reject(error);
});

/* harmony default export */ var api_public = ({
  //get请求
  requestGet: function requestGet(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new promise_default.a(function (resolve, reject) {
      Service.get(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  //get请求不带参数
  requestQuickGet: function requestQuickGet(url) {
    return new promise_default.a(function (resolve, reject) {
      Service.get(url).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  //post请求
  requestPost: function requestPost(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new promise_default.a(function (resolve, reject) {
      Service.post(url, params).then(function (res) {
        // var token = '';
        // if (url == '/mobile/j_spring_security_check') {
        //   try {
        //     token = res.data.items[0].token;
        //     if (token != '' && token != null && token != undefined) {
        //       $cookies.set('token',token,'1d');
        //     }
        //   } catch (e) {
        //     console.log(e);
        //   }
        // }
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  //post请求
  requestPostForm: function requestPostForm(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new promise_default.a(function (resolve, reject) {
      Service.post(url, params, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'accept': '*/*',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        resolve(res.data); //注意res是axios封装的对象，res.data才是服务端返回的信息
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // //put图片请求 form-data请求
  requestPostFormData: function requestPostFormData(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return new promise_default.a(function (resolve, reject) {
      Service.put(url, params, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },


  //put请求
  requestPut: function requestPut(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new promise_default.a(function (resolve, reject) {
      Service.put(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  //delete请求
  requestDelete: function requestDelete(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new promise_default.a(function (resolve, reject) {
      Service.delete(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  //get图片请求
  requestQuickGetImage: function requestQuickGetImage(url) {
    return new promise_default.a(function (resolve, reject) {
      Service.get(url, { responseType: 'arraybuffer' }).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  //post zip请求
  requestPostZip: function requestPostZip(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new promise_default.a(function (resolve, reject) {
      Service.post(url, params, { responseType: 'blob' }).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});
// EXTERNAL MODULE: ./node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("1nuA");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// CONCATENATED MODULE: ./src/common/utils.js




var apiUrl = __webpack_require__("kspH");

/* harmony default export */ var utils = ({
  calcTimeDifference: function calcTimeDifference(time1, time2) {
    if (!time1 || !time2) {
      return 0;
    }
    var timeArr1 = time1.split(":");
    var timeArr2 = time2.split(":");
    var minutes1 = Number(timeArr1[0]) * 60 + Number(timeArr1[1]);
    var minutes2 = Number(timeArr2[0]) * 60 + Number(timeArr2[1]);

    return minutes1 - minutes2;
  },

  /**
   * 入力した数値をコンマで毎3桁に分割する
   * 例：1234⇒1,234
   *     1234.5555⇒1,234.5555
   * @param {*} val フォマトの数値
   */
  decimalFormatter: function decimalFormatter(val) {
    if (val != null) {
      var reg = new RegExp(/(?=(\d)+(\.\d+)?$)/, 'g');
      if (reg.test(val)) {
        var valArr = val.split('.');
        valArr[0] = valArr[0].replace(/^0+\./, '0.').replace(/^0+([0-9])/, '$1').replace(/(?=(\B)(\d{3})+$)/g, '$1,');
        return valArr.length == 1 ? valArr[0] : valArr[0] + '.' + valArr[1];
      }
    }

    return val;
  },


  // 带,金额转number
  strToNum: function strToNum(val) {
    if (val != null && val !== '') {
      return Number(val.replace(/,/g, ''));
    } else {
      return 0;
    }
  },


  /**
   * 四舍五入
   * @param {*} num 変数
   * @param {*} n 小数桁数
   */
  tofixeds: function tofixeds(num, n) {
    var flag = 1;
    if (num < 0) {
      flag = -1;
      num *= -1;
    }

    num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) + Math.pow(10, -(n + 1));
    return (num * flag).toFixed(n);
  },


  // 日期格式化（yyyy/MM/dd）
  timeDefault: function timeDefault(date) {
    // 如果没有传日期参数，默认为系统时间
    if (!date) {
      var date = new Date();
    } else {
      var date = new Date(date);
    }
    var curr_date = date.getDate();
    var curr_month = date.getMonth() + 1;
    var curr_year = date.getFullYear();
    String(curr_month).length < 2 ? curr_month = "0" + curr_month : curr_month;
    String(curr_date).length < 2 ? curr_date = "0" + curr_date : curr_date;
    var s1 = curr_year + "/" + curr_month + "/" + curr_date;
    return s1;
  },

  //时间格式化
  timeFormatter: function timeFormatter(val) {
    var reg = /[^\d]/;
    if (reg.test(val)) val = val.replace(/[^0-9]/ig, "");
    if (val.length == 1) {
      val = '0' + val + ':00';
    } else if (val.length == 2) {
      val = '00:' + val;
    } else if (val.length == 3) {
      val = '0' + val[0] + ':' + val[1] + val[2];
    } else {
      val = val[0] + val[1] + ':' + val[2] + val[3];
    }
    var regex = /^([0-9][0-9]|4[0-5]):([0-5][0-9])$/;
    if (!regex.test(val)) {
      val = '00:00';
    }
    return val;
  },

  //时间去掉毫秒的部分
  extractMillisecond: function extractMillisecond(obj) {
    if (obj == null || obj == "") {
      return "";
    }
    var index = obj.lastIndexOf("\.");
    if (index == "-1") {
      return obj;
    } else {
      return obj.substring(0, index);
    }
  },


  // 时间戳（yyyyMMddHHmmssSSS）
  timeNumberGet: function timeNumberGet() {
    this.time_Format = new Date();
    var date = new Date();
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString().padStart(2, '0');
    var dd = date.getDate().toString().padStart(2, '0');
    var hh = date.getHours().toString().padStart(2, '0');
    var min = date.getMinutes().toString().padStart(2, '0');
    var ss = date.getSeconds().toString().padStart(2, '0');
    var ms = date.getMilliseconds().toString();
    String(ms).length < 2 ? ms = "0" + ms : ms;
    String(ms).length < 3 ? ms = "0" + ms : ms;
    var s1 = yyyy + mm + dd + hh + min + ss + ms;
    return s1;
  },

  /**
   * 获取上一个月
   *
   * @date 格式为yyyy/mm/dd的日期，如：2014/01/25
  */
  getPreMonth: function getPreMonth(date) {
    var arr = date.split('/');
    var year = arr[0]; //获取当前日期的年份
    var month = arr[1]; //获取当前日期的月份
    var day = arr[2]; //获取当前日期的日
    var days = new Date(year, month, 0);
    days = days.getDate(); //获取当前日期中月的天数
    var year2 = year;
    var month2 = parseInt(month) - 1;
    if (month2 == 0) {
      year2 = parseInt(year2) - 1;
      month2 = 12;
    }
    var day2 = day;
    var days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
      day2 = days2;
    }
    if (month2 < 10) {
      month2 = '0' + month2;
    }
    var t2 = year2 + '/' + month2 + '/' + day2;
    return t2;
  },

  /**
   * 获取下一个月
   *
   * @date 格式为yyyy/mm/dd的日期，如：2014/01/25
   */
  getNextMonth: function getNextMonth(date) {
    var arr = date.split('/');
    var year = arr[0]; //获取当前日期的年份
    var month = arr[1]; //获取当前日期的月份
    var day = arr[2]; //获取当前日期的日
    var days = new Date(year, month, 0);
    days = days.getDate(); //获取当前日期中的月的天数
    var year2 = year;
    var month2 = parseInt(month) + 1;
    if (month2 == 13) {
      year2 = parseInt(year2) + 1;
      month2 = 1;
    }
    var day2 = day;
    var days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
      day2 = days2;
    }
    if (month2 < 10) {
      month2 = '0' + month2;
    }

    var t2 = year2 + '/' + month2 + '/' + day2;
    return t2;
  },

  /**
   * 获取月末日
   *  @date 格式为yyyy/mm/dd的日期，如：2014/01/25
   */
  getLastDayOfMonth: function getLastDayOfMonth(date) {
    if (!date) {
      var date = new Date();
    } else {
      var date = new Date(date);
    }

    //下一个月1日
    var firstDayOfNextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);

    //减1日，这个月月末日
    var LastDayOfThisMonth = firstDayOfNextMonth.setDate(firstDayOfNextMonth.getDate() - 1);

    var s1 = this.timeDefault(LastDayOfThisMonth);

    return s1;
  },
  isEmpty: function isEmpty(obj) {
    if (obj == null || obj == "" || obj == undefined) {
      return true;
    }
    return false;
  },

  /**
  * 输入金额校验
  * @param {*} value  输入值
  * @param {*} maxIntNum 最大整数位
  * @param {*} maxDecNum 最大小数位
  * @param {*} canNegativeNum 是否能输入负数 不传默认false（不能输入负号）
  */
  validitMoney: function validitMoney(value, maxIntNum, maxDecNum, canNegativeNum) {
    if (canNegativeNum == '' || canNegativeNum == null || canNegativeNum == undefined) {
      canNegativeNum = false;
    }
    if (canNegativeNum == true) {
      value = value.replace(/[^\-\d.]/g, ''); // 只能输入.和-和数字
    } else {
      value = value.replace(/[^\d.]/g, ''); //第一个字符不能是-
    }
    value = value.replace(/^\./g, ''); //第一个字符不能是.
    value = value.replace(/\.{2,}/g, '.'); // 不能连续输入. 
    value = value.replace(/(\.\d+)\./g, '$1'); // .后面不能再输入.
    value = value.replace(/(-)\./g, '$1'); // -后面不能输入.
    value = value.replace(/\-{2,}/g, '-'); // -只能保留一个
    value = value.replace(/(\d+|\.)-/g, '$1'); // 数字和.后面不能接-,不能出现类似11-, 12.-
    value = value.replace(/-(0){2,}/g, "$1"); // 不能出现-00,-001,-0001类似
    value = value.replace(/(-)0+(\d+)/g, '$1$2'); // 不能出现-01,-02类似
    value = value.replace(/^0+(\d)/, '$1'); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
    var regMaxIntNum = new RegExp('(\\d{' + maxIntNum + '})\\d*');
    value = value.replace(regMaxIntNum, '$1'); // 最多保留6位整数
    var regMaxDecNum1 = new RegExp('(\\.\\d{' + maxDecNum + '})\\d*');
    value = value.replace(regMaxDecNum1, '$1'); // 最多保留2位小数
    // value = value.replace(/(\d{6})\d*/, '$1') // 最多保留6位整数
    // value = value.replace(/(\.\d{2})\d*/, '$1')// 最多保留2位小数
    return value;
  },

  /* 
  日付より曜日を返す
  date: 日期参数(date:yyyy/mm/dd)
  */
  getWeek: function getWeek(date) {
    var dateArray = date.split('/');
    var week = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
    return week.getDay() + 1;
  },

  //「作業開始／作業完了／戻す」処理
  jobStateEdit: function jobStateEdit(inputParam) {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var retInfo, strSysdate, param, checkParam, querys;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              retInfo = {};
              strSysdate = _this.timeDefault();
              //作業開始

              if (!(inputParam.btnType === '1')) {
                _context.next = 21;
                break;
              }

              if (!(strSysdate !== inputParam.jobDate)) {
                _context.next = 7;
                break;
              }

              retInfo.code = '310';
              retInfo.msgID = 'MSG_ERROR_INSTORE_JOBDATE';
              return _context.abrupt('return', retInfo);

            case 7:
              param = {};

              param.crewCd = inputParam.crewCd;
              //param.orderNo = inputParam.orderNo
              param.jobState = '1';
              param.gamenId = inputParam.gamenId;
              param.jobStateFlg = '0';
              param.checkFlg = inputParam.checkFlg;
              param.jobDate = inputParam.jobDate;
              param.salesOfficeCd = inputParam.salesOfficeCd; //営業所CD
              param.gamenIdRoleChk = inputParam.gamenIdRoleChk; //画面ID(権限チェック用)
              _context.next = 18;
              return api_public.requestPost(apiUrl.apiUrl_WorkJobstate, param).then(function (res) {
                retInfo.code = res.code;
                retInfo.msgID = res.message;
                return retInfo;
              });

            case 18:
              retInfo = _context.sent;
              _context.next = 59;
              break;

            case 21:
              if (!(inputParam.btnType === '2')) {
                _context.next = 46;
                break;
              }

              if (!(inputParam.checkFlg === '1')) {
                _context.next = 32;
                break;
              }

              checkParam = {};

              checkParam.div = '1';
              checkParam.crewCd = inputParam.crewCd;
              querys = querystring_es3_default.a.stringify(checkParam);
              _context.next = 29;
              return api_public.requestGet(apiUrl.apiUrl_Check + '?' + querys).then(function (res) {
                retInfo.code = res.code;
                retInfo.msgID = res.message;
                return retInfo;
              });

            case 29:
              retInfo = _context.sent;
              _context.next = 44;
              break;

            case 32:
              param = {};

              param.crewCd = inputParam.crewCd;
              //  param.orderNo = inputParam.orderNo
              param.jobState = '2';
              param.gamenId = inputParam.gamenId;
              param.jobStateFlg = '1';
              param.checkFlg = inputParam.checkFlg;
              param.jobDate = inputParam.jobDate;
              param.salesOfficeCd = inputParam.salesOfficeCd; //営業所CD
              param.gamenIdRoleChk = inputParam.gamenIdRoleChk; //画面ID(権限チェック用)
              _context.next = 43;
              return api_public.requestPost(apiUrl.apiUrl_WorkJobstate, param).then(function (res) {
                retInfo.code = res.code;
                retInfo.msgID = res.message;
                return retInfo;
              });

            case 43:
              retInfo = _context.sent;

            case 44:
              _context.next = 59;
              break;

            case 46:
              if (!(inputParam.btnType === '3')) {
                _context.next = 59;
                break;
              }

              //戻す
              param = {};

              param.crewCd = inputParam.crewCd;
              //  param.orderNo = inputParam.orderNo
              param.jobState = '1';
              param.gamenId = inputParam.gamenId;
              param.jobStateFlg = '2';
              param.checkFlg = inputParam.checkFlg;
              param.jobDate = inputParam.jobDate;
              param.salesOfficeCd = inputParam.salesOfficeCd; //営業所CD
              param.gamenIdRoleChk = inputParam.gamenIdRoleChk; //画面ID(権限チェック用)
              _context.next = 58;
              return api_public.requestPost(apiUrl.apiUrl_WorkJobstate, param).then(function (res) {
                retInfo.code = res.code;
                retInfo.msgID = res.message;
                return retInfo;
              });

            case 58:
              retInfo = _context.sent;

            case 59:
              return _context.abrupt('return', retInfo);

            case 60:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//



/* harmony default export */ var App = ({
  data: function data() {
    return {
      name: 'app'
    };
  },

  methods: {
    signin: function signin(callback) {
      var vm = this;
      store.commit('set_router', vm.$router);
      /*
      * Step 1
      * Check whether the user has access
      */

      var topath = vm.$router.currentRoute.path;
      var localUser = localStorage.getItem(topath);
      if (localUser) {

        return vm.$router.push({ path: vm.$router.currentRoute.path });
      } else {
        return vm.$router.push({ path: '/login' });
      }
    },
    loginDirect: function loginDirect(newPath) {
      var _this = this;

      /*
      * Monitor login events
      * Will trigger the events in views/login.vue
      */
      this.signin(function () {
        _this.$router.push({ path: newPath || '/' });
      });
    },
    logoutDirect: function logoutDirect() {
      /*
      * Monitor logout events
      * Will trigger the events in views/index.vue
      */
      //Clear local user information
      util.session('token', '');
      // logout 保留k0003 select选择值  Add xuyang 20230731
      var k0003_businessTypeSelectKey = localStorage.getItem('k0003_businessTypeSelectKey');
      console.log('logout-k0003_businessTypeSelectKey:' + k0003_businessTypeSelectKey);
      localStorage.clear();
      // logout 保留k0003 select选择值  Add xuyang 20230731
      localStorage.setItem('k0003_businessTypeSelectKey', k0003_businessTypeSelectKey);
      console.log(k0003_businessTypeSelectKey);
      // reload app
      window.location.href = Object({"NODE_ENV":"production"}).BASE_URL || '/';
    },
    // 言語切替
    changeLang: function changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
    }
  },
  created: function created() {
    /*
    * Start from here!
    */
    this.signin();
    // 言語切替
    this.changeLang('ja');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4df908b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"id":"app"},on:{"login":_vm.loginDirect,"logout":_vm.logoutDirect}})}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("MPkl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/components/api/login.js


var login_apiUrl = __webpack_require__("kspH");
// menu列表
var login_login_check = function login_check(params) {
    return api_public.requestPost(login_apiUrl.apiUrl_LoginCheck, params);
};

//パスワードフラグ検索
var login_pwFlagGet = function pwFlagGet(userCd) {
    return api_public.requestGet(login_apiUrl.apiUrl_PwFlag + '?userId=' + userCd);
};
// CONCATENATED MODULE: ./src/statics/css.js
var header = 'fontSize:10pt;background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48); ';
var css_loading = void 0;
/* harmony default export */ var css = ({
  methods: {
    tdStyleFontSize: function tdStyleFontSize() {
      return 'fontSize:9pt;';
    },

    //表头样式
    headerStyle: function headerStyle() {
      return header + 'padding:1px;';
    },

    //表格样式
    tdStyleLeft: function tdStyleLeft() {
      return 'text-align:left;' + this.tdStyleFontSize();
    },
    tdStyleRight: function tdStyleRight() {
      return 'text-align:right;' + this.tdStyleFontSize();
    },

    // Dialog 表格样式
    dialogHeaderStyle: function dialogHeaderStyle() {
      return header + 'padding:2px;';
    },
    dialogCellStyle_left: function dialogCellStyle_left() {
      return 'text-align:left;' + this.tdStyleFontSize();
    },
    dialogCellStyle_center: function dialogCellStyle_center() {
      return 'text-align:center;' + this.tdStyleFontSize();
    },
    set_loading: function set_loading() {
      //实现Loading 加载方法
      css_loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    close_loading: function close_loading() {
      //close Loading
      if ("undefined" != typeof css_loading) {
        css_loading.close();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/k_0008.vue
//
//
//
//
//


var k_0008_url = __webpack_require__("kspH");

/* harmony default export */ var k_0008 = ({
  data: function data() {
    return {
      userInfo: []
    };
  },

  methods: {
    destroyChatbotScript: function destroyChatbotScript() {
      var container = document.getElementById('k0008_container');
      if (container) {
        container.innerHTML = ''; // 清空容器内的内容
        // 可选：移除 k0008_container 元素本身
        container.parentNode.removeChild(container);
      }
    },
    removeScriptElement: function removeScriptElement() {
      // 移除动态创建的 script 元素
      if (this.scriptElement && this.scriptElement.parentNode) {
        this.scriptElement.parentNode.removeChild(this.scriptElement);
        this.scriptElement = null; // 释放引用
      }
    }
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {
    this.destroyChatbotScript();
    this.removeScriptElement();
  },
  mounted: function mounted() {
    var script = document.createElement('script');
    script.id = 'k0008_script';
    script.type = "text/javascript";
    script.innerHTML = "";
    var scriptText = "";
    scriptText = "(function (c, n, s) {";
    scriptText = scriptText + "if (c[n] === void 0) {c['ULObject'] = n; ";
    scriptText = scriptText + "		c[n] = c[n] || function () {(c[n].q = c[n].q || []).push(arguments)}; ";
    scriptText = scriptText + "		c[n].l = 1 * new Date();var e = document.createElement('script'); ";
    scriptText = scriptText + "		e.async = 1;e.src = s + '/chatbot.js'; ";
    scriptText = scriptText + "		var t = document.getElementsByTagName('script')[0];t.parentNode.insertBefore(e, t);} ";
    scriptText = scriptText + "})(window, 'ul_widget', 'https://support-widget.userlocal.jp'); ";
    scriptText = scriptText + "ul_widget('init', { 'id': '302ae48f41f91e4de143', 'site_in': true, 'mode_spa': true, 'lg_id': '', 'target_id':'ulAiWidget'});";
    scriptText = scriptText + "";
    script.innerHTML = scriptText;
    var container = document.getElementById('k0008_container');
    container.prepend(script);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba296d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/k_0008.vue
var k_0008_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var k_0008_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"},attrs:{"id":"k0008_container"}},[_c('div',{staticStyle:{"margin-top":"10px"},attrs:{"id":"ulAiWidget"}})])}]
var k_0008_esExports = { render: k_0008_render, staticRenderFns: k_0008_staticRenderFns }
/* harmony default export */ var page_k_0008 = (k_0008_esExports);
// CONCATENATED MODULE: ./src/module/page/k_0008.vue
function k_0008_injectStyle (ssrContext) {
  __webpack_require__("Pd1n")
}
var k_0008_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var k_0008___vue_template_functional__ = false
/* styles */
var k_0008___vue_styles__ = k_0008_injectStyle
/* scopeId */
var k_0008___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var k_0008___vue_module_identifier__ = null
var k_0008_Component = k_0008_normalizeComponent(
  k_0008,
  page_k_0008,
  k_0008___vue_template_functional__,
  k_0008___vue_styles__,
  k_0008___vue_scopeId__,
  k_0008___vue_module_identifier__
)

/* harmony default export */ var module_page_k_0008 = (k_0008_Component.exports);

// CONCATENATED MODULE: ./src/components/api/passwordResetDeliver.js



var passwordResetDeliver_apiUrl = __webpack_require__("kspH");

// パスワードリセット
var passwordResetDeliver_passwordReset = function passwordReset(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet(passwordResetDeliver_apiUrl.apiUrl_PwReset + '?' + querys);
};
//loginCheck
var passwordResetDeliver_login_check = function login_check(userCd, verCode) {
    return api_public.requestPost(passwordResetDeliver_apiUrl.apiUrl_TempCode + '?userCd=' + userCd + '&verCode=' + verCode);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/passwordResetDeliver.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var passwordResetDeliver_url = __webpack_require__("kspH");



/* harmony default export */ var passwordResetDeliver = ({
  mixins: [css],
  props: {
    showK0008Dialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "K0008": module_page_k_0008
  },
  data: function data() {
    return {
      staffNo: '',
      birthday: '',
      phoneNo: '',
      address: '',
      dialogVisible: false,
      authenticationCode: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    // 戻る処理
    back_click: function back_click() {
      this.$emit('closePasswordResetDeliverDialog');
    },
    sendBtnClick: function sendBtnClick() {
      var re = new RegExp(/^[0-9]{8}$/);
      //スタッフNo、生年月日、電話番号のいずれか入力していない場合、エラーメッセージ表示
      if (!this.staffNo) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.PASSWORDRESET_LBL_STAFF_NO')), showClose: true });
        return;
      }
      if (!this.birthday) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.PASSWORDRESET_LBL_BIRTHDAY')), showClose: true });
        return;
      }
      if (!this.phoneNo) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.PASSWORDRESET_LBL_PHONE_NO')), showClose: true });
        return;
      }
      //スタッフNoが8桁の数字で入力してください。
      if (!re.test(this.staffNo)) {
        this.$message.error({ message: this.$t('COMMON.MSG_STAFF_NO_VALIDITY'), showClose: true });
        return;
      }
      //生年月日が8桁の数字で入力してください。
      if (!re.test(this.birthday)) {
        this.$message.error({ message: this.$t('COMMON.MSG_BIRTHDAY_VALIDITY'), showClose: true });
        return;
      }
      this.userInfoSearch();
    },
    userInfoSearch: function userInfoSearch() {
      var _this = this;

      this.set_loading();
      var params = {};
      params.userId = this.staffNo;
      params.birthday = this.birthday;
      params.phoneNo = this.phoneNo;
      passwordResetDeliver_passwordReset(params).then(function (res) {
        if (res.code == '434') {
          //該当スタッフNoが存在しません。
          _this.$message.error({ message: _this.$t('COMMON.MSG_STAFF_NOT_EXIST'), showClose: true });
        }
        //生年月日、或いは電話番号が不正です。
        else if (res.code == '439') {
            _this.$message.error({ message: _this.$t('COMMON.MSG_PWRESET_INFO_ERROR'), showClose: true });
          }
          //該当スタッフNoのメールアドレスが空白。
          else if (res.code == '440') {
              _this.$message.error({ message: _this.$t('COMMON.MSG_ADDRESS_EXIST'), showClose: true });
            }
            //成功
            else if (res.code == '204') {
                _this.dialogVisible = true;
              }
              // 権限がありません。
              else if (res.code == '436') {
                  _this.$message.error({ message: _this.$t('COMMON.MSG_NO_AUTHORITY'), showClose: true });
                }
        _this.close_loading();
      }).catch(function (err) {
        _this.close_loading();
      });
    },

    //認証コードチェック
    codeCheck: function codeCheck() {
      var _this2 = this;

      var userCd = this.staffNo;
      var verCode = this.authenticationCode;
      passwordResetDeliver_login_check(userCd, verCode).then(function (res) {
        if (res.code == '442') {
          _this2.$message.success({ message: _this2.$t('COMMON.MSG_TEMPCODE_OK'), showClose: true });
          _this2.$router.push({ name: 'ホーム', params: { pwResetForwardFlag: "1" } });
        } else if (res.code == '441') {
          _this2.$message.error({ message: _this2.$t('COMMON.MSG_TEMPCODE_ERROR'), showClose: true });
          return;
        }
      }).catch(function (err) {
        _this2.$message.error({ message: _this2.$t('COMMON.MSG_TEMPCODE_ERROR'), showClose: true });
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485e69d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/passwordResetDeliver.vue
var passwordResetDeliver_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showK0008Dialog),expression:"!showK0008Dialog"}]},[_c('div',{staticClass:"modal-container-company",staticStyle:{"height":"100%","overflow":"auto","width":"100%"}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticStyle:{"width":"50%","text-align":"left"}},[_vm._v(_vm._s(_vm.$t('MODULE.PASSWORDRESET_DIALOG_TITLE')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","padding-right":"5px"},attrs:{"align":"right"}},[_c('el-button',{staticClass:"el-icon-close",staticStyle:{"color":"white"},attrs:{"type":"text"},on:{"click":_vm.back_click}})],1)]),_vm._v(" "),_c('div',{staticClass:"passwordReset_msg",attrs:{"align":"center"}},[_c('h1',{staticClass:"passwordReset_msg5"},[_vm._v(_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG5')))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG6'))}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG7'))}}),_vm._v(" "),_c('p',{staticClass:"passwordReset_msg8",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG8'))}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG9'))}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG10'))}}),_vm._v(" "),_c('table',{staticClass:"passwordReset-table table-label"},[_c('tr',[_c('td',{staticClass:"passwordReset-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_LBL_STAFF_NO'))}}),_vm._v(" "),_c('td',[_c('el-input',{staticClass:"passwordReset_input",attrs:{"maxlength":"8"},model:{value:(_vm.staffNo),callback:function ($$v) {_vm.staffNo=$$v},expression:"staffNo"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"passwordReset-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_LBL_BIRTHDAY'))}}),_vm._v(" "),_c('td',[_c('el-input',{staticClass:"passwordReset_input",attrs:{"maxlength":"8"},model:{value:(_vm.birthday),callback:function ($$v) {_vm.birthday=$$v},expression:"birthday"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"passwordReset-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_LBL_PHONE_NO'))}}),_vm._v(" "),_c('td',[_c('el-input',{staticClass:"passwordReset_input",model:{value:(_vm.phoneNo),callback:function ($$v) {_vm.phoneNo=$$v},expression:"phoneNo"}})],1)])])]),_vm._v(" "),_c('div',[_c('el-button',{staticClass:"css-button css-btn",staticStyle:{"margin-top":"15px"},attrs:{"type":"primary"},on:{"click":_vm.sendBtnClick}},[_vm._v(_vm._s(_vm.$t('MODULE.PASSWORDRESET_LBL_BACK')))])],1),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showK0008Dialog),expression:"showK0008Dialog"}]},[_c('div',{staticClass:"modal-container-company",staticStyle:{"height":"100%","overflow":"auto","width":"100%"}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0008_LBL_TITTLE')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","padding-right":"5px"},attrs:{"align":"right"}},[_c('el-button',{staticClass:"el-icon-close",staticStyle:{"color":"white"},attrs:{"type":"text"},on:{"click":_vm.back_click}})],1)]),_vm._v(" "),_c('K0008',{staticStyle:{"height":"50%"}})],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"codeCheck",attrs:{"visible":_vm.dialogVisible,"close-on-click-modal":false,"width":"70%","modal":false,"center":true},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticStyle:{"line-height":"2"}},[_vm._v(_vm._s(_vm.$t('MODULE.PASSWORDRESET_LBL_STAFF_NO_DIALOG'))+_vm._s(_vm.staffNo))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"2"}},[_vm._v(_vm._s(_vm.$t('MODULE.PASSWORDRESET_LBL_CONFIRM_DIALOG')))]),_vm._v(" "),_c('el-input',{staticClass:"passwordReset_input",staticStyle:{"margin-top":"5px"},model:{value:(_vm.authenticationCode),callback:function ($$v) {_vm.authenticationCode=$$v},expression:"authenticationCode"}}),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"css-button css-btn",attrs:{"type":"primary"},on:{"click":_vm.codeCheck}},[_vm._v("OK")])],1)],1)],1)}
var passwordResetDeliver_staticRenderFns = []
var passwordResetDeliver_esExports = { render: passwordResetDeliver_render, staticRenderFns: passwordResetDeliver_staticRenderFns }
/* harmony default export */ var page_passwordResetDeliver = (passwordResetDeliver_esExports);
// CONCATENATED MODULE: ./src/components/page/passwordResetDeliver.vue
function passwordResetDeliver_injectStyle (ssrContext) {
  __webpack_require__("Hap8")
}
var passwordResetDeliver_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var passwordResetDeliver___vue_template_functional__ = false
/* styles */
var passwordResetDeliver___vue_styles__ = passwordResetDeliver_injectStyle
/* scopeId */
var passwordResetDeliver___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var passwordResetDeliver___vue_module_identifier__ = null
var passwordResetDeliver_Component = passwordResetDeliver_normalizeComponent(
  passwordResetDeliver,
  page_passwordResetDeliver,
  passwordResetDeliver___vue_template_functional__,
  passwordResetDeliver___vue_styles__,
  passwordResetDeliver___vue_scopeId__,
  passwordResetDeliver___vue_module_identifier__
)

/* harmony default export */ var components_page_passwordResetDeliver = (passwordResetDeliver_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/passwordReset.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var passwordReset_url = __webpack_require__("kspH");

/* harmony default export */ var page_passwordReset = ({
  components: {
    "PasswordResetDeliver": components_page_passwordResetDeliver
  },
  data: function data() {
    return {
      showPasswordResetDeliverDialog: false,
      showK0008Dialog: false
    };
  },
  mounted: function mounted() {},

  methods: {
    // 戻る処理
    back_click: function back_click() {
      this.$emit('closepasswordResetDialog');
    },
    resetClick: function resetClick() {
      this.showK0008Dialog = false;
      this.showPasswordResetDeliverDialog = true;
    },
    closePasswordResetDeliverDialog: function closePasswordResetDeliverDialog() {
      this.showPasswordResetDeliverDialog = false;
    },
    submitPasswordResetDeliverDialog: function submitPasswordResetDeliverDialog() {
      this.showPasswordResetDeliverDialog = false;
      this.$emit('closepasswordResetDialog');
    },
    k0008ButtonClick: function k0008ButtonClick() {
      this.showK0008Dialog = true;
      this.showPasswordResetDeliverDialog = true;
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7029654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/passwordReset.vue
var passwordReset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('div',{staticClass:"modal-container-company",staticStyle:{"height":"100%","width":"100%","background":"white"}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v(_vm._s(_vm.$t('MODULE.PASSWORDRESET_DIALOG_TITLE')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","padding-right":"5px"},attrs:{"align":"right"}},[_c('el-button',{staticClass:"el-icon-close",staticStyle:{"color":"white"},attrs:{"type":"text"},on:{"click":_vm.back_click}})],1)]),_vm._v(" "),_c('el-container',{staticStyle:{"padding":"0px","width":"100%","height":"100%"}},[_c('el-main',[_c('div',{attrs:{"align":"center"}},[_c('div',{staticClass:"passwordReset_msg",attrs:{"align":"center"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG'))}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG1'))}})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"}},[_c('el-button',{staticClass:"passwordReset-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_BUTTON_NAME'))},on:{"click":_vm.resetClick}})],1),_vm._v(" "),_c('div',[_c('p',{staticStyle:{"font-size":"15px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_MSG_MSG4'))}})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"}},[_c('el-button',{staticClass:"passwordReset-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.PASSWORDRESET_BUTTON_NAME1'))},on:{"click":_vm.k0008ButtonClick}})],1),_vm._v(" "),(_vm.showPasswordResetDeliverDialog)?_c('PasswordResetDeliver',{attrs:{"visible":_vm.showPasswordResetDeliverDialog,"showK0008Dialog":_vm.showK0008Dialog},on:{"update:visible":function($event){_vm.showPasswordResetDeliverDialog=$event},"closePasswordResetDeliverDialog":_vm.closePasswordResetDeliverDialog,"submitPasswordResetDeliverDialog":_vm.submitPasswordResetDeliverDialog}}):_vm._e()],1)])],1)],1)])}
var passwordReset_staticRenderFns = []
var passwordReset_esExports = { render: passwordReset_render, staticRenderFns: passwordReset_staticRenderFns }
/* harmony default export */ var components_page_passwordReset = (passwordReset_esExports);
// CONCATENATED MODULE: ./src/components/page/passwordReset.vue
function passwordReset_injectStyle (ssrContext) {
  __webpack_require__("l7Pl")
}
var passwordReset_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var passwordReset___vue_template_functional__ = false
/* styles */
var passwordReset___vue_styles__ = passwordReset_injectStyle
/* scopeId */
var passwordReset___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var passwordReset___vue_module_identifier__ = null
var passwordReset_Component = passwordReset_normalizeComponent(
  page_passwordReset,
  components_page_passwordReset,
  passwordReset___vue_template_functional__,
  passwordReset___vue_styles__,
  passwordReset___vue_scopeId__,
  passwordReset___vue_module_identifier__
)

/* harmony default export */ var src_components_page_passwordReset = (passwordReset_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var login_url = __webpack_require__("kspH");
/* harmony default export */ var page_login = ({
  mixins: [css],
  components: {
    "PasswordReset": src_components_page_passwordReset
  },
  data: function data() {
    return {
      username: '',
      password: '',
      isBtnLoading: false,
      showpasswordResetDialog: false
    };
  },

  computed: {
    btnText: function btnText() {
      if (this.isBtnLoading) return message_i18n.t('COMMON.LOGIN_LBL_LOGINING');
      return message_i18n.t('COMMON.LOGIN_LBL_LOGIN');
    },
    user: function user() {
      return this.$store.state.user;
    },
    userid: function userid() {
      return message_i18n.t('COMMON.LOGIN_LBL_USER');
    },
    paswd: function paswd() {
      return message_i18n.t('COMMON.LOGIN_LBL_PASWD');
    }
  },
  methods: {
    login: function login() {
      var vm = this;
      if (!vm.username) {
        vm.$message.error(message_i18n.t('COMMON.LOGIN_LBL_USERCD_CHECK'));
        return;
      }
      if (!vm.password) {
        vm.$message.error(message_i18n.t('COMMON.LOGIN_LBL_PASSWORD_CHECK'));
        return;
      }
      vm.isBtnLoading = true;
      // ユーザーチェック
      var loginParams = { userCd: vm.username, password: vm.password };
      login_login_check(loginParams).then(function (res) {
        if (res.code == '200') {
          vm.$router.push({ path: login_url.routerUrl_Top });
        } else {
          vm.$message.error(message_i18n.t('COMMON.LOGIN_LBL_LOGINCHECK_ERROR'));
          return;
        }
      }).catch(function (err) {
        vm.$message.error(message_i18n.t('COMMON.LOGIN_LBL_LOGINCHECK_ERROR'));
        vm.isBtnLoading = false;
      });
      vm.isBtnLoading = false;
    },


    // 关闭企业对话框的弹窗回调
    closepasswordResetDialog: function closepasswordResetDialog() {
      this.companyInputEdit = false;
      this.showpasswordResetDialog = false;
    },

    // 选择企业对话框弹窗回调
    submitpasswordResetDialog: function submitpasswordResetDialog(row) {
      this.companyInputEdit = false;
      this.companyInput = row.companyName;
      this.companyDialogCd = row.companyCd;
      this.showpasswordResetDialog = false;
      this.storeInput = '';
      this.storeDialogCd = '';
    },
    blurSearchFor1: function blurSearchFor1() {
      this.companyInputEdit = true;
      this.showpasswordResetDialog = true;
    }
  },

  created: function created() {
    // logout 保留k0003 select选择值  Add xuyang 20230731
    var k0003_businessTypeSelectKey = localStorage.getItem('k0003_businessTypeSelectKey');
    console.log('login-k0003_businessTypeSelectKey:' + k0003_businessTypeSelectKey);
    localStorage.clear();
    // logout 保留k0003 select选择值  Add xuyang 20230731
    localStorage.setItem('k0003_businessTypeSelectKey', k0003_businessTypeSelectKey);
    this.close_loading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43cfda0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-center"},[_c('el-form',[_c('el-row',[_c('div',{attrs:{"align":"center"}},[_c('img',{staticStyle:{"width":"33.4%","height":"19.2%","text-align":"center","padding":"10px 0px 0px 0px"},attrs:{"src":__webpack_require__("Wb2M"),"alt":""}})]),_vm._v(" "),_c('el-form-item',{attrs:{"align":"center"}},[_c('div',{staticStyle:{"padding":"0px 0px 9px 0px"}},[_c('el-input',{staticClass:"login-input",attrs:{"size":"small","autofocus":true,"placeholder":_vm.userid,"maxlength":"16"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 0px 5px 0px"}},[_c('el-input',{staticClass:"login-input",attrs:{"size":"small","placeholder":_vm.paswd,"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('el-button',{staticClass:"login-button css-btn",attrs:{"type":"primary","loading":_vm.isBtnLoading},nativeOn:{"click":function($event){return _vm.login.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.btnText))])],1)])],1)],1),_vm._v(" "),_c('div',[_c('a',{staticClass:"passwordReset_button",staticStyle:{"text-decoration":"underline"},on:{"click":function($event){_vm.showpasswordResetDialog = true}}},[_vm._v(_vm._s(_vm.$t('COMMON.LOGIN_BUTTON')))]),_vm._v(" "),(_vm.showpasswordResetDialog)?_c('PasswordReset',{attrs:{"visible":_vm.showpasswordResetDialog,"show":_vm.showpasswordResetDialog},on:{"update:visible":function($event){_vm.showpasswordResetDialog=$event},"closepasswordResetDialog":_vm.closepasswordResetDialog,"submitpasswordResetDialog":_vm.submitpasswordResetDialog}}):_vm._e(),_vm._v(" "),(!_vm.showpasswordResetDialog)?_c('el-row',{staticClass:"ver-text"},[_vm._v("\n        "+_vm._s(_vm.$t('COMMON.LBL_VER'))+"\n      ")]):_vm._e()],1)],1)])}
var login_staticRenderFns = []
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var components_page_login = (login_esExports);
// CONCATENATED MODULE: ./src/components/page/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("3Yhd")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  page_login,
  components_page_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_components_page_login = (login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/components/api/home.js


var home_apiUrl = __webpack_require__("kspH");

// 初期化
var home_home = function home() {
  return api_public.requestQuickGet(home_apiUrl.apiUrl_Initialization);
};

// メニュー状態管理検索
var home_menuStateManager = function menuStateManager(userCd) {
  return api_public.requestGet(home_apiUrl.apiurl_MenuStateManager + "?userId=" + userCd);
};

//お知らせ検索
var home_noticeDetailGet = function noticeDetailGet(userCd) {
  return api_public.requestGet(home_apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd);
};

//パスワードフラグ検索
var home_pwFlagGet = function pwFlagGet(userCd) {
  return api_public.requestGet(home_apiUrl.apiUrl_PwFlag + '?userId=' + userCd);
};
// CONCATENATED MODULE: ./src/module/api/b_0001.js




var b_0001_apiUrl = __webpack_require__("kspH");
// 検索
var b_0001_noticeDetailGet = function noticeDetailGet(userCd) {
    return api_public.requestGet(b_0001_apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd);
};

// 検索
var b_0001_noticeSave = function noticeSave(saveParams, userCd) {
    return api_public.requestPost(b_0001_apiUrl.apiUrl_Notice + '?userCd=' + userCd, saveParams);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/b_0001.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var b_0001_url = __webpack_require__("kspH");

/* harmony default export */ var b_0001 = ({
  mixins: [css],
  name: '',
  data: function data() {
    return {
      userCd: '', //login-userCd
      tNoticeDetail: [],
      saveParams: {},
      clientWidth: 0
    };
  },
  created: function created() {
    this.clientWidth = document.body.clientWidth;
    window.localStorage.removeItem(b_0001_url.routerUrl_B0001);
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    this.query();
  },


  methods: {
    // お知らせ一覧情報を取得する
    query: function query() {
      var _this = this;

      //实现Loading 加载方法
      this.set_loading();
      b_0001_noticeDetailGet(this.userCd).then(function (res) {
        if (res.code == '300') {
          _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true }); //該当データはありません。
        } else {
          _this.tNoticeDetail = res.items.tNoticeDetail;
          var mailNum = 0;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = get_iterator_default()(_this.tNoticeDetail), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.confirmFlag == '0') {
                mailNum++;
              }
            }
            // 未确认通知数更新
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.$store.commit('mailNum', mailNum);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(_this.tNoticeDetail), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              if (item.mailDate) {
                item.mailDate = utils.timeDefault(item.mailDate);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
        _this.close_loading();
      }).catch(function (err) {
        _this.close_loading();
      });
    },


    // お知らせ一覧情報を確認する
    noticeConfirm: function noticeConfirm() {
      var _this2 = this;

      var params = [];
      params.push(this.saveParams);
      b_0001_noticeSave(params, this.userCd).then(function (res) {
        if (res.code == '202') {
          var mailNum = 0;
          mailNum = _this2.$store.state.mailNum;
          // 更新メニュー欄のメッセージアイコンに未確認件数
          _this2.$store.commit('mailNum', mailNum - 1);
        } else if (res.code == '311') {
          _this2.$message.error({ message: message_i18n.$t('COMMON.CURD_ERROR'), showClose: true }); //更新失敗になる
        }
      });
    },


    // 明細行选择
    rowClick: function rowClick(row) {
      this.noticeCd = row.noticeCd;
      this.saveParams.noticeCd = row.noticeCd;
      this.saveParams.userId = this.userCd;
      this.saveParams.processDiv = '4';
      this.saveParams.editFlg = '1';
      if (row.confirmFlag == '0') {
        this.noticeConfirm();
      }
      this.$router.push({ path: b_0001_url.routerUrl_B0002, query: { userCd: this.userCd, noticeCd: this.noticeCd } });
    }
  },

  mounted: function mounted() {
    var that = this;
    window.onresize = function () {
      return function () {
        window.clientWidth = document.body.clientWidth;
        that.clientWidth = window.clientWidth;
      }();
    };
  },


  watch: {
    // 监听窗口宽度变化
    clientWidth: function clientWidth(val) {
      if (!this.timer) {
        // 一旦监听到的clientWidth值改变，就将其重新赋给data里的clientWidth
        this.clientWidth = val;
        this.timer = true;
        var that = this;
        setTimeout(function () {
          // 打印clientWidth变化的值
          that.timer = false;
        }, 400);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35971e63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/b_0001.vue
var b_0001_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticClass:"b0001-box-card"},[_c('el-row',{staticStyle:{"margin-top":"8px"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.$t('MODULE.B0001_LBL_INFORM')))])]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tNoticeDetail,"show-header":false},on:{"row-click":_vm.rowClick}},[_c('el-table-column',{attrs:{"prop":"value","label":"","width":"25px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.confirmFlag=='0')?_c('span',{staticStyle:{"color":"#409EFF","font-size":"25px"}},[_vm._v("●")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('span',{staticClass:"b0001-noticeTitle",style:({width:_vm.clientWidth-150+'px'})},[_vm._v(_vm._s(scope.row.mailTitle))]),_vm._v(" "),_c('div',{staticStyle:{"float":"right","margin-right":"0px"}},[_vm._v(_vm._s(scope.row.mailDate))])]),_vm._v(" "),_c('div',{staticClass:"b0001-mailContents"},[_vm._v(" "+_vm._s(scope.row.mailContents)+" ")])]}}])})],1)],1)],1)}
var b_0001_staticRenderFns = []
var b_0001_esExports = { render: b_0001_render, staticRenderFns: b_0001_staticRenderFns }
/* harmony default export */ var page_b_0001 = (b_0001_esExports);
// CONCATENATED MODULE: ./src/module/page/b_0001.vue
function b_0001_injectStyle (ssrContext) {
  __webpack_require__("gu/3")
}
var b_0001_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var b_0001___vue_template_functional__ = false
/* styles */
var b_0001___vue_styles__ = b_0001_injectStyle
/* scopeId */
var b_0001___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var b_0001___vue_module_identifier__ = null
var b_0001_Component = b_0001_normalizeComponent(
  b_0001,
  page_b_0001,
  b_0001___vue_template_functional__,
  b_0001___vue_styles__,
  b_0001___vue_scopeId__,
  b_0001___vue_module_identifier__
)

/* harmony default export */ var module_page_b_0001 = (b_0001_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/home.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var home_url = __webpack_require__("kspH");
/* harmony default export */ var page_home = ({
  name: "Map",
  components: {
    B0001: module_page_b_0001
  },
  data: function data() {
    return {
      pageReload: true,
      userCd: '',
      s0001: false,
      c0001: false,
      p0001: false,
      d0001: false,
      i0001: false,
      i0002: false,
      i0003: false,
      i0004: false,
      i0005: false,
      i0007: false,
      i0008: false,
      i0010: false,
      i0011: false,
      i0013: false,
      i0014: false,
      i0015: false,
      i0016: false,
      k0001: false,
      k0003: false,
      k0006: false,
      btn1: false,
      btn2: false,
      btn3: false,
      btn4: false,
      paid: false,
      immediate_payment: false,
      job_introduction: false,
      w0001: false,
      activeName: '1',
      homeTittle: '',
      userInfo: [],
      menuState: {},
      drawer: false,
      dialogTableVisible: false,
      imgUrl1: __webpack_require__("jlC0"),
      imgUrl2: __webpack_require__("GTAJ"),
      imgUrl3: __webpack_require__("EuE6"),
      imgUrlaaa: __webpack_require__("1ZJi"),
      userFont: '1rem', //导航用户名字体大小（动态）
      hostName: '',
      menuOpenShow: false //是否可以按下菜单按钮
    };
  },
  created: function created() {
    // 导航用户名字体大小动态修改
    if (window.innerWidth < 360) {
      this.userFont = '.875rem';
    }
    this.homeTittle = this.$route.name;
    //hostnameを取得
    this.hostName = store.state.hostname;
  },

  //页面初期化
  mounted: function mounted() {
    this.init_query();
  },

  methods: {
    // 初期化
    init_query: function init_query() {
      var _this = this;

      home_home().then(function (res) {
        _this.userInfo = res.items.userInfo;
        localStorage.setItem("userInfo", stringify_default()(_this.userInfo));
        _this.userCd = _this.userInfo.userCd;
        if (!_this.$route.params.pwResetForwardFlag) {
          _this._pwFlagGet();
        } else {
          _this.$router.push({ path: home_url.routerUrl_I0012 });
        }
      });
    },


    // パスワードフラグ検索
    _pwFlagGet: function _pwFlagGet() {
      var _this2 = this;

      home_pwFlagGet(this.userCd).then(function (res) {
        var oneTimePwFlag = res.items.pwFlag[0].oneTimePwFlag;
        _this2.$store.commit('passwordUpdate', oneTimePwFlag);
        if (oneTimePwFlag === '1') {
          // 初期パスワードを持ってログインユーザーと見做して、パスワード変更画面を表示する																						
          _this2.$router.replace({ path: home_url.routerUrl_I0012 });
        } else {
          // ワンタイムパスワードフラグが「0」の場合、
          _this2._menuStateManager();
        }
      });
    },


    // メニューボタンを押したら、各ボタンの状態を設定する
    menuOpen: function menuOpen() {
      var _this3 = this;

      this.handleMenuData();
      //判断是否可以点击menu
      if (this.menuOpenShow) {
        home_menuStateManager(this.userCd).then(function (res) {
          if (res.code == 204) {
            _this3.menuState = res.items.menuState[0];
            localStorage.setItem("menuState", stringify_default()(_this3.menuState));
            //
            if (_this3.menuState.i0011Used == '0' && _this3.menuState.c0001Expired == '1') {
              _this3.menuOpenShow = false;
            } else {
              _this3.menuOpenShow = true;
            }
          }
        });
      }
      if (this.menuOpenShow) {
        return;
      }
      //hostnameを取得
      this.hostName = store.state.hostname;
      // Localhostから各ボタンの状態を取得する
      if (JSON.parse(localStorage.getItem('menuState'))) {
        this.menuState = JSON.parse(localStorage.getItem('menuState'));
        var that = this;
        // 申請項目（プロフィール基本申請～契約照会）にはいずれか1または２であれば、ボタン情報を再取得
        var arr = [];
        for (var key in this.menuState) {
          if (key.indexOf('Used') != -1) {
            // 获取所有申請項目状态
            arr.push(this.menuState[key]);
          }
        }
        if (arr.indexOf(1) != -1 || arr.indexOf(2) != -1) {
          that._menuStateManager('menuOpen');
        } else {
          that.dialogTableVisible = true;
        }
      } else {
        this._menuStateManager('menuOpen');
      }
    },


    // メニュー状態管理情報を取得する
    _menuStateManager: function _menuStateManager(val) {
      var _this4 = this;

      home_menuStateManager(this.userCd).then(function (res) {
        if (res.code == 204) {
          _this4.menuState = res.items.menuState[0];
          localStorage.setItem("menuState", stringify_default()(_this4.menuState));
          if (val == 'menuOpen') {
            _this4.dialogTableVisible = true;
          } else {
            _this4.mailSearch();
          }
          //判断是否可以点击menu
          if (_this4.menuState.i0011Used == '0' && _this4.menuState.c0001Expired == '1') {
            _this4.menuOpenShow = false;
          } else {
            _this4.menuOpenShow = true;
          }
        }
      });
    },


    //お知らせ検索
    mailSearch: function mailSearch() {
      var _this5 = this;

      home_noticeDetailGet(this.userCd).then(function (res) {
        if (res.code == '204') {
          _this5.tNoticeDetail = res.items.tNoticeDetail;
          // 取未确认消息数量并更新入vuex
          var mailNum = 0;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = get_iterator_default()(_this5.tNoticeDetail), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.confirmFlag == '0') {
                mailNum++;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this5.$store.commit('mailNum', mailNum);
        }
        _this5.pageJump(mailNum);
      });
    },


    //メニュー状態管理情報を取得する,画面を表示する
    pageJump: function pageJump(mailNum) {
      if (this.menuState.i0011Used == '1') {
        //誓約・同意は0の場合、誓約・同意画面を表示する
        this.$store.commit('increment', '1');
        this.menuOpenShow = true;
        this.$router.push({ path: home_url.routerUrl_I0011 });
      } else if (this.menuState.c0001Used == '1') {
        //上記3.2.1で取得した契約照会は1の場合、契約照会画面を表示する
        this.$store.commit('increment', '1');
        this.menuOpenShow = true;
        this.$router.push({ path: home_url.routerUrl_C0001 });
      } else if (this.menuState.i0008Expired == '0' && this.menuState.i0008Used != '2') {
        //上記3.2.1で取得したマイカー出勤申請(期間切れ) =「0」かつ　マイカー出勤申請) !=「2」の場合、マイカー出勤申請画面を表示する
        this.$store.commit('increment', '1');
        this.$router.push({ path: home_url.routerUrl_I0013 });
      } else if (mailNum > 0) {
        // 確認フラグは０の場合、お知らせ一覧画面を表示する
        this.$store.commit('increment', '1');
        this.$router.push({ path: home_url.routerUrl_B0001 });
      } else {
        this.$router.push({ path: home_url.routerUrl_S0001 });
      }
    },


    //menu选中
    menuClick: function menuClick(path) {
      // 修改被选中的menu边框样式
      this.menuSelected(path);
      if (path == 'i0005OrI0006') {
        if (this.menuState.i0005Used == '1') {
          path = 'i0005';
        } else {
          path = 'i0006';
        }
      }

      //有給申請
      if (path == 'paid') {
        window.open(home_url.routerUrl_paid_apply);
        return;
      }

      if ('/' + path != this.$route.path) {
        //画面遷移
        this.$router.push({ path: path });
      }

      // 关闭menu
      this.dialogTableVisible = false;
    },


    // 修改被选中的menu边框样式
    menuSelected: function menuSelected(val) {
      this.s0001 = false;
      this.c0001 = false;
      this.p0001 = false;
      this.d0001 = false;
      this.i0001 = false;
      this.i0002 = false;
      this.i0003 = false;
      this.i0004 = false;
      this.i0005 = false;
      this.i0007 = false;
      this.i0008 = false;
      this.i0010 = false;
      this.i0011 = false;
      this.i0013 = false;
      this.i0014 = false;
      this.i0015 = false;
      this.i0016 = false;
      this.k0001 = false;
      this.k0003 = false;
      this.k0006 = false;
      this.btn1 = false;
      this.btn2 = false;
      this.btn3 = false;
      this.btn4 = false;
      this.paid = false;
      this.immediate_payment = false;
      this.job_introduction = false;
      this.w0001 = false;
      this[val] = true;
    },


    // 問合せ連絡先<br/>(オフィス事務センター)
    btn1Click: function btn1Click(val) {
      var vm = this;
      this.menuSelected(val);
      localStorage.setItem(home_url.routerUrl_K0008, stringify_default()(true));
      vm.$router.push({ path: home_url.routerUrl_K0008 });
      this.dialogTableVisible = false;
    },

    //add by hexy 20210105 start
    // ハラスメント相談窓口<br/>(社内相談フォーム)
    btn2Click: function btn2Click(val) {
      this.menuSelected(val);
      window.open(home_url.routerUrl_K0005_btn3URL);
    },


    // ハラスメント相談窓口<br/>(社外メール相談
    btn3Click: function btn3Click(val) {
      this.menuSelected(val);
      window.open("mailto: info1-ajis-group@solare-sr.com");
    },


    // StaffExpressNEO<br/>ログイン
    btn4Click: function btn4Click(val) {
      this.menuSelected(val);
      window.open(home_url.routerUrl_K0005_btn1URL);
    },


    //お仕事紹介,即払い
    paymentJobClick: function paymentJobClick(val) {
      var token = $cookies.get('token');
      this.menuSelected(val);

      //お仕事紹介
      if (val == 'immediate_payment') {
        window.open(home_url.routerUrl_immediate_payment + '?Authorization=' + token, '_top');
        return;
      };

      //即払い
      if (val == 'job_introduction') {
        window.open(home_url.routerUrl_job_introduction + '?Authorization=' + token, '_top');
        return;
      };
    },


    // 点击tabs时，menu切换
    tabsClick: function tabsClick() {
      var index = Number(this.activeName) - 1;
      this.swiper.slideTo(index, 200, false);
    },


    // 右滑
    slideNextTransitionEnd: function slideNextTransitionEnd() {
      this.activeName = Number(this.activeName) + 1 > 3 ? '3' : (Number(this.activeName) + 1).toString();
    },

    // 左滑
    slidePrevTransitionEnd: function slidePrevTransitionEnd() {
      this.activeName = Number(this.activeName) - 1 < 1 ? '1' : (Number(this.activeName) - 1).toString();
    },


    // 点击お知らせicon
    noticeClick: function noticeClick() {
      this.handleMenuData();
      if (this.menuOpenShow) {
        return;
      }
      this.pageReload = false;
      // 重新加载页面（不是刷新）
      this.$nextTick(function () {
        this.pageReload = true;
      });
      this.$router.push({ path: home_url.routerUrl_B0001 });
    },


    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      // vuex重置
      this.$store.commit('increment', '0');
      this.$store.commit('passwordUpdate', '0');
      this.$store.commit('mailNum', 0);
      vm.$router.push({ path: "/login" });
    },

    //路由变化 menu缓存数据获取
    handleMenuData: function handleMenuData() {
      this.menuState = JSON.parse(localStorage.getItem('menuState'));
      if (this.menuState.i0011Used == '0' && this.menuState.c0001Expired == '1') {
        this.menuOpenShow = false;
      } else {
        this.menuOpenShow = true;
      }
    }
  },
  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.$swiper;
    },


    //监听「ワンタイムパスワードフラグ」变化
    oneTimePwFlag: function oneTimePwFlag() {
      return this.$store.state.oneTimePwFlag;
    },


    // 监听vuex中mailNum变化
    mailNum: function mailNum() {
      return this.$store.state.mailNum;
    }
  },
  watch: {
    $route: {
      handler: function handler(to, from) {
        this.homeTittle = this.$route.name;
      }
    },
    // 监听oneTimePwFlag状态变化
    oneTimePwFlag: function oneTimePwFlag(val) {
      if (val == '0') {
        this._menuStateManager();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2856a686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/home.vue
var home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-dialog',{staticClass:"menu-dialog",attrs:{"visible":_vm.dialogTableVisible,"fullscreen":true},on:{"update:visible":function($event){_vm.dialogTableVisible=$event}}},[_c('el-tabs',{attrs:{"stretch":true},on:{"tab-click":_vm.tabsClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":_vm.$t('MODULE.MENU_LBL_TIMESHEET'),"name":"1"}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":_vm.$t('MODULE.MENU_LBL_TOIAWASE'),"name":"2"}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":_vm.$t('MODULE.MENU_LBL_STAFFINFO'),"name":"3"}})],1),_vm._v(" "),_c('swiper',{ref:"mySwiper",staticClass:"menu-swiper",on:{"slidePrevTransitionEnd":function($event){return _vm.slidePrevTransitionEnd()},"slideNextTransitionEnd":function($event){return _vm.slideNextTransitionEnd()}}},[_c('swiper-slide',{staticStyle:{"height":"900px"}},[_c('div',{staticClass:"home-menu"},[_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.k0001},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('k0001')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconqindai"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_KINTAI')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.k0006},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('k0006')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconjingfei"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_KEIHI')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.s0001},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('s0001')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconsch"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_SCHEDULE')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0015},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('i0015')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconicon-test"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_PAIDAPPLY')))])]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show"}],staticClass:"home-button",class:{},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('i0017')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icongongzuo"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_WORKBAG')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.immediate_payment},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.paymentJobClick('immediate_payment')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icongongzuo"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_JOB_INTRODUCTION')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.job_introduction},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.paymentJobClick('job_introduction')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconzhifu"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_IMMEDIATE_PAYMENT')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.w0001},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('w0001')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconqiyue"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_AMOUNT')))])])],1)]),_vm._v(" "),_c('swiper-slide',{staticStyle:{"height":"900px"}},[_c('div',{staticClass:"home-menu1"},[_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.btn1},staticStyle:{"margin-top":"10px","margin-left":"38px"},nativeOn:{"click":function($event){return _vm.btn1Click('btn1')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconoffice"}})]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-2px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.K0005_LBL_BTN1'))}})]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.btn2},staticStyle:{"margin-top":"10px","margin-left":"5px"},nativeOn:{"click":function($event){return _vm.btn2Click('btn2')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconform"}})]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-2px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.K0005_LBL_BTN2'))}})]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"home-button",class:{menuClick:_vm.btn3},staticStyle:{"margin-top":"10px","margin-left":"38px"},nativeOn:{"click":function($event){return _vm.btn3Click('btn3')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconyoujian"}})]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-2px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.K0005_LBL_BTN3'))}})]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"home-button",class:{menuClick:_vm.btn4},staticStyle:{"margin-top":"10px","margin-left":"5px"},nativeOn:{"click":function($event){return _vm.btn4Click('btn4')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconse_xitong"}})]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-2px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.K0005_LBL_BTN4'))}})])],1)]),_vm._v(" "),_c('swiper-slide',{staticStyle:{"height":"900px"}},[_c('div',{staticClass:"home-menu"},[_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.k0003},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('k0003')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconskill"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_HOURLYWAGE')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.p0001},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('p0001')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icongeiyu"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_PAY_INQUIRY')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.c0001,bgColor:_vm.menuState.c0001Used==1},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('c0001')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.c0001Used==2),expression:"menuState.c0001Used==2"}],staticClass:"iconfont iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconRightStyle:_vm.menuState.c0001Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconqiyue"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_CONTRACT_INQUIRY')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0013,bgColor:_vm.menuState.i0008Used==1},staticStyle:{"margin-left":"5px","margin-top":"8px"},on:{"click":function($event){return _vm.menuClick('i0013')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0008Expired==0),expression:"menuState.i0008Expired==0"}],staticClass:"iconfont iconjinggao menu-warn-icon-left"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0008Used==2),expression:"menuState.i0008Used==2"}],staticClass:"iconfont iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconLeftStyle:_vm.menuState.i0008Expired==0&&_vm.menuState.i0008Used!=2,iconRightStyle:_vm.menuState.i0008Expired!=0&&_vm.menuState.i0008Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconmycar"}})]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-6px","margin-bottom":"-5px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.MENU_LBL_CAR_WORK'))}})]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0001,bgColor:_vm.menuState.i0001Used==1},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('i0001')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0001Used==2),expression:"menuState.i0001Used==2"}],staticClass:"iconfont iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconRightStyle:_vm.menuState.i0001Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconjibenxinxi"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_BASIC_STAFF_INFO')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0003,bgColor:_vm.menuState.i0003Used==1},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('i0003')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0003Used==2),expression:"menuState.i0003Used==2"}],staticClass:"iconfont iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconRightStyle:_vm.menuState.i0003Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconhuikuan"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_SALARY_ACCOUNT')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0004,bgColor:_vm.menuState.i0004Used==1},staticStyle:{"margin-left":"5px","margin-top":"8px"},on:{"click":function($event){return _vm.menuClick('i0004')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0004Used==2),expression:"menuState.i0004Used==2"}],staticClass:"iconfont iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconRightStyle:_vm.menuState.i0004Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconjinjilianluo"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_EMERGENCY_CONTACT')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0010,bgColor:_vm.menuState.i0010Used==1},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('i0010')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0010Expired==0),expression:"menuState.i0010Expired==0"}],staticClass:"iconfont  iconjinggao menu-warn-icon-left"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0010Used==2),expression:"menuState.i0010Used==2"}],staticClass:"iconfont  iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconLeftStyle:_vm.menuState.i0010Expired==0&&_vm.menuState.i0010Used!=2,iconRightStyle:_vm.menuState.i0010Expired!=0&&_vm.menuState.i0010Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconguoji"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_NATIONALITY_CONFIRM')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0005,bgColor:_vm.menuState.i0005Used==1},staticStyle:{"margin-left":"5px","margin-top":"8px"},on:{"click":function($event){return _vm.menuClick('i0005OrI0006')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0005Used==2),expression:"menuState.i0005Used==2"}],staticClass:"iconfont iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconRightStyle:_vm.menuState.i0005Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#iconshenfenzheng"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_MYNANBAR')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0011,bgColor:_vm.menuState.i0011Used==1},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('i0011')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0011Used==2),expression:"menuState.i0011Used==2"}],staticClass:"iconfont iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconRightStyle:_vm.menuState.i0011Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icontongyi"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_OATH_AGREE')))])]),_vm._v(" "),_c('el-button',{staticClass:"home-button",class:{menuClick:_vm.i0014,bgColor:_vm.menuState.i0014Used==1},staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"click":function($event){return _vm.menuClick('i0014')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuState.i0014Used==2),expression:"menuState.i0014Used==2"}],staticClass:"iconfont iconshenqingzhong menu-warn-icon-right"}),_vm._v(" "),_c('svg',{staticClass:"svg-icon",class:{iconRightStyle:_vm.menuState.i0014Used==2},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icondefault"}})]),_c('br'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('MODULE.MENU_LBL_TRAINING')))])])],1)])],1)],1),_vm._v(" "),_c('el-header',{staticStyle:{"padding":"0px","width":"100%","height":"100%"}},[_c('el-row',{staticClass:"home-logout-head"},[_c('span',{staticClass:"el-icon-menu css-white",staticStyle:{"font-size":"32px","margin-top":"4px","padding-left":"4px"},on:{"click":_vm.menuOpen}}),_vm._v(" "),_c('el-image',{staticClass:"img-icon",staticStyle:{"margin-top":"6px","display":"inline-block","vertical-align":"top"},attrs:{"src":_vm.imgUrl1,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"menu-right",staticStyle:{"float":"right"}},[_c('el-badge',{staticClass:"badge-message",attrs:{"hidden":_vm.mailNum==0,"value":_vm.mailNum}},[_c('i',{staticClass:"el-icon-message",on:{"click":function($event){return _vm.noticeClick()}}})]),_vm._v(" "),_c('div',{staticClass:"userhead"},[_c('el-image',{staticClass:"img-icon",attrs:{"src":_vm.imgUrl2,"alt":""}})],1),_vm._v(" "),_c('div',{staticClass:"username",style:({fontSize:_vm.userFont})},[_c('span',[_vm._v(_vm._s(this.userInfo.userName))])]),_vm._v(" "),_c('div',{staticClass:"logoutIcn"},[_c('el-image',{staticClass:"img-icon",attrs:{"src":_vm.imgUrl3,"alt":""},on:{"click":_vm.log_out}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"home-tittle-head",staticStyle:{"padding-top":"2px"},attrs:{"align":"left"}},[_c('span',{staticClass:"css-white",staticStyle:{"font-size":"14px","padding-left":"5px","text-align":"left"}},[_vm._v(_vm._s(this.homeTittle))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","float":"right","color":"white","margin-right":"5px"},domProps:{"innerHTML":_vm._s(_vm.hostName)}})]),_vm._v(" "),_c('el-row')],1),_vm._v(" "),_c('el-main',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[(_vm.pageReload)?_c('router-view'):_vm._e()],1)],1)}
var home_staticRenderFns = []
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var components_page_home = (home_esExports);
// CONCATENATED MODULE: ./src/components/page/home.vue
function home_injectStyle (ssrContext) {
  __webpack_require__("l5D2")
}
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = home_injectStyle
/* scopeId */
var home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  page_home,
  components_page_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)

/* harmony default export */ var src_components_page_home = (home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/top.vue
//
//
//
//
//

/* harmony default export */ var page_top = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d632cbe6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/top.vue
var top_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var top_staticRenderFns = []
var top_esExports = { render: top_render, staticRenderFns: top_staticRenderFns }
/* harmony default export */ var components_page_top = (top_esExports);
// CONCATENATED MODULE: ./src/components/page/top.vue
function top_injectStyle (ssrContext) {
  __webpack_require__("e+7C")
}
var top_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var top___vue_template_functional__ = false
/* styles */
var top___vue_styles__ = top_injectStyle
/* scopeId */
var top___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var top___vue_module_identifier__ = null
var top_Component = top_normalizeComponent(
  page_top,
  components_page_top,
  top___vue_template_functional__,
  top___vue_styles__,
  top___vue_scopeId__,
  top___vue_module_identifier__
)

/* harmony default export */ var src_components_page_top = (top_Component.exports);

// CONCATENATED MODULE: ./src/module/api/k_0001.js
/* eslint-disable camelcase */


var k_0001_apiUrl = __webpack_require__("kspH");

// 初期化
var k_0001_home = function home() {
  return api_public.requestQuickGet(k_0001_apiUrl.apiUrl_Initialization);
};
// 检索处理
var k_0001_k_0001 = function k_0001(params) {
  return api_public.requestQuickGet('api/v1/staff/attendances' + '/from/' + params.dateFrom + '/end/' + params.dateTo);
};

// 入店退店点击后更新处理
var k_0001_k_0001_update = function k_0001_update(params) {
  return api_public.requestPut(k_0001_apiUrl.apiUrl_StaffAttendances, params);
};
// 出発コール、退店コール
var k_0001_jobStateApi = function jobStateApi(params) {
  return api_public.requestPost(k_0001_apiUrl.apiUrl_WorkJobstate, params);
};

// チェック用のAPI
var k_0001_checkApi = function checkApi(params) {
  return api_public.requestQuickGet(k_0001_apiUrl.apiUrl_Check + '?div=' + params.div + '&crewCd=' + params.crewCd);
};
// EXTERNAL MODULE: ./node_modules/element-ui/lib/locale/lang/ja.js
var ja = __webpack_require__("znjY");
var ja_default = /*#__PURE__*/__webpack_require__.n(ja);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/k_0001.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var k_0001_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var page_k_0001 = ({
  data: function data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      imgIconComplete: __webpack_require__("NFlY"),
      imgIconPlan: __webpack_require__("dP0d"),
      imgIconUnderway: __webpack_require__("/fmQ"),
      imgIconCloseComplete: __webpack_require__("OBZi"),
      imgIconGoComplete: __webpack_require__("XuR1"),
      list: [],
      queryParams: {
        siteId: '' // サイトid
      },
      kikanVal1: '',
      kikanVal2: '',
      fullscreenLoading: false,
      // 実働時間
      realityTime: '00:00',
      // 内深夜実働時間
      lateRealityTime: '00:00'
    };
  },

  methods: {
    // 初期化
    init_query: function init_query() {
      var _this = this;

      // 期間初期化
      var search_condition = JSON.parse(localStorage.getItem('search_condition'));
      if (search_condition == null) {
        var today = new Date();
        var torrom = new Date();
        this.kikanVal1 = today;
        var torrom = torrom.setDate(torrom.getDate() + 1);
        torrom = new Date(torrom);
        this.kikanVal2 = torrom;
        var search_condition = {};
        search_condition.fromDate = this.dateToString(this.kikanVal1, '0');
        search_condition.toDate = this.dateToString(this.kikanVal2, '0');
        localStorage.setItem('search_condition', stringify_default()(search_condition));
      } else {
        var fromDate = search_condition.fromDate;
        var toDate = search_condition.toDate;
        if (search_condition.fromDate != null) {
          this.kikanVal1 = new Date(fromDate.substring(0, 4) + '/' + fromDate.substring(4, 6) + '/' + fromDate.substring(6, 8));
        } else {
          this.kikanVal1 = null;
        }
        if (search_condition.toDate != null) {
          this.kikanVal2 = new Date(toDate.substring(0, 4) + '/' + toDate.substring(4, 6) + '/' + toDate.substring(6, 8));
        } else {
          this.kikanVal2 = null;
        }
      }
      k_0001_home().then(function (res) {
        _this.userInfo = res.items.userInfo;
        localStorage.setItem('userInfo', stringify_default()(_this.userInfo));
      });
    },

    // 検索ボタン
    query_btn: function query_btn(e) {
      // 点击后失去焦点(用于按钮还原)
      var target = e.target;
      target.blur();

      var search_condition = {};
      search_condition.fromDate = this.dateToString(this.kikanVal1, '0');
      search_condition.toDate = this.dateToString(this.kikanVal2, '0');
      localStorage.setItem('search_condition', stringify_default()(search_condition));
      this.query();
    },

    // 検索
    query: function query() {
      var _this2 = this;

      var dateFrom = '';
      var dateTo = '';
      if (this.dateToString(this.kikanVal1, '0') !== null) {
        dateFrom = this.dateToString(this.kikanVal1, '0');
      } else {
        dateFrom = null;
      }
      if (this.dateToString(this.kikanVal2, '0') !== null) {
        dateTo = this.dateToString(this.kikanVal2, '0');
      } else {
        dateTo = null;
      }
      if (dateFrom != null && dateTo != null && dateFrom > dateTo) {
        this.$message.error({ message: this.$t('COMMON.MSG_MESSAGE_ERROR_FROMDATE'), showClose: true }); // 期間開始日＜＝期間終了日で設定してください。
      } else {
        var Params = {
          'dateFrom': dateFrom,
          'dateTo': dateTo
        };
        var loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(function () {
          loading.close();
        }, 2000);
        // 検索処理
        k_0001_k_0001(Params).then(function (res) {
          // 戻るリスト
          _this2.total = res.total;
          _this2.list = res.items;
          if (res.code === 300) {
            _this2.$message.warning({ message: _this2.$t('COMMON.NO_TARGET_DATA'), showClose: true });
            loading.close();
            return;
          }
          loading.close();
        });
      }
    },

    // TABLEHeader样式
    k0001HeaderStyle: function k0001HeaderStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; ';
    },

    // TABLE单元格样式
    k0001IsCellStyle: function k0001IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return 'text-align:center;fontSize:10pt';
    },

    // 时给确认画面link
    k0003linkClick: function k0003linkClick() {
      window.open(k_0001_url.testUrl);
    },

    // 单击行事件
    k0001RowOnClick: function k0001RowOnClick(thisRowDate, column, cell, event) {
      // 计划的场合，点击无效
      if (thisRowDate.jobStateCd == 0) {
        return;
      }
      if (column.property !== 'col1' && column.property !== 'col2') {
        return;
      }
      thisRowDate.goalFlg = '3';
      localStorage.setItem('obj', stringify_default()(thisRowDate));
      localStorage.setItem(k_0001_url.routerUrl_K0002, stringify_default()(true));
      this.$router.push({ path: k_0001_url.routerUrl_K0002 });
    },

    // 入店按钮处理
    inStoreBtnFunction: function inStoreBtnFunction(index, thisRowDate) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var res, today, strTodayHHMM, strDate, ret, param;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$confirm_hint(_this3.$t('COMMON.MSG_MESSAGE_INSTORE'), _this3.$t('COMMON.MSG_DELETE_CONFIRM'), _this3.$t('COMMON.MSG_DELETE_CANCEL'));

              case 2:
                res = _context.sent;

                if (!res) {
                  _context.next = 33;
                  break;
                }

                //更新按钮
                today = new Date();
                // システム時刻

                strTodayHHMM = '';

                strTodayHHMM = _this3.dateToStringHHMM(today, 0);
                strDate = _this3.dateToString(today, '1');
                // 作業日チェック

                if (!(strDate !== thisRowDate.jobDate)) {
                  _context.next = 11;
                  break;
                }

                _this3.$message.error({ message: _this3.$t('COMMON.MSG_ERROR_INSTORE_JOBDATE'), showClose: true }); // 作業日が異なります。入店できません。
                return _context.abrupt('return');

              case 11:
                if (!((thisRowDate.workType == 1 || thisRowDate.workType == 2) && thisRowDate.jobStateCd == 0)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 14;
                return _this3.workStart(thisRowDate);

              case 14:
                ret = _context.sent;

                if (ret.successFlg) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt('return');

              case 17:
                param = {};
                // 実働時間、内深夜実働時間計算

                _this3.realityTime = _this3.calculateWorkTime(strTodayHHMM, thisRowDate.acStoreOut, thisRowDate.allRestTime);
                _this3.lateRealityTime = _this3.calculateLatenightWorkTime(strTodayHHMM, thisRowDate.acStoreOut, thisRowDate.inLateBreak);
                param.div = '1';
                param.crewCd = thisRowDate.crewCd;
                param.storePositionCd = thisRowDate.storePositionCd;
                param.storeInTime = strTodayHHMM;
                param.storeOutTime = thisRowDate.acStoreOut;
                param.updateDate = thisRowDate.updateDate;
                param.jobDate = thisRowDate.jobDate;
                param.workTime = _this3.realityTime;
                param.latenightWorkTime = _this3.lateRealityTime;
                param.personalJobState = '2';
                k_0001_k_0001_update(param).then(function (res) {
                  _this3.res_code_back(res);
                });
                _context.next = 34;
                break;

              case 33:
                return _context.abrupt('return');

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },

    // 退店按钮处理
    outStoreBtnFunction: function outStoreBtnFunction(index, thisRowDate) {
      var _this4 = this;

      var returnFlg = false; //trueの場合、更新しない
      this.$confirm(this.$t('COMMON.MSG_MESSAGE_OUTSTORE'), { // 退店を更新します。よろしいですか。
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(function () {
        // システム日(date)
        var today = new Date();
        // 昨日(date)
        var yesterday = new Date();
        yesterday = yesterday.setDate(today.getDate() - 1);
        yesterday = new Date(yesterday);
        // 昨日(str)
        var strYesterday = _this4.dateToString(yesterday, '1');
        // システム時刻
        var strTodayHHMM = '';
        // 棚卸日が昨日の場合、退店時+24処理
        if (strYesterday === thisRowDate.jobDate) {
          strTodayHHMM = _this4.dateToStringHHMM(today, 24);
        } else {
          strTodayHHMM = _this4.dateToStringHHMM(today, 0);
        }
        // システム時刻(num)))
        var min_sysDate = _this4.stringToMin(strTodayHHMM);
        // 未入店チェック
        if (thisRowDate.acStoreIn === null || thisRowDate.acStoreIn === '') {
          _this4.$message.error({ message: _this4.$t('COMMON.MSG_ERROR_OUTSTORE_INSTORE_NULL'), showClose: true }); // 入店していないため、退店できません。
          returnFlg = true;
        }
        if (returnFlg == false && strYesterday > thisRowDate.jobDate) {
          // 棚卸日が昨日以前の場合、更新しない
          _this4.$message.error({ message: _this4.$t('COMMON.MSG_ERROR_STORE_INOUT_JOBDATE'), showClose: true }); // 作業日が異なります。退店できません。
          returnFlg = true;
        }
        if (returnFlg == false) {
          // 入店時刻(num)
          var min_storeIn = _this4.stringToMin(thisRowDate.acStoreIn);
          // 入退店の関連チェック
          if (min_storeIn > min_sysDate) {
            _this4.$message.error({ message: _this4.$t('COMMON.MSG_STORE_INOUT_VALIDITY'), showClose: true }); // 入店＜退店で入力してください。
            returnFlg = true;
          }
          // 入退店時刻の差チェック
          if (returnFlg == false && min_sysDate - min_storeIn > 24 * 60) {
            _this4.$message.error({ message: _this4.$t('COMMON.MSG_STORE_INOUT_SA_VALIDITY'), showClose: true }); // 入店時刻から退店時刻が24時間以内になるよう時刻を入力してください。
            returnFlg = true;
          }
          // 退店時刻が46時を超えるかチェック
          if (returnFlg == false && strYesterday === thisRowDate.jobDate && min_sysDate > 46 * 60) {
            // 棚卸日が昨日且つ最大46：00 以上の場合
            _this4.$message.error({ message: _this4.$t('COMMON.MSG_ERROR_OUTSTORE_24'), showClose: true }); // 退店時刻が最大46：00まで入力してください。
            returnFlg = true;
          }
        }
        if (returnFlg == false) {
          var min_allRestTime = _this4.stringToMin(thisRowDate.allRestTime);
          // 休憩時間の合理性チェック 全休憩時間＞（退店-入店）
          if (min_allRestTime > min_sysDate - min_storeIn) {
            _this4.$message.error({ message: _this4.$t('COMMON.MSG_RESTTIME_VALIDITY'), showClose: true }); // 休憩時間を正しく入力してください。
            returnFlg = true;
          }
        }
        //以上チェックokの場合、更新処理
        if (returnFlg == false) {
          // 実働時間、内深夜実働時間計算
          _this4.realityTime = _this4.calculateWorkTime(thisRowDate.acStoreIn, strTodayHHMM, thisRowDate.allRestTime);
          _this4.lateRealityTime = _this4.calculateLatenightWorkTime(thisRowDate.acStoreIn, strTodayHHMM, thisRowDate.inLateBreak);
          var param = {};
          param.div = '2';
          param.crewCd = thisRowDate.crewCd;
          param.storePositionCd = thisRowDate.storePositionCd;
          param.storeInTime = thisRowDate.acStoreIn;
          param.storeOutTime = strTodayHHMM;
          param.updateDate = thisRowDate.updateDate;
          param.jobDate = thisRowDate.jobDate;
          param.workTime = _this4.realityTime;
          param.latenightWorkTime = _this4.lateRealityTime;
          param.personalJobState = '3';
          // 更新処理
          k_0001_k_0001_update(param).then(function (res) {
            _this4.res_code_back(res);
          });
        }
      }).catch(function () {
        // キャンセル
      });
    },
    k0001HeaderClass: function k0001HeaderClass(_ref3) {
      var row = _ref3.row,
          rowIndex = _ref3.rowIndex;

      return 'k0001HeaderClass';
    },
    k0001IsCellClass: function k0001IsCellClass(_ref4) {
      var row = _ref4.row,
          rowIndex = _ref4.rowIndex;

      return 'k0001IsCellClass';
    },

    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: '/login' });
    },

    // 戻る処理
    back_click: function back_click() {
      var vm = this;
      vm.$router.push({ path: k_0001_url.routerUrl_Menu });
    },

    // res_code処理
    res_code_back: function res_code_back(res) {
      var _this5 = this;

      if (res.code === 202) {
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
        this.query();
      } else if (res.code === 308) {
        setTimeout(function () {
          _this5.$confirm(_this5.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this5.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: _this5.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(function () {
            _this5.query();
          }).catch(function () {
            // いいえ
          });
        }, 500);
      } else if (res.code === 408) {
        setTimeout(function () {
          _this5.$confirm(_this5.$t('COMMON.MSG_ERROR_STATE_OVER'), { // 作業状態はもう作業完了でした。他の人が先に更新した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this5.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: _this5.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(function () {
            _this5.query();
          }).catch(function () {
            // いいえ
          });
        }, 500);
        // } else if (res.code === 427) {
        //   setTimeout(() => {
        //     this.$confirm(this.$t('COMMON.MSG_APPROVAL'), { // 勤怠承認済、戻り値メッセージを表示する
        //       confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        //       cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
        //       center: true
        //     }).then(() => {
        //       // はい
        //       this.query()
        //     }).catch(() => {
        //       // いいえ
        //     })
        //   }, 500)
      } else if (res.code === 617) {
        var reg1 = '{0}';
        var reg2 = '{1}';
        var msg = this.$t('COMMON.MSG_KINTAITIME_VALIDITY').replace(reg1, res.items.InOut).replace(reg2, res.items.dbInOut);
        this.$message.error({ message: msg, showClose: true }); // 更新失敗
      } else if (res.code === 428) {
        setTimeout(function () {
          _this5.$confirm(_this5.$t('COMMON.MSG_TRANSMIT'), { // 勤怠承認済、戻り値メッセージを表示する
            confirmButtonText: _this5.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this5.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true
          }).then(function () {
            // はい
            _this5.query();
          }).catch(function () {
            // いいえ
          });
        }, 500);
      } else {
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
      }
    },

    // date->string(0:yyyymmdd  1:yyyy/mm/dd ) 変化
    dateToString: function dateToString(dateTime, changeType) {
      var strTime = '';
      if (dateTime == null) {
        return null;
      }
      var year = dateTime.getFullYear();
      var month = (dateTime.getMonth() + 1).toString();
      var day = dateTime.getDate().toString();
      if (month.length === 1) {
        month = '0' + month;
      }
      if (day.length === 1) {
        day = '0' + day;
      }
      if (changeType === '0') {
        strTime = year + month + day;
      } else if (changeType === '1') {
        strTime = year + '/' + month + '/' + day;
      } else {
        strTime = year + month + day;
      }
      return strTime;
    },

    // date->string(HH:MM) 変化
    dateToStringHHMM: function dateToStringHHMM(dateTime, addHour) {
      var strTime = '';
      if (dateTime == null) {
        return '';
      }
      var hours = dateTime.getHours() + addHour;
      var minutes = dateTime.getMinutes();
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      strTime = hours + ':' + minutes;
      return strTime;
    },

    // 時刻(分) str->num (00:00->num)
    stringToMin: function stringToMin(time) {
      if (time === null || time === '') {
        return 0;
      } else {
        return Number(time.substring(0, 2)) * 60 + Number(time.substring(3, 5));
      }
    },

    // 出発コール
    departBtnFunction: function departBtnFunction(index, thisRowDate) {
      var _this6 = this;

      this.$confirm(this.$t('COMMON.MSG_JOBSTATE'), { // 作業開始します。よろしいでしょうか。
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
        center: true
      }).then(function () {
        // 作業開始处理
        var today = new Date();
        var strTodayHHMM = _this6.dateToStringHHMM(today, 0);
        var strDate = _this6.dateToString(today, '1');
        // 作業日チェック
        if (strDate !== thisRowDate.jobDate) {
          _this6.$message.error({ message: _this6.$t('COMMON.MSG_ERROR_DEPART_JOBDATE'), showClose: true }); // 作業日が異なります。開始できません。
          return;
        }
        var param = {};
        // 画面ID
        param.gamenId = 'SK_0001';
        // チェックフラグ
        param.checkFlg = '0';
        // 作業日
        param.jobDate = thisRowDate.jobDate;
        // クルーコード
        param.crewCd = thisRowDate.crewCd;
        // 受注NO
        // param.orderNo = thisRowDate.orderNo.replace(new RegExp('-', 'g'), '')
        // 作業状態
        param.jobState = '1';
        // 作業状態フラグ
        param.jobStateFlg = '0';

        _this6.openFullScreen();
        k_0001_jobStateApi(param).then(function (res) {
          // 关闭loading
          _this6.closeFullScreen(_this6.openFullScreen());
          var code = res.code;
          switch (code) {
            case 412:
            case 201:
              _this6.$confirm(_this6.$t('COMMON.MSG_MESSAGE_DEPARTURE_CALL'), { // 出発記録します。よろしいでしょうか。
                confirmButtonText: _this6.$t('COMMON.MSG_DELETE_CONFIRM'),
                cancelButtonText: _this6.$t('COMMON.MSG_DELETE_CANCEL'),
                center: true
              }).then(function () {
                // はい 出発記録处理
                var param = {};
                param.div = '3';
                param.crewCd = thisRowDate.crewCd;
                param.storePositionCd = thisRowDate.storePositionCd;
                param.personalJobState = '1';
                param.jobDate = thisRowDate.jobDate;
                // 出発コール
                param.departureCall = strTodayHHMM;
                // 更新処理
                k_0001_k_0001_update(param).then(function (res) {
                  // 关闭loading
                  _this6.closeFullScreen(_this6.openFullScreen());
                  // 更新成功 跳转到详细
                  if (res.code === 202) {
                    _this6.changeFgl = false;
                    thisRowDate.goalFlg = '1';
                    localStorage.setItem('obj', stringify_default()(thisRowDate));
                    localStorage.setItem(k_0001_url.routerUrl_K0002, stringify_default()(true));
                    _this6.$router.push({ path: k_0001_url.routerUrl_K0002 });
                  } else {
                    _this6.res_code_back(res);
                  }
                });
              }).catch(function () {
                // いいえ
                var param = {};
                param.div = '3';
                param.crewCd = thisRowDate.crewCd;
                param.storePositionCd = thisRowDate.storePositionCd;
                param.personalJobState = '1';
                param.jobDate = thisRowDate.jobDate;
                // 出発コール
                param.departureCall = strTodayHHMM;
                // 更新処理
                k_0001_k_0001_update(param).then(function (res) {
                  // 关闭loading
                  _this6.closeFullScreen(_this6.openFullScreen());
                  _this6.res_code_back(res);
                });
              });
              break;
            case 311:
              _this6.$message.error({ message: _this6.$t('MODULE.MSG_CURD_ERROR'), showClose: true });
              break;
          }
        }).catch(function (err) {
          // 关闭loading
          _this6.closeFullScreen(_this6.openFullScreen());
        });
      }).catch(function () {
        // いいえ
      });
    },

    // 退店コール
    quitBtnFunction: function quitBtnFunction(index, thisRowDate) {
      if (thisRowDate.jobStateCd === '0') {
        return;
      }
      thisRowDate.goalFlg = '2';
      localStorage.setItem('obj', stringify_default()(thisRowDate));
      localStorage.setItem(k_0001_url.routerUrl_K0002, stringify_default()(true));
      this.$router.push({ path: k_0001_url.routerUrl_K0002 });
    },

    // quitBtnFunction_B (thisRowDate) {
    //   var param = {}
    //   // 画面ID
    //   param.gamenId = 'SK_0001'
    //   // チェックフラグ
    //   param.checkFlg = '0'
    //   // 作業日
    //   param.jobDate = ''
    //   // クルーコード
    //   param.crewCd = thisRowDate.crewCd
    //   // 受注NO
    //   param.orderNo = thisRowDate.orderNo.replace(new RegExp('-', 'g'), '')
    //   // 作業状態
    //   param.jobState = '2'
    //   // 作業状態フラグ
    //   param.jobStateFlg = '1'
    //   amsApi.jobStateApi(param).then(res => {
    //     var code = res.code
    //     switch (code) {
    //       case 402:
    //         this.$message.error({ message: this.$t('COMMON.MSG_STORETIME_NOT_INPUT'), showClose: true })
    //         break
    //       case 403:
    //         this.$message.error({ message: this.$t('COMMON.MSG_SIGN_NOT_INPUT'), showClose: true })
    //         break
    //       case 405:
    //         this.$message.error({ message: this.$t('COMMON.MSG_SOTRESIGN_NOT_INPUT'), showClose: true })
    //         break
    //       case 418:
    //         this.$message.error({ message: this.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true })
    //         break
    //       case 408:
    //         this.$confirm(this.$t('COMMON.MSG_ERROR_STATE_OVER'), {
    //           confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),
    //           cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),
    //           center: true
    //         }).then(() => {
    //           // はい
    //           this.query()
    //         }).catch(() => {
    //           // いいえ
    //         })
    //         break
    //       case 412:
    //         this.$confirm(this.$t('COMMON.MSG_STATE_ING'), {
    //           confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),
    //           cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),
    //           center: true
    //         }).then(() => {
    //           // はい
    //           this.query()
    //         }).catch(() => {
    //           // いいえ
    //         })
    //         break
    //       case 428:
    //         this.$confirm(this.$t('COMMON.MSG_TRANSMIT'), {
    //           confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),
    //           cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),
    //           center: true
    //         }).then(() => {
    //           // はい
    //           this.query()
    //         }).catch(() => {
    //           // いいえ
    //         })
    //         break
    //       case 202:
    //         this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true })
    //         this.query()
    //         break
    //       case 201:
    //         this.$message.success({ message: this.$t('COMMON.MSG_INSERTED'), showClose: true })
    //         this.query()
    //         break
    //       case 311:
    //         this.$message.error({ message: this.$t('MODULE.MSG_CURD_ERROR'), showClose: true })
    //         break
    //     }
    //   }).catch((err) => {
    //     // 关闭loading
    //     this.closeFullScreen(this.openFullScreen())
    //   })
    // },
    disabledFunction: function disabledFunction(thisRowDate) {
      if (thisRowDate.jobStateCd == '1' && thisRowDate.acStoreOut != '') {
        return false; // 活性
      }
      if (thisRowDate.jobStateCd != '1' || thisRowDate.jobStateCd == '1' && thisRowDate.acStoreOut == '') {
        return true; // 非活性
      }
    },
    needShow: function needShow(thisRowDate, type) {
      var showReturn = false;
      if (thisRowDate.timeFlag === '0') {
        //該当作業の時刻フラグが0
        return false;
      }
      switch (type) {
        case 'storeInButton':
          if ((thisRowDate.workType == '1' || thisRowDate.workType == '2') && thisRowDate.jobStateCd != '2' && this.isEmpty(thisRowDate.acStoreOut)) {
            showReturn = true;
          }
          if (thisRowDate.workType == '3' && thisRowDate.personalJobState == '1') {
            showReturn = true;
          }
          break;
        case 'storeOutButton':
          if ((thisRowDate.workType == '1' || thisRowDate.workType == '2') && thisRowDate.jobStateCd == '1' && !this.isEmpty(thisRowDate.acStoreIn)) {
            showReturn = true;
          }
          if (thisRowDate.workType == '3' && thisRowDate.personalJobState == '2') {
            showReturn = true;
          }
          break;
        case 'storeInGoalButton':
          if (thisRowDate.workType == '3' && thisRowDate.personalJobState == '0') {
            showReturn = true;
          }
          break;
        case 'storeOutGoalButton':
          if (thisRowDate.workType == '3' && thisRowDate.personalJobState == '3') {
            showReturn = true;
          }
          break;
      }
      return showReturn;
    },
    NeedReadonly: function NeedReadonly(thisRowDate, type) {
      var readonlyReturn = false;
      if (thisRowDate.transmitFlag == '1' || thisRowDate.jobStateCd == '2') {
        readonlyReturn = true;
      }
      return readonlyReturn;
    },
    isEmpty: function isEmpty(value) {
      if (typeof value == "undefined" || value == null || value == '') {
        return true;
      } else {
        return false;
      }
    },

    // 点击后失去焦点(用于按钮还原)
    handleClick: function handleClick(e) {
      var target = e.target;
      target.blur();
    },

    // Loading加载
    openFullScreen: function openFullScreen() {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return loading;
    },
    closeFullScreen: function closeFullScreen(loading) {
      loading.close();
    },

    // 计算実動時間  退店-入店-全休憩時間。
    calculateWorkTime: function calculateWorkTime(storeIn, storeOut, allRestTime) {
      var cal_result = 0;
      if (storeIn === null || storeIn === '' || storeOut === null || storeOut === '') {
        cal_result = 0;
      } else {
        var cal_storeIn = storeIn === null || storeIn === '' ? '0' : Number(storeIn.substring(0, 2)) * 60 + Number(storeIn.substring(3, 5));
        var cal_storeOut = storeOut === null || storeOut === '' ? '0' : Number(storeOut.substring(0, 2)) * 60 + Number(storeOut.substring(3, 5));
        var cal_allRestTime = allRestTime === null || allRestTime === '' ? '0' : Number(allRestTime.substring(0, 2)) * 60 + Number(allRestTime.substring(3, 5));
        cal_result = cal_storeOut - cal_storeIn - cal_allRestTime < 0 ? 0 : cal_storeOut - cal_storeIn - cal_allRestTime;
      }
      var ret = this.minuteTOtime(cal_result);
      return ret;
    },

    // 计算内深夜実動時間  深夜时间-内深夜休憩時間。
    calculateLatenightWorkTime: function calculateLatenightWorkTime(storeIn, storeOut, inLateBreak) {
      var cal_result = 0;
      if (storeIn === null || storeIn === '' || storeOut === null || storeOut === '') {
        cal_result = 0;
      } else {
        var cal_storeIn = storeIn === null || storeIn === '' ? '0' : Number(storeIn.substring(0, 2)) * 60 + Number(storeIn.substring(3, 5));
        var cal_storeOut = storeOut === null || storeOut === '' ? '0' : Number(storeOut.substring(0, 2)) * 60 + Number(storeOut.substring(3, 5));
        var cal_inLateBreak = inLateBreak === null || inLateBreak === '' ? '0' : Number(inLateBreak.substring(0, 2)) * 60 + Number(inLateBreak.substring(3, 5));
        var inlateBlock = this.getInLateBlock(cal_storeIn, cal_storeOut); // 深夜时间取得
        cal_result = inlateBlock - cal_inLateBreak < 0 ? 0 : inlateBlock - cal_inLateBreak;
      }
      var ret = this.minuteTOtime(cal_result);
      return ret;
    },

    // 深夜时间带计算
    // 深夜时段：时间带1：00:00~05:00  时间带2：22:00~29:00
    getInLateBlock: function getInLateBlock(value_in, value_out) {
      var ret_totalTime = 0;
      var cal_value_out = 0;
      var cal_value_in = 0;
      var S_IN1 = 0;
      var S_OUT1 = 5 * 60;
      var S_IN2 = 22 * 60;
      var S_OUT2 = 29 * 60;
      // 时间带1计算
      if (S_IN1 <= value_in && value_in <= S_OUT1 || S_IN1 <= value_out && value_out <= S_OUT1) {
        cal_value_in = value_in < S_IN1 ? S_IN1 : value_in;
        cal_value_out = value_out > S_OUT1 ? S_OUT1 : value_out;
        ret_totalTime = cal_value_out - cal_value_in + ret_totalTime;
      } else if (S_IN1 >= value_in && value_out >= S_OUT1) {
        ret_totalTime = S_OUT1 - S_IN1 + ret_totalTime;
      }
      cal_value_out = 0;
      cal_value_in = 0;
      // 时间带2计算
      if (S_IN2 <= value_in && value_in <= S_OUT2 || S_IN2 <= value_out && value_out <= S_OUT2) {
        cal_value_in = value_in < S_IN2 ? S_IN2 : value_in;
        cal_value_out = value_out > S_OUT2 ? S_OUT2 : value_out;
        ret_totalTime = cal_value_out - cal_value_in + ret_totalTime;
      } else if (S_IN2 >= value_in && value_out >= S_OUT2) {
        ret_totalTime = S_OUT2 - S_IN2 + ret_totalTime;
      }
      return ret_totalTime;
    },

    // 分钟 转 【时：分】
    minuteTOtime: function minuteTOtime(val) {
      var ret = '';
      if (val === '' || val === '0') {
        ret = '00:00';
      } else {
        ret = (Math.floor(val / 60).toString().length < 2 ? '0' + Math.floor(val / 60).toString() : Math.floor(val / 60).toString()) + ':' + ((val % 60).toString().length < 2 ? '0' + (val % 60).toString() : (val % 60).toString());
      }
      return ret;
    },

    //労働条件通知書
    click_notice: function click_notice(row) {
      var _this7 = this;

      var info = JSON.parse(localStorage.getItem("userInfo"));
      setTimeout(function () {
        _this7.$router.push({ path: k_0001_url.routerUrl_C0003, query: { "jobDate": row.jobDate, "fieldCd": row.fieldCd, "userCd": info.userCd, "storePositionCd": row.storePositionCd } });
      }, 300);
    },

    //入店ボタン用、作業開始処理
    workStart: function workStart(thisRowDate) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var ret, param;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ret = {
                  successFlg: false
                };
                param = {};
                // 画面ID

                param.gamenId = 'SK_0001';
                // チェックフラグ
                param.checkFlg = '0';
                // 作業日
                param.jobDate = thisRowDate.jobDate;
                // クルーコード
                param.crewCd = thisRowDate.crewCd;
                // 作業状態
                param.jobState = '1';
                // 作業状態フラグ
                param.jobStateFlg = '0';
                return _context2.abrupt('return', new promise_default.a(function (resolve) {
                  k_0001_jobStateApi(param).then(function (res) {
                    if (res.code == '201' || '412') {
                      ret.successFlg = true;
                      resolve(ret);
                    } else if (res.code == '311') {
                      ret.successFlg = false;
                      _this8.$message.error({ message: _this8.$t('MODULE.MSG_CURD_ERROR'), showClose: true });
                      resolve(ret);
                    } else {
                      ret.successFlg = false;
                      _this8.$message.error({ message: _this8.$t('COMMON.CURD_ERROR'), showClose: true });
                      resolve(ret);
                    }
                  });
                }).catch(function (err) {
                  resolve(ret);
                }));

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    }
  },
  created: function created() {
    // 初期化
    this.init_query();
    // 期間より検索
    this.query();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ade776","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/k_0001.vue
var k_0001_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k0001-content"},[_c('div',{staticClass:"search-module-k0001"},[_c('el-row',{staticStyle:{"padding-top":"5px","padding-left":"5px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":7}},[_c('div',[_c('el-date-picker',{staticStyle:{"width":"130px","font-size":"12px"},attrs:{"size":"mini","type":"date","editable":false,"clearable":false,"format":"yyyy/MM/dd"},model:{value:(_vm.kikanVal1),callback:function ($$v) {_vm.kikanVal1=$$v},expression:"kikanVal1"}})],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"padding-left":"2px","padding-right":"10px"},attrs:{"span":2}},[_c('div',[_vm._v("\n           \n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('div',[_c('el-date-picker',{staticStyle:{"width":"130px","font-size":"12px"},attrs:{"size":"mini","type":"date","editable":false,"clearable":false,"format":"yyyy/MM/dd"},model:{value:(_vm.kikanVal2),callback:function ($$v) {_vm.kikanVal2=$$v},expression:"kikanVal2"}})],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',[_vm._v(" ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"css-button_k0001 css-btn_k0001",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.query_btn}},[_vm._v(_vm._s(_vm.$t('COMMON.LBL_SEARCH')))])],1)])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA"},attrs:{"header-cell-style":_vm.k0001HeaderStyle,"cell-style":_vm.k0001IsCellStyle,"header-row-class-name":_vm.k0001HeaderClass,"cell-class-name":_vm.k0001IsCellClass,"data":_vm.list,"border":"","size":"mini"},on:{"row-click":_vm.k0001RowOnClick}},[(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"jobDate","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"jobStateCd","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"jobStateName","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"companyName","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"fieldName","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"typeName","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"esStoreIn","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"acStoreIn","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"esStoreOut","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"acStoreOut","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"updateDate","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"approvalFlag","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"workType","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"transmitFlag","align":"center"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col1","label":_vm.$t('MODULE.K0001_LBL_col1'),"width":"","text-align":"center","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.jobDate)+"\n        "),_c('div',[((scope.row.workType==1||scope.row.workType==2) && scope.row.jobStateCd==0)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconPlan,"alt":""}}):_vm._e(),_vm._v(" "),((scope.row.workType==1||scope.row.workType==2) && scope.row.jobStateCd==1)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconUnderway,"alt":""}}):_vm._e(),_vm._v(" "),((scope.row.workType==1||scope.row.workType==2) && scope.row.jobStateCd==2)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconComplete,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==0)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconPlan,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==1)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconGoComplete,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==2)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconUnderway,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==3)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconCloseComplete,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==4)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconComplete,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==1||scope.row.workType==2)?[_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(scope.row.jobStateName))])]:_vm._e(),_vm._v(" "),(scope.row.workType==3)?[_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(scope.row.personalJobValue))])]:_vm._e()],2),_vm._v(" "),_c('div',[_vm._v(_vm._s(scope.row.attenAbbr))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col2","label":_vm.$t('MODULE.K0001_LBL_col2'),"width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.companyName)),_c('br'),_vm._v("\n        "+_vm._s(scope.row.fieldName)),_c('br'),_vm._v("\n        "+_vm._s(scope.row.serviceName)+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col3","label":_vm.$t('MODULE.K0001_LBL_col3'),"width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.esStoreIn)+_vm._s(_vm.$t('MODULE.K0001_LBL_YO')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(scope.row.acStoreIn)+_vm._s(_vm.$t('MODULE.K0001_LBL_JI')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.needShow(scope.row,'storeInGoalButton')),expression:"needShow(scope.row,'storeInGoalButton')"},{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"css-button_k0001_l css-btn_k0001_l",attrs:{"type":"text","size":"mini","disabled":_vm.NeedReadonly(scope.row,'storeInGoalButton')},on:{"click":[_vm.handleClick,function($event){$event.stopPropagation();return _vm.departBtnFunction(scope.$index, scope.row)}]}},[_vm._v(_vm._s(_vm.$t('MODULE.K0001_BTN_DEPART')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.needShow(scope.row,'storeInButton')),expression:"needShow(scope.row,'storeInButton')"}],staticClass:"css-button_k0001 css-btn_k0001",attrs:{"type":"text","size":"mini","disabled":_vm.NeedReadonly(scope.row,'storeInButton')},on:{"click":[_vm.handleClick,function($event){$event.stopPropagation();return _vm.inStoreBtnFunction(scope.$index, scope.row)}]}},[_vm._v(_vm._s(_vm.$t('MODULE.K0001_BTN_INSTORE')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col4","label":_vm.$t('MODULE.K0001_LBL_col4'),"width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.esStoreOut)+_vm._s(_vm.$t('MODULE.K0001_LBL_YO')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(scope.row.acStoreOut)+_vm._s(_vm.$t('MODULE.K0001_LBL_JI')))]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(scope.row.crewCd))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.needShow(scope.row,'storeOutGoalButton')),expression:"needShow(scope.row,'storeOutGoalButton')"},{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"css-button_k0001_l css-btn_k0001_l",attrs:{"type":"text","size":"mini","disabled":_vm.NeedReadonly(scope.row,'storeOutGoalButton')},on:{"click":[_vm.handleClick,function($event){$event.stopPropagation();return _vm.quitBtnFunction(scope.$index, scope.row)}]}},[_vm._v(_vm._s(_vm.$t('MODULE.K0001_BTN_QUIT')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.needShow(scope.row,'storeOutButton')),expression:"needShow(scope.row,'storeOutButton')"}],staticClass:"css-button_k0001 css-btn_k0001",attrs:{"type":"text","size":"mini","disabled":_vm.NeedReadonly(scope.row,'storeOutButton')},on:{"click":[_vm.handleClick,function($event){$event.stopPropagation();return _vm.outStoreBtnFunction(scope.$index, scope.row)}]}},[_vm._v(_vm._s(_vm.$t('MODULE.K0001_BTN_OUTSTORE')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('MODULE.K0001_LBL_col5'),"width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.attendanceDiv=='0'||scope.row.attendanceDiv=='4'||scope.row.attendanceDiv=='5')?_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.click_notice(scope.row)}}},[_c('i',{staticClass:"el-icon-document-remove"})]):_vm._e()]}}])})],1)],1)}
var k_0001_staticRenderFns = []
var k_0001_esExports = { render: k_0001_render, staticRenderFns: k_0001_staticRenderFns }
/* harmony default export */ var module_page_k_0001 = (k_0001_esExports);
// CONCATENATED MODULE: ./src/module/page/k_0001.vue
function k_0001_injectStyle (ssrContext) {
  __webpack_require__("B1Vh")
}
var k_0001_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var k_0001___vue_template_functional__ = false
/* styles */
var k_0001___vue_styles__ = k_0001_injectStyle
/* scopeId */
var k_0001___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var k_0001___vue_module_identifier__ = null
var k_0001_Component = k_0001_normalizeComponent(
  page_k_0001,
  module_page_k_0001,
  k_0001___vue_template_functional__,
  k_0001___vue_styles__,
  k_0001___vue_scopeId__,
  k_0001___vue_module_identifier__
)

/* harmony default export */ var src_module_page_k_0001 = (k_0001_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/module/api/k_0002.js



var k_0002_apiUrl = __webpack_require__("kspH");
// 検索
var k_0002_k_0002 = function k_0002(params) {
  //params序列化
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(k_0002_apiUrl.apiUrl_AttendExpenseAttendancesExpense + '?' + querys);
};
// 更新
var k_0002_k_0002_update = function k_0002_update(params) {
  return api_public.requestPut(k_0002_apiUrl.apiUrl_AttendExpenseAttendances, params);
};
//图片取得
var k_0002_k_0002_getImage = function k_0002_getImage(params) {
  return api_public.requestQuickGetImage('/api/v1/files?filePath=' + encodeURIComponent(params.filePath) + '&resizeCd=' + params.resizeCd);
};
//图片路径等信息取得
var k_0002_k_0002_getPhotoInfo = function k_0002_getPhotoInfo(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet('/api/v1/photoInfo' + '?' + querys);
};
//图片更新
var k_0002_k_0002_saveImage = function k_0002_saveImage(formData) {
  var querys = querystring_es3_default.a.stringify(formData);
  return api_public.requestPostFormData(k_0002_apiUrl.apiUrl_filesUpdate, formData);
};
//保存处理
var k_0002_k_0002_Attendances_update = function k_0002_Attendances_update(params) {
  return api_public.requestPut(k_0002_apiUrl.apiUrl_StaffAttendances, params);
};
//m_code
var k_0002_conditionApi = function conditionApi(page, div) {
  return api_public.requestQuickGet(k_0002_apiUrl.apiurl_masterData + '/' + page + '/' + div);
};
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/element-ui/src/utils/dom.js
var dom = __webpack_require__("oXIA");

// EXTERNAL MODULE: ./node_modules/element-ui/src/utils/util.js + 1 modules
var utils_util = __webpack_require__("3Q1+");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/element-ui/packages/image/src/image-viewer.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
};

var mousewheelEventName = Object(utils_util["a" /* isFirefox */])() ? 'DOMMouseScroll' : 'mousewheel';

/* harmony default export */ var image_viewer = ({
  name: 'elImageViewer',

  props: {
    urlList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    onSwitch: {
      type: Function,
      default: function _default() {}
    },
    onClose: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      index: 0,
      isShow: false,
      infinite: true,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      }
    };
  },

  computed: {
    isSingle: function isSingle() {
      return this.urlList.length <= 1;
    },
    isFirst: function isFirst() {
      return this.index === 0;
    },
    isLast: function isLast() {
      return this.index === this.urlList.length - 1;
    },
    currentImg: function currentImg() {
      return this.urlList[this.index];
    },
    imgStyle: function imgStyle() {
      var _transform = this.transform,
          scale = _transform.scale,
          deg = _transform.deg,
          offsetX = _transform.offsetX,
          offsetY = _transform.offsetY,
          enableTransition = _transform.enableTransition;

      var style = {
        transform: 'scale(' + scale + ') rotate(' + deg + 'deg)',
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': offsetX + 'px',
        'margin-top': offsetY + 'px'
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '100%';
      }
      return style;
    }
  },
  watch: {
    index: {
      handler: function handler(val) {
        this.reset();
        this.onSwitch(val);
      }
    },
    currentImg: function currentImg(val) {
      var _this = this;

      this.$nextTick(function (_) {
        var $img = _this.$refs.img[0];
        if (!$img.complete) {
          _this.loading = true;
        }
      });
    }
  },
  methods: {
    hide: function hide() {
      this.deviceSupportUninstall();
      this.onClose();
    },
    deviceSupportInstall: function deviceSupportInstall() {
      var _this2 = this;

      this._keyDownHandler = Object(utils_util["b" /* rafThrottle */])(function (e) {
        var keyCode = e.keyCode;
        switch (keyCode) {
          // ESC
          case 27:
            _this2.hide();
            break;
          // SPACE
          case 32:
            _this2.toggleMode();
            break;
          // LEFT_ARROW
          case 37:
            _this2.prev();
            break;
          // UP_ARROW
          case 38:
            _this2.handleActions('zoomIn');
            break;
          // RIGHT_ARROW
          case 39:
            _this2.next();
            break;
          // DOWN_ARROW
          case 40:
            _this2.handleActions('zoomOut');
            break;
        }
      });
      this._mouseWheelHandler = Object(utils_util["b" /* rafThrottle */])(function (e) {
        var delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta > 0) {
          _this2.handleActions('zoomIn', {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          _this2.handleActions('zoomOut', {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      Object(dom["b" /* on */])(document, 'keydown', this._keyDownHandler);
      Object(dom["b" /* on */])(document, mousewheelEventName, this._mouseWheelHandler);
    },
    deviceSupportUninstall: function deviceSupportUninstall() {
      Object(dom["a" /* off */])(document, 'keydown', this._keyDownHandler);
      Object(dom["a" /* off */])(document, mousewheelEventName, this._mouseWheelHandler);
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;
    },
    handleImgLoad: function handleImgLoad(e) {
      this.loading = false;
    },
    handleImgError: function handleImgError(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },
    handleMouseDown: function handleMouseDown(e) {
      var _this3 = this;

      if (this.loading || e.button !== 0) return;

      var _transform2 = this.transform,
          offsetX = _transform2.offsetX,
          offsetY = _transform2.offsetY;

      var startX = e.pageX;
      var startY = e.pageY;
      this._dragHandler = Object(utils_util["b" /* rafThrottle */])(function (ev) {
        _this3.transform.offsetX = offsetX + ev.pageX - startX;
        _this3.transform.offsetY = offsetY + ev.pageY - startY;
      });
      Object(dom["b" /* on */])(document, 'mousemove', this._dragHandler);
      Object(dom["b" /* on */])(document, 'mouseup', function (ev) {
        Object(dom["a" /* off */])(document, 'mousemove', _this3._dragHandler);
      });

      e.preventDefault();
    },
    reset: function reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    toggleMode: function toggleMode() {
      if (this.loading) return;

      var modeNames = keys_default()(Mode);
      var modeValues = values_default()(Mode);
      var index = modeValues.indexOf(this.mode);
      var nextIndex = (index + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      this.reset();
    },
    prev: function prev() {
      if (this.isFirst && !this.infinite) return;
      var len = this.urlList.length;
      this.index = (this.index - 1 + len) % len;
    },
    next: function next() {
      if (this.isLast && !this.infinite) return;
      var len = this.urlList.length;
      this.index = (this.index + 1) % len;
    },
    handleActions: function handleActions(action) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.loading) return;

      var _zoomRate$rotateDeg$e = extends_default()({
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true
      }, options),
          zoomRate = _zoomRate$rotateDeg$e.zoomRate,
          rotateDeg = _zoomRate$rotateDeg$e.rotateDeg,
          enableTransition = _zoomRate$rotateDeg$e.enableTransition;

      var transform = this.transform;

      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    }
  },
  mounted: function mounted() {
    this.deviceSupportInstall();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1703dd18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/element-ui/packages/image/src/image-viewer.vue
var image_viewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"viewer-fade"}},[_c('div',{staticClass:"el-image-viewer__wrapper",style:({ 'z-index': _vm.zIndex })},[_c('div',{staticClass:"el-image-viewer__mask"}),_vm._v(" "),_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__close",on:{"click":_vm.hide}},[_c('i',{staticClass:"el-icon-circle-close"})]),_vm._v(" "),(!_vm.isSingle)?[_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__prev",class:{ 'is-disabled': !_vm.infinite && _vm.isFirst },on:{"click":_vm.prev}},[_c('i',{staticClass:"el-icon-arrow-left"})]),_vm._v(" "),_c('span',{staticClass:"el-image-viewer__btn el-image-viewer__next",class:{ 'is-disabled': !_vm.infinite && _vm.isLast },on:{"click":_vm.next}},[_c('i',{staticClass:"el-icon-arrow-right"})])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"el-image-viewer__btn el-image-viewer__actions"},[_c('div',{staticClass:"el-image-viewer__actions__inner"},[_c('i',{staticClass:"el-icon-zoom-out",on:{"click":function($event){return _vm.handleActions('zoomOut')}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-zoom-in",on:{"click":function($event){return _vm.handleActions('zoomIn')}}}),_vm._v(" "),_c('i',{staticClass:"el-image-viewer__actions__divider"}),_vm._v(" "),_c('i',{class:_vm.mode.icon,on:{"click":_vm.toggleMode}}),_vm._v(" "),_c('i',{staticClass:"el-image-viewer__actions__divider"}),_vm._v(" "),_c('i',{staticClass:"el-icon-refresh-left",on:{"click":function($event){return _vm.handleActions('anticlocelise')}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-refresh-right",on:{"click":function($event){return _vm.handleActions('clocelise')}}})])]),_vm._v(" "),_c('div',{staticClass:"el-image-viewer__canvas"},_vm._l((_vm.urlList),function(url,i){return (i === _vm.index)?_c('img',{key:url,ref:"img",refInFor:true,staticClass:"el-image-viewer__img",style:(_vm.imgStyle),attrs:{"src":_vm.currentImg},on:{"load":_vm.handleImgLoad,"error":_vm.handleImgError,"mousedown":_vm.handleMouseDown}}):_vm._e()}),0)],2)])}
var image_viewer_staticRenderFns = []
var image_viewer_esExports = { render: image_viewer_render, staticRenderFns: image_viewer_staticRenderFns }
/* harmony default export */ var src_image_viewer = (image_viewer_esExports);
// CONCATENATED MODULE: ./node_modules/element-ui/packages/image/src/image-viewer.vue
var image_viewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var image_viewer___vue_template_functional__ = false
/* styles */
var image_viewer___vue_styles__ = null
/* scopeId */
var image_viewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var image_viewer___vue_module_identifier__ = null
var image_viewer_Component = image_viewer_normalizeComponent(
  image_viewer,
  src_image_viewer,
  image_viewer___vue_template_functional__,
  image_viewer___vue_styles__,
  image_viewer___vue_scopeId__,
  image_viewer___vue_module_identifier__
)

/* harmony default export */ var image_src_image_viewer = (image_viewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/k_0002.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var k_0002_url = __webpack_require__("kspH");

/* harmony default export */ var page_k_0002 = ({
  mixins: [css],
  components: {
    ElImageViewer: image_src_image_viewer
  },
  data: function data() {
    return {
      inputFlag: false,
      obj: [],
      WORKING: '1', //作業中(常量)
      attendanceList: [], //作業区分リスト
      attendanceDiv: '', //作業区分cd 出勤区分
      jobState_working: false, //是否为作业中的判断FLAG：true=工作中
      approvalStatus: '1', //勤怠承認「1：承認」
      userInfo: [],
      job_date: '',
      company_name: '',
      fieldName: '',
      position: '',
      jobState: '',
      approvalFlag: '', //勤怠承認FLAG
      crewCd: '',
      cl: '',
      listLoading: false,
      list: [],
      total: 0, //総カウント
      checked: true,
      storePositionCd: '', //店舗役職Cd
      storePositionName: '', //店舗役職名
      storePositionDisplayCd: '', //店舗役職cd（表示用）
      storePositionDisplayName: '', //店舗役職名（表示用）
      timeFlag: '', //時刻フラグ
      teamCd: '',
      userCd: '',
      userName: '',
      storeIn: '',
      storeOut: '',
      breakTime: '',
      latenightBreakTime: '',
      transportExpenses: '',
      allRestTime: '',
      inLateBreak: '',
      workTime: '',
      latenightWorkTime: '',
      km: '',
      kmPrice: '',
      travelAllowance: '',
      commutingExpenses: '',
      transportExpensesTrip: '',
      accommodation: '',
      allowanceTrip: '',
      othersExpenses: '',
      oritenCost: '',
      ecoasTravelExpenses: '',
      ecoasFuelExpenses: '',
      transportTeate: '',
      updateDate: '',
      initFlg: 0,
      blurErrorFgl: false,
      changeFgl: false,
      departureCall: '', //出発コール
      returnCall: '', //退店コール
      departureCallMemo: '', //出発コールメモ
      returnCallMemo: '', //退店コールメモ
      personalJobState: '', //個人作業状態
      esStoreIn: '', //预测入店(前画面传入)
      esStoreOut: '', //预测退店(前画面传入)
      workType: '', //作業区分(前画面传入)
      goalFlg: '', //コールフラグ(前画面传入)
      dialogImageUrl: "", //timeSheet图片预览用的单张图片
      timeSheetImageList: [], //timeSheet初始化时的list
      updateLoad_timeSheetImageList: [], //timeSheet的保存前图片list。
      imageDialogVisible: false, //图片dialog是否显示flag
      show_image_border: true, //是否显示假图片框
      has_UpdateLoadedDel: false, //是否上传成功过
      delPhotoUrl: '', //删除用图片路径存储
      contractFormDiv: '', //契約種別
      strYesterday: '' //昨日(字符串)
    };
  },

  methods: {
    //readonly判定
    NeedReadonly: function NeedReadonly(type) {
      var readonlyReturn = false;
      switch (type) {
        case "STOREIN": //入店時刻
        case "STOREOUT": //退店時刻
        case "RESTTIME": //全休憩時間
        case "INLATEBREAK":
          //内深夜休憩
          if ((this.workType == '1' || this.workType === '2') && this.jobState !== this.WORKING) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && (this.goalFlg === '2' || this.goalFlg === '1')) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && this.personalJobState === '4' && this.jobState === this.WORKING) {
            readonlyReturn = true;
          }
          break;
        case "DEPART":
          //出発コールメモ
          if (this.workType === '3' && this.goalFlg === '2') {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.personalJobState === '4' || this.personalJobState === '0') && this.jobState === this.WORKING) {
            readonlyReturn = true;
          }
          break;
        case "QUIT":
          //退店コールメモ
          if (this.workType === '3' && this.goalFlg === '1') {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3') {
            readonlyReturn = true;
          }
          break;
        case "PHOTO_INFO":
          //タイムシート写真
          if (this.workType === '3' && this.goalFlg === '1') {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.personalJobState === '4' || this.personalJobState === '0') && this.jobState === this.WORKING) {
            readonlyReturn = true;
          }
          break;
        case "SAVE_BTN":
          //保存ボタン
          if ((this.workType == '1' || this.workType === '2') && this.jobState !== this.WORKING) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && this.personalJobState === '4' && this.jobState === this.WORKING) {
            readonlyReturn = true;
          }
          break;
        case "ATTENDANCE_DIV":
          //出勤区分
          if ((this.workType == '1' || this.workType === '2') && this.jobState == this.WORKING && this.contractFormDiv === '1') {
            readonlyReturn = true;
          }
          if ((this.workType == '1' || this.workType === '2') && this.jobState !== this.WORKING) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '1') {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '2') {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && this.personalJobState === '4' && this.jobState === this.WORKING) {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && this.personalJobState === '0' && this.jobState === this.WORKING && this.contractFormDiv === '1') {
            readonlyReturn = true;
          }
          if (this.workType === '3' && this.goalFlg === '3' && this.personalJobState !== '4' && this.personalJobState !== '0' && this.jobState === this.WORKING && this.contractFormDiv === '1') {
            readonlyReturn = true;
          }
          break;
      }
      return readonlyReturn;
    },

    //单张图片删除
    fileRemove: function fileRemove(file) {
      //组件表示图片清空
      this.$refs.upload.clearFiles();
      //上传用list清空
      this.updateLoad_timeSheetImageList[0] = {};
      this.show_image_border = true;
      this.has_UpdateLoadedDel = true;
    },

    //单张图片点击
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imageDialogVisible = true;
    },

    // 画像上传成功后处理
    handleChange: function handleChange(file, fileList, itemName, type) {
      var _this = this;

      var file_type = file.raw.type;
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpeg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
      } else {
        //变更flg设定
        this.changeFgl = true;
        // 当有文件的时候先删除旧文件再上传新的
        if (fileList.length > 1) {
          fileList = fileList.splice(0, 1);
        }
        //假图片框若有的话，隐藏
        if (this.show_image_border == true) {
          this.show_image_border = false;
        }
        //执行过图片操作处理
        this.has_UpdateLoadedDel = true;

        // 写真パス：「image/personalPhoto/クルーコード/社員ID_店舗役職CD（表示用）_種別_写真ID.jpg」
        //写真パス：「image/personalPhoto/クルーコード/社員ID_店舗役職CD（表示用）_種別_写真ID_yyyyMMddHHmmssSSS.拡張子」
        var that = this;
        // var photoItem = {}
        this.getBase64(file.raw).then(function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
            var photo, files, timenumber, photoPath;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return that.compressImg(that.base64ToBlob(res));

                  case 2:
                    photo = _context.sent;
                    files = new window.File([photo], file.name, { type: file.type });
                    timenumber = utils.timeNumberGet();
                    photoPath = 'image/personalPhoto/' + that.crewCd + '/' + that.userCd + '_' + that.storePositionCd + '_' + type + '_' + '0_' + timenumber + '.jpg';

                    _this.updateLoad_timeSheetImageList[0] = {};
                    _this.updateLoad_timeSheetImageList[0].files = files;
                    _this.updateLoad_timeSheetImageList[0].photoId = type;
                    _this.updateLoad_timeSheetImageList[0].photoPath = photoPath;
                    _this.updateLoad_timeSheetImageList[0].type = type;

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },


    // 图片转base64
    getBase64: function getBase64(file) {
      return new promise_default.a(function (resolve, reject) {
        var reader = new FileReader();
        var imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },


    // base转blob
    base64ToBlob: function base64ToBlob(file) {
      var byteString = void 0;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1]);
      } else {
        byteString = unescape(file.split(',')[1]);
      }
      var mimeString = file.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },


    // 压缩图片
    compressImg: function compressImg(file) {
      var that = this;
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new promise_default.a(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
                h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);

            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files);
          };
        };
      });
    },

    // 关闭查看器
    closeViewer: function closeViewer() {
      var _this2 = this;

      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), { // 変更がありました。一覧に戻りますか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(function () {
        //组件表示图片清空
        _this2.$refs.upload.clearFiles();
        //上传用list清空
        _this2.updateLoad_timeSheetImageList[0] = {};
        _this2.show_image_border = true;
        _this2.has_UpdateLoadedDel = true;
        _this2.imageDialogVisible = false;
        _this2.changeFgl = true;
      }).catch(function () {});
    },

    /* 图片压缩方法-canvas压缩 */
    compressUpload: function compressUpload(image, file) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var initSize = image.src.length;
      var width = image.width,
          height = image.height;
      canvas.width = width;
      canvas.height = height;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);
      // 进行最小压缩0.5
      var isLt2M = file.size / 1024 / 1024;
      var compressData = void 0;
      if (5 < isLt2M < 10) {
        compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.1);
      } else {
        compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.5);
      }
      //压缩后调用方法进行base64转Blob，方法写在下边
      var blobImg = this.dataURItoBlob(compressData);
      return blobImg;
    },


    //金额每三位加','
    NumericalFormatter: function NumericalFormatter(val) {
      if (val != null && val !== '') {
        var reg = /[^\d]/;
        if (reg.test(val)) {

          val = val.replace(/[^0-9]/ig, ',');
        }
        if (val !== '0' && val !== '0.0') {
          var regex = /^[0]+/;
          val = val.toString().replace(regex, '');
        }

        return val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      } else {
        return '0';
      }
    },

    // 小数金额每三位加','
    NumericalFormatterDigit: function NumericalFormatterDigit(val) {
      val = Number(val).toFixed(1);
      val = val.toString();
      var ret = '';
      if (val != null && val !== '') {
        if (val.indexOf('.') !== -1) {
          var strDigit = val.substring(val.indexOf('.'));
          var strInt = val.substring(0, val.indexOf('.'));
          ret = this.NumericalFormatter(strInt) + '' + strDigit;
        } else {
          ret = this.NumericalFormatter(strInt);
        }
        return ret;
      } else {
        return '0.0';
      }
    },


    // 带,金额转number
    strToNum: function strToNum(val) {
      if (val != null && val !== '') {
        return Number(val.replace(/,/g, ''));
      } else {
        return 0;
      }
    },

    // 时间入力check
    timeInputCheck: function timeInputCheck(item) {
      this.changeFgl = true;
      var reg = /^\d*(\:?\d{0,2})/g;
      var matchResult = item.target.value.match(reg);
      if (matchResult === null) {
        item.target.value = null;
      } else {
        item.target.value = matchResult[0];
      }
    },
    inputcompositionstart: function inputcompositionstart(item) {
      //  this.allowanceTrip = '5'
      this.inputFlag = false;
    },
    inputcompositionend: function inputcompositionend(item) {
      // this.allowanceTrip = '7'
      this.inputFlag = true;
    },

    // 数字入力check
    numberInputCheck: function numberInputCheck(item) {
      this.changeFgl = true;
      var aa = JSON.parse(stringify_default()(item.target.value));
      item.target.value = aa.replace(/([^\d])/g, '').slice(0, 8);
    },

    // 小数入力check
    floatInputCheck: function floatInputCheck(item) {
      this.changeFgl = true;
      var reg = /^\d*(\.?\d{0,1})/g;
      if (item.target.value === null) {
        item.target.value = null;
      } else {
        var matchResult = item.target.value.match(reg);
        item.target.value = matchResult[0].slice(0, 8);
      }
    },

    // KM BLURチェック
    kmBlurCheck: function kmBlurCheck(e) {
      var _this3 = this;

      this.changeFgl = true;
      var reg = /(^[0-9]{0,6}$)|(^[0-9]{1,6}[\.]{1}[0-9]{1}$)/g;
      if (reg.test(e.currentTarget.value)) {
        var kmValue = JSON.parse(stringify_default()(e.currentTarget.value));
        var changValue = 0;
        if (kmValue === null || kmValue === '' || kmValue === '0' || this.transportTeate === null || this.transportTeate === '' || this.transportTeate === 0) {
          changValue = 0;
        } else {
          changValue = Math.round(Number(kmValue) * Number(this.transportTeate)).toFixed(0);
        }
        this.kmPrice = this.NumericalFormatter(changValue.toString());
        this.km = this.NumericalFormatterDigit(e.currentTarget.value);
        e.currentTarget.value = this.km;
        this.blurErrorFgl = false;
      } else {
        this.$nextTick(function (x) {
          _this3.$refs.km.focus();
          _this3.$message.error({ message: _this3.$t('COMMON.MSG_GOODS_INPUT_VALIDITY'), showClose: true });
        });
        this.blurErrorFgl = true;
      }
    },

    // 時刻チェック46
    timeBlurCheck: function timeBlurCheck(item) {
      var myTime = item.currentTarget.value;
      var reg = /^(([0-3][0-9]|4[0-5])[0-5][0-9]|4600)$/;
      var reg1 = /^(([0-3][0-9]|4[0-5]):[0-5][0-9]|46:00)$/;
      var reg2 = /^(([0-5]?[0-9])|([0-9][0-5][0-9]))$/;
      if (myTime === '') {
        this.blurErrorFgl = false;
        return '';
      }
      if (reg.test(myTime)) {
        var str11 = myTime.substring(0, 2);
        var strSep = ":";
        var str00 = myTime.substring(2, myTime.length);
        var strNew = str11 + strSep + str00;
        item.currentTarget.value = strNew;
        this.blurErrorFgl = false;
        return item.currentTarget.value;
      } else if (reg1.test(myTime)) {
        this.blurErrorFgl = false;
        return item.currentTarget.value;
      } else if (reg2.test(myTime)) {
        var value_4 = (Array(4).join(0) + myTime).slice(-4);
        var str11 = value_4.substring(0, 2);
        var strSep = ":";
        var str00 = value_4.substring(2, value_4.length);
        var strNew = str11 + strSep + str00;
        item.currentTarget.value = strNew;
        this.blurErrorFgl = false;
        return item.currentTarget.value;
      } else {
        this.blurErrorFgl = true;
        return '';
      }
    },

    // 時刻チェック24
    timeBlurCheck_24: function timeBlurCheck_24(item) {
      var myTime = item.currentTarget.value;
      var reg = /^(([0-1][0-9]|2[0-3])[0-5][0-9])$/;
      var reg1 = /^(([0-1][0-9]|2[0-3]):[0-5][0-9])$/;
      var reg2 = /^(([0-2]?[0-9])|([0-9][0-5][0-9]))$/;
      if (myTime === '') {
        this.blurErrorFgl = false;
        return '';
      }
      if (reg.test(myTime)) {
        var str11 = myTime.substring(0, 2);
        var strSep = ":";
        var str00 = myTime.substring(2, myTime.length);
        var strNew = str11 + strSep + str00;
        item.currentTarget.value = strNew;
        this.blurErrorFgl = false;
        return item.currentTarget.value;
      } else if (reg1.test(myTime)) {
        this.blurErrorFgl = false;
        return item.currentTarget.value;
      } else if (reg2.test(myTime)) {
        var value_4 = (Array(4).join(0) + myTime).slice(-4);
        var str11 = value_4.substring(0, 2);
        var strSep = ":";
        var str00 = value_4.substring(2, value_4.length);
        var strNew = str11 + strSep + str00;
        item.currentTarget.value = strNew;
        this.blurErrorFgl = false;
        return item.currentTarget.value;
      } else {
        this.blurErrorFgl = true;
        return '';
      }
    },
    storeInBlur: function storeInBlur(item) {
      var _this4 = this;

      var retValue = this.timeBlurCheck_24(item);
      if (this.blurErrorFgl == true) {
        this.$nextTick(function (x) {
          if (_this4.$refs.storeInStatus != null) {
            _this4.$refs.storeInStatus.focus();
            _this4.$message.error({ message: _this4.$t('COMMON.MSG_TIME_VALIDITY_24'), showClose: true });
          }
        });
      } else {
        this.storeIn = retValue;
      }
    },
    storeOutBlur: function storeOutBlur(item) {
      var _this5 = this;

      var retValue = this.timeBlurCheck(item);
      if (this.blurErrorFgl == true) {
        this.$nextTick(function (x) {
          if (_this5.$refs.storeOutStatus != null) {
            _this5.$refs.storeOutStatus.focus();
            _this5.$message.error({ message: _this5.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true });
          }
        });
      } else {
        this.storeOut = retValue;
      }
    },

    //深夜时间带计算
    //深夜时段：时间带1：00:00~05:00  时间带2：22:00~29:00
    getInLateBlock: function getInLateBlock(value_in, value_out) {
      var ret_totalTime = 0;
      var cal_value_out = 0;
      var cal_value_in = 0;
      var S_IN1 = 0;
      var S_OUT1 = 5 * 60;
      var S_IN2 = 22 * 60;
      var S_OUT2 = 29 * 60;
      //时间带1计算
      if (S_IN1 <= value_in && value_in <= S_OUT1 || S_IN1 <= value_out && value_out <= S_OUT1) {
        cal_value_in = value_in < S_IN1 ? S_IN1 : value_in;
        cal_value_out = value_out > S_OUT1 ? S_OUT1 : value_out;
        ret_totalTime = cal_value_out - cal_value_in + ret_totalTime;
      } else if (S_IN1 >= value_in && value_out >= S_OUT1) {
        ret_totalTime = S_OUT1 - S_IN1 + ret_totalTime;
      }
      cal_value_out = 0;
      cal_value_in = 0;
      //时间带2计算
      if (S_IN2 <= value_in && value_in <= S_OUT2 || S_IN2 <= value_out && value_out <= S_OUT2) {
        cal_value_in = value_in < S_IN2 ? S_IN2 : value_in;
        cal_value_out = value_out > S_OUT2 ? S_OUT2 : value_out;
        ret_totalTime = cal_value_out - cal_value_in + ret_totalTime;
      } else if (S_IN2 >= value_in && value_out >= S_OUT2) {
        ret_totalTime = S_OUT2 - S_IN2 + ret_totalTime;
      }
      return ret_totalTime;
    },

    //全休憩時間失去焦点事件
    allRestTimeBlur: function allRestTimeBlur(item) {
      var _this6 = this;

      var retValue = this.timeBlurCheck(item);
      if (this.blurErrorFgl == true) {
        this.$nextTick(function (x) {
          if (_this6.$refs.allRestTime != null) {
            _this6.$refs.allRestTime.focus();
            _this6.$message.error({ message: _this6.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true });
          }
        });
      } else {
        this.allRestTime = retValue;
      }
    },

    //内深夜休憩失去焦点事件
    inLateBreakBlur: function inLateBreakBlur(item) {
      var _this7 = this;

      var retValue = this.timeBlurCheck(item);
      if (this.blurErrorFgl == true) {
        this.$nextTick(function (x) {
          if (_this7.$refs.inLateBreak != null) {
            _this7.$refs.inLateBreak.focus();
            _this7.$message.error({ message: _this7.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true });
          }
        });
      } else {
        this.inLateBreak = retValue;
      }
    },

    //(时间用)获取焦点事件
    timeFocusInput: function timeFocusInput(e) {
      var obj = e.srcElement;
      obj.focus();
      obj.selectionStart = e.currentTarget.value.length;
      obj.selectionEnd = e.currentTarget.value.length;
    },


    // 検索
    query: function query() {
      var _this8 = this;

      var Params = {
        'crewCd': this.crewCd,
        'jobState': this.jobState,
        'storePositionCd': this.storePositionCd,
        'userId': this.userInfo.userCd,
        'status': '2',
        'trminal': 'staff'
        // 検索処理
      };k_0002_k_0002(Params).then(function (res) {
        _this8.job_date = res.items[0].jobDate;
        _this8.company_name = res.items[0].companyName;
        //this.fieldName = res.items[0].fieldName
        _this8.storePositionCd = res.items[0].storePositionCd;
        //this.storePositionName = res.items[0].storePositionName;
        _this8.storePositionDisplayName = res.items[0].storePositionDisplayName;
        _this8.teamCd = res.items[0].teamCd;
        _this8.userCd = res.items[0].userCd;
        _this8.userName = res.items[0].userName;
        _this8.storeIn = res.items[0].storeIn;
        _this8.storeOut = res.items[0].storeOut;
        _this8.breakTime = res.items[0].breakTime;
        _this8.allRestTime = res.items[0].allRestTime;
        _this8.inLateBreak = res.items[0].inLateBreak;
        _this8.workTime = res.items[0].workTime;
        _this8.latenightWorkTime = res.items[0].latenightWorkTime;
        _this8.latenightBreakTime = res.items[0].latenightBreakTime;
        _this8.transportExpenses = _this8.NumericalFormatter(res.items[0].transportExpenses);
        _this8.km = _this8.NumericalFormatterDigit(res.items[0].km);
        _this8.kmPrice = _this8.NumericalFormatter(res.items[0].kmPrice);
        _this8.travelAllowance = _this8.NumericalFormatter(res.items[0].travelAllowance);
        _this8.commutingExpenses = _this8.NumericalFormatter(res.items[0].commutingExpenses);
        _this8.transportExpensesTrip = _this8.NumericalFormatter(res.items[0].transportExpensesTrip);
        _this8.accommodation = _this8.NumericalFormatter(res.items[0].accommodation);
        _this8.allowanceTrip = _this8.NumericalFormatter(res.items[0].allowanceTrip);
        _this8.othersExpenses = _this8.NumericalFormatter(res.items[0].othersExpenses);
        _this8.oritenCost = _this8.NumericalFormatter(res.items[0].oritenCost);
        _this8.ecoasTravelExpenses = _this8.NumericalFormatter(res.items[0].ecoasTravelExpenses);
        _this8.ecoasFuelExpenses = _this8.NumericalFormatter(res.items[0].ecoasFuelExpenses);
        _this8.transportTeate = res.items[0].transportTeate;
        _this8.updateDate = res.items[0].updateDate;
        _this8.departureCallMemo = res.items[0].departureCallMemo;
        _this8.returnCallMemo = res.items[0].returnCallMemo;
        _this8.departureCall = res.items[0].departureCall;
        _this8.returnCall = res.items[0].returnCall;
        _this8.personalJobState = res.items[0].personalJobState;
        _this8.timeFlag = res.items[0].timeFlag;
        _this8.attendanceDiv = res.items[0].attendanceDiv;
        _this8.contractFormDiv = res.items[0].contractFormDiv;
        _this8.storePositionDisplayCd = res.items[0].storePositionDisplayCd;
        console.log('this.timeFlag:' + _this8.timeFlag);
        //作業区分リスト取得
        _this8.searchAttendanceList();
        //作業区分は「3」派遣・その他請負の場合、タイムシートを取得し表示する。
        if (_this8.workType === '3') {
          //图片取得
          var getPhotoInfoParams = {};
          getPhotoInfoParams.crewCd = _this8.crewCd;
          getPhotoInfoParams.storePositionCd = _this8.storePositionCd;
          getPhotoInfoParams.userId = _this8.userCd;
          getPhotoInfoParams.type = '0';
          //照片路径等信息取得API
          k_0002_k_0002_getPhotoInfo(getPhotoInfoParams).then(function (res_photoInfo) {
            if (res_photoInfo.code === 204 && res_photoInfo.items.personalPhotoData.length > 0) {
              var getPhotoImageParams = {};
              getPhotoImageParams.filePath = res_photoInfo.items.personalPhotoData[0].photoPath;
              getPhotoImageParams.resizeCd = '0';
              //照片取得
              k_0002_k_0002_getImage(getPhotoImageParams).then(function (res_photo) {
                var blob = new Blob([res_photo], { type: 'image/jpeg' });
                var url = window.URL.createObjectURL(blob);
                //  var url= 'data:image/jpeg;base64,' + btoa(new Uint8Array(res_photo).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                var urlsLength = _this8.timeSheetImageList.length;
                var oneImage = {};
                oneImage.name = 'test.jpeg';
                oneImage.url = url;
                oneImage.filePath = getPhotoImageParams.filePath;

                _this8.delPhotoUrl = getPhotoImageParams.filePath;
                _this8.timeSheetImageList = [];
                _this8.timeSheetImageList.splice(urlsLength, 0, oneImage);
                _this8.show_image_border = false;

                //  this.photoListSum = this.photoListSum - 1
                //没有文件和图片时关闭loading
                // if (this.photoListSum === 0) {
                //关闭loading
                //   this.close_loading()
                // }
              }).catch(function (err) {
                //关闭loading
                // this.close_loading()
                // 按钮非活性
                // this.save_btn_disabled = true;
              });
            } else {
              //return
            }
          }).catch(function (err) {});
        }
      });
    },

    // 整形入力
    // handleInput(e) {
    //   if(e.keyCode == 48){return;}
    //   let a = e.key.replace(/[^\d]/g, "");
    //   if (!a) {
    //     e.preventDefault();
    //   }
    // },
    // 退出登录处理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    // 戻る処理
    back_click: function back_click() {
      var _this9 = this;

      if (this.changeFgl === true) {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_CHANGE_BACK'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: true
        }).then(function () {
          var vm = _this9;
          vm.$router.push({ path: k_0002_url.routerUrl_K0001 });
        }).catch(function () {});
      } else {
        var vm = this;
        vm.$router.push({ path: k_0002_url.routerUrl_K0001 });
      }
    },

    // 数据保存的返回值（res_code）処理
    res_code_back: function res_code_back(res) {
      var _this10 = this;

      if (res.code === 202) {
        this.changeFgl = false;
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
        //更新成功的场合，清空更新用图片list
        this.updateLoad_timeSheetImageList[0] = {};
        //更新成功的场合，图片操作初始化false
        this.has_UpdateLoadedDel = false;
        this.query();
      } else if (res.code === 308) {
        setTimeout(function () {
          _this10.$confirm(_this10.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this10.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this10.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(function () {
            var vm = _this10;
            vm.$router.push({ path: k_0002_url.routerUrl_K0001 });
          }).catch(function () {});
        }, 500);
      } else if (res.code === 408) {
        setTimeout(function () {
          _this10.$confirm(_this10.$t('COMMON.MSG_ERROR_STATE_OVER'), { // 作業状態はもう作業完了でした。他の人が先に更新した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this10.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this10.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(function () {
            var vm = _this10;
            vm.$router.push({ path: k_0002_url.routerUrl_K0001 });
          }).catch(function () {});
        }, 500);
        //add by hexy 20200921 start 
      } else if (res.code === 428) {
        setTimeout(function () {
          _this10.$confirm(_this10.$t('COMMON.MSG_TRANSMIT'), { // 勤怠承認済、戻り値メッセージを表示する
            confirmButtonText: _this10.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this10.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true
          }).then(function () {
            // はい
            var vm = _this10;
            vm.$router.push({ path: k_0002_url.routerUrl_K0001 });
          }).catch(function () {
            // いいえ
          });
        }, 500);
        //add by hexy 20200921 end 
        // } else if (res.code === 427) {
        //   setTimeout(() => {
        //     this.$confirm(this.$t('COMMON.MSG_APPROVAL'), { // 勤怠承認済、戻り値メッセージを表示する
        //       confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        //       cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
        //       center: true
        //     }).then(() => {
        //       // はい
        //       var vm = this
        //       vm.$router.push({ path: url.routerUrl_K0001 })
        //     }).catch(() => {
        //       // いいえ
        //     })
        //   }, 500)
      } else if (res.code === 615) {
        var reg1 = '{0}';
        var msg = this.$t('COMMON.MSG_KINTAI_DIV_CHK1').replace(reg1, this.attenAbbr);
        this.$message.error({ message: msg, showClose: true }); // 出勤区分が{0}の場合、2件以上の勤怠は入力できません
      } else if (res.code === 616) {
        //複数な勤怠を入力する場合、出勤区分は一致する必要があります。
        this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_DIV_CHK2'), showClose: true });
      } else if (res.code === 617) {
        var reg1 = '{0}';
        var reg2 = '{1}';
        var msg = this.$t('COMMON.MSG_KINTAITIME_VALIDITY').replace(reg1, res.items.InOut).replace(reg2, res.items.dbInOut);
        this.$message.error({ message: msg, showClose: true }); // 更新失敗  
      } else {
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
      }
    },


    // 保存按钮事件
    save_click: function save_click() {
      var _this11 = this;

      var today = new Date();
      var strTodayHHMM = this.dateToStringHHMM(today, 0);
      var strTrueTodayHHMM = '';
      // 棚卸日が昨日の場合、時+24処理
      if (this.strYesterday === this.job_date) {
        strTrueTodayHHMM = this.dateToStringHHMM(today, 24);
      }

      //---------------------------------コールフラグは1:出発コールの場合-----------------------------------------
      if (this.goalFlg === '1') {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_DEPARTURE_CALL_MEMO'), { // 出発コール時メモを保存します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(function () {
          var Params = {
            'crewCd': _this11.crewCd,
            'jobDate': _this11.job_date,
            'storePositionCd': _this11.storePositionCd,
            'departureCall': strTodayHHMM,
            'div': '3',
            'personalJobState': '1',
            'departureCallMemo': _this11.departureCallMemo
          };
          k_0002_k_0002_Attendances_update(Params).then(function (res) {
            if (res.code == 202) {
              _this11.changeFgl = false;
              //成功返回
              _this11.back_click();
            } else if (res.code == 311) {
              //失败提示
              that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
            }
          });
        }).catch(function () {
          //いいえ　無処理
        });
      } else if (this.goalFlg === '2') {

        //---------------------------コールフラグは2:退店コールの場合-----------------------------------
        //退店コール(現時点)と退店の関連チェック
        if (this.storeOut !== null && this.storeOut !== '') {
          if (this.strYesterday === this.job_date) {
            strTodayHHMM = strTrueTodayHHMM;
          }
          var min_strHHMM = Number(strTodayHHMM.substring(0, 2)) * 60 + Number(strTodayHHMM.substring(3, 5));
          var min_storeOut = Number(this.storeOut.substring(0, 2)) * 60 + Number(this.storeOut.substring(3, 5));
          //退店＞退店コール(現時点)の場合 エラー
          if (min_storeOut > min_strHHMM) {
            this.$message.error({ message: this.$t('COMMON.MSG_RETURN_CALL_OUT_VALIDITY'), showClose: true }); //退店＜退店コールで入力してください。
            return;
          }
          // 退店時刻が46時を超えるかチェック
          if (min_strHHMM > 46 * 60) {
            // 最大46：00 以上の場合
            this.$message.error({ message: this.$t('COMMON.MSG_ERROR_OUTSTORE_24'), showClose: true }); // 退店時刻が最大46：00まで入力してください。
            return;
          }
        }
        this.photoFormData = new FormData();
        var that = this;
        //图片存在チェック
        // let image_control = document.querySelector(
        //   ".el-upload-list__item-thumbnail"
        // );
        // if (image_control === null) {
        //   // this.$message.error({ message: this.$t('COMMON.MSG_MESSAGETIMESHEET_PHOTO_CHECK'), showClose: true });//タイムシート写真を添付してください。
        // } else {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_RETURN_CALL_MEMO'), { // 退店コール時メモを保存します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(function () {
          _this11.set_loading();
          //有图片操作且图片上传list有的场合，保存图片
          if (_this11.updateLoad_timeSheetImageList.length !== 0 && keys_default()(_this11.updateLoad_timeSheetImageList[0]).length !== 0) {
            _this11.photoFormData.append('files', _this11.updateLoad_timeSheetImageList[0].files, _this11.updateLoad_timeSheetImageList[0].photoPath);
            k_0002_k_0002_saveImage(_this11.photoFormData).then(function (res) {
              //保存图片成功，保存数据
              if (res.code == 205) {
                var Params = {
                  'crewCd': _this11.crewCd,
                  'jobDate': _this11.job_date,
                  'storePositionCd': _this11.storePositionCd,
                  'returnCall': strTodayHHMM,
                  'div': '4',
                  'personalJobState': '4',
                  'returnCallMemo': _this11.returnCallMemo,
                  'delPhotoUrl': _this11.delPhotoUrl,
                  'updateDate': _this11.updateDate
                };
                Params.photoItem = [];
                Params.photoItem.push({
                  photoId: _this11.updateLoad_timeSheetImageList[0].photoId,
                  photoPath: _this11.updateLoad_timeSheetImageList[0].photoPath,
                  type: _this11.updateLoad_timeSheetImageList[0].type
                });
                k_0002_k_0002_Attendances_update(Params).then(function (res) {
                  _this11.close_loading();
                  if (res.code == 202) {
                    _this11.$message.success({ message: _this11.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
                    _this11.$alert(_this11.$t('COMMON.MSG_MESSAGE_RETURN_SAVE_OVER'), { // お疲れ様でした。気を付けてお帰りください。経費入力が有れば忘れずに、入力お願いします。
                      confirmButtonText: _this11.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                      center: true
                    }).then(function () {
                      _this11.changeFgl = false;
                      //成功返回
                      _this11.back_click();
                    });
                  } else if (res.code == 311) {
                    //失败提示
                    that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
                  } else if (res.code === 308) {
                    setTimeout(function () {
                      _this11.$confirm(_this11.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                        confirmButtonText: _this11.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                        cancelButtonText: _this11.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                        center: true
                      }).then(function () {
                        var vm = _this11;
                        vm.$router.push({ path: k_0002_url.routerUrl_K0001 });
                      }).catch(function () {});
                    }, 500);
                  }
                });
              } else if (res.code == 311) {
                _this11.close_loading();
                //图片上传失败
                that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
              }
            });
          } else {
            //图片list没有的场合 if (this.updateLoad_timeSheetImageList.length !== 0 && Object.keys(this.updateLoad_timeSheetImageList[0]).length !== 0) 
            var Params = {
              'crewCd': _this11.crewCd,
              'jobDate': _this11.job_date,
              'storePositionCd': _this11.storePositionCd,
              'returnCall': strTodayHHMM,
              'div': '4',
              'personalJobState': '4',
              'returnCallMemo': _this11.returnCallMemo,
              'updateDate': _this11.updateDate
            };
            k_0002_k_0002_Attendances_update(Params).then(function (res) {
              if (res.code == 202) {
                _this11.$message.success({ message: _this11.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
                _this11.$alert(_this11.$t('COMMON.MSG_MESSAGE_RETURN_SAVE_OVER'), { // お疲れ様でした。気を付けてお帰りください。経費入力が有れば忘れずに、入力お願いします。
                  confirmButtonText: _this11.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                  center: true
                }).then(function () {
                  //成功返回
                  _this11.back_click();
                });
              } else if (res.code == 311) {
                //失败提示
                that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
              } else if (res.code === 308) {
                setTimeout(function () {
                  _this11.$confirm(_this11.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                    confirmButtonText: _this11.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                    cancelButtonText: _this11.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                    center: true
                  }).then(function () {
                    var vm = _this11;
                    vm.$router.push({ path: k_0002_url.routerUrl_K0001 });
                  }).catch(function () {});
                }, 500);
              }
            });
          }
        }).catch(function () {
          //いいえ　無処理
        });
        // }
      } else if (this.goalFlg === '3') {
        //-----------------------------コールフラグは3:明細の場合------------------------
        if (this.blurErrorFgl) {
          return;
        }
        //時刻フラグは0の場合、入店、退店、全休憩時間、内深夜休憩  入力できません
        if (this.timeFlag == '0') {
          if (this.storeIn != null && this.storeIn != '') {
            this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_INPUT').replace('{0}', this.attenAbbr).replace('{1}', this.$t('MODULE.C0003_DIALOG_SPAN_IN_STORE')), showClose: true });
            return;
          }
          if (this.storeOut != null && this.storeOut != '') {
            this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_INPUT').replace('{0}', this.attenAbbr).replace('{1}', this.$t('MODULE.C0003_DIALOG_SPAN_OUT_STORE')), showClose: true });
            return;
          }
          if (this.allRestTime != null && this.allRestTime != '') {
            this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_INPUT').replace('{0}', this.attenAbbr).replace('{1}', this.$t('MODULE.C0003_DIALOG_SPAN_NORMAL_REST')), showClose: true });
            return;
          }
          if (this.inLateBreak != null && this.inLateBreak != '') {
            this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_INPUT').replace('{0}', this.attenAbbr).replace('{1}', this.$t('MODULE.C0003_DIALOG_SPAN_DARK_REST')), showClose: true });
            return;
          }
        } else {
          // 必須入力（入店）
          if (this.storeIn == null || this.storeIn === '') {
            this.$message.error({ message: this.$t('COMMON.STORE_IN_MSG_EQUIRED_VALIDITY'), showClose: true }); // 入店は入力必須項目です
            return;
          }
          // 入店の有効性チェック(入力時チェック)
          // 時間の有効性チェック(入力時チェック)
          // 入店時刻(分)
          var min_storeIn = Number(this.storeIn.substring(0, 2)) * 60 + Number(this.storeIn.substring(3, 5));
          // 退店時刻(分)
          var min_storeOut = this.storeOut == null || this.storeOut === '' ? 0 : Number(this.storeOut.substring(0, 2)) * 60 + Number(this.storeOut.substring(3, 5));
          // 予測入店時刻(分)
          var min_esstoreIn = this.esStoreIn == null || this.esStoreIn === '' ? 0 : Number(this.esStoreIn.substring(0, 2)) * 60 + Number(this.esStoreIn.substring(3, 5));
          // 予測退店時刻(分)
          var min_esstoreOut = this.esStoreOut == null || this.esStoreOut === '' ? 0 : Number(this.esStoreOut.substring(0, 2)) * 60 + Number(this.esStoreOut.substring(3, 5));
          //出発コール(分)
          var min_departureCall = this.departureCall == null || this.departureCall === '' ? 0 : Number(this.departureCall.substring(0, 2)) * 60 + Number(this.departureCall.substring(3, 5));
          //退店コール(分)
          var min_returnCall = this.returnCall == null || this.returnCall === '' ? 0 : Number(this.returnCall.substring(0, 2)) * 60 + Number(this.returnCall.substring(3, 5));
          //全休憩時間(分)
          if (this.allRestTime === null || this.allRestTime === '') {
            var min_allRestTime = 0;
          } else {
            var min_allRestTime = Number(this.allRestTime.substring(0, 2)) * 60 + Number(this.allRestTime.substring(3, 5));
          }
          //内深夜休憩(分)
          if (this.inLateBreak === null || this.inLateBreak === '') {
            var min_inLateBreak = 0;
          } else {
            var min_inLateBreak = Number(this.inLateBreak.substring(0, 2)) * 60 + Number(this.inLateBreak.substring(3, 5));
          }
          // 入店＞＝退店 チェック
          if (this.storeOut !== null && this.storeOut !== '' && min_storeIn > min_storeOut) {
            this.$message.error({ message: this.$t('COMMON.MSG_STORE_INOUT_VALIDITY'), showClose: true }); //入店＜退店で入力してください。
            return;
          }
          // 入退店時刻の差チェック
          if (this.storeOut !== null && this.storeOut !== '' && min_storeOut - min_storeIn > 24 * 60) {
            this.$message.error({ message: this.$t('COMMON.MSG_STORE_INOUT_SA_VALIDITY'), showClose: true }); //入店時刻から退店時刻が24時間以内になるよう時刻を入力してください。
            return;
          }
          //if (this.workType === '3') {
          //出発コール、入店両方存在、出発コール＞入店の場合
          //if (this.departureCall !== null && this.departureCall !== '' && this.storeIn !== null && this.storeIn !== '' && min_departureCall > min_storeIn) {
          //  this.$message.error({ message: this.$t('COMMON.MSG_DEPARTURE_CALL_IN_VALIDITY'), showClose: true });//出発コール＜入店で入力してください。
          //  return;
          //}
          //退店コール、退店両方存在、退店＞退店コールの場合
          //if (this.returnCall !== null && this.returnCall !== '' && this.storeOut !== null && this.storeOut !== '' && min_storeOut > min_returnCall) {
          //  this.$message.error({ message: this.$t('COMMON.MSG_RETURN_CALL_OUT_VALIDITY'), showClose: true });//退店＜退店コールで入力してください。
          //   return;
          //}
          //}
        }

        //実働時間、内深夜実働時間計算
        this.workTime = this.calculateWorkTime();
        this.latenightWorkTime = this.calculateLatenightWorkTime();
        //勤怠項目チェック
        if (this.timeFlag == '1') {
          // 休憩時間の合理性チェック(内深夜休憩＞全休憩時間)：
          if (min_inLateBreak > min_allRestTime) {
            this.$message.error({ message: this.$t('COMMON.MSG_RESTTIME_VALIDITY'), showClose: true }); //休憩時間を正しく入力してください。
            return;
          }
          // 休憩時間の合理性チェック(入店・退店両方存在、全休憩時間＞（退店-入店)：
          if (this.storeOut !== null && this.storeOut !== '' && min_allRestTime > min_storeOut - min_storeIn) {
            this.$message.error({ message: this.$t('COMMON.MSG_RESTTIME_VALIDITY'), showClose: true }); //休憩時間を正しく入力してください。)
            return;
          }

          //実働時間(分)
          if (this.workTime === null || this.workTime === '') {
            var min_workTime = 0;
          } else {
            var min_workTime = Number(this.workTime.substring(0, 2)) * 60 + Number(this.workTime.substring(3, 5));
          }
          var check_msg = [];
          //勤怠チェック(実働8時間超で休憩が60分未満)
          if (min_workTime > 8 * 60 && min_allRestTime < 60) {
            check_msg.push('・' + this.$t('COMMON.MSG_KINTAI_CHECK2')); //休憩時間を再確認してください。（実働8H超で休憩1H未満）。
          }
          //勤怠チェック(実働6時間超で休憩が45分未満)
          if (min_workTime > 6 * 60 && min_allRestTime < 45) {
            check_msg.push('・' + this.$t('COMMON.MSG_KINTAI_CHECK3')); //休憩時間を再確認してください。（実働6H超で休憩0.75H未満）
          }
          //勤怠チェック(実動時間12時間超)
          if (min_workTime > 12 * 60) {
            check_msg.push('・' + this.$t('COMMON.MSG_KINTAI_CHECK4')); //残業時間を再確認してください。
          }
          //勤怠チェック(実働0)
          if (min_workTime === 0) {
            check_msg.push('・' + this.$t('COMMON.MSG_KINTAI_CHECK5')); //勤怠を確認してください。
          }
        }
        //勤怠チェックpop処理
        if (this.timeFlag == '1' && check_msg.length > 0 && this.storeOut) {
          var newDatas = [];
          var newDatas1 = [];
          var h = this.$createElement;
          newDatas.push(h('h3', { style: 'text-align:left' }, this.$t('COMMON.MSG_KINTAI_CHECK_TITTLE')));
          newDatas1.push(h('h3', { style: 'text-align:left' }, this.$t('COMMON.MSG_KINTAI_CHECK_TITTLE')));
          for (var i in check_msg) {
            newDatas.push(h('p', { style: 'text-align:left' }, check_msg[i]));
          }
          this.$confirm(h('div', null, newDatas), '', {
            confirmButtonText: this.$t('COMMON.BTN_REGIST'), //登録
            cancelButtonText: this.$t('COMMON.BTN_CHANGE'), //修正
            cancelButtonClass: "btn-custom-cancel_k0002",
            confirmButtonClass: "btn-custom-confirm_k0002",
            center: true,
            showClose: false,
            type: 'warning'
          }).then(function () {
            // 登録の場合、保存処理
            // //图片控件取得（用于判断画面上是否有图片）
            // let image_control = document.querySelector(
            //   ".el-upload-list__item-thumbnail"
            // );
            // //タイムシート添付チェック
            // if (this.workType === '3' && image_control === null && this.storeOut !== '') {
            //   this.$message.error({ message: this.$t('COMMON.MSG_MESSAGETIMESHEET_PHOTO_CHECK'), showClose: true });//タイムシート写真を添付してください。
            // } else {
            //   this.allSave()
            // }
            _this11.allSave();
          }).catch(function () {
            // 修正の場合、取消 
          });
        } else {
          // let image_control = document.querySelector(
          //   ".el-upload-list__item-thumbnail"
          // );
          //タイムシート添付チェックz
          // if (this.workType === '3' && image_control === null && this.storeOut !== '') {
          //   this.$message.error({ message: this.$t('COMMON.MSG_MESSAGETIMESHEET_PHOTO_CHECK'), showClose: true });//タイムシート写真を添付してください。
          // } else {
          //   this.allSave()
          // }
          this.allSave();
        }
      } else {
        //無処理
      }
    },

    //保存处理 (コールフラグは3:明細専用)
    allSave: function allSave() {
      var _this12 = this;

      if (this.timeFlag == '1' && (this.storeOut === null || this.storeOut === "")) {
        var save_msg = this.$t('MODULE.K0002_MSG_NO_STOREOUT');
      } else {
        var save_msg = this.$t('COMMON.MSG_SAVE');
      }
      this.$confirm(save_msg, { //保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
        center: true
      }).then(function () {
        _this12.set_loading();
        _this12.photoFormData = new FormData();
        var that = _this12;
        //若没进行过图片操作，不保存图片，只保存数据
        if (!_this12.has_UpdateLoadedDel) {
          _this12.save_do();
        } else {
          //有图片操作且图片上传list有的场合，保存图片
          if (_this12.updateLoad_timeSheetImageList.length !== 0 && keys_default()(_this12.updateLoad_timeSheetImageList[0]).length !== 0) {
            _this12.photoFormData.append('files', _this12.updateLoad_timeSheetImageList[0].files, _this12.updateLoad_timeSheetImageList[0].photoPath);
            k_0002_k_0002_saveImage(_this12.photoFormData).then(function (res) {
              //保存图片成功，保存数据
              if (res.code == 205) {
                that.save_do();
              } else if (res.code == 311) {
                _this12.close_loading();
                //图片上传失败
                that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
              }
            });
          } else {
            //有图片操作且图片上传list没有的场合，不保存图片，只保存数据
            _this12.save_do();
          }
        }
      }).catch(function () {
        // 取消
      });
    },

    // 数据保存処理(コールフラグは3:明細専用)
    save_do: function save_do() {
      var _this13 = this;

      var update_params_list = [];
      var update_params = {};
      update_params.crewCd = this.crewCd;
      update_params.userCd = this.userInfo.userCd;
      update_params.jobDate = this.job_date;
      update_params.storePositionCd = this.storePositionCd;
      // update_params.storePositionCdNew = this.storePositionCd
      update_params.teamCd = this.teamCd;
      update_params.storeIn = this.storeIn;
      update_params.storeOut = this.storeOut === null || this.storeOut === '' ? '' : this.storeOut;
      if (this.timeFlag === '1') {
        if (this.allRestTime === null || this.allRestTime === '') {
          update_params.allRestTime = '00:00';
        } else {
          update_params.allRestTime = this.allRestTime;
        }
        if (this.inLateBreak === null || this.inLateBreak === '') {
          update_params.inLateBreak = '00:00';
        } else {
          update_params.inLateBreak = this.inLateBreak;
        }
      } else {
        update_params.allRestTime = '';
        update_params.inLateBreak = '';
      }
      update_params.workTime = this.timeFlag === '0' ? '' : this.workTime;
      update_params.latenightWorkTime = this.timeFlag === '0' ? '' : this.latenightWorkTime;
      update_params.sign = '';
      update_params.jobState = this.jobState;
      update_params.selfFlag = 1;
      update_params.updateDate = this.updateDate;
      update_params.trminal = 'staff';
      update_params.gamenId = 'SK_0002';
      update_params.div = '2';
      update_params.photoItem = [];
      update_params.departureCallMemo = this.timeFlag === '0' ? '' : this.departureCallMemo;
      update_params.returnCallMemo = this.timeFlag === '0' ? '' : this.returnCallMemo;
      update_params.delPhotoUrl = '';
      update_params.timeFlag = this.timeFlag;
      update_params.attendanceDiv = this.attendanceDiv;
      update_params.storePositionDisplayCd = this.storePositionDisplayCd;
      if (this.has_UpdateLoadedDel) {
        update_params.timesheetCheck = 0;
      }
      //作業区分は「3」（派遣・その他請負）かつ選択した出勤区分の時刻フラグは0の場合 出発コール''  退店コール''
      if (this.workType === '3' && this.timeFlag === '0') {
        update_params.departureCall = '';
        update_params.returnCall = '';
      }
      //状態设定
      if (this.workType === '1' || this.workType === '2') {
        update_params.personalJobState = '0';
      } else if (this.workType === '3' && this.jobState === '0') {
        update_params.personalJobState = '0';
      } else if (this.workType === '3' && this.jobState !== '0' && this.timeFlag === '0') {
        update_params.personalJobState = '0';
      } else if (this.workType === '3' && this.jobState !== '0' && this.timeFlag !== '0') {
        update_params.personalJobState = this.getPersonalJobState();
      } else {}
      //無処理

      //有图片操作且图片上传list没有的场合，图片信息设为空 删除图片
      if (this.has_UpdateLoadedDel && (this.updateLoad_timeSheetImageList.length === 0 || this.updateLoad_timeSheetImageList.length === 1 && keys_default()(this.updateLoad_timeSheetImageList[0]).length === 0)) {
        update_params.photoItem.push({
          photoId: '',
          photoPath: '',
          type: '0'
        });
        update_params.delPhotoUrl = this.delPhotoUrl;
        //进图片上传list不为空的场合，保存图片信息
      } else if (this.updateLoad_timeSheetImageList.length !== 0 && keys_default()(this.updateLoad_timeSheetImageList[0]).length !== 0) {
        update_params.photoItem.push({
          photoId: this.updateLoad_timeSheetImageList[0].photoId,
          photoPath: this.updateLoad_timeSheetImageList[0].photoPath,
          type: this.updateLoad_timeSheetImageList[0].type
        });
        update_params.delPhotoUrl = this.delPhotoUrl;
      } else {
        //无处理
      }
      update_params_list.push(update_params);
      // 保存接口调用
      k_0002_k_0002_update(update_params_list).then(function (res) {
        _this13.close_loading();
        _this13.res_code_back(res);
      });
    },


    //时间比较
    compareDate: function compareDate(date) {
      var date1 = new Date(date);
      var date2 = new Date();
      date1.setDate(date1.getDate() + 1);
      date2.setDate(date2.getDate());
      var month1 = date1.getMonth() + 1;
      var month2 = date2.getMonth() + 1;
      var day1 = date1.getDate();
      var day2 = date2.getDate();
      var d1 = date1.getFullYear() + '/' + this.getFormatDate(month1) + '/' + this.getFormatDate(day1);
      var d2 = date2.getFullYear() + '/' + this.getFormatDate(month2) + '/' + this.getFormatDate(day2);
      var time1 = parseInt(Date.parse(new Date(d1)) / 1000 / 3600 / 24);
      var time2 = parseInt(Date.parse(new Date(d2)) / 1000 / 3600 / 24);
      var nDays = time2 <= time1;
      return nDays;
    },

    // date->string(0:yyyymmdd  1:yyyy/mm/dd ) 変化
    dateToString: function dateToString(dateTime, changeType) {
      var strTime = '';
      if (dateTime == null) {
        return null;
      }
      var year = dateTime.getFullYear();
      var month = (dateTime.getMonth() + 1).toString();
      var day = dateTime.getDate().toString();
      if (month.length === 1) {
        month = '0' + month;
      }
      if (day.length === 1) {
        day = '0' + day;
      }
      if (changeType === '0') {
        strTime = year + month + day;
      } else if (changeType === '1') {
        strTime = year + '/' + month + '/' + day;
      } else {
        strTime = year + month + day;
      }
      return strTime;
    },

    //时间格式化
    getFormatDate: function getFormatDate(arg) {
      if (arg == undefined || arg == '') {
        return '';
      }
      var re = arg + '';
      if (re.length < 2) {
        re = '0' + re;
      }
      return re;
    },

    //0005182: スタッフ側：勤怠詳細画面経費項目制御変更

    //计算実動時間  退店-入店-全休憩時間。
    calculateWorkTime: function calculateWorkTime() {
      //var cal_result = 0;
      var ret = '';
      if (this.storeIn === null || this.storeIn === '' || this.storeOut === null || this.storeOut === '') {
        ret = '';
      } else {
        var cal_storeIn = this.storeIn === null || this.storeIn === '' ? "0" : Number(this.storeIn.substring(0, 2)) * 60 + Number(this.storeIn.substring(3, 5));
        var cal_storeOut = this.storeOut === null || this.storeOut === '' ? "0" : Number(this.storeOut.substring(0, 2)) * 60 + Number(this.storeOut.substring(3, 5));
        var cal_allRestTime = this.allRestTime === null || this.allRestTime === '' ? "0" : Number(this.allRestTime.substring(0, 2)) * 60 + Number(this.allRestTime.substring(3, 5));
        var cal_result = cal_storeOut - cal_storeIn - cal_allRestTime < 0 ? 0 : cal_storeOut - cal_storeIn - cal_allRestTime;
        ret = this.minuteTOtime(cal_result);
      }
      return ret;
    },

    //计算内深夜実動時間  深夜时间-内深夜休憩時間。
    calculateLatenightWorkTime: function calculateLatenightWorkTime() {
      // var cal_result = 0;
      var ret = '';
      if (this.storeIn === null || this.storeIn === '' || this.storeOut === null || this.storeOut === '') {
        ret = '';
      } else {
        var cal_storeIn = this.storeIn === null || this.storeIn === '' ? "0" : Number(this.storeIn.substring(0, 2)) * 60 + Number(this.storeIn.substring(3, 5));
        var cal_storeOut = this.storeIn === null || this.storeOut === '' ? "0" : Number(this.storeOut.substring(0, 2)) * 60 + Number(this.storeOut.substring(3, 5));
        var cal_inLateBreak = this.inLateBreak === null || this.inLateBreak === '' ? "0" : Number(this.inLateBreak.substring(0, 2)) * 60 + Number(this.inLateBreak.substring(3, 5));
        var inlateBlock = this.getInLateBlock(cal_storeIn, cal_storeOut); //深夜时间取得
        var cal_result = inlateBlock - cal_inLateBreak < 0 ? 0 : inlateBlock - cal_inLateBreak;
        ret = this.minuteTOtime(cal_result);
      }

      return ret;
    },


    //分钟 转 【时：分】
    minuteTOtime: function minuteTOtime(val) {
      var ret = "";
      if (val === '' || val === '0') {
        ret = '00:00';
      } else {
        ret = (Math.floor(val / 60).toString().length < 2 ? "0" + Math.floor(val / 60).toString() : Math.floor(val / 60).toString()) + ":" + ((val % 60).toString().length < 2 ? "0" + (val % 60).toString() : (val % 60).toString());
      }
      return ret;
    },

    // date->string(HH:MM) 変化
    dateToStringHHMM: function dateToStringHHMM(dateTime, addHour) {
      var strTime = '';
      if (dateTime == null) {
        return '';
      }
      var hours = dateTime.getHours() + addHour;
      var minutes = dateTime.getMinutes();
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      strTime = hours + ':' + minutes;
      return strTime;
    },

    //個人作業状態  戻り値：0:計画、1:出発済、2:入店済、3:退店済、4:作業完了
    //個人作業状態の判断について、下記の条件を順番にチェックする																													
    //退店コールがある場合、'4'にする。それ以外は続き処理になる																											
    //	退店がある場合、'3'にする。それ以外は続き処理になる																										
    //		入店がある場合、'2'にする。それ以外は続き処理になる																									
    //			出発コールがある場合、'1'にする。それ以外は'0'にする	
    getPersonalJobState: function getPersonalJobState() {
      if (this.returnCall !== null && this.returnCall !== '') {
        return '4';
      } else if (this.storeOut !== null && this.storeOut !== '') {
        return '3';
      } else if (this.storeIn !== null && this.storeIn !== '') {
        return '2';
      } else if (this.departureCall !== null && this.departureCall !== '') {
        return '1';
      } else {
        return '0';
      }
    },

    //出勤区分リスト取得
    searchAttendanceList: function searchAttendanceList() {
      var _this14 = this;

      var div = '25';
      k_0002_conditionApi('all', div).then(function (res) {
        _this14.attendanceList = res.items.attenDiv;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(_this14.attendanceList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (_this14.attendanceDiv == item.attendanceDiv) {
              _this14.attenAbbr = item.attenAbbr;
            }
            if (item.attenAbbr == '') {
              item.attenAbbr = ' ';
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },

    //出勤区分选择
    attendanceDivSelect: function attendanceDivSelect(val) {
      if (val === '') {
        this.timeFlag = '';
        this.attendanceDiv = '';
      } else if (val !== '') {
        var attendanceObj = this.attendanceList.find(function (item) {
          return item.attendanceDiv === val;
        });
        this.timeFlag = attendanceObj.timeFlag;
        this.attendanceDiv = attendanceObj.attendanceDiv;
        this.attenAbbr = attendanceObj.attenAbbr;
        if (this.timeFlag === "0") {
          this.storeIn = '';
          this.storeOut = '';
          this.allRestTime = '';
          this.inLateBreak = '';
          this.workTime = '';
          this.latenightWorkTime = '';
          if (this.workType == '3') {
            this.departureCallMemo = '';
            this.returnCallMemo = '';
          }
        }
      }
    }
  },

  // 初期化自动调用
  created: function created() {
    // 昨日(date)
    var yesterday = new Date();
    yesterday = yesterday.setDate(yesterday.getDate() - 1);
    yesterday = new Date(yesterday);
    // 昨日(str)
    this.strYesterday = this.dateToString(yesterday, '1');

    this.obj = JSON.parse(localStorage.getItem('obj'));
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.storePositionCd = this.obj.storePositionCd;
    this.crewCd = this.obj.crewCd;
    this.jobState = this.obj.jobStateCd;
    // 勤怠承認FLAG
    this.approvalFlag = this.obj.approvalFlag;
    //add by hexy 20200921 start
    this.transmitFlag = this.obj.transmitFlag;
    //add by hexy 20200921 end

    this.esStoreIn = this.obj.esStoreIn;
    this.esStoreOut = this.obj.esStoreOut;
    this.workType = this.obj.workType;
    this.goalFlg = this.obj.goalFlg;
    this.fieldName = this.obj.fieldName;
    // コールフラグは1:出発コール以外の場合 初期化函数调用
    if (this.goalFlg !== '1') {
      this.query();
    } else {
      this.company_name = this.obj.companyName;
      this.job_date = this.obj.jobDate;
    }
    if (this.jobState == this.WORKING) {
      this.jobState_working = true;
    } else {
      this.jobState_working = false;
    }
  },
  mounted: function mounted() {
    //点击删除按钮之外的地方退出长按模式
    var that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-upload-list__item-actions' && e.target.className != 'el-icon-refresh-left' && e.target.className != 'el-icon-refresh-right' && e.target.className != 'el-icon-c-scale-to-original' && e.target.className != 'el-icon-zoom-in' && e.target.className != 'el-icon-zoom-out' && e.target.className != 'el-image-viewer__actions__inner' && e.target.className != 'el-icon-full-screen' && e.target.className != 'el-icon-circle-close' && e.target.className != 'el-button el-button--default el-button--small') {
        that.imageDialogVisible = false;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ee55924","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/k_0002.vue
var k_0002_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_k0002 "},[_c('div',{staticClass:"search-module_k0002"},[_c('el-row',[_c('el-col',{staticClass:"el-col_k0002",attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple readonly_input"},[_c('span',{staticClass:"span_search_condition_k0002 "},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_CORPORATION_NAME')))]),_vm._v(" "),_c('el-input',{staticClass:" css-input-width_k0002 ",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","readonly":true},model:{value:(_vm.company_name),callback:function ($$v) {_vm.company_name=$$v},expression:"company_name"}})],1)]),_vm._v(" "),_c('el-col',{staticClass:"el-col_k0002",attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple readonly_input"},[_c('span',{staticClass:"span_search_condition_k0002",attrs:{"size":"small"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_STORE_NAME')))]),_vm._v(" "),_c('el-input',{staticClass:"css-input-width_k0002",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","readonly":true},model:{value:(_vm.fieldName),callback:function ($$v) {_vm.fieldName=$$v},expression:"fieldName"}})],1)]),_vm._v(" "),_c('el-col',{staticClass:"el-col_k0002",attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple readonly_input"},[_c('span',{staticClass:"span_search_condition_k0002"},[_vm._v(_vm._s(_vm.$t('COMMON.LBL_WORKDAY')))]),_vm._v(" "),_c('el-input',{staticClass:"css-input-width_k0002 ",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","readonly":true},model:{value:(_vm.job_date),callback:function ($$v) {_vm.job_date=$$v},expression:"job_date"}})],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"el-detail_k0002"},[_c('el-row',[_c('div',{staticClass:"div_span_k0002"},[_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_ATTENDANCE')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0002 ",class:{readonly_input1:_vm.NeedReadonly('ATTENDANCE_DIV')},staticStyle:{"text-align":"center"}},[_c('el-select',{staticClass:"input_input1_k0002",attrs:{"maxLength":"5","disabled":_vm.NeedReadonly('ATTENDANCE_DIV'),"placeholder":""},on:{"change":function($event){return _vm.attendanceDivSelect(_vm.attendanceDiv)}},model:{value:(_vm.attendanceDiv),callback:function ($$v) {_vm.attendanceDiv=$$v},expression:"attendanceDiv"}},_vm._l((_vm.attendanceList),function(item){return _c('el-option',{key:item.attendanceDiv,attrs:{"label":item.attenAbbr,"value":item.attendanceDiv}})}),1)],1)]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(this.workType == '1' || this.workType === '2'),expression:"this.workType == '1' || this.workType === '2'"}]},[_c('div',{staticClass:"div_span_k0002"},[_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_POSITION')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_DAY_TEAM')))])])]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(this.workType == '1' || this.workType === '2'),expression:"this.workType == '1' || this.workType === '2'"}]},[_c('div',{staticClass:"div_input_k0002 readonly_input1",staticStyle:{"text-align":"center"}},[_c('el-input',{staticClass:"input_input1_k0002",attrs:{"readonly":true},model:{value:(_vm.storePositionDisplayName),callback:function ($$v) {_vm.storePositionDisplayName=$$v},expression:"storePositionDisplayName"}}),_vm._v(" "),_c('el-input',{staticClass:"input_input1_k0002",attrs:{"readonly":true},model:{value:(_vm.teamCd),callback:function ($$v) {_vm.teamCd=$$v},expression:"teamCd"}})],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0002 "},[_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_IN_STORE')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_OUT_STORE')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0002 ",class:{readonly_input1:_vm.NeedReadonly('STOREIN')||_vm.timeFlag=='0'}},[_c('el-input',{ref:"storeInStatus",staticClass:"input_input1_k0002",attrs:{"maxlength":"5","readonly":_vm.NeedReadonly('STOREIN')||_vm.timeFlag=='0',"pattern":"\\d*"},on:{"blur":function($event){return _vm.storeInBlur($event)},"focus":function($event){return _vm.timeFocusInput($event)}},nativeOn:{"input":function($event){return _vm.timeInputCheck($event)}},model:{value:(_vm.storeIn),callback:function ($$v) {_vm.storeIn=$$v},expression:"storeIn"}}),_vm._v(" "),_c('el-input',{ref:"storeOutStatus",staticClass:"input_input1_k0002",attrs:{"maxlength":"5","readonly":_vm.NeedReadonly('STOREOUT')||_vm.timeFlag=='0',"pattern":"\\d*"},on:{"blur":function($event){return _vm.storeOutBlur($event)},"focus":function($event){return _vm.timeFocusInput($event)}},nativeOn:{"input":function($event){return _vm.timeInputCheck($event)}},model:{value:(_vm.storeOut),callback:function ($$v) {_vm.storeOut=$$v},expression:"storeOut"}})],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0002"},[_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_ALL_REST_TIME')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_INLATE_BREAK')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0002 ",class:{readonly_input1:_vm.NeedReadonly('RESTTIME')||_vm.timeFlag=='0'}},[_c('el-input',{ref:"allRestTime",staticClass:"input_input1_k0002",attrs:{"readonly":_vm.NeedReadonly('RESTTIME')||_vm.timeFlag=='0',"pattern":"\\d*"},on:{"blur":function($event){return _vm.allRestTimeBlur($event)},"focus":function($event){return _vm.timeFocusInput($event)}},nativeOn:{"input":function($event){return _vm.timeInputCheck($event)}},model:{value:(_vm.allRestTime),callback:function ($$v) {_vm.allRestTime=$$v},expression:"allRestTime"}}),_vm._v(" "),_c('el-input',{ref:"inLateBreak",staticClass:"input_input1_k0002",attrs:{"readonly":_vm.NeedReadonly('INLATEBREAK')||_vm.timeFlag=='0',"pattern":"\\d*"},on:{"blur":function($event){return _vm.inLateBreakBlur($event)},"focus":function($event){return _vm.timeFocusInput($event)}},nativeOn:{"input":function($event){return _vm.timeInputCheck($event)}},model:{value:(_vm.inLateBreak),callback:function ($$v) {_vm.inLateBreak=$$v},expression:"inLateBreak"}})],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0002"},[_c('span',{staticClass:"input_span_k0002 "},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_WORK_TIME')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_LATENIGHT_WORK_TIEM')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0002 readonly_input1",staticStyle:{"text-align":"center"}},[_c('el-input',{ref:"workTime",staticClass:"input_input1_k0002",attrs:{"readonly":true},model:{value:(_vm.workTime),callback:function ($$v) {_vm.workTime=$$v},expression:"workTime"}}),_vm._v(" "),_c('el-input',{ref:"latenightWorkTime",staticClass:"input_input1_k0002",attrs:{"readonly":true},model:{value:(_vm.latenightWorkTime),callback:function ($$v) {_vm.latenightWorkTime=$$v},expression:"latenightWorkTime"}})],1)]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.workType=='3'),expression:"workType=='3'"}]},[_c('div',{staticClass:"div_span_k0002"},[_c('span',{staticClass:"input_span_k0002 "},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_DEPART')))])])]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.workType=='3'),expression:"workType=='3'"}]},[_c('div',{staticClass:"div_textarea_k0002",class:{readonly_textarea:_vm.NeedReadonly('DEPART')},staticStyle:{"text-align":"center"}},[_c('el-input',{ref:"workTime",staticClass:"input_textarea_k0002",attrs:{"type":"textarea","maxlength":"500","rows":2,"readonly":_vm.NeedReadonly('DEPART')},model:{value:(_vm.departureCallMemo),callback:function ($$v) {_vm.departureCallMemo=$$v},expression:"departureCallMemo"}})],1)]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.workType=='3'),expression:"workType=='3'"}]},[_c('div',{staticClass:"div_span_k0002"},[_c('span',{staticClass:"input_span_k0002 "},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_QUIT')))])])]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.workType=='3'),expression:"workType=='3'"}]},[_c('div',{staticClass:"div_textarea_k0002",class:{readonly_textarea:_vm.NeedReadonly('QUIT')},staticStyle:{"text-align":"center"}},[_c('el-input',{ref:"workTime",staticClass:"input_textarea_k0002",attrs:{"type":"textarea","maxlength":"500","rows":2,"readonly":_vm.NeedReadonly('QUIT')},model:{value:(_vm.returnCallMemo),callback:function ($$v) {_vm.returnCallMemo=$$v},expression:"returnCallMemo"}})],1)]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.workType=='3'),expression:"workType=='3'"}]},[_c('div',{staticClass:"div_span_k0002"},[_c('span',{staticClass:"input_span_k0002"},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_PHOTO_INFO')))])])]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.workType=='3'),expression:"workType=='3'"}]},[_c('div',{staticClass:"photo_div"},[(_vm.show_image_border)?_c('div',{staticClass:"image_border"}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"disabled":_vm.NeedReadonly('PHOTO_INFO'),"show-file-list":true,"file-list":_vm.timeSheetImageList,"list-type":"picture-card","limit":2,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"#","on-change":function (file, fileList){_vm.handleChange(file, fileList,'photoImage','0')},"auto-upload":false},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return _c('div',{},[_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file)}}},[(false)?_c('span',{staticClass:"el-upload-list__item-delete"}):_vm._e()])])}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.imageDialogVisible)?_c('el-image-viewer',{class:{image_view_red:_vm.jobState_working,image_view_hidden:!_vm.jobState_working},attrs:{"on-close":_vm.closeViewer,"url-list":[_vm.dialogImageUrl]}}):_vm._e()],1)])],1),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary","disabled":_vm.NeedReadonly('SAVE_BTN')},on:{"click":_vm.save_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_SAVE')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))])],1)],1)])])}
var k_0002_staticRenderFns = []
var k_0002_esExports = { render: k_0002_render, staticRenderFns: k_0002_staticRenderFns }
/* harmony default export */ var module_page_k_0002 = (k_0002_esExports);
// CONCATENATED MODULE: ./src/module/page/k_0002.vue
function k_0002_injectStyle (ssrContext) {
  __webpack_require__("p9DJ")
}
var k_0002_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var k_0002___vue_template_functional__ = false
/* styles */
var k_0002___vue_styles__ = k_0002_injectStyle
/* scopeId */
var k_0002___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var k_0002___vue_module_identifier__ = null
var k_0002_Component = k_0002_normalizeComponent(
  page_k_0002,
  module_page_k_0002,
  k_0002___vue_template_functional__,
  k_0002___vue_styles__,
  k_0002___vue_scopeId__,
  k_0002___vue_module_identifier__
)

/* harmony default export */ var src_module_page_k_0002 = (k_0002_Component.exports);

// CONCATENATED MODULE: ./src/module/api/k_0003.js



var k_0003_apiUrl = __webpack_require__("kspH");
// 初期化
var k_0003_home = function home() {
    return api_public.requestQuickGet(k_0003_apiUrl.apiUrl_Initialization);
};

// マスタデータ
var k_0003_conditionSearch = function conditionSearch(page, div, type) {
    var querys = querystring_es3_default.a.stringify({ type: type });
    return api_public.requestQuickGet(k_0003_apiUrl.apiurl_masterData + '/' + page + '/' + div + '?' + querys);
};

// 対象年月取得
var k_0003_k_0003_targetYm = function k_0003_targetYm() {
    return api_public.requestGet(k_0003_apiUrl.apiUrl_StaffTargetYm);
};
// スタッフ時給取得
var k_0003_k_0003_hourwage = function k_0003_hourwage(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet(k_0003_apiUrl.apiUrl_StaffHourwage + '?' + querys);
};
// 各手当時給情報取得
var k_0003_k_0003_typeAllowance = function k_0003_typeAllowance(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet(k_0003_apiUrl.apiUrl_StaffTypeAllowance + '?' + querys);
};

// 時給合計情報取得
var k_0003_k_0003_totalAllowance = function k_0003_totalAllowance(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet(k_0003_apiUrl.apiUrl_StaffTotalAllowance + '?' + querys);
};

// スタッフ案件手当取得
var k_0003_k_0003_allowance = function k_0003_allowance(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet(k_0003_apiUrl.apiUrl_StaffAllowance + '?' + querys);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/k_0003.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var k_0003_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var k_0003 = ({
  components: {},
  data: function data() {
    return {
      titleDisplayDate: '',
      paramDate: '',
      retDateList: [], //param
      //スタッフ時給取得
      hourwage: {
        "userCd": '',
        "userName": '',
        "affiliationPlace": '',
        "sumWorkTime": ''
      },
      typeAllowanceList: [], //各手当時給情報取得
      allowanceList: [], //スタッフ案件手当取得

      businessTypeSelectKey: '1',
      businessTypeList: [], //業務形態区分

      status1: false,
      status2: true,
      fullscreenLoading: false
    };
  },
  created: function created() {
    // 初期化
    this.init_query();
  },
  mounted: function mounted() {},

  methods: {
    // 初期化
    init_query: function init_query() {
      var _this = this;

      //API「マスタデータ」の業務形態区分を呼出す。
      k_0003_conditionSearch('all', '50', 'business_type').then(function (res) {
        _this.businessTypeList = res.items.generalData.businessType;
      });

      //業務形態の選択値を変更すれば、変更後の選択値はLocalStorageに保存する。
      //画面初期値：LocalStorageから取得する。取得できない場合、STとする。
      var localStorageBusinessTypeSelect = localStorage.getItem('k0003_businessTypeSelectKey');
      if (JSON.parse(localStorageBusinessTypeSelect) != null) {
        this.businessTypeSelectKey = localStorageBusinessTypeSelect;
      } else {
        localStorage.setItem("k0003_businessTypeSelectKey", this.businessTypeSelectKey);
      }

      //API「対象年月取得」を呼出す。
      k_0003_k_0003_targetYm().then(function (res) {
        _this.retDateList = res.items;
        if (_this.retDateList.length < 2) {
          _this.$message.warning({ message: _this.$t('COMMON.MSG_TARGETYM'), showClose: true });
        } else {
          _this.previousDateClick();
        }
      });

      // //対象年月の初期値：当月
      // var thisDate = utilApi.timeDefault();

      // //対象年月の月初末日（YYYY/MM/end）
      // thisDate = utilApi.getLastDayOfMonth(thisDate);
      // var preMonth = utilApi.getPreMonth(thisDate);

      // var thisRetDate = {
      //   "targetDate": thisDate,
      //   "crJudgeLevel": thisDate.split('/')[0] + this.$t('MODULE.K0003_LBL_YEAR') + thisDate.split('/')[1] + this.$t('MODULE.K0003_LBL_MONTH')
      // }
      // var preRetDate = {
      //   "targetDate": preMonth,
      //   "crJudgeLevel": preMonth.split('/')[0] + this.$t('MODULE.K0003_LBL_YEAR') + preMonth.split('/')[1] + this.$t('MODULE.K0003_LBL_MONTH')
      // }
      // this.retDateList = [];
      // this.retDateList.push(preRetDate);
      // this.retDateList.push(thisRetDate);
      // console.log(this.retDateList);

      // //年月範囲：前月と当月のみ表示。
      // this.nextDateClick();
    },


    //前一个月
    previousDateClick: function previousDateClick() {
      this.status1 = false;
      this.status2 = true;
      this.titleDisplayDate = this.retDateList[0].crJudgeLevel;
      this.paramDate = this.retDateList[0].targetDate;
      var Params = {
        'targetYm': this.paramDate,
        "businessType": this.businessTypeSelectKey
      };
      this.query(Params);
    },


    //下一个月
    nextDateClick: function nextDateClick() {
      this.status1 = true;
      this.status2 = false;
      this.titleDisplayDate = this.retDateList[1].crJudgeLevel;
      this.paramDate = this.retDateList[1].targetDate;
      var Params = {
        'targetYm': this.paramDate,
        "businessType": this.businessTypeSelectKey
      };
      this.query(Params);
    },
    query: function query(Params) {
      var _this2 = this;

      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 2000);

      //2.1スタッフ時給取得
      k_0003_k_0003_hourwage(Params).then(function (res) {
        if (res.code === 429) {
          _this2.$message.warning({ message: _this2.$t('COMMON.MSG_NO_SUBJECT'), showClose: true });

          _this2.hourwage = {
            "userCd": '',
            "userName": '',
            "affiliationPlace": '',
            "sumWorkTime": ''
          };
          _this2.typeAllowanceList = [];
          _this2.allowanceList = [];

          loading.close();
          return;
        }
        if (res.code === 204) {
          _this2.hourwage.userCd = res.items[0].userCd;
          _this2.hourwage.userName = res.items[0].userName;
          _this2.hourwage.affiliationPlace = res.items[0].affiliationPlace;
          if (res.items[0].sumWorkTime != null) {
            _this2.hourwage.sumWorkTime = utils.decimalFormatter(parseFloat(res.items[0].sumWorkTime).toFixed(2));
          } else {
            _this2.hourwage.sumWorkTime = '';
          }

          //戻り値コードが「204」の場合、下記2.2の処理を続ける。
          //2.2各手当時給情報取得
          _this2.queryAllowance(loading, Params);

          //2.4スタッフ案件手当取得
          k_0003_k_0003_allowance(Params).then(function (res) {
            if (res.code === 204) {
              _this2.allowanceList = res.items;
              for (var i = 0; i < _this2.allowanceList.length; i++) {
                _this2.allowanceList[i].orderAllowance = _this2.NumericalFormatter_k0003(_this2.allowanceList[i].orderAllowance);
                _this2.allowanceList[i].hourwageUnitPrice = _this2.NumericalFormatter_k0003(_this2.allowanceList[i].hourwageUnitPrice);
              }
            } else {
              _this2.allowanceList = [];
            }
            loading.close();
          }).catch(function (err) {
            loading.close();
          });
        } else {
          _this2.hourwage = {
            "userCd": '',
            "userName": '',
            "affiliationPlace": '',
            "sumWorkTime": ''
          };
          _this2.typeAllowanceList = [];
          _this2.allowanceList = [];
          loading.close();
        }
      }).catch(function (err) {
        loading.close();
      });
    },


    //2.2各手当時給情報取得
    queryAllowance: function queryAllowance(loading, businessTypeSelectParams) {
      var _this3 = this;

      //2.2各手当時給情報取得
      k_0003_k_0003_typeAllowance(businessTypeSelectParams).then(function (res) {
        if (res.code === 204) {
          _this3.typeAllowanceList = res.items;
          for (var i = 0; i < _this3.typeAllowanceList.length; i++) {
            _this3.typeAllowanceList[i].allowance = _this3.NumericalFormatter_k0003(_this3.typeAllowanceList[i].allowance);
          }
          loading.close();
        } else {
          _this3.typeAllowanceList = [];
          loading.close();
        }
      }).catch(function (err) {
        loading.close();
      });
    },


    //画面表示変更、データ再表示
    businessTypeSelect: function businessTypeSelect(key) {
      //業務形態の選択値を変更すれば、変更後の選択値はLocalStorageに保存する。
      localStorage.setItem("k0003_businessTypeSelectKey", this.businessTypeSelectKey);

      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 2000);

      //2.2各手当時給情報取得
      var businessTypeSelectParams = {
        'targetYm': this.paramDate,
        "businessType": this.businessTypeSelectKey
      };
      this.queryAllowance(loading, businessTypeSelectParams);
    },


    //金额每三位加','
    NumericalFormatter_k0003: function NumericalFormatter_k0003(val) {
      if (val != null && val !== '') {
        var reg = /[^\d]/;
        if (reg.test(val)) {
          val = val.toString().replace(/[^0-9]/ig, ',');
        }
        if (val.toString() !== '0' && val.toString() !== '0.0') {
          var regex = /^[0]+/;
          val = val.toString().replace(regex, '');
        }
        return "￥" + val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      } else {
        return '';
      }
    },

    // TABLEHeader样式
    k0003HeaderStyle: function k0003HeaderStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; ';
    },

    // TABLE单元格样式
    k0003IsCellStyle: function k0003IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return 'text-align:center;fontSize:10pt';
    },
    k0003IsCellStyleAllowance: function k0003IsCellStyleAllowance(_ref3) {
      var row = _ref3.row,
          colum = _ref3.colum,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;

      if (columnIndex == 2) {
        return 'text-align:left;fontSize:10pt';
      } else if (columnIndex == 3) {
        return 'text-align:right;fontSize:10pt';
      } else {
        return 'text-align:center;fontSize:10pt';
      }
    },
    k0003HeaderClass: function k0003HeaderClass(_ref4) {
      var row = _ref4.row,
          rowIndex = _ref4.rowIndex;

      return 'k0003HeaderClass';
    },
    k0003IsCellClass: function k0003IsCellClass(_ref5) {
      var row = _ref5.row,
          rowIndex = _ref5.rowIndex;

      return 'k0003IsCellClass';
    },

    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4e1d2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/k_0003.vue
var k_0003_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-main',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('div',{staticClass:"search-module_k0003"},[_c('el-row',{staticStyle:{"text-align":"center"},attrs:{"gutter":20}},[_c('el-col',[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}},{name:"show",rawName:"v-show",value:(_vm.status1),expression:"status1"}],staticStyle:{"color":"#000000","padding":"0px 0px 0px 0px"},attrs:{"type":"text","size":"mini"},on:{"click":_vm.previousDateClick}},[_vm._v("＜＜")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.titleDisplayDate)+" ")]),_vm._v(" "),_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}},{name:"show",rawName:"v-show",value:(_vm.status2),expression:"status2"}],staticStyle:{"color":"#000000","padding":"0px 0px 0px 0px"},attrs:{"type":"text","size":"mini"},on:{"click":_vm.nextDateClick}},[_vm._v("＞＞")])],1)])],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding-top":"5px","background-color":"#ffffff"}}),_vm._v(" "),_c('el-row',{staticStyle:{"border":"1px solid #dfdfdf"}},[_c('el-col',{staticClass:"el-col_k0003",staticStyle:{"border-bottom":"1px solid #dfdfdf"},attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple readonly_input div_input_k0003"},[_c('span',{staticClass:"input_span_k0003",staticStyle:{"border-right":"1px solid #dfdfdf","width":"30%"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0003_LBL_NAME')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0003",staticStyle:{"width":"69%"}},[_vm._v(_vm._s(_vm.hourwage.userName)+" ")])])]),_vm._v(" "),_c('el-col',{staticClass:"el-col_k0003",staticStyle:{"border-bottom":"1px solid #dfdfdf"},attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple readonly_input div_input_k0003"},[_c('span',{staticClass:"input_span_k0003",staticStyle:{"border-right":"1px solid #dfdfdf","width":"30%"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0003_LBL_USERID')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0003",staticStyle:{"width":"69%"}},[_vm._v(_vm._s(_vm.hourwage.userCd)+" ")])])]),_vm._v(" "),_c('el-col',{staticClass:"el-col_k0003",staticStyle:{"border-bottom":"1px solid #dfdfdf"},attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple readonly_input div_input_k0003"},[_c('span',{staticClass:"input_span_k0003",staticStyle:{"border-right":"1px solid #dfdfdf","width":"30%"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0003_LBL_POINT')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0003",staticStyle:{"width":"69%"}},[_vm._v(_vm._s(_vm.hourwage.affiliationPlace)+" ")])])]),_vm._v(" "),_c('el-col',{staticClass:"el-col_k0003",attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple readonly_input div_input_k0003"},[_c('span',{staticClass:"input_span_k0003",staticStyle:{"border-right":"1px solid #dfdfdf","width":"30%"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0003_LBL_SUMWORKTIME')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0003",staticStyle:{"width":"69%"}},[_vm._v(_vm._s(_vm.hourwage.sumWorkTime)+" ")])])])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding-top":"5px","background-color":"#ffffff"}}),_vm._v(" "),_c('div',{staticClass:"el-detail_k0003"},[_c('el-row',{staticStyle:{"border":"0px solid #dfdfdf","height":"35px"}},[_c('el-col',{staticClass:"el-col_k0003",staticStyle:{"border-bottom":"0px solid #dfdfdf"},attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple readonly_input div_input_k0003"},[_c('span',{staticClass:"input_span_k0003",staticStyle:{"border-right":"0px solid #dfdfdf","width":"30%"}},[_vm._v("\n              "+_vm._s(_vm.$t('MODULE.K0003_LBL_BUSINESSTYPE'))+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"55%"}},[_c('el-select',{staticStyle:{"width":"45%"},attrs:{"size":"small"},on:{"change":function($event){return _vm.businessTypeSelect(_vm.businessTypeSelectKey)}},model:{value:(_vm.businessTypeSelectKey),callback:function ($$v) {_vm.businessTypeSelectKey=$$v},expression:"businessTypeSelectKey"}},_vm._l((_vm.businessTypeList),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.key}})}),1)],1)])])],1),_vm._v(" "),_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA"},attrs:{"header-cell-style":_vm.k0003HeaderStyle,"cell-style":_vm.k0003IsCellStyle,"header-row-class-name":_vm.k0003HeaderClass,"cell-class-name":_vm.k0003IsCellClass,"data":_vm.typeAllowanceList,"max-height":"380","border":"","size":"mini"}},[_c('el-table-column',{attrs:{"prop":"col1","label":_vm.$t('MODULE.K0003_LBL_BUSINESSTYPE_ALLOWANCE'),"min-width":"40%","width":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.displayName)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col1","label":_vm.$t('MODULE.K0003_LBL_BUSINESSTYPE_SKILLLEVEL'),"min-width":"30%","width":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.skillLevel)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col1","label":_vm.$t('MODULE.K0003_LBL_BUSINESSTYPE_HOURWAGE'),"min-width":"30%","width":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.allowance)+"\n          ")]}}])})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding-top":"5px","background-color":"#ffffff"}}),_vm._v(" "),_c('div',{staticClass:"el-detail_k0003"},[_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA"},attrs:{"header-cell-style":_vm.k0003HeaderStyle,"cell-style":_vm.k0003IsCellStyleAllowance,"header-row-class-name":_vm.k0003HeaderClass,"cell-class-name":_vm.k0003IsCellClass,"data":_vm.allowanceList,"height":"380","border":"","size":"mini"}},[_c('el-table-column',{attrs:{"prop":"col1","label":_vm.$t('MODULE.K0003_LBL_GYOUMU'),"min-width":"15%","width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.businessType)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col2","label":_vm.$t('MODULE.K0003_LBL_KIGYO'),"min-width":"35%","width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.companyName)),_c('br'),_vm._v("\n            "+_vm._s(scope.row.fieldCd)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col3","label":_vm.$t('MODULE.K0003_LBL_STORE'),"min-width":"28%","width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.storeName)),_c('br'),_vm._v("\n            "+_vm._s(scope.row.storePositionName)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col4","label":_vm.$t('MODULE.K0003_LBL_ALLOWANCE'),"min-width":"22%","width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.orderAllowance)),_c('br'),_vm._v("\n            "+_vm._s(scope.row.hourwageUnitPrice)+"\n          ")]}}])})],1)],1)],1)],1)}
var k_0003_staticRenderFns = []
var k_0003_esExports = { render: k_0003_render, staticRenderFns: k_0003_staticRenderFns }
/* harmony default export */ var page_k_0003 = (k_0003_esExports);
// CONCATENATED MODULE: ./src/module/page/k_0003.vue
function k_0003_injectStyle (ssrContext) {
  __webpack_require__("IJCh")
}
var k_0003_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var k_0003___vue_template_functional__ = false
/* styles */
var k_0003___vue_styles__ = k_0003_injectStyle
/* scopeId */
var k_0003___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var k_0003___vue_module_identifier__ = null
var k_0003_Component = k_0003_normalizeComponent(
  k_0003,
  page_k_0003,
  k_0003___vue_template_functional__,
  k_0003___vue_styles__,
  k_0003___vue_scopeId__,
  k_0003___vue_module_identifier__
)

/* harmony default export */ var module_page_k_0003 = (k_0003_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/k_0005.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var k_0005_url = __webpack_require__("kspH");
/* harmony default export */ var k_0005 = ({
  data: function data() {
    return {
      userInfo: [],
      imgIconComplete: __webpack_require__("NFlY"),
      imgIconPlan: __webpack_require__("dP0d"),
      imgIconUnderway: __webpack_require__("/fmQ")
    };
  },

  methods: {
    btn1Click: function btn1Click() {
      window.open(k_0005_url.routerUrl_K0005_btn1URL);
    },
    btn2Click: function btn2Click() {
      var vm = this;
      localStorage.setItem(k_0005_url.routerUrl_K0008, stringify_default()(true));
      vm.$router.push({ path: k_0005_url.routerUrl_K0008 });
    },

    //add by hexy 20210105 start
    btn3Click: function btn3Click() {
      window.open(k_0005_url.routerUrl_K0005_btn3URL);
    },

    //add by hexy 20210105 end
    // 戻る処理
    back_click: function back_click() {
      var vm = this;
      vm.$router.push({ path: k_0005_url.routerUrl_Menu });
    },

    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    }
  },
  created: function created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f85c4b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/k_0005.vue
var k_0005_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-container',{staticStyle:{"padding":"0px","width":"100%","height":"100%","margin-top":"25%"}},[_c('el-main',{staticStyle:{"padding":"100px 0px 0px 0px","width":"100%","height":"100%"}},[_c('div',{attrs:{"align":"center"}},[_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"}},[_c('el-button',{staticClass:"k0005-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.K0005_LBL_BTN1'))},nativeOn:{"click":function($event){return _vm.btn1Click.apply(null, arguments)}}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"}},[_c('el-button',{staticClass:"k0005-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.K0005_LBL_BTN2'))},nativeOn:{"click":function($event){return _vm.btn2Click.apply(null, arguments)}}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"}},[_c('el-button',{staticClass:"k0005-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.K0005_LBL_BTN3'))},nativeOn:{"click":function($event){return _vm.btn3Click.apply(null, arguments)}}})],1),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('el-button',{staticClass:"k0005-button css-btn",attrs:{"type":"primary"}},[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":"mailto: info1-ajis-group@solare-sr.com"}},[_c('span',{staticClass:"k0005-span",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.K0005_LBL_BTN4'))}})])])],1)])])],1),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center","padding-top":"40px"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))])],1)],1)],1)}
var k_0005_staticRenderFns = []
var k_0005_esExports = { render: k_0005_render, staticRenderFns: k_0005_staticRenderFns }
/* harmony default export */ var page_k_0005 = (k_0005_esExports);
// CONCATENATED MODULE: ./src/module/page/k_0005.vue
function k_0005_injectStyle (ssrContext) {
  __webpack_require__("XW2A")
}
var k_0005_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var k_0005___vue_template_functional__ = false
/* styles */
var k_0005___vue_styles__ = k_0005_injectStyle
/* scopeId */
var k_0005___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var k_0005___vue_module_identifier__ = null
var k_0005_Component = k_0005_normalizeComponent(
  k_0005,
  page_k_0005,
  k_0005___vue_template_functional__,
  k_0005___vue_styles__,
  k_0005___vue_scopeId__,
  k_0005___vue_module_identifier__
)

/* harmony default export */ var module_page_k_0005 = (k_0005_Component.exports);

// CONCATENATED MODULE: ./src/module/api/k_0006.js
/* eslint-disable camelcase */


var k_0006_apiUrl = __webpack_require__("kspH");

// 初期化
var k_0006_home = function home() {
  return api_public.requestQuickGet(k_0006_apiUrl.apiUrl_Initialization);
};
// 检索处理
var k_0006_k_0006 = function k_0006(params) {
  return api_public.requestQuickGet('api/v1/staff/attendances' + '/from/' + params.dateFrom + '/end/' + params.dateTo);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/k_0006.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var k_0006_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var page_k_0006 = ({
  data: function data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      imgIconComplete: __webpack_require__("NFlY"),
      imgIconPlan: __webpack_require__("dP0d"),
      imgIconUnderway: __webpack_require__("/fmQ"),
      imgIconCloseComplete: __webpack_require__("OBZi"),
      imgIconGoComplete: __webpack_require__("XuR1"),
      list: [],
      queryParams: {
        siteId: '' //サイトid
      },
      kikanVal1: '',
      kikanVal2: '',
      fullscreenLoading: false
    };
  },

  methods: {
    // 初期化
    init_query: function init_query() {
      var _this = this;

      // 期間初期化
      var search_condition = JSON.parse(localStorage.getItem('search_condition'));
      if (search_condition == null) {
        var today = new Date();
        var torrom = new Date();
        this.kikanVal1 = today;
        var torrom = torrom.setDate(torrom.getDate() + 1);
        torrom = new Date(torrom);
        this.kikanVal2 = torrom;
        var search_condition = {};
        search_condition.fromDate = this.dateToString(this.kikanVal1, '0');
        search_condition.toDate = this.dateToString(this.kikanVal2, '0');
        localStorage.setItem("search_condition", stringify_default()(search_condition));
      } else {
        var fromDate = search_condition.fromDate;
        var toDate = search_condition.toDate;
        if (search_condition.fromDate != null) {
          this.kikanVal1 = new Date(fromDate.substring(0, 4) + '/' + fromDate.substring(4, 6) + '/' + fromDate.substring(6, 8));
        } else {
          this.kikanVal1 = null;
        }
        if (search_condition.toDate != null) {
          this.kikanVal2 = new Date(toDate.substring(0, 4) + '/' + toDate.substring(4, 6) + '/' + toDate.substring(6, 8));
        } else {
          this.kikanVal2 = null;
        }
      }
      k_0006_home().then(function (res) {
        _this.userInfo = res.items.userInfo;
        localStorage.setItem("userInfo", stringify_default()(_this.userInfo));
      });
    },

    // 検索ボタン
    query_btn: function query_btn() {
      var search_condition = {};
      search_condition.fromDate = this.dateToString(this.kikanVal1, '0');
      search_condition.toDate = this.dateToString(this.kikanVal2, '0');
      localStorage.setItem("search_condition", stringify_default()(search_condition));
      this.query();
    },

    // 検索
    query: function query() {
      var _this2 = this;

      var dateFrom = '';
      var dateTo = '';
      if (this.dateToString(this.kikanVal1, '0') !== null) {
        dateFrom = this.dateToString(this.kikanVal1, '0');
      } else {
        dateFrom = null;
      }
      if (this.dateToString(this.kikanVal2, '0') !== null) {
        dateTo = this.dateToString(this.kikanVal2, '0');
      } else {
        dateTo = null;
      }
      if (dateFrom != null && dateTo != null && dateFrom > dateTo) {
        this.$message.error({ message: this.$t('COMMON.MSG_MESSAGE_ERROR_FROMDATE'), showClose: true }); // 期間開始日＜＝期間終了日で設定してください。
      } else {
        var Params = {
          "dateFrom": dateFrom,
          "dateTo": dateTo
        };
        var loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        setTimeout(function () {
          loading.close();
        }, 2000);
        // 検索処理
        k_0006_k_0006(Params).then(function (res) {
          // 戻るリスト
          _this2.total = res.total;
          if (res.code === 300) {
            _this2.$message.warning({ message: _this2.$t('COMMON.NO_TARGET_DATA'), showClose: true });
          }
          _this2.list = res.items;
          loading.close();
        });
      }
    },

    // TABLEHeader样式
    k0006HeaderStyle: function k0006HeaderStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; ';
    },

    // TABLE单元格样式
    k0006IsCellStyle: function k0006IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return 'text-align:center;fontSize:10pt';
    },

    // 单击行事件
    k0006RowOnClick: function k0006RowOnClick(thisRowDate, column, cell, event) {
      //计划的场合，点击无效
      if (thisRowDate.workType != 3 && thisRowDate.jobStateCd == 0 || thisRowDate.workType == 3 && thisRowDate.personalJobState == 0) {
        return;
      }
      if (column.property !== 'col1' && column.property !== 'col2') {
        return;
      }

      localStorage.setItem('obj', stringify_default()(thisRowDate));
      localStorage.setItem(k_0006_url.routerUrl_K0007, stringify_default()(true));
      this.$router.push({ path: k_0006_url.routerUrl_K0007 });
    },
    k0006HeaderClass: function k0006HeaderClass(_ref3) {
      var row = _ref3.row,
          rowIndex = _ref3.rowIndex;

      return 'k0006HeaderClass';
    },
    k0006IsCellClass: function k0006IsCellClass(_ref4) {
      var row = _ref4.row,
          rowIndex = _ref4.rowIndex;

      return 'k0006IsCellClass';
    },

    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    // 戻る処理
    back_click: function back_click() {
      var vm = this;
      vm.$router.push({ path: k_0006_url.routerUrl_Menu });
    },

    // date->string(yyyy/mm/dd  yyyymmdd) 変化
    dateToString: function dateToString(dateTime, changeType) {
      var strTime = '';
      if (dateTime == null) {
        return null;
      }
      var year = dateTime.getFullYear();
      var month = (dateTime.getMonth() + 1).toString();
      var day = dateTime.getDate().toString();
      if (month.length === 1) {
        month = '0' + month;
      }
      if (day.length === 1) {
        day = '0' + day;
      }
      if (changeType === '0') {
        strTime = year + month + day;
      } else if (changeType === '1') {
        strTime = year + '/' + month + '/' + day;
      } else {
        strTime = year + month + day;
      }
      return strTime;
    },

    // date->string(HH:MM) 変化
    dateToStringHHMM: function dateToStringHHMM(dateTime, addHour) {
      var strTime = '';
      if (dateTime == null) {
        return '';
      }
      var hours = dateTime.getHours() + addHour;
      var minutes = dateTime.getMinutes();
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      strTime = hours + ':' + minutes;
      return strTime;
    },

    // 時刻(分) str->num (00:00->num)
    stringToMin: function stringToMin(time) {
      if (time === null || time === '') {
        return 0;
      } else {
        return Number(time.substring(0, 2)) * 60 + Number(time.substring(3, 5));
      }
    }
  },
  created: function created() {
    // 初期化
    this.init_query();
    // 期間より検索
    this.query();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c11493a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/k_0006.vue
var k_0006_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-container',{staticStyle:{"padding":"0px","width":"100%","height":"100%"}},[_c('el-main',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('div',{staticClass:"search-module-k0006 "},[_c('el-row',{staticStyle:{"padding-top":"5px","padding-left":"5px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":7}},[_c('div',[_c('el-date-picker',{staticStyle:{"width":"130px","font-size":"12px"},attrs:{"size":"mini","type":"date","editable":false,"clearable":false,"format":"yyyy/MM/dd"},model:{value:(_vm.kikanVal1),callback:function ($$v) {_vm.kikanVal1=$$v},expression:"kikanVal1"}})],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"padding-left":"2px","padding-right":"10px"},attrs:{"span":2}},[_c('div',[_vm._v("\n               \n            ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('div',[_c('el-date-picker',{staticStyle:{"width":"130px","font-size":"12px"},attrs:{"size":"mini","type":"date","editable":false,"clearable":false,"format":"yyyy/MM/dd"},model:{value:(_vm.kikanVal2),callback:function ($$v) {_vm.kikanVal2=$$v},expression:"kikanVal2"}})],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',[_vm._v("\n               \n            ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"css-button_k0006 css-btn_k0006",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.query_btn}},[_vm._v(_vm._s(_vm.$t('COMMON.LBL_SEARCH')))])],1)])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA"},attrs:{"header-cell-style":_vm.k0006HeaderStyle,"cell-style":_vm.k0006IsCellStyle,"header-row-class-name":_vm.k0006HeaderClass,"cell-class-name":_vm.k0006IsCellClass,"data":_vm.list,"border":"","size":"mini"},on:{"row-click":_vm.k0006RowOnClick}},[(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"jobDate","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"jobStateCd","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"jobStateName","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"companyName","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"storeName","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"typeName","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"esStoreIn","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"acStoreIn","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"esStoreOut","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"acStoreOut","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"updateDate","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"approvalFlag","align":"center"}}):_vm._e(),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"fixed":"left","prop":"transmitFlag","align":"center"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","prop":"col1","label":_vm.$t('MODULE.K0006_LBL_col1'),"width":"","text-align":"center","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.jobDate)+"\n              "),_vm._v(" "),_c('div',[(scope.row.workType!=3 && scope.row.jobStateCd==0)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconPlan,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType!=3 && scope.row.jobStateCd==1)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconUnderway,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType!=3 && scope.row.jobStateCd==2)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconComplete,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==0)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconPlan,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==1)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconGoComplete,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==2)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconUnderway,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==3)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconCloseComplete,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==3 && scope.row.personalJobState==4)?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconComplete,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.workType==1||scope.row.workType==2)?[_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(scope.row.jobStateName))])]:_vm._e(),_vm._v(" "),(scope.row.workType==3)?[_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(scope.row.personalJobValue))])]:_vm._e()],2),_vm._v(" "),_c('div',[_vm._v(_vm._s(scope.row.attenAbbr))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","prop":"col2","label":_vm.$t('MODULE.K0006_LBL_col2'),"width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.companyName)),_c('br'),_vm._v("\n            "+_vm._s(scope.row.fieldName)),_c('br'),_vm._v("\n            "+_vm._s(scope.row.serviceName)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","prop":"col3","label":_vm.$t('MODULE.K0006_LBL_col3'),"width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.esStoreIn)+_vm._s(_vm.$t('MODULE.K0006_LBL_YO')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(scope.row.acStoreIn)+_vm._s(_vm.$t('MODULE.K0006_LBL_JI')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","prop":"col4","label":_vm.$t('MODULE.K0006_LBL_col4'),"width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.esStoreOut)+_vm._s(_vm.$t('MODULE.K0006_LBL_YO')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(scope.row.acStoreOut)+_vm._s(_vm.$t('MODULE.K0006_LBL_JI')))]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(scope.row.crewCd))])]}}])})],1)],1)],1)],1)}
var k_0006_staticRenderFns = []
var k_0006_esExports = { render: k_0006_render, staticRenderFns: k_0006_staticRenderFns }
/* harmony default export */ var module_page_k_0006 = (k_0006_esExports);
// CONCATENATED MODULE: ./src/module/page/k_0006.vue
function k_0006_injectStyle (ssrContext) {
  __webpack_require__("IbRq")
}
var k_0006_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var k_0006___vue_template_functional__ = false
/* styles */
var k_0006___vue_styles__ = k_0006_injectStyle
/* scopeId */
var k_0006___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var k_0006___vue_module_identifier__ = null
var k_0006_Component = k_0006_normalizeComponent(
  page_k_0006,
  module_page_k_0006,
  k_0006___vue_template_functional__,
  k_0006___vue_styles__,
  k_0006___vue_scopeId__,
  k_0006___vue_module_identifier__
)

/* harmony default export */ var src_module_page_k_0006 = (k_0006_Component.exports);

// CONCATENATED MODULE: ./src/module/api/k_0007.js



var k_0007_apiUrl = __webpack_require__("kspH");
// 検索
var k_0007_k_0007 = function k_0007(params) {
  //params序列化
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(k_0007_apiUrl.apiUrl_AttendExpenseAttendancesExpense + '?' + querys);
};
// 更新
var k_0007_k_0007_update = function k_0007_update(params) {
  return api_public.requestPut(k_0007_apiUrl.apiUrl_AttendExpenseAttendances, params);
};

//图片更新
var k_0007_k_0007_saveImage = function k_0007_saveImage(formData) {
  var querys = querystring_es3_default.a.stringify(formData);
  return api_public.requestPostFormData(k_0007_apiUrl.apiUrl_filesUpdate, formData);
};

// マスタデータ
var k_0007_conditionApi = function conditionApi(page, div) {
  console.log('apiUrl.apiurl_masterData:' + k_0007_apiUrl.apiurl_masterData);
  return api_public.requestQuickGet(k_0007_apiUrl.apiurl_masterData + '/' + page + '/' + div);
};
// 店舗現場情報
var k_0007_storeFieldInfo = function storeFieldInfo(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(k_0007_apiUrl.apiUrl_storeFieldInfo + '?' + querys);
};
// 写真情報取得
var k_0007_photoInfo = function photoInfo(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(k_0007_apiUrl.apiUrl_AttendPhotoInfo + '?' + querys);
};

//图片查询
var k_0007_photoFile_get = function photoFile_get(params) {
  return api_public.requestQuickGetImage(k_0007_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(params.photoPath) + '&resizeCd=0');
};
//ekispert交通费查询
// export const requestEkiStationGet = (params) => {
//   let link = "/expcgi/?val_htmb=jcgi_details2&val_expressonly=0&val_airbus=3&val_max_result=10&val_preferred_ticket_order=2&val_feeling=3321122&val_shinkansen=0&val_ship=3&val_highwaybus=3&val_icticket=1&"
//   return http.requestGet(link + 'val_day=' + params.val_day + '&val_month=' + params.val_month + '&val_year=' + params.val_year + '&val_from=' + params.val_from + '&val_to=' + params.val_to)
// }
var k_0007_requestEkiStationGet = function requestEkiStationGet(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(k_0007_apiUrl.apiUrl_expcgi + '?' + querys);
};

//google交通费查询
var k_0007_requestGoogleGet = function requestGoogleGet(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(k_0007_apiUrl.apiUrl_googleapis + '?' + querys);
};
// CONCATENATED MODULE: ./src/common/validator.js



/* harmony default export */ var validator = ({
    // 经费最大入力check
    expenseCheck: function expenseCheck(itemName, vt, row, fieldName) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = get_iterator_default()(vt.personalAttendanceExpense), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.note == fieldName && Number(row[itemName].replace(/,/g, "")) > item.value) {
                    return vt.$t('COMMON.MSG_EXPENSE_CHECK1').replace('{0}', fieldName).replace('{1}', utils.decimalFormatter(item.value));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return '';
    },


    // 金額の有効性チェック
    expenseDigitsCheck: function expenseDigitsCheck(itemName, vt, row, fieldName) {
        if (itemName === 'km') {
            var regex = /^(([0-9]{0,6})\.([0-9]{0,1})$)|^([0-9]{0,6})$/;
            if (!regex.test(row[itemName].replace(/,/g, ""))) {
                return vt.$t('COMMON.MSG_GOODS_INPUT_VALIDITY', { 0: vt.$t('MODULE.K0002_LBL_CATEGORY_EXPENSE'), 1: '6', 2: '1' });
            }
        } else {
            // 金額の有効性チェック
            var regex = /^([\d]{0,8})$/;
            if (!regex.test(row[itemName].toString().replace(/,/g, ""))) {
                return vt.$t('COMMON.MSG_AMOUNT_VALIDITY', { 0: fieldName, 1: '8' });
            }
        }
        return '';
    },


    //经费check方法
    expensesInputCheck: function expensesInputCheck(itemName, vt, row, fieldName) {
        // row.trainBus = vt.gamenId == 'K_0007' ? row.transportExpenses : row.trainBus
        if (itemName === 'km') {
            var msgs = [];
            if (this.expenseCheck('kmPrice', vt, row, fieldName) !== '') {
                msgs.push(this.expenseCheck('kmPrice', vt, row, fieldName));
            }

            if (row.trainBus.toString().replace(/,/g, "") > 0 && row.km.toString().replace(/,/g, "") > 0) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK3')); //入力額を再確認してください。（電車バスとガソリンが同時申請）
            }
            return msgs;
        } else {
            var msgs = [];
            if (this.expenseCheck(itemName, vt, row, fieldName) !== '') {
                msgs.push(this.expenseCheck(itemName, vt, row, fieldName));
            }

            if (itemName == 'trainBus' && row.trainBus.toString().replace(/,/g, "") > 0 && row.km.toString().replace(/,/g, "") > 0) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK3')); //入力額を再確認してください。（電車バスとガソリンが同時申請）
            }
            if (itemName == 'driverAllowance' && row.driverAllowance.toString().replace(/,/g, "") > 0) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK5')); //入力額を再確認してください。（移動、運転手当の入力）
            }
            if ((itemName == 'moveAllowance' || itemName == 'driverAllowance') && row.moveAllowance.toString().replace(/,/g, "") > 0 && row.driverAllowance.toString().replace(/,/g, "") > 0) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK6')); //入力額を再確認してください。（移動手当と移動運転手当が同時申請）
            }
            if ((itemName == 'allowanceTrip' || itemName == 'tripAllowanceManager') && row.allowanceTrip.toString().replace(/,/g, "") > 0 && row.tripAllowanceManager.toString().replace(/,/g, "") > 0) {
                msgs.push(vt.$t('COMMON.MSG_EXPENSE_CHECK7')); //入力額を再確認してください。（食事補助と出張手当の入力）
            }

            return msgs;
        }
    }
});
// EXTERNAL MODULE: ./node_modules/encoding-japanese/src/index.js
var src = __webpack_require__("iw0P");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/k_0007.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var k_0007_url = __webpack_require__("kspH");





// import { Switch } from 'element-ui'

/* harmony default export */ var page_k_0007 = ({
  mixins: [css],
  components: {
    ElImageViewer: image_src_image_viewer
  },
  data: function data() {
    return {
      inputFlag: false,
      obj: [],
      gamenId: 'SK_0007',
      approvalStatus: '1', //勤怠承認「1：承認」
      userInfo: [],
      checked: true,
      fileList: [], //放大图片
      approvalFlag: '', //勤怠承認FLAG
      cl: '',
      listLoading: false,
      queryParam: [],
      job_date: '',
      company_name: '',
      fieldName: '',
      jobState: '',
      crewCd: '',
      userCd: '',
      teamCd: '',
      trainBus: '', //電車・バス
      km: '', //移動km
      kmPrice: '', //ｶﾞｿﾘﾝ精算
      trainBusAuto: '', //電車・バス(自動)
      kmAuto: '', //移動km(自動)
      kmPriceAuto: '', //ｶﾞｿﾘﾝ精算(自動)
      parkingFee: '', //駐車代
      roadFee: '', //有料道路代
      moveAllowance: '', //移動手当
      driverAllowance: '', //移動・移動運転手当
      othersExpenses: '', //消耗・通信・破損・運搬
      transportExpensesTrip: '', //公共移動(出張)
      accommodation: '', //宿泊費
      allowanceTrip: '', //食事補助
      tripAllowanceManager: '', //出張手当(管理職以上)
      actualCostTotal: '', //実費計
      total: '', //合計
      parkingFeeImage: '', //駐車代图片
      roadFeeImage: '', //有料道路代图片
      othersExpensesImage: '', //消耗・通信・破損・運搬图片
      transportExpensesTripImage: '', //公共移動(出張)图片
      accommodationImage: '', //宿泊費图片
      allowanceTripList: [], //食事補助
      driverAllowanceList: [], //移動運転手当
      moveAllowanceList: [], //移動手当List
      personalAttendanceExpense: [], //経費チェック
      tripAllowanceManagerList: [], //出張手当(管理職以上)
      parkingFeeBtn: true, //駐車代上传按钮制御
      roadFeeBtn: true, //有料道路代上传按钮制御
      othersExpensesBtn: true, //消耗・通信・破損・運搬图片上传按钮制御
      transportExpensesTripBtn: true, //公共移動(出張)图片上传按钮制御
      accommodationBtn: true, //宿泊費图片上传按钮制御
      parkingFeeCss: true, //駐車代图片边框样式
      roadFeeCss: true, //有料道路代图片边框样式
      othersExpensesCss: true, //消耗・通信・破損・運搬图片边框样式
      transportExpensesTripCss: true, //公共移動(出張)图片边框样式
      accommodationCss: true, //宿泊費图片边框样式
      parkingFeeUrl: '', //駐車代图片边框样式
      roadFeeUrl: '', //有料道路代图片边框样式
      othersExpensesUrl: '', //消耗・通信・破損・運搬图片边框样式
      transportExpensesTripUrl: '', //公共移動(出張)图片边框样式
      accommodationUrl: '', //宿泊費图片边框样式
      parkingFeeDialog: false,
      roadFeeDialog: false,
      othersExpensesDialog: false,
      transportExpensesTripDialog: false,
      accommodationDialog: false,
      parkingFeeLongClick: false, //是否为图片长按模式（true=长按模式）。
      roadFeeLongClick: false, //是否为图片长按模式（true=长按模式）。
      othersExpensesLongClick: false, //是否为图片长按模式（true=长按模式）。
      transportExpensesTripLongClick: false, //是否为图片长按模式（true=长按模式）。
      accommodationLongClick: false, //是否为图片长按模式（true=长按模式）。
      photoFormData: {},
      transportTeate: '',
      updateDate: '',
      initFlg: 0,
      changeFgl: false,
      transmitFlag: '',
      imageSelect: false,
      photoImage: '', //照相图片
      parkingFeeImageList: [],
      roadFeeImageList: [],
      othersExpensesImageList: [],
      transportExpensesTripImageList: [],
      accommodationImageList: [],
      photoListInit: {},
      photoList: { 1: {}, 2: {}, 3: {}, 4: {}, 5: {} },
      photoItem: { 1: {}, 2: {}, 3: {}, 4: {}, 5: {} },
      personalPhotoData: [],
      srcindex: 0, //图片检索成功数
      params: {
        siteId: '' //サイトid
      },
      status1: false,
      status2: false,
      tripAllowanceStatus: false, //出張手当(管理職以上)权限
      transportFlag: '', //移動手段(1:電車・バス 	2:マイカー 	4:なし	3:直接入力	)
      route: '', //経路
      otherFieldFlag: '', //別店舗移動チェック 
      initiallyFieldFlag: '0', //別店舗移動元現場チェック 
      initiallyFieldCd: '', //別店舗移動元現場cd    
      initiallyFieldName: '', //別店舗移動元現場Name   
      initiallyFieldList: [], //別店舗移動元現場list 
      initiallyFieldGeoLocationLatS: '', //別店舗緯度(店) 
      initiallyFieldGeoLocationLngS: '', //別店舗経度(店)
      initiallyFieldNearestStationS: '', //別店舗最寄り駅(店) 
      initiallyFieldNearestStationBusS: '', //別店舗最寄りバス停(店) 
      geoLocationLatP: '', //緯度(人)      
      geoLocationLngP: '', //経度(人)      
      nearestStationP: '', //最寄り駅(人)    
      nearestStationBusP: '', //最寄りバス停(人) 
      geoLocationLatS: '', //緯度(店)      
      geoLocationLngS: '', //経度(店)      
      nearestStationS: '', //最寄り駅(店)    
      nearestStationBusS: '', //最寄りバス停(店) 
      activeCollapseName: '', //経路詳細折叠面板激活
      transport_status_copy: {} //自动计算交通费的初始状态保存
    };
  },

  methods: {
    // 画像文件之前的钩子
    handleChange: function handleChange(file, fileList, itemName, type) {
      var _this = this;

      var file_type = file.raw.type;
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
        return;
      }

      this[itemName + 'LongClick'] = false;
      if (file.status === "ready") {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length === 2) {
          fileList.shift();
        }
      }
      this[itemName + 'Url'] = file.url;
      var that = this;
      this.getBase64(file.raw).then(function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
          var photo, files, photoPath;
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return that.compressImg(that.base64ToBlob(res));

                case 2:
                  photo = _context.sent;
                  files = new window.File([photo], file.name, { type: file.type });
                  // image/personalPhoto/クルーコード/社員ID_店舗役職CD_種別_写真ID_yyyyMMddHHmmssSSS.拡張子

                  photoPath = 'image/personalPhoto/' + that.crewCd + '/' + that.userCd + '_' + that.storePositionCd + '_' + type + '_' + '0_' + utils.timeNumberGet() + '.' + file.name.split('.').pop();

                  _this.photoList[type] = {};
                  _this.photoList[type].itemName = itemName;
                  _this.photoList[type].files = files;
                  _this.photoList[type].photoId = '0';
                  _this.photoList[type].photoPath = photoPath;
                  _this.photoList[type].type = type;
                  if (_this[itemName + 'ImageList'].length > 0) {
                    _this.photoGet(itemName, file.url, _this.photoList[type]);
                  }

                case 12:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },


    // 图片转base64
    getBase64: function getBase64(file) {
      return new promise_default.a(function (resolve, reject) {
        var reader = new FileReader();
        var imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },


    // base转blob
    base64ToBlob: function base64ToBlob(file) {
      var byteString = void 0;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1]);
      } else {
        byteString = unescape(file.split(',')[1]);
      }
      var mimeString = file.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },


    // 压缩图片
    compressImg: function compressImg(file) {
      var that = this;
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new promise_default.a(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
                h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files);
          };
        };
      });
    },


    //单张图片删除
    fileRemove: function fileRemove(file, fileList, itemName, type) {
      this.$refs[itemName].clearFiles();
      this[itemName + "Url"] = '';
      this[itemName + "LongClick"] = false;
      this.photoList[type] = '';
    },

    //单张图片点击
    handlePictureCardPreview: function handlePictureCardPreview(file, dialogName) {
      if (this[dialogName + 'LongClick'] == true) {
        this[dialogName + 'LongClick'] = false;
      } else {
        this[dialogName + 'Url'] = file.url;
        this[dialogName + 'Dialog'] = true;
      }
    },

    // 検索
    query: function query() {
      var _this2 = this;

      console.log('query');
      var Params = {
        'crewCd': this.crewCd,
        'jobState': this.jobState,
        'storePositionCd': this.storePositionCd,
        'userId': this.userInfo.userCd,
        'status': '2',
        'trminal': 'staff'

        //实现Loading 加载方法
      };this.set_loading();

      // 検索処理
      k_0007_k_0007(Params).then(function (res) {
        console.log(res);
        // this.job_date = res.items[0].jobDate
        _this2.company_name = res.items[0].companyName;
        _this2.fieldName = res.items[0].fieldName;
        // this.userCd = res.items[0].userCd
        _this2.storePositionCd = res.items[0].storePositionCd;
        _this2.teamCd = res.items[0].teamCd;
        _this2.transportFlag = res.items[0].transportFlag;
        console.log('this.transportFlag:' + _this2.transportFlag);
        if (_this2.transportFlag == '3' || _this2.transportFlag == '4') {
          _this2.trainBus = res.items[0].trainBus == null || res.items[0].trainBus === '' ? '0' : utils.decimalFormatter(res.items[0].trainBus.toString());
          _this2.km = res.items[0].km == null || res.items[0].km === '' ? '0.0' : utils.decimalFormatter(utils.tofixeds(res.items[0].km, 1).toString());
          _this2.kmPrice = res.items[0].kmPrice == null || res.items[0].kmPrice === '' ? '0' : utils.decimalFormatter(res.items[0].kmPrice.toString());
          _this2.trainBusAuto = '0';
          _this2.kmAuto = '0.0';
          _this2.kmPriceAuto = '0';
        } else if (_this2.transportFlag == '2') {
          _this2.kmAuto = res.items[0].km == null || res.items[0].km === '' ? '0.0' : utils.decimalFormatter(utils.tofixeds(res.items[0].km, 1).toString());
          _this2.kmPriceAuto = res.items[0].kmPrice == null || res.items[0].kmPrice === '' ? '0' : utils.decimalFormatter(res.items[0].kmPrice.toString());
          _this2.trainBusAuto = '0';
          _this2.trainBus = '0';
          _this2.km = '0.0';
          _this2.kmPrice = '0';
        } else if (_this2.transportFlag == '1') {
          _this2.trainBusAuto = res.items[0].trainBus == null || res.items[0].trainBus === '' ? '0' : utils.decimalFormatter(res.items[0].trainBus.toString());
          _this2.kmAuto = '0.0';
          _this2.kmPriceAuto = '0';
          _this2.trainBus = '0';
          _this2.km = '0.0';
          _this2.kmPrice = '0';
        }
        _this2.parkingFee = res.items[0].parkingFee == null || res.items[0].parkingFee === '' ? '0' : utils.decimalFormatter(res.items[0].parkingFee.toString());
        _this2.roadFee = res.items[0].roadFee == null || res.items[0].roadFee === '' ? '0' : utils.decimalFormatter(res.items[0].roadFee.toString());
        _this2.moveAllowance = res.items[0].moveAllowance == null || res.items[0].moveAllowance === '' ? '0' : utils.decimalFormatter(res.items[0].moveAllowance.toString());
        _this2.driverAllowance = res.items[0].driverAllowance == null || res.items[0].driverAllowance === '' ? '0' : utils.decimalFormatter(res.items[0].driverAllowance.toString());
        _this2.othersExpenses = res.items[0].othersExpenses == null || res.items[0].othersExpenses === '' ? '0' : utils.decimalFormatter(res.items[0].othersExpenses.toString());
        _this2.transportExpensesTrip = res.items[0].transportExpensesTrip == null || res.items[0].transportExpensesTrip === '' ? '0' : utils.decimalFormatter(res.items[0].transportExpensesTrip.toString());
        _this2.accommodation = res.items[0].accommodation == null || res.items[0].accommodation === '' ? '0' : utils.decimalFormatter(res.items[0].accommodation.toString());
        _this2.allowanceTrip = res.items[0].allowanceTrip == null || res.items[0].allowanceTrip === '' ? '0' : utils.decimalFormatter(res.items[0].allowanceTrip.toString());
        _this2.tripAllowanceManager = res.items[0].tripAllowanceManager == null || res.items[0].tripAllowanceManager === '' ? '0' : utils.decimalFormatter(res.items[0].tripAllowanceManager.toString());
        _this2.actualCostTotal = res.items[0].actualCostTotal == null || res.items[0].actualCostTotal === '' ? '0' : utils.decimalFormatter(res.items[0].actualCostTotal.toString());
        _this2.total = res.items[0].total == null || res.items[0].total === '' ? '0' : utils.decimalFormatter(res.items[0].total.toString());
        _this2.transportTeate = res.items[0].transportTeate;
        _this2.updateDate = res.items[0].updateDate;

        _this2.route = res.items[0].route;
        _this2.otherFieldFlag = res.items[0].otherFieldFlag;
        _this2.initiallyFieldFlag = res.items[0].initiallyFieldFlag;
        _this2.initiallyFieldCd = res.items[0].initiallyFieldCd;
        _this2.geoLocationLatP = res.items[0].geoLocationLatP;
        _this2.geoLocationLngP = res.items[0].geoLocationLngP;
        _this2.nearestStationP = res.items[0].nearestStationP;
        _this2.nearestStationBusP = res.items[0].nearestStationBusP;
        _this2.geoLocationLatS = res.items[0].geoLocationLatS;
        _this2.geoLocationLngS = res.items[0].geoLocationLngS;
        _this2.nearestStationS = res.items[0].nearestStationS;
        _this2.nearestStationBusS = res.items[0].nearestStationBusS;
        //自动计算交通费的初始状态保存(只保存时check使用)
        _this2.transport_status_copy.otherFieldFlag = _this2.otherFieldFlag;
        _this2.transport_status_copy.initiallyFieldFlag = _this2.initiallyFieldFlag;
        _this2.transport_status_copy.transportFlag = _this2.transportFlag;
        _this2.transport_status_copy.initiallyFieldCd = _this2.initiallyFieldCd;

        _this2.status1 = true;
        _this2.status2 = true;
        //0005182: スタッフ側：勤怠詳細画面経費項目制御変更
        if (_this2.jobState == '1') {
          //作業中の場合 1
          _this2.status1 = false;
          _this2.status2 = false;
        }
        //作業中以外の場合 2
        //作業完了、且つ連携フラグ=0、且つ現在日時<=作業日+1・の場合
        if (_this2.jobState == '2' && _this2.compareDate(_this2.job_date) && _this2.transmitFlag == 0) {
          _this2.status1 = false;
          _this2.status2 = false;
        }

        // 出張手当(管理職以上)の制御について、登録者のIDは09690000～09699999の場合、活性にする。以外の場合、非活性にする。
        if (Number(_this2.userCd) >= Number("09690000") && Number(_this2.userCd) <= Number("09699999")) {
          _this2.tripAllowanceStatus = false;
        } else {
          _this2.tripAllowanceStatus = true;
        }

        //上記以外の場合
        if (_this2.transmitFlag == 1) {
          _this2.tripAllowanceStatus = true;
        }
        //経路詳細折叠面板激活
        // if(this.isEmpty(this.route)){
        //   this.activeCollapseName='1'
        // }else{
        //   this.activeCollapseName='0'
        // }
        _this2.searchStoreFieldInfo();
        _this2.photoInfoGet();
      }).catch(function (error) {
        _this2.close_loading();
      });
    },


    // 写真情報取得
    photoInfoGet: function photoInfoGet() {
      var _this3 = this;

      var params = {
        crewCd: this.crewCd,
        userId: this.userInfo.userCd,
        storePositionCd: this.storePositionCd,
        type: '1,2,3,4,5'
        // 清空原照片数据，取最新数据
      };this.photoInit();
      k_0007_photoInfo(params).then(function (res) {
        if (res.code == 204) {
          _this3.personalPhotoData = res.items.personalPhotoData;
          _this3.srcindex = 0;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = get_iterator_default()(_this3.personalPhotoData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              _this3.photoList[item.type] = {
                type: item.type,
                photoId: '0',
                photoPath: item.photoPath
              };
              _this3.photoFileGet(item);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          _this3.close_loading();
        }
        _this3.photoListInit = JSON.parse(stringify_default()(_this3.photoList));
      }).catch(function (error) {
        _this3.close_loading();
      });
    },


    // 写真file取得
    photoFileGet: function photoFileGet(item) {
      var _this4 = this;

      k_0007_photoFile_get(item).then(function (res) {
        var blob = new Blob([res], { type: 'image/jpeg' });
        var url = window.URL.createObjectURL(blob);
        if (item.type === "1") {
          _this4.parkingFeeImageList.push({ url: item.photoPath });
          _this4.photoGet('parkingFee', url, item);
        } else if (item.type === "2") {
          _this4.roadFeeImageList.push({ url: item.photoPath });
          _this4.photoGet('roadFee', url, item);
        }if (item.type === "3") {
          _this4.othersExpensesImageList.push({ url: item.photoPath });
          _this4.photoGet('othersExpenses', url, item);
        }if (item.type === "4") {
          _this4.transportExpensesTripImageList.push({ url: item.photoPath });
          _this4.photoGet('transportExpensesTrip', url, item);
        }if (item.type === "5") {
          _this4.accommodationImageList.push({ url: item.photoPath });
          _this4.photoGet('accommodation', url, item);
        }

        if (_this4.srcindex == _this4.personalPhotoData.length - 1) {
          _this4.close_loading();
        } else {
          _this4.srcindex = _this4.srcindex + 1;
        }
      }).catch(function (error) {
        _this4.close_loading();
      });
    },


    // 照片检索前数据初始化
    photoInit: function photoInit() {
      this.personalPhotoData = [];
      this.photoList = {};
      this.parkingFeeImageList = [];
      this.roadFeeImageList = [];
      this.othersExpensesImageList = [];
      this.transportExpensesTripImageList = [];
      this.accommodationImageList = [];
      this.parkingFeeUrl = '';
      this.roadFeeUrl = '';
      this.othersExpensesUrl = '';
      this.transportExpensesTripUrl = '';
      this.accommodationUrl = '';
    },


    // 照片数据赋值
    photoGet: function photoGet(itemName, url, item) {
      var urlsLength = this[itemName + 'ImageList'].length;
      var oneImage = {};
      oneImage.name = 'test.jpeg';
      oneImage.url = url;
      this[itemName + 'Url'] = item.photoPath;
      this[itemName + 'ImageList'] = [];
      this[itemName + 'ImageList'].splice(urlsLength, 0, oneImage);
    },


    // 退出登录处理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    // 戻る処理
    back_click: function back_click() {
      var _this5 = this;

      if (this.changeFgl === true) {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_CHANGE_BACK'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: 'true'
        }).then(function () {
          var vm = _this5;
          vm.$router.push({ path: k_0007_url.routerUrl_K0006 });
        }).catch(function () {});
      } else {
        var vm = this;
        vm.$router.push({ path: k_0007_url.routerUrl_K0006 });
      }
    },

    // res_code処理
    res_code_back: function res_code_back(res) {
      var _this6 = this;

      if (res.code === 202) {
        this.changeFgl = false;
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
        this.query();
      } else if (res.code === 308) {
        setTimeout(function () {
          _this6.$confirm(_this6.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this6.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: _this6.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            customClass: 'textCenter'
          }).then(function () {
            var vm = _this6;
            vm.$router.push({ path: k_0007_url.routerUrl_K0006 });
          }).catch(function () {
            _this6.close_loading();
          });
        }, 500);
      } else if (res.code === 408) {
        setTimeout(function () {
          _this6.$confirm(_this6.$t('COMMON.MSG_ERROR_STATE_OVER'), { // 作業状態はもう作業完了でした。他の人が先に更新した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this6.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: _this6.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            customClass: 'textCenter'
          }).then(function () {
            var vm = _this6;
            vm.$router.push({ path: k_0007_url.routerUrl_K0006 });
          }).catch(function () {
            _this6.close_loading();
          });
        }, 500);
        //add by hexy 20200921 start 
      } else if (res.code === 428) {
        setTimeout(function () {
          _this6.$confirm(_this6.$t('COMMON.MSG_TRANSMIT'), { // 勤怠承認済、戻り値メッセージを表示する
            confirmButtonText: _this6.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this6.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: 'true'
          }).then(function () {
            // はい
            var vm = _this6;
            vm.$router.push({ path: k_0007_url.routerUrl_K0006 });
          }).catch(function () {
            // いいえ
            _this6.close_loading();
          });
        }, 500);
        //add by hexy 20200921 end 
      } else if (res.code === 400) {
        var reg1 = '{0}';
        var reg2 = '{1}';
        var msg = this.$t('COMMON.MSG_KINTAITIME_VALIDITY').replace(reg1, res.items.InOut).replace(reg2, res.items.dbInOut);
        this.$message.error({ message: msg, showClose: true }); // 更新失敗
        this.close_loading();
      } else if (res.code === 430) {
        this.$message.error({ message: this.$t('COMMON.MSG_STOREOUT_EXPENSE'), showClose: true }); // 退店が押下されていなければ保存できません。 
        this.close_loading();
      } else {
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
        this.close_loading();
      }
    },

    //检索按钮事件（交通费自动计算）
    transport_search_click: function transport_search_click() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var res, station_home, station_store, initiallyStation_store, param, calResult1, calResult2, calkm1, calkm2, location_home, location_store, lat_initiallystore, retObj;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this7.initiallyFieldFlag == '1' && _this7.isEmpty(_this7.initiallyFieldCd))) {
                  _context2.next = 3;
                  break;
                }

                _this7.$message.error({ message: _this7.$t('COMMON.MSG_EXPENSE_CHECK13'), showClose: true });
                return _context2.abrupt('return');

              case 3:
                if (!(!_this7.isEmpty_zero(_this7.trainBus) || !_this7.isEmpty_zero(_this7.km))) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 6;
                return _this7.$confirm_hint(_this7.$t('COMMON.MSG_EXPENSE_CHECK12'));

              case 6:
                res = _context2.sent;

                console.log(res);

                if (!res) {
                  _context2.next = 14;
                  break;
                }

                _this7.km = '0.0';
                _this7.kmPrice = '0';
                _this7.trainBus = '0';
                _context2.next = 15;
                break;

              case 14:
                return _context2.abrupt('return');

              case 15:
                _this7.set_loading();
                //交通费自动计算
                //電車・バス 交通费

                if (!(_this7.transportFlag == '1')) {
                  _context2.next = 120;
                  break;
                }

                //駅(自宅)
                station_home = !_this7.isEmpty(_this7.nearestStationBusP) ? _this7.nearestStationBusP : !_this7.isEmpty(_this7.nearestStationP) ? _this7.nearestStationP : '';
                //駅(店舗)

                station_store = !_this7.isEmpty(_this7.nearestStationBusS) ? _this7.nearestStationBusS : !_this7.isEmpty(_this7.nearestStationS) ? _this7.nearestStationS : '';
                //別現場駅(店舗)

                initiallyStation_store = !_this7.isEmpty(_this7.initiallyFieldNearestStationBusS) ? _this7.initiallyFieldNearestStationBusS : !_this7.isEmpty(_this7.initiallyFieldNearestStationS) ? _this7.initiallyFieldNearestStationS : '';
                //计算用参数

                param = {
                  jobDate: _this7.job_date,
                  stationFrom: '',
                  stationTo: ''
                  //作業終了後帰宅、「別現場より移動」にチェックしない場合：自宅 - 当現場＋当現場 - 自宅の交通費
                };

                if (!(_this7.otherFieldFlag == '0' && _this7.initiallyFieldFlag == '0')) {
                  _context2.next = 52;
                  break;
                }

                if (!(!_this7.isEmpty(station_home) && !_this7.isEmpty(station_store))) {
                  _context2.next = 33;
                  break;
                }

                param.stationFrom = station_home;
                param.stationTo = station_store;
                _context2.next = 27;
                return _this7.transport_calculation_eki(param);

              case 27:
                calResult1 = _context2.sent;

                if (!(calResult1.successFlg == false)) {
                  _context2.next = 31;
                  break;
                }

                _this7.close_loading();
                return _context2.abrupt('return');

              case 31:
                _context2.next = 36;
                break;

              case 33:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true });
                return _context2.abrupt('return');

              case 36:
                if (!(!_this7.isEmpty(station_home) && !_this7.isEmpty(station_store))) {
                  _context2.next = 47;
                  break;
                }

                param.stationFrom = station_store;
                param.stationTo = station_home;
                _context2.next = 41;
                return _this7.transport_calculation_eki(param);

              case 41:
                calResult2 = _context2.sent;

                if (!(calResult2.successFlg == false)) {
                  _context2.next = 45;
                  break;
                }

                _this7.close_loading();
                return _context2.abrupt('return');

              case 45:
                _context2.next = 50;
                break;

              case 47:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true });
                return _context2.abrupt('return');

              case 50:
                if (!_this7.isEmpty(calResult1.cheapRoute) && !_this7.isEmpty(calResult2.cheapRoute)) {
                  _this7.route = calResult1.cheapRoute + '\n' + calResult2.cheapRoute;
                } else {
                  _this7.route = calResult1.cheapRoute + calResult2.cheapRoute;
                }
                _this7.trainBusAuto = utils.decimalFormatter((calResult1.cheapCost + calResult2.cheapCost).toString());

              case 52:
                if (!(_this7.otherFieldFlag == '0' && _this7.initiallyFieldFlag == '1')) {
                  _context2.next = 83;
                  break;
                }

                if (!(!_this7.isEmpty(initiallyStation_store) && !_this7.isEmpty(station_store))) {
                  _context2.next = 64;
                  break;
                }

                param.stationFrom = initiallyStation_store;
                param.stationTo = station_store;
                _context2.next = 58;
                return _this7.transport_calculation_eki(param);

              case 58:
                calResult1 = _context2.sent;

                if (!(calResult1.successFlg == false)) {
                  _context2.next = 62;
                  break;
                }

                _this7.close_loading();
                return _context2.abrupt('return');

              case 62:
                _context2.next = 67;
                break;

              case 64:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true });
                return _context2.abrupt('return');

              case 67:
                if (!(!_this7.isEmpty(station_home) && !_this7.isEmpty(station_store))) {
                  _context2.next = 78;
                  break;
                }

                param.stationFrom = station_store;
                param.stationTo = station_home;
                _context2.next = 72;
                return _this7.transport_calculation_eki(param);

              case 72:
                calResult2 = _context2.sent;

                if (!(calResult2.successFlg == false)) {
                  _context2.next = 76;
                  break;
                }

                _this7.close_loading();
                return _context2.abrupt('return');

              case 76:
                _context2.next = 81;
                break;

              case 78:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true });
                return _context2.abrupt('return');

              case 81:
                if (!_this7.isEmpty(calResult1.cheapRoute) && !_this7.isEmpty(calResult2.cheapRoute)) {
                  _this7.route = calResult1.cheapRoute + '\n' + calResult2.cheapRoute;
                } else {
                  _this7.route = calResult1.cheapRoute + calResult2.cheapRoute;
                }

                _this7.trainBusAuto = utils.decimalFormatter((calResult1.cheapCost + calResult2.cheapCost).toString());

              case 83:
                if (!(_this7.otherFieldFlag == '1' && _this7.initiallyFieldFlag == '0')) {
                  _context2.next = 100;
                  break;
                }

                if (!(!_this7.isEmpty(station_home) && !_this7.isEmpty(station_store))) {
                  _context2.next = 95;
                  break;
                }

                param.stationFrom = station_home;
                param.stationTo = station_store;
                _context2.next = 89;
                return _this7.transport_calculation_eki(param);

              case 89:
                calResult1 = _context2.sent;

                if (!(calResult1.successFlg == false)) {
                  _context2.next = 93;
                  break;
                }

                _this7.close_loading();
                return _context2.abrupt('return');

              case 93:
                _context2.next = 98;
                break;

              case 95:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true });
                return _context2.abrupt('return');

              case 98:
                _this7.route = calResult1.cheapRoute;
                _this7.trainBusAuto = utils.decimalFormatter(calResult1.cheapCost.toString());

              case 100:
                if (!(_this7.otherFieldFlag == '1' && _this7.initiallyFieldFlag == '1')) {
                  _context2.next = 117;
                  break;
                }

                if (!(!_this7.isEmpty(initiallyStation_store) && !_this7.isEmpty(station_store))) {
                  _context2.next = 112;
                  break;
                }

                param.stationFrom = initiallyStation_store;
                param.stationTo = station_store;
                _context2.next = 106;
                return _this7.transport_calculation_eki(param);

              case 106:
                calResult1 = _context2.sent;

                if (!(calResult1.successFlg == false)) {
                  _context2.next = 110;
                  break;
                }

                _this7.close_loading();
                return _context2.abrupt('return');

              case 110:
                _context2.next = 115;
                break;

              case 112:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true });
                return _context2.abrupt('return');

              case 115:
                _this7.route = calResult1.cheapRoute;
                _this7.trainBusAuto = utils.decimalFormatter(calResult1.cheapCost.toString());

              case 117:
                _this7.kmAuto = '0.0';
                _this7.kmPriceAuto = '0';
                _this7.close_loading();

              case 120:
                if (!(_this7.transportFlag == '2')) {
                  _context2.next = 253;
                  break;
                }

                calkm1 = 0;
                calkm2 = 0;
                //緯経度(自宅)

                location_home = _this7.geoLocationLatP + ',' + _this7.geoLocationLngP;
                //緯経度(店舗)

                location_store = _this7.geoLocationLatS + ',' + _this7.geoLocationLngS;
                //緯度,経度(移動元現場店舗)

                lat_initiallystore = _this7.initiallyFieldGeoLocationLatS + ',' + _this7.initiallyFieldGeoLocationLngS;
                //计算用参数

                param = {
                  origin: '',
                  destination: ''
                  //car 作業終了後帰宅、「別現場より移動」にチェックしない場合：自宅 - 当現場＋当現場 - 自宅の交通費
                };

                if (!(_this7.otherFieldFlag == '0' && _this7.initiallyFieldFlag == '0')) {
                  _context2.next = 170;
                  break;
                }

                if (!(_this7.isEmpty(_this7.geoLocationLatP) || _this7.isEmpty(_this7.geoLocationLatS))) {
                  _context2.next = 134;
                  break;
                }

                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 134:
                param.origin = location_home;
                param.destination = location_store;
                _context2.next = 138;
                return _this7.transport_calculation_google(param);

              case 138:
                retObj = _context2.sent;

                console.log('retObj1');
                console.log(retObj);

                if (!retObj.successFlg) {
                  _context2.next = 145;
                  break;
                }

                calkm1 = retObj.calkm;
                _context2.next = 148;
                break;

              case 145:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 148:
                if (!(_this7.isEmpty(_this7.geoLocationLatP) || _this7.isEmpty(_this7.geoLocationLatS))) {
                  _context2.next = 154;
                  break;
                }

                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 154:
                param.origin = location_store;
                param.destination = location_home;
                _context2.next = 158;
                return _this7.transport_calculation_google(param);

              case 158:
                retObj = _context2.sent;

                console.log('retObj2');
                console.log(retObj);

                if (!retObj.successFlg) {
                  _context2.next = 165;
                  break;
                }

                calkm2 = retObj.calkm;
                _context2.next = 168;
                break;

              case 165:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 168:
                _this7.kmAuto = utils.decimalFormatter((calkm1 + calkm2).toFixed(1));
                _this7.kmPriceAuto = utils.decimalFormatter(utils.tofixeds(Number(calkm1 + calkm2) * Number(_this7.transportTeate), 0));

              case 170:
                if (!(_this7.otherFieldFlag == '0' && _this7.initiallyFieldFlag == '1')) {
                  _context2.next = 209;
                  break;
                }

                if (!(_this7.isEmpty(_this7.initiallyFieldGeoLocationLatS) || _this7.isEmpty(_this7.geoLocationLatS))) {
                  _context2.next = 177;
                  break;
                }

                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 177:
                param.origin = lat_initiallystore;
                param.destination = location_store;
                _context2.next = 181;
                return _this7.transport_calculation_google(param);

              case 181:
                retObj = _context2.sent;

                if (!retObj.successFlg) {
                  _context2.next = 186;
                  break;
                }

                calkm1 = retObj.calkm;
                _context2.next = 189;
                break;

              case 186:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 189:
                if (!(_this7.isEmpty(_this7.geoLocationLatP) || _this7.isEmpty(_this7.geoLocationLatS))) {
                  _context2.next = 195;
                  break;
                }

                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 195:
                param.origin = location_store;
                param.destination = location_home;
                _context2.next = 199;
                return _this7.transport_calculation_google(param);

              case 199:
                retObj = _context2.sent;

                if (!retObj.successFlg) {
                  _context2.next = 204;
                  break;
                }

                calkm2 = retObj.calkm;
                _context2.next = 207;
                break;

              case 204:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 207:
                _this7.kmAuto = utils.decimalFormatter((calkm1 + calkm2).toFixed(1));
                _this7.kmPriceAuto = utils.decimalFormatter(utils.tofixeds(Number(calkm1 + calkm2) * Number(_this7.transportTeate), 0));

              case 209:
                if (!(_this7.otherFieldFlag == '1' && _this7.initiallyFieldFlag == '0')) {
                  _context2.next = 230;
                  break;
                }

                if (!(_this7.isEmpty(_this7.geoLocationLatP) || _this7.isEmpty(_this7.geoLocationLatS))) {
                  _context2.next = 216;
                  break;
                }

                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 216:
                param.origin = location_home;
                param.destination = location_store;
                _context2.next = 220;
                return _this7.transport_calculation_google(param);

              case 220:
                retObj = _context2.sent;

                if (!retObj.successFlg) {
                  _context2.next = 225;
                  break;
                }

                calkm1 = retObj.calkm;
                _context2.next = 228;
                break;

              case 225:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 228:
                _this7.kmAuto = utils.decimalFormatter(calkm1.toString());
                _this7.kmPriceAuto = utils.decimalFormatter(utils.tofixeds(calkm1 * Number(_this7.transportTeate), 0));

              case 230:
                if (!(_this7.otherFieldFlag == '1' && _this7.initiallyFieldFlag == '1')) {
                  _context2.next = 251;
                  break;
                }

                if (!(_this7.isEmpty(_this7.initiallyFieldGeoLocationLatS) || _this7.isEmpty(_this7.geoLocationLatS))) {
                  _context2.next = 237;
                  break;
                }

                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 237:
                param.origin = lat_initiallystore;
                param.destination = location_store;
                _context2.next = 241;
                return _this7.transport_calculation_google(param);

              case 241:
                retObj = _context2.sent;

                if (!retObj.successFlg) {
                  _context2.next = 246;
                  break;
                }

                calkm1 = retObj.calkm;
                _context2.next = 249;
                break;

              case 246:
                _this7.close_loading();
                _this7.$message.error({ message: _this7.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true });
                return _context2.abrupt('return');

              case 249:
                _this7.kmAuto = utils.decimalFormatter(calkm1.toString());
                _this7.kmPriceAuto = utils.decimalFormatter(utils.tofixeds(calkm1 * Number(_this7.transportTeate), 0));

              case 251:
                _this7.trainBusAuto = '0';
                _this7.route = '';

              case 253:
                console.log('end transport_search_click');
                //自动计算交通费的初始状态保存(只保存时check使用)
                _this7.transport_status_copy.otherFieldFlag = _this7.otherFieldFlag;
                _this7.transport_status_copy.initiallyFieldFlag = _this7.initiallyFieldFlag;
                _this7.transport_status_copy.transportFlag = _this7.transportFlag;
                _this7.transport_status_copy.initiallyFieldCd = _this7.initiallyFieldCd;
                _this7.close_loading();

              case 259:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },

    // 保存按钮事件
    save_click: function save_click() {
      var _this8 = this;

      // 実費計、合計の計算
      this.calculateExpenses();

      // チェック処理
      if (!this.saveCheck()) {
        return;
      }
      //別現場より移動チェック
      if (this.initiallyFieldFlag == '1' && this.isEmpty(this.initiallyFieldCd)) {
        this.$message.error({ message: this.$t('COMMON.MSG_EXPENSE_CHECK13'), showClose: true });
        return;
      }
      // 下記の経費項目は金額入力あり・領収書添付なしがある場合、メッセージを表示する。
      if (this.itemPhotoCheck()) {
        this.$message.error({ message: this.$t('COMMON.MSG_PHOTO_CHECK'), showClose: true });
        return;
      }
      //自动计算交通费的初始状态check
      if (this.transportFlag != '4' && this.transportFlag != '3') {
        if (this.transport_status_copy.otherFieldFlag != this.otherFieldFlag || this.transport_status_copy.initiallyFieldFlag != this.initiallyFieldFlag || this.transport_status_copy.transportFlag != this.transportFlag || this.transport_status_copy.initiallyFieldCd != this.initiallyFieldCd) {
          this.$message.error({ message: this.$t('COMMON.MSG_EXPENSE_CHECK14'), showClose: true });
          return;
        }
      }
      // 実費計
      var msgs = [];
      var msg1 = validator.expensesInputCheck('actualCostTotal', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ACTUALCOSTTOTAL'));
      var msg2 = validator.expensesInputCheck('total', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TOTAL'));
      if (msg1.length > 0) {
        msgs.push('・' + msg1[0]);
      }
      if (msg2.length > 0) {
        msgs.push('・' + msg2[0]);
      }
      if (msgs.length > 0) {
        //check确认提示
        var msg = '';
        if (msgs.length > 1) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(msgs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              msg = msg + '<span>' + item + '</span><br/>';
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        } else {
          msg = '<span>' + msgs[0] + '</span><br/>';
        }
        // 下記の警告を確認してください。
        this.$confirm(msg, this.$t('COMMON.MSG_CONFIRM_WARNING'), {
          confirmButtonText: this.$t('COMMON.BTN_REGIST'), //BTN_REGIST
          cancelButtonText: this.$t('COMMON.BTN_CHANGE'), //修正
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "btn-custom-cancel_k0007",
          confirmButtonClass: "btn-custom-confirm_k0007",
          type: 'warning',
          center: true,
          showClose: false,
          customClass: 'confirmStyle'
        }).then(function () {
          // 継続の場合、保存処理
          _this8.photoAndExpensesCheck();
        }).catch(function () {
          // 確認の場合、取消         
        });
      } else {
        this.photoAndExpensesCheck();
      }
    },


    //  経費と写真の関連チェック
    photoAndExpensesCheck: function photoAndExpensesCheck() {
      var _this9 = this;

      this.photoItemSet();
      if (this.photoItemCheck()) {
        // 保存処理
        var newDatas = [];
        var h = this.$createElement;
        // 経費項目は空白或いは「0」のため、撮影完了できません。当該写真を削除しても、よろしいでしょうか
        newDatas.push(h('p', { style: 'text-align:left' }, this.$t('COMMON.MSG_PERSONAL_PHOTO')));
        this.$confirm(h('div', null, newDatas), '', {
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //いいえ
          center: true,
          showClose: false,
          customClass: 'confirmStyle',
          type: 'warning'
        }).then(function () {
          // 保存时先进行图片上传，成功之后进行数据更新
          _this9.saveConfirm();
        }).catch(function () {
          // 確認の場合、取消         
        });
        return;
      } else {
        this.saveConfirm();
      }
    },


    // 保存确认提示
    saveConfirm: function saveConfirm() {
      var _this10 = this;

      // 保存処理
      this.$confirm(this.$t('COMMON.MSG_SAVE'), { //保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //保存
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
        center: 'true'
      }).then(function () {
        //实现Loading 加载方法
        _this10.set_loading();
        // 保存时先进行图片上传，成功之后进行数据更新
        _this10.photoSave();
      }).catch(function () {
        // 取消
      });
    },


    //数据更新
    paramDataSave: function paramDataSave() {
      var _this11 = this;

      var update_params = {};
      update_params.crewCd = this.crewCd;
      update_params.userCd = this.userCd;
      update_params.storePositionCd = this.storePositionCd;
      update_params.storePositionCdNew = this.storePositionCd;

      update_params.parkingFee = utils.strToNum(this.parkingFee);
      update_params.roadFee = utils.strToNum(this.roadFee);
      update_params.moveAllowance = utils.strToNum(this.moveAllowance);
      update_params.driverAllowance = utils.strToNum(this.driverAllowance);
      update_params.othersExpenses = utils.strToNum(this.othersExpenses);
      update_params.transportExpensesTrip = utils.strToNum(this.transportExpensesTrip);
      update_params.accommodation = utils.strToNum(this.accommodation);
      update_params.allowanceTrip = utils.strToNum(this.allowanceTrip);
      update_params.tripAllowanceManager = utils.strToNum(this.tripAllowanceManager);
      update_params.actualCostTotal = utils.strToNum(this.actualCostTotal);
      update_params.total = utils.strToNum(this.total);
      update_params.sign = '';
      update_params.jobState = this.jobState;
      update_params.selfFlag = 1;
      update_params.updateDate = this.updateDate;
      update_params.trminal = 'staff';
      update_params.gamenId = 'SK_0007';
      update_params.photoItem = [];
      update_params.delPhotoUrl = ''; //写真パス(削除用)
      update_params.div = '2';
      if (!this.isEmpty_zero(this.trainBus) || !this.isEmpty_zero(this.km)) {
        //有手动的情况下，手段强制为手动入力
        this.transportFlag = '3';
      }
      update_params.transportFlag = this.transportFlag;
      if (this.isEmpty(this.transportFlag) || this.transportFlag == '3') {
        update_params.trainBus = utils.strToNum(this.trainBus);
        update_params.km = utils.strToNum(this.km);
        update_params.kmPrice = utils.strToNum(this.kmPrice);
        update_params.route = '';
        update_params.otherFieldFlag = '99';
        update_params.initiallyFieldFlag = '0';
        update_params.initiallyFieldCd = '';
      } else {
        update_params.trainBus = utils.strToNum(this.trainBusAuto);
        update_params.km = utils.strToNum(this.kmAuto);
        update_params.kmPrice = utils.strToNum(this.kmPriceAuto);
        update_params.route = this.route;
        update_params.otherFieldFlag = this.otherFieldFlag;
        update_params.initiallyFieldFlag = this.initiallyFieldFlag;
        update_params.initiallyFieldCd = this.initiallyFieldCd;
      }

      var that = this;

      // 写真变更参数
      var that = this;
      keys_default()(this.photoItem).forEach(function (key) {
        if (that.photoItem[key].photoId == '' || that.photoList[key] && that.photoList[key].files) {
          update_params.photoItem.push(that.photoItem[key]);
          // 	経費写真がある　且つ　経費写真が変更された場合
          // 写真パス(削除用)：初期で取得した写真パス*複数写真の場合、「,」で区切り										
          if (that.photoListInit[key]) {
            if (update_params.delPhotoUrl) {
              update_params.delPhotoUrl = update_params.delPhotoUrl + ',' + that.photoListInit[key].photoPath;
            } else {
              update_params.delPhotoUrl = that.photoListInit[key].photoPath;
            }
          }

          /**
           * 	駐車代チェック：駐車代写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           *  有料道路代チェック：有料道路代写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           *  消耗・通信・破損・運搬チェック：消耗・通信・破損・運搬写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           *  公共移動(出張)チェック：公共移動(出張)写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           *  宿泊費チェック：宿泊費写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           */
          update_params[that.expensesCheck(key)] = 0;
        }
      });
      k_0007_k_0007_update([update_params]).then(function (res) {
        _this11.res_code_back(res);
      }).catch(function (err) {
        _this11.close_loading();
      });
    },


    // 照片参数设定
    photoItemSet: function photoItemSet() {
      var photoId = [];
      var items = {};
      var that = this;
      // 确定itemName
      for (var i = 1; i <= 5; i++) {
        switch (i) {
          case 1:
            var itemName = 'parkingFee';
            break;
          case 2:
            var itemName = 'roadFee';
            break;
          case 3:
            var itemName = 'othersExpenses';
            break;
          case 4:
            var itemName = 'transportExpensesTrip';
            break;
          case 5:
            var itemName = 'accommodation';
            break;
        }

        // 遍历检索出来的照片
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(this.personalPhotoData), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var item = _step3.value;

            photoId.push(item.type);
            items[item.type] = item;
          }

          // 检索有照片，photoItem赋值图片参数，没有赋空
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        if (photoId.indexOf(i + '') == -1) {
          this.photoItem[i] = {
            photoId: '',
            photoPath: '',
            type: i + ''
          };
        } else if (this[itemName] === '0') {
          this.photoItem[i] = {
            photoId: items[i].photoId,
            photoPath: items[i].photoPath,
            type: items[i].type
          };
        }
        // 新插入的图片photoItem参数绑定
        keys_default()(this.photoList).forEach(function (key) {
          if (key == i) {
            if (that.photoList[key] === '' || that[itemName] === '0') {
              that.photoItem[key].photoId = '';
              that.photoItem[key].photoPath = '';
              that.photoItem[key].type = i + '';
            } else {
              that.photoItem[key].photoId = that.photoList[key].photoId;
              that.photoItem[key].photoPath = that.photoList[key].photoPath;
              that.photoItem[key].type = that.photoList[key].type;
            }
          }
        });
      }
    },


    // 下記の経費項目は金額入力あり・領収書添付なしがある場合、メッセージを表示する。
    itemPhotoCheck: function itemPhotoCheck() {
      if (utils.strToNum(this.parkingFee) && utils.strToNum(this.parkingFee) != 0 && !this.photoList['1']) {
        return true;
      } else if (utils.strToNum(this.roadFee) && utils.strToNum(this.roadFee) != 0 && !this.photoList['2']) {
        return true;
      } else if (utils.strToNum(this.othersExpenses) && utils.strToNum(this.othersExpenses) != 0 && !this.photoList['3']) {
        return true;
      } else if (utils.strToNum(this.transportExpensesTrip) && utils.strToNum(this.transportExpensesTrip) != 0 && !this.photoList['4']) {
        return true;
      } else if (utils.strToNum(this.accommodation) && utils.strToNum(this.accommodation) != 0 && !this.photoList['5']) {
        return true;
      }
      return false;
    },


    // 下記の経費項目は空白或いは「０」、写真がある場合、メッセージを表示する。																						
    //駐車代、有料道路代、消耗・通信・破損・運搬、公共移動(出張)、宿泊費																							
    photoItemCheck: function photoItemCheck() {
      if (this.photoList['1'] && this.photoList['1'].photoId !== '' && utils.strToNum(this.parkingFee) == 0) {
        return true;
      } else if (this.photoList['2'] && this.photoList['2'].photoId !== '' && utils.strToNum(this.roadFee) == 0) {
        return true;
      } else if (this.photoList['3'] && this.photoList['3'].photoId !== '' && utils.strToNum(this.othersExpenses) == 0) {
        return true;
      } else if (this.photoList['4'] && this.photoList['4'].photoId !== '' && utils.strToNum(this.transportExpensesTrip) == 0) {
        return true;
      } else if (this.photoList['5'] && this.photoList['5'].photoId !== '' && utils.strToNum(this.accommodation) == 0) {
        return true;
      }
      return false;
    },

    //移動手段変更イベント
    transportFlagChange: function transportFlagChange(val) {

      this.otherFieldFlag = '0';
      this.initiallyFieldFlag = '0';
      this.initiallyFieldCd = '';
      this.kmAuto = '0.0';
      this.trainBusAuto = '0';
      this.kmPriceAuto = '0';
      this.route = '';
    },

    //別現場より移動 変更イベント
    initiallyFieldChange: function initiallyFieldChange(val) {
      if (val == '0') {
        this.initiallyFieldCd = '';
      }
    },

    // 経費チェック
    expensesCheck: function expensesCheck(key) {
      var itemName = '';
      switch (key) {
        case '1':
          itemName = 'parkingFeeCheck'; //駐車代チェック
          break;
        case '2':
          itemName = 'roadFeeCheck'; //有料道路代チェック
          break;
        case '3':
          itemName = 'othersExpensesCheck'; //消耗・通信・破損・運搬チェック
          break;
        case '4':
          itemName = 'transportExpensesTripCheck'; //公共移動(出張)チェック
          break;
        case '5':
          itemName = 'accommodationCheck'; //宿泊費チェック
          break;
      }
      return itemName;
    },


    //图片保存
    photoSave: function photoSave() {
      var _this12 = this;

      this.photoFormData = new FormData();
      var that = this;
      var photoSum = 0;

      keys_default()(this.photoList).forEach(function (key) {
        if (that.photoList[key] && that.photoList[key].files) {
          photoSum = photoSum + 1;
          that.photoFormData.append('files', that.photoList[key].files, that.photoList[key].photoPath);
        }
      });

      if (photoSum != 0) {
        k_0007_k_0007_saveImage(this.photoFormData).then(function (res) {
          if (res.code == 205) {
            _this12.paramDataSave();
          } else if (res.code == 311) {
            //图片上传失败
            _this12.$message.error({ message: _this12.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
            _this12.close_loading();
          }
        });
      } else {
        this.paramDataSave();
      }
    },


    //保存check
    saveCheck: function saveCheck() {
      var msg = '';
      this.tablDataExpenses();
      // 電車・バス
      msg = validator.expenseDigitsCheck('trainBus', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TRAINBUS'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 移動km
      msg = validator.expenseDigitsCheck('km', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_KMPRICE'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 駐車代
      msg = validator.expenseDigitsCheck('parkingFee', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_PARKINGFEE'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 有料道路代
      msg = validator.expenseDigitsCheck('roadFee', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ROADFEE'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 移動手当
      msg = validator.expenseDigitsCheck('moveAllowance', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_MOVEALLOWANCE'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 移動・移動運転手当
      msg = validator.expenseDigitsCheck('driverAllowance', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_DRIVERALLOWANCE'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 消耗・通信・破損・運搬
      msg = validator.expenseDigitsCheck('othersExpenses', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_OTHERSEXPENSES'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 公共移動(出張)
      msg = validator.expenseDigitsCheck('transportExpensesTrip', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TRANSPORTEXPENSESTRIP'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 宿泊費
      msg = validator.expenseDigitsCheck('accommodation', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ACCOMMODATION'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      //食事補助 
      msg = validator.expenseDigitsCheck('allowanceTrip', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ALLOWANCETRIP'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 出張手当(管理職以上)
      msg = validator.expenseDigitsCheck('tripAllowanceManager', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TRIPALLOWANCEMANAGER'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 実費計
      msg = validator.expenseDigitsCheck('actualCostTotal', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ACTUALCOSTTOTAL'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      // 合計
      msg = validator.expenseDigitsCheck('total', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TOTAL'));
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true });
        return;
      }
      return true;
    },


    // 実費計、合計の計算について、計算結果を実費計、合計に設定する
    calculateExpenses: function calculateExpenses() {
      //実費計 =  電車バス(直接入力) + ガソリン精算 (直接入力) + 駐車代 + 有料道路代 + 消耗・通信・破損・運搬 + 公共移動（出張） 
      //          + 宿泊費 +  電車バス(自動計算) + ガソリン精算 (自動計算) 
      var actualCostTotal = (utils.strToNum(this.trainBus) + utils.strToNum(this.kmPrice) + utils.strToNum(this.parkingFee) + utils.strToNum(this.roadFee) + utils.strToNum(this.othersExpenses) + utils.strToNum(this.transportExpensesTrip) + utils.strToNum(this.accommodation) + utils.strToNum(this.trainBusAuto) + utils.strToNum(this.kmPriceAuto)).toString();
      if (isNaN(actualCostTotal)) {
        this.actualCostTotal = '0';
      } else {
        this.actualCostTotal = utils.decimalFormatter(actualCostTotal);
      }
      //合計 = 電車バス(直接入力) + ガソリン精算 (直接入力) + 駐車代 + 有料道路代 + 移動手当 + 移動運転手当 
      //      + 消耗・通信・破損・運搬 + 公共移動（出張） + 宿泊費 + 食事補助 + 出張手当 + 電車バス(自動計算) + ガソリン精算 (自動計算) 
      var total = (utils.strToNum(this.trainBus) + utils.strToNum(this.kmPrice) + utils.strToNum(this.parkingFee) + utils.strToNum(this.roadFee) + utils.strToNum(this.moveAllowance) + utils.strToNum(this.driverAllowance) + utils.strToNum(this.othersExpenses) + utils.strToNum(this.transportExpensesTrip) + utils.strToNum(this.accommodation) + utils.strToNum(this.allowanceTrip) + utils.strToNum(this.tripAllowanceManager) + utils.strToNum(this.trainBusAuto) + utils.strToNum(this.kmPriceAuto)).toString();
      if (isNaN(total)) {
        this.total = '0';
      } else {
        this.total = utils.decimalFormatter(total);
      }
    },


    //时间比较
    compareDate: function compareDate(date) {
      var date1 = new Date(date);
      var date2 = new Date();
      date1.setDate(date1.getDate() + 1);
      date2.setDate(date2.getDate());
      var month1 = date1.getMonth() + 1;
      var month2 = date2.getMonth() + 1;
      var day1 = date1.getDate();
      var day2 = date2.getDate();
      var d1 = date1.getFullYear() + '/' + this.getFormatDate(month1) + '/' + this.getFormatDate(day1);
      var d2 = date2.getFullYear() + '/' + this.getFormatDate(month2) + '/' + this.getFormatDate(day2);
      var time1 = parseInt(Date.parse(new Date(d1)) / 1000 / 3600 / 24);
      var time2 = parseInt(Date.parse(new Date(d2)) / 1000 / 3600 / 24);
      var nDays = time2 <= time1;
      return nDays;
    },

    //时间格式化
    getFormatDate: function getFormatDate(arg) {
      if (arg == undefined || arg == '') {
        return '';
      }
      var re = arg + '';
      if (re.length < 2) {
        re = '0' + re;
      }
      return re;
    },


    // 经费选择
    expensesChange: function expensesChange(expenses, itemName, fieldName) {
      this.changeFgl = true;
      this[itemName] = utils.decimalFormatter(expenses);
      this.tablDataExpenses();
      // 入力された経費の正確性のチェック
      var msgs = validator.expensesInputCheck(itemName, this, this.queryParam[0], fieldName);
      if (msgs.length > 0) {
        //确认提示
        this.confirmAlert(msgs);
      }
    },


    // 经费输入框离开焦点
    blurInput: function blurInput(expenses, itemName, fieldName) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var msgs;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:

                _this13[itemName] = utils.decimalFormatter(expenses);

                if (!(itemName === 'km' || itemName === 'trainBus')) {
                  _context3.next = 24;
                  break;
                }

                if (!(_this13.transportFlag != '3')) {
                  _context3.next = 16;
                  break;
                }

                //移動手段： 「3:直接入力」以外の場合
                _this13.tablDataExpenses();
                // 入力された経費の正確性のチェック
                msgs = validator.expensesInputCheck(itemName, _this13, _this13.queryParam[0], fieldName);

                if (!(msgs.length > 0)) {
                  _context3.next = 12;
                  break;
                }

                console.log(1111);
                //确认提示
                _context3.next = 9;
                return _this13.confirmAlert(msgs);

              case 9:
                _this13.autoDelConfirm(itemName);
                _context3.next = 14;
                break;

              case 12:
                console.log(333);
                _this13.autoDelConfirm(itemName);

              case 14:
                _context3.next = 22;
                break;

              case 16:
                if (itemName === 'km' && _this13.km !== '') {
                  _this13.kmPrice = utils.decimalFormatter(utils.tofixeds(Number(_this13.km.replace(/,/g, "")) * Number(_this13.transportTeate), 0).toString());
                }
                if (itemName === 'trainBus' && _this13.trainBus === '') {
                  _this13.trainBus = '0';
                }
                if (itemName === 'km' && _this13.km === '') {
                  _this13.km = '0.0';
                  _this13.kmPrice = '0';
                }
                _this13.tablDataExpenses();
                // 入力された経費の正確性のチェック
                msgs = validator.expensesInputCheck(itemName, _this13, _this13.queryParam[0], fieldName);

                if (msgs.length > 0) {
                  console.log(22);
                  //确认提示
                  _this13.confirmAlert(msgs);
                }

              case 22:
                _context3.next = 28;
                break;

              case 24:
                if (_this13[itemName] === '') {
                  _this13[itemName] = '0';
                }
                _this13.tablDataExpenses();
                // 入力された経費の正確性のチェック
                msgs = validator.expensesInputCheck(itemName, _this13, _this13.queryParam[0], fieldName);

                if (msgs.length > 0) {
                  console.log(33);
                  //确认提示
                  _this13.confirmAlert(msgs);
                }

              case 28:
                _this13.calculateExpenses();

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this13);
      }))();
    },


    //经费输入
    inputChange: function inputChange() {
      this.changeFgl = true;
    },


    //check确认提示
    confirmAlert: function confirmAlert(msgs) {
      var _this14 = this;

      var msg = '';
      if (msgs.length > 1) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(msgs), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;

            msg = msg + '<span>・' + item + '</span><br/>';
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      } else {
        msg = '<span>' + msgs[0] + '</span><br/>';
      }
      return new promise_default.a(function (resolve, reject) {
        // 下記の警告を確認してください。
        _this14.$alert(msg, _this14.$t('COMMON.MSG_CONFIRM_WARNING'), {
          confirmButtonText: 'OK',
          dangerouslyUseHTMLString: true,
          type: 'warning',
          center: true,
          showClose: false,
          customClass: 'confirmStyle'
        }).then(function () {
          resolve(true);
        }).catch(function () {
          resolve(false);
        });
      });
    },
    tablDataExpenses: function tablDataExpenses() {
      this.queryParam[0] = {};
      this.queryParam[0].trainBus = this.trainBus; //電車・バス
      this.queryParam[0].km = this.km;
      this.queryParam[0].kmPrice = this.kmPrice;
      this.queryParam[0].parkingFee = this.parkingFee; // 駐車代
      this.queryParam[0].roadFee = this.roadFee; //有料道路代
      this.queryParam[0].moveAllowance = this.moveAllowance; //移動手当
      this.queryParam[0].driverAllowance = this.driverAllowance; //移動・移動運転手当
      this.queryParam[0].othersExpenses = this.othersExpenses; //消耗・通信・破損・運搬
      this.queryParam[0].transportExpensesTrip = this.transportExpensesTrip; // 公共移動(出張)
      this.queryParam[0].accommodation = this.accommodation; //宿泊費
      this.queryParam[0].allowanceTrip = this.allowanceTrip; //食事補助
      this.queryParam[0].tripAllowanceManager = this.tripAllowanceManager; //出張手当(管理職以上)
      this.queryParam[0].actualCostTotal = this.actualCostTotal; //実費計
      this.queryParam[0].total = this.total; //合计
    },


    //input获取焦点时自动去掉','和':'
    focusInput: function focusInput(row, itemName) {
      if (row != null && row !== '') {
        if (this[itemName] === '0' || this[itemName] === '0.0') {
          this[itemName] = '';
        } else {
          this[itemName] = row.replace(/:|,/g, "");
        }
      }
    },


    //店舗役職-検索
    searchStorePosition: function searchStorePosition() {
      var _this15 = this;

      var div = '13,14,15,16,17';
      var page = 'ul';
      k_0007_conditionApi(page, div).then(function (res) {
        _this15.allowanceTripList = res.items.allowanceTrip; //食事補助
        _this15.driverAllowanceList = res.items.driverAllowance; //移動運転手当
        _this15.moveAllowanceList = res.items.moveAllowance; //移動手当
        _this15.personalAttendanceExpense = res.items.personalAttendanceExpense; //経費チェック
        _this15.tripAllowanceManagerList = res.items.tripAllowanceManager; //出張手当(管理職以上)
      });
    },


    //店舗現場情報-検索
    searchStoreFieldInfo: function searchStoreFieldInfo() {
      var _this16 = this;

      var param = {};
      param.jobDateTo = this.job_date;
      var dateJobDate = new Date(this.job_date);
      param.jobDateFrom = utils.timeDefault(dateJobDate.setDate(dateJobDate.getDate() - 1));
      param.userId = this.userCd;
      param.crewCd = this.crewCd;
      k_0007_storeFieldInfo(param).then(function (res) {
        if (res.code == '204') {
          _this16.initiallyFieldList = res.items.storeFieldInfo;
          //更新的场合，强制检索一次
          if (!_this16.isEmpty(_this16.initiallyFieldCd)) {
            _this16.fieldListChange(_this16.initiallyFieldCd, 'initiallyFieldCd');
          }
        }
      });
    },

    // 照片删除
    parkingFeePhotoDelete: function parkingFeePhotoDelete() {
      this.photoDelete('parkingFee', '1');
    },
    roadFeePhotoDelete: function roadFeePhotoDelete() {
      this.photoDelete('roadFee', '2');
    },
    othersExpensesPhotoDelete: function othersExpensesPhotoDelete() {
      this.photoDelete('othersExpenses', '3');
    },
    transportExpensesTripPhotoDelete: function transportExpensesTripPhotoDelete() {
      this.photoDelete('transportExpensesTrip', '4');
    },
    accommodationPhotoDelete: function accommodationPhotoDelete() {
      this.photoDelete('accommodation', '5');
    },


    // 删除确认
    photoDelete: function photoDelete(itemName, type) {
      var _this17 = this;

      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.BTN_CONFIRM'), // 確認
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: 'true'
      }).then(function () {
        //组件表示图片清空
        _this17.$refs[itemName].clearFiles();
        //上传用list清空
        _this17[itemName + 'ImageList'] = [];
        _this17[itemName + 'Url'] = '';
        _this17[itemName + 'Dialog'] = false;
        _this17.photoList[type] = '';
      }).catch(function () {});
    },

    //空判断，不带0
    isEmpty: function isEmpty(value) {
      if (typeof value == "undefined" || value == null || value == '') {
        return true;
      } else {
        return false;
      }
    },

    //空判断，带0
    isEmpty_zero: function isEmpty_zero(value) {
      if (typeof value == "undefined" || value == null || value == '' || value == '0' || value == '0.0') {
        return true;
      } else {
        return false;
      }
    },

    //移動手段的制御
    disableTransportFlag: function disableTransportFlag() {
      if (this.isEmpty(this.transportFlag) || this.transportFlag == '3' || this.transportFlag == '4') {
        return true;
      } else {
        return false;
      }
    },

    //交通费计算api(google)
    transport_calculation_google: function transport_calculation_google(param) {
      var retObj = {};
      retObj.successFlg = false;
      retObj.calkm = 0;
      return new promise_default.a(function (resolve) {
        k_0007_requestGoogleGet(param).then(function (res) {
          console.log(res);
          if (res.code == '640') {
            retObj.successFlg = false;
            resolve(retObj);
          } else {
            retObj.successFlg = true;
            retObj.calkm = Number(res.items.distance);
            resolve(retObj);
          }
        }).catch(function (err) {
          console.log('google Api Error: ' + err); //计算出错
          retObj.successFlg = false;
          resolve(retObj);
        });
      }).catch(function (err) {
        console.log('google Api Error: ' + err); //计算出错
        retObj.successFlg = false;
        resolve(retObj);
      });
    },

    //交通费计算api(ekispert)
    transport_calculation_eki: function transport_calculation_eki(param) {
      var _this18 = this;

      console.log('transport_calculation_eki start');
      var retObj = {};
      retObj.successFlg = false;
      retObj.cheapRoute = '';
      retObj.cheapCost = 0;
      return new promise_default.a(function (resolve) {
        k_0007_requestEkiStationGet(param).then(function (res) {
          if (res.code == '204') {
            //正常返回
            retObj.successFlg = true;
            retObj.cheapRoute = res.items.route;
            console.log(res.items);
            console.log(res.items.route);
            console.log('res.items.route');
            retObj.cheapCost = Number(res.items.trainBus);
          } else if (res.code == '641') {
            if (retObj.cheapCost == 0) {
              _this18.$message.error({ message: _this18.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true });
            }
            console.log('ekispert Api Error1: ' + err); //计算出错
            retObj.successFlg = false;
          } else {
            console.log('ekispert Api Error2: ' + err); //计算出错
            retObj.successFlg = false;
          }
          resolve(retObj);
        }).catch(function (err) {
          console.log('ekispert Api Error3: ' + err); //计算出错
          resolve(retObj);
        });
      });
    },

    // 現場名list选择
    fieldListChange: function fieldListChange(initiallyFieldCd, itemName) {
      var retIndex = this.initiallyFieldList.findIndex(function (item) {
        if (item.fieldCd == initiallyFieldCd) {
          return true;
        }
      });
      if (retIndex != -1) {
        this.initiallyFieldName = this.initiallyFieldList[retIndex].fieldName;
        this.initiallyFieldGeoLocationLatS = this.initiallyFieldList[retIndex].geoLocationLatS; //別店舗緯度(店) 
        this.initiallyFieldGeoLocationLngS = this.initiallyFieldList[retIndex].geoLocationLngS; //別店舗経度(店)
        this.initiallyFieldNearestStationS = this.initiallyFieldList[retIndex].nearestStationS; //別店舗最寄り駅(店) 
        this.initiallyFieldNearestStationBusS = this.initiallyFieldList[retIndex].nearestStationBusS; //別店舗最寄りバス停(店) 
      }
    },

    //将字符串转为url编码（ekispert用）
    // convertString(queryString){
    //   var unicodeArray= encoding.stringToCode(queryString) 
    //   var sjisArray = encoding.convert(unicodeArray, {to: 'SJIS',from: 'UNICODE',});
    //   var encodedKeyword = encoding.urlEncode(sjisArray);
    //   return encodedKeyword
    // },
    //将交通费字符串转为对象（ekispert用）
    // convertObj(str){
    //   var tempObjEki = {}
    //   var tempEkiArry = str.split('&')
    //   tempEkiArry.forEach((item) => {
    //     var tempsplit = item.split('=')      
    //     tempObjEki[tempsplit[0]]=tempsplit[1]
    //   });
    //   console.log(tempObjEki)
    //   return tempObjEki
    // },
    //最便宜的费用取得（ekispert用）
    // getCheapObj(resObj){
    //   var retObj={
    //     cheapCost:0,
    //     cheapNum:0,
    //     cheapRoute:'',
    //   }
    //   for(var i=1;i<=resObj.val_route_cnt;i++){
    //     if(i==1){
    //       retObj.cheapCost=parseInt(resObj['val_fare_'+i])
    //       retObj.cheapNum=i
    //       retObj.cheapRoute=resObj['val_route_'+i]
    //     }else{
    //       if(retObj.cheapCost>parseInt(resObj['val_fare_'+i])){
    //         retObj.cheapCost=parseInt(resObj['val_fare_'+i])
    //         retObj.cheapNum=i
    //         retObj.cheapRoute=resObj['val_route_'+i]
    //       }
    //     }
    //   }
    //   return retObj
    // },
    //自動計算結果削除的确认提示confirm
    autoDelConfirm: function autoDelConfirm(itemName) {
      var _this19 = this;

      this.$confirm(this.$t('COMMON.MSG_EXPENSE_CHECK11'), {
        confirmButtonText: this.$t('MODULE.K0007_BTN_YES'), // はい
        cancelButtonText: this.$t('MODULE.K0007_BTN_NO'), // キャンセル
        center: 'true'
      }).then(function () {
        _this19.kmAuto = '0.0';
        _this19.trainBusAuto = '0';
        _this19.kmPriceAuto = '0';
        _this19.transportFlag = '3';
        _this19.otherFieldFlag = '99';
        _this19.initiallyFieldFlag = '0';
        _this19.initiallyFieldCd = '';
        _this19.route = '';
        if (itemName === 'km' && _this19.km !== '') {
          _this19.kmPrice = utils.decimalFormatter(utils.tofixeds(Number(_this19.km.replace(/,/g, "")) * Number(_this19.transportTeate), 0).toString());
        }
      }).catch(function () {
        _this19.km = '0.0';
        _this19.trainBus = '0';
        _this19.kmPrice = '0';
      });
    }
  },
  // 初期化自动调用
  created: function created() {
    this.obj = JSON.parse(localStorage.getItem('obj'));
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.storePositionCd = this.obj.storePositionCd;
    this.crewCd = this.obj.crewCd;
    this.jobState = this.obj.jobStateCd;
    this.job_date = this.obj.jobDate;
    this.userCd = this.userInfo.userCd;
    // 勤怠承認FLAG
    this.approvalFlag = this.obj.approvalFlag;
    //add by hexy 20200921 start
    this.transmitFlag = this.obj.transmitFlag;
    //add by hexy 20200921 end
    this.searchStorePosition();

    // 初期化函数调用
    this.query();
  },
  mounted: function mounted() {
    //点击删除按钮之外的地方退出长按模式
    var that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.imageLongClick = false;
        that.parkingFeeLongClick = false; //是否为图片长按模式（true=长按模式）。
        that.roadFeeLongClick = false; //是否为图片长按模式（true=长按模式）。
        that.othersExpensesLongClick = false; //是否为图片长按模式（true=长按模式）。
        that.transportExpensesTripLongClick = false; //是否为图片长按模式（true=长按模式）。
        that.accommodationLongClick = false; //是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions' && e.target.className != 'el-icon-refresh-left' && e.target.className != 'el-icon-refresh-right' && e.target.className != 'el-icon-c-scale-to-original' && e.target.className != 'el-icon-zoom-in' && e.target.className != 'el-icon-zoom-out' && e.target.className != 'el-image-viewer__actions__inner' && e.target.className != 'el-icon-full-screen' && e.target.className != 'el-icon-circle-close' && e.target.className != 'el-button el-button--default el-button--small') {
        //关闭照片查看器
        that.parkingFeeDialog = false;
        that.roadFeeDialog = false;
        that.othersExpensesDialog = false;
        that.transportExpensesTripDialog = false;
        that.accommodationDialog = false;
      }
    });
  },

  watch: {
    //経路详细折叠面板控制
    route: function route(val) {
      if (this.isEmpty(val)) {
        this.activeCollapseName = '0';
        //return "1"
      } else {
        this.activeCollapseName = '1';
      }
    },
    //駐車代
    parkingFee: function parkingFee(val) {
      if (val != '' && val !== '0') {
        this.parkingFeeBtn = false;
        this.parkingFeeCss = true;
      } else {
        this.parkingFeeBtn = true;
        this.parkingFeeCss = false;
      }
    },
    //有料道路代
    roadFee: function roadFee(val) {
      if (val != '' && val !== '0') {
        this.roadFeeBtn = false;
        this.roadFeeCss = true;
      } else {
        this.roadFeeBtn = true;
        this.roadFeeCss = false;
      }
    },
    //消耗・通信・破損・運搬
    othersExpenses: function othersExpenses(val) {
      if (val != '' && val !== '0') {
        this.othersExpensesBtn = false;
        this.othersExpensesCss = true;
      } else {
        this.othersExpensesBtn = true;
        this.othersExpensesCss = false;
      }
    },
    //公共移動(出張)
    transportExpensesTrip: function transportExpensesTrip(val) {
      if (val != '' && val !== '0') {
        this.transportExpensesTripBtn = false;
        this.transportExpensesTripCss = true;
      } else {
        this.transportExpensesTripBtn = true;
        this.transportExpensesTripCss = false;
      }
    },
    //宿泊費
    accommodation: function accommodation(val) {
      if (val != '' && val !== '0') {
        this.accommodationBtn = false;
        this.accommodationCss = true;
      } else {
        this.accommodationBtn = true;
        this.accommodationCss = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e66a590","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/k_0007.vue
var k_0007_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_k0007"},[_c('div',{staticClass:"search-module_k0007"},[_c('el-row',[_c('el-col',{staticClass:"el-col_k0007",attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple c0007_readonly_input"},[_c('span',{staticClass:"span_search_condition_k0007 "},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_CORPORATION_NAME')))]),_vm._v(" "),_c('el-input',{staticClass:" css-input-width_k0007 ",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","disabled":true},model:{value:(_vm.company_name),callback:function ($$v) {_vm.company_name=$$v},expression:"company_name"}})],1)]),_vm._v(" "),_c('el-col',{staticClass:"el-col_k0007",attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple c0007_readonly_input"},[_c('span',{staticClass:"span_search_condition_k0007",attrs:{"size":"small"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_FIELDNAME')))]),_vm._v(" "),_c('el-input',{staticClass:"css-input-width_k0007",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","disabled":true},model:{value:(_vm.fieldName),callback:function ($$v) {_vm.fieldName=$$v},expression:"fieldName"}})],1)]),_vm._v(" "),_c('el-col',{staticClass:"el-col_k0007",attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple c0007_readonly_input"},[_c('span',{staticClass:"span_search_condition_k0007"},[_vm._v(_vm._s(_vm.$t('COMMON.LBL_WORKDAY')))]),_vm._v(" "),_c('el-input',{staticClass:"css-input-width_k0007 ",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","disabled":true},model:{value:(_vm.job_date),callback:function ($$v) {_vm.job_date=$$v},expression:"job_date"}})],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"el-detail_k0007"},[_c('el-row',[_c('div',{staticClass:"div_span_k0007_trasport"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRANSPORTEXPENSE_AUTO')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007_trasport"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRANSPORTFLAG')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_radio_k0007_trasport"},[_c('el-radio',{attrs:{"disabled":_vm.status1,"label":"4"},on:{"input":_vm.transportFlagChange},model:{value:(_vm.transportFlag),callback:function ($$v) {_vm.transportFlag=$$v},expression:"transportFlag"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRANSPORTFLAG_NO')))]),_vm._v(" "),_c('el-radio',{attrs:{"disabled":_vm.status1,"label":"2"},on:{"input":_vm.transportFlagChange},model:{value:(_vm.transportFlag),callback:function ($$v) {_vm.transportFlag=$$v},expression:"transportFlag"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRANSPORTFLAG_MYCAR')))]),_vm._v(" "),_c('el-radio',{attrs:{"disabled":_vm.status1,"label":"1"},on:{"input":_vm.transportFlagChange},model:{value:(_vm.transportFlag),callback:function ($$v) {_vm.transportFlag=$$v},expression:"transportFlag"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRANSPORTFLAG_BUS')))])],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_radio_k0007_trasport"},[_c('el-radio',{attrs:{"disabled":_vm.status1||_vm.disableTransportFlag(),"label":"0"},model:{value:(_vm.otherFieldFlag),callback:function ($$v) {_vm.otherFieldFlag=$$v},expression:"otherFieldFlag"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_OTHERFIELDFLAG_OK')))]),_vm._v(" "),_c('el-radio',{attrs:{"disabled":_vm.status1||_vm.disableTransportFlag(),"label":"1"},model:{value:(_vm.otherFieldFlag),callback:function ($$v) {_vm.otherFieldFlag=$$v},expression:"otherFieldFlag"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_OTHERFIELDFLAG_NO')))])],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007"},[_c('el-checkbox',{staticClass:"input_input1_k0007_trasport ",attrs:{"disabled":_vm.status1||_vm.disableTransportFlag(),"true-label":"1","false-label":"0"},on:{"change":_vm.initiallyFieldChange},model:{value:(_vm.initiallyFieldFlag),callback:function ($$v) {_vm.initiallyFieldFlag=$$v},expression:"initiallyFieldFlag"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_INITIALLYFIELDFLAG')))]),_vm._v(" "),_c('el-select',{staticClass:"input_input1_k0007 textRight",attrs:{"popper-class":"selectStyle","disabled":_vm.initiallyFieldFlag==0||_vm.status1||_vm.disableTransportFlag(),"placeholder":_vm.$t('COMMON.PLACEHOLDER_SELECT'),"filterable":""},on:{"change":function($event){return _vm.fieldListChange(_vm.initiallyFieldCd,'initiallyFieldCd')}},model:{value:(_vm.initiallyFieldCd),callback:function ($$v) {_vm.initiallyFieldCd=$$v},expression:"initiallyFieldCd"}},_vm._l((_vm.initiallyFieldList),function(item){return _c('el-option',{key:item.fieldCd,attrs:{"label":item.fieldName,"value":item.fieldCd}})}),1)],1)]),_vm._v(" "),_c('el-row',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"div_span_k0007_trasport",staticStyle:{"height":"50px","padding-top":"6px"}},[_c('el-button',{staticClass:"css-btn_green css-button_green",attrs:{"type":"primary","disabled":_vm.status1||_vm.disableTransportFlag()},on:{"click":_vm.transport_search_click}},[_vm._v(_vm._s(_vm.$t('COMMON.LBL_SEARCH')))])],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007_trasport"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRAINBUS')))]),_vm._v(" "),_c('span',{staticClass:"input_span2_k0007",staticStyle:{"padding":"3px 0px 0px 20px"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_CATEGORY_EXPENSE')))]),_vm._v(" "),_c('span',{staticClass:"input_span2_k0007",staticStyle:{"padding":"3px 0px 0px 5px"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_GAS_EXPENSE')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 ",class:{K0007_disable_input:true}},[_c('el-input',{staticClass:"input_input1_k0007 textRight ",class:{K0007_disable_input:true},attrs:{"disabled":true},model:{value:(_vm.trainBusAuto),callback:function ($$v) {_vm.trainBusAuto=$$v},expression:"trainBusAuto"}}),_vm._v(" "),_c('el-input',{staticClass:"input_input2_k0007 textRight",staticStyle:{"padding":"10px 0px 0px 20px"},attrs:{"disabled":true},model:{value:(_vm.kmAuto),callback:function ($$v) {_vm.kmAuto=$$v},expression:"kmAuto"}}),_vm._v(" "),_c('el-input',{staticClass:"input_input3_k0007 textRight ",class:{K0007_disable_input:true},staticStyle:{"padding":"10px 0px 0px 5px"},attrs:{"disabled":true},model:{value:(_vm.kmPriceAuto),callback:function ($$v) {_vm.kmPriceAuto=$$v},expression:"kmPriceAuto"}})],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_collapse_k0007_trasport"},[_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeCollapseName),callback:function ($$v) {_vm.activeCollapseName=$$v},expression:"activeCollapseName"}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_ROUTE')))]),_vm._v(" "),_c('span',{staticClass:"multiline"},[_vm._v(_vm._s(_vm.route))])],2)],1)],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRANSPORTEXPENSE_MANUAL')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRAINBUS')))]),_vm._v(" "),_c('span',{staticClass:"input_span2_k0007",staticStyle:{"padding":"3px 0px 0px 20px"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_CATEGORY_EXPENSE')))]),_vm._v(" "),_c('span',{staticClass:"input_span2_k0007",staticStyle:{"padding":"3px 0px 0px 5px"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0002_LBL_GAS_EXPENSE')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 ",class:{K0007_disable_input:_vm.status1}},[_c('el-input',{staticClass:"input_input1_k0007 textRight ",attrs:{"maxlength":"8","pattern":"\\d*","disabled":_vm.status1},on:{"focus":function($event){return _vm.focusInput(_vm.trainBus,'trainBus')},"input":function($event){return _vm.inputChange()},"blur":function($event){_vm.blurInput(_vm.trainBus,'trainBus',_vm.$t('MODULE.K0007_LBL_TRAINBUS'))}},model:{value:(_vm.trainBus),callback:function ($$v) {_vm.trainBus=$$v},expression:"trainBus"}}),_vm._v(" "),_c('el-input',{staticClass:"input_input2_k0007 textRight",staticStyle:{"padding":"10px 0px 0px 20px"},attrs:{"maxlength":"8","disabled":_vm.status1},on:{"focus":function($event){return _vm.focusInput(_vm.km,'km')},"input":function($event){return _vm.inputChange()},"blur":function($event){_vm.blurInput(_vm.km,'km',_vm.$t('MODULE.K0007_LBL_KMPRICE'))}},model:{value:(_vm.km),callback:function ($$v) {_vm.km=$$v},expression:"km"}}),_vm._v(" "),_c('el-input',{staticClass:"input_input3_k0007 textRight ",class:{K0007_disable_input:true},staticStyle:{"padding":"10px 0px 0px 5px"},attrs:{"disabled":true},model:{value:(_vm.kmPrice),callback:function ($$v) {_vm.kmPrice=$$v},expression:"kmPrice"}})],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007 "},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_PARKINGFEE')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_RECEIPTPHOTO')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 ",class:{K0007_disable_input:_vm.status1}},[_c('el-input',{ref:"parkingFee",staticClass:"input_input1_k0007 textRight",attrs:{"maxlength":"8","pattern":"\\d*","disabled":_vm.status1},on:{"focus":function($event){return _vm.focusInput(_vm.parkingFee,'parkingFee')},"input":function($event){return _vm.inputChange()},"blur":function($event){_vm.blurInput(_vm.parkingFee,'parkingFee',_vm.$t('MODULE.K0007_LBL_PARKINGFEE'))}},model:{value:(_vm.parkingFee),callback:function ($$v) {_vm.parkingFee=$$v},expression:"parkingFee"}}),_vm._v(" "),(!_vm.parkingFeeUrl)?_c('div',{staticClass:"k0007-photo-border",class:{'parkingFeeCss': _vm.parkingFeeCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"parkingFee",staticClass:"photo_upload",attrs:{"show-file-list":true,"file-list":_vm.parkingFeeImageList,"disabled":_vm.parkingFeeBtn,"list-type":"picture-card","limit":2,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'parkingFee','1')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"parkingFeeImg","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'parkingFee')}}},[(_vm.parkingFeeLongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'parkingFee','1')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.parkingFeeDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.parkingFeePhotoDelete,"url-list":[_vm.parkingFeeUrl]}}):_vm._e()],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_ROADFEE')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_RECEIPTPHOTO')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 ",class:{K0007_disable_input:_vm.status1}},[_c('el-input',{staticClass:"input_input1_k0007 textRight",attrs:{"maxlength":"8","pattern":"\\d*","disabled":_vm.status1},on:{"focus":function($event){return _vm.focusInput(_vm.roadFee,'roadFee')},"input":function($event){return _vm.inputChange()},"blur":function($event){_vm.blurInput(_vm.roadFee,'roadFee',_vm.$t('MODULE.K0007_LBL_ROADFEE'))}},model:{value:(_vm.roadFee),callback:function ($$v) {_vm.roadFee=$$v},expression:"roadFee"}}),_vm._v(" "),(!_vm.roadFeeUrl)?_c('div',{staticClass:"k0007-photo-border",class:{'roadFeeCss': _vm.roadFeeCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"roadFee",staticClass:"photo_upload",attrs:{"show-file-list":true,"file-list":_vm.roadFeeImageList,"disabled":_vm.roadFeeBtn,"list-type":"picture-card","limit":2,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'roadFee','2')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'roadFee')}}},[(_vm.roadFeeLongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'roadFee','2')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.roadFeeDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.roadFeePhotoDelete,"url-list":[_vm.roadFeeUrl]}}):_vm._e()],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_MOVEALLOWANCE')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_DRIVERALLOWANCE')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 ",class:{K0007_disable_input:_vm.status1}},[_c('el-select',{staticClass:"input_input1_k0007 textRight",attrs:{"popper-class":"selectStyle","disabled":_vm.status1,"placeholder":_vm.$t('COMMON.PLACEHOLDER_SELECT')},on:{"change":function($event){_vm.expensesChange(_vm.moveAllowance,'moveAllowance',_vm.$t('MODULE.K0007_LBL_MOVEALLOWANCE'))},"blur":function($event){return _vm.calculateExpenses()}},model:{value:(_vm.moveAllowance),callback:function ($$v) {_vm.moveAllowance=$$v},expression:"moveAllowance"}},_vm._l((_vm.moveAllowanceList),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.value}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.note))]),_vm._v("      \n              "),_c('span',{staticStyle:{"float":"right","font-size":"13px"}},[_vm._v(_vm._s(item.value))])])}),1),_vm._v(" "),_c('el-select',{ref:"input",staticClass:"input_input1_k0007 textRight",attrs:{"popper-class":"selectStyle","maxlength":"8","disabled":true,"placeholder":_vm.$t('COMMON.PLACEHOLDER_SELECT')},on:{"change":function($event){_vm.expensesChange(_vm.driverAllowance,'driverAllowance',_vm.$t('MODULE.K0007_LBL_DRIVERALLOWANCE'))},"blur":function($event){return _vm.calculateExpenses()}},model:{value:(_vm.driverAllowance),callback:function ($$v) {_vm.driverAllowance=$$v},expression:"driverAllowance"}},_vm._l((_vm.driverAllowanceList),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.value}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.note))]),_vm._v("      \n              "),_c('span',{staticStyle:{"float":"right","font-size":"13px"}},[_vm._v(_vm._s(item.value))])])}),1)],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_OTHERSEXPENSES')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_RECEIPTPHOTO')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 ",class:{K0007_disable_input:_vm.status1}},[_c('el-input',{staticClass:"input_input1_k0007 textRight",attrs:{"maxlength":"8","pattern":"\\d*","disabled":_vm.status1},on:{"focus":function($event){return _vm.focusInput(_vm.othersExpenses,'othersExpenses')},"input":function($event){return _vm.inputChange()},"blur":function($event){_vm.blurInput(_vm.othersExpenses,'othersExpenses',_vm.$t('MODULE.K0007_LBL_OTHERSEXPENSES'))}},model:{value:(_vm.othersExpenses),callback:function ($$v) {_vm.othersExpenses=$$v},expression:"othersExpenses"}}),_vm._v(" "),(!_vm.othersExpensesUrl)?_c('div',{staticClass:"k0007-photo-border",class:{'othersExpensesCss': _vm.othersExpensesCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"othersExpenses",staticClass:"photo_upload",attrs:{"show-file-list":true,"file-list":_vm.othersExpensesImageList,"disabled":_vm.othersExpensesBtn,"list-type":"picture-card","limit":2,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'othersExpenses','3')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'othersExpenses')}}},[(_vm.othersExpensesLongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'othersExpenses','3')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.othersExpensesDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.othersExpensesPhotoDelete,"url-list":[_vm.othersExpensesUrl]}}):_vm._e()],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRANSPORTEXPENSESTRIP')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_RECEIPTPHOTO')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 ",class:{K0007_disable_input:_vm.status1}},[_c('el-input',{staticClass:"input_input1_k0007 textRight",attrs:{"id":"transportExpensesTrip","maxlength":"8","pattern":"\\d*","disabled":_vm.status1},on:{"input":function($event){return _vm.inputChange()},"focus":function($event){return _vm.focusInput(_vm.transportExpensesTrip,'transportExpensesTrip')},"blur":function($event){_vm.blurInput(_vm.transportExpensesTrip,'transportExpensesTrip',_vm.$t('MODULE.K0007_LBL_TRANSPORTEXPENSESTRIP'))}},model:{value:(_vm.transportExpensesTrip),callback:function ($$v) {_vm.transportExpensesTrip=$$v},expression:"transportExpensesTrip"}}),_vm._v(" "),(!_vm.transportExpensesTripUrl)?_c('div',{staticClass:"k0007-photo-border",class:{'transportExpensesTripCss': _vm.transportExpensesTripCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"transportExpensesTrip",staticClass:"photo_upload",attrs:{"show-file-list":true,"file-list":_vm.transportExpensesTripImageList,"disabled":_vm.transportExpensesTripBtn,"list-type":"picture-card","limit":2,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'transportExpensesTrip','4')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'transportExpensesTrip')}}},[(_vm.transportExpensesTripLongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'transportExpensesTrip','4')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.transportExpensesTripDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.transportExpensesTripPhotoDelete,"url-list":[_vm.transportExpensesTripUrl]}}):_vm._e()],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_ACCOMMODATION')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_RECEIPTPHOTO')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 ",class:{K0007_disable_input:_vm.status1}},[_c('el-input',{staticClass:"input_input1_k0007 textRight",attrs:{"id":"accommodation","maxlength":"8","pattern":"\\d*","disabled":_vm.status1},on:{"focus":function($event){return _vm.focusInput(_vm.accommodation,'accommodation')},"blur":function($event){_vm.blurInput(_vm.accommodation,'accommodation',_vm.$t('MODULE.K0007_LBL_ACCOMMODATION'))}},model:{value:(_vm.accommodation),callback:function ($$v) {_vm.accommodation=$$v},expression:"accommodation"}}),_vm._v(" "),(!_vm.accommodationUrl)?_c('div',{staticClass:"k0007-photo-border",class:{'accommodationCss': _vm.accommodationCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"accommodation",staticClass:"photo_upload",attrs:{"show-file-list":true,"file-list":_vm.accommodationImageList,"disabled":_vm.accommodationBtn,"list-type":"picture-card","limit":2,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'accommodation','5')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'accommodation')}}},[(_vm.accommodationLongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'accommodation','5')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.accommodationDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.accommodationPhotoDelete,"url-list":[_vm.accommodationUrl]}}):_vm._e()],1)]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_k0007"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_ALLOWANCETRIP')))]),_vm._v(" "),_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TRIPALLOWANCEMANAGER')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_input_k0007 "},[_c('el-select',{staticClass:"input_input1_k0007 textRight",class:{K0007_disable_input:_vm.status1},attrs:{"id":"allowanceTrip","disabled":_vm.status1,"popper-class":"selectStyle","placeholder":_vm.$t('COMMON.PLACEHOLDER_SELECT')},on:{"change":function($event){_vm.expensesChange(_vm.allowanceTrip,'allowanceTrip',_vm.$t('MODULE.K0007_LBL_ALLOWANCETRIP'))},"blur":function($event){return _vm.calculateExpenses()}},model:{value:(_vm.allowanceTrip),callback:function ($$v) {_vm.allowanceTrip=$$v},expression:"allowanceTrip"}},_vm._l((_vm.allowanceTripList),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.value}})}),1),_vm._v(" "),_c('el-select',{staticClass:"input_input1_k0007 textRight",class:{K0007_disable_input:_vm.status1},attrs:{"id":"tripAllowanceManager","disabled":_vm.tripAllowanceStatus,"popper-class":"selectStyle","placeholder":_vm.$t('COMMON.PLACEHOLDER_SELECT')},on:{"change":function($event){_vm.expensesChange(_vm.tripAllowanceManager,'tripAllowanceManager',_vm.$t('MODULE.k0007_LBL_TRIPALLOWANCEMANAGER'))},"blur":function($event){return _vm.calculateExpenses()}},model:{value:(_vm.tripAllowanceManager),callback:function ($$v) {_vm.tripAllowanceManager=$$v},expression:"tripAllowanceManager"}},_vm._l((_vm.tripAllowanceManagerList),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('el-row',{attrs:{"gutter":2}},[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"div_span_k0007_total"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_ACTUALCOSTTOTAL')))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"div_span_k0007_total"},[_c('span',{staticClass:"input_span_k0007"},[_vm._v(_vm._s(_vm.$t('MODULE.K0007_LBL_TOTAL')))])])])],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":2}},[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"div_input_k0007 "},[_c('el-input',{staticClass:"input_input1_k0007_total textRight",attrs:{"id":"actualCostTotal","disabled":true},model:{value:(_vm.actualCostTotal),callback:function ($$v) {_vm.actualCostTotal=$$v},expression:"actualCostTotal"}})],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"div_input_k0007 "},[_c('el-input',{staticClass:"input_input1_k0007_total textRight",attrs:{"id":"total","disabled":true},model:{value:(_vm.total),callback:function ($$v) {_vm.total=$$v},expression:"total"}})],1)])],1)],1),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.status2)),expression:"!(status2)"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.save_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_SAVE')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))])],1)],1)])])}
var k_0007_staticRenderFns = []
var k_0007_esExports = { render: k_0007_render, staticRenderFns: k_0007_staticRenderFns }
/* harmony default export */ var module_page_k_0007 = (k_0007_esExports);
// CONCATENATED MODULE: ./src/module/page/k_0007.vue
function k_0007_injectStyle (ssrContext) {
  __webpack_require__("S8+E")
}
var k_0007_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var k_0007___vue_template_functional__ = false
/* styles */
var k_0007___vue_styles__ = k_0007_injectStyle
/* scopeId */
var k_0007___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var k_0007___vue_module_identifier__ = null
var k_0007_Component = k_0007_normalizeComponent(
  page_k_0007,
  module_page_k_0007,
  k_0007___vue_template_functional__,
  k_0007___vue_styles__,
  k_0007___vue_scopeId__,
  k_0007___vue_module_identifier__
)

/* harmony default export */ var src_module_page_k_0007 = (k_0007_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0001.js



var i_0001_apiUrl = __webpack_require__("kspH");
// スタッフ基本情報申請検索
var i_0001_i_0001_query = function i_0001_query(userCd) {
  return api_public.requestQuickGet(i_0001_apiUrl.apiUrl_BasicStaffInfo + '?userId=' + userCd);
};
// スタッフ基本情報申請保存
var i_0001_i_0001_update = function i_0001_update(params, userCd) {
  return api_public.requestPost(i_0001_apiUrl.apiUrl_BasicStaffInfo + '?userCd=' + userCd, params);
};
//最寄り駅/最寄りバス停
var i_0001_requestEkiStationGet = function requestEkiStationGet(params, type) {
  if (type == "station") {
    return api_public.requestGet('/expcgi/?val_htmb=jcgi_station&val_sttypefilter=0000001&val_in_name=' + params);
  } else if (type == "bus") {
    return api_public.requestGet('/expcgi/?val_htmb=jcgi_busstop&val_sttypefilter=1101100&val_in_name=' + params);
  }
};
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/components/api/dialogAddress.js



var dialogAddress_apiUrl = __webpack_require__("kspH");
// 共通住所ポップ页面列表
var dialogAddress_dialogApi = function dialogApi(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(dialogAddress_apiUrl.apiUrl_AddressData + '?' + querys);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/dialogAddress.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var dialogAddress_url = __webpack_require__("kspH");
/* harmony default export */ var dialogAddress = ({
  mixins: [css],
  name: '',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mainpostcode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      tableheight: '' + document.documentElement.clientHeight,
      x: 0,
      y: 0,
      node: null,
      isCanMove: false,
      code: '',
      name: '',
      total: 0, //总记录数
      params: {
        page: 1, //当前页码
        size: 10 //每页显示个数
      },
      options: [{
        value: 10,
        size: '10'
      }, {
        value: 20,
        size: '20'
      }, {
        value: 30,
        size: '30'
      }, {
        value: 40,
        size: '40'
      }],
      //TableList
      dialogTableData: [],
      //都道府県リスト
      todofukenList: [],
      //市区町村リスト
      shikuchosonList: [],
      //大字町丁目リスト
      oazamachiChomeList: [],
      oazamachiChomeListCopy: [],
      //番地リスト
      addressBanchiList: [],
      //都道府県
      todofuken: '',
      //市区町村
      shikuchoson: '',
      //大字町丁目
      oazamachiChome: '',
      //番地
      addressBanch: '',
      cityId: '',
      oazamachiChomId: '',
      queryButtonDisabled: true,
      clearableShow: false
    };
  },
  mounted: function mounted() {
    //表格高度随着窗口大小而改变
    var that = this;
    window.onresize = function () {
      that.tableheight = '' + document.documentElement.clientHeight;
      that.tableheight = parseInt(that.tableheight) - 340;
    };
  },
  created: function created() {
    var _this = this;

    //表格高度随着窗口大小而改变
    this.tableheight = '' + document.documentElement.clientHeight;
    this.tableheight = parseInt(this.tableheight) - 340;

    var queryParams = {};
    queryParams.postCode = this.mainpostcode;
    queryParams.processDiv = "0";

    //调用服务端接口
    dialogAddress_dialogApi(queryParams).then(function (res) {
      if (res.code == 204) {
        _this.todofukenList = res.items.stateSet;
        if (res.items.stateDisp != "" && res.items.stateDisp != null) {
          _this.todofuken = res.items.stateDisp.stateCD;
        }
        _this.shikuchosonList = res.items.citySet;
        if (res.items.cityDisp != "" && res.items.cityDisp != null) {
          _this.shikuchoson = res.items.cityDisp.cityOnlyId;
          //大字町丁目赋值_町域名
          _this.oazamachiChome = res.items.cityDisp.townName;
        }
        _this.oazamachiChomeList = res.items.oazamachiChomeSet;
        //备份初始化的大字町丁目リスト
        _this.oazamachiChomeListCopy = JSON.parse(stringify_default()(_this.oazamachiChomeList));
        if (_this.oazamachiChome != "" && _this.oazamachiChome != null) {
          //大字町丁目赋值后筛选
          _this.oazamachiChomeListFilter(_this.oazamachiChome);
          //弹出大字町丁目下拉列表
          _this.$refs.oazamachiChomeListRef.toggleMenu();
        }
      }
    }).catch(function (err) {});
  },

  watch: {
    //监听下拉列表
    oazamachiChome: function oazamachiChome(value) {
      if (value != "" && value != null && this.oazamachiChomId != "" && this.oazamachiChomId != null) {
        this.queryButtonDisabled = false;
      } else {
        this.queryButtonDisabled = true;
      }
    }
  },
  methods: defineProperty_default()({
    // el-select_ios对应:失去焦点
    onblur: function onblur() {
      var _this2 = this;

      setTimeout(function () {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          _this2.$refs.select.blur();
        }
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },

    //el-select_ios对应:取消只读
    cancalReadOnly: function cancalReadOnly(onOff) {
      var _this3 = this;

      this.$nextTick(function () {
        if (onOff) {
          _this3.clearableShow = true;
        }
        if (!onOff) {
          var select = _this3.$refs.select;

          var input = select.$el.querySelector('.el-input__inner');
          input.removeAttribute('readonly');
          _this3.clearableShow = false;
        }
      });
    },

    //判断TABLE单元格样式
    isCellStyle: function isCellStyle(_ref) {
      var row = _ref.row,
          colum = _ref.colum,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (columnIndex > 0) {
        return this.dialogCellStyle_left();
      }
    },

    //分页
    handleSizeChange: function handleSizeChange(size) {
      this.params.size = size;
    },

    // 改变当前页并刷新页面
    handleCurrentChange: function handleCurrentChange(page) {
      this.params.page = page;
      this.query();
    },
    pageChanged: function pageChanged() {
      this.params.page = 1;
      this.query();
    },

    //住所検索
    query_address: function query_address() {
      this.params.page = 1;
      this.query();
    },
    query: function query() {
      var _this4 = this;

      this.params.postCode = this.mainpostcode;
      this.params.stateCD = this.todofuken;
      this.params.cityCD = this.cityId;
      this.params.oazamachiChomeCd = this.oazamachiChomId;
      this.params.addressBanchiCd = this.addressBanch;
      this.params.cityOnlyId = this.shikuchoson;
      this.params.oazamachiChomOnlyId = this.oazamachiChome;

      this.params.processDiv = "4";

      //调用服务端接口
      dialogAddress_dialogApi(this.params).then(function (res) {
        if (res.code == 204) {
          //将res结果数据赋值给数据模型对象
          if (_this4.params.page == 1) {
            _this4.total = res.total;
          }
          //TableList
          _this4.dialogTableData = res.items.addressSet;
          //住所1⇒都道府県＋市区町村＋大字町丁目＋番地												
          for (var i = 0; i < _this4.dialogTableData.length; i++) {
            _this4.dialogTableData[i].address1 = _this4.dialogTableData[i].stateName + _this4.dialogTableData[i].cityName + _this4.dialogTableData[i].oazamachiChomName + _this4.dialogTableData[i].addressBanchi;
          }
        } else if (res.code == 300) {
          _this4.dialogTableData = [];
          _this4.$message.warning({ message: _this4.$t('COMMON.NO_TARGET_DATA'), showClose: true });
        }
      }).catch(function (err) {});
    },

    //都道府県切替
    selectTodofukenList: function selectTodofukenList(val) {
      var _this5 = this;

      if (val != "") {
        var queryParams = {};
        queryParams.stateCD = val;
        queryParams.processDiv = "1";

        //调用服务端接口
        dialogAddress_dialogApi(queryParams).then(function (res) {
          if (res.code == 204) {
            _this5.shikuchosonList = res.items.citySet;
          }
          _this5.shikuchoson = "";
          _this5.oazamachiChome = "";
          _this5.addressBanch = "";
          _this5.oazamachiChomeList = [];
          _this5.addressBanchiList = [];
          _this5.dialogTableData = [];
        }).catch(function (err) {});
      } else {
        this.shikuchoson = "";
        this.oazamachiChome = "";
        this.addressBanch = "";
        this.shikuchosonList = [];
        this.oazamachiChomeList = [];
        this.addressBanchiList = [];
        this.dialogTableData = [];
      }
    },

    //市区町村切替
    selectShikuchosonList: function selectShikuchosonList(val) {
      var _this6 = this;

      if (val != "") {
        var queryParams = {};
        queryParams.cityOnlyId = val;
        queryParams.processDiv = "2";

        var obj = {};
        obj = this.shikuchosonList.find(function (item) {
          return item.cityOnlyId === val;
        });

        queryParams.cityCD = obj.cityCD;
        this.cityId = obj.cityCD;

        //调用服务端接口
        dialogAddress_dialogApi(queryParams).then(function (res) {
          if (res.code == 204) {
            _this6.oazamachiChomeList = res.items.oazamachiChomeSet;
          }
          _this6.oazamachiChome = "";
          _this6.addressBanch = "";
          _this6.addressBanchiList = [];
          _this6.dialogTableData = [];
        }).catch(function (err) {});
      } else {
        this.oazamachiChome = "";
        this.addressBanch = "";
        this.oazamachiChomeList = [];
        this.addressBanchiList = [];
        this.dialogTableData = [];
      }
    },

    //大字町丁目切替
    selectOazamachiChomeList: function selectOazamachiChomeList(val) {
      var _this7 = this;

      if (val != "") {
        var queryParams = {};
        queryParams.oazamachiChomOnlyId = val;
        queryParams.processDiv = "3";

        var obj = {};
        obj = this.oazamachiChomeList.find(function (item) {
          return item.oazamachiChomOnlyId === val;
        });

        queryParams.oazamachiChomeCd = obj.oazamachiChomCD;
        this.oazamachiChomId = obj.oazamachiChomCD;

        //调用服务端接口
        dialogAddress_dialogApi(queryParams).then(function (res) {
          if (res.code == 204) {
            _this7.addressBanchiList = res.items.addressBanchiSet;
          }
          _this7.addressBanch = "";
          _this7.dialogTableData = [];
        }).catch(function (err) {});
      } else {
        this.addressBanch = "";
        this.addressBanchiList = [];
        this.dialogTableData = [];
        this.oazamachiChomeList = this.oazamachiChomeListCopy;
      }
    },

    //番地切替
    selectAddressBanchiList: function selectAddressBanchiList(val) {
      this.params.page = 1;
      this.query();
    },

    //过滤大字町丁目
    oazamachiChomeListFilter: function oazamachiChomeListFilter(val) {
      if (val) {
        var value = val.toUpperCase();
        this.oazamachiChomeList = this.oazamachiChomeListCopy.filter(function (item) {
          if (item.oazamachiChomCD != null) {
            if (item.oazamachiChomCD.indexOf(value) > -1 || item.oazamachiChomName.indexOf(value) > -1) {
              return true;
            }
          }
        });
      } else {
        this.oazamachiChomeList = this.oazamachiChomeListCopy;
      }
    },
    closeDialog: function closeDialog() {
      this.dialogTableData = [];
      this.$emit('closeAddressDialog');
    },
    onClickSelIcon: function onClickSelIcon(row) {
      for (var key in row) {
        if (row[key] == null) {
          row[key] = "";
        }
      }
      this.dialogTableData = [];
      this.$emit('submitAddressDialog', row);
    },
    dialogHeaderStyle: function dialogHeaderStyle() {
      return 'fontSize:13px;background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);';
    }
  }, 'isCellStyle', function isCellStyle() {
    return 'fontSize:12px;';
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44cad026","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/dialogAddress.vue
var dialogAddress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%","width":"100%"}},[_c('div',{staticClass:"modal-container-address",staticStyle:{"height":"100%","width":"100%","background":"white"}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticStyle:{"width":"100%","font-size":"15px"}},[_vm._v(_vm._s(_vm.$t('MODULE.DIALOG_LBL_ADDRESS_CONDITIONS')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"},attrs:{"align":"right"}},[_c('el-button',{staticClass:"el-icon-close",staticStyle:{"color":"white"},attrs:{"type":"text","circle":""},on:{"click":_vm.closeDialog}})],1)]),_vm._v(" "),_c('div',{staticClass:"dialog-select-address"},[_c('el-row',{staticClass:"el-row-dialog-address"},[_c('el-col',{staticClass:"el-row-dialog-address",attrs:{"span":6}},[_c('div',{staticStyle:{"padding-left":"13px"},attrs:{"align":"left"}},[_c('span',{staticStyle:{"font-size":"10pt"}},[_vm._v(_vm._s(_vm.$t('MODULE.DIALOG_LBL_STATE'))+"  ")]),_vm._v(" "),_c('el-select',{staticClass:"css-input-box-shadow css-dialog-input-width",attrs:{"size":"small","clearable":""},on:{"change":function($event){return _vm.selectTodofukenList($event)}},model:{value:(_vm.todofuken),callback:function ($$v) {_vm.todofuken=$$v},expression:"todofuken"}},_vm._l((_vm.todofukenList),function(item){return _c('el-option',{key:item.stateCD,attrs:{"label":item.stateName,"value":item.stateCD}})}),1)],1)])],1),_vm._v(" "),_c('el-row',{staticClass:"el-row-dialog-address"},[_c('el-col',{staticClass:"el-row-dialog-address",attrs:{"span":6}},[_c('div',{staticStyle:{"padding-left":"13px"},attrs:{"align":"left"}},[_c('span',{staticStyle:{"font-size":"10pt"}},[_vm._v(_vm._s(_vm.$t('MODULE.DIALOG_LBL_CITY'))+"  ")]),_vm._v(" "),_c('el-select',{staticClass:"css-input-box-shadow css-dialog-input-width",attrs:{"filterable":"","size":"small","clearable":""},on:{"change":function($event){return _vm.selectShikuchosonList($event)}},model:{value:(_vm.shikuchoson),callback:function ($$v) {_vm.shikuchoson=$$v},expression:"shikuchoson"}},_vm._l((_vm.shikuchosonList),function(item){return _c('el-option',{key:item.cityOnlyId,attrs:{"label":item.cityName,"value":item.cityOnlyId}})}),1)],1)])],1),_vm._v(" "),_c('el-row',{staticClass:"el-row-dialog-address"},[_c('el-col',{staticClass:"el-row-dialog-address",attrs:{"span":6}},[_c('div',{attrs:{"align":"left"}},[_c('span',{staticStyle:{"font-size":"10pt"}},[_vm._v(_vm._s(_vm.$t('MODULE.DIALOG_LBL_OAZAMA_CHICHOME'))+"  ")]),_vm._v(" "),_c('el-select',{ref:"oazamachiChomeListRef",staticClass:"css-input-box-shadow css-dialog-input-width",attrs:{"filterable":"","size":"small","clearable":""},on:{"change":function($event){return _vm.selectOazamachiChomeList($event)}},model:{value:(_vm.oazamachiChome),callback:function ($$v) {_vm.oazamachiChome=$$v},expression:"oazamachiChome"}},_vm._l((_vm.oazamachiChomeList),function(item){return _c('el-option',{key:item.oazamachiChomOnlyId,attrs:{"label":item.oazamachiChomName,"value":item.oazamachiChomOnlyId}})}),1)],1)])],1),_vm._v(" "),_c('el-row',{staticClass:"el-row-dialog-address"},[_c('el-col',{staticClass:"el-row-dialog-address",attrs:{"span":6}},[_c('div',{staticStyle:{"padding-left":"40px"},attrs:{"align":"left"}},[_c('span',{staticStyle:{"font-size":"10pt"}},[_vm._v(_vm._s(_vm.$t('MODULE.DIALOG_LBL_ADDRESS_BANCHI'))+"  ")]),_vm._v(" "),_c('el-select',{ref:"select",staticClass:"css-input-box-shadow css-dialog-input-width",attrs:{"filterable":"","size":"small","popper-class":"select-down","popper-append-to-body:false":"","clearable":_vm.clearableShow},on:{"hook:mounted":_vm.cancalReadOnly,"visible-change":_vm.cancalReadOnly,"change":function($event){return _vm.selectAddressBanchiList($event)}},nativeOn:{"!blur":function($event){return _vm.onblur.apply(null, arguments)}},model:{value:(_vm.addressBanch),callback:function ($$v) {_vm.addressBanch=$$v},expression:"addressBanch"}},_vm._l((_vm.addressBanchiList),function(item){return _c('el-option',{key:item.addressBanchiCd,attrs:{"label":item.addressBanchiName,"value":item.addressBanchiCd}})}),1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"5px","padding-bottom":"10px","padding-left":"100px"}},[_c('el-button',{staticClass:"css-button css-btn",staticStyle:{"margin-left":"90px","width":"40%","height":"35px"},attrs:{"type":"primary","disabled":_vm.queryButtonDisabled,"size":"mini"},on:{"click":_vm.query_address}},[_vm._v(_vm._s(_vm.$t('COMMON.LBL_SEARCH')))])],1)],1),_vm._v(" "),_c('el-table',{attrs:{"height":_vm.tableheight,"data":_vm.dialogTableData,"header-cell-style":_vm.dialogHeaderStyle,"cell-style":_vm.isCellStyle,"stripe":"","border":"","size":"mini"}},[_c('el-table-column',{attrs:{"prop":"kselect","label":_vm.$t('MODULE.DIALOG_TBL_CHOOSE'),"width":"50%","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('i',{staticClass:"el-icon-collection",on:{"click":function($event){return _vm.onClickSelIcon(props.row)}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stateName","label":_vm.$t('MODULE.DIALOG_LBL_STATE'),"width":"","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cityName","label":_vm.$t('MODULE.DIALOG_LBL_CITY'),"width":"","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"oazamachiChomName","label":_vm.$t('MODULE.DIALOG_LBL_OAZAMA_CHICHOME'),"width":"90px","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"addressBanchi","label":_vm.$t('MODULE.DIALOG_LBL_ADDRESS_BANCHI'),"width":"","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"latitude","label":_vm.$t('MODULE.DIALOG_LBL_LATITUDE'),"width":"90px","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"longitude","label":_vm.$t('MODULE.DIALOG_LBL_LONGITUDE'),"width":"90px","align":"center"}}),_vm._v(" "),(false)?_c('el-table-column',{attrs:{"prop":"address1","width":"","align":"center"}}):_vm._e()],1),_vm._v(" "),_c('el-row',{staticClass:"pagination-row-address"},[_c('el-pagination',{staticClass:"pagination-page-address",attrs:{"background":"","small":"","current-page":_vm.params.page,"page-size":_vm.params.size,"layout":" prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-row',{staticClass:"pagination-row-address"},[_c('span',{staticClass:"total-pages-address"},[_vm._v(_vm._s(_vm.$t('MODULE.DIALOG_LBL_TOTAL'))+_vm._s(_vm.total)+_vm._s(_vm.$t('MODULE.DIALOG_LBL_TOTAL_PIECE'))+"  ")]),_vm._v(" "),_c('span',{staticClass:"total-pages-address"},[_vm._v(_vm._s(_vm.$t('MODULE.DIALOG_LBL_TOTAL_PAGE'))+"  ")]),_vm._v(" "),_c('el-select',{staticClass:"pagination-select-address",attrs:{"size":"mini","placeholder":""},on:{"change":_vm.pageChanged},model:{value:(_vm.params.size),callback:function ($$v) {_vm.$set(_vm.params, "size", $$v)},expression:"params.size"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)])}
var dialogAddress_staticRenderFns = []
var dialogAddress_esExports = { render: dialogAddress_render, staticRenderFns: dialogAddress_staticRenderFns }
/* harmony default export */ var page_dialogAddress = (dialogAddress_esExports);
// CONCATENATED MODULE: ./src/components/page/dialogAddress.vue
function dialogAddress_injectStyle (ssrContext) {
  __webpack_require__("AsIs")
}
var dialogAddress_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialogAddress___vue_template_functional__ = false
/* styles */
var dialogAddress___vue_styles__ = dialogAddress_injectStyle
/* scopeId */
var dialogAddress___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialogAddress___vue_module_identifier__ = null
var dialogAddress_Component = dialogAddress_normalizeComponent(
  dialogAddress,
  page_dialogAddress,
  dialogAddress___vue_template_functional__,
  dialogAddress___vue_styles__,
  dialogAddress___vue_scopeId__,
  dialogAddress___vue_module_identifier__
)

/* harmony default export */ var components_page_dialogAddress = (dialogAddress_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0001.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var i_0001_url = __webpack_require__("kspH");
/* harmony default export */ var i_0001 = ({
  mixins: [css],
  components: {
    "DialogAddress": components_page_dialogAddress
  },
  data: function data() {
    return {
      //スタッフCD
      staffCd: "",
      //氏名
      userName: "",
      //生年月日
      birthday: "",
      //性別
      gender: "",
      //郵便番号
      postCd1: "",
      postCd2: "",
      //住所1
      address1: "",
      //住所2
      address2: "",
      //住所3
      address3: "",
      //最寄り駅
      nearestStation: "",
      //最寄りバス停
      nearestStationBus: "",
      //携帯番号
      mobileNo1: "",
      mobileNo2: "",
      mobileNo3: "",
      //電話番号
      phoneNo1: "",
      phoneNo2: "",
      phoneNo3: "",
      //携帯メール
      mobileMail: "",
      //PCメール
      pcMail: "",
      //営業所
      salesOffice: "",
      //申請日時
      applyDate: "",
      //申請ステータス
      status: "",
      //ステータス名
      statusName: "",
      //申請番号
      id: "",
      //処理区分
      processCd: "",
      //確認日時
      confirmDate: "",
      //更新日時
      updateDate: "",
      //日時表示
      timeShow: "",
      userCd: "",
      showAddressDialog: false,
      //マイカー使用 0：無；1：有
      mycarUse: "",
      //郵便番号(住所取得ボタン用)
      addressPostCode: "",
      //緯度
      latitude: "",
      //経度
      longitude: "",
      //市区町村CD
      cityCD: ""
    };
  },
  created: function created() {
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    //検索
    this.query();
  },

  methods: {
    // 検索
    query: function query() {
      var _this = this;

      // loading处理
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
      // 検索処理
      i_0001_i_0001_query(this.userCd).then(function (res) {
        if (res.code == 204) {
          console.log(res);
          _this.staffCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
          _this.userName = res.items.selfDoc[0].userName;
          _this.birthday = res.items.selfDoc[0].birthday;
          _this.gender = res.items.selfDoc[0].gender;

          if (res.items.selfDoc[0].PostCd == null) {
            _this.postCd1 = "";
            _this.postCd2 = "";
          } else {
            _this.postCd1 = res.items.selfDoc[0].PostCd.split("-")[0];
            _this.postCd2 = res.items.selfDoc[0].PostCd.split("-")[1];
          }

          _this.address1 = res.items.selfDoc[0].address1;
          _this.address2 = res.items.selfDoc[0].address2;
          _this.address3 = res.items.selfDoc[0].address3;

          if (res.items.selfDoc[0].nearestStation == null) {
            _this.nearestStation = "";
          } else {
            _this.nearestStation = res.items.selfDoc[0].nearestStation;
          }

          if (res.items.selfDoc[0].nearestStationBus == null) {
            _this.nearestStationBus = "";
          } else {
            _this.nearestStationBus = res.items.selfDoc[0].nearestStationBus;
          }

          if (res.items.selfDoc[0].MobileNo == null) {
            _this.mobileNo1 = "";
            _this.mobileNo2 = "";
            _this.mobileNo3 = "";
          } else {
            _this.mobileNo1 = res.items.selfDoc[0].MobileNo.split("-")[0];
            _this.mobileNo2 = res.items.selfDoc[0].MobileNo.split("-")[1];
            _this.mobileNo3 = res.items.selfDoc[0].MobileNo.split("-")[2];
          }

          if (res.items.selfDoc[0].PhoneNo == null) {
            _this.phoneNo1 = "";
            _this.phoneNo2 = "";
            _this.phoneNo3 = "";
          } else {
            _this.phoneNo1 = res.items.selfDoc[0].PhoneNo.split("-")[0];
            _this.phoneNo2 = res.items.selfDoc[0].PhoneNo.split("-")[1];
            _this.phoneNo3 = res.items.selfDoc[0].PhoneNo.split("-")[2];
          }

          _this.mobileMail = res.items.selfDoc[0].mobileMail;
          _this.pcMail = res.items.selfDoc[0].pcMail;

          _this.salesOffice = res.items.selfDoc[0].salesOfficeName;

          _this.applyDate = res.items.selfDoc[0].applyDate;
          if (res.items.selfDoc[0].id == null) {
            _this.id = "";
          } else {
            _this.id = res.items.selfDoc[0].id;
          }

          _this.processCd = res.items.selfDoc[0].processCd;

          _this.status = res.items.selfDoc[0].status;
          _this.statusName = res.items.selfDoc[0].statusName;
          _this.confirmDate = res.items.selfDoc[0].confirmDate;
          _this.updateDate = res.items.selfDoc[0].updateDate;
          //マイカー使用
          _this.mycarUse = res.items.selfDoc[0].mycarUse;
          _this.cityCD = res.items.selfDoc[0].cityCd;
          _this.latitude = res.items.selfDoc[0].geoLocationLat;
          _this.longitude = res.items.selfDoc[0].geoLocationLng;
          // 処理区分が「1：更新」表示日時
          // ステータス取得
          // 「0」の場合 申請日時
          // 「1」or「2」の場合 確認日時
          if (_this.processCd == "1") {
            if (_this.status == "0") {
              _this.timeShow = utils.extractMillisecond(_this.applyDate);
            } else if (_this.status == "1" || _this.status == "2") {
              _this.timeShow = utils.extractMillisecond(_this.confirmDate);
            }
          }
        } else if (res.code === 300) {
          _this.loading.close();
          return;
        }
        _this.loading.close();
      }).catch(function () {
        _this.loading.close();
      });
    },

    // 申请
    apply_click: function apply_click() {
      var _this2 = this;

      if (this.postCd1 == null) {
        this.postCd1 = "";
      }
      if (this.postCd2 == null) {
        this.postCd2 = "";
      }
      if (this.address1 == null) {
        this.address1 = "";
      }
      if (this.nearestStation == null) {
        this.nearestStation = "";
      }
      if (this.nearestStationBus == null) {
        this.nearestStationBus = "";
      }
      if (this.mobileNo1 == null) {
        this.mobileNo1 = "";
      }
      if (this.mobileNo2 == null) {
        this.mobileNo2 = "";
      }
      if (this.mobileNo3 == null) {
        this.mobileNo3 = "";
      }
      if (this.phoneNo1 == null) {
        this.phoneNo1 = "";
      }
      if (this.phoneNo2 == null) {
        this.phoneNo2 = "";
      }
      if (this.phoneNo3 == null) {
        this.phoneNo3 = "";
      }
      if (this.mobileMail == null) {
        this.mobileMail = "";
      }
      if (this.pcMail == null) {
        this.pcMail = "";
      }
      if (this.cityCD == null) {
        this.cityCD = "";
      }

      //チェック処理
      //必須項目のいずれが入力されていない場合
      //郵便番号
      if (this.postCd1 + this.postCd2 == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_ZIPCODE')), showClose: true });
        return false;
      }

      //郵便番号桁数チェック
      if (this.postCd1.length != 3 || this.postCd2.length != 4) {
        this.$message.error({ message: this.$t('MODULE.DIALOG_MSG_POST_CODE_CHECK'), showClose: true });
        return false;
      }

      //住所1
      if (this.address1 == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0001_MSG_ADDRESS1')), showClose: true });
        return false;
      }

      //最寄り駅とも最寄りバス停両方入力していない場合
      if (this.nearestStation == "" && this.nearestStationBus == "") {
        this.$message.error({ message: this.$t('MODULE.I0001_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_NEAREST_STATION')).replace('{2}', this.$t('MODULE.I0001_LBL_NEAREST_STATION_BUS')), showClose: true });
        return false;
      }

      //携帯番号と電話番号両方入力していない場合
      if (this.mobileNo1 + this.mobileNo2 + this.mobileNo3 == "" && this.phoneNo1 + this.phoneNo2 + this.phoneNo3 == "") {
        this.$message.error({ message: this.$t('MODULE.I0001_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_TEL_NUMBER')).replace('{2}', this.$t('MODULE.I0001_LBL_HOME_NUMBER')), showClose: true });
        return false;
      }

      //携帯メールとPCメール両方入力していない場合
      if (this.mobileMail == "" && this.pcMail == "") {
        this.$message.error({ message: this.$t('MODULE.I0001_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_TEL_MAIL')).replace('{2}', this.$t('MODULE.I0001_LBL_PC_MAIL')), showClose: true });
        return false;
      }

      //携帯メールアドレス正確性チェック
      if (this.mobileMail != "") {
        var regu = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
        var re = new RegExp(regu);
        if (!re.test(this.mobileMail)) {
          this.$message.error({ message: this.$t('COMMON.MSG_ERROR_MAIL_ADDRESS'), showClose: true });
          return false;
        }
      }

      //PCメールアドレス正確性チェック
      if (this.pcMail != "") {
        var regu = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
        var re = new RegExp(regu);
        if (!re.test(this.pcMail)) {
          this.$message.error({ message: this.$t('COMMON.MSG_ERROR_MAIL_ADDRESS'), showClose: true });
          return false;
        }
      }

      //マイカー使用入力必須
      //del by chaiz 20240606 start
      // if (this.mycarUse == "" || this.mycarUse == null) {
      //   this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0001_LBL_MYCAR_USE')), showClose: true })
      //   return false
      // }
      //del by chaiz 20240606 end

      // データを保存します。よろしいでしょうか？
      // 「はい」を選択したら、下記の処理へ進む
      // 「いいえ」を選択したら、何もしない
      this.$confirm(this.$t('COMMON.MSG_CONFIRM_CHANGE'), this.$t('COMMON.CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //を選択します
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
        center: true
      }).then(function () {
        //はい
        var update_params = {};

        update_params.userCd = _this2.staffCd;
        update_params.postCd = _this2.postCd1 + "-" + _this2.postCd2;
        update_params.address1 = _this2.address1;
        if (_this2.address2 == null) {
          update_params.address2 = "";
        } else {
          update_params.address2 = _this2.address2;
        }

        if (_this2.address3 == null) {
          update_params.address3 = "";
        } else {
          update_params.address3 = _this2.address3;
        }

        update_params.nearestStation = _this2.nearestStation;
        update_params.nearestStationBus = _this2.nearestStationBus;
        if (_this2.mobileNo1 + _this2.mobileNo2 + _this2.mobileNo3 == "") {
          update_params.mobileNo = "";
        } else {
          update_params.mobileNo = _this2.mobileNo1 + "-" + _this2.mobileNo2 + "-" + _this2.mobileNo3;
        }
        if (_this2.phoneNo1 + _this2.phoneNo2 + _this2.phoneNo3 == "") {
          update_params.phoneNo = "";
        } else {
          update_params.phoneNo = _this2.phoneNo1 + "-" + _this2.phoneNo2 + "-" + _this2.phoneNo3;
        }
        update_params.mobileMail = _this2.mobileMail;
        update_params.pcMail = _this2.pcMail;

        update_params.processCd = _this2.processCd;

        if (_this2.processCd == "2") {
          update_params.updateDate = "";
          update_params.id = null;
        } else {
          update_params.updateDate = _this2.updateDate;
          update_params.id = _this2.id;
        }

        update_params.mycarUse = _this2.mycarUse;

        update_params.cityCd = _this2.cityCD;

        if (_this2.latitude != null && _this2.latitude != "") {
          update_params.geoLocationLat = Number(_this2.latitude);
        }
        if (_this2.longitude != null && _this2.longitude != "") {
          update_params.geoLocationLng = Number(_this2.longitude);
        }
        i_0001_i_0001_update(update_params, _this2.userCd).then(function (res) {
          if (res.code === 202) {
            _this2.$message.success({ message: _this2.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
            _this2.query();
          } else if (res.code === 308) {
            setTimeout(function () {
              _this2.$confirm(_this2.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                confirmButtonText: _this2.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
                cancelButtonText: _this2.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                center: true
              }).then(function () {
                _this2.query();
              }).catch(function () {});
            }, 500);
          } else if (res.code === 311) {
            setTimeout(function () {
              _this2.$message.error({ message: _this2.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
            }, 500);
          }
        });
      }).catch(function () {
        //いいえ
      });
    },
    address_click: function address_click() {
      //将当前郵便番号的值取得,传递到住所Dialog
      if (this.postCd1 == null) {
        this.postCd1 = "";
      }
      if (this.postCd2 == null) {
        this.postCd2 = "";
      }

      if (this.postCd1 + this.postCd2 == "") {
        this.addressPostCode = "";
      } else {
        this.addressPostCode = this.postCd1 + "-" + this.postCd2;
      }

      this.showAddressDialog = true;
    },

    // 选择住所对话框弹窗回调
    submitAddressDialog: function submitAddressDialog(row) {
      //住所1:都道府県＋市区町村
      //住所2:大字町丁目＋番地
      for (var key in row) {
        if (row[key] == null) {
          row[key] = "";
        }
      }
      this.showAddressDialog = false;
      this.address1 = row.stateName + row.cityName;
      this.address2 = row.oazamachiChomName + row.addressBanchi;
      this.address3 = "";
      this.latitude = row.latitude;
      this.longitude = row.longitude;
      this.cityCD = row.cityCD;
      // this.postCd1 = row.postCode.split("-")[0];
      // this.postCd2 = row.postCode.split("-")[1];
    },

    // 关闭住所对话框的弹窗回调
    closeAddressDialog: function closeAddressDialog() {
      this.showAddressDialog = false;
    },
    ekiStationSearch: function ekiStationSearch(queryString, cb, type) {
      var keyword = queryString;
      // キーワードを文字コードの数値の配列に変換
      var unicodeArray = [];
      for (var i = 0; i < keyword.length; i++) {
        unicodeArray.push(keyword.charCodeAt(i));
      }
      var sjisArray = src_default.a.convert(unicodeArray, {
        to: 'SJIS',
        from: 'UNICODE'
      });
      var encodedKeyword = src_default.a.urlEncode(sjisArray);
      i_0001_requestEkiStationGet(encodedKeyword, type).then(function (res) {
        var tempEkiArrey = res.split('&');
        var retEkiArrey = [];
        tempEkiArrey.forEach(function (item, i) {
          var tempsplit = item.split('=');
          var tempObjEki = { value: tempsplit[1] };
          if (i !== 0 && i !== tempEkiArrey.length - 1 & i !== tempEkiArrey.length - 2) {
            retEkiArrey.push(tempObjEki);
          }
        });
        cb(retEkiArrey);
      });
    },
    UTF8ToSJIS: function UTF8ToSJIS(data) {
      var results = [];
      var i = 0;
      var len = data && data.length;
      var b, b1, b2, utf8, jis;

      for (; i < len; i++) {
        b = data[i];
        if (b >= 0x80) {
          if (b <= 0xDF) {
            // 2 bytes.
            utf8 = (b << 8) + data[++i];
          } else {
            // 3 bytes.
            utf8 = (b << 16) + (data[++i] << 8) + (data[++i] & 0xFF);
          }
          jis = UTF8_TO_JIS_TABLE[utf8];
          if (jis === void 0) {
            //  *** 変更の開始
            //  UTF8の円記号(\)をSJISのバックスラッシュ(表記上は\)に変換 
            if (utf8 == 0xC2A5) {
              results[results.length] = 0x5C;
            } else {
              results[results.length] = UTF8_UNKNOWN;
            }
            //  *** 変更の終了
            // 元のコード        
            //results[results.length] = UTF8_UNKNOWN;
          } else {
            if (jis < 0xFF) {
              results[results.length] = jis + 0x80;
            } else {
              if (jis > 0x10000) {
                jis -= 0x10000;
              }

              b1 = jis >> 8;
              b2 = jis & 0xFF;
              if (b1 & 0x01) {
                b1 >>= 1;
                if (b1 < 0x2F) {
                  b1 += 0x71;
                } else {
                  b1 -= 0x4F;
                }

                if (b2 > 0x5F) {
                  b2 += 0x20;
                } else {
                  b2 += 0x1F;
                }
              } else {
                b1 >>= 1;
                if (b1 <= 0x2F) {
                  b1 += 0x70;
                } else {
                  b1 -= 0x50;
                }
                b2 += 0x7E;
              }
              results[results.length] = b1 & 0xFF;
              results[results.length] = b2 & 0xFF;
            }
          }
        } else {
          results[results.length] = data[i] & 0xFF;
        }
      }
      return results;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-451d46ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0001.vue
var i_0001_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"5px"}},[_c('el-row',{staticStyle:{"background-color":"#3cc6fa"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_BASIC_INFO')))])]),_vm._v(" "),_c('table',{staticClass:"i0001-table table-label"},[_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_STAFF_CD')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_vm._v(_vm._s(this.staffCd))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_USERNAME')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_vm._v(_vm._s(this.userName))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_BIRTHDAY')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_vm._v(_vm._s(this.birthday))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_GENDER')))]),_vm._v(" "),(this.gender == 1)?_c('td',{staticClass:"i0001-form-value"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_MSG_GENDERA')))]):_vm._e(),_vm._v(" "),(this.gender == 2)?_c('td',{staticClass:"i0001-form-value"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_MSG_GENDERB')))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_ZIPCODE')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_c('el-input',{staticClass:"i0001-input",staticStyle:{"width":"55px"},attrs:{"maxlength":"3","readonly":false},on:{"input":function($event){_vm.postCd1 = _vm.postCd1.replace(/[^\d]/g, '');}},model:{value:(_vm.postCd1),callback:function ($$v) {_vm.postCd1=$$v},expression:"postCd1"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0001-input",staticStyle:{"width":"65px"},attrs:{"maxlength":"4","readonly":false},on:{"input":function($event){_vm.postCd2 = _vm.postCd2.replace(/[^\d]/g, '');}},model:{value:(_vm.postCd2),callback:function ($$v) {_vm.postCd2=$$v},expression:"postCd2"}}),_vm._v(" "),_c('el-button',{staticClass:"i0001-css-addressbtn",on:{"click":_vm.address_click}},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_GET_ADDRESS')))]),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_ADDRESS')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_c('el-input',{staticClass:"i0001-input",model:{value:(_vm.address1),callback:function ($$v) {_vm.address1=$$v},expression:"address1"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")]),_vm._v(" "),_c('el-input',{staticClass:"i0001-input",staticStyle:{"margin-top":"3px"},model:{value:(_vm.address2),callback:function ($$v) {_vm.address2=$$v},expression:"address2"}}),_vm._v(" "),_c('el-input',{staticClass:"i0001-input",staticStyle:{"margin-top":"3px"},model:{value:(_vm.address3),callback:function ($$v) {_vm.address3=$$v},expression:"address3"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_NEAREST_STATION')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_c('el-autocomplete',{staticClass:"i0001-input",attrs:{"fetch-suggestions":function (queryString,cb){_vm.ekiStationSearch(queryString,cb,'station')},"maxlength":100},model:{value:(_vm.nearestStation),callback:function ($$v) {_vm.nearestStation=$$v},expression:"nearestStation"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_NEAREST_STATION_BUS')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_c('el-autocomplete',{staticClass:"i0001-input",attrs:{"fetch-suggestions":function (queryString,cb){_vm.ekiStationSearch(queryString,cb,'bus')},"maxlength":100},model:{value:(_vm.nearestStationBus),callback:function ($$v) {_vm.nearestStationBus=$$v},expression:"nearestStationBus"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_TEL_NUMBER')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_c('el-input',{staticClass:"i0001-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.mobileNo1 = _vm.mobileNo1.replace(/[^\d]/g, '');}},model:{value:(_vm.mobileNo1),callback:function ($$v) {_vm.mobileNo1=$$v},expression:"mobileNo1"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0001-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.mobileNo2 = _vm.mobileNo2.replace(/[^\d]/g, '');}},model:{value:(_vm.mobileNo2),callback:function ($$v) {_vm.mobileNo2=$$v},expression:"mobileNo2"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0001-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.mobileNo3 = _vm.mobileNo3.replace(/[^\d]/g, '');}},model:{value:(_vm.mobileNo3),callback:function ($$v) {_vm.mobileNo3=$$v},expression:"mobileNo3"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_HOME_NUMBER')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_c('el-input',{staticClass:"i0001-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.phoneNo1 = _vm.phoneNo1.replace(/[^\d]/g, '');}},model:{value:(_vm.phoneNo1),callback:function ($$v) {_vm.phoneNo1=$$v},expression:"phoneNo1"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0001-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.phoneNo2 = _vm.phoneNo2.replace(/[^\d]/g, '');}},model:{value:(_vm.phoneNo2),callback:function ($$v) {_vm.phoneNo2=$$v},expression:"phoneNo2"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0001-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.phoneNo3 = _vm.phoneNo3.replace(/[^\d]/g, '');}},model:{value:(_vm.phoneNo3),callback:function ($$v) {_vm.phoneNo3=$$v},expression:"phoneNo3"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_TEL_MAIL')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_c('el-input',{staticClass:"i0001-input",attrs:{"maxlength":"100"},model:{value:(_vm.mobileMail),callback:function ($$v) {_vm.mobileMail=$$v},expression:"mobileMail"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_PC_MAIL')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_c('el-input',{staticClass:"i0001-input",attrs:{"maxlength":"100"},model:{value:(_vm.pcMail),callback:function ($$v) {_vm.pcMail=$$v},expression:"pcMail"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0001-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_SALESOFFICE')))]),_vm._v(" "),_c('td',{staticClass:"i0001-form-value"},[_vm._v(_vm._s(this.salesOffice))])])]),_vm._v(" "),(this.processCd == 1)?_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(this.statusName)+" "+_vm._s(this.timeShow))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"i0001-css-btn",on:{"click":_vm.apply_click}},[_vm._v(_vm._s(_vm.$t('MODULE.I0001_LBL_APPLY')))])],1)],1),_vm._v(" "),_c('div',[(_vm.showAddressDialog)?_c('DialogAddress',{attrs:{"visible":_vm.showAddressDialog,"show":_vm.showAddressDialog,"mainpostcode":_vm.addressPostCode},on:{"update:visible":function($event){_vm.showAddressDialog=$event},"closeAddressDialog":_vm.closeAddressDialog,"submitAddressDialog":_vm.submitAddressDialog}}):_vm._e()],1)])}
var i_0001_staticRenderFns = []
var i_0001_esExports = { render: i_0001_render, staticRenderFns: i_0001_staticRenderFns }
/* harmony default export */ var page_i_0001 = (i_0001_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0001.vue
function i_0001_injectStyle (ssrContext) {
  __webpack_require__("Au8q")
}
var i_0001_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0001___vue_template_functional__ = false
/* styles */
var i_0001___vue_styles__ = i_0001_injectStyle
/* scopeId */
var i_0001___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0001___vue_module_identifier__ = null
var i_0001_Component = i_0001_normalizeComponent(
  i_0001,
  page_i_0001,
  i_0001___vue_template_functional__,
  i_0001___vue_styles__,
  i_0001___vue_scopeId__,
  i_0001___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0001 = (i_0001_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0002.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var i_0002_url = __webpack_require__("kspH");
/* harmony default export */ var i_0002 = ({
  data: function data() {
    return {
      checked: false
    };
  },
  created: function created() {},

  methods: {
    toInputPage: function toInputPage() {
      this.$router.push({ path: i_0002_url.routerUrl_I0009 });
    },
    // 戻る
    back: function back() {
      this.$router.push({ path: i_0002_url.routerUrl_I0010 });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-600f289c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0002.vue
var i_0002_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i0002"},[_c('div',{staticClass:"i0002-title"},[_c('p',[_vm._v(_vm._s(_vm.$t('MODULE.I0002_LBL_TITLE')))])]),_vm._v(" "),_c('div',{staticClass:"i0002-main"},[_c('ul',[_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0002_LBL_TEXT1'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0002_LBL_TEXT2'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0002_LBL_TEXT3'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0002_LBL_TEXT4'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0002_LBL_TEXT5'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0002_LBL_TEXT6'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0002_LBL_TEXT7'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0002_LBL_TEXT8'))+"\n      ")])])]),_vm._v(" "),_c('el-checkbox',{staticStyle:{"margin-top":"10px"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0002_LBL_ABOVE_AGREE')))]),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%","padding-left":"8px"},attrs:{"type":"primary","disabled":!_vm.checked},on:{"click":function($event){return _vm.toInputPage()}}},[_vm._v(_vm._s(_vm.$t('MODULE.I0002_LBL_INPUT_PAGE')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%","margin-left":"10px"},attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('MODULE.I0002_LBL_BACK')))])],1)],1)}
var i_0002_staticRenderFns = []
var i_0002_esExports = { render: i_0002_render, staticRenderFns: i_0002_staticRenderFns }
/* harmony default export */ var page_i_0002 = (i_0002_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0002.vue
function i_0002_injectStyle (ssrContext) {
  __webpack_require__("S+WE")
}
var i_0002_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0002___vue_template_functional__ = false
/* styles */
var i_0002___vue_styles__ = i_0002_injectStyle
/* scopeId */
var i_0002___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0002___vue_module_identifier__ = null
var i_0002_Component = i_0002_normalizeComponent(
  i_0002,
  page_i_0002,
  i_0002___vue_template_functional__,
  i_0002___vue_styles__,
  i_0002___vue_scopeId__,
  i_0002___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0002 = (i_0002_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0003.js



var i_0003_apiUrl = __webpack_require__("kspH");

// マスタデータ
var i_0003_conditionSearch = function conditionSearch(page, div, type) {
    var querys = querystring_es3_default.a.stringify({ type: type });
    return api_public.requestQuickGet(i_0003_apiUrl.apiurl_masterData + '/' + page + '/' + div + '?' + querys);
};

// 給与振込口座申請検索
var i_0003_salaryAccountInfoGet = function salaryAccountInfoGet(userCd) {
    return api_public.requestGet(i_0003_apiUrl.apiUrl_SalaryAccountInfo + '?userCd=' + userCd);
};

// 銀行検索
var i_0003_bankInfoGet = function bankInfoGet(bankName) {
    return api_public.requestGet(i_0003_apiUrl.apiUrl_BankInfo + '?bankName=' + encodeURIComponent(bankName) + '&page=1&size=2000');
};

// 支店検索
var i_0003_branchInfoGet = function branchInfoGet(bankCd, branchName) {
    return api_public.requestGet(i_0003_apiUrl.apiUrl_BranchInfo + '?bankCd=' + bankCd + '&branchName=' + encodeURIComponent(branchName) + '&page=1&size=2000');
};

// 給与振込口座申請更新
var i_0003_salaryAccountInfoSave = function salaryAccountInfoSave(params, userCd) {
    return api_public.requestPost(i_0003_apiUrl.apiUrl_SalaryAccountInfo + '?userCd=' + userCd, params);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0003.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var i_0003_url = __webpack_require__("kspH");
/* harmony default export */ var i_0003 = ({
  mixins: [css],
  data: function data() {
    return {
      userCd: '',
      accountDiv: '1', //口座区分
      accountNo: '', //口座番号
      applyDate: '', //申請日時
      bankCd: '', //銀行コード
      bankName: '', //銀行名
      branchCd: '', //支店コード
      branchName: '', //支店名
      holderKana: '', //名義人カナ
      holderName: '', //名義人名
      id: '', //申請番号
      status: '', //ステータス
      statusName: '', //ステータス名
      processCd: '', //処理区分
      bankInfo: [], //銀行候補
      branchInfo: [], //支店候補
      bankAccountDiv: [], //口座区分
      confirmDate: '', //確認日時
      updateDate: '' //更新日時
    };
  },
  created: function created() {
    this.search();
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
  },


  methods: {
    // 口座区分の内容を取得する。
    search: function search() {
      var _this = this;

      var page = 'all';
      var div = '50';
      var type = 'bank_account_div';
      i_0003_conditionSearch(page, div, type).then(function (res) {
        _this.bankAccountDiv = res.items.generalData.bankAccountDiv;
        _this.salaryAccountInfoQuery();
      });
    },


    // 給与振込口座申請検索
    salaryAccountInfoQuery: function salaryAccountInfoQuery() {
      var _this2 = this;

      this.set_loading();
      i_0003_salaryAccountInfoGet(this.userCd).then(function (res) {
        _this2.accountDiv = res.items.salaryAccountInfo.accountDiv; //口座区分
        _this2.accountNo = res.items.salaryAccountInfo.accountNo; //口座番号
        _this2.applyDate = utils.extractMillisecond(res.items.salaryAccountInfo.applyDate); //申請日時
        if (_this2.applyDate) {
          _this2.applyDate = _this2.applyDate.replace(/\-/g, '/');
        }
        _this2.bankCd = res.items.salaryAccountInfo.bankCd; //銀行コード
        _this2.bankName = res.items.salaryAccountInfo.bankName; //銀行名
        _this2.branchCd = res.items.salaryAccountInfo.branchCd; //支店コード
        _this2.branchName = res.items.salaryAccountInfo.branchName; //支店名
        _this2.holderKana = res.items.salaryAccountInfo.holderKana; //名義人カナ
        _this2.holderName = res.items.salaryAccountInfo.holderName; //名義人名
        _this2.id = res.items.salaryAccountInfo.id; //申請番号
        _this2.status = res.items.salaryAccountInfo.status; //ステータス
        _this2.statusName = res.items.salaryAccountInfo.statusName; //ステータス
        _this2.processCd = res.items.salaryAccountInfo.processCd; //処理区分
        if (_this2.confirmDate) {
          _this2.confirmDate = _this2.confirmDate.replace(/\-/g, '/');
        }
        _this2.updateDate = res.items.salaryAccountInfo.updateDate;
        _this2.close_loading();
      }).catch(function (err) {
        _this2.close_loading();
      });
    },


    // 銀行コードをクリアし、銀行候補を表示する。
    bankInput: function bankInput(val, cb) {
      this.branchName = '';
      this.branchCd = '';
      // 调用 callback 返回建议列表的数据
      cb(this.bankInfo);
    },


    // 银行选择
    bankSelect: function bankSelect(item) {
      this.bankCd = item.bankCd;
    },


    // 银行input失去焦点
    bankBlur: function bankBlur() {
      if (this.bankName) {
        this.bankInfoQuery('blur');
      }
    },


    // 銀行検索
    bankInfoQuery: function bankInfoQuery(val) {
      var _this3 = this;

      this.bankInfo = [];
      this.branchInfo = [];
      i_0003_bankInfoGet(this.bankName).then(function (res) {
        if (res.code == 204) {
          _this3.bankInfo = res.items.bankInfo;
          if (val == 'blur') {
            var exist = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = get_iterator_default()(_this3.bankInfo), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.bankName == _this3.bankName) {
                  exist = true;
                  _this3.bankCd = item.bankCd;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (!exist) {
              _this3.$message.warning({ message: _this3.$t('COMMON.MSG_NO_BANK'), showClose: true });
              _this3.bankName = '';
              _this3.bankCd = '';
              _this3.branchName = '';
              _this3.branchCd = '';
            }
          }
        } else if (res.code == '300' && val == 'blur') {
          // 銀行が存在しません。
          _this3.$message.warning({ message: _this3.$t('COMMON.MSG_NO_BANK'), showClose: true });
          _this3.bankName = '';
          _this3.bankCd = '';
          _this3.branchName = '';
          _this3.branchCd = '';
        }
      });
    },


    // 支店コードをクリアし、銀行候補を表示する。
    branchInput: function branchInput(val, cb) {
      // 调用 callback 返回建议列表的数据
      cb(this.branchInfo);
    },


    //  支店选择
    branchSelect: function branchSelect(item) {
      this.branchCd = item.branchCd;
    },


    //  支店input失去焦点
    branchBlur: function branchBlur() {
      if (this.branchName) {
        this.branchInfoQuery('blur');
      }
    },


    //  支店検索
    branchInfoQuery: function branchInfoQuery(val) {
      var _this4 = this;

      this.branchInfo = [];
      i_0003_branchInfoGet(this.bankCd, this.branchName).then(function (res) {
        if (res.code == 204) {
          _this4.branchInfo = res.items.branchInfo;
          if (val == 'blur') {
            var exist = false;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(_this4.branchInfo), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                if (item.branchName == _this4.branchName) {
                  exist = true;
                  _this4.branchCd = item.branchCd;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (!exist) {
              _this4.$message.warning({ message: _this4.$t('COMMON.MSG_NO_BRANCH'), showClose: true });
              _this4.branchName = '';
              _this4.branchCd = '';
            }
          } else {
            // 支店input 变化监听，先清空branchCd，防止从支店点击“申请”按钮，无法进行check
            _this4.branchCd = '';
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = get_iterator_default()(_this4.branchInfo), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var item = _step3.value;

                if (item.branchName == _this4.branchName) {
                  _this4.branchCd = item.branchCd;
                }
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
        } else if (res.code == '300' && val == 'blur') {
          // 支店が存在しません。
          _this4.$message.warning({ message: _this4.$t('COMMON.MSG_NO_BRANCH'), showClose: true });
          _this4.branchName = '';
          _this4.branchCd = '';
        }
      });
    },


    //申請
    apply: function apply() {
      var _this5 = this;

      if (!this.paramsCheck()) {
        return;
      }
      // データを保存します。よろしいでしょうか？
      this.$confirm(this.$t('COMMON.MSG_CONFIRM_CHANGE'), this.$t('COMMON.CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //いいえ
        customClass: 'i0003textCenter'
      }).then(function () {
        // 画面刷新
        _this5.save();
      }).catch(function () {});
    },


    // 保存数据
    save: function save() {
      var _this6 = this;

      i_0003_salaryAccountInfoSave(this.saveParamsGet(), this.userCd).then(function (res) {
        if (res.code == '202') {
          _this6.$message.success({ message: _this6.$t('COMMON.MSG_INSERTED'), showClose: true }); //保存成功
          _this6.salaryAccountInfoQuery();
        } else if (res.code == '311') {
          _this6.$message.error({ message: _this6.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
        } else if (res.code == '308') {
          // 処理が失敗しました。他の人が先に更新した可能性があります。最新情報を取得しますか。
          _this6.$confirm(_this6.$t('COMMON.EXCLUSIVE'), _this6.$t('COMMON.CONFIRM'), {
            confirmButtonText: _this6.$t('COMMON.MSG_DELETE_CONFIRM'), //はい
            cancelButtonText: _this6.$t('COMMON.MSG_DELETE_CANCEL'), //いいえ
            customClass: 'i0003textCenter'
          }).then(function () {
            // 画面刷新
            _this6.salaryAccountInfoQuery();
          }).catch(function () {});
        } else if (res.code == '435') {
          // 既に承認されましたので、処理が失敗しました。最新情報を取得しますか？
          _this6.$confirm(_this6.$t('COMMON.MSG_APPROVED'), _this6.$t('COMMON.CONFIRM'), {
            confirmButtonText: _this6.$t('COMMON.MSG_DELETE_CONFIRM'), //はい
            cancelButtonText: _this6.$t('COMMON.MSG_DELETE_CANCEL'), //いいえ
            customClass: 'i0003textCenter'
          }).then(function () {
            // 画面刷新
            _this6.salaryAccountInfoQuery();
          }).catch(function () {});
        }
      });
    },


    //申請参数获取
    saveParamsGet: function saveParamsGet() {
      var saveParams = {
        "bankCd": this.bankCd,
        "bankName": this.bankName,
        "branchCd": this.branchCd,
        "branchName": this.branchName,
        "accountDiv": this.accountDiv,
        "accountNo": this.accountNo,
        "holderName": this.holderName,
        "holderKana": this.holderKana,
        "processCd": this.processCd,
        "userCd": this.userCd,
        "updateDate": this.updateDate
      };
      if (saveParams.processCd == '1') {
        saveParams.id = this.id;
      }
      return saveParams;
    },


    // 必須チェックを行う。
    paramsCheck: function paramsCheck() {
      //銀行名
      if (this.bankName == '' || this.bankCd == '') {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_BANKNAME')), showClose: true });
        return false;
      }

      //支店名
      if (this.branchName == '' || this.branchCd == '') {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_BRANCHNAME')), showClose: true });
        return false;
      }

      //口座区分
      if (!this.accountDiv) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_ACCOUNT_CLASSIFICATION')), showClose: true });
        return false;
      }

      //口座番号
      if (!this.accountNo) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_ACCOUNT_NUMBER')), showClose: true });
        return false;
      }

      //名義人名
      if (!this.holderName) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_NOMINAL_NAME')), showClose: true });
        return false;
      }

      //名義人カナ
      if (!this.holderKana) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_NOMINAL_KANA')), showClose: true });
        return false;
      }
      return true;
    },


    // 口座番号半角数字のみ入力可
    accountNoChange: function accountNoChange() {
      this.accountNo = this.accountNo.replace(/[^0-9]/ig, "");
    },


    // 名義人カナ半角文字のみ入力可
    holderKanaChange: function holderKanaChange(val) {
      var reg = /[^\uff66-\uff9f^\u0020^a-zA-Z0-9]/g;
      this.holderKana = this.holderKana.replace(reg, '');
    }
  },
  watch: {
    bankName: function bankName() {
      this.bankInfoQuery();
    },
    branchName: function branchName() {
      this.branchInfoQuery();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b49bacd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0003.vue
var i_0003_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('div',[_c('ul',{staticClass:"infinite-list decimal",staticStyle:{"font-size":"13px"}},[_c('li',{staticClass:"infinite-list-item",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0003_LBL_TEXT1'))}}),_vm._v(" "),_c('li',{staticClass:"infinite-list-item",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0003_LBL_TEXT2'))}}),_vm._v(" "),_c('li',{staticClass:"infinite-list-item",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0003_LBL_TEXT3'))}})])]),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.$t('MODULE.I0003_LBL_SUPPLY_INFO')))])]),_vm._v(" "),_c('table',{staticClass:"i0003-table table-label"},[_c('tr',[_c('td',{staticClass:"i0003-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0003_LBL_BANKNAME')))]),_vm._v(" "),_c('td',{staticClass:"i0003-form-value"},[_c('el-autocomplete',{staticClass:"i0003-input",attrs:{"fetch-suggestions":_vm.bankInput,"value-key":"bankName","trigger-on-focus":false},on:{"blur":_vm.bankBlur,"select":_vm.bankSelect},model:{value:(_vm.bankName),callback:function ($$v) {_vm.bankName=$$v},expression:"bankName"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")]),_vm._v(" "),_vm._v("\n          "+_vm._s(_vm.$t('MODULE.I0003_LBL_TEXT4'))+"\n        ")],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0003-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0003_LBL_BRANCHNAME')))]),_vm._v(" "),_c('td',{staticClass:"i0003-form-value"},[_c('el-autocomplete',{staticClass:"i0003-input",attrs:{"fetch-suggestions":_vm.branchInput,"value-key":"branchName","trigger-on-focus":false},on:{"blur":_vm.branchBlur,"select":_vm.branchSelect},model:{value:(_vm.branchName),callback:function ($$v) {_vm.branchName=$$v},expression:"branchName"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0003_LBL_TEXT5'))}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0003-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0003_LBL_ACCOUNT_CLASSIFICATION')))]),_vm._v(" "),_c('td',{staticClass:"i0003-form-value"},[_vm._l((_vm.bankAccountDiv),function(item,key){return [_c('el-radio',{attrs:{"label":item.key},model:{value:(_vm.accountDiv),callback:function ($$v) {_vm.accountDiv=$$v},expression:"accountDiv"}},[_vm._v(_vm._s(item.value))])]})],2)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0003-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0003_LBL_ACCOUNT_NUMBER')))]),_vm._v(" "),_c('td',{staticClass:"i0003-form-value"},[_c('el-input',{staticClass:"i0003-input",attrs:{"pattern":"\\d*","maxlength":7},on:{"input":_vm.accountNoChange},model:{value:(_vm.accountNo),callback:function ($$v) {_vm.accountNo=$$v},expression:"accountNo"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0003-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0003_LBL_NOMINAL_NAME')))]),_vm._v(" "),_c('td',{staticClass:"i0003-form-value"},[_c('el-input',{staticClass:"i0003-input",model:{value:(_vm.holderName),callback:function ($$v) {_vm.holderName=$$v},expression:"holderName"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0003-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0003_LBL_NOMINAL_KANA')))]),_vm._v(" "),_c('td',{staticClass:"i0003-form-value"},[_c('el-input',{staticClass:"i0003-input",on:{"input":_vm.holderKanaChange},model:{value:(_vm.holderKana),callback:function ($$v) {_vm.holderKana=$$v},expression:"holderKana"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")]),_vm._v(" "),_vm._v("\n          "+_vm._s(_vm.$t('MODULE.I0003_LBL_TEXT6'))+"\n        ")],1)])]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.processCd),expression:"processCd"}],staticStyle:{"font-size":"13px","padding-top":"5px"}},[_c('span',[_vm._v(_vm._s(_vm.statusName))]),_vm._v(" "),(_vm.status=='0')?_c('span',[_vm._v(_vm._s(_vm.applyDate))]):_c('span',[_vm._v(_vm._s(_vm.confirmDate))])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"disabled":_vm.processCd=='1'&&_vm.status=='2',"type":"primary"},on:{"click":_vm.apply}},[_vm._v(_vm._s(_vm.$t('MODULE.I0003_LBL_APPLY')))])],1)],1)])}
var i_0003_staticRenderFns = []
var i_0003_esExports = { render: i_0003_render, staticRenderFns: i_0003_staticRenderFns }
/* harmony default export */ var page_i_0003 = (i_0003_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0003.vue
function i_0003_injectStyle (ssrContext) {
  __webpack_require__("FwHB")
}
var i_0003_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0003___vue_template_functional__ = false
/* styles */
var i_0003___vue_styles__ = i_0003_injectStyle
/* scopeId */
var i_0003___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0003___vue_module_identifier__ = null
var i_0003_Component = i_0003_normalizeComponent(
  i_0003,
  page_i_0003,
  i_0003___vue_template_functional__,
  i_0003___vue_styles__,
  i_0003___vue_scopeId__,
  i_0003___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0003 = (i_0003_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0004.js



var i_0004_apiUrl = __webpack_require__("kspH");
// 緊急連絡先申請検索
var i_0004_i_0004_query = function i_0004_query(userCd) {
  return api_public.requestQuickGet(i_0004_apiUrl.apiUrl_EmergencyContact + '?userId=' + userCd);
};
// 緊急連絡先申請更新
var i_0004_i_0004_update = function i_0004_update(params, userCd) {
  return api_public.requestPost(i_0004_apiUrl.apiUrl_EmergencyContact + '?userCd=' + userCd, params);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0004.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var i_0004_url = __webpack_require__("kspH");
/* harmony default export */ var i_0004 = ({
  mixins: [css],
  components: {
    "DialogAddress": components_page_dialogAddress
  },
  data: function data() {
    return {
      //郵便番号
      ecPostCd1: "",
      ecPostCd2: "",
      //住所1
      ecAddress1: "",
      //住所2
      ecAddress2: "",
      //住所3
      ecAddress3: "",
      //携帯番号
      ecMobileNo1: "",
      ecMobileNo2: "",
      ecMobileNo3: "",
      //電話番号
      ecPhoneNo1: "",
      ecPhoneNo2: "",
      ecPhoneNo3: "",
      //連絡先名
      ecName: "",
      //続柄
      ecRelations: "",
      //申請日時
      applyDate: "",
      //申請ステータス
      status: "",
      //ステータス名
      statusName: "",
      //申請番号
      id: "",
      //処理区分
      processCd: "",
      //確認日時
      confirmDate: "",
      //更新日時
      updateDate: "",
      //日時表示
      timeShow: "",
      userCd: "",
      showAddressDialog: false,
      //郵便番号(住所取得ボタン用)
      addressPostCode: ""
    };
  },
  created: function created() {
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;

    //検索
    this.query();
  },

  methods: {
    // 検索
    query: function query() {
      var _this = this;

      // loading处理
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 検索処理
      i_0004_i_0004_query(this.userCd).then(function (res) {
        if (res.code == 204) {
          if (res.items.selfDoc[0].ecPostCd == null) {
            _this.ecPostCd1 = "";
            _this.ecPostCd2 = "";
          } else {
            _this.ecPostCd1 = res.items.selfDoc[0].ecPostCd.split("-")[0];
            _this.ecPostCd2 = res.items.selfDoc[0].ecPostCd.split("-")[1];
          }

          _this.ecAddress1 = res.items.selfDoc[0].ecAddress1;
          _this.ecAddress2 = res.items.selfDoc[0].ecAddress2;
          _this.ecAddress3 = res.items.selfDoc[0].ecAddress3;

          if (res.items.selfDoc[0].ecMobileNo == null) {
            _this.ecMobileNo1 = "";
            _this.ecMobileNo2 = "";
            _this.ecMobileNo3 = "";
          } else {
            _this.ecMobileNo1 = res.items.selfDoc[0].ecMobileNo.split("-")[0];
            _this.ecMobileNo2 = res.items.selfDoc[0].ecMobileNo.split("-")[1];
            _this.ecMobileNo3 = res.items.selfDoc[0].ecMobileNo.split("-")[2];
          }

          if (res.items.selfDoc[0].ecPhoneNo == null) {
            _this.ecPhoneNo1 = "";
            _this.ecPhoneNo2 = "";
            _this.ecPhoneNo3 = "";
          } else {
            _this.ecPhoneNo1 = res.items.selfDoc[0].ecPhoneNo.split("-")[0];
            _this.ecPhoneNo2 = res.items.selfDoc[0].ecPhoneNo.split("-")[1];
            _this.ecPhoneNo3 = res.items.selfDoc[0].ecPhoneNo.split("-")[2];
          }

          _this.ecName = res.items.selfDoc[0].ecName;
          _this.ecRelations = res.items.selfDoc[0].ecRelations;

          _this.applyDate = res.items.selfDoc[0].applyDate;
          if (res.items.selfDoc[0].id == null) {
            _this.id = 0;
          } else {
            _this.id = res.items.selfDoc[0].id;
          }

          _this.processCd = res.items.selfDoc[0].processCd;

          _this.status = res.items.selfDoc[0].status;
          _this.statusName = res.items.selfDoc[0].statusName;
          _this.confirmDate = res.items.selfDoc[0].confirmDate;
          _this.updateDate = res.items.selfDoc[0].updateDate;

          // 処理区分が「1：更新」表示日時
          // ステータス取得
          // 「0」の場合 申請日時
          // 「1」or「2」の場合 確認日時
          if (_this.processCd == "1") {
            if (_this.status == "0") {
              _this.timeShow = utils.extractMillisecond(_this.applyDate);
            } else if (_this.status == "1" || _this.status == "2") {
              _this.timeShow = utils.extractMillisecond(_this.confirmDate);
            }
          }
        } else if (res.code === 300) {
          _this.loading.close();
          return;
        }
        _this.loading.close();
      }).catch(function () {
        _this.loading.close();
      });
    },

    // 申请
    apply_click: function apply_click() {
      var _this2 = this;

      if (this.ecPostCd1 == null) {
        this.ecPostCd1 = "";
      }
      if (this.ecPostCd2 == null) {
        this.ecPostCd2 = "";
      }
      if (this.ecAddress1 == null) {
        this.ecAddress1 = "";
      }
      if (this.ecMobileNo1 == null) {
        this.ecMobileNo1 = "";
      }
      if (this.ecMobileNo2 == null) {
        this.ecMobileNo2 = "";
      }
      if (this.ecMobileNo3 == null) {
        this.ecMobileNo3 = "";
      }
      if (this.ecPhoneNo1 == null) {
        this.ecPhoneNo1 = "";
      }
      if (this.ecPhoneNo2 == null) {
        this.ecPhoneNo2 = "";
      }
      if (this.ecPhoneNo3 == null) {
        this.ecPhoneNo3 = "";
      }
      if (this.ecName == null) {
        this.ecName = "";
      }
      if (this.ecRelations == null) {
        this.ecRelations = "";
      }
      //チェック処理
      //必須項目のいずれが入力されていない場合
      if (this.ecPostCd1 + this.ecPostCd2 == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0004_LBL_POSTCODE')), showClose: true });
        return false;
      }

      if (this.ecAddress1 == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0004_MSG_ADDRESS1')), showClose: true });
        return false;
      }

      //郵便番号桁数チェック
      if (this.ecPostCd1.length != 3 || this.ecPostCd2.length != 4) {
        this.$message.error({ message: this.$t('MODULE.DIALOG_MSG_POST_CODE_CHECK'), showClose: true });
        return false;
      }

      //携帯番号と電話番号両方入力していない場合
      if (this.ecMobileNo1 + this.ecMobileNo2 + this.ecMobileNo3 == "" && this.ecPhoneNo1 + this.ecPhoneNo2 + this.ecPhoneNo3 == "") {
        this.$message.error({ message: this.$t('MODULE.I0004_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0004_LBL_CARRYCODE')).replace('{2}', this.$t('MODULE.I0004_LBL_TELCODE')), showClose: true });
        return false;
      }

      if (this.ecName == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0004_LBL_CALLNAME')), showClose: true });
        return false;
      }

      if (this.ecRelations == "") {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0004_LBL_RELAT')), showClose: true });
        return false;
      }

      // データを保存します。よろしいでしょうか？
      // 「はい」を選択したら、下記の処理へ進む
      // 「いいえ」を選択したら、何もしない
      this.$confirm(this.$t('COMMON.MSG_CONFIRM_CHANGE'), this.$t('COMMON.CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //を選択します
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
        center: true
      }).then(function () {
        //はい
        var update_params = {};
        update_params.ecAddress1 = _this2.ecAddress1;
        update_params.ecAddress2 = _this2.ecAddress2;
        update_params.ecAddress3 = _this2.ecAddress3;
        if (_this2.ecMobileNo1 + _this2.ecMobileNo2 + _this2.ecMobileNo3 == "") {
          update_params.ecMobileNo = "";
        } else {
          update_params.ecMobileNo = _this2.ecMobileNo1 + "-" + _this2.ecMobileNo2 + "-" + _this2.ecMobileNo3;
        }

        if (_this2.ecPhoneNo1 + _this2.ecPhoneNo2 + _this2.ecPhoneNo3 == "") {
          update_params.ecPhoneNo = "";
        } else {
          update_params.ecPhoneNo = _this2.ecPhoneNo1 + "-" + _this2.ecPhoneNo2 + "-" + _this2.ecPhoneNo3;
        }

        update_params.ecName = _this2.ecName;
        update_params.ecPostCd = _this2.ecPostCd1 + "-" + _this2.ecPostCd2;
        update_params.ecRelations = _this2.ecRelations;
        update_params.processCd = _this2.processCd;
        update_params.id = _this2.id;
        if (_this2.processCd == "2") {
          update_params.updateDate = "";
        } else {
          update_params.updateDate = _this2.updateDate;
        }
        i_0004_i_0004_update(update_params, _this2.userCd).then(function (res) {
          if (res.code === 202) {
            _this2.$message.success({ message: _this2.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
            _this2.query();
          } else if (res.code === 308) {
            setTimeout(function () {
              _this2.$confirm(_this2.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                confirmButtonText: _this2.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
                cancelButtonText: _this2.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                center: true
              }).then(function () {
                _this2.query();
              }).catch(function () {});
            }, 500);
          } else if (res.code === 311) {
            setTimeout(function () {
              _this2.$message.error({ message: _this2.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
            }, 500);
          }
        });
      }).catch(function () {
        //いいえ
      });
    },

    //住所取得ボタン 按下
    address_click: function address_click() {
      //将当前郵便番号的值取得,传递到住所Dialog
      if (this.ecPostCd1 == null) {
        this.ecPostCd1 = "";
      }
      if (this.ecPostCd2 == null) {
        this.ecPostCd2 = "";
      }

      if (this.ecPostCd1 + this.ecPostCd2 == "") {
        this.addressPostCode = "";
      } else {
        this.addressPostCode = this.ecPostCd1 + "-" + this.ecPostCd2;
      }

      this.showAddressDialog = true;
    },

    // 选择住所对话框弹窗回调
    submitAddressDialog: function submitAddressDialog(row) {
      //住所1:都道府県＋市区町村
      //住所2:大字町丁目＋番地
      console.log(row);
      for (var key in row) {
        if (row[key] == null) {
          row[key] = "";
        }
      }
      this.showAddressDialog = false;
      this.ecAddress1 = row.stateName + row.cityName;
      this.ecAddress2 = row.oazamachiChomName + row.addressBanchi;
      this.ecAddress3 = "";
      // this.ecPostCd1 = row.postCode.split("-")[0];
      // this.ecPostCd2 = row.postCode.split("-")[1];
    },

    // 关闭住所对话框的弹窗回调
    closeAddressDialog: function closeAddressDialog() {
      this.showAddressDialog = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fec792b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0004.vue
var i_0004_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"5px"}},[_c('el-row',{staticStyle:{"background-color":"#3cc6fa"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_TITLE')))])]),_vm._v(" "),_c('table',{staticClass:"i0004-table table-label"},[_c('tr',[_c('td',{staticClass:"i0004-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_POSTCODE')))]),_vm._v(" "),_c('td',{staticClass:"i0004-form-value"},[_c('el-input',{staticClass:"i0004-input",staticStyle:{"width":"55px"},attrs:{"maxlength":"3","readonly":false},on:{"input":function($event){_vm.ecPostCd1 = _vm.ecPostCd1.replace(/[^\d]/g, '');}},model:{value:(_vm.ecPostCd1),callback:function ($$v) {_vm.ecPostCd1=$$v},expression:"ecPostCd1"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0004-input",staticStyle:{"width":"65px"},attrs:{"maxlength":"4","readonly":false},on:{"input":function($event){_vm.ecPostCd2 = _vm.ecPostCd2.replace(/[^\d]/g, '');}},model:{value:(_vm.ecPostCd2),callback:function ($$v) {_vm.ecPostCd2=$$v},expression:"ecPostCd2"}}),_vm._v(" "),_c('el-button',{staticClass:"i0004-css-addressbtn",on:{"click":_vm.address_click}},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_GETHOME')))]),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0004-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_HOME')))]),_vm._v(" "),_c('td',{staticClass:"i0004-form-value"},[_c('el-input',{staticClass:"i0004-input",model:{value:(_vm.ecAddress1),callback:function ($$v) {_vm.ecAddress1=$$v},expression:"ecAddress1"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")]),_vm._v(" "),_c('el-input',{staticClass:"i0004-input",staticStyle:{"margin-top":"3px"},model:{value:(_vm.ecAddress2),callback:function ($$v) {_vm.ecAddress2=$$v},expression:"ecAddress2"}}),_vm._v(" "),_c('el-input',{staticClass:"i0004-input",staticStyle:{"margin-top":"3px"},model:{value:(_vm.ecAddress3),callback:function ($$v) {_vm.ecAddress3=$$v},expression:"ecAddress3"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0004-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_CARRYCODE')))]),_vm._v(" "),_c('td',{staticClass:"i0004-form-value"},[_c('el-input',{staticClass:"i0004-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.ecMobileNo1 = _vm.ecMobileNo1.replace(/[^\d]/g, '');}},model:{value:(_vm.ecMobileNo1),callback:function ($$v) {_vm.ecMobileNo1=$$v},expression:"ecMobileNo1"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0004-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.ecMobileNo2 = _vm.ecMobileNo2.replace(/[^\d]/g, '');}},model:{value:(_vm.ecMobileNo2),callback:function ($$v) {_vm.ecMobileNo2=$$v},expression:"ecMobileNo2"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0004-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.ecMobileNo3 = _vm.ecMobileNo3.replace(/[^\d]/g, '');}},model:{value:(_vm.ecMobileNo3),callback:function ($$v) {_vm.ecMobileNo3=$$v},expression:"ecMobileNo3"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0004-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_TELCODE')))]),_vm._v(" "),_c('td',{staticClass:"i0004-form-value"},[_c('el-input',{staticClass:"i0004-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.ecPhoneNo1 = _vm.ecPhoneNo1.replace(/[^\d]/g, '');}},model:{value:(_vm.ecPhoneNo1),callback:function ($$v) {_vm.ecPhoneNo1=$$v},expression:"ecPhoneNo1"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0004-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.ecPhoneNo2 = _vm.ecPhoneNo2.replace(/[^\d]/g, '');}},model:{value:(_vm.ecPhoneNo2),callback:function ($$v) {_vm.ecPhoneNo2=$$v},expression:"ecPhoneNo2"}}),_vm._v(" -\n          "),_c('el-input',{staticClass:"i0004-input",staticStyle:{"width":"64px"},attrs:{"pattern":"\\d*","maxlength":"4"},on:{"input":function($event){_vm.ecPhoneNo3 = _vm.ecPhoneNo3.replace(/[^\d]/g, '');}},model:{value:(_vm.ecPhoneNo3),callback:function ($$v) {_vm.ecPhoneNo3=$$v},expression:"ecPhoneNo3"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0004-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_CALLNAME')))]),_vm._v(" "),_c('td',{staticClass:"i0004-form-value"},[_c('el-input',{staticClass:"i0004-input",attrs:{"maxlength":"100"},model:{value:(_vm.ecName),callback:function ($$v) {_vm.ecName=$$v},expression:"ecName"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0004-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_RELAT')))]),_vm._v(" "),_c('td',{staticClass:"i0004-form-value"},[_c('el-input',{staticClass:"i0004-input",attrs:{"maxlength":"20"},model:{value:(_vm.ecRelations),callback:function ($$v) {_vm.ecRelations=$$v},expression:"ecRelations"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)])]),_vm._v(" "),(this.processCd == 1)?_c('span',{staticStyle:{"font-size":"10pt"}},[_vm._v(_vm._s(this.statusName)+" "+_vm._s(this.timeShow))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"i0004-css-btn",on:{"click":_vm.apply_click}},[_vm._v(_vm._s(_vm.$t('MODULE.I0004_LBL_APPLY')))])],1)],1),_vm._v(" "),_c('div',[(_vm.showAddressDialog)?_c('DialogAddress',{attrs:{"visible":_vm.showAddressDialog,"show":_vm.showAddressDialog,"mainpostcode":_vm.addressPostCode},on:{"update:visible":function($event){_vm.showAddressDialog=$event},"closeAddressDialog":_vm.closeAddressDialog,"submitAddressDialog":_vm.submitAddressDialog}}):_vm._e()],1)])}
var i_0004_staticRenderFns = []
var i_0004_esExports = { render: i_0004_render, staticRenderFns: i_0004_staticRenderFns }
/* harmony default export */ var page_i_0004 = (i_0004_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0004.vue
function i_0004_injectStyle (ssrContext) {
  __webpack_require__("sMHB")
}
var i_0004_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0004___vue_template_functional__ = false
/* styles */
var i_0004___vue_styles__ = i_0004_injectStyle
/* scopeId */
var i_0004___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0004___vue_module_identifier__ = null
var i_0004_Component = i_0004_normalizeComponent(
  i_0004,
  page_i_0004,
  i_0004___vue_template_functional__,
  i_0004___vue_styles__,
  i_0004___vue_scopeId__,
  i_0004___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0004 = (i_0004_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0005.js



var i_0005_apiUrl = __webpack_require__("kspH");
// マイナンバー申請確認
var i_0005_i_0005_update = function i_0005_update(params, userCd) {
  return api_public.requestPost(i_0005_apiUrl.apiUrl_StaffApplyConfirmLog + '?userCd=' + userCd, [params]);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0005.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var i_0005_url = __webpack_require__("kspH");
/* harmony default export */ var i_0005 = ({
  mixins: [css],
  data: function data() {
    return {
      checked: false,
      checkedNo: false,
      disabledChkConsent: false,
      disabledChkNo: false,
      disabledBtnConsent: false,
      disabledBtnNo: false,
      userCd: ''
    };
  },
  created: function created() {
    this.disabledChkConsent = false;
    this.disabledChkNo = false;
    this.disabledBtnConsent = true;
    this.disabledBtnNo = true;
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
  },

  watch: {
    checked: function checked(val) {
      if (val == true) {
        this.disabledBtnConsent = false;
      } else if (val == false) {
        this.disabledBtnConsent = true;
      }
    },

    checkedNo: function checkedNo(val) {
      if (val == true) {
        this.disabledBtnNo = false;
      } else if (val == false) {
        this.disabledBtnNo = true;
      }
    }
  },
  methods: {
    //入力画面ボタン
    btn_input: function btn_input() {
      var _this = this;

      //API「スタッフ申請確認ログ保存」を呼び出す。
      var params = {
        stfConfirmType: "1", //マイナンバー
        stfConfirmResult: "1", //同意
        stfConfirmUserCd: JSON.parse(localStorage.getItem('userInfo')).userCd
      };
      i_0005_i_0005_update(params, this.userCd).then(function (res) {
        if (res.code === 202) {
          //マイナンバー申請画面へ遷移
          _this.$router.push({ path: i_0005_url.routerUrl_I0006 });
        } else if (res.code === 311) {
          _this.$message.error({ message: _this.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
        }
      });
    },

    //確定ボタン
    btn_no_confirm: function btn_no_confirm() {
      var _this2 = this;

      //API「スタッフ申請確認ログ保存」を呼び出す。
      var params = {
        stfConfirmType: "1", //マイナンバー
        stfConfirmResult: "2", //拒否
        stfConfirmUserCd: JSON.parse(localStorage.getItem('userInfo')).userCd
      };
      i_0005_i_0005_update(params, this.userCd).then(function (res) {
        if (res.code === 202) {
          _this2.$message.success({ message: _this2.$t('COMMON.UPDATED'), showClose: true }); //更新成功
          //同意チェック・入力画面ボタン・拒否チェック・確定ボタンを非活性にする。
          _this2.disabledChkConsent = true;
          _this2.disabledChkNo = true;
          _this2.disabledBtnConsent = true;
          _this2.disabledBtnNo = true;
        } else if (res.code === 311) {
          _this2.$message.error({ message: _this2.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
        }
      });
    },

    //上記内容に同意します。チェック按下
    changeConsent: function changeConsent() {
      this.checked = !this.checked;
      //同意・拒否が同時チェックの場合
      if (this.checked && this.checkedNo) {
        //同意・拒否は同時にチェックできません。
        this.$message.warning({ message: this.$t('MODULE.I0005_MSG_MYNO_AGREE_REFUSE'), showClose: true });
        this.checked = false;
      }
    },

    //マイナンバー提出を拒否します。チェック按下
    changeNO: function changeNO() {
      this.checkedNo = !this.checkedNo;
      //同意・拒否が同時チェックの場合
      if (this.checkedNo && this.checked) {
        //同意・拒否は同時にチェックできません。
        this.$message.warning({ message: this.$t('MODULE.I0005_MSG_MYNO_AGREE_REFUSE'), showClose: true });
        this.checkedNo = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd8542ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0005.vue
var i_0005_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i0005"},[_c('div',{staticClass:"i0005-title"},[_c('p',[_vm._v(_vm._s(_vm.$t('MODULE.I0005_LBL_TITLE')))])]),_vm._v(" "),_c('div',{staticClass:"i0005-main"},[_c('ul',[_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT1'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT2'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT3'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT4'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT5'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT6'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT7'))+"\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        "+_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT8'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"table-label",staticStyle:{"padding-left":"10px","color":"red","padding-top":"12px","line-height":"23px"}},[_c('span',{staticStyle:{"letter-spacing":"1px"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0005_LBL_TEXT'))}})]),_vm._v(" "),_c('el-checkbox',{staticStyle:{"margin-top":"10px"},attrs:{"value":_vm.checked,"disabled":this.disabledChkConsent},on:{"change":function($event){return _vm.changeConsent()}}},[_c('div',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0005_LBL_ABOVE_AGREE')))])]),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('el-button',{staticClass:"i0005-css-btn css-button",staticStyle:{"margin-top":"8px","width":"70px","padding-left":"8px","font-size":"13px"},attrs:{"type":"primary","disabled":this.disabledBtnConsent},on:{"click":function($event){return _vm.btn_input()}}},[_vm._v(_vm._s(_vm.$t('MODULE.I0005_BTN_TEXT1')))])],1),_vm._v(" "),_c('el-checkbox',{staticStyle:{"margin-top":"30px"},attrs:{"value":_vm.checkedNo,"disabled":this.disabledChkNo},on:{"change":function($event){return _vm.changeNO()}}},[_c('div',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0005_LBL_CONSENT')))])]),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('el-button',{staticClass:"i0005-css-btn css-button",staticStyle:{"margin-top":"8px","width":"70px","padding-left":"18px","font-size":"13px"},attrs:{"type":"primary","disabled":this.disabledBtnNo},on:{"click":function($event){return _vm.btn_no_confirm()}}},[_vm._v(_vm._s(_vm.$t('MODULE.I0005_BTN_TEXT2')))])],1)],1)}
var i_0005_staticRenderFns = []
var i_0005_esExports = { render: i_0005_render, staticRenderFns: i_0005_staticRenderFns }
/* harmony default export */ var page_i_0005 = (i_0005_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0005.vue
function i_0005_injectStyle (ssrContext) {
  __webpack_require__("LT+B")
}
var i_0005_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0005___vue_template_functional__ = false
/* styles */
var i_0005___vue_styles__ = i_0005_injectStyle
/* scopeId */
var i_0005___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0005___vue_module_identifier__ = null
var i_0005_Component = i_0005_normalizeComponent(
  i_0005,
  page_i_0005,
  i_0005___vue_template_functional__,
  i_0005___vue_styles__,
  i_0005___vue_scopeId__,
  i_0005___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0005 = (i_0005_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0006.js




var i_0006_apiUrl = __webpack_require__("kspH");

// マスタデータ
var i_0006_conditionSearch = function conditionSearch(page, div, type) {
    var querys = querystring_es3_default.a.stringify({ type: type });
    return api_public.requestQuickGet(i_0006_apiUrl.apiurl_masterData + '/' + page + '/' + div + '?' + querys);
};
// 検索
var i_0006_myNoInfoGet = function myNoInfoGet(userCd) {
    return api_public.requestGet(i_0006_apiUrl.apiUrl_MyNoInfo + '?userId=' + userCd);
};

// // 保存
// export const noticeSave = (saveParams, userCd) => {
//     return http.requestPost(apiUrl.apiUrl_Notice + '?userId=' + userCd, saveParams)
// }

//图片查询
var i_0006_photoFile_get = function photoFile_get(photoPath) {
    return api_public.requestQuickGetImage(i_0006_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0');
};

//图片保存
var i_0006_photoFile_saveImage = function photoFile_saveImage(photo) {
    return api_public.requestPostFormData(i_0006_apiUrl.apiUrl_filesUpdate, photo);
};

// メニュー状態管理検索
var i_0006_menuStateManagerGet = function menuStateManagerGet(userCd) {
    return api_public.requestGet(i_0006_apiUrl.apiurl_MenuStateManager + '?userId=' + userCd);
};

// マイナンバー申請保存
var i_0006_Apply_Save = function Apply_Save(userCd, applySaveParams) {
    return api_public.requestPost(i_0006_apiUrl.apiUrl_MyNoInfo + '?userCd=' + userCd, applySaveParams);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0006.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var i_0006_url = __webpack_require__("kspH");

/* harmony default export */ var i_0006 = ({
  mixins: [css],
  components: {
    ElImageViewer: image_src_image_viewer
  },
  data: function data() {
    return {
      ApplyCheck: false,
      backside1ImageList: [],
      backside2ImageList: [],
      backside1Url: '',
      backside2Url: '',
      backside1Btn: true,
      backside2Btn: true,
      applyDate: '',
      confirmDate: '',
      statusDate: '',
      statusFatDate: '',
      backside1Css: true,
      myNoCfmDivlist: [],
      myNoCfmDiv: '',
      tableData: [],
      photoList: {},
      myNoPhoto1: false,
      myNoPhoto2: false,
      myNo: '',
      pageShow: true,
      ButtonShow: '',
      i0005UsedNum: '',
      processCdNum: '',
      statusNum: '',
      statusName: '',
      processCdShow: '',
      myNumber: '',
      myNumberAffirm: '',
      backside1Dialog: false,
      backside2Dialog: false,
      backside1LongClick: false,
      backside2LongClick: false,
      value: '',
      myNoCfmDivValue: '',
      changeFlg: false,
      applySaveParams: {
        userCd: '',
        myNo: '',
        myNoCfmDiv: '',
        myNoPhoto1: '',
        myNoPhoto2: '',
        processCd: '',
        id: '',
        updateDate: ''
      },
      photoNum: '',
      photoUpdateList: [],
      SaveParams: []
    };
  },
  created: function created() {
    // login-User
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    this.myNoCfmDiv_select();
  },
  mounted: function mounted() {
    //点击删除按钮之外的地方退出长按模式
    var that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.imageLongClick = false;
        that.backside1LongClick = false; //是否为图片长按模式（true=长按模式）。
        that.backside2LongClick = false; //是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions' && e.target.className != 'el-icon-refresh-left' && e.target.className != 'el-icon-refresh-right' && e.target.className != 'el-icon-c-scale-to-original' && e.target.className != 'el-icon-zoom-in' && e.target.className != 'el-icon-zoom-out' && e.target.className != 'el-image-viewer__actions__inner' && e.target.className != 'el-icon-full-screen' && e.target.className != 'el-icon-circle-close' && e.target.className != 'el-button el-button--default el-button--small') {
        //关闭照片查看器
        that.backside1Dialog = false;
        that.backside2Dialog = false;
        that.othersExpensesDialog = false;
        that.transportExpensesTripDialog = false;
        that.accommodationDialog = false;
      }
    });
  },

  methods: {
    // 画像文件之前的钩子
    handleChange: function handleChange(file, fileList, itemName, type) {
      var _this = this;

      var file_type = file.raw.type;
      if (!(file_type === 'image/jpg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpeg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
      } else {
        if (this.photoUpdateList.indexOf(type) == -1) {
          this.photoUpdateList.push(type);
        }
        this[itemName + 'imageList'] = [];
        this[itemName + 'LongClick'] = false;
        if (file.status === "ready") {
          // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
          if (fileList.length === 2) {
            fileList.shift();
          }
        }
        this['myNoPhoto' + type] = true;
        // backside2ImageList
        this[itemName + 'imageList'].push(fileList[0]);
        this[itemName + 'Url'] = file.url;
        //拡張子
        var exhibitionName = file.name.split('.')[1];
        // // 写真パス：「image/personalPhoto/クルーコード/社員ID_店舗役職CD_種別_写真ID.jpg」
        this.applySaveParams['myNoPhoto' + type] = i_0006_url.imgUrl_UserInfo + this.userCd + '/myno' + '/' + type + '_' + this.getDateTimeToString() + '.' + exhibitionName;
        var that = this;
        this.getBase64(file.raw).then(function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
            var photo, files;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return that.compressImg(that.base64ToBlob(res));

                  case 2:
                    photo = _context.sent;
                    files = new window.File([photo], file.name, { type: file.type });

                    _this["photo" + type] = files;

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        this.changeFlg = true;
      }
    },


    // 图片转base64
    getBase64: function getBase64(file) {
      return new promise_default.a(function (resolve, reject) {
        var reader = new FileReader();
        var imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },


    // base转blob
    base64ToBlob: function base64ToBlob(file) {
      var byteString = void 0;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1]);
      } else {
        byteString = unescape(file.split(',')[1]);
      }
      var mimeString = file.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },


    // 压缩图片
    compressImg: function compressImg(file) {
      var that = this;
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new promise_default.a(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
                h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files);
          };
        };
      });
    },


    //input入力チェック
    i0006ApplicationOnClick: function i0006ApplicationOnClick() {
      var re = new RegExp(/\d{12}/);
      if (this.applySaveParams.myNo == null || this.applySaveParams.myNo == '') {
        this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_LABEL1')));
        return;
      }
      if (this.myNumberAffirm == null || this.myNumberAffirm == '') {
        this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_LABEL2')));
        return;
      }
      if (this.myNoCfmDivValue == null || this.myNoCfmDivValue == '') {
        this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_DATA_CONFIRM')));
        return;
      }
      if (this.applySaveParams.myNoPhoto1 == null || this.applySaveParams.myNoPhoto1 == '') {
        this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_FRONTPHOTO_SIDE')));
        return;
      }
      if (this.pageShow) {
        if (this.applySaveParams.myNoPhoto2 == null || this.applySaveParams.myNoPhoto2 == '') {
          this.$message.error(this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0006_LBL_BACKPHOTO_SIDE')));
          return;
        }
      }
      if (this.applySaveParams.myNo.length != 12) {
        this.$message.error(this.$t('COMMON.MSG_MYNO_VALIDITY'));
        return;
      }
      if (!re.test(this.applySaveParams.myNo)) {
        this.$message.error(this.$t('MODULE.I0006_ERR_MSG2'));
        return;
      }
      if (this.applySaveParams.myNo != this.myNumberAffirm) {
        this.$message.error(this.$t('MODULE.I0006_ERR_MSG3'));
        return;
      }
      this.ApplyConfirm();
    },

    //获取时间戳yyyymmddhhmmssfff
    getDateTimeToString: function getDateTimeToString() {
      var date_ = new Date();
      var year = date_.getFullYear();
      var month = date_.getMonth() + 1;
      var day = date_.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      var hours = date_.getHours();
      var mins = date_.getMinutes();
      var secs = date_.getSeconds();
      var msecs = date_.getMilliseconds();
      if (hours < 10) hours = "0" + hours;
      if (mins < 10) mins = "0" + mins;
      if (secs < 10) secs = "0" + secs;
      if (msecs < 10) {
        msecs = "00" + msecs;
      } else if (msecs < 100) {
        msecs = "0" + msecs;
      }
      return year.toString() + month.toString() + day.toString() + hours.toString() + mins.toString() + secs.toString() + msecs.toString();
    },

    // 確認資料を取得する。
    myNoCfmDiv_select: function myNoCfmDiv_select() {
      var _this2 = this;

      var page = 'all';
      var div = '50';
      var type = 'my_no_cfm_div';
      i_0006_conditionSearch(page, div, type).then(function (res) {
        _this2.myNoCfmDivlist = res.items.generalData.myNoCfmDiv;
        _this2.myNoInfo_select();
      });
    },

    // 初期値を取得する。
    myNoInfo_select: function myNoInfo_select() {
      var _this3 = this;

      this.photoInit();
      //实现Loading 加载方法
      this.set_loading();
      i_0006_myNoInfoGet(this.userCd).then(function (res) {
        _this3.applySaveParams.myNo = res.items.myNoInfo[0].myNo;
        _this3.applySaveParams.processCd = res.items.myNoInfo[0].processCd;
        _this3.statusName = res.items.myNoInfo[0].statusName;
        _this3.applyDate = res.items.myNoInfo[0].applyDate;
        _this3.confirmDate = res.items.myNoInfo[0].confirmDate;
        _this3.statusNum = res.items.myNoInfo[0].status;
        _this3.myNoCfmDivValue = res.items.myNoInfo[0].myNoCfmDiv;
        _this3.applySaveParams.myNoPhoto1 = res.items.myNoInfo[0].myNoPhoto1;
        _this3.applySaveParams.myNoPhoto2 = res.items.myNoInfo[0].myNoPhoto2;
        _this3.applySaveParams.id = res.items.myNoInfo[0].id;
        _this3.applySaveParams.updateDate = res.items.myNoInfo[0].updateDate;
        _this3.ApplyShow();
        _this3.ApplyBtnCheck();
        _this3.statusDateCheck();
        _this3.BackButtonCheck();
        _this3.photo2Show(_this3.myNoCfmDivValue);
        if (_this3.applySaveParams.myNoPhoto1) {
          _this3.download_Get(_this3.applySaveParams.myNoPhoto1, '1');
        }
        if (_this3.applySaveParams.myNoPhoto2) {
          _this3.download_Get(_this3.applySaveParams.myNoPhoto2, '2');
        }
        _this3.close_loading();
      }).catch(function (err) {
        _this3.close_loading();
      });
    },

    // 戻るボタン活性check
    BackButtonCheck: function BackButtonCheck() {
      var _this4 = this;

      i_0006_menuStateManagerGet(this.userCd).then(function (res) {
        _this4.i0005UsedNum = res.items.menuState[0].i0005Used;
        if (_this4.i0005UsedNum == 1) {
          _this4.ButtonShow = true;
        } else {
          _this4.ButtonShow = false;
        }
      });
    },

    // ステータス&日時、処理区分が「1」の場合は活性
    ApplyShow: function ApplyShow() {
      if (this.applySaveParams.processCd == 1) {
        this.processCdShow = true;
      } else {
        this.processCdShow = false;
      }
    },

    // 処理区分が「1：更新」 and  ステータスが「2：確認済」の場合、申請ボタンが非活性する。
    ApplyBtnCheck: function ApplyBtnCheck() {
      if (this.applySaveParams.processCd == 1 && this.statusNum == 2) {
        this.ApplyCheck = true;
      }
    },

    // 日時Check
    statusDateCheck: function statusDateCheck() {
      if (this.statusNum == 0) {
        this.statusFatDate = this.applyDate;
        this.statusDateFormat(this.statusFatDate);
      } else if (this.statusNum == 1 || this.statusNum == 2) {
        this.statusFatDate = this.confirmDate;
        this.statusDateFormat(this.statusFatDate);
      }
    },

    // 写真检索
    download_Get: function download_Get(photoPath, type) {
      var _this5 = this;

      this.photoUpdateList = [];
      this['backside' + type + 'ImageList'] = [];
      i_0006_photoFile_get(photoPath).then(function (res) {
        var blob = new Blob([res], { type: 'image/jpg' });
        var url = window.URL.createObjectURL(blob);
        _this5['backside' + type + 'ImageList'].push({ url: url });
        _this5.close_loading();
      }).catch(function () {
        _this5.close_loading();
      });
    },


    // 日期删掉毫秒
    statusDateFormat: function statusDateFormat(date) {
      var str = date;
      this.statusDate = str.substring(0, 19);
    },


    //確認資料判定
    select: function select(myNoCfmDivValue) {
      if (myNoCfmDivValue == "03") {
        this.pageShow = false;
        // if (this.photoUpdateList.length == 2) {
        //   for (var i = 0; i < this.photoUpdateList.length; i++) {
        //     if (this.photoUpdateList[i] == '2') {
        //       this.photoUpdateList.splice(i, 1);
        //     }
        //   }
        //   //this.photoUpdateList.pop()
        // }
      } else {
        this.pageShow = true;
      }
      this.changeFlg = true;
    },

    //初期確認資料判定
    photo2Show: function photo2Show(myNoCfmDivValue) {
      if (myNoCfmDivValue == "03") {
        this.pageShow = false;
      } else {
        this.pageShow = true;
      }
    },

    // 申請(12桁)判定
    MynoChange: function MynoChange() {
      this.changeFlg = true;
    },

    // 返回按钮点击事件
    back_click: function back_click() {
      var _this6 = this;

      if (this.changeFlg == true) {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_CHANGE_BACK'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: 'true'
        }).then(function () {
          var vm = _this6;
          vm.$router.push({ path: i_0006_url.routerUrl_I0005 });
        }).catch(function () {});
      } else {
        var vm = this;
        vm.$router.push({ path: i_0006_url.routerUrl_I0005 });
      }
    },

    //单张图片点击
    handlePictureCardPreview: function handlePictureCardPreview(file, dialogName) {
      if (this[dialogName + 'LongClick'] == true) {
        this[dialogName + 'LongClick'] = false;
      } else {
        this[dialogName + 'Url'] = file.url;
        this[dialogName + 'Dialog'] = true;
      }
    },

    //单张图片删除
    fileRemove: function fileRemove(file, fileList, itemName, type) {
      this.$refs[itemName].clearFiles();
      this[itemName + "Url"] = '';
      this[itemName + "LongClick"] = false;
      this.photoList[type] = '';
    },


    // 照片删除
    backside1PhotoDelete: function backside1PhotoDelete() {
      this.photoDelete('backside1', '1');
    },
    backside2PhotoDelete: function backside2PhotoDelete() {
      this.photoDelete('backside2', '2');
    },


    // 照片检索前数据初始化
    photoInit: function photoInit() {
      this.photoList = {};
      this.backside2ImageList = [];
      this.backside1ImageList = [];
      this.backside2Url = '';
      this.backside1Url = '';
    },

    // 申請确认
    ApplyConfirm: function ApplyConfirm() {
      var _this7 = this;

      this.$confirm(this.$t('COMMON.MSG_APPLY_CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 確認
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: 'true'
      }).then(function () {
        _this7.applyData();
      }).catch(function () {});
    },


    // 上传照片数量判定
    applyData: function applyData() {
      this.photoNum = 0;
      // 单张照片排他不上传
      if (!this.myNoPhoto1) {
        this.applySaveParams.myNoPhoto1 = null;
      }
      if (!this.myNoPhoto2) {
        this.applySaveParams.myNoPhoto2 = null;
      }

      if (this.photoUpdateList.length == 2 && this.myNoCfmDivValue == "03") {
        for (var i = 0; i < this.photoUpdateList.length; i++) {
          if (this.photoUpdateList[i] == '2') {
            this.photoUpdateList.splice(i, 1);
          }
        }
      }
      if (this.photoUpdateList.length > 0) {
        for (var i = 0; i < this.photoUpdateList.length; i++) {
          this.Photo_upload(this.photoUpdateList[i], this.photoUpdateList.length);
        }
      } else {
        this.ApplySave();
      }
    },


    // 写真毎に、API「アップロード」を呼び出す。
    Photo_upload: function Photo_upload(type, length) {
      var _this8 = this;

      var photoFormData = new FormData();
      photoFormData.append('files', this["photo" + type], this.applySaveParams["myNoPhoto" + type]);
      this.set_loading();
      i_0006_photoFile_saveImage(photoFormData).then(function (res) {
        _this8['myNoPhoto' + type] = false;
        if (res.code == 205) {
          _this8.photoNum += 1;
          if (_this8.photoNum == length) {
            _this8.ApplySave();
          }
          _this8.close_loading();
        } else if (res.code == 311) {
          _this8.close_loading();
          //图片上传失败
          _this8.$message.error({ message: _this8.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
        }
      }).catch(function (err) {
        _this8.close_loading();
      });
    },


    // 申请保存API
    ApplySave: function ApplySave() {
      var _this9 = this;

      this.applySaveParams.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
      this.applySaveParams.myNoCfmDiv = this.myNoCfmDivValue;
      if (!this.pageShow) {
        this.photo2Delete('backside2', '2');
        this.applySaveParams.myNoPhoto2 = '';
      }
      i_0006_Apply_Save(this.userCd, this.applySaveParams).then(function (res) {
        if (res.code == '202') {
          _this9.changeFlg = false;
          _this9.$message.success({ message: _this9.$t('COMMON.MSG_INSERTED'), showClose: true }); //保存成功
          _this9.myNoInfo_select();
        } else if (res.code == '311') {
          _this9.$message.error({ message: _this9.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
        } else if (res.code == '308') {
          // 処理が失敗しました。他の人が先に更新した可能性があります。最新情報を取得しますか。
          _this9.$confirm(_this9.$t('COMMON.EXCLUSIVE'), _this9.$t('COMMON.CONFIRM'), {
            confirmButtonText: _this9.$t('COMMON.MSG_DELETE_CONFIRM'), //はい
            cancelButtonText: _this9.$t('COMMON.MSG_DELETE_CANCEL'), //いいえ
            center: 'true'
          }).then(function () {
            // 画面刷新
            _this9.myNoInfo_select();
          }).catch(function () {});
        }
      });
    },


    // 删除确认
    photoDelete: function photoDelete(itemName, type) {
      var _this10 = this;

      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.BTN_CONFIRM'), // 確認
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: 'true'
      }).then(function () {
        //组件表示图片清空
        _this10.$refs[itemName].clearFiles();
        _this10.applySaveParams['myNoPhoto' + type] = '';
        //上传用list清空
        _this10[itemName + 'ImageList'] = [];
        _this10[itemName + 'Url'] = '';
        _this10[itemName + 'Dialog'] = false;
        _this10.photoList[type] = '';
        _this10.changeFlg = true;
      }).catch(function () {});
    },


    // 确认资料key是03时，删除裹面图片
    photo2Delete: function photo2Delete(itemName, type) {
      //组件表示图片清空
      this.$refs[itemName].clearFiles();
      this.applySaveParams['myNoPhoto' + type] = '';
      //上传用list清空
      this[itemName + 'ImageList'] = [];
      this[itemName + 'Url'] = '';
      this[itemName + 'Dialog'] = false;
      this.photoList[type] = '';
      this.changeFlg = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44cdd2f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0006.vue
var i_0006_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"background-color":"#fafafa","margin-top":"8px"}},[_c('el-row',{attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0006_LBL_TITLE')))])]),_vm._v(" "),_c('table',{staticClass:"i0006-table"},[_c('tr',{staticStyle:{"width":"100%"}},[_c('td',{staticClass:"i0006-form-label",staticStyle:{"line-height":"30px"}},[_vm._v("\n            "+_vm._s(_vm.$t('MODULE.I0006_LBL_LABEL1'))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"i0006-input-value"},[_c('el-input',{staticStyle:{"width":"89%","font-size":"12px"},attrs:{"maxlength":"12","pattern":"\\d*"},on:{"change":function($event){return _vm.MynoChange()},"input":function($event){_vm.applySaveParams.myNo = _vm.applySaveParams.myNo.replace(/[^\d]/g, '');}},model:{value:(_vm.applySaveParams.myNo),callback:function ($$v) {_vm.$set(_vm.applySaveParams, "myNo", $$v)},expression:"applySaveParams.myNo"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"red","font-size":"15px"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',{staticStyle:{"width":"100%"}},[_c('td',{staticClass:" i0006-form-label",staticStyle:{"line-height":"30px"}},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0006_LBL_LABEL2')))])]),_vm._v(" "),_c('td',{staticClass:"i0006-input-value"},[_c('el-input',{staticStyle:{"width":"89%","font-size":"12px"},attrs:{"maxlength":"12","pattern":"\\d*"},on:{"input":function($event){_vm.myNumberAffirm = _vm.myNumberAffirm.replace(/[^\d]/g, '');}},model:{value:(_vm.myNumberAffirm),callback:function ($$v) {_vm.myNumberAffirm=$$v},expression:"myNumberAffirm"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"red","font-size":"15px"}},[_vm._v("＊")])],1)])])])],1),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#fafafa","margin-top":"3px"}},[_c('el-row',{attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0006_LBL_SELF_CONFIRM')))])]),_vm._v(" "),_c('table',{staticClass:"i0006-table"},[_c('tr',{staticStyle:{"width":"100%"}},[_c('td',{staticClass:"i0006-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0006_LBL_DATA_CONFIRM')))]),_vm._v(" "),_c('td',{staticClass:"i0006_select_value"},[_c('el-select',{staticStyle:{"width":"91%"},on:{"change":function($event){return _vm.select(_vm.myNoCfmDivValue)}},model:{value:(_vm.myNoCfmDivValue),callback:function ($$v) {_vm.myNoCfmDivValue=$$v},expression:"myNoCfmDivValue"}},_vm._l((_vm.myNoCfmDivlist),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.key}})}),1),_vm._v(" "),_c('span',{staticStyle:{"color":"red","font-size":"15px"}},[_vm._v("＊")])],1)])])]),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid #ccc","border-top":"none"}},[_c('table',{staticClass:"i0006-upload-table"},[_c('tr',[_c('td',{staticClass:"i0006-form-photolabel",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0006_LBL_FRONT_SIDE'))}}),_vm._v(" "),_c('td',{staticClass:"i0006-form-value"},[_c('div',{staticClass:"div_input_i0006"},[(!_vm.applySaveParams.myNoPhoto1)?_c('div',{staticClass:"i0006_photo_border"}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"color":"red","float":"right","margin-top":"15px","margin-right":"2px","font-size":"15px"}},[_vm._v("＊")]),_vm._v(" "),_c('el-upload',{ref:"backside1",staticClass:"i0006_photo_upload",attrs:{"file-list":_vm.backside1ImageList,"show-file-list":true,"list-type":"picture-card","limit":2,"accept":".jpg,.gif,.png,.bmp,.jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'backside1','1')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"backside1Img","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'backside1')}}},[(_vm.backside1LongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'backside1','1')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.backside1Dialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.backside1PhotoDelete,"url-list":[_vm.backside1Url]}}):_vm._e()],1)])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageShow),expression:"pageShow"}]},[_c('td',{staticClass:"i0006-form-photolabel"},[_vm._v(_vm._s(_vm.$t('MODULE.I0006_LBL_BACK_SIDE')))]),_vm._v(" "),_c('td',{staticClass:"i0006-form-value"},[_c('div',{staticClass:"div_input_i0006"},[(!_vm.applySaveParams.myNoPhoto2)?_c('div',{staticClass:"i0006_photo_border"}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"color":"red","float":"right","margin-top":"15px","margin-right":"2px","font-size":"15px"}},[_vm._v("＊")]),_vm._v(" "),_c('el-upload',{ref:"backside2",staticClass:"i0006_photo_upload",attrs:{"file-list":_vm.backside2ImageList,"show-file-list":true,"list-type":"picture-card","limit":2,"accept":".jpg,.gif,.png,.bmp,.jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'backside2','2')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"backside2Img","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'backside2')}}},[(_vm.backside1LongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'backside2','2')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.backside2Dialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.backside2PhotoDelete,"url-list":[_vm.backside2Url]}}):_vm._e()],1)])])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageShow),expression:"pageShow"}],staticClass:"i0006_MSG",staticStyle:{"font-size":"13px","color":"red","margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0006_LBL_TEXT')))])])],1),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.processCdShow),expression:"processCdShow"}]},[_c('td',[_c('p',{staticStyle:{"font-size":"13px"},domProps:{"innerHTML":_vm._s(_vm.statusName)}})]),_vm._v(" "),_c('td',[_c('p',{staticStyle:{"font-size":"13px","padding-left":"10px"},domProps:{"innerHTML":_vm._s(_vm.statusDate)}})])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"},attrs:{"align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary","disabled":_vm.ApplyCheck},on:{"click":function($event){return _vm.i0006ApplicationOnClick()}}},[_vm._v(_vm._s(_vm.$t('MODULE.I0006_LBL_APPLY')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.ButtonShow),expression:"ButtonShow"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.back_click()}}},[_vm._v(_vm._s(_vm.$t('MODULE.I0006_LBL_BACK')))])],1)])}
var i_0006_staticRenderFns = []
var i_0006_esExports = { render: i_0006_render, staticRenderFns: i_0006_staticRenderFns }
/* harmony default export */ var page_i_0006 = (i_0006_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0006.vue
function i_0006_injectStyle (ssrContext) {
  __webpack_require__("LgX+")
}
var i_0006_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0006___vue_template_functional__ = false
/* styles */
var i_0006___vue_styles__ = i_0006_injectStyle
/* scopeId */
var i_0006___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0006___vue_module_identifier__ = null
var i_0006_Component = i_0006_normalizeComponent(
  i_0006,
  page_i_0006,
  i_0006___vue_template_functional__,
  i_0006___vue_styles__,
  i_0006___vue_scopeId__,
  i_0006___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0006 = (i_0006_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0007.js




var i_0007_apiUrl = __webpack_require__("kspH");

// マスタデータ
var i_0007_conditionSearch = function conditionSearch(page, div) {
    return api_public.requestQuickGet(i_0007_apiUrl.apiurl_masterData + '/' + page + '/' + div);
};

// 検索
var i_0007_residentCardGet = function residentCardGet(userCd) {
    return api_public.requestGet(i_0007_apiUrl.apiUrl_ResidentCard + '?userId=' + userCd);
};

// 保存
var i_0007_residentCardSave = function residentCardSave(params) {
    return api_public.requestPost(i_0007_apiUrl.apiUrl_ResidentCard, params);
};

//图片查询
var i_0007_i_0007_getImage = function i_0007_getImage(filePath, resizeCd) {
    return api_public.requestQuickGetImage('/api/v1/files?filePath=' + encodeURIComponent(filePath) + '&resizeCd=' + resizeCd);
};

//图片更新
var i_0007_i_0007_saveImage = function i_0007_saveImage(params) {
    return api_public.requestPostFormData('/api/v1/files', params);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0007.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var i_0007_url = __webpack_require__("kspH");
/* harmony default export */ var i_0007 = ({
  mixins: [css],
  components: {
    ElImageViewer: image_src_image_viewer
  },
  data: function data() {
    return {
      nationality: [], //国籍
      residentCard: {
        userCd: '', //社員コード
        applyDate: '', //申請日時
        status: '', //ステータス
        statusValue: '', //申請状態
        confirmDate: '', //確認日時
        confirmUserCd: '', //確認者
        approvalDate: '', //承認日時
        approvalUserCd: '', //承認者
        transmitFlag: '', //連携フラグ
        transmitDate: '', //連携日時
        updateDate: '', //更新日時
        residenceCardName: '', //在留カード氏名
        nationalityCode: '', //国籍
        cardNo: '', //カード番号
        cardExpDate: '', //カード期限
        residenceCardPhoto1: '', //在留カード写真1
        residenceCardPhoto2: '' //在留カード写真2
      }, //在留カード情報
      nationalityCode: '',
      photo1: '',
      photo2: '',
      photo1List: [],
      photo2List: [],
      photo1Dialog: false,
      photo2Dialog: false,
      photoSum: 0,
      photo1Path: '',
      photo2Path: '',
      photoUpdate1: false,
      photoUpdate2: false,
      regionCode: '',
      saveParams: [], //申请参数

      driveLicensePhoto1LongClick: false, //是否为图片长按模式（true=长按模式）。
      driveLicensePhoto2LongClick: false //是否为图片长按模式（true=长按模式）。
    };
  },
  created: function created() {
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    this.search();
  },

  methods: {
    // マスタデータ
    search: function search() {
      var _this = this;

      var page = 'aa';
      var div = '21';
      i_0007_conditionSearch(page, div).then(function (res) {
        _this.nationality = res.items.mstNationality;
        _this.query();
      });
    },


    // 在留カード情報検索
    query: function query() {
      var _this2 = this;

      //实现Loading 加载方法
      this.set_loading();
      this.photoSum = 0;
      i_0007_residentCardGet(this.userCd).then(function (res) {
        if (res.items.residentCard.length > 0) {
          _this2.residentCard = res.items.residentCard[0];
        }
        _this2.photo1List = [];
        _this2.photo2List = [];
        _this2.residentCard.nationalityCode = _this2.residentCard.nationalityDiv ? _this2.residentCard.nationalityDiv : _this2.nationality[0].nationalityCode;
        _this2.nationalityCode = _this2.residentCard.nationalityCode;
        _this2.regionCode = _this2.residentCard.regionCode ? _this2.residentCard.regionCode : _this2.nationality[0].regionCode;
        // photo1Path与residenceCardPhoto1进行比较，判断写真是否有变更）
        _this2.photo1Path = _this2.residentCard.residenceCardPhoto1;
        _this2.photo2Path = _this2.residentCard.residenceCardPhoto2;
        if (_this2.residentCard.residenceCardPhoto1) {
          _this2.photoSum += 1;
          _this2.photoQuery(_this2.residentCard.residenceCardPhoto1, 'photo1List');
        }
        if (_this2.residentCard.residenceCardPhoto2) {
          _this2.photoSum += 1;
          _this2.photoQuery(_this2.residentCard.residenceCardPhoto2, 'photo2List');
        }
        if (!_this2.residentCard.residenceCardPhoto1 && !_this2.residentCard.residenceCardPhoto2) {
          _this2.close_loading();
        }
      }).catch(function (err) {
        _this2.close_loading();
      });
    },


    // 写真检索
    photoQuery: function photoQuery(filePath, fileListName) {
      var _this3 = this;

      this[fileListName] = [];
      this.photoSum -= 1;
      var resizeCd = '0';
      var fileUrl = {};
      fileUrl.name = filePath.split('/')[filePath.split('/').length - 1];
      i_0007_i_0007_getImage(filePath, resizeCd).then(function (res_file) {
        var blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' });
        var url = window.URL.createObjectURL(blob);
        fileUrl.url = url;
        if (fileUrl.name.indexOf("%26") !== -1) {
          fileUrl.name = fileUrl.name.replace('%26', '&');
        }
        if (fileUrl.name.indexOf("%2F") !== -1) {
          fileUrl.name = fileUrl.name.replace('%2F', '/');
        }
        if (fileUrl.name.indexOf("%3F") !== -1) {
          fileUrl.name = fileUrl.name.replace('%3F', '?');
        }
        if (fileUrl.name.indexOf("%23") !== -1) {
          fileUrl.name = fileUrl.name.replace('%23', '#');
        }
        if (fileUrl.name.indexOf("%25") !== -1) {
          fileUrl.name = fileUrl.name.replace('%25', '%');
        }
        _this3[fileListName].push(fileUrl);
        if (_this3.photoSum == 0) {
          _this3.close_loading();
        }
      }).catch(function (err) {
        _this3.close_loading();
      });
    },


    // 在留カード情報申请
    residentCardApply: function residentCardApply() {
      var _this4 = this;

      if (!this.saveParamsCheck()) {
        return;
      }
      //データを保存します。よろしいでしょうか？
      this.$confirm(this.$t('COMMON.MSG_CONFIRM_CHANGE'), this.$t('COMMON.CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //いいえ
        customClass: 'i0007textCenter'
      }).then(function () {
        // はい：処理を続ける					
        _this4.confirmApply();
      }).catch(function () {
        //いいえ：処理せず
      });
    },


    //  はい：処理を続ける
    confirmApply: function confirmApply() {
      this.photoSum = 0;
      this.saveParamsGet();
      //实现Loading 加载方法
      this.set_loading();
      // 写真变更の場合 
      if (this.photoUpdate1) {
        this.photoSave(this.photo1, this.residentCard.residenceCardPhoto1, '1');
      }
      if (this.photoUpdate2) {
        this.photoSave(this.photo2, this.residentCard.residenceCardPhoto2, '2');
      }
      if (!this.photoUpdate1 && !this.photoUpdate2) {
        this.paramsSave();
      }
    },


    // 在留カード情報保存
    paramsSave: function paramsSave() {
      var _this5 = this;

      i_0007_residentCardSave(this.saveParams).then(function (res) {
        if (res.code === 202) {
          _this5.changeFgl = false;
          _this5.$message.success({ message: _this5.$t('COMMON.MSG_INSERTED'), showClose: true }); // 保存しました。
          _this5.query();
        } else if (res.code === 308) {
          _this5.$confirm(_this5.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this5.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: _this5.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            customClass: 'i0007textCenter'
          }).then(function () {
            _this5.query();
          }).catch(function () {
            _this5.close_loading();
          });
        } else if (res.code === 311) {
          _this5.$message.error({ message: _this5.$t('COMMON.CURD_ERROR'), showClose: true }); //処理が失敗しました。
          _this5.close_loading();
        }
      });
    },


    // 写真保存
    photoSave: function photoSave(photoFiles, photoPath, type) {
      var _this6 = this;

      var photoFormData = new FormData();
      photoFormData.append('files', photoFiles, photoPath);
      i_0007_i_0007_saveImage(photoFormData).then(function (res) {
        _this6['photoUpdate' + type] = false;
        _this6.photoSum += 1;
        // 变更的写真都成功上传后，保存申请参数
        if (!_this6.photoUpdate1 && !_this6.photoUpdate2) {
          if (res.code == 205) {
            _this6.paramsSave();
          } else if (res.code == 311) {
            //图片上传失败
            _this6.$message.error({ message: _this6.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
            _this6.close_loading();
          }
        }
      });
    },


    // 申请参数
    saveParamsGet: function saveParamsGet() {
      this.saveParams = [];
      var params = {};
      //ステータスは3：承認済の場合、新規と見なす
      params.userId = this.userCd; // 社員コード
      params.residenceCardName = this.residentCard.residenceCardName; // 氏名
      params.nationalityDiv = this.nationalityCode; // 国籍
      params.cardNo = this.residentCard.cardNo; // カード番号
      params.cardExpDate = this.residentCard.cardExpDate; // カード期限
      params.regionCode = this.regionCode;
      // 写真变更の場合\
      params.residenceCardPhoto1 = this.photoUpdate1 ? this.residentCard.residenceCardPhoto1 : null; // 在留カード写真
      params.residenceCardPhoto2 = this.photoUpdate2 ? this.residentCard.residenceCardPhoto2 : null; // 在留カード裏写真

      if (this.residentCard.status == '3' || this.residentCard.status == '') {
        params.id = null;
        params.updateDate = null;
      } else {
        params.id = this.residentCard.id;
        params.updateDate = this.residentCard.updateDate;
      }
      this.saveParams.push(params);
    },


    // 保存参数check
    saveParamsCheck: function saveParamsCheck() {
      //  氏名
      if (!this.residentCard.residenceCardName) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0007_LBL_FULLNAME').split('<br />')[0]), showClose: true });
        return false;
      }
      //  在留カード番号
      if (!this.residentCard.cardNo) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0007_LBL_RESIDENCE_CARD_NO').split('<br />')[0]), showClose: true });
        return false;
      }
      //  在留カード期限
      if (!this.residentCard.cardExpDate) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0007_LBL_RESIDENCE_CARD_EXP').split('<br />')[0]), showClose: true });
        return false;
      }
      //  在留カード写真
      if (!this.residentCard.residenceCardPhoto1) {
        this.$message.error({ message: this.$t('MODULE.I0007_MSG_UPLOAD_PHOTO_FRONT'), showClose: true });
        return false;
      }
      //  在留カード裏写真
      if (!this.residentCard.residenceCardPhoto2) {
        this.$message.error({ message: this.$t('MODULE.I0007_MSG_UPLOAD_PHOTO_BACK'), showClose: true });
        return false;
      }
      return true;
    },


    // 图片上传选择
    handleChange: function handleChange(file, fileList, type) {
      var _this7 = this;

      var file_type = file.raw.type;
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
        return;
      }

      this['photo' + type + 'LongClick'] = false;
      if (file.status === "ready") {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length === 2) {
          fileList.shift();
        }
      }
      this['photoUpdate' + type] = true;
      var that = this;
      // 压缩
      var blob = new Blob([file.raw], { type: file.raw.type });
      this.compressImg(blob, file.name).then(function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // 照片文件
                  that['photo' + type] = res;
                  //写真アップロード時のＵＲＬ: image/userInfo/社員コード/residentCard/1_yyyyMMddHHmmssSSS.拡張子																					
                  that.residentCard['residenceCardPhoto' + type] = i_0007_url.imgUrl_UserInfo + that.userCd + '/residentCard/' + type + '_' + utils.timeNumberGet() + '.' + file.name.split('.').pop();

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this7);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },


    // base转file
    base64ToFile: function base64ToFile(file, fileName) {
      var arr = file.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },


    // 压缩图片
    compressImg: function compressImg(file, fileName) {
      var that = this;
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new promise_default.a(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
                h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToFile(base64, fileName); //如果后台接收类型为base64的话这一步可以省略
            resolve(files);
          };
        };
      });
    },


    //单张图片点击
    handlePhotoPreview: function handlePhotoPreview(file, type) {
      this['photo' + type + 'Url'] = file.url;
      this['photo' + type + 'Dialog'] = true;
    },

    // 照片1删除
    photoOneDelete: function photoOneDelete() {
      var _this8 = this;

      // 写真を削除しても、よろしいでしょうか？
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(function () {
        //组件表示图片清空
        _this8.photo1List = [];
        _this8.residentCard.residenceCardPhoto1 = "";
        //上传用list清空
        _this8.photo1Url = '';
        _this8.photo1Dialog = false;
        _this8.photo1Img = {};
      }).catch(function () {});
    },

    // 照片2删除
    photoTwoDelete: function photoTwoDelete() {
      var _this9 = this;

      // 写真を削除しても、よろしいでしょうか？
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(function () {
        //组件表示图片清空
        _this9.photo2List = [];
        _this9.residentCard.residenceCardPhoto2 = "";
        //上传用list清空
        _this9.photo2Url = '';
        _this9.photo2Dialog = false;
        _this9.photo2Img = {};
      }).catch(function () {});
    },


    // 地域コード取得
    regionCodeGet: function regionCodeGet(val) {
      var nationality = {};
      nationality = this.nationality.find(function (item) {
        return item.nationalityCode === val;
      });
      // 地域コード
      this.regionCode = nationality.regionCode;
    },


    // 戻る
    back: function back() {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    //点击删除按钮之外的地方退出长按模式
    var that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.driveLicensePhoto1LongClick = false; //是否为图片长按模式（true=长按模式）。
        that.driveLicensePhoto2LongClick = false; //是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions' && e.target.className != 'el-icon-refresh-left' && e.target.className != 'el-icon-refresh-right' && e.target.className != 'el-icon-c-scale-to-original' && e.target.className != 'el-icon-zoom-in' && e.target.className != 'el-icon-zoom-out' && e.target.className != 'el-image-viewer__actions__inner' && e.target.className != 'el-icon-full-screen' && e.target.className != 'el-icon-circle-close' && e.target.className != 'el-button el-button--default el-button--small') {
        //关闭照片查看器
        that.photo1Dialog = false;
        that.photo2Dialog = false;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28225166","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0007.vue
var i_0007_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('el-row',{attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.$t('MODULE.I0007_LBL_TITLE')))])]),_vm._v(" "),_c('table',{staticClass:"i0007-table table-label"},[_c('tr',[_c('td',{staticClass:"i0007-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0007_LBL_FULLNAME'))}}),_vm._v(" "),_c('td',{staticClass:"i0007-form-value"},[_c('el-input',{staticClass:"i0007-input",attrs:{"maxlength":"100"},model:{value:(_vm.residentCard.residenceCardName),callback:function ($$v) {_vm.$set(_vm.residentCard, "residenceCardName", $$v)},expression:"residentCard.residenceCardName"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0007-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0007_LBL_NATIONALITY'))}}),_vm._v(" "),_c('td',{staticClass:"i0007-form-value"},[_c('el-select',{staticStyle:{"width":"94%"},on:{"change":function($event){return _vm.regionCodeGet(_vm.nationalityCode)}},model:{value:(_vm.nationalityCode),callback:function ($$v) {_vm.nationalityCode=$$v},expression:"nationalityCode"}},_vm._l((_vm.nationality),function(item,key){return _c('el-option',{key:item.nationalityCode,attrs:{"label":item.nationalityName,"value":item.nationalityCode}})}),1),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0007-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0007_LBL_RESIDENCE_CARD_NO'))}}),_vm._v(" "),_c('td',{staticClass:"i0007-form-value"},[_c('el-input',{staticClass:"i0007-input",attrs:{"maxlength":"20"},model:{value:(_vm.residentCard.cardNo),callback:function ($$v) {_vm.$set(_vm.residentCard, "cardNo", $$v)},expression:"residentCard.cardNo"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0007-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0007_LBL_RESIDENCE_CARD_EXP'))}}),_vm._v(" "),_c('td',{staticClass:"i0007-form-value"},[_c('el-date-picker',{staticClass:"i0007-picker",attrs:{"editable":false,"format":"yyyy/MM/dd","value-format":"yyyy/MM/dd","clearable":false,"type":"date"},model:{value:(_vm.residentCard.cardExpDate),callback:function ($$v) {_vm.$set(_vm.residentCard, "cardExpDate", $$v)},expression:"residentCard.cardExpDate"}}),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0007-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0007_LBL_RESIDENCE_CARD_FRONTSIDEPHOTO'))}}),_vm._v(" "),_c('td',{staticClass:"i0007-form-value"},[(!_vm.residentCard.residenceCardPhoto1)?_c('div',{staticClass:"i0007_photo_border"}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"color":"red","float":"right","margin-top":"15px"}},[_vm._v("＊")]),_vm._v(" "),_c('el-upload',{ref:"photo1",staticClass:"i0007_photo_upload",attrs:{"file-list":_vm.photo1List,"show-file-list":true,"list-type":"picture-card","limit":2,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'1')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"photo1Img","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePhotoPreview(file,'1')}}},[(_vm.driveLicensePhoto1LongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'1','1')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.photo1Dialog)?_c('el-image-viewer',{staticClass:"i0007_photo_icon",attrs:{"on-close":_vm.photoOneDelete,"url-list":[_vm.photo1Url]}}):_vm._e()],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0007-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0007_LBL_RESIDENCE_CARD_BACKSIDEPHOTO'))}}),_vm._v(" "),_c('td',{staticClass:"i0007-form-value"},[(!_vm.residentCard.residenceCardPhoto2)?_c('div',{staticClass:"i0007_photo_border"}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"color":"red","float":"right","margin-top":"15px"}},[_vm._v("＊")]),_vm._v(" "),_c('el-upload',{ref:"photo2",staticClass:"i0007_photo_upload",attrs:{"file-list":_vm.photo2List,"show-file-list":true,"list-type":"picture-card","limit":2,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'2')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"photo2Img","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePhotoPreview(file,'2')}}},[(_vm.driveLicensePhoto2LongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'2','1')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.photo2Dialog)?_c('el-image-viewer',{staticClass:"i0007_photo_icon",attrs:{"on-close":_vm.photoTwoDelete,"url-list":[_vm.photo2Url]}}):_vm._e()],1)])]),_vm._v(" "),_c('el-row',{staticStyle:{"font-size":"13px","padding-top":"5px"}},[_c('span',[_vm._v(_vm._s(_vm.residentCard.statusValue))])]),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center","padding-top":"10px"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"disabled":_vm.residentCard.status=='2',"type":"primary"},on:{"click":_vm.residentCardApply}},[_vm._v(_vm._s(_vm.$t('MODULE.I0007_LBL_APPLY')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%","margin-left":"10px"},attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('MODULE.I0007_LBL_BACK')))])],1)],1)],1)])}
var i_0007_staticRenderFns = []
var i_0007_esExports = { render: i_0007_render, staticRenderFns: i_0007_staticRenderFns }
/* harmony default export */ var page_i_0007 = (i_0007_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0007.vue
function i_0007_injectStyle (ssrContext) {
  __webpack_require__("Avw6")
}
var i_0007_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0007___vue_template_functional__ = false
/* styles */
var i_0007___vue_styles__ = i_0007_injectStyle
/* scopeId */
var i_0007___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0007___vue_module_identifier__ = null
var i_0007_Component = i_0007_normalizeComponent(
  i_0007,
  page_i_0007,
  i_0007___vue_template_functional__,
  i_0007___vue_styles__,
  i_0007___vue_scopeId__,
  i_0007___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0007 = (i_0007_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0008.js



var i_0008_apiUrl = __webpack_require__("kspH");
// マイカー通勤申請検索
var i_0008_i_0008_privateCarInfoQuery = function i_0008_privateCarInfoQuery(userCd) {
  return api_public.requestQuickGet(i_0008_apiUrl.apiUrl_PrivateCarInfo + '?userCd=' + userCd);
};
// マイカー通勤申請更新
var i_0008_i_0008_update = function i_0008_update(params) {
  return api_public.requestPost(i_0008_apiUrl.apiUrl_PrivateCarInfo + '?userCd=' + params.userCd, [params]);
};

// マイカー通勤申請图片查询
var i_0008_i_0008_photoFile_get = function i_0008_photoFile_get(photoPath) {
  return api_public.requestQuickGetImage(i_0008_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0');
};

// マイカー通勤申請图片更新
var i_0008_i_0008_saveImage = function i_0008_saveImage(formData) {
  return api_public.requestPostFormData(i_0008_apiUrl.apiUrl_filesUpdate, formData);
};
// EXTERNAL MODULE: ./node_modules/vue-pdf/src/componentFactory.js
var componentFactory = __webpack_require__("iwQb");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-pdf/src/vuePdfNoSss.vue
//




if (Object({"NODE_ENV":"production"}).VUE_ENV !== 'server') {

	var pdfjsWrapper = __webpack_require__("ytml").default;
	var PDFJS = __webpack_require__("nKpR");

	if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {

		var PdfjsWorker = __webpack_require__("ahHh");
		PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker();
	}

	var component = Object(componentFactory["a" /* default */])(pdfjsWrapper(PDFJS));
} else {

	var component = Object(componentFactory["a" /* default */])({});
}

/* harmony default export */ var vuePdfNoSss = (component);
// CONCATENATED MODULE: ./node_modules/vue-pdf/src/vuePdfNoSss.vue
function vuePdfNoSss_injectStyle (ssrContext) {
  __webpack_require__("1qEj")
}
var vuePdfNoSss_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var vuePdfNoSss___vue_template_functional__ = false
/* styles */
var vuePdfNoSss___vue_styles__ = vuePdfNoSss_injectStyle
/* scopeId */
var vuePdfNoSss___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var vuePdfNoSss___vue_module_identifier__ = null
var vuePdfNoSss_Component = vuePdfNoSss_normalizeComponent(
  vuePdfNoSss,
  __vue_template__,
  vuePdfNoSss___vue_template_functional__,
  vuePdfNoSss___vue_styles__,
  vuePdfNoSss___vue_scopeId__,
  vuePdfNoSss___vue_module_identifier__
)

/* harmony default export */ var src_vuePdfNoSss = (vuePdfNoSss_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/pdf.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pdf = ({
  name: "attachPreview",
  components: { pdf: src_vuePdfNoSss },
  props: ["src"],
  data: function data() {
    return {
      filesProps: {
        label: "originName"
      },
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf" // 文件类型
    };
  },
  created: function created() {},

  methods: {
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage: function changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },

    // pdf加载时
    loadPdfHandler: function loadPdfHandler() {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
    close: function close() {
      this.$emit('pdfClose');
    },


    //附件下载
    download: function download() {
      var url = this.src.url;
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', this.src.name);
      document.body.appendChild(link);
      link.click(link);
      // 下载完成移除元素
      document.body.removeChild(link);
      // 释放掉blob对象
      //window.URL.revokeObjectURL(url);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fd41d3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/pdf.vue
var pdf_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfDialog"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileType == 'pdf'),expression:"fileType == 'pdf'"}],staticClass:"pdf"},[_c('p',{staticClass:"arrow"},[_c('span',{staticClass:"currentPage",class:{ grey: _vm.currentPage == 1 },on:{"click":function($event){return _vm.changePdfPage(0)}}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_PREVIOUS_PAGE'))+"  ")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#c2c2c2"}},[_vm._v(_vm._s(_vm.currentPage)+" / "+_vm._s(_vm.pageCount))]),_vm._v(" "),_c('span',{staticClass:"currentPage",class:{ grey: _vm.currentPage == _vm.pageCount },on:{"click":function($event){return _vm.changePdfPage(1)}}},[_vm._v("  "+_vm._s(_vm.$t('COMMON.BTN_NEXT_PAGE')))]),_vm._v("    "),_c('el-button',{attrs:{"icon":"el-icon-download","type":"primary","size":"mini"},on:{"click":function($event){return _vm.download()}}}),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding-right":"20px","font-size":"20px","color":"#c2c2c2","cursor":"pointer"},on:{"click":_vm.close}},[_c('i',{staticClass:"el-icon-close"})])],1),_vm._v(" "),_c('pdf',{attrs:{"src":_vm.src.url,"page":_vm.currentPage},on:{"num-pages":function($event){_vm.pageCount = $event},"page-loaded":function($event){_vm.currentPage = $event},"loaded":_vm.loadPdfHandler}})],1)])}
var pdf_staticRenderFns = []
var pdf_esExports = { render: pdf_render, staticRenderFns: pdf_staticRenderFns }
/* harmony default export */ var page_pdf = (pdf_esExports);
// CONCATENATED MODULE: ./src/components/page/pdf.vue
function pdf_injectStyle (ssrContext) {
  __webpack_require__("8uC3")
}
var pdf_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pdf___vue_template_functional__ = false
/* styles */
var pdf___vue_styles__ = pdf_injectStyle
/* scopeId */
var pdf___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pdf___vue_module_identifier__ = null
var pdf_Component = pdf_normalizeComponent(
  pdf,
  page_pdf,
  pdf___vue_template_functional__,
  pdf___vue_styles__,
  pdf___vue_scopeId__,
  pdf___vue_module_identifier__
)

/* harmony default export */ var components_page_pdf = (pdf_Component.exports);

// EXTERNAL MODULE: ./node_modules/browser-image-compression/dist/browser-image-compression.mjs
var browser_image_compression = __webpack_require__("U0rC");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0008.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var i_0008_url = __webpack_require__("kspH");
/* harmony default export */ var i_0008 = ({
  mixins: [css],
  components: {
    ElImageViewer: image_src_image_viewer,
    Pdf: components_page_pdf
  },
  data: function data() {
    return {
      obj: [],
      fileList: [], //放大图片

      driveLicensePhoto1Css: true, //图片边框样式
      driveLicensePhoto2Css: true,
      carVerificationPhotoCss: true,
      insuranceExpPhotoCss: true,
      insuranceExpPhoto2Css: true,

      driveLicensePhoto1Url: '', //图片URL
      driveLicensePhoto2Url: '',
      carVerificationPhotoUrl: '',
      insuranceExpPhotoUrl: '',
      insuranceExpPhoto2Url: '',

      driveLicensePhoto1Dialog: false, //照片查看Dialog
      driveLicensePhoto2Dialog: false,
      carVerificationPhotoDialog: false,
      insuranceExpPhotoDialog: false,
      insuranceExpPhoto2Dialog: false,

      changeFlg: false,
      driveLicensePhoto1List: [],
      driveLicensePhoto2List: [],
      carVerificationPhotoList: [],
      insuranceExpPhotoList: [],
      insuranceExpPhoto2List: [],
      photoListSave: [],

      driveLicensePhoto1Image: {},
      driveLicensePhoto2Image: {},
      carVerificationPhotoImage: {},
      insuranceExpPhotoImage: {},
      insuranceExpPhoto2Image: {},

      privateCarInfoData: {},

      carNo: '', //マイカー番号
      driveLicenseExpDate: '', //免許証期限
      driveLicensePhoto1: '', //免許証写真1
      driveLicensePhoto2: '', //免許証写真2
      carVerificationExpDate: '', //車検証期限
      carVerificationPhoto: '', //車検証写真
      insuranceExpDate: '', //保険期限
      insuranceExpPhoto: '', //保険写真
      insuranceExpPhoto2: '', //保険写真2
      persionalInsurance: '', //対人保証
      othersInsurance: '', //対物保証
      personalInjuryCompensation: '', //人身傷害補償
      applyDate: '', //申請日時
      id: '', //申請番号
      processCd: '', //処理区分
      status: '', //ステータス
      statusName: '', //ステータス名
      confirmDate: '', //確認日時
      updateDate: '', //更新日時
      userCd: '',
      timeShow: '', //日時表示
      updateChange: {}, //用来判断返回上个页面时，页面是否与初始查询的数据有变更
      //文件上传
      filesPdf: [], //更新时文件list
      filePdfList: [], //检索文件list
      blobFile: {},
      fileTotal: 0, //文件总大小
      filePdfUrl: "",
      timeFormat: 0,
      //PDF
      viewVisible: false,
      pdfUrl: ''
    };
  },

  methods: {
    // 画像文件之前的钩子
    handleChange: function handleChange(file, fileList, itemName, type) {
      var _this = this;

      var file_type = file.raw.type;
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
      } else {
        if (file.status === "ready") {
          // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
          if (fileList.length === 2) {
            fileList.shift();
          }
        }
        this[itemName + 'Url'] = file.url;
        var that = this;
        // 写真パス：「image/userInfo/社員コード/mycar/drivelicense1_yyyymmddhhmmssfff.jpg」
        // 写真パス：「image/userInfo/社員コード/mycar/drivelicense2_yyyymmddhhmmssfff.jpg」
        // 写真パス：「image/userInfo/社員コード/mycar/carverification_yyyymmddhhmmssfff.jpg」
        // 写真パス：「image/userInfo/社員コード/mycar/insurance_yyyymmddhhmmssfff.jpg」
        // 写真パス：「image/userInfo/社員コード/mycar/insurance2_yyyymmddhhmmssfff.jpg」
        this.getBase64(file.raw).then(function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
            var options, photo, files, photoPath, exhibitionName;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // 压缩设定
                    options = {
                      maxSizeMB: 1,
                      maxWidthOrHeight: 1920,
                      useWebWorker: true
                      // 压缩图片
                    };
                    _context.next = 3;
                    return Object(browser_image_compression["a" /* default */])(file.raw, options).catch(function () {
                      _this.$message.error({ message: _this.$t('COMMON.MSG_CURD_ERROR'), showClose: true });
                    });

                  case 3:
                    photo = _context.sent;
                    files = new window.File([photo], file.name, { type: file.type });
                    photoPath = '';
                    //拡張子

                    exhibitionName = file.name.split('.')[1];


                    if (type == '1') {
                      //運転免許証期限表面写真
                      photoPath = i_0008_url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'drivelicense1' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
                      _this.driveLicensePhoto1Image = {};
                      _this.driveLicensePhoto1Image.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
                      _this.driveLicensePhoto1Image.files = files;
                      _this.driveLicensePhoto1Image.photoId = "1";
                      _this.driveLicensePhoto1Image.photoPath = photoPath;
                      _this.driveLicensePhoto1Image.type = "1";
                    } else if (type == '2') {
                      //運転免許証期限裏面写真
                      photoPath = i_0008_url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'drivelicense2' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
                      _this.driveLicensePhoto2Image = {};
                      _this.driveLicensePhoto2Image.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
                      _this.driveLicensePhoto2Image.files = files;
                      _this.driveLicensePhoto2Image.photoId = "2";
                      _this.driveLicensePhoto2Image.photoPath = photoPath;
                      _this.driveLicensePhoto2Image.type = "2";
                    } else if (type == '3') {
                      //車検証期限写真
                      photoPath = i_0008_url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'carverification' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
                      _this.carVerificationPhotoImage = {};
                      _this.carVerificationPhotoImage.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
                      _this.carVerificationPhotoImage.files = files;
                      _this.carVerificationPhotoImage.photoId = "3";
                      _this.carVerificationPhotoImage.photoPath = photoPath;
                      _this.carVerificationPhotoImage.type = "3";
                    } else if (type == '4') {
                      //任意保険期限写真1
                      photoPath = i_0008_url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'insurance' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
                      _this.insuranceExpPhotoImage = {};
                      _this.insuranceExpPhotoImage.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
                      _this.insuranceExpPhotoImage.files = files;
                      _this.insuranceExpPhotoImage.photoId = "4";
                      _this.insuranceExpPhotoImage.photoPath = photoPath;
                      _this.insuranceExpPhotoImage.type = "4";
                    } else if (type == '5') {
                      //任意保険期限写真2
                      photoPath = i_0008_url.imgUrl_UserInfo + that.userCd + '/mycar/' + 'insurance2' + '_' + utils.timeNumberGet() + '.' + exhibitionName;
                      _this.insuranceExpPhoto2Image = {};
                      _this.insuranceExpPhoto2Image.name = photoPath.substring(photoPath.lastIndexOf("/") + 1);
                      _this.insuranceExpPhoto2Image.files = files;
                      _this.insuranceExpPhoto2Image.photoId = "5";
                      _this.insuranceExpPhoto2Image.photoPath = photoPath;
                      _this.insuranceExpPhoto2Image.type = "5";
                    }

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },

    //选择PDF文件
    handleChangePdf: function handleChangePdf(file, fileList) {
      this.changeFlg = true;
      var that = this;
      this.filesPdf = [];
      this.fileTotal = 0;
      this.filePdfUrl = "";
      this.filePdfList = fileList;
      this.timeFormat = Number(this.dateFormat());
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(fileList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          // 计算文件总大小
          if (item.status == 'success') {
            this.fileTotal = this.fileTotal + new Blob([item.url]).size;
          } else {
            this.fileTotal = this.fileTotal + item.size;
            this.filesPdf.push(item);
          }

          this.timeFormat = this.timeFormat + 1;
          if (!item.raw) {
            var raw = new window.File([item], item.name, { type: item.type });
            item.fileName = item.name;
            item.file = raw;
            item.size = raw.size;
            item.filePath = item.filePath;
          } else {
            // 假设`items`是包含文件信息的数组
            var nameParts = item.name.split('.');
            var extension = nameParts[nameParts.length - 1];
            if (!this.isValidExtension(item.name)) {
              //不合法的文件
              extension = 'aaa';
            }
            //image/userInfo/社員コード/mycar/yyyymmddhhmmssfff.拡張子
            item.filePath = i_0008_url.imgUrl_UserInfo + that.userCd + '/mycar/' + this.timeFormat + '.' + extension;
            item.file = item.raw;
          }

          if (this.filePdfUrl) {
            this.filePdfUrl = this.filePdfUrl + ',' + item.filePath;
          } else {
            this.filePdfUrl = item.filePath;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },

    // 检查扩展名是否存在，即确保文件名包含至少一个'.'
    isValidExtension: function isValidExtension(name) {
      var parts = name.split('.');
      return parts.length > 1;
    },

    //移除PDF文件
    onRemovePdffile: function onRemovePdffile(file, fileList) {
      this.handleChangePdf(file, fileList);
    },

    //浏览PDF文件
    onPreviewPdfFile: function onPreviewPdfFile(file) {
      if (file.status == 'ready') {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_VIEW'), showClose: true });
        return;
      }
      this.pdfUrl = file;
      this.viewVisible = true;
    },
    pdfClose: function pdfClose() {
      this.pdfUrl = "";
      this.viewVisible = false;
    },

    //時間フォーマット
    dateFormat: function dateFormat() {
      this.time_Format = new Date();
      var date = new Date();
      var yyyy = date.getFullYear().toString();
      var mm = (date.getMonth() + 1).toString().padStart(2, '0');
      var dd = date.getDate().toString().padStart(2, '0');
      var hh = date.getHours().toString().padStart(2, '0');
      var min = date.getMinutes().toString().padStart(2, '0');
      var sss = date.getMilliseconds().toString().padStart(3, '0');
      return yyyy + mm + dd + hh + min + sss;
    },

    // 图片转base64
    getBase64: function getBase64(file) {
      return new promise_default.a(function (resolve, reject) {
        var reader = new FileReader();
        var imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },

    // base转blob
    base64ToBlob: function base64ToBlob(file) {
      var byteString = void 0;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1]);
      } else {
        byteString = unescape(file.split(',')[1]);
      }
      var mimeString = file.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },

    //单张图片点击
    handlePictureCardPreview: function handlePictureCardPreview(file, dialogName) {
      this[dialogName + 'Url'] = file.url;
      this[dialogName + 'Dialog'] = true;
    },

    // 検索
    query: function query() {
      var _this2 = this;

      //实现Loading 加载方法
      this.set_loading();
      this.changeFlg = false;
      this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
      // 検索処理
      i_0008_i_0008_privateCarInfoQuery(this.userCd).then(function (res) {
        if (res.code == 204) {
          _this2.privateCarInfoData = res.items.privateCarInfo[0];
          _this2.updateChange = JSON.parse(stringify_default()(res.items.privateCarInfo[0]));

          _this2.carNo = _this2.privateCarInfoData.carNo;

          if (_this2.privateCarInfoData.driveLicenseExpDate == null) {
            _this2.driveLicenseExpDate = "";
          } else {
            _this2.driveLicenseExpDate = _this2.privateCarInfoData.driveLicenseExpDate.replace(new RegExp("-", 'g'), "/");
          }

          if (_this2.privateCarInfoData.carVerificationExpDate == null) {
            _this2.carVerificationExpDate = "";
          } else {
            _this2.carVerificationExpDate = _this2.privateCarInfoData.carVerificationExpDate.replace(new RegExp("-", 'g'), "/");
          }

          if (_this2.privateCarInfoData.insuranceExpDate == null) {
            _this2.insuranceExpDate = "";
          } else {
            _this2.insuranceExpDate = _this2.privateCarInfoData.insuranceExpDate.replace(new RegExp("-", 'g'), "/");
          }

          _this2.persionalInsurance = _this2.privateCarInfoData.persionalInsurance;
          _this2.othersInsurance = _this2.privateCarInfoData.othersInsurance;
          _this2.personalInjuryCompensation = _this2.privateCarInfoData.personalInjuryCompensation;

          _this2.applyDate = _this2.privateCarInfoData.applyDate;
          if (_this2.privateCarInfoData.id == null) {
            _this2.id = "";
          } else {
            _this2.id = _this2.privateCarInfoData.id;
          }

          _this2.processCd = _this2.privateCarInfoData.processCd;

          _this2.status = _this2.privateCarInfoData.status;
          _this2.statusName = _this2.privateCarInfoData.statusName;
          _this2.confirmDate = _this2.privateCarInfoData.confirmDate;
          _this2.updateDate = _this2.privateCarInfoData.updateDate;

          // 処理区分が「1：更新」表示日時
          // ステータス取得
          // 「0」の場合 申請日時
          // 「1」or「2」の場合 確認日時
          if (_this2.processCd == "1") {
            if (_this2.status == "0") {
              _this2.timeShow = utils.extractMillisecond(_this2.applyDate);
            } else if (_this2.status == "1" || _this2.status == "2") {
              _this2.timeShow = utils.extractMillisecond(_this2.confirmDate);
            }
          }

          //照片
          // this.driveLicensePhoto1 = this.privateCarInfoData.driveLicensePhoto1;
          // this.driveLicensePhoto2 = this.privateCarInfoData.driveLicensePhoto2;
          // this.carVerificationPhoto = this.privateCarInfoData.carVerificationPhoto;
          // this.insuranceExpPhoto = this.privateCarInfoData.insuranceExpPhoto;
          // this.insuranceExpPhoto2 = this.privateCarInfoData.insuranceExpPhoto2;

          // 清空原照片数据，取最新数据
          _this2.photoInit();
          //写真パスより、写真を取得する。
          if (_this2.privateCarInfoData.driveLicensePhoto1 != '' && _this2.privateCarInfoData.driveLicensePhoto1 != null) {
            _this2.fileQuery(_this2.privateCarInfoData.driveLicensePhoto1, "1");
          }
          if (_this2.privateCarInfoData.driveLicensePhoto2 != '' && _this2.privateCarInfoData.driveLicensePhoto2 != null) {
            _this2.fileQuery(_this2.privateCarInfoData.driveLicensePhoto2, "2");
          }
          if (_this2.privateCarInfoData.carVerificationPhoto != '' && _this2.privateCarInfoData.carVerificationPhoto != null) {
            _this2.fileQuery(_this2.privateCarInfoData.carVerificationPhoto, "3");
          }
          if (_this2.privateCarInfoData.insuranceExpPhoto != '' && _this2.privateCarInfoData.insuranceExpPhoto != null) {
            _this2.fileQuery(_this2.privateCarInfoData.insuranceExpPhoto, "4");
          }
          if (_this2.privateCarInfoData.insuranceExpPhoto2 != '' && _this2.privateCarInfoData.insuranceExpPhoto2 != null) {
            _this2.fileQuery(_this2.privateCarInfoData.insuranceExpPhoto2, "5");
          }

          //PDFFILE
          _this2.filePdfUrl = "";
          _this2.filePdfList = [];
          if (_this2.privateCarInfoData.insuranceExpFile != null && _this2.privateCarInfoData.insuranceExpFile.length != 0) {
            _this2.filePdfUrl = _this2.privateCarInfoData.insuranceExpFile;
            var tempList = [];
            _this2.blobFile = {};
            _this2.filePdfList = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(_this2.privateCarInfoData.insuranceExpFile.split(',')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                if (tempList.indexOf(item) == -1) {
                  tempList.push(item);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            for (var i = 0; i < tempList.length; i++) {
              //ファイル名取得
              var fileName = tempList[i].split('/')[tempList[i].split('/').length - 1];
              var PathfileName = tempList[i];
              _this2.blobFile[fileName] = PathfileName;
            }
            var sum = 0;

            var _loop = function _loop() {
              var fileUrl = {};
              fileUrl.name = key;
              fileUrl.filePath = _this2.blobFile[key];
              i_0008_i_0008_photoFile_get(_this2.blobFile[key]).then(function (res_file) {
                sum += 1;
                var blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' });
                var url = window.URL.createObjectURL(blob);
                fileUrl.url = url;
                if (fileUrl.name.indexOf("%26") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%26', '&');
                }
                if (fileUrl.name.indexOf("%2F") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%2F', '/');
                }
                if (fileUrl.name.indexOf("%3F") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%3F', '?');
                }
                if (fileUrl.name.indexOf("%23") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%23', '#');
                }
                if (fileUrl.name.indexOf("%25") !== -1) {
                  fileUrl.name = fileUrl.name.replace('%25', '%');
                }

                _this2.filePdfList.push(fileUrl);

                if (sum == tempList.length) {
                  _this2.close_loading();
                }
              }).catch(function (err) {
                //关闭loading
                _this2.close_loading();
              });
            };

            for (var key in _this2.blobFile) {
              _loop();
            }
          }
        } else if (res.code === 300) {
          _this2.close_loading();
          _this2.confirmAlert(_this2.$t('COMMON.NO_TARGET_DATA'));
          return;
        }
        _this2.close_loading();
      }).catch(function (error) {
        _this2.close_loading();
      });
    },


    //文件查询
    fileQuery: function fileQuery(filePath, filePathType) {
      var _this3 = this;

      this.set_loading();
      i_0008_i_0008_photoFile_get(filePath).then(function (res) {
        var blob = new Blob([res], { type: 'image/jpg' });
        var url = window.URL.createObjectURL(blob);

        var fileName = filePath.substring(filePath.lastIndexOf("/") + 1);

        if (filePathType == '1') {
          //運転免許証期限表面写真
          _this3.driveLicensePhoto1List.push({ url: url });
          _this3.driveLicensePhoto1Url = filePath;

          _this3.driveLicensePhoto1Image = {};
          _this3.driveLicensePhoto1Image.name = fileName;
          _this3.driveLicensePhoto1Image.files = blob;
          _this3.driveLicensePhoto1Image.photoId = "1";
          _this3.driveLicensePhoto1Image.photoPath = filePath;
          _this3.driveLicensePhoto1Image.type = "1";
        } else if (filePathType == '2') {
          //運転免許証期限裏面写真
          _this3.driveLicensePhoto2List.push({ url: url });
          _this3.driveLicensePhoto2Url = filePath;

          _this3.driveLicensePhoto2Image = {};
          _this3.driveLicensePhoto2Image.name = fileName;
          _this3.driveLicensePhoto2Image.files = blob;
          _this3.driveLicensePhoto2Image.photoId = "2";
          _this3.driveLicensePhoto2Image.photoPath = filePath;
          _this3.driveLicensePhoto2Image.type = "2";
        } else if (filePathType == '3') {
          //車検証期限写真
          _this3.carVerificationPhotoList.push({ url: url });
          _this3.carVerificationPhotoUrl = filePath;

          _this3.carVerificationPhotoImage = {};
          _this3.carVerificationPhotoImage.name = fileName;
          _this3.carVerificationPhotoImage.files = blob;
          _this3.carVerificationPhotoImage.photoId = "3";
          _this3.carVerificationPhotoImage.photoPath = filePath;
          _this3.carVerificationPhotoImage.type = "3";
        } else if (filePathType == '4') {
          //任意保険期限写真1
          _this3.insuranceExpPhotoList.push({ url: url });
          _this3.insuranceExpPhotoUrl = filePath;

          _this3.insuranceExpPhotoImage = {};
          _this3.insuranceExpPhotoImage.name = fileName;
          _this3.insuranceExpPhotoImage.files = blob;
          _this3.insuranceExpPhotoImage.photoId = "4";
          _this3.insuranceExpPhotoImage.photoPath = filePath;
          _this3.insuranceExpPhotoImage.type = "4";
        } else if (filePathType == '5') {
          //任意保険期限写真2
          _this3.insuranceExpPhoto2List.push({ url: url });
          _this3.insuranceExpPhoto2Url = filePath;

          _this3.insuranceExpPhoto2Image = {};
          _this3.insuranceExpPhoto2Image.name = fileName;
          _this3.insuranceExpPhoto2Image.files = blob;
          _this3.insuranceExpPhoto2Image.photoId = "5";
          _this3.insuranceExpPhoto2Image.photoPath = filePath;
          _this3.insuranceExpPhoto2Image.type = "5";
        }
        _this3.close_loading();
      }).catch(function (error) {
        _this3.close_loading();
      });
    },


    // 照片检索前数据初始化
    photoInit: function photoInit() {
      this.driveLicensePhoto1List = [];
      this.driveLicensePhoto2List = [];
      this.carVerificationPhotoList = [];
      this.insuranceExpPhotoList = [];
      this.insuranceExpPhoto2List = [];
      this.driveLicensePhoto1Url = '';
      this.driveLicensePhoto2Url = '';
      this.carVerificationPhotoUrl = '';
      this.insuranceExpPhotoUrl = '';
      this.insuranceExpPhoto2Url = '';
    },


    // 退出登录处理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    // 戻る処理
    back_click: function back_click() {
      var _this4 = this;

      if (this.updateChange.carNo == null) {
        this.updateChange.carNo = "";
      }
      if (this.updateChange.driveLicenseExpDate == null) {
        this.updateChange.driveLicenseExpDate = "";
      }
      if (this.updateChange.carVerificationExpDate == null) {
        this.updateChange.carVerificationExpDate = "";
      }
      if (this.updateChange.insuranceExpDate == null) {
        this.updateChange.insuranceExpDate = "";
      }
      if (this.carNo == null) {
        this.carNo = "";
      }
      if (this.driveLicenseExpDate == null) {
        this.driveLicenseExpDate = "";
      }
      if (this.carVerificationExpDate == null) {
        this.carVerificationExpDate = "";
      }
      if (this.insuranceExpDate == null) {
        this.insuranceExpDate = "";
      }
      if (this.updateChange.carNo != this.carNo || this.updateChange.driveLicenseExpDate.replace(new RegExp("-", 'g'), "/") != this.driveLicenseExpDate || this.updateChange.carVerificationExpDate.replace(new RegExp("-", 'g'), "/") != this.carVerificationExpDate || this.updateChange.insuranceExpDate.replace(new RegExp("-", 'g'), "/") != this.insuranceExpDate) {
        this.changeFlg = true;
      }

      if (this.changeFlg == true) {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_CHANGE_BACK'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: 'true'
        }).then(function () {
          var vm = _this4;
          vm.$router.push({ path: i_0008_url.routerUrl_I0013 });
        }).catch(function () {});
      } else {
        var vm = this;
        vm.$router.push({ path: i_0008_url.routerUrl_I0013 });
      }
    },


    // 保存按钮事件
    save_click: function save_click() {
      //チェック処理
      if (!this.saveCheck()) {
        return;
      }
      this.saveConfirm();
    },


    // 保存确认提示
    saveConfirm: function saveConfirm() {
      var _this5 = this;

      // 保存処理
      this.$confirm(this.$t('COMMON.MSG_SAVE'), { //保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //保存
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
        center: 'true'
      }).then(function () {
        // 保存时先进行图片上传，成功之后进行数据更新
        _this5.photoSave();
      }).catch(function () {
        // 取消
      });
    },


    //数据更新
    dataSave: function dataSave() {
      var _this6 = this;

      var update_params = {};

      update_params.userCd = this.userCd;
      update_params.carNo = this.carNo;
      update_params.driveLicenseExpDate = this.driveLicenseExpDate;
      update_params.carVerificationExpDate = this.carVerificationExpDate;
      update_params.insuranceExpDate = this.insuranceExpDate;
      update_params.insuranceExpFile = this.filePdfUrl;
      update_params.persionalInsurance = this.persionalInsurance;
      update_params.othersInsurance = this.othersInsurance;
      update_params.personalInjuryCompensation = this.personalInjuryCompensation;

      update_params.processCd = this.processCd;
      update_params.id = this.id;
      if (this.processCd == "2") {
        update_params.updateDate = "";
      } else {
        update_params.updateDate = this.updateDate;
      }

      update_params.driveLicensePhoto1 = this.photoListSave[0].photoPath;
      update_params.driveLicensePhoto2 = this.photoListSave[1].photoPath;
      update_params.carVerificationPhoto = this.photoListSave[2].photoPath;
      update_params.insuranceExpPhoto = this.photoListSave[3].photoPath;
      update_params.insuranceExpPhoto2 = this.photoListSave[4].photoPath;

      //图片没有变更不用再保存
      if (this.updateChange.driveLicensePhoto1 != null && this.updateChange.driveLicensePhoto1 == this.photoListSave[0].photoPath) {
        update_params.driveLicensePhoto1 = null;
      }
      if (this.updateChange.driveLicensePhoto2 != null && this.updateChange.driveLicensePhoto2 == this.photoListSave[1].photoPath) {
        update_params.driveLicensePhoto2 = null;
      }
      if (this.updateChange.carVerificationPhoto != null && this.updateChange.carVerificationPhoto == this.photoListSave[2].photoPath) {
        update_params.carVerificationPhoto = null;
      }
      if (this.updateChange.insuranceExpPhoto != null && this.updateChange.insuranceExpPhoto == this.photoListSave[3].photoPath) {
        update_params.insuranceExpPhoto = null;
      }
      if (this.updateChange.insuranceExpPhoto2 != null && this.updateChange.insuranceExpPhoto2 == this.photoListSave[4].photoPath) {
        update_params.insuranceExpPhoto2 = null;
      }
      //删除图片的场合
      //New Add
      if (this.updateChange.driveLicensePhoto1 != null && this.photoListSave[0].photoPath == undefined) {
        update_params.driveLicensePhoto1 = "";
      }
      //New Add
      if (this.updateChange.driveLicensePhoto2 != null && this.photoListSave[1].photoPath == undefined) {
        update_params.driveLicensePhoto2 = "";
      }
      if (this.updateChange.carVerificationPhoto != null && this.photoListSave[2].photoPath == undefined) {
        update_params.carVerificationPhoto = "";
      }
      //New Add
      if (this.updateChange.insuranceExpPhoto != null && this.photoListSave[3].photoPath == undefined) {
        update_params.insuranceExpPhoto = "";
      }
      if (this.updateChange.insuranceExpPhoto2 != null && this.photoListSave[4].photoPath == undefined) {
        update_params.insuranceExpPhoto2 = "";
      }

      i_0008_i_0008_update(update_params).then(function (res) {
        _this6.res_code_back(res);
      }).catch(function (err) {
        //关闭loading
        _this6.close_loading();
      });
    },

    // res_code処理
    res_code_back: function res_code_back(res) {
      var _this7 = this;

      if (res.code === 202) {
        this.changeFlg = false;
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
        this.query();
      } else if (res.code === 308) {
        setTimeout(function () {
          _this7.$confirm(_this7.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this7.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: _this7.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(function () {
            _this7.query();
          }).catch(function () {
            _this7.close_loading();
          });
        }, 500);
      } else if (res.code === 311) {
        setTimeout(function () {
          _this7.$message.error({ message: _this7.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
          _this7.close_loading();
        }, 500);
      }
    },


    //图片保存
    photoSave: function photoSave() {
      var _this8 = this;

      var photoList = [];

      this.photoListSave = [];
      this.photoListSave.push(this.driveLicensePhoto1Image);
      this.photoListSave.push(this.driveLicensePhoto2Image);
      this.photoListSave.push(this.carVerificationPhotoImage);
      this.photoListSave.push(this.insuranceExpPhotoImage);
      this.photoListSave.push(this.insuranceExpPhoto2Image);

      //初始化的图片与当前画面图片名称一样则不上传
      if (this.driveLicensePhoto1Image.photoPath == this.privateCarInfoData.driveLicensePhoto1) {
        this.driveLicensePhoto1Image = {};
      }
      if (this.driveLicensePhoto2Image.photoPath == this.privateCarInfoData.driveLicensePhoto2) {
        this.driveLicensePhoto2Image = {};
      }
      if (this.carVerificationPhotoImage.photoPath == this.privateCarInfoData.carVerificationPhoto) {
        this.carVerificationPhotoImage = {};
      }
      if (this.insuranceExpPhotoImage.photoPath == this.privateCarInfoData.insuranceExpPhoto) {
        this.insuranceExpPhotoImage = {};
      }
      if (this.insuranceExpPhoto2Image.photoPath == this.privateCarInfoData.insuranceExpPhoto2) {
        this.insuranceExpPhoto2Image = {};
      }

      photoList.push(this.driveLicensePhoto1Image);
      photoList.push(this.driveLicensePhoto2Image);
      photoList.push(this.carVerificationPhotoImage);
      photoList.push(this.insuranceExpPhotoImage);
      photoList.push(this.insuranceExpPhoto2Image);

      var photoFormData = new FormData();

      var photoSum = 0;
      //写真
      for (var i = 0; i < photoList.length; i++) {
        if (photoList[i] && photoList[i].files) {
          photoSum = photoSum + 1;
          photoFormData.append('files', photoList[i].files, photoList[i].photoPath);
        }
      }

      //保険ファイル
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.filesPdf), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          photoSum = photoSum + 1;
          photoFormData.append('files', item.file, item.filePath);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (photoSum > 0) {
        //实现Loading 加载方法
        this.set_loading();
        i_0008_i_0008_saveImage(photoFormData).then(function (res) {
          if (res.code == 205) {
            _this8.dataSave();
          } else if (res.code == 311) {
            //图片上传失败
            _this8.$message.error({ message: _this8.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
            _this8.close_loading();
          }
        }).catch(function (err) {
          //关闭loading
          _this8.close_loading();
        });
      } else {
        //实现Loading 加载方法
        this.set_loading();
        this.dataSave();
      }
    },


    //保存check
    saveCheck: function saveCheck() {
      var flag = true;
      //必須入力 登録番号
      if (!this.carNo) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_A_VALIDITY')), showClose: true });
        return flag = false;
      }
      //必須入力 運転免許証期限
      if (!this.driveLicenseExpDate) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_B_VALIDITY')), showClose: true });
        return flag = false;
      }
      if (this.updateChange.driveLicenseExpDate == null) {
        this.updateChange.driveLicenseExpDate = "";
      }
      //「運転免許証期限」が変更した場合、免許証表面写真、裏面写真が必須；　変更無しの場合、必須ではない
      if (this.driveLicenseExpDate != this.updateChange.driveLicenseExpDate.replace(new RegExp("-", 'g'), "/")) {
        //必須入力 免許証表面写真
        if (!this.driveLicensePhoto1Url) {
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_C_VALIDITY')), showClose: true });
          return flag = false;
        }
        //必須入力 免許証裏面写真
        if (!this.driveLicensePhoto2Url) {
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_D_VALIDITY')), showClose: true });
          return flag = false;
        }
      } else {
        //免許証表面写真 存在-->なし
        if (this.driveLicensePhoto1Url == "" && !utils.isEmpty(this.updateChange.driveLicensePhoto1)) {
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_C_VALIDITY')), showClose: true });
          return flag = false;
        }
        //免許証裏面写真 存在-->なし
        if (this.driveLicensePhoto2Url == "" && !utils.isEmpty(this.updateChange.driveLicensePhoto2)) {
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_D_VALIDITY')), showClose: true });
          return flag = false;
        }
        if (utils.isEmpty(this.updateChange.driveLicensePhoto1) && utils.isEmpty(this.updateChange.driveLicensePhoto2)) {
          if (!this.driveLicensePhoto1Url && !!this.driveLicensePhoto2Url) {
            //免許証表面写真 存在-->なし
            this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_C_VALIDITY')), showClose: true });
            return flag = false;
          } else if (!!this.driveLicensePhoto1Url && !this.driveLicensePhoto2Url) {
            //免許証裏面写真 存在-->なし
            this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_D_VALIDITY')), showClose: true });
            return flag = false;
          } else if (this.driveLicensePhoto1Url == "" && this.driveLicensePhoto2Url == "") {}
        }
      }
      //必須入力 任意保険期限
      if (!this.insuranceExpDate) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_EQUIRED_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_G_VALIDITY')), showClose: true });
        return flag = false;
      }
      if (this.updateChange.insuranceExpDate == null) {
        this.updateChange.insuranceExpDate = "";
      }
      //「任意保険期限」が変更した場合、保険写真と保険ファイルの片方が必須；　変更無しの場合、必須ではない
      if (this.insuranceExpDate != this.updateChange.insuranceExpDate.replace(new RegExp("-", 'g'), "/")) {
        //保険写真と保険ファイル両方が入力されていない場合 エラーメッセージを表示し
        if (!this.insuranceExpPhotoUrl && !this.filePdfUrl && this.filePdfList.length == 0) {
          //保険写真或いは保険ファイルのいずれを入力してください。
          this.$message.error({ message: this.$t('MODULE.I0008_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0008_MSG_H_VALIDITY')).replace('{2}', this.$t('MODULE.I0008_MSG_FILE_VALIDITY')), showClose: true });
          return flag = false;
        }
      } else {
        //存在-->なし NG
        if (!this.insuranceExpPhotoUrl && !this.filePdfUrl && this.filePdfList.length == 0) {
          if (!(!this.updateChange.insuranceExpPhoto && !this.updateChange.insuranceExpFile)) {
            //保険写真或いは保険ファイルのいずれを入力してください。
            this.$message.error({ message: this.$t('MODULE.I0008_MSG_WHICH_VALIDITY').replace('{1}', this.$t('MODULE.I0008_MSG_H_VALIDITY')).replace('{2}', this.$t('MODULE.I0008_MSG_FILE_VALIDITY')), showClose: true });
            return flag = false;
          }
        }
      }
      //保険ファイルを添付した場合、保険ファイル拡張子はPDF
      if (this.filePdfUrl != null && this.filePdfUrl != "") {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(this.filePdfUrl.split(',')), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;

            if (["pdf", "PDF"].indexOf(this.getFileExtensions(item)) == -1) {
              // 保険ファイル拡張子はPDF必要です。
              this.$message.error({ message: this.$t('MODULE.I0008_MSG_PDF'), showClose: true });
              return flag = false;
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      //添付ファイルサイズ
      if (this.fileTotal / 1024 / 1024 > 10) {
        // 添付ファイルの総サイズを10M以内にしてください。
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_SIZECHECK'), showClose: true });
        return flag = false;
      }
      //「はい」必須場合 対人保証
      if (this.persionalInsurance != 1) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_RADIO_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_I_VALIDITY')), showClose: true });
        return flag = false;
      }
      //「はい」必須場合 対物保証
      if (this.othersInsurance != 1) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_RADIO_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_J_VALIDITY')), showClose: true });
        return flag = false;
      }
      //「はい」必須場合 人身傷害補償
      if (this.personalInjuryCompensation != 1) {
        this.$message.error({ message: this.$t('MODULE.I0008_MSG_RADIO_VALIDITY').replace('{0}', this.$t('MODULE.I0008_MSG_K_VALIDITY')), showClose: true });
        return flag = false;
      }

      return flag;
    },


    // 照片删除
    driveLicensePhoto1PhotoDelete: function driveLicensePhoto1PhotoDelete() {
      this.photoDelete('driveLicensePhoto1');
    },
    driveLicensePhoto2PhotoDelete: function driveLicensePhoto2PhotoDelete() {
      this.photoDelete('driveLicensePhoto2');
    },
    carVerificationPhotoPhotoDelete: function carVerificationPhotoPhotoDelete() {
      this.photoDelete('carVerificationPhoto');
    },
    insuranceExpPhotoPhotoDelete: function insuranceExpPhotoPhotoDelete() {
      this.photoDelete('insuranceExpPhoto');
    },
    insuranceExpPhoto2PhotoDelete: function insuranceExpPhoto2PhotoDelete() {
      this.photoDelete('insuranceExpPhoto2');
    },


    // 删除确认
    photoDelete: function photoDelete(itemName) {
      var _this9 = this;

      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.BTN_CONFIRM'), // 確認
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: 'true'
      }).then(function () {
        //上传用list清空
        _this9[itemName + 'List'] = [];
        _this9[itemName + 'Url'] = '';
        _this9[itemName + 'Dialog'] = false;
        _this9[itemName + 'Image'] = {};
        _this9.changeFlg = true;
      }).catch(function () {});
    },

    //ALERT确认提示
    confirmAlert: function confirmAlert(msgs) {
      var msg = '';
      msg = '<span>' + msgs + '</span><br/>';
      this.$alert(msg, '', {
        confirmButtonText: 'OK',
        dangerouslyUseHTMLString: true,
        type: 'warning',
        center: true,
        showClose: false,
        customClass: 'confirmStyle'
      }).then(function () {});
    },

    //取得文件名的扩展名
    getFileExtensions: function getFileExtensions(name) {
      //取到文件名开始到最后一个点的长度
      var fileName = name.lastIndexOf(".");
      //取到文件名长度
      var fileNameLength = name.length;
      //截取扩展名
      var fileExtensions = name.substring(fileName + 1, fileNameLength);
      return fileExtensions;
    }
  },
  // 初期化自动调用
  created: function created() {
    // 初期化函数调用
    this.query();
  },
  mounted: function mounted() {
    //点击删除按钮之外的地方退出长按模式
    var that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-upload-list__item-actions' && e.target.className != 'el-icon-refresh-left' && e.target.className != 'el-icon-refresh-right' && e.target.className != 'el-icon-c-scale-to-original' && e.target.className != 'el-icon-zoom-in' && e.target.className != 'el-icon-zoom-out' && e.target.className != 'el-image-viewer__actions__inner' && e.target.className != 'el-icon-full-screen' && e.target.className != 'el-icon-circle-close' && e.target.className != 'el-button el-button--default el-button--small') {
        //关闭照片查看器
        that.driveLicensePhoto1Dialog = false;
        that.driveLicensePhoto2Dialog = false;
        that.carVerificationPhotoDialog = false;
        that.insuranceExpPhotoDialog = false;
        that.insuranceExpPhoto2Dialog = false;
      }
    });
  },

  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec272b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0008.vue
var i_0008_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_i0008"},[_c('div',{staticClass:"el-detail_i0008"},[_c('el-row',[_c('div',{staticClass:"div_span_i0008"},[_c('span',{staticClass:"input_span_i0008",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_A')))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10px","padding-bottom":"10px","background":"#d2eef8"}},[_c('el-row',{staticStyle:{"margin-left":"20px","background":"#d2eef8"}},[_c('el-col',[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_REI')))]),_vm._v(" "),_c('el-input',{staticClass:"textRight_i0008",staticStyle:{"margin-left":"40px","width":"40%"},attrs:{"size":"small","maxlength":"20"},model:{value:(_vm.carNo),callback:function ($$v) {_vm.carNo=$$v},expression:"carNo"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("＊")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_i0008"},[_c('span',{staticClass:"input_span_i0008"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_C')))]),_vm._v(" "),_c('span',{staticClass:"input_span_i0008"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_PHOTO')))])])]),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":11}},[_c('div',{staticClass:"div_input_i0008"},[_c('el-date-picker',{staticClass:"date_select_i0008 date_picker_i0008 textRight_i0008",staticStyle:{"margin-left":"10px"},attrs:{"format":"yyyy/MM/dd","value-format":"yyyy/MM/dd","size":"small","clearable":false,"editable":false},model:{value:(_vm.driveLicenseExpDate),callback:function ($$v) {_vm.driveLicenseExpDate=$$v},expression:"driveLicenseExpDate"}})],1),_vm._v(" "),_c('div',{staticStyle:{"color":"red","margin-top":"18px"}},[_vm._v("＊")])]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"18px","margin-left":"0px"},attrs:{"span":2}},[_c('div',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_FRONT')))])]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"0px"},attrs:{"span":10}},[_c('div',{staticClass:"div_input_i0008",staticStyle:{"width":"100%"}},[(!_vm.driveLicensePhoto1Url)?_c('div',{staticClass:"photo_border_i0008",class:{'driveLicensePhoto1Css': _vm.driveLicensePhoto1Css}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"driveLicensePhoto1",staticClass:"photo_upload_i0008",attrs:{"show-file-list":true,"file-list":_vm.driveLicensePhoto1List,"list-type":"picture-card","limit":2,"accept":"image/jpg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'driveLicensePhoto1','1')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"driveLicensePhoto1Img","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'driveLicensePhoto1')}}})]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.driveLicensePhoto1Dialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.driveLicensePhoto1PhotoDelete,"url-list":[_vm.driveLicensePhoto1Url]}}):_vm._e()],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"-5px"},attrs:{"span":1}},[_c('div',{staticStyle:{"color":"red"}},[_vm._v("＊")])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":11}},[_c('div',{staticClass:"table-label",staticStyle:{"margin-left":"10px","margin-right":"10px"}},[_vm._v("\n            "+_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_I'))+"\n          ")])]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"18px","margin-left":"0"},attrs:{"span":2}},[_c('div',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_BACK')))])]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"0px"},attrs:{"span":10}},[_c('div',{staticClass:"div_input_i0008",staticStyle:{"width":"100%"}},[(!_vm.driveLicensePhoto2Url)?_c('div',{staticClass:"photo_border_i0008",class:{'driveLicensePhoto2Css': _vm.driveLicensePhoto2Css}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"driveLicensePhoto2",staticClass:"photo_upload_i0008",attrs:{"show-file-list":true,"file-list":_vm.driveLicensePhoto2List,"list-type":"picture-card","limit":2,"accept":"image/jpg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'driveLicensePhoto2','2')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'driveLicensePhoto2')}}})]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.driveLicensePhoto2Dialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.driveLicensePhoto2PhotoDelete,"url-list":[_vm.driveLicensePhoto2Url]}}):_vm._e()],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"-5px"},attrs:{"span":1}},[_c('div',{staticStyle:{"color":"red"}},[_vm._v("＊")])])],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_i0008"},[_c('span',{staticClass:"input_span_i0008"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_D')))]),_vm._v(" "),_c('span',{staticClass:"input_span_i0008"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_PHOTO')))])])]),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":11}},[_c('div',{staticClass:"div_input_i0008"},[_c('el-date-picker',{staticClass:"date_select_i0008 date_picker_i0008 textRight_i0008",staticStyle:{"margin-left":"10px"},attrs:{"format":"yyyy/MM/dd","value-format":"yyyy/MM/dd","size":"small","clearable":false,"editable":false},model:{value:(_vm.carVerificationExpDate),callback:function ($$v) {_vm.carVerificationExpDate=$$v},expression:"carVerificationExpDate"}})],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"0px"},attrs:{"span":2}}),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"0px"},attrs:{"span":10}},[_c('div',{staticClass:"div_input_i0008",staticStyle:{"width":"100%"}},[(!_vm.carVerificationPhotoUrl)?_c('div',{staticClass:"photo_border_i0008",class:{'carVerificationPhotoCss': _vm.carVerificationPhotoCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"carVerificationPhoto",staticClass:"photo_upload_i0008",attrs:{"show-file-list":true,"file-list":_vm.carVerificationPhotoList,"list-type":"picture-card","limit":2,"accept":"image/jpg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'carVerificationPhoto','3')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'carVerificationPhoto')}}})]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.carVerificationPhotoDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.carVerificationPhotoPhotoDelete,"url-list":[_vm.carVerificationPhotoUrl]}}):_vm._e()],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"-5px"},attrs:{"span":1}},[_c('div',{staticStyle:{"color":"red"}})])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":24}},[_c('div',{staticClass:"table-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_J')))])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":24}},[_c('div',{staticClass:"table-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_50'))+"    "+_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_125')))])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-left":"10px","margin-bottom":"10px"},attrs:{"span":24}},[_c('div',{staticClass:"table-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_250')))])])],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span_i0008"},[_c('span',{staticClass:"input_span_i0008"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_E')))]),_vm._v(" "),_c('span',{staticClass:"input_span_i0008"},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_PHOTO')))])])]),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":11}},[_c('div',{staticClass:"div_input_i0008"},[_c('el-date-picker',{staticClass:"date_select_i0008 date_picker_i0008 textRight_i0008",staticStyle:{"margin-left":"10px"},attrs:{"format":"yyyy/MM/dd","value-format":"yyyy/MM/dd","size":"small","clearable":false,"editable":false},model:{value:(_vm.insuranceExpDate),callback:function ($$v) {_vm.insuranceExpDate=$$v},expression:"insuranceExpDate"}})],1),_vm._v(" "),_c('div',{staticStyle:{"color":"red","margin-top":"18px"}},[_vm._v("＊")])]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"0px"},attrs:{"span":2}}),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"0px"},attrs:{"span":10}},[_c('div',{staticClass:"div_input_i0008",staticStyle:{"width":"100%"}},[(!_vm.insuranceExpPhotoUrl)?_c('div',{staticClass:"photo_border_i0008",class:{'insuranceExpPhotoCss': _vm.insuranceExpPhotoCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"insuranceExpPhoto",staticClass:"photo_upload_i0008",attrs:{"show-file-list":true,"file-list":_vm.insuranceExpPhotoList,"list-type":"picture-card","limit":2,"accept":"image/jpg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'insuranceExpPhoto','4')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'insuranceExpPhoto')}}})]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.insuranceExpPhotoDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.insuranceExpPhotoPhotoDelete,"url-list":[_vm.insuranceExpPhotoUrl]}}):_vm._e()],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"-5px"},attrs:{"span":1}},[_c('div',{staticStyle:{"color":"red"}},[_vm._v("＊")])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":11}}),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"0px"},attrs:{"span":2}}),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"0px"},attrs:{"span":10}},[_c('div',{staticClass:"div_input_i0008",staticStyle:{"width":"100%"}},[(!_vm.insuranceExpPhoto2Url)?_c('div',{staticClass:"photo_border_i0008",class:{'insuranceExpPhoto2Css': _vm.insuranceExpPhoto2Css}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"insuranceExpPhoto2",staticClass:"photo_upload_i0008",attrs:{"show-file-list":true,"file-list":_vm.insuranceExpPhoto2List,"list-type":"picture-card","limit":2,"accept":"image/jpg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'insuranceExpPhoto2','5')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'insuranceExpPhoto2')}}})]}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.insuranceExpPhoto2Dialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.insuranceExpPhoto2PhotoDelete,"url-list":[_vm.insuranceExpPhoto2Url]}}):_vm._e()],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"-5px"},attrs:{"span":1}},[_c('div',{staticStyle:{"color":"red"}})])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-bottom":"10px"},attrs:{"span":23}},[_c('el-upload',{attrs:{"action":"string","accept":".pdf,.PDF","on-preview":_vm.onPreviewPdfFile,"file-list":_vm.filePdfList,"on-change":function (file, fileList) {_vm.handleChangePdf(file, fileList)},"on-remove":_vm.onRemovePdffile,"auto-upload":false,"limit":5,"multiple":"","list-type":"text"}},[_c('el-button',{staticClass:"css-button css-btn",staticStyle:{"width":"110px","font-size":"10pt","margin-left":"10px"},attrs:{"type":"primary","size":"small"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_BTN_FILE')))])],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-top":"15px","margin-left":"-5px"},attrs:{"span":1}},[_c('div',{staticStyle:{"color":"red"}})])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-left":"10px","margin-bottom":"10px"},attrs:{"span":24}},[_c('div',{staticClass:"table-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_KEIYAKUSHAMEI')))])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-left":"10px","margin-bottom":"10px"},attrs:{"span":24}},[_c('div',{staticClass:"table-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_N')))])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":24}},[_c('div',{staticClass:"table-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_O')))])]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":24}},[_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.persionalInsurance),callback:function ($$v) {_vm.persionalInsurance=$$v},expression:"persionalInsurance"}},[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_YES')))])]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"},model:{value:(_vm.persionalInsurance),callback:function ($$v) {_vm.persionalInsurance=$$v},expression:"persionalInsurance"}},[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_NO')))])])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":24}},[_c('div',{staticClass:"table-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_P')))])]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":24}},[_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.othersInsurance),callback:function ($$v) {_vm.othersInsurance=$$v},expression:"othersInsurance"}},[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_YES')))])]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"},model:{value:(_vm.othersInsurance),callback:function ($$v) {_vm.othersInsurance=$$v},expression:"othersInsurance"}},[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_NO')))])])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#d2eef8"},attrs:{"type":"flex"}},[_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":24}},[_c('div',{staticClass:"table-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_LBL_TEXT_Q')))])]),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"10px","margin-bottom":"10px"},attrs:{"span":24}},[_c('el-radio',{attrs:{"label":"1"},model:{value:( _vm.personalInjuryCompensation),callback:function ($$v) { _vm.personalInjuryCompensation=$$v},expression:" personalInjuryCompensation"}},[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_YES')))])]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"},model:{value:(_vm.personalInjuryCompensation),callback:function ($$v) {_vm.personalInjuryCompensation=$$v},expression:"personalInjuryCompensation"}},[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_NO')))])])],1)],1)],1),_vm._v(" "),(this.processCd == 1)?_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(this.statusName)+" "+_vm._s(this.timeShow))]):_vm._e(),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary","disabled":this.processCd == 1 && this.status == 2},on:{"click":_vm.save_click}},[_vm._v(_vm._s(_vm.$t('MODULE.I0008_BTN_APPLICATION')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))])],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"fullscreen":"","visible":_vm.viewVisible,"close-on-click-modal":false,"show-close":false,"width":"100%","top":"52px","height":"120%"},on:{"update:visible":function($event){_vm.viewVisible=$event}}},[_c('Pdf',{attrs:{"src":_vm.pdfUrl},on:{"pdfClose":_vm.pdfClose}})],1)],1)}
var i_0008_staticRenderFns = []
var i_0008_esExports = { render: i_0008_render, staticRenderFns: i_0008_staticRenderFns }
/* harmony default export */ var page_i_0008 = (i_0008_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0008.vue
function i_0008_injectStyle (ssrContext) {
  __webpack_require__("f08t")
}
var i_0008_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0008___vue_template_functional__ = false
/* styles */
var i_0008___vue_styles__ = i_0008_injectStyle
/* scopeId */
var i_0008___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0008___vue_module_identifier__ = null
var i_0008_Component = i_0008_normalizeComponent(
  i_0008,
  page_i_0008,
  i_0008___vue_template_functional__,
  i_0008___vue_styles__,
  i_0008___vue_scopeId__,
  i_0008___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0008 = (i_0008_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0009.js


var i_0009_apiUrl = __webpack_require__("kspH");

// 汎用マスタ
var i_0009_i_0009_conditionSearch = function i_0009_conditionSearch(page, div, type) {
  return api_public.requestQuickGet(i_0009_apiUrl.apiurl_masterData + '/' + page + '/' + div + '?type=' + type);
};

// 本人確認書類検索
var i_0009_i_0009_selfDocSearch = function i_0009_selfDocSearch(params) {
  return api_public.requestQuickGet(i_0009_apiUrl.apiUrl_SelfDoc);
};

// 契約確認情報保存
var i_0009_i_0009_selfDocSave = function i_0009_selfDocSave(params) {
  return api_public.requestPost(i_0009_apiUrl.apiUrl_SelfDoc, params);
};

//图片查询
var i_0009_i_0009_photoFileGet = function i_0009_photoFileGet(photoPath) {
  return api_public.requestQuickGetImage(i_0009_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0');
};

// 契約確認情報图片更新
var i_0009_i_0009_saveImage = function i_0009_saveImage(formData) {
  return api_public.requestPostFormData(i_0009_apiUrl.apiUrl_filesUpdate, formData);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0009.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var i_0009_url = __webpack_require__("kspH");

/* harmony default export */ var i_0009 = ({
  mixins: [css],
  components: {
    ElImageViewer: image_src_image_viewer
  },
  data: function data() {
    return {
      // loading: false,
      // obj: [],
      selectData: [],
      selectValue: '',
      selectValueOld: '',
      selectType: '2', //2:両面, 1:片面
      //processCd:'',//処理区分
      editDisabled: true, //申請ボタン false:活性/true:非活性
      statusNameLabel: '',
      selfDocData: {}, //本人確認書

      limitNum: 2,
      positiveImage: {},
      positiveList: [],
      positiveUrl: '',
      positiveDialog: false,
      positiveLongClick: false,
      positiveCss: false,

      reverseImage: {},
      reverseList: [],
      reverseUrl: '',
      reverseDialog: false,
      reverseLongClick: false,
      reverseCss: false,

      confirmSelectFlag: false
    };
  },
  created: function created() {
    var _this = this;

    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    // ページ:'all' 区分:50 タイプ:'piv_doc_div'
    i_0009_i_0009_conditionSearch('all', '3,50', 'piv_doc_div').then(function (res) {
      //確認資料リスト取得
      _this.selectData = res.items.generalData.pivDocDiv;
    });

    this.query();
  },

  methods: {
    query: function query() {
      var _this2 = this;

      //实现Loading 加载方法
      this.set_loading();
      var params = [];
      //调用服务端接口
      i_0009_i_0009_selfDocSearch(params).then(function (res) {

        _this2.confirmSelectFlag = false;
        //検索結果0件以外
        if (res.code == '204') {
          _this2.selfDocData = res.items.selfDoc[0];
          if (_this2.selfDocData.processCd == '1') {
            //処理区分が「1：更新」場合
            _this2.statusNameLabel = _this2.selfDocData.statusName + ":";
            if (_this2.selfDocData.status == '0') {
              //「0」の場合、申請日時
              var applyDate = _this2.selfDocData.applyDate;
              if (applyDate.length > 18) {
                applyDate = applyDate.substr(0, 19);
              }
              _this2.statusNameLabel = _this2.statusNameLabel + applyDate;
            } else {
              //「1,2」の場合、確認日時
              var confirmDate = _this2.selfDocData.confirmDate;
              if (confirmDate.length > 18) {
                confirmDate = confirmDate.substr(0, 19);
              }
              _this2.statusNameLabel = _this2.statusNameLabel + confirmDate;
            }
          } else if (_this2.selfDocData.processCd == '2') {
            //2：新規 場合
            _this2.selectValue = '01';
            _this2.statusNameLabel = '';
          }

          //処理区分が「1：更新」 and  ステータスが「2：確認済」の場合、
          if (_this2.selfDocData.processCd == '1' && _this2.selfDocData.status == '2') {
            _this2.editDisabled = true;
          } else {
            _this2.editDisabled = false;
          }

          //レスポンス.本人確認書類
          if (_this2.selfDocData.pivDocDiv != '' && _this2.selfDocData.pivDocDiv != null) {
            _this2.selectValue = _this2.selfDocData.pivDocDiv;
          }

          // 両面アップロード資料：
          _this2.showUploadImageControl(_this2.selectValue);

          //本人書類写真1
          if (_this2.selfDocData.pivDocPhoto1 != '' && _this2.selfDocData.pivDocPhoto1 != null) {
            _this2.fileQuery(_this2.selfDocData.pivDocPhoto1, "1");
          }
          //本人書類写真12
          if (_this2.selfDocData.pivDocPhoto2 != '' && _this2.selfDocData.pivDocPhoto2 != null) {
            _this2.fileQuery(_this2.selfDocData.pivDocPhoto2, "2");
          }

          if ((_this2.selfDocData.pivDocPhoto1 == '' || _this2.selfDocData.pivDocPhoto1 == null) && (_this2.selfDocData.pivDocPhoto2 == '' || _this2.selfDocData.pivDocPhoto2 == null)) {
            _this2.close_loading();
          }
        } else if (res.code == '300') {}
        //this.close_loading()
      }).catch(function (err) {
        //关闭loading
        _this2.close_loading();
      });
    },

    //文件查询
    fileQuery: function fileQuery(filePath, filePathType) {
      var _this3 = this;

      this.set_loading();
      i_0009_i_0009_photoFileGet(filePath).then(function (res) {
        var blob = new Blob([res], { type: 'image/jpg' });
        var url = window.URL.createObjectURL(blob);
        //拡張子
        var exhibitionName = filePath.split('.')[1];

        if (filePathType == '1') {
          //本人書類写真1
          _this3.positiveList.push({ url: url });
          _this3.positiveUrl = filePath;

          _this3.positiveImage = {};
          _this3.positiveImage.name = 'pivDoc1.' + exhibitionName;
          _this3.positiveImage.files = blob;
          _this3.positiveImage.photoId = "1";
          _this3.positiveImage.photoPath = filePath;
          _this3.positiveImage.type = "1";
        } else if (filePathType == '2') {
          //本人書類写真2
          _this3.reverseList.push({ url: url });
          _this3.reverseUrl = filePath;

          _this3.reverseImage = {};
          _this3.reverseImage.name = 'pivDoc2.' + exhibitionName;
          _this3.reverseImage.files = blob;
          _this3.reverseImage.photoId = "2";
          _this3.reverseImage.photoPath = filePath;
          _this3.reverseImage.type = "2";
        }
        _this3.close_loading();
      }).catch(function (error) {
        _this3.close_loading();
      });
    },
    selectBeforeChange: function selectBeforeChange(callback) {
      if (callback) {
        this.selectValueOld = this.selectValue;
      }
    },

    //  確認資料 
    confirmSelect: function confirmSelect() {
      var _this4 = this;

      if (this.selectValueOld != this.selectValue) {
        //確認資料を切替えるとき、未保存のアップロード写真がある場合
        if ((this.positiveUrl != '' || this.reverseUrl != '') && this.confirmSelectFlag == true) {
          //var that = this;
          this.$confirm(this.$t('MODULE.I0009_MSG_SELECT_CHANGE'), {
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //いいえ
            center: 'true'
          }).then(function () {
            _this4.showUploadImageControl(_this4.selectValue);
            _this4.positiveUrl = '';
            _this4.reverseUrl = '';
            _this4.positiveList = [];
            _this4.reverseList = [];
          }).catch(function () {
            // 取消
            _this4.selectValue = _this4.selectValueOld;
          });
        } else {
          this.showUploadImageControl(this.selectValue);
          this.positiveUrl = '';
          this.reverseUrl = '';
          this.positiveList = [];
          this.reverseList = [];
        }
      }
    },
    showUploadImageControl: function showUploadImageControl(val) {
      // 両面アップロード資料：
      // 01: 運転免許証
      if (val == '01') {
        this.selectType = '2'; //2:両面
      } else {
        this.selectType = '1'; //1:片面
      }
    },
    back: function back() {
      this.$router.push({ path: i_0009_url.routerUrl_I0002 });
    },
    save: function save() {
      var _this5 = this;

      //確認資料入力チェック
      if (this.selectValue == '') {
        this.$message.error({ message: this.$t('MODULE.I0009_MSG_SELF'), showClose: true });
        return;
      }
      //写真（表面）アップロードチェック
      if (this.positiveUrl == '') {
        this.$message.error({ message: this.$t('MODULE.I0009_MSG_PHOTO1'), showClose: true });
        return;
      }
      //両面アップロードの場合のみ、下記のチェックを行う
      if (this.selectType == '2') {
        if (this.reverseUrl == '') {
          this.$message.error({ message: this.$t('MODULE.I0009_MSG_PHOTO2'), showClose: true });
          return;
        }
      }
      //上記チェックがOKでしたら、確認ダイアログ表示
      // 保存処理
      this.$confirm(this.$t('COMMON.MSG_SAVE'), { //保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), //保存
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
        center: 'true'
      }).then(function () {
        // 保存时先进行图片上传，成功之后进行数据更新
        _this5.photoSave();
      }).catch(function () {
        // 取消
      });
    },

    //添付写真を転送する。
    photoSave: function photoSave() {
      var _this6 = this;

      this.set_loading();
      var photoList = [];
      //1:片面
      if (this.selectType == '1') {
        photoList.push(this.positiveImage);
      } else if (this.selectType == '2') {
        photoList.push(this.positiveImage);
        photoList.push(this.reverseImage);
      }

      //check，DB Data和File Data不一致
      var photoListCheckError = false;
      if (this.selectType == '1') {
        if (photoList.length != 1) {
          photoListCheckError = true;
        } else {
          if (photoList[0].photoPath == '') {
            photoListCheckError = true;
          }
        }
      } else if (this.selectType == '2') {
        if (photoList.length != 2) {
          photoListCheckError = true;
        } else {
          if (photoList[0].photoPath == '') {
            photoListCheckError = true;
          } else if (photoList[1].photoPath == '') {
            photoListCheckError = true;
          }
        }
      }
      if (photoListCheckError) {
        this.close_loading();
        //图片上传失败
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });
        return;
      }

      //图片批量上传 ，调用一次API
      var photoFormData = new FormData();
      for (var i = 0; i < photoList.length; i++) {
        photoFormData.append('files', photoList[i].files, photoList[i].photoPath);
      }
      if (photoList.length > 0) {
        i_0009_i_0009_saveImage(photoFormData).then(function (res) {
          if (res.code == 205) {
            // 写真都成功上传后，保存申请参数
            _this6.dataSave();
          } else if (res.code == 311) {
            _this6.close_loading();
            //图片上传失败
            _this6.$message.error({ message: _this6.$t('COMMON.CURD_ERROR'), showClose: true });
          } else {
            //this.close_loading();
          }
        }).catch(function (err) {
          _this6.close_loading();
          _this6.$message.error({ message: _this6.$t('COMMON.CURD_ERROR'), showClose: true });
        });
      }
    },

    //本人確認書類保存
    dataSave: function dataSave() {
      var _this7 = this;

      var update_params = {};
      update_params.userCd = this.userCd; //社員コード
      update_params.pivDocDiv = this.selectValue; //本人確認書類
      update_params.pivDocPhoto1 = this.positiveImage.photoPath; //本人書類写真1
      update_params.pivDocPhoto2 = '';
      if (this.selectType == '2') {
        update_params.pivDocPhoto2 = this.reverseImage.photoPath; //本人書類写真2
      }
      update_params.processCd = this.selfDocData.processCd; //処理区分
      update_params.id = this.selfDocData.id; //申請番号
      update_params.updateDate = this.selfDocData.updateDate; //更新日時

      i_0009_i_0009_selfDocSave(update_params).then(function (res) {
        if (res.code === 202) {
          _this7.$message.success({ message: _this7.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
          //this.$router.push({ path: url.routerUrl_I0002 })
          //画面を再表示する。
          _this7.showUploadImageControl(_this7.selectValue);
          _this7.positiveUrl = '';
          _this7.reverseUrl = '';
          _this7.positiveList = [];
          _this7.reverseList = [];
          _this7.query();
        } else if (res.code === 308) {
          _this7.close_loading();
          _this7.$confirm(_this7.$t('COMMON.EXCLUSIVE'), _this7.$t('COMMON.CONFIRM'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this7.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: _this7.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: 'true'
          }).then(function () {
            //画面を再表示する。
            _this7.selectType = '2';
            _this7.positiveUrl = '';
            _this7.reverseUrl = '';
            _this7.positiveList = [];
            _this7.reverseList = [];
            _this7.query();
          }).catch(function () {
            _this7.close_loading();
          });
        } else if (res.code === 311) {
          _this7.close_loading();
          _this7.$message.error({ message: _this7.$t('COMMON.CURD_ERROR'), showClose: true }); //処理が失敗しました。
        }
      }).catch(function (err) {
        _this7.close_loading();
        _this7.$message.error({ message: _this7.$t('COMMON.CURD_ERROR'), showClose: true }); //処理が失敗しました。
      });
    },

    // 图片上传选择
    handleChange: function handleChange(file, fileList, itemName, type) {
      var _this8 = this;

      var file_type = file.raw.type;
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpeg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
      } else {
        if (file.status === "ready") {
          // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
          if (fileList.length === 2) {
            fileList.shift();
          }
        }
        this[itemName + 'Url'] = file.url;
        var that = this;
        // var photoItem = {}
        this.getBase64(file.raw).then(function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
            var photo, files, photoPath, exhibitionName;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this8.confirmSelectFlag = true;
                    // 进行图片压缩获取压缩后的blob文件
                    _context.next = 3;
                    return that.compressImg(that.base64ToBlob(res));

                  case 3:
                    photo = _context.sent;
                    files = new window.File([photo], file.name, { type: file.type });
                    //表面写真：image/userInfo/[userCd]/selfDoc/[pivDocDiv]/pivDoc1.拡張子
                    //裏面写真：image/userInfo/[userCd]/selfDoc/[pivDocDiv]/pivDoc2.拡張子

                    photoPath = '';
                    //拡張子

                    exhibitionName = file.name.split('.')[1];

                    if (type == '1') {
                      //表面写真
                      photoPath = i_0009_url.imgUrl_UserInfo + that.userCd + '/selfDoc/' + that.selectValue + '/pivDoc1.' + exhibitionName;
                      _this8.positiveImage = {};
                      _this8.positiveImage.name = 'pivDoc1.' + exhibitionName;
                      _this8.positiveImage.files = files;
                      _this8.positiveImage.photoId = type;
                      _this8.positiveImage.photoPath = photoPath;
                      _this8.positiveImage.type = type;
                    } else if (type = '2') {
                      //裏面写真
                      photoPath = i_0009_url.imgUrl_UserInfo + that.userCd + '/selfDoc/' + that.selectValue + '/pivDoc2.' + exhibitionName;
                      _this8.reverseImage = {};
                      _this8.reverseImage.name = 'pivDoc2.' + exhibitionName;
                      _this8.reverseImage.files = files;
                      _this8.reverseImage.photoId = type;
                      _this8.reverseImage.photoPath = photoPath;
                      _this8.reverseImage.type = type;
                    }

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this8);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },

    //单张图片点击
    handlePhotoPreview: function handlePhotoPreview(file, dialogName) {
      this[dialogName + 'Url'] = file.url;
      this[dialogName + 'Dialog'] = true;
    },

    // 照片删除
    positivePhotoDelete: function positivePhotoDelete() {
      var _this9 = this;

      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), { // 変更がありました。一覧に戻りますか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(function () {
        //组件表示图片清空
        _this9.positiveList = [];
        //上传用list清空
        _this9.positiveUrl = '';
        _this9.positiveDialog = false;
        _this9.positiveImage = {};
      }).catch(function () {});
    },

    // 照片删除
    reversePhotoDelete: function reversePhotoDelete() {
      var _this10 = this;

      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), { // 変更がありました。一覧に戻りますか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(function () {
        //组件表示图片清空
        _this10.reverseList = [];
        //上传用list清空
        _this10.reverseUrl = '';
        _this10.reverseDialog = false;
        _this10.reverseImage = {};
      }).catch(function () {});
    },

    // 图片转base64
    getBase64: function getBase64(file) {
      return new promise_default.a(function (resolve, reject) {
        var reader = new FileReader();
        var imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },

    // base转blob
    base64ToBlob: function base64ToBlob(file) {
      var byteString = void 0;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1]);
      } else {
        byteString = unescape(file.split(',')[1]);
      }
      var mimeString = file.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },

    // 压缩图片
    compressImg: function compressImg(file) {
      var that = this;
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new promise_default.a(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
                h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files);
          };
        };
      });
    }
  },
  mounted: function mounted() {
    //点击删除按钮之外的地方退出长按模式
    var that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.positiveClick = false;
        that.reverseLongClick = false; //是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions' && e.target.className != 'el-icon-refresh-left' && e.target.className != 'el-icon-refresh-right' && e.target.className != 'el-icon-c-scale-to-original' && e.target.className != 'el-icon-zoom-in' && e.target.className != 'el-icon-zoom-out' && e.target.className != 'el-image-viewer__actions__inner' && e.target.className != 'el-icon-full-screen' && e.target.className != 'el-icon-circle-close' && e.target.className != 'el-button el-button--default el-button--small') {
        //关闭照片查看器
        that.positiveDialog = false;
        that.reverseDialog = false;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b69152f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0009.vue
var i_0009_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i0009"},[_c('div',{staticClass:"i0009-title"},[_c('p',[_vm._v(_vm._s(_vm.$t('MODULE.I0009_LBL_SELF_CONFIRM')))])]),_vm._v(" "),_c('div',{staticClass:"i0009-main-border"},[_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"i0009-row_div-text",staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0009_LBL_DATA_CONFIRM')))])]),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('COMMON.PLACEHOLDER_SELECT')},on:{"change":_vm.confirmSelect,"visible-change":function($event){return _vm.selectBeforeChange($event)}},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},_vm._l((_vm.selectData),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.key}})}),1)],1)],1),_vm._v(" "),(_vm.selectType==='1')?_c('el-row',{staticStyle:{"margin-top":"10px"}},[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"i0009-row_div-text"})]),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[(!_vm.positiveUrl)?_c('div',{staticClass:"i0009_photo_border",class:{'positiveCss': _vm.positiveCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"positive",staticClass:"i0009_photo_upload",attrs:{"file-list":_vm.positiveList,"show-file-list":true,"list-type":"picture-card","limit":_vm.limitNum,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'positive','1')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"positiveImg","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePhotoPreview(file,'positive')}}},[(_vm.positiveLongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'positive','1')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}],null,false,3570833117)},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.positiveDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.positivePhotoDelete,"url-list":[_vm.positiveUrl]}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.selectType==='2')?_c('el-row',{staticStyle:{"margin-top":"10px"}},[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"i0009-row_div-text"},[_vm._v(_vm._s(_vm.$t('MODULE.I0009_LBL_FRONT_SIDE')))])]),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[(!_vm.positiveUrl)?_c('div',{staticClass:"i0009_photo_border",class:{'positiveCss': _vm.positiveCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"positive",staticClass:"i0009_photo_upload",attrs:{"file-list":_vm.positiveList,"show-file-list":true,"list-type":"picture-card","limit":_vm.limitNum,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'positive','1')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"positiveImg","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePhotoPreview(file,'positive')}}},[(_vm.positiveLongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'positive','1')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}],null,false,3570833117)},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.positiveDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.positivePhotoDelete,"url-list":[_vm.positiveUrl]}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.selectType==='2')?_c('el-row',{staticStyle:{"margin-top":"10px"}},[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"i0009-row_div-text"},[_vm._v(_vm._s(_vm.$t('MODULE.I0009_LBL_BACK_SIDE')))])]),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[(!_vm.reverseUrl)?_c('div',{staticClass:"i0009_photo_border",class:{'reverseCss': _vm.reverseCss}}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"reverse",staticClass:"i0009_photo_upload",attrs:{"file-list":_vm.reverseList,"show-file-list":true,"list-type":"picture-card","limit":_vm.limitNum,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"string","on-change":function (file, fileList) {_vm.handleChange(file, fileList,'reverse','2')},"auto-upload":false,"multiple":""},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return [_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"reverseImg","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePhotoPreview(file,'reverse')}}},[(_vm.reverseLongClick)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function (file, fileList) {_vm.fileRemove(file, fileList,'reverse','1')}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])]}}],null,false,295821597)},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.reverseDialog)?_c('el-image-viewer',{attrs:{"on-close":_vm.reversePhotoDelete,"url-list":[_vm.reverseUrl]}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.selectType==='2')?_c('el-row',{staticStyle:{"font-size":"12px","color":"red","margin-top":"10px"}},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0009_LBL_TEXT')))])]):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"align":"left"}},[_c('span',{staticStyle:{"font-size":"10pt"}},[_vm._v(_vm._s(_vm.statusNameLabel))])]),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary","disabled":_vm.editDisabled},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('MODULE.I0009_LBL_APPLY')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('MODULE.I0009_LBL_BACK')))])],1)])}
var i_0009_staticRenderFns = []
var i_0009_esExports = { render: i_0009_render, staticRenderFns: i_0009_staticRenderFns }
/* harmony default export */ var page_i_0009 = (i_0009_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0009.vue
function i_0009_injectStyle (ssrContext) {
  __webpack_require__("KqMY")
}
var i_0009_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0009___vue_template_functional__ = false
/* styles */
var i_0009___vue_styles__ = i_0009_injectStyle
/* scopeId */
var i_0009___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0009___vue_module_identifier__ = null
var i_0009_Component = i_0009_normalizeComponent(
  i_0009,
  page_i_0009,
  i_0009___vue_template_functional__,
  i_0009___vue_styles__,
  i_0009___vue_scopeId__,
  i_0009___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0009 = (i_0009_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0010.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var i_0010_url = __webpack_require__("kspH");
/* harmony default export */ var i_0010 = ({
  data: function data() {
    return {};
  },

  methods: {
    // 日本国籍の方
    btn1Click: function btn1Click() {
      this.$router.push({ path: i_0010_url.routerUrl_I0002 });
    },

    // 外国籍の方
    btn2Click: function btn2Click() {
      this.$router.push({ path: i_0010_url.routerUrl_I0007 });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d076ad1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0010.vue
var i_0010_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"i0010-explain"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0010_LBL_TEXT'))}})]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"},attrs:{"align":"center"}},[_c('el-button',{staticClass:"i0010-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0010_LBL_BTN1'))},on:{"click":function($event){return _vm.btn1Click()}}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"},attrs:{"align":"center"}},[_c('el-button',{staticClass:"i0010-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0010_LBL_BTN2'))},on:{"click":function($event){return _vm.btn2Click()}}})],1)])}
var i_0010_staticRenderFns = []
var i_0010_esExports = { render: i_0010_render, staticRenderFns: i_0010_staticRenderFns }
/* harmony default export */ var page_i_0010 = (i_0010_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0010.vue
function i_0010_injectStyle (ssrContext) {
  __webpack_require__("o8uO")
}
var i_0010_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0010___vue_template_functional__ = false
/* styles */
var i_0010___vue_styles__ = i_0010_injectStyle
/* scopeId */
var i_0010___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0010___vue_module_identifier__ = null
var i_0010_Component = i_0010_normalizeComponent(
  i_0010,
  page_i_0010,
  i_0010___vue_template_functional__,
  i_0010___vue_styles__,
  i_0010___vue_scopeId__,
  i_0010___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0010 = (i_0010_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0011.js




var i_0011_apiUrl = __webpack_require__("kspH");
// 誓約・同意既読フラグ検索
var i_0011_readFlagSearch = function readFlagSearch(userCd) {
    return api_public.requestGet(i_0011_apiUrl.apiUrl_ReadFlag + '?userCd=' + userCd);
};
// 誓約・同意既読フラグ検索
var i_0011_readFlagUpdate = function readFlagUpdate(saveParams) {
    return api_public.requestPost(i_0011_apiUrl.apiUrl_ReadFlag, saveParams);
};
// お知らせ詳細検索
var i_0011_noticeDetailSearch = function noticeDetailSearch(userCd) {
    return api_public.requestGet(i_0011_apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd);
};
//PDF查询
var i_0011_PDFFile_get = function PDFFile_get(PDFPath) {
    return api_public.requestQuickGetImage(i_0011_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(PDFPath) + '&resizeCd=0');
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0011.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var i_0011_url = __webpack_require__("kspH");

/* harmony default export */ var i_0011 = ({
  mixins: [css],
  components: {
    Pdf: components_page_pdf
  },
  data: function data() {
    return {
      checked: false,
      disabled: true,
      btn1: false,
      btn2: false,
      btn3: false,
      btn4: false,
      btn5: false,
      //就業規則フラグ
      btn1Flag: '0',
      //個人情報告知フラグ
      btn2Flag: '0',
      //支払明示フラグ
      btn3Flag: '0',
      //雇用電磁フラグ
      btn4Flag: '0',
      //給与電磁フラグ
      btn5Flag: '0',
      //契約締結可能フラグ
      totalFlag: '0',
      //処理区分
      processCd: '',
      //pdfFlag
      viewVisible: false,
      pdfUrl: '',
      pdfPath: '',
      menuOpenShow: false //是否可以按下菜单按钮
    };
  },

  methods: {
    //申請btn
    applyBtnClick: function applyBtnClick() {
      this.$router.push({ path: i_0011_url.routerUrl_C0001 });
    },
    btnClick: function btnClick(btn) {
      this[btn + 'Flag'] = '1';
      this.popMethod(btn);
      this.readFlagUpdate();
      this.handleMenuState();
    },

    //获取menu状态
    handleMenuState: function handleMenuState() {
      var _this = this;

      home_menuStateManager(this.userInfo.userCd).then(function (res) {
        if (res.code == 204) {
          var menuState = res.items.menuState[0];
          localStorage.setItem("menuState", stringify_default()(menuState));
          //
          if (menuState.i0011Used == '0' && menuState.c0001Expired == '1') {
            _this.menuOpenShow = false;
          } else {
            _this.menuOpenShow = true;
          }
        }
      });
    },

    //pop
    popMethod: function popMethod(btn) {
      var _this2 = this;

      if (btn == 'btn1') {
        this.pdfPath = i_0011_url.routerUrl_I0011_btn1URL;
      }
      if (btn == 'btn2') {
        this.pdfPath = i_0011_url.routerUrl_I0011_btn2URL;
      }
      if (btn == 'btn3') {
        this.pdfPath = i_0011_url.routerUrl_I0011_btn3URL;
      }
      if (btn == 'btn4') {
        this.pdfPath = i_0011_url.routerUrl_I0011_btn4URL;
      }
      if (btn == 'btn5') {
        this.pdfPath = i_0011_url.routerUrl_I0011_btn5URL;
      }
      this.set_loading();
      i_0011_PDFFile_get(this.pdfPath).then(function (res_file) {
        var fileUrl = {};
        var blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' });
        var url = window.URL.createObjectURL(blob);
        fileUrl.url = url;
        fileUrl.name = _this2.pdfPath;
        for (var index = 0; index < 2; index++) {
          fileUrl.name = fileUrl.name.substring(fileUrl.name.indexOf('/') + 1);
        }
        _this2.download(fileUrl);
        _this2.close_loading();
      }).catch(function (err) {
        //关闭loading
        _this2.close_loading();
      });
    },
    pdfClose: function pdfClose() {
      this.viewVisible = false;
    },

    //pdfダウンロード
    download: function download(file) {
      this.pdfUrl = file;
      this.viewVisible = true;
    },

    //誓約・同意既読フラグ検索
    readFlagSearch: function readFlagSearch() {
      var _this3 = this;

      i_0011_readFlagSearch(this.userInfo.userCd).then(function (res) {
        if (res.code == '204') {
          if (res.items.readFlag[0].processCd == '2') {
            _this3.processCd = res.items.readFlag[0].processCd;
          } else if (res.items.readFlag[0].processCd == '1') {
            _this3.btn1Flag = res.items.readFlag[0].workRulesFlag;
            _this3.btn2Flag = res.items.readFlag[0].personalInfoFlag;
            _this3.btn3Flag = res.items.readFlag[0].paymentExplicateFlag;
            _this3.btn4Flag = res.items.readFlag[0].employmentEmFlag;
            _this3.btn5Flag = res.items.readFlag[0].salaryEmFlag;
            _this3.totalFlag = res.items.readFlag[0].contractPossibleFlag;
            _this3.processCd = res.items.readFlag[0].processCd;
          }
          _this3.btnInit();
        } else if (res.code == '300') {
          //検索結果0件
          _this3.processCd = '2';
          _this3.$message.warning({ message: _this3.$t('COMMON.NO_TARGET_DATA'), showClose: true });
        }
      });
    },

    //誓約・同意既読フラグ更新
    readFlagUpdate: function readFlagUpdate() {
      var _this4 = this;

      if (this.btn2Flag == '1' && this.btn3Flag == '1' && this.btn4Flag == '1' && this.btn5Flag == '1') {
        this.$store.commit('increment', '0');
        this.totalFlag = '1';
      }
      var updateParam = [{
        "userId": this.userInfo.userCd,
        "workRulesFlag": this.btn1Flag,
        "personalInfoFlag": this.btn2Flag,
        "paymentExplicateFlag": this.btn3Flag,
        "employmentEmFlag": this.btn4Flag,
        "salaryEmFlag": this.btn5Flag,
        "contractPossibleFlag": this.totalFlag,
        "processCd": this.processCd
      }];
      i_0011_readFlagUpdate(updateParam).then(function (res) {
        if (res.code == '202') {
          _this4.readFlagSearch();
        } else if (res.code == '311') {
          _this4.$message.error({ message: _this4.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
        }
      });
    },

    //btn初期化
    btnInit: function btnInit() {
      for (var index = 1; index <= 5; index++) {
        if (this['btn' + index + 'Flag'] == '1') {
          this['btn' + index] = true;
        }
      }

      if (this.totalFlag == '1') {
        this.$store.commit('increment', '0');
        this.disabled = false;
      } else {
        this.$store.commit('increment', '1');
      }
      this.handleMenuState();
    },
    back: function back() {
      var _this5 = this;

      i_0011_noticeDetailSearch(this.userInfo.userCd).then(function (res) {
        if (res.code == '204') {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = get_iterator_default()(res.items.tNoticeDetail), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              //未読のを知らせがある場合、お知らせ一覧画面へ遷移する
              if (item.confirmFlag == 0) {
                _this5.$router.push({ path: i_0011_url.routerUrl_B0001 });
                return;
              } else {
                //未読のお知らせがない場合、スケジュール画面へ遷移する
                _this5.$router.push({ path: i_0011_url.routerUrl_S0001 });
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else if (res.code == '300') {
          //お知らせがない場合、スケジュール画面へ遷移する
          _this5.$router.push({ path: i_0011_url.routerUrl_S0001 });
        }
      });
    }
  },
  created: function created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    //誓約・同意既読フラグ検索
    this.readFlagSearch();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e64e2d60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0011.vue
var i_0011_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"padding":"5px 10px","font-size":"13px"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0011_LBL_TITLE')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"15px"}},[_c('el-col',{attrs:{"align":"center","span":24}},[_c('el-button',{class:[{i0011_afterClick:_vm.btn1},{i0011_button:!_vm.btn1}],staticStyle:{"width":"95%"},attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0011_LBL_BTN1'))},on:{"click":function($event){return _vm.btnClick('btn1')}}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"15px"}},[_c('el-col',{attrs:{"align":"center","span":12}},[_c('el-button',{class:[{i0011_afterClick:_vm.btn2},{i0011_button:!_vm.btn2}],attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0011_LBL_BTN2'))},on:{"click":function($event){return _vm.btnClick('btn2')}}})],1),_vm._v(" "),_c('el-col',{attrs:{"align":"center","span":12}},[_c('el-button',{class:[{i0011_afterClick:_vm.btn3},{i0011_button:!_vm.btn3}],attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0011_LBL_BTN4'))},on:{"click":function($event){return _vm.btnClick('btn3')}}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px"}},[_c('el-col',{attrs:{"align":"center","span":12}},[_c('el-button',{class:[{i0011_afterClick:_vm.btn4},{i0011_button:!_vm.btn4}],attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0011_LBL_BTN5'))},on:{"click":function($event){return _vm.btnClick('btn4')}}})],1),_vm._v(" "),_c('el-col',{attrs:{"align":"center","span":12}},[_c('el-button',{class:[{i0011_afterClick:_vm.btn5},{i0011_button:!_vm.btn5}],attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0011_LBL_BTN6'))},on:{"click":function($event){return _vm.btnClick('btn5')}}})],1)],1),_vm._v(" "),_c('el-checkbox',{staticClass:"i0011_checkbox",staticStyle:{"margin-left":"10px"},attrs:{"disabled":_vm.disabled},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0011_LBL_CONSENT')))]),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center","padding-top":"10px"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"width":"140px"},attrs:{"type":"primary","disabled":!_vm.checked},on:{"click":_vm.applyBtnClick}},[_vm._v(_vm._s(_vm.$t('MODULE.I0011_LBL_APPLY')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",attrs:{"type":"primary","disabled":_vm.menuOpenShow},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"fullscreen":"","visible":_vm.viewVisible,"close-on-click-modal":false,"show-close":false,"width":"100%","top":"52px","height":"120%"},on:{"update:visible":function($event){_vm.viewVisible=$event}}},[_c('Pdf',{attrs:{"src":_vm.pdfUrl},on:{"pdfClose":_vm.pdfClose}})],1)],1)}
var i_0011_staticRenderFns = []
var i_0011_esExports = { render: i_0011_render, staticRenderFns: i_0011_staticRenderFns }
/* harmony default export */ var page_i_0011 = (i_0011_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0011.vue
function i_0011_injectStyle (ssrContext) {
  __webpack_require__("ke1e")
}
var i_0011_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0011___vue_template_functional__ = false
/* styles */
var i_0011___vue_styles__ = i_0011_injectStyle
/* scopeId */
var i_0011___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0011___vue_module_identifier__ = null
var i_0011_Component = i_0011_normalizeComponent(
  i_0011,
  page_i_0011,
  i_0011___vue_template_functional__,
  i_0011___vue_styles__,
  i_0011___vue_scopeId__,
  i_0011___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0011 = (i_0011_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0012.js




var i_0012_apiUrl = __webpack_require__("kspH");
// パスワード変更
var i_0012_pwChange = function pwChange(params) {
    return api_public.requestPost(i_0012_apiUrl.apiUrl_PwChange, params);
};
// メニュー状態管理検索
var i_0012_menuStateManagerGet = function menuStateManagerGet(userCd) {
    return api_public.requestGet(i_0012_apiUrl.apiurl_MenuStateManager + '?userId=' + userCd);
};
// お知らせ詳細検索
var i_0012_noticeDetailSearch = function noticeDetailSearch(userCd) {
    return api_public.requestGet(i_0012_apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd);
};
// menu列表
var i_0012_login_check = function login_check(params) {
    return api_public.requestPost(i_0012_apiUrl.apiUrl_LoginCheck, params);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0012.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var i_0012_url = __webpack_require__("kspH");


/* harmony default export */ var i_0012 = ({
  mixins: [css],
  data: function data() {
    return {
      newPassword: '',
      newPasswordAffirm: ''
    };
  },

  methods: {
    //input入力チェック
    i0012ApplicationOnClick: function i0012ApplicationOnClick() {
      var re = new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/);
      if (!re.test(this.newPassword)) {
        this.$message.error({ message: this.$t('COMMON.MSG_PWRESET_VALIDITY'), showClose: true });
        return;
      }
      if (this.newPassword != this.newPasswordAffirm) {
        this.$message.error({ message: this.$t('COMMON.MSG_NEWPW_VALIDITY'), showClose: true });
        return;
      }
      this.passwordUpdate();
    },

    //パスワード変更
    passwordUpdate: function passwordUpdate() {
      var _this = this;

      var params = {};
      params.userId = JSON.parse(localStorage.getItem('userInfo')).userCd;
      params.password = this.newPassword;
      params.oneTimePwFlag = '0';
      i_0012_pwChange(params).then(function (res) {
        if (res.code == '202') {
          //変更成功
          _this.$message.success({ message: _this.$t('COMMON.UPDATED'), showClose: true });
          _this.$store.commit('passwordUpdate', '1');
          _this.newPasswordAffirm = '';
          _this.newPassword = '';
          _this.loginCheck(params.userId, params.password);
          //遷移先判定
          _this.menuStateManagerGet(params.userId);
        } else if (res.code == '311') {
          //変更失敗
          _this.$message.error({ message: _this.$t('COMMON.CURD_ERROR'), showClose: true });
        }
      });
    },

    //誓約・同意画面を表示する
    menuStateManagerGet: function menuStateManagerGet(userId) {
      var _this2 = this;

      i_0012_menuStateManagerGet(userId).then(function (res) {
        if (res.code == 204) {
          var i0011UsedNum = res.items.menuState[0].i0011Used;
          if (i0011UsedNum == 1) {
            _this2.$router.push({ path: i_0012_url.routerUrl_I0011 });
          } else {
            _this2.noticeDetailSearch(userId);
          }
        }
      }).catch(function (err) {});
    },

    //お知らせ一覧画面を表示する
    noticeDetailSearch: function noticeDetailSearch(userId) {
      var _this3 = this;

      i_0012_noticeDetailSearch(userId).then(function (res) {
        if (res.code == '204') {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = get_iterator_default()(res.items.tNoticeDetail), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.confirmFlag == 0) {
                _this3.$router.push({ path: i_0012_url.routerUrl_B0001 });
                return;
              } else {
                _this3.$router.push({ path: i_0012_url.routerUrl_S0001 });
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else if (res.code == '300') {
          _this3.$router.push({ path: i_0012_url.routerUrl_S0001 });
        }
      });
    },

    //token再取得
    loginCheck: function loginCheck(userId, password) {
      var _this4 = this;

      var loginParams = { userCd: userId, password: password };
      i_0012_login_check(loginParams).then(function (res) {
        if (res.code != '200') {
          _this4.$message.error({ message: _this4.$t('COMMON.LOGIN_LBL_LOGINCHECK_ERROR'), showClose: true });
          return;
        }
      }).catch(function (err) {
        _this4.$message.error({ message: _this4.$t('COMMON.LOGIN_LBL_LOGINCHECK_ERROR'), showClose: true });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-092b7190","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0012.vue
var i_0012_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"i0012-top-warn"},[_vm._v("\n    "+_vm._s(_vm.$t('MODULE.I0012_LBL_TOP_WARN'))+"\n  ")]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#fafafa"}},[_c('el-row',{staticStyle:{"text-align":"center"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0012_LBL_PASSWORD_CHANGE')))])]),_vm._v(" "),_c('table',{staticClass:"i0012-table table-label"},[_c('tr',[_c('td',{staticClass:"i0012-form-label",staticStyle:{"line-height":"30px"}},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0012_LBL_NEW_PASSWORD')))])]),_vm._v(" "),_c('td',[_c('el-input',{staticClass:"i0012-input",attrs:{"type":"password"},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0012-form-label",staticStyle:{"line-height":"30px"}},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0012_LBL_NEW_PASSWORD_CONFIRM')))])]),_vm._v(" "),_c('td',[_c('el-input',{staticClass:"i0012-input",attrs:{"type":"password"},model:{value:(_vm.newPasswordAffirm),callback:function ($$v) {_vm.newPasswordAffirm=$$v},expression:"newPasswordAffirm"}})],1)])])])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"},attrs:{"align":"center"}},[_c('div',{staticClass:"i0012-bottom-warn"},[_vm._v(_vm._s(_vm.$t('MODULE.I0012_LBL_BOTTOM_WARN')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",attrs:{"type":"primary"},on:{"click":_vm.i0012ApplicationOnClick}},[_vm._v(_vm._s(_vm.$t('MODULE.I0012_LBL_CHANGE')))])],1)])}
var i_0012_staticRenderFns = []
var i_0012_esExports = { render: i_0012_render, staticRenderFns: i_0012_staticRenderFns }
/* harmony default export */ var page_i_0012 = (i_0012_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0012.vue
function i_0012_injectStyle (ssrContext) {
  __webpack_require__("J4+u")
}
var i_0012_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0012___vue_template_functional__ = false
/* styles */
var i_0012___vue_styles__ = i_0012_injectStyle
/* scopeId */
var i_0012___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0012___vue_module_identifier__ = null
var i_0012_Component = i_0012_normalizeComponent(
  i_0012,
  page_i_0012,
  i_0012___vue_template_functional__,
  i_0012___vue_styles__,
  i_0012___vue_scopeId__,
  i_0012___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0012 = (i_0012_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0013.js



var i_0013_apiUrl = __webpack_require__("kspH");
// マイカー出勤申請確認 API「スタッフ申請確認ログ保存」
var i_0013_i_0013_confirmlog = function i_0013_confirmlog(params, userCd) {
  return api_public.requestPost(i_0013_apiUrl.apiUrl_StaffApplyConfirmLog + '?userCd=' + userCd, [params]);
};
//マイカー出勤申請確認 API「マイカー使用有無検索」
var i_0013_i_0013_mycarusecheck = function i_0013_mycarusecheck(userCd) {
  return api_public.requestQuickGet(i_0013_apiUrl.apiUrl_myCarUseInfo + '?userCd=' + userCd);
};
// メニュー状態管理検索
var i_0013_menuStateManagerGet = function menuStateManagerGet(userCd) {
  return api_public.requestGet(i_0013_apiUrl.apiurl_MenuStateManager + '?userId=' + userCd);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0013.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var i_0013_url = __webpack_require__("kspH");


/* harmony default export */ var i_0013 = ({
  mixins: [css],
  components: {},
  data: function data() {
    return {
      //氏名
      name: '',
      //スタッフCD
      userCd: '',
      //営業所
      address: '',
      //承諾
      radioValue: '',
      //同意
      checkboxValue: false
    };
  },

  // 初期化
  created: function created() {
    //氏名
    this.name = JSON.parse(localStorage.getItem('userInfo')).userName;
    //スタッフCD
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    //営業所
    this.address = JSON.parse(localStorage.getItem('userInfo')).salesOfficeAbbreviation;
    //承諾
    this.radioValue = "";
    //同意
    this.checkboxValue = false;
    ///書類の期限切れの有無を取得する。
    this.mycarPeriodCheck();
  },

  methods: {
    // 入力画面
    inputPicuture_click: function inputPicuture_click() {
      var _this = this;

      // //マイカー使用有無をチェック
      // //API「マイカー使用有無検索」を呼び出す。
      // amsApi.i_0013_mycarusecheck(this.userCd).then(res => {
      //   if (res.code == 204) {
      //     if (res.items.myCarUse == 1) {
      //       //マイカー使用有無が「1：有」の場合、処理を続け
      //       //API「スタッフ申請確認ログ保存」を呼び出す。
      //       var params = {
      //         stfConfirmType: "3",//3（マイカー通勤）
      //         stfConfirmResult: "1",//同意
      //         stfConfirmUserCd: JSON.parse(localStorage.getItem('userInfo')).userCd,
      //       };
      //       amsApi.i_0013_confirmlog(params, this.userCd).then(res => {
      //         if (res.code == 202) {
      //           //マイカー出勤申請画面へ遷移
      //           this.$router.push({ path: url.routerUrl_I0008 });
      //         } else if (res.code == 311) {
      //           this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
      //         }
      //       });
      //     } else {
      //       //マイカー使用有無が上記以外の場合、エラーメッセージ「マイカー使用無のため、入力画面へ遷移できません。」
      //       this.$message.error({ message: this.$t('COMMON.MSG_MYCAR_USE_CHE'), showClose: true });
      //     }
      //   } else if (res.code == 300) {
      //     this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
      //   }
      // });

      //API「スタッフ申請確認ログ保存」を呼び出す。
      var params = {
        stfConfirmType: "3", //3（マイカー通勤）
        stfConfirmResult: "1", //同意
        stfConfirmUserCd: JSON.parse(localStorage.getItem('userInfo')).userCd
      };
      i_0013_i_0013_confirmlog(params, this.userCd).then(function (res) {
        if (res.code == 202) {
          //マイカー出勤申請画面へ遷移
          _this.$router.push({ path: i_0013_url.routerUrl_I0008 });
        } else if (res.code == 311) {
          _this.$message.error({ message: _this.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
        }
      });
    },

    //書類の期限切れの有無を取得する。
    mycarPeriodCheck: function mycarPeriodCheck() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return i_0013_menuStateManagerGet(_this2.userCd).then(function (res) {
                  if (res.code == 204) {
                    //レスポンス．マイカー通勤申請(期間切れ)＝0の場合、警告メッセージ[（辞書ID：MSG_MYCAR_PERIOD_CHECK）を表示する。
                    var i0008Expired = res.items.menuState[0].i0008Expired;
                    var i0008Used = res.items.menuState[0].i0008Used;
                    if (i0008Expired == 0 && i0008Used != 2) {
                      _this2.$message.warning({ message: _this2.$t('COMMON.MSG_MYCAR_PERIOD_CHECK'), showClose: true });
                    }
                  }
                }).catch(function (error) {});

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af27978","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0013.vue
var i_0013_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_i0013"},[_c('div',{staticClass:"el-detail_i0013"},[_c('el-row',{staticStyle:{"padding-bottom":"10px"}},[_c('table',{staticClass:"i0013-table table-label"},[_c('tr',[_c('td',{staticClass:"i0013-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_NAME')))]),_vm._v(" "),_c('td',{staticClass:"i0013-form-value"},[_vm._v(_vm._s(this.name))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0013-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_NUMBER')))]),_vm._v(" "),_c('td',{staticClass:"i0013-form-value"},[_vm._v(_vm._s(this.userCd))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0013-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_ADDRESS')))]),_vm._v(" "),_c('td',{staticClass:"i0013-form-value"},[_vm._v(_vm._s(this.address))])])]),_vm._v(" "),_c('div',{staticClass:"table-label",staticStyle:{"color":"red","padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_A')))]),_vm._v(" "),_c('div',{staticClass:"table-label",staticStyle:{"margin-top":"3px","padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_B')))]),_vm._v(" "),_c('div',{staticClass:"table-label",staticStyle:{"margin-top":"3px","padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_C')))]),_vm._v(" "),_c('div',{staticClass:"table-label",staticStyle:{"margin-top":"3px","padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_D')))]),_vm._v(" "),_c('div',{staticClass:"table-label",staticStyle:{"margin-top":"3px","padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_E')))])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"table-header",staticStyle:{"text-align":"left"}},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_F')))])]),_vm._v(" "),_c('table',{staticClass:"i0013-table table-label"},[_c('tr',[_c('td',{staticStyle:{"border":"1px","border-right-style":"none","text-align":"left","background":"#fafafa","width":"45%"}},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_G'))),_c('br'),_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_H')))]),_vm._v(" "),_c('td',{staticStyle:{"border":"1px","border-left-style":"none","text-align":"left","background":"#fafafa"}},[_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.radioValue),callback:function ($$v) {_vm.radioValue=$$v},expression:"radioValue"}},[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_YES')))])]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"},model:{value:(_vm.radioValue),callback:function ($$v) {_vm.radioValue=$$v},expression:"radioValue"}},[_c('span',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_NO')))])])],1)])])]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"table-header",staticStyle:{"text-align":"left"}},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_P')))])]),_vm._v(" "),_c('table',{staticClass:"i0013-table table-label"},[_c('tr',{staticClass:"i0013-form-value1"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_I')))]),_vm._v(" "),_c('tr',{staticClass:"i0013-form-value1"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_J')))])])])],1),_vm._v(" "),_c('div',[_c('el-checkbox',{staticStyle:{"margin-left":"5px","margin-top":"10px"},model:{value:(_vm.checkboxValue),callback:function ($$v) {_vm.checkboxValue=$$v},expression:"checkboxValue"}},[_c('div',{staticClass:"table-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_LBL_TEXT_O')))])])],1),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"26%"},attrs:{"type":"primary","disabled":!(this.radioValue == 1 && this.checkboxValue)},on:{"click":_vm.inputPicuture_click}},[_vm._v(_vm._s(_vm.$t('MODULE.I0013_BTN_INPUT_PICTURE')))])],1)],1)])])}
var i_0013_staticRenderFns = []
var i_0013_esExports = { render: i_0013_render, staticRenderFns: i_0013_staticRenderFns }
/* harmony default export */ var page_i_0013 = (i_0013_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0013.vue
function i_0013_injectStyle (ssrContext) {
  __webpack_require__("O3N8")
}
var i_0013_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0013___vue_template_functional__ = false
/* styles */
var i_0013___vue_styles__ = i_0013_injectStyle
/* scopeId */
var i_0013___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0013___vue_module_identifier__ = null
var i_0013_Component = i_0013_normalizeComponent(
  i_0013,
  page_i_0013,
  i_0013___vue_template_functional__,
  i_0013___vue_styles__,
  i_0013___vue_scopeId__,
  i_0013___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0013 = (i_0013_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0014.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var i_0014_url = __webpack_require__("kspH");

/* harmony default export */ var i_0014 = ({
  data: function data() {
    return {
      userInfo: []
    };
  },

  methods: {
    //初期トレーニング方法処理
    button1_Click: function button1_Click() {
      window.open(i_0014_url.routerUrl_I0014_btn1URL);
    },

    //コンプライアンス方法処理
    button2_Click: function button2_Click() {
      window.open(i_0014_url.routerUrl_I0014_btn2URL);
    }
  },
  created: function created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e6b69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0014.vue
var i_0014_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-container',{staticStyle:{"padding":"0px","width":"100%","height":"100%","margin-top":"25%"}},[_c('el-main',{staticStyle:{"padding":"100px 0px 10px 0px","width":"100%","height":"100%"}},[_c('div',{attrs:{"align":"center"}},[_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"}},[_c('el-button',{staticClass:"i0014-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0014_LBL_BTN1'))},nativeOn:{"click":function($event){return _vm.button1_Click.apply(null, arguments)}}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 0px 15px 0px"}},[_c('el-button',{staticClass:"i0014-button1 css-btn",attrs:{"type":"primary"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0014_LBL_BTN2'))},nativeOn:{"click":function($event){return _vm.button2_Click.apply(null, arguments)}}})],1)])])],1)],1)}
var i_0014_staticRenderFns = []
var i_0014_esExports = { render: i_0014_render, staticRenderFns: i_0014_staticRenderFns }
/* harmony default export */ var page_i_0014 = (i_0014_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0014.vue
function i_0014_injectStyle (ssrContext) {
  __webpack_require__("x55n")
}
var i_0014_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0014___vue_template_functional__ = false
/* styles */
var i_0014___vue_styles__ = i_0014_injectStyle
/* scopeId */
var i_0014___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0014___vue_module_identifier__ = null
var i_0014_Component = i_0014_normalizeComponent(
  i_0014,
  page_i_0014,
  i_0014___vue_template_functional__,
  i_0014___vue_styles__,
  i_0014___vue_scopeId__,
  i_0014___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0014 = (i_0014_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0015.js
/*
 * @Description: 
 * @Version: 
 * @Autor: 
 * @Date: 2022-02-16 09:24:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-18 09:13:16
 */



var i_0015_apiUrl = __webpack_require__("kspH");

var i_0015_i_0015_search = function i_0015_search(month, userCd) {
  return api_public.requestGet(i_0015_apiUrl.apiUrl_holidaySearch + '?month=' + month + '&userCd=' + userCd);
};
var i_0015_i_0015_detail_search = function i_0015_detail_search(jobDate) {
  return api_public.requestGet(i_0015_apiUrl.apiUrl_holidayDetailSearch + '?jobDate=' + jobDate);
};
var i_0015_i_0015_update = function i_0015_update(params, userCd) {
  return api_public.requestPost(i_0015_apiUrl.apiUrl_holidaySave + '?userCd=' + userCd, params);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0015.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var i_0015_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var i_0015 = ({
  mixins: [css],
  data: function data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      list: [],
      fullscreenLoading: false,
      yearOpt: ''
    };
  },
  created: function created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (!this.yearOpt && !this.$route.query.yearOpt) {
      this.yearOpt = this.timeDefault();
    } else {
      this.yearOpt = this.$route.query.yearOpt;
    }
    // 期間より検索
    this.query();
  },
  mounted: function mounted() {},

  methods: {
    //默认作業期間
    timeDefault: function timeDefault() {
      var date = new Date();
      var curr_month = date.getMonth() + 1;
      var curr_year = date.getFullYear();
      String(curr_month).length < 2 ? curr_month = "0" + curr_month : curr_month;
      var s1 = curr_year + "/" + curr_month;
      return s1;
    },
    query: function query() {
      var _this = this;

      this.list = [];
      //实现Loading 加载方法
      this.set_loading();
      //取得当前用户的用户ID
      var userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
      var yearMonth = this.yearOpt.split('/')[0] + this.yearOpt.split('/')[1];
      //检索条件保存到本地
      sessionStorage.setItem('searchParam', stringify_default()(yearMonth));
      i_0015_i_0015_search(yearMonth, userCd).then(function (response) {
        if (response.code === 300) {
          _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
          _this.list = [];
          //关闭loading
          _this.close_loading();
          return;
        }
        _this.list = response.items.holidayInfoSet;
        // doLayout  再加载
        _this.table_doLayout();
        //关闭loading
        _this.close_loading();
      }).catch(function (err) {
        //关闭loading
        _this.close_loading();
      });
    },

    // TABLEHeader样式
    i0015HeaderStyle: function i0015HeaderStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:15px;text-align:center ';
    },

    // TABLE单元格样式
    i0015IsCellStyle: function i0015IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return 'text-align:center;fontSize:13px';
    },

    // 单击行事件
    i0015RowOnClick: function i0015RowOnClick(thisRowDate, column, cell, event) {
      sessionStorage.setItem('I0015Param', stringify_default()(thisRowDate));
      sessionStorage.setItem('I0016ProcessDiv', stringify_default()('2'));
      this.$router.push({ path: i_0015_url.routerUrl_I0016, query: { yearOpt: this.yearOpt } });
    },

    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    //追加按钮按下
    handleClickNextYear: function handleClickNextYear(e) {
      sessionStorage.setItem('I0016ProcessDiv', stringify_default()('1'));
      this.$router.push({ path: i_0015_url.routerUrl_I0016, query: { yearOpt: this.yearOpt } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f098e97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0015.vue
var i_0015_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-container',{staticStyle:{"padding":"0px","width":"100%","height":"100%"}},[_c('el-main',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('div',[_c('el-row',{staticStyle:{"padding-top":"5px","padding-left":"5px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[_c('el-date-picker',{staticStyle:{"width":"110px"},attrs:{"format":"yyyy/MM","type":"month","value-format":"yyyy/MM","size":"mini","clearable":false,"editable":false},on:{"blur":function($event){return _vm.query()}},model:{value:(_vm.yearOpt),callback:function ($$v) {_vm.yearOpt=$$v},expression:"yearOpt"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"css-btn css-button",staticStyle:{"margin-left":"30%"},attrs:{"type":"primary","id":"next_year","size":"mini"},on:{"click":_vm.handleClickNextYear}},[_vm._v(_vm._s(_vm.$t('MODULE.I0015_BTN_ADD')))])],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"3px","padding-bottom":"5px"}}),_vm._v(" "),_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA"},attrs:{"header-cell-style":_vm.i0015HeaderStyle,"cell-style":_vm.i0015IsCellStyle,"data":_vm.list,"border":"","size":"mini"},on:{"row-click":_vm.i0015RowOnClick}},[_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.I0015_LBL_APPLY_DATE'),"min-width":"50px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.jobDate))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.I0015_LBL_STATE'),"min-width":"40px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.statusName))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.I0015_LBL_ADMINISTRATOR'),"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.approvalUser))])]}}])})],1)],1)],1)],1)}
var i_0015_staticRenderFns = []
var i_0015_esExports = { render: i_0015_render, staticRenderFns: i_0015_staticRenderFns }
/* harmony default export */ var page_i_0015 = (i_0015_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0015.vue
function i_0015_injectStyle (ssrContext) {
  __webpack_require__("ZTT/")
}
var i_0015_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0015___vue_template_functional__ = false
/* styles */
var i_0015___vue_styles__ = i_0015_injectStyle
/* scopeId */
var i_0015___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0015___vue_module_identifier__ = null
var i_0015_Component = i_0015_normalizeComponent(
  i_0015,
  page_i_0015,
  i_0015___vue_template_functional__,
  i_0015___vue_styles__,
  i_0015___vue_scopeId__,
  i_0015___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0015 = (i_0015_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0016.vue




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var i_0016_url = __webpack_require__("kspH");
/* harmony default export */ var i_0016 = ({
  mixins: [css],
  data: function data() {
    return {
      title: '',
      text: '',
      user: '',
      status: '',
      statusName: '',
      yearMonthDay: '',
      updateDate: '',
      buttonShowable: false,
      buttonReadonly: false,
      dateEditable: false
    };
  },
  mounted: function mounted() {
    this.yearMonthDay = this.timeDefaultDay();
  },

  methods: (_methods = {
    buttonShowableChange: function buttonShowableChange(row) {
      if (JSON.parse(sessionStorage.getItem('I0016ProcessDiv')) === '1') {
        this.buttonShowable = true;
        this.buttonReadonly = false;
      }
      if (row) {
        if (row.status == '0') {
          this.buttonShowable = false;
          this.buttonReadonly = true;
        } else if (row.status == '1') {
          this.buttonShowable = true;
          this.buttonReadonly = true;
        } else if (row.status == '3') {
          this.buttonShowable = true;
          this.buttonReadonly = false;
        }
      }
    },
    dateCheck: function dateCheck() {
      if (!this.yearMonthDay) {
        return;
      }
      var thisDate = this.timeDefault();
      var inputDate = this.yearMonthDay.substring(0, 7);
      if (inputDate < thisDate) {
        this.$message.error({ message: this.$t('COMMON.MSG_PASTDATE_SELECT'), showClose: true });
        this.yearMonthDay = this.timeDefaultDay();
      }
    },
    timeDefault: function timeDefault() {
      var date = new Date();
      var curr_month = date.getMonth() + 1;
      var curr_year = date.getFullYear();
      String(curr_month).length < 2 ? curr_month = "0" + curr_month : curr_month;
      var s1 = curr_year + "/" + curr_month;
      return s1;
    },
    timeDefaultDay: function timeDefaultDay() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1;
      var curr_year = date.getFullYear();
      String(curr_month).length < 2 ? curr_month = "0" + curr_month : curr_month;
      String(curr_date).length < 2 ? curr_date = "0" + curr_date : curr_date;
      var s1 = curr_year + "/" + curr_month + "/" + curr_date;
      return s1;
    },

    // 戻る処理
    back_click: function back_click() {
      this.$router.push({ path: i_0016_url.routerUrl_I0015, query: { yearOpt: this.$route.query.yearOpt } });
    },
    query: function query() {
      var _this = this;

      i_0015_i_0015_detail_search(JSON.parse(sessionStorage.getItem('I0015Param')).jobDate).then(function (response) {
        if (response.code === 300) {
          _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
          _this.list = [];
          //关闭loading
          _this.close_loading();
          return;
        }
        _this.dateEditable = true;
        _this.yearMonthDay = response.items.holidayDetailSet[0].jobDate;
        _this.status = response.items.holidayDetailSet[0].status;
        _this.statusName = response.items.holidayDetailSet[0].statusName;
        _this.user = response.items.holidayDetailSet[0].approvalUserName;
        _this.text = response.items.holidayDetailSet[0].remandReason;
        _this.updateDate = response.items.holidayDetailSet[0].updateDate;
        _this.buttonShowableChange(response.items.holidayDetailSet[0]);
        // doLayout  再加载
        _this.table_doLayout();
        //关闭loading
        _this.close_loading();
      }).catch(function (err) {
        //关闭loading
        _this.close_loading();
      });
    }
  }, defineProperty_default()(_methods, "timeDefault", function timeDefault() {
    var date = new Date();
    var curr_month = date.getMonth() + 1;
    var curr_year = date.getFullYear();
    String(curr_month).length < 2 ? curr_month = "0" + curr_month : curr_month;
    var s1 = curr_year + "/" + curr_month;
    return s1;
  }), defineProperty_default()(_methods, "querySave", function querySave() {
    var _this2 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.yearMonthDay) {
                _context2.next = 3;
                break;
              }

              _this2.$message.error({ message: _this2.$t('COMMON.MSG_EQUIRED_VALIDITY').replaceAll("{1}", _this2.$t('MODULE.I0015_LBL_APPLY_DATE')), showClose: true });
              return _context2.abrupt("return");

            case 3:
              if (!(_this2.yearMonthDay.replaceAll('/', '').substring(0, 6) < _this2.timeDefault().replaceAll('/', ''))) {
                _context2.next = 6;
                break;
              }

              _this2.$message.error({ message: _this2.$t('COMMON.MSG_PASTDATE_SELECT'), showClose: true });
              return _context2.abrupt("return");

            case 6:
              _context2.next = 8;
              return _this2.$confirm(_this2.$t('COMMON.MSG_SAVE'), { //保存しても、よろしいでしょか？
                confirmButtonText: _this2.$t('COMMON.MSG_DELETE_CONFIRM'), //保存
                cancelButtonText: _this2.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
                center: 'true'
              }).then(function () {
                var updateDate = '';
                if (JSON.parse(sessionStorage.getItem('I0016ProcessDiv')) === '2') {
                  updateDate = _this2.updateDate;
                }
                var param = {
                  "processDiv": JSON.parse(sessionStorage.getItem('I0016ProcessDiv')),
                  "jobDate": _this2.yearMonthDay,
                  "updateDate": updateDate
                  //取得当前用户的用户ID
                };var userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
                //调用売上保存API
                i_0015_i_0015_update(param, userCd).then(function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
                    var _msg, _msg2, msg;

                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(res.code == 484)) {
                              _context.next = 6;
                              break;
                            }

                            _msg = _this2.$t('COMMON.' + res.message);

                            _this2.$message.error({ message: _msg, showClose: true });
                            return _context.abrupt("return");

                          case 6:
                            if (!(res.code == 452)) {
                              _context.next = 12;
                              break;
                            }

                            _msg2 = _this2.$t('COMMON.' + res.message);

                            _this2.$message.error({ message: _msg2.replaceAll("{0}", _this2.$t('MODULE.I0015_LBL_TODAY_APPLY')), showClose: true });
                            return _context.abrupt("return");

                          case 12:
                            if (!(res.code == 308)) {
                              _context.next = 16;
                              break;
                            }

                            _context.next = 15;
                            return _this2.$confirm(_this2.$t('COMMON.' + res.message), {
                              confirmButtonText: _this2.$t('MODULE.I0013_BTN_YES'), //はい
                              cancelButtonText: _this2.$t('MODULE.I0013_BTN_NO'), //いいえ
                              center: 'true'
                            }).then(function () {
                              _this2.query();
                            }).catch(function () {
                              // 取消
                            });

                          case 15:
                            return _context.abrupt("return");

                          case 16:
                            msg = _this2.$t('COMMON.' + res.message);

                            _this2.$message.success({ message: msg, showClose: true });
                            _this2.back_click();

                          case 19:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (err) {});
              }).catch(function () {
                // 取消
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), defineProperty_default()(_methods, "queryCancle", function queryCancle() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this3.$confirm(_this3.$t('COMMON.MSG_SAVE'), { //保存しても、よろしいでしょか？
                confirmButtonText: _this3.$t('COMMON.MSG_DELETE_CONFIRM'), //保存
                cancelButtonText: _this3.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
                center: 'true'
              }).then(function () {
                var param = {
                  "processDiv": '3',
                  "jobDate": _this3.yearMonthDay,
                  "updateDate": _this3.updateDate
                  //取得当前用户的用户ID
                };var userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
                //调用売上保存API
                i_0015_i_0015_update(param, userCd).then(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(res) {
                    var _msg3, _msg4, msg;

                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(res.code == 484)) {
                              _context3.next = 6;
                              break;
                            }

                            _msg3 = _this3.$t('COMMON.' + res.message);

                            _this3.$message.error({ message: _msg3, showClose: true });
                            return _context3.abrupt("return");

                          case 6:
                            if (!(res.code == 452)) {
                              _context3.next = 12;
                              break;
                            }

                            _msg4 = _this3.$t('COMMON.' + res.message);

                            _this3.$message.error({ message: _msg4.replaceAll("{0}", _this3.$t('MODULE.I0015_LBL_TODAY_APPLY')), showClose: true });
                            return _context3.abrupt("return");

                          case 12:
                            if (!(res.code == 308)) {
                              _context3.next = 16;
                              break;
                            }

                            _context3.next = 15;
                            return _this3.$confirm(_this3.$t('COMMON.' + res.message), {
                              confirmButtonText: _this3.$t('MODULE.I0013_BTN_YES'), //はい
                              cancelButtonText: _this3.$t('MODULE.I0013_BTN_NO'), //いいえ
                              center: 'true'
                            }).then(function () {
                              _this3.query();
                            }).catch(function () {
                              // 取消
                            });

                          case 15:
                            return _context3.abrupt("return");

                          case 16:
                            msg = _this3.$t('COMMON.' + res.message);

                            _this3.$message.success({ message: msg, showClose: true });
                            _this3.back_click();

                          case 19:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (err) {});
              }).catch(function () {
                // 取消
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  }), _methods),
  // 初期化
  created: function created() {
    this.buttonShowableChange();
    if (JSON.parse(sessionStorage.getItem('I0016ProcessDiv')) === '2') {
      this.query();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-297167b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0016.vue
var i_0016_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_i0016"},[_c('div',{staticClass:"search-module_i0016"}),_vm._v(" "),_c('div',{staticClass:"el-detail_i0016"},[_c('el-row',{staticStyle:{"padding-bottom":"10px"}},[_c('table',{staticClass:"i0016-table table-label"},[_c('tr',[_c('td',{staticClass:"table-header",attrs:{"colspan":"3"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0015_LBL_HOLIDAY_APPLY'))}})]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0016-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0015_LBL_APPLY_DATE'))}}),_vm._v(" "),_c('td',{staticClass:"i0016-form-value"},[_c('el-date-picker',{staticStyle:{"width":"94%","font-size":"12px"},attrs:{"disabled":_vm.dateEditable,"editable":false,"format":"yyyy/MM/dd","value-format":"yyyy/MM/dd","clearable":false,"type":"date"},on:{"blur":function($event){return _vm.dateCheck()}},model:{value:(_vm.yearMonthDay),callback:function ($$v) {_vm.yearMonthDay=$$v},expression:"yearMonthDay"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0016-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0015_LBL_STATE'))}}),_vm._v(" "),_c('td',{staticClass:"i0016-form-value"},[_c('el-input',{staticClass:"i0016-input",attrs:{"disabled":""},model:{value:(_vm.statusName),callback:function ($$v) {_vm.statusName=$$v},expression:"statusName"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0016-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0015_LBL_ADMINISTRATOR'))}}),_vm._v(" "),_c('td',{staticClass:"i0016-form-value"},[_c('el-input',{staticClass:"i0016-input",attrs:{"disabled":""},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0016-form-label",domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.I0016_LBL_REMAND_REASON'))}}),_vm._v(" "),_c('td',{staticClass:"i0016-form-value"},[_c('el-input',{staticClass:"input_textarea_i0016",attrs:{"disabled":"","type":"textarea","maxlength":"500","rows":3},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)])])])],1),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonShowable),expression:"buttonShowable"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.querySave()}}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_APPLY')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonReadonly),expression:"buttonReadonly"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.queryCancle()}}},[_vm._v(_vm._s(_vm.$t('MODULE.I0016_LBL_CANCLE')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))])],1)],1)])])}
var i_0016_staticRenderFns = []
var i_0016_esExports = { render: i_0016_render, staticRenderFns: i_0016_staticRenderFns }
/* harmony default export */ var page_i_0016 = (i_0016_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0016.vue
function i_0016_injectStyle (ssrContext) {
  __webpack_require__("2P/j")
}
var i_0016_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0016___vue_template_functional__ = false
/* styles */
var i_0016___vue_styles__ = i_0016_injectStyle
/* scopeId */
var i_0016___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0016___vue_module_identifier__ = null
var i_0016_Component = i_0016_normalizeComponent(
  i_0016,
  page_i_0016,
  i_0016___vue_template_functional__,
  i_0016___vue_styles__,
  i_0016___vue_scopeId__,
  i_0016___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0016 = (i_0016_Component.exports);

// CONCATENATED MODULE: ./src/module/api/i_0017.js
/*
 * @Description: 
 * @Version: 
 * @Autor: 
 * @Date: 2022-04-19 08:45:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-24 10:59:25
 */



var i_0017_apiUrl = __webpack_require__("kspH");
//お仕事案内一覧検索
var i_0017_i_0017_search = function i_0017_search(month, userCd) {
  return api_public.requestGet(i_0017_apiUrl.apiUrl_jobIntroSearch + '?yearMonth=' + month + '&jobIntroStaffCode=' + userCd);
};
//お仕事選択一覧検索
var i_0017_i_0017_select_search = function i_0017_select_search(jobDate, jobSelectStaffCode) {
  return api_public.requestGet(i_0017_apiUrl.apiUrl_jobSelectSearch + '?jobDate=' + jobDate + '&jobSelectStaffCode=' + jobSelectStaffCode);
};
//お仕事詳細一覧検索
var i_0017_i_0017_detail_search = function i_0017_detail_search(fieldCode, recruitNo) {
  return api_public.requestGet(i_0017_apiUrl.apiUrl_jobDetailSearch + '?fieldCode=' + fieldCode + '&recruitNo=' + recruitNo);
};
//お仕事申請一覧検索
var i_0017_i_0017_apply_search = function i_0017_apply_search(jobApplyStaffCode, yearMonth, fieldCode, recruitNo) {
  return api_public.requestGet(i_0017_apiUrl.apiUrl_jobApplySearch + '?jobApplyStaffCode=' + jobApplyStaffCode + '&yearMonth=' + yearMonth + '&fieldCode=' + fieldCode + '&recruitNo=' + recruitNo);
};
//お仕事申請保存
var i_0017_i_0017_apply_update = function i_0017_apply_update(params) {
  return api_public.requestPost(i_0017_apiUrl.apiUrl_jobApplyUpdate, params);
};
var i_0017_i_0015_update = function i_0015_update(params, userCd) {
  return api_public.requestPost(i_0017_apiUrl.apiUrl_holidaySave + '?userCd=' + userCd, params);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0017.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var i_0017_url = __webpack_require__("kspH");
/* harmony default export */ var i_0017 = ({
  // name: "Map",
  data: function data() {
    return {
      calenderDateList: [], //calender1表示用list
      selectedMonth: '', //当前月（字符串格式）
      selectedDay: '', //当前点击的日期（字符串格式）
      login_officeCd: '', //登陆者所属officecd
      login_userCd: '', //登陆者cd
      icon_request: this.$t('MODULE.I0017_LBL_REQUEST'),
      icon_recruit: this.$t('MODULE.I0017_LBL_RECRUIT'),
      icon_over: this.$t('MODULE.I0017_LBL_OVER'),
      weekStr: [], //一周的文言
      //add
      clickDayInfo: [] //点击一天的详细list
    };
  },
  mounted: function mounted() {
    this.query();
  },

  created: function created() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.login_officeCd = userInfo.officeCd;
    this.login_userCd = userInfo.userCd;
    this.selectedMonth = this.dateFormart(new Date(), 'yyyymm');
  },
  methods: {
    // 検索
    query: function query() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var loading, calendarThead, i, calendarTbody, calendarTbodyChildren, calendarTbodyChildrenChildren, changeChk, secondChk, num, count, date;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this.$loading({
                  lock: true,
                  text: "Loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)"
                });

                setTimeout(function () {
                  loading.close();
                }, 2000);
                // 検索処理
                _context.next = 4;
                return i_0017_i_0017_search(_this.selectedMonth, _this.login_userCd).then(function (res) {
                  //初始化前清空
                  _this.calenderDateList = undefined;
                  _this.calenderDateList = new Array();
                  _this.selectedDay = '';
                  _this.clickDayInfo = undefined;
                  if (res.code === 300) {
                    _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
                    loading.close();
                    return;
                  } else {
                    //更新基本list
                    _this.calenderDateList = JSON.parse(stringify_default()(res.items.jobIntroInfoList));
                  }
                  loading.close();
                });

              case 4:
                //カレンダーのセルセット
                calendarThead = document.querySelector(".i0017Class .el-calendar-table thead");

                calendarThead.childNodes[0].style.color = "red";
                calendarThead.childNodes[6].style.color = "blue";
                _this.weekStr[0] = _this.$t('MODULE.S0001_LBL_CALENDAR_SUN');
                _this.weekStr[1] = _this.$t('MODULE.S0001_LBL_CALENDAR_MON');
                _this.weekStr[2] = _this.$t('MODULE.S0001_LBL_CALENDAR_TUE');
                _this.weekStr[3] = _this.$t('MODULE.S0001_LBL_CALENDAR_WED');
                _this.weekStr[4] = _this.$t('MODULE.S0001_LBL_CALENDAR_THU');
                _this.weekStr[5] = _this.$t('MODULE.S0001_LBL_CALENDAR_FRI');
                _this.weekStr[6] = _this.$t('MODULE.S0001_LBL_CALENDAR_SAT');
                for (i = 0; i < 7; i++) {
                  calendarThead.childNodes[i].innerHTML = _this.weekStr[i];
                }
                calendarTbody = document.querySelector(".i0017Class .el-calendar-table tbody");
                calendarTbodyChildren = calendarTbody.children;
                changeChk = false;
                secondChk = false;
                num = 0;

                for (i = 0; i < calendarTbodyChildren.length; i++) {
                  calendarTbodyChildrenChildren = calendarTbody.children[i].cells;
                  for (count = 0; count < calendarTbodyChildrenChildren.length; count++) {
                    num++;
                    date = calendarTbodyChildrenChildren[count].innerText[0] + calendarTbodyChildrenChildren[count].innerText[1];

                    if (date == _this.calenderDateList[0].date.substring(8, 10)) {
                      changeChk = true;
                    }
                    if (changeChk && !secondChk) {
                      _this.calenderDateList.forEach(function (item) {
                        if (date == item.date.substring(8, 10)) {
                          if (item.applyStatus == '1') {
                            calendarTbodyChildrenChildren[count].style.background = "#DFEDF2";
                          } else if (item.applyStatus == '2') {
                            calendarTbodyChildrenChildren[count].style.background = "#F7FBFC";
                          } else if (item.applyStatus == '3' || item.applyStatus == '4') {
                            calendarTbodyChildrenChildren[count].style.background = "#DCDCDC";
                          }
                        }
                      });
                    } else {
                      calendarTbodyChildrenChildren[count].style.background = "#FFFFFF";
                    }
                    if (num > _this.calenderDateList.length && date == _this.calenderDateList[_this.calenderDateList.length - 1].date.substring(8, 10)) {
                      changeChk = false;
                      secondChk = true;
                    }
                  }
                }

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    //日期转为字符串formartType='yyyymm'或'yyyymmdd'，
    dateFormart: function dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? '0' + M : M) + '-' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? '0' + M : M) + '/' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? '0' + M : M);
    },

    //前月翌月今日综合处理
    monthChange: function monthChange(val) {
      var _this2 = this;

      var getEl = this.$refs.elCalendar.$children[0].$children[val];
      //触发调转事件
      getEl.$el.click();
      this.$nextTick(function () {
        var calendarTitle = document.querySelector(".i0017Class .el-calendar__header .el-calendar__title");
        var monthStr = calendarTitle.innerHTML;
        if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
          _this2.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16);
        } else {
          _this2.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15);
        }
        //刷新数据
        _this2.query();
        if (document.querySelector(".is-selected") !== null) {
          document.querySelector(".is-selected").classList.remove('is-selected');
        }
      });
    },

    //前月
    preMonthClick: function preMonthClick() {
      this.monthChange(0);
    },

    //今日
    todayClick: function todayClick() {
      this.monthChange(1);
    },

    //翌月
    nextMonthClick: function nextMonthClick() {
      this.monthChange(2);
    },

    //日期单元格点击事件。  参数空的场合，直接使用this.selectedDay
    dateCellClick: function dateCellClick(date) {
      var _this3 = this;

      var in_dateDay = date.day;
      var statusChk = '';
      if (in_dateDay !== '') {
        this.selectedDay = in_dateDay.replace(/-/g, '/');
      }
      this.calenderDateList.forEach(function (item) {
        if (item.date == _this3.selectedDay) {
          statusChk = item.applyStatus;
        }
      });
      if (statusChk == '3' || statusChk == '4') {
        return;
      }
      this.$router.push({ path: i_0017_url.routerUrl_I0018, query: { jobDate: this.selectedDay } });
    },

    //单元格内容表示
    calendarCellcharacters: function calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/');
      var ret = '';
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(function (item) {
        return item.date === thisDay;
      });
      if (Index !== -1) {
        var applyStatus = this.calenderDateList[Index].applyStatus;
        if (applyStatus === '1') {
          ret = this.icon_request;
        } else if (applyStatus === '2') {
          ret = this.icon_recruit;
        } else if (applyStatus === '3') {
          ret = this.icon_over;
        } else if (applyStatus === '4') {
          ret = '';
        }
      } else {
        ret = '';
      }
      return ret;
    },

    //cal2的cell样式
    HeaderClass: function HeaderClass(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return 'HeaderClass';
    },

    //cal2的head样式
    IsCellClass: function IsCellClass(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      return 'IsCellClass';
    }
  },
  computed: {
    //selectedMonth->selectedMonthStr yyyymm->yyyy年mm月
    selectedMonthStr: function selectedMonthStr() {
      return this.selectedMonth.substring(0, 4) + '年' + this.selectedMonth.substring(4, 7) + '月';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76c0c3a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0017.vue
var i_0017_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i0017Class",staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-row',{attrs:{"type":"flex","align":"bottom"}},[_c('el-col',{attrs:{"span":9,"align":"middle"}},[_c('span',[_vm._v(_vm._s(_vm.selectedMonthStr))])]),_vm._v(" "),_c('el-col',{staticStyle:{"font-size":"0"},attrs:{"span":14,"align":"right"}},[_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.preMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_PREMONTH')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.todayClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TODAY')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.nextMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_NEXTMONTH')))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"calenderMode1-calendar",staticStyle:{"text-align":"center","margin-top":"8px"}},[_c('div',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('el-calendar',{ref:"elCalendar",attrs:{"firstDayOfWeek":7},scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',{staticClass:"el-calendar-day",attrs:{"slot":"reference"},on:{"click":function($event){return _vm.dateCellClick(data)}},slot:"reference"},[_c('div',{domProps:{"innerHTML":_vm._s(data.day.split('-')[2])}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.calendarCellcharacters(data))}})])]}}])})],1)])],1)}
var i_0017_staticRenderFns = []
var i_0017_esExports = { render: i_0017_render, staticRenderFns: i_0017_staticRenderFns }
/* harmony default export */ var page_i_0017 = (i_0017_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0017.vue
function i_0017_injectStyle (ssrContext) {
  __webpack_require__("zQWP")
}
var i_0017_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0017___vue_template_functional__ = false
/* styles */
var i_0017___vue_styles__ = i_0017_injectStyle
/* scopeId */
var i_0017___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0017___vue_module_identifier__ = null
var i_0017_Component = i_0017_normalizeComponent(
  i_0017,
  page_i_0017,
  i_0017___vue_template_functional__,
  i_0017___vue_styles__,
  i_0017___vue_scopeId__,
  i_0017___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0017 = (i_0017_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0018.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var i_0018_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var i_0018 = ({
  data: function data() {
    return {
      jobDateTitle: '',
      login_userCd: '', //登陆者cd
      list: []
    };
  },
  created: function created() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.login_userCd = userInfo.userCd;
    var date = '';
    date = this.$route.query.jobDate;
    if (date) {
      this.jobDateTitle = date.split('/')[0] + this.$t('MODULE.P0002_LBL_MONTH') + date.split('/')[1] + this.$t('MODULE.P0002_LBL_YEAR') + date.split('/')[2] + this.$t('MODULE.S0001_LBL_CALENDAR_SUN');
    }
    // 期間より検索
    this.query();
  },

  methods: {
    back: function back() {
      this.$router.push({ path: i_0018_url.routerUrl_I0017 });
    },

    // 検索
    query: function query() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var loading;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this.$loading({
                  lock: true,
                  text: "Loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)"
                });

                setTimeout(function () {
                  loading.close();
                }, 2000);
                // 検索処理
                _context.next = 4;
                return i_0017_i_0017_select_search(_this.$route.query.jobDate, _this.login_userCd).then(function (res) {
                  if (res.code === 300) {
                    _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
                    loading.close();
                    return;
                  } else {
                    //更新基本list
                    _this.list = res.items.jobSelectInfoList;
                  }
                  loading.close();
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // TABLEHeader样式
    i0018HeaderStyle: function i0018HeaderStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; ';
    },

    // TABLE单元格样式
    i0018IsCellStyle: function i0018IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (row.applyStatus == '1') {
        return 'text-align:center;fontSize:10pt;background-color:#DFEDF2;';
      } else if (row.applyStatus == '2') {
        return 'text-align:center;fontSize:10pt;background-color:#DCDCDC;';
      } else {
        return 'text-align:center;fontSize:10pt;';
      }
    },

    // 单击行事件
    i0018RowOnClick: function i0018RowOnClick(thisRowDate, column, cell, event) {
      if (thisRowDate.applyStatus == '2') {
        return;
      }
      var recruitNo = thisRowDate.recruitNo;
      var fieldCd = thisRowDate.fieldCD;
      var jobDate = this.$route.query.jobDate;
      var editShow = false;
      this.list.forEach(function (item) {
        if (item.fieldCD != thisRowDate.fieldCD) {
          if (item.applyStatus == '1') {
            editShow = true;
          }
        }
      });
      //计划的场合，点击无效
      this.$router.push({ path: i_0018_url.routerUrl_I0019, query: { recruitNo: recruitNo, fieldCd: fieldCd, jobDate: jobDate, editShow: editShow } });
    },
    i0018HeaderClass: function i0018HeaderClass(_ref3) {
      var row = _ref3.row,
          rowIndex = _ref3.rowIndex;

      return 'i0018HeaderClass';
    },
    i0018IsCellClass: function i0018IsCellClass(_ref4) {
      var row = _ref4.row,
          rowIndex = _ref4.rowIndex;

      return 'i0018IsCellClass';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1be081ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0018.vue
var i_0018_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"search-module-i0018"},[_c('el-row',{staticStyle:{"padding-top":"11px","padding-left":"5px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":9,"align":"middle"}},[_c('span',[_vm._v(_vm._s(_vm.jobDateTitle))])])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA","width":"100%"},attrs:{"header-cell-style":_vm.i0018HeaderStyle,"cell-style":_vm.i0018IsCellStyle,"header-row-class-name":_vm.i0018HeaderClass,"cell-class-name":_vm.i0018IsCellClass,"data":_vm.list,"border":"","size":"mini"},on:{"row-click":_vm.i0018RowOnClick}},[_c('el-table-column',{attrs:{"prop":"col1","label":_vm.$t('MODULE.I0017_LBL_START_AND_END'),"width":"130px;","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.startTime)),_c('br'),_vm._v(_vm._s(scope.row.endTime)+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col2","label":_vm.$t('MODULE.I0017_LBL_COL2'),"min-width":"180px;","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.companyName)),_c('br'),_vm._v(_vm._s(scope.row.storeName)+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"col3","label":_vm.$t('MODULE.I0017_LBL_COL3'),"min-width":"160px;","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.jobContent)+"\n      ")]}}])})],1),_vm._v(" "),_c('el-row',{staticStyle:{"text-align":"center","padding-top":"10px"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"width":"114px","height":"34px","padding-top":"10px"},attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_CANCEL')))])],1)],1)}
var i_0018_staticRenderFns = []
var i_0018_esExports = { render: i_0018_render, staticRenderFns: i_0018_staticRenderFns }
/* harmony default export */ var page_i_0018 = (i_0018_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0018.vue
function i_0018_injectStyle (ssrContext) {
  __webpack_require__("FJkM")
}
var i_0018_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0018___vue_template_functional__ = false
/* styles */
var i_0018___vue_styles__ = i_0018_injectStyle
/* scopeId */
var i_0018___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0018___vue_module_identifier__ = null
var i_0018_Component = i_0018_normalizeComponent(
  i_0018,
  page_i_0018,
  i_0018___vue_template_functional__,
  i_0018___vue_styles__,
  i_0018___vue_scopeId__,
  i_0018___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0018 = (i_0018_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0019.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var i_0019_url = __webpack_require__("kspH");
/* harmony default export */ var i_0019 = ({
  mixins: [css],
  data: function data() {
    return {
      detailInfo: []
    };
  },
  created: function created() {
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    //検索
    this.query();
  },

  methods: {
    // 検索
    query: function query() {
      var _this = this;

      // loading处理
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 検索処理
      i_0017_i_0017_detail_search(this.$route.query.fieldCd, this.$route.query.recruitNo).then(function (res) {
        if (res.code === 300) {
          _this.loading.close();
          return;
        } else if (res.code === 204) {
          _this.detailInfo = res.items.jobDetailInfoList[0];
        }
        _this.loading.close();
      }).catch(function () {
        _this.loading.close();
      });
    },

    // キャンセル
    ret_click: function ret_click() {
      this.$router.push({ path: i_0019_url.routerUrl_I0018, query: { jobDate: this.$route.query.jobDate } });
    },
    job_apply: function job_apply() {
      if (this.$route.query.editShow) {
        this.$message.warning({ message: this.$t('COMMON.MSG_JOB_ALREADY_APPLY'), showClose: true });
        return;
      }
      this.$router.push({ path: i_0019_url.routerUrl_I0020, query: { editShow: this.$route.query.editShow, jobDate: this.$route.query.jobDate, recruitNo: this.$route.query.recruitNo, fieldCd: this.$route.query.fieldCd } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aff3016","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0019.vue
var i_0019_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"5px"}},[_c('el-row',{staticStyle:{"background-color":"#3cc6fa"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.$t('MODULE.I0019_LBL_DETAIL_TITLE')))])]),_vm._v(" "),_c('table',{staticClass:"i0019-table table-label"},[_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL1')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.$route.query.jobDate))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL2')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.storeName))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0019_LBL_WORK_AREA')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.workPlace))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL4')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.jobContent))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0019_LBL_WORK_DATE')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.startDate)+"～"+_vm._s(this.detailInfo.endDate))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL5')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.startTime))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL6')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.endTime))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL8')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.workTime))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL7')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.breakTime))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL9')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.restTime))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0019_LBL_TRAFFIC_COST')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.transportExpenses))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL12')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.gatherPlace))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL13')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.gatherTime))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0019-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL15')))]),_vm._v(" "),_c('td',{staticClass:"i0019-form-value"},[_vm._v(_vm._s(this.detailInfo.note))])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","width":"120px"},on:{"click":function($event){return _vm.job_apply()}}},[_vm._v(_vm._s(_vm.$t('MODULE.K0011_LBL_MSG7')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","width":"120px"},on:{"click":function($event){return _vm.ret_click()}}},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_BTN2')))])],1)],1)])}
var i_0019_staticRenderFns = []
var i_0019_esExports = { render: i_0019_render, staticRenderFns: i_0019_staticRenderFns }
/* harmony default export */ var page_i_0019 = (i_0019_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0019.vue
function i_0019_injectStyle (ssrContext) {
  __webpack_require__("QOO/")
}
var i_0019_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0019___vue_template_functional__ = false
/* styles */
var i_0019___vue_styles__ = i_0019_injectStyle
/* scopeId */
var i_0019___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0019___vue_module_identifier__ = null
var i_0019_Component = i_0019_normalizeComponent(
  i_0019,
  page_i_0019,
  i_0019___vue_template_functional__,
  i_0019___vue_styles__,
  i_0019___vue_scopeId__,
  i_0019___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0019 = (i_0019_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/i_0020.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var i_0020_url = __webpack_require__("kspH");
/* harmony default export */ var i_0020 = ({
  data: function data() {
    return {
      calenderDateList: [], //calender1表示用list
      selectedMonth: '', //当前月（字符串格式）
      selectedDay: '', //当前点击的日期（字符串格式）
      login_userCd: '', //登陆者cd
      icon_maru: '〇',
      icon_corss: '✖',
      weekStr: [], //一周的文言
      detailDate: '',
      detailDateChk: '',
      workDateStart: '',
      workDateEnd: '',
      note: '',
      showDetail: false,
      editChk: true,
      noteChk: true,
      longPress: false,
      touchmoveFlag: false,
      isEditMode: false,
      changedCheck: false,
      showMonth: new Date(this.$route.query.jobDate)
    };
  },
  mounted: function mounted() {
    this.query();
  },

  created: function created() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.login_userCd = userInfo.userCd;
    this.selectedMonth = this.$route.query.jobDate;
  },
  methods: {
    // キャンセル
    ret_click: function ret_click() {
      this.$router.push({ path: i_0020_url.routerUrl_I0019, query: { recruitNo: this.$route.query.recruitNo, fieldCd: this.$route.query.fieldCd, jobDate: this.$route.query.jobDate, editShow: this.$route.query.editShow } });
    },

    // 検索
    query: function query() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var loading, yearMonth, calendarThead, i, calendarTbody, calendarTbodyChildren, calendarTbodyChildrenChildren, changeChk, secondChk, num, count, date;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this.$loading({
                  lock: true,
                  text: "Loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)"
                });

                setTimeout(function () {
                  loading.close();
                }, 2000);
                yearMonth = _this.selectedMonth.replaceAll('/', '').substring(0, 4) + '/' + _this.selectedMonth.replaceAll('/', '').substring(4, 6);
                // 検索処理

                _context.next = 5;
                return i_0017_i_0017_apply_search(_this.login_userCd, yearMonth, _this.$route.query.fieldCd, _this.$route.query.recruitNo).then(function (res) {
                  //初始化前清空
                  _this.calenderDateList = undefined;
                  _this.calenderDateList = new Array();
                  _this.selectedDay = '';
                  _this.isEditMode = false;
                  _this.showDetail = false;
                  _this.changedCheck = false;
                  _this.editChk = true;
                  _this.noteChk = true;
                  if (res.code === 300) {
                    loading.close();
                    return;
                  } else {
                    //更新基本list
                    _this.calenderDateList = JSON.parse(stringify_default()(res.items.jobApplyInfoList));
                    _this.calenderDateList.forEach(function (item) {
                      item.changeData = false;
                    });
                  }
                  loading.close();
                });

              case 5:
                //カレンダーのセルセット
                calendarThead = document.querySelector(".i0020Class .el-calendar-table thead");

                calendarThead.childNodes[0].style.color = "red";
                calendarThead.childNodes[6].style.color = "blue";
                _this.weekStr[0] = _this.$t('MODULE.S0001_LBL_CALENDAR_SUN');
                _this.weekStr[1] = _this.$t('MODULE.S0001_LBL_CALENDAR_MON');
                _this.weekStr[2] = _this.$t('MODULE.S0001_LBL_CALENDAR_TUE');
                _this.weekStr[3] = _this.$t('MODULE.S0001_LBL_CALENDAR_WED');
                _this.weekStr[4] = _this.$t('MODULE.S0001_LBL_CALENDAR_THU');
                _this.weekStr[5] = _this.$t('MODULE.S0001_LBL_CALENDAR_FRI');
                _this.weekStr[6] = _this.$t('MODULE.S0001_LBL_CALENDAR_SAT');
                for (i = 0; i < 7; i++) {
                  calendarThead.childNodes[i].innerHTML = _this.weekStr[i];
                }
                calendarTbody = document.querySelector(".i0020Class .el-calendar-table tbody");
                calendarTbodyChildren = calendarTbody.children;
                changeChk = false;
                secondChk = false;
                num = 0;

                for (i = 0; i < calendarTbodyChildren.length; i++) {
                  calendarTbodyChildrenChildren = calendarTbody.children[i].cells;
                  for (count = 0; count < calendarTbodyChildrenChildren.length; count++) {
                    num++;
                    date = calendarTbodyChildrenChildren[count].innerText[0] + calendarTbodyChildrenChildren[count].innerText[1];

                    if (date == _this.calenderDateList[0].jobDate.substring(8, 10)) {
                      changeChk = true;
                    }
                    if (changeChk && !secondChk) {
                      _this.calenderDateList.forEach(function (item) {
                        if (item.jobDate) {
                          if (date == item.jobDate.substring(8, 10)) {
                            if (item.applyStatus == '3') {
                              calendarTbodyChildrenChildren[count].style.background = "#DFEDF2";
                            } else if (item.applyStatus == '1' || item.applyStatus == '0') {
                              calendarTbodyChildrenChildren[count].style.background = "#F7FBFC";
                            } else if (item.applyStatus == '2') {
                              calendarTbodyChildrenChildren[count].style.background = "#DCDCDC";
                            }
                          }
                        } else {
                          if (item.applyStatus == '1' || item.applyStatus == '0') {
                            calendarTbodyChildrenChildren[count].style.background = "#F7FBFC";
                          } else if (item.applyStatus == '2') {
                            calendarTbodyChildrenChildren[count].style.background = "#DCDCDC";
                          }
                        }
                      });
                    } else {
                      calendarTbodyChildrenChildren[count].style.background = "#FFFFFF";
                    }
                    if (num > _this.calenderDateList.length && date == _this.calenderDateList[_this.calenderDateList.length - 1].jobDate.substring(8, 10)) {
                      changeChk = false;
                      secondChk = true;
                    }
                  }
                }

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    //日期转为字符串formartType='yyyymm'或'yyyymmdd'，
    dateFormart: function dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? '0' + M : M) + '-' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? '0' + M : M) + '/' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? '0' + M : M);
    },

    //前月翌月今日综合处理
    monthChange: function monthChange(val) {
      var _this2 = this;

      var getEl = this.$refs.elCalendar.$children[0].$children[val];
      //触发调转事件
      getEl.$el.click();
      this.$nextTick(function () {
        var calendarTitle = document.querySelector(".i0020Class .el-calendar__header .el-calendar__title");
        var monthStr = calendarTitle.innerHTML;
        if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
          _this2.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16);
        } else {
          _this2.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15);
        }
        //刷新数据
        _this2.query();
        if (document.querySelector(".is-selected") !== null) {
          document.querySelector(".is-selected").classList.remove('is-selected');
        }
      });
    },

    //前月
    preMonthClick: function preMonthClick() {
      var _this3 = this;

      if (this.changedCheck) {
        this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(function () {
          _this3.isEditMode = false;
          _this3.showDetail = false;
          _this3.changedCheck = false;
          _this3.editChk = true;
          _this3.noteChk = true;
          _this3.monthChange(0);
        }).catch(function () {
          // いいえ
        });
      } else {
        this.isEditMode = false;
        this.showDetail = false;
        this.changedCheck = false;
        this.editChk = true;
        this.noteChk = true;
        this.monthChange(0);
      }
    },

    //今日
    todayClick: function todayClick() {
      var _this4 = this;

      if (this.changedCheck) {
        this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(function () {
          _this4.isEditMode = false;
          _this4.showDetail = false;
          _this4.changedCheck = false;
          _this4.editChk = true;
          _this4.noteChk = true;
          _this4.monthChange(1);
        }).catch(function () {
          // いいえ
        });
      } else {
        this.isEditMode = false;
        this.showDetail = false;
        this.changedCheck = false;
        this.editChk = true;
        this.noteChk = true;
        this.monthChange(1);
      }
    },

    //翌月
    nextMonthClick: function nextMonthClick() {
      var _this5 = this;

      if (this.changedCheck) {
        this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(function () {
          _this5.isEditMode = false;
          _this5.showDetail = false;
          _this5.changedCheck = false;
          _this5.editChk = true;
          _this5.noteChk = true;
          _this5.monthChange(2);
        }).catch(function () {
          // いいえ
        });
      } else {
        this.isEditMode = false;
        this.showDetail = false;
        this.changedCheck = false;
        this.editChk = true;
        this.noteChk = true;
        this.monthChange(2);
      }
    },
    save_btn: function save_btn() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var params, dateList, thisMonth, i, o;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = [];

                _this6.calenderDateList.forEach(function (item) {
                  if (item.changeData) {
                    var startTime = item.applyStatus == '1' ? item.startTime : '';
                    var endTime = item.applyStatus == '1' ? item.endTime : '';
                    var param = {
                      "fieldCD": _this6.$route.query.fieldCd,
                      "recruitNo": _this6.$route.query.recruitNo,
                      "jobApplyStaffCode": _this6.login_userCd,
                      "jobDate": item.jobDate,
                      "applyStatus": item.applyStatus,
                      "startWorkTime": startTime,
                      "endWorkTime": endTime,
                      "note": item.note,
                      "updateDate": item.updateDate.replaceAll('-', '/')
                    };
                    params.push(param);
                  }
                });

                if (!(params.length == 0)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                dateList = [];
                thisMonth = _this6.selectedMonth.replaceAll('/', '').substring(0, 6);
                // 検索処理

                _context2.next = 8;
                return i_0017_i_0017_search(thisMonth, _this6.login_userCd).then(function (res) {
                  //更新基本list
                  dateList = JSON.parse(stringify_default()(res.items.jobIntroInfoList));
                });

              case 8:
                i = 0;

              case 9:
                if (!(i < params.length)) {
                  _context2.next = 36;
                  break;
                }

                if (!(params[i].startWorkTime && !params[i].endWorkTime)) {
                  _context2.next = 15;
                  break;
                }

                _this6.$message.error({ message: _this6.$t('COMMON.MSG_SHIFT_APPLY_END_TIME_VALIDITY'), showClose: true });
                return _context2.abrupt('return');

              case 15:
                if (!(!params[i].startWorkTime && params[i].endWorkTime)) {
                  _context2.next = 20;
                  break;
                }

                _this6.$message.error({ message: _this6.$t('COMMON.MSG_SHIFT_APPLY_START_TIME_VALIDITY'), showClose: true });
                return _context2.abrupt('return');

              case 20:
                if (!(params[i].startWorkTime && params[i].endWorkTime)) {
                  _context2.next = 24;
                  break;
                }

                if (!(params[i].startWorkTime.replace(':', '') >= params[i].endWorkTime.replace(':', ''))) {
                  _context2.next = 24;
                  break;
                }

                _this6.$message.error({ message: _this6.$t('COMMON.MSG_SHIFT_APPLY_PERIOD_VALIDITY'), showClose: true });
                return _context2.abrupt('return');

              case 24:
                o = 0;

              case 25:
                if (!(o < dateList.length)) {
                  _context2.next = 33;
                  break;
                }

                if (!(dateList[o].fieldCode && params[i].jobDate == dateList[o].date)) {
                  _context2.next = 30;
                  break;
                }

                if (!(_this6.$route.query.fieldCd != dateList[o].fieldCode)) {
                  _context2.next = 30;
                  break;
                }

                _this6.$message.error({ message: _this6.$t('COMMON.MSG_JOB_DATE_ALREADY_APPLY').replaceAll("{1}", params[i].jobDate), showClose: true });
                return _context2.abrupt('return');

              case 30:
                o++;
                _context2.next = 25;
                break;

              case 33:
                i++;
                _context2.next = 9;
                break;

              case 36:
                // 保存处理
                _this6.$confirm(_this6.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか。
                  confirmButtonText: _this6.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                  cancelButtonText: _this6.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
                  center: true
                }).then(function () {
                  // 更新処理
                  i_0017_i_0017_apply_update(params).then(function (res) {
                    if (res.code === 202) {
                      //更新成功
                      _this6.$message.success({ message: _this6.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
                      _this6.updateList = undefined;
                      _this6.updateList = new Array();
                      _this6.isEditMode = false;
                      _this6.firstEditClickFlg = true;
                      _this6.passedDateFlg = false;
                      _this6.query();
                    } else if (res.code === 308) {
                      //shift lock error
                      setTimeout(function () {
                        _this6.$confirm(_this6.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                          confirmButtonText: _this6.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
                          cancelButtonText: _this6.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                          center: true
                        }).then(function () {
                          _this6.query();
                        }).catch(function () {});
                      }, 500);
                    } else if (res.code === 311) {
                      _this6.$message.error({ message: _this6.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
                    }
                  });
                }).catch(function () {
                  // いいえ
                });

              case 37:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },

    //日期单元格点击事件。  参数空的场合，直接使用this.selectedDay
    dateCellClick: function dateCellClick(date) {
      var selectedCellDay;
      if (date !== '') {
        selectedCellDay = date.day.replace(/-/g, '/');
        this.showMonth = new Date(selectedCellDay);
      } else {
        return;
      }
      var thisDay = date.day.replace(/-/g, '/');
      //从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(function (item) {
        return item.jobDate === thisDay;
      });
      if (Index !== -1) {
        var applyStatus = this.calenderDateList[Index].applyStatus;
        if (applyStatus === '1') {
          if (this.isEditMode) {
            this.editChk = false;
            this.noteChk = false;
          }
          this.workDateStart = this.calenderDateList[Index].startTime;
          this.workDateEnd = this.calenderDateList[Index].endTime;
          this.note = this.calenderDateList[Index].note;
        } else if (applyStatus === '0') {
          if (this.isEditMode) {
            this.editChk = true;
            this.noteChk = false;
          }
          this.workDateStart = '';
          this.workDateEnd = '';
          this.note = this.calenderDateList[Index].note;
        } else if (applyStatus === '2') {
          if (this.isEditMode) {
            this.editChk = true;
            this.noteChk = true;
          }
          this.workDateStart = '';
          this.workDateEnd = '';
          this.note = '';
        } else if (applyStatus === '3') {
          if (this.isEditMode) {
            this.editChk = true;
            this.noteChk = true;
          }
          this.workDateStart = this.calenderDateList[Index].startTime;
          this.workDateEnd = this.calenderDateList[Index].endTime;
          this.note = this.calenderDateList[Index].note;
        }
      } else {
        if (this.isEditMode) {
          this.editChk = true;
          this.noteChk = true;
        }
        this.workDateStart = '';
        this.workDateEnd = '';
        this.note = '';
      }
    },

    //单元格内容表示
    calendarCellcharacters: function calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/');
      var ret = '';
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(function (item) {
        return item.jobDate === thisDay;
      });
      if (Index !== -1) {
        var applyStatus = this.calenderDateList[Index].applyStatus;
        if (applyStatus === '1' || applyStatus === '3') {
          ret = this.icon_maru;
        } else if (applyStatus === '0') {
          ret = this.icon_corss;
        } else {
          ret = '';
        }
      } else {
        ret = '';
      }
      return ret;
    },

    //タッチstart
    touchStart: function touchStart(in_date) {
      var _this7 = this;

      this.showDetail = true;
      var date = new Date(in_date.day);
      var weekDay = this.weekStr[date.getDay()];
      this.detailDate = this.dateFormart(date, 'yyyy/mm/dd') + '(' + weekDay + ')';
      this.longPress = false;
      clearTimeout(this.loop); //再次清空定时器，防止重复注册定时器
      this.loop = setTimeout(function () {
        _this7.longPress = true;
      }, 500);
    },

    //タッチend
    touchEnd: function touchEnd(in_date) {
      clearTimeout(this.loop); //清空定时器，防止重复注册定时器
      if (this.touchmoveFlag == false) {
        if (this.longPress) {
          this.isEditMode = true;
        }
        this.longPress = false;
        if (this.isEditMode) {
          this.dateCellClick(in_date);
          if (this.detailDate != this.detailDateChk) {
            this.detailDateChk = this.detailDate;
            return;
          } else {
            this.statusChange(in_date);
          }
        }
      }
      this.touchmoveFlag = false;
    },

    //タッチmove
    touchMove: function touchMove() {
      this.touchmoveFlag = true;
    },
    statusChange: function statusChange(date) {
      if (!this.isEditMode) {
        return;
      }
      if (this.detailDate != this.detailDateChk) {
        return;
      }
      var thisDay = date.day.replace(/-/g, '/');
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(function (item) {
        return item.jobDate === thisDay;
      });
      if (Index !== -1) {
        this.changedCheck = true;
        var applyStatus = this.calenderDateList[Index].applyStatus;
        if (applyStatus === '1') {
          this.calenderDateList[Index].startTime = '';
          this.calenderDateList[Index].endTime = '';
          this.calenderDateList[Index].applyStatus = '0';
          this.calenderDateList[Index].changeData = true;
          this.workDateStart = '';
          this.workDateEnd = '';
          this.editChk = true;
          this.noteChk = false;
        } else if (applyStatus === '0') {
          this.calenderDateList[Index].applyStatus = '1';
          this.calenderDateList[Index].changeData = true;
          this.editChk = false;
          this.noteChk = false;
        }
      }
    },

    //calendar2时间入力失去焦点事件
    cal2_inputBlur: function cal2_inputBlur() {
      if (this.isEditMode == false) return;
      var thisDay = this.detailDate.substring(0, 10).replace(/-/g, '/');
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(function (item) {
        return item.jobDate === thisDay;
      });
      if (Index !== -1) {
        this.calenderDateList[Index].startTime = this.workDateStart;
        this.calenderDateList[Index].endTime = this.workDateEnd;
        this.calenderDateList[Index].note = this.note;
        this.calenderDateList[Index].changeData = true;
      }
    },

    //calendar1时间入力失去焦点事件
    cal1_inputBlur: function cal1_inputBlur(val) {
      if (this.isEditMode == false) return;
      this.changedCheck = true;
      var retValue = '';
      if (val) {
        retValue = utils.timeFormatter(val);
      } else {
        retValue = '';
      }
      return retValue;
    },

    // 时间入力check
    timeInputCheck: function timeInputCheck(val) {
      if (!val) {
        return;
      }
      var reg = /^\d*(\:?\d{0,2})/g;
      var matchResult = val.match(reg);
      if (matchResult === null) {
        return null;
      } else {
        return matchResult[0];
      }
    },

    //cal2的cell样式
    HeaderClass: function HeaderClass(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return 'HeaderClass';
    },

    //cal2的head样式
    IsCellClass: function IsCellClass(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      return 'IsCellClass';
    }
  },
  computed: {
    selectedMonthStr: function selectedMonthStr() {
      return this.selectedMonth.replaceAll('/', '').substring(0, 4) + '年' + this.selectedMonth.replaceAll('/', '').substring(4, 6) + '月';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6383e7b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/i_0020.vue
var i_0020_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i0020Class",staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-row',{attrs:{"type":"flex","align":"bottom"}},[_c('el-col',{attrs:{"span":9,"align":"middle"}},[_c('span',[_vm._v(_vm._s(_vm.selectedMonthStr))])]),_vm._v(" "),_c('el-col',{staticStyle:{"font-size":"0"},attrs:{"span":14,"align":"right"}},[_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.preMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_PREMONTH')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.todayClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TODAY')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.nextMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_NEXTMONTH')))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"calenderMode1-calendar",staticStyle:{"text-align":"center","margin-top":"2px"}},[_c('div',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('el-calendar',{ref:"elCalendar",attrs:{"firstDayOfWeek":7},scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',{staticClass:"el-calendar-day",attrs:{"slot":"reference"},on:{"touchstart":function($event){return _vm.touchStart(data)},"touchend":function($event){return _vm.touchEnd(data)}},slot:"reference"},[_c('div',{domProps:{"innerHTML":_vm._s(data.day.split('-')[2])},on:{"click":function($event){return _vm.dateCellClick(data)}}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.calendarCellcharacters(data))}})])]}}]),model:{value:(_vm.showMonth),callback:function ($$v) {_vm.showMonth=$$v},expression:"showMonth"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDetail),expression:"showDetail"}],staticStyle:{"margin-top":"5px"}},[_c('el-row',{staticStyle:{"background-color":"#3cc6fa"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.detailDate))])]),_vm._v(" "),_c('table',{staticClass:"i0020-table table-label"},[_c('tr',[_c('td',{staticClass:"i0020-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0020_LBL_WORK_TIME')))]),_vm._v(" "),_c('td',{staticClass:"i0020-form-value"},[_c('el-input',{staticClass:"css-dialog-input-width",staticStyle:{"width":"44%"},attrs:{"disabled":_vm.editChk,"size":"mini","clearable":""},on:{"change":function($event){_vm.workDateStart = _vm.cal1_inputBlur(_vm.workDateStart),_vm.cal2_inputBlur()}},nativeOn:{"input":function($event){_vm.workDateStart = _vm.timeInputCheck(_vm.workDateStart)}},model:{value:(_vm.workDateStart),callback:function ($$v) {_vm.workDateStart=$$v},expression:"workDateStart"}}),_vm._v("\n          ～"),_c('el-input',{staticClass:"css-dialog-input-width",staticStyle:{"width":"44%","margin-left":"4px"},attrs:{"disabled":_vm.editChk,"size":"mini","clearable":""},on:{"change":function($event){_vm.workDateEnd = _vm.cal1_inputBlur(_vm.workDateEnd),_vm.cal2_inputBlur()}},nativeOn:{"input":function($event){_vm.workDateEnd = _vm.timeInputCheck(_vm.workDateEnd)}},model:{value:(_vm.workDateEnd),callback:function ($$v) {_vm.workDateEnd=$$v},expression:"workDateEnd"}})],1)]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"i0020-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_COL15')))]),_vm._v(" "),_c('td',{staticClass:"i0020-form-value"},[_c('el-input',{staticClass:"input_textarea_i0020",attrs:{"disabled":_vm.noteChk,"type":"textarea","maxlength":"500","rows":3},on:{"change":function($event){_vm.changedCheck = true},"blur":function($event){return _vm.cal2_inputBlur()}},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)])])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEditMode),expression:"isEditMode"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","width":"120px"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.save_btn()}}},[_vm._v(_vm._s(_vm.$t('MODULE.K0011_LBL_MSG7')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","width":"120px"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.ret_click()}}},[_vm._v(_vm._s(_vm.$t('MODULE.I0018_LBL_BTN2')))])],1)],1)}
var i_0020_staticRenderFns = []
var i_0020_esExports = { render: i_0020_render, staticRenderFns: i_0020_staticRenderFns }
/* harmony default export */ var page_i_0020 = (i_0020_esExports);
// CONCATENATED MODULE: ./src/module/page/i_0020.vue
function i_0020_injectStyle (ssrContext) {
  __webpack_require__("NVQd")
}
var i_0020_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var i_0020___vue_template_functional__ = false
/* styles */
var i_0020___vue_styles__ = i_0020_injectStyle
/* scopeId */
var i_0020___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var i_0020___vue_module_identifier__ = null
var i_0020_Component = i_0020_normalizeComponent(
  i_0020,
  page_i_0020,
  i_0020___vue_template_functional__,
  i_0020___vue_styles__,
  i_0020___vue_scopeId__,
  i_0020___vue_module_identifier__
)

/* harmony default export */ var module_page_i_0020 = (i_0020_Component.exports);

// CONCATENATED MODULE: ./src/module/api/c_0001.js


var c_0001_apiUrl = __webpack_require__("kspH");

// 契約状況検索检索
var c_0001_c_0001 = function c_0001(params) {
  return api_public.requestQuickGet(c_0001_apiUrl.apiUrl_ContractStatus + '?year=' + params.year);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/c_0001.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var c_0001_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var page_c_0001 = ({
  mixins: [css],
  data: function data() {
    return {
      userInfo: [],
      listLoading: false,
      fullscreenLoading: false,
      targetYear: '',
      list: []
    };
  },
  created: function created() {
    // 初期化
    this.init_query();
  },

  methods: {
    // 初期化
    init_query: function init_query() {

      if (!(stringify_default()(this.$route.query) == "{}")) {
        //详细画面返回的检索条件
        this.targetYear = JSON.parse(localStorage.getItem('C0001search_condition'));
      } else {
        //システム年度
        var dt = new Date();
        this.targetYear = dt.getFullYear().toString();
      }

      // 検索
      this.query(this.targetYear);
    },

    // 検索
    query: function query(paramYear) {
      var _this = this;

      localStorage.setItem("C0001search_condition", stringify_default()(paramYear));

      var params = {
        "year": paramYear
      };
      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 2000);
      //検索処理
      c_0001_c_0001(params).then(function (res) {
        //API数据格式化整型
        _this.list = _this.formatDataFromApiForList(res.items.contractStatusSet);
        if (res.code === 300) {
          _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
          loading.close();
          return;
        }
        loading.close();
      }).catch(function (err) {
        //关闭loading
        loading.close();
      });
    },
    selectYear: function selectYear() {
      // 検索
      this.query(this.targetYear);
    },

    //点击后失去焦点(用于按钮还原)/前年
    handleClick1: function handleClick1(e) {
      var target = e.target;
      target.blur();
      var targetYearTemp = parseInt(this.targetYear) - 1;
      this.targetYear = String(targetYearTemp);
      // 検索
      this.query(this.targetYear);
    },

    //点击后失去焦点(用于按钮还原)/翌年
    handleClick2: function handleClick2(e) {
      var target = e.target;
      target.blur();
      var targetYearTemp = parseInt(this.targetYear) + 1;
      this.targetYear = String(targetYearTemp);
      // 検索
      this.query(this.targetYear);
    },

    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    // 戻る処理
    back_click: function back_click() {
      var vm = this;
      vm.$router.push({ path: c_0001_url.routerUrl_Menu });
    },

    // TABLEHeader样式
    c0001HeaderStyle: function c0001HeaderStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:15px;text-align:center ';
    },

    // TABLE单元格样式
    c0001IsCellStyle: function c0001IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (columnIndex == 3) {
        return 'text-align:left;fontSize:13px';
      } else {
        return 'text-align:center;fontSize:13px';
      }
    },

    // 单击行事件
    c0001RowOnClick: function c0001RowOnClick(thisRowDate, column, cell, event) {
      //発行日
      localStorage.setItem('obj', stringify_default()(thisRowDate));
      localStorage.setItem(c_0001_url.routerUrl_C0002, stringify_default()(true));
      this.$router.push({ path: c_0001_url.routerUrl_C0002 });
    },
    c0001HeaderClass: function c0001HeaderClass(_ref3) {
      var row = _ref3.row,
          rowIndex = _ref3.rowIndex;

      return 'c0001HeaderClass';
    },
    c0001IsCellClass: function c0001IsCellClass(_ref4) {
      var row = _ref4.row,
          rowIndex = _ref4.rowIndex;

      return 'c0001IsCellClass';
    },

    //Loading加载
    openFullScreen: function openFullScreen() {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return loading;
    },
    closeFullScreen: function closeFullScreen(loading) {
      loading.close();
    },

    //API数据格式化整型
    formatDataFromApiForList: function formatDataFromApiForList(contractStatusSet) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(contractStatusSet), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.issueDate != null && item.issueDate != '') {
            var issueDateArry = item.issueDate.split('/');
            if (issueDateArry.length == 1) {
              //item.issueDateMonth = item.issueDate.substr(4,2) + this.$t('MODULE.C0001_LBL_COLUMN1');
              item.issueDateMonth = item.issueDate.substr(4, 2) + '/' + item.issueDate.substr(6, 2);
            } else {
              //item.issueDateMonth = issueDateArry[1] + this.$t('MODULE.C0001_LBL_COLUMN1');
              item.issueDateMonth = issueDateArry[1] + '/' + issueDateArry[2];
            }
          }
          if (item.consentDate != null && item.consentDate != '') {
            item.consentDate = item.consentDate.substr(0, 16);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return contractStatusSet;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7499333f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/c_0001.vue
var c_0001_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-container',{staticStyle:{"padding":"0px","width":"100%","height":"100%"}},[_c('el-main',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('div',{staticClass:"search-module-k"},[_c('el-row',{staticStyle:{"padding-top":"5px","padding-left":"5px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('el-date-picker',{staticClass:"c0001-year-select",attrs:{"format":"yyyy","value-format":"yyyy","type":"year","size":"mini","clearable":false,"editable":false},on:{"change":function($event){return _vm.selectYear()}},model:{value:(_vm.targetYear),callback:function ($$v) {_vm.targetYear=$$v},expression:"targetYear"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"padding-left":"10px","padding-right":"10px"},attrs:{"span":6}},[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"c0001-css-button c0001-css-btn",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.handleClick1}},[_vm._v(_vm._s(_vm.$t('MODULE.C0001_LBL_MSG1')))])],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"padding-left":"10px","padding-right":"10px"},attrs:{"span":6}},[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"c0001-css-button c0001-css-btn",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.handleClick2}},[_vm._v(_vm._s(_vm.$t('MODULE.C0001_LBL_MSG2')))])],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"3px","padding-bottom":"5px"}}),_vm._v(" "),_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA"},attrs:{"header-cell-style":_vm.c0001HeaderStyle,"cell-style":_vm.c0001IsCellStyle,"header-row-class-name":_vm.c0001HeaderClass,"cell-class-name":_vm.c0001IsCellClass,"data":_vm.list,"border":"","size":"mini"},on:{"row-click":_vm.c0001RowOnClick}},[_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.C0001_LBL_COLUMN1'),"min-width":"30px","width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.issueDateMonth))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.C0001_LBL_COLUMN2'),"min-width":"","width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.documentName)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.C0001_LBL_COLUMN3'),"min-width":"70px","width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.consentDate))])]}}])}),_vm._v(" "),(false)?_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.recNo))])]}}],null,false,1034755812)}):_vm._e()],1)],1)],1)],1)}
var c_0001_staticRenderFns = []
var c_0001_esExports = { render: c_0001_render, staticRenderFns: c_0001_staticRenderFns }
/* harmony default export */ var module_page_c_0001 = (c_0001_esExports);
// CONCATENATED MODULE: ./src/module/page/c_0001.vue
function c_0001_injectStyle (ssrContext) {
  __webpack_require__("muAb")
}
var c_0001_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_0001___vue_template_functional__ = false
/* styles */
var c_0001___vue_styles__ = c_0001_injectStyle
/* scopeId */
var c_0001___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var c_0001___vue_module_identifier__ = null
var c_0001_Component = c_0001_normalizeComponent(
  page_c_0001,
  module_page_c_0001,
  c_0001___vue_template_functional__,
  c_0001___vue_styles__,
  c_0001___vue_scopeId__,
  c_0001___vue_module_identifier__
)

/* harmony default export */ var src_module_page_c_0001 = (c_0001_Component.exports);

// CONCATENATED MODULE: ./src/module/api/c_0002.js


var c_0002_apiUrl = __webpack_require__("kspH");

// 契約明細検索检索
var c_0002_c_0002 = function c_0002(params, dataSource) {
  if (dataSource == '1') {
    return api_public.requestQuickGet(c_0002_apiUrl.apiUrl_ContractDetail + '?recNo=' + params.recNo);
  } else if (dataSource == '2') {
    return api_public.requestQuickGet(c_0002_apiUrl.apiUrl_ContractDetailNew + '?recNo=' + params.recNo);
  } else {
    return api_public.requestQuickGet(c_0002_apiUrl.apiUrl_ContractDetail + '?recNo=' + params.recNo);
  }
};
// 契約確認情報保存
var c_0002_c_0002_save = function c_0002_save(params, dataSource) {
  if (dataSource == '1') {
    return api_public.requestPost(c_0002_apiUrl.apiUrl_ContractStatus, params);
  } else if (dataSource == '2') {
    return api_public.requestPost(c_0002_apiUrl.apiUrl_ContractStatusNew, params);
  } else {
    return api_public.requestPost(c_0002_apiUrl.apiUrl_ContractStatus, params);
  }
};
//PDF查询
var c_0002_PDFFile_get = function PDFFile_get(PDFPath) {
  return api_public.requestQuickGetImage(c_0002_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(PDFPath) + '&resizeCd=0');
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/c_0002.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var c_0002_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var page_c_0002 = ({
  mixins: [css],
  components: {
    Pdf: components_page_pdf
  },
  data: function data() {
    return {
      obj: [],
      listLoading: false,
      pledgeCheck: false, //誓約チェック
      consentCheck: false, //同意チェック
      pageShow: true,
      list: [],
      issueDate: "", //発行日
      consentDate: "", //同意日時
      consentText: "", //同意項目表示
      recNo: "", //レコード番号 
      dataSource: "", //データ元
      userInfo: [], //用户信息
      printBtnShow: false, //印刷ボタンの表示
      contractPath: "", //契約書パス
      //pdfFlag
      viewVisible: false,
      pdfUrl: ''
    };
  },
  created: function created() {
    this.obj = JSON.parse(localStorage.getItem('obj'));
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.recNo = this.obj.recNo;
    this.issueDate = this.obj.issueDate;
    this.consentDate = this.obj.consentDate;
    this.dataSource = this.obj.dataSource;
    this.contractPath = this.obj.contractPath; //契約書パス
    //默认值
    if (!(this.dataSource && this.dataSource.trim() !== '')) {
      this.dataSource = '1';
    }
    //【同意日時：YYYYMMDD HH:MM:SS】で表示する。
    if (this.consentDate != '' && this.consentDate != null) {
      this.consentText = this.$t('MODULE.C0001_LBL_COLUMN3') + "：" + this.consentDate;
      this.pageShow = false;
    }
    //IF.契約書パスがNull以外の場合のみ、ボタン表示 以外の場合、非表示
    if (this.contractPath != '' && this.contractPath != null) {
      this.printBtnShow = true;
    }
    this.init_query();
  },

  methods: {
    // 初期化
    init_query: function init_query() {
      // 検索
      this.query(this.recNo, this.dataSource);
      //1：確認
      this.saveProcess(this.recNo, "1", this.dataSource);
    },

    // 検索
    query: function query(recNo, dataSource) {
      var _this = this;

      var params = {
        "recNo": recNo
      };
      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 2000);
      //検索処理
      c_0002_c_0002(params, this.dataSource).then(function (res) {
        //API数据
        //this.list = res.items.contractDetailSet;
        _this.list = _this.formartListData(res.items.contractDetailSet);
        if (res.code === 300) {
          _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
          loading.close();
          return;
        }
        loading.close();
      }).catch(function (err) {
        //关闭loading
        loading.close();
      });
    },

    //整理API返回的数据
    formartListData: function formartListData(list) {
      //返回结构体
      // contractDetailSetList = [
      //                           { //contractDetailSet
      //                             key : "",
      //                             title : "",
      //                             itemContent : [
      //                                             {
      //                                               itemName : "",
      //                                               contractText : "",
      //                                             },
      //                                           ],
      //                           }
      //                         ]

      var contractDetailSetList = [];
      var contractDetailSetIndex = 0;
      for (var i = 0; i < list.length; i++) {
        var items = list[i];
        var itemContent = {
          itemName: "",
          contractText: ""
        };
        if (items.title != "") {
          var contractDetailSet = {
            key: "",
            title: "",
            itemContent: []
          };
          contractDetailSet.key = contractDetailSetIndex;
          contractDetailSet.title = items.title;

          itemContent.itemName = items.itemName;
          itemContent.contractText = items.contractText;
          contractDetailSet.itemContent.push(itemContent);
          contractDetailSetList.push(contractDetailSet);
          contractDetailSetIndex++;
        } else {
          itemContent.itemName = items.itemName;
          itemContent.contractText = items.contractText;

          contractDetailSetList[contractDetailSetIndex - 1].itemContent.push(itemContent);
        }
      }
      //APIから「タイトル」が有る場合、タイトル様式を設定する
      //「契約文言」だけタイトル様式として表示する
      for (var _i = 0; _i < contractDetailSetList.length; _i++) {
        var items = contractDetailSetList[_i];
        if (items.title == "TITLE") {
          if (items.itemContent.length > 0) {
            items.title = items.itemContent[0].contractText;
            items.itemContent.splice(0, 1); //删除明细行和title重复的数据
          }
        }
      }
      return contractDetailSetList;
    },

    //保存
    saveProcess: function saveProcess(recNo, division, dataSource) {
      var _this2 = this;

      var params = [];
      var param = {
        "recNo": recNo,
        "division": division //1：確認 , 2：同意
      };
      params.push(param);
      //保存
      c_0002_c_0002_save(params, this.dataSource).then(function (res) {
        if (res.code == "202") {
          if (division == "2") {
            //保存しました。
            _this2.$message.success({ message: _this2.$t('COMMON.MSG_INSERTED'), showClose: true });
            _this2.$store.commit('increment', '0');
            _this2.handleMenuState();
            _this2.back_click();
          }
        } else {
          //処理失敗しました。
          _this2.$message.error({ message: _this2.$t('COMMON.' + res.message), showClose: true });
        }
      });
    },

    //获取menu状态
    handleMenuState: function handleMenuState() {
      home_menuStateManager(this.userInfo.userCd).then(function (res) {
        if (res.code == 204) {
          var menuState = res.items.menuState[0];
          localStorage.setItem("menuState", stringify_default()(menuState));
        }
      });
    },

    // 申請
    basicInfoApply: function basicInfoApply() {
      //2：同意
      this.saveProcess(this.recNo, "2", this.dataSource);
    },

    // 戻る処理
    back_click: function back_click() {
      var returnC0001Param = JSON.parse(localStorage.getItem('C0001search_condition'));
      var vm = this;
      vm.$router.push({ path: c_0002_url.routerUrl_C0001, query: returnC0001Param });
    },

    //印刷処理
    print_click: function print_click() {
      var _this3 = this;

      this.set_loading();
      c_0002_PDFFile_get(this.contractPath).then(function (res_file) {
        var fileUrl = {};
        var blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' });
        var url = window.URL.createObjectURL(blob);
        fileUrl.url = url;
        fileUrl.name = _this3.contractPath;
        for (var index = 0; index < 2; index++) {
          fileUrl.name = fileUrl.name.substring(fileUrl.name.indexOf('/') + 1);
        }
        _this3.download(fileUrl);
        _this3.close_loading();
      }).catch(function (err) {
        //关闭loading
        _this3.close_loading();
      });
    },

    //pdfダウンロード
    download: function download(file) {
      this.pdfUrl = file;
      this.viewVisible = true;
    },
    pdfClose: function pdfClose() {
      this.viewVisible = false;
    },

    //表格行样式
    c0002IsRowClass: function c0002IsRowClass(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return 'c0002IsRowClass';
    },

    //表格单元格样式
    c0002IsCellClass: function c0002IsCellClass(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      return 'c0002IsCellClass';
    },

    //表格第一列与第二列样式
    c0002IsCellStyle: function c0002IsCellStyle(_ref3) {
      var row = _ref3.row,
          colum = _ref3.colum,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;

      if (columnIndex == 0) {
        return 'text-align:right;background:#d2eef8;';
      } else {
        return 'background:#fafafa;';
      }
    },
    pledgeCheckChange: function pledgeCheckChange(isChack) {
      //誓約チェックがチェックOFFの場合、同意チェックもチェックOFFになる。
      if (isChack == false) {
        this.consentCheck = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e64655b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/c_0002.vue
var c_0002_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"10px"}},[_vm._l((_vm.list),function(item){return _c('div',{key:item.key},[_c('el-row',{staticStyle:{"background-color":"#3cc6fa","text-align":"center"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('el-table',{staticClass:"table-label",attrs:{"data":item.itemContent,"show-header":false,"row-class-name":_vm.c0002IsRowClass,"cell-style":_vm.c0002IsCellStyle,"cell-class-name":_vm.c0002IsCellClass}},[_c('el-table-column',{attrs:{"width":"127px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.itemName))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(scope.row.contractText))])]}}],null,true)})],1)],1)}),_vm._v(" "),_c('el-checkbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageShow),expression:"pageShow"}],staticStyle:{"margin-left":"5px","margin-top":"10px"},on:{"change":function($event){return _vm.pledgeCheckChange(_vm.pledgeCheck)}},model:{value:(_vm.pledgeCheck),callback:function ($$v) {_vm.pledgeCheck=$$v},expression:"pledgeCheck"}},[_c('span',[_c('div',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.$t('MODULE.C0002_LBL_CHECKBOX1'))},slot:"content"})])]),_vm._v(" "),_c('el-checkbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageShow),expression:"pageShow"}],staticStyle:{"margin-left":"5px","margin-top":"10px"},attrs:{"disabled":!_vm.pledgeCheck},model:{value:(_vm.consentCheck),callback:function ($$v) {_vm.consentCheck=$$v},expression:"consentCheck"}},[_vm._v(_vm._s(_vm.$t('MODULE.C0002_LBL_CHECKBOX2')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pageShow),expression:"!pageShow"}],staticStyle:{"padding-top":"5px","padding-bottom":"5px","padding-left":"5px","font-size":"12pt"}},[_vm._v(_vm._s(_vm.consentText))]),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.pageShow),expression:"pageShow"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary","disabled":!_vm.consentCheck},on:{"click":_vm.basicInfoApply}},[_vm._v(_vm._s(_vm.$t('MODULE.C0002_BTN_APPLY')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('MODULE.C0002_BTN_RETURN')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.printBtnShow),expression:"printBtnShow"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.print_click}},[_vm._v(_vm._s(_vm.$t('MODULE.C0002_BTN_PRINT')))])],1),_vm._v(" "),_c('el-dialog',{attrs:{"fullscreen":"","visible":_vm.viewVisible,"close-on-click-modal":false,"show-close":false,"width":"100%","top":"52px","height":"120%"},on:{"update:visible":function($event){_vm.viewVisible=$event}}},[_c('Pdf',{attrs:{"src":_vm.pdfUrl},on:{"pdfClose":_vm.pdfClose}})],1)],2)}
var c_0002_staticRenderFns = []
var c_0002_esExports = { render: c_0002_render, staticRenderFns: c_0002_staticRenderFns }
/* harmony default export */ var module_page_c_0002 = (c_0002_esExports);
// CONCATENATED MODULE: ./src/module/page/c_0002.vue
function c_0002_injectStyle (ssrContext) {
  __webpack_require__("pQD1")
}
var c_0002_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_0002___vue_template_functional__ = false
/* styles */
var c_0002___vue_styles__ = c_0002_injectStyle
/* scopeId */
var c_0002___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var c_0002___vue_module_identifier__ = null
var c_0002_Component = c_0002_normalizeComponent(
  page_c_0002,
  module_page_c_0002,
  c_0002___vue_template_functional__,
  c_0002___vue_styles__,
  c_0002___vue_scopeId__,
  c_0002___vue_module_identifier__
)

/* harmony default export */ var src_module_page_c_0002 = (c_0002_Component.exports);

// CONCATENATED MODULE: ./src/module/api/c_0003.js



var c_0003_apiUrl = __webpack_require__("kspH");

// 页面列表検索
var c_0003_search = function search(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(c_0003_apiUrl.apiUrl_laberNoticeInfo + '?' + querys);
};
//文件查询
var c_0003_b_0002_getFile = function b_0002_getFile(params) {
  return api_public.requestQuickGetImage(c_0003_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(params.filePath) + '&resizeCd=' + params.resizeCd);
};
// 労働条件通知書PDF検索
var c_0003_getLaborNoticeOutput = function getLaborNoticeOutput(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestPostZip(c_0003_apiUrl.apiUrl_laborNoticeOutput + '?' + querys);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/c_0003.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var c_0003_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var c_0003 = ({
  mixins: [css],
  components: {
    Pdf: components_page_pdf
  },
  data: function data() {
    return {
      obj: [],
      listLoading: false,
      pledgeCheck: false, //誓約チェック
      consentCheck: false, //同意チェック
      pageShow: true,
      list: [],
      issueDate: "", //発行日
      consentDate: "", //同意日時
      consentText: "", //同意項目表示
      recNo: "", //レコード番号
      //pdfFlag
      viewVisible: false,
      pdfUrl: '',
      pdfPath: ''
    };
  },
  created: function created() {
    this.query();
  },

  methods: {
    // 検索
    query: function query() {
      var _this = this;

      var params = {
        "jobDate": this.$route.query.jobDate,
        "fieldCd": this.$route.query.fieldCd,
        "fieldUserCd": this.$route.query.userCd,
        "storePositionCd": this.$route.query.storePositionCd
      };
      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 2000);

      //検索処理
      c_0003_search(params).then(function (res) {
        //API数据
        _this.list = _this.formartListData(res.items.laberNoticeSet);
        if (res.code === 300) {
          _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
          loading.close();
          //return
          //返回之前页面
          //var returnParam = JSON.parse(localStorage.getItem('search_condition'));
          //var routerUrl = JSON.parse(localStorage.getItem('routerUrl'));
          //var vm = this;
          //vm.$router.push({ path: routerUrl, query: returnParam });
        } else if (res.code === 311) {
          _this.$message.error({ message: _this.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
        }
        loading.close();
      }).catch(function (err) {
        //关闭loading
        loading.close();
      });
    },

    //整理API返回的数据
    formartListData: function formartListData(list) {
      //返回结构体
      // contractDetailSetList = [
      //                           { //contractDetailSet
      //                             key : "",
      //                             title : "",
      //                             itemContent : [
      //                                             {
      //                                               itemName : "",
      //                                               contractText : "",
      //                                             },
      //                                           ],
      //                           }
      //                         ]

      var contractDetailSetList = [];
      var contractDetailSetIndex = 0;
      for (var i = 0; i < list.length; i++) {
        var items = list[i];
        var itemContent = {
          itemName: "",
          contractText: ""
        };
        if (items.note != "" && items.note != null) {
          var contractDetailSet = {
            key: "",
            title: "",
            itemContent: []
          };
          contractDetailSet.key = contractDetailSetIndex;
          contractDetailSet.title = items.note;
          itemContent.itemName = items.itemName;
          itemContent.contractText = items.contractText;
          contractDetailSet.itemContent.push(itemContent);
          contractDetailSetList.push(contractDetailSet);
          contractDetailSetIndex++;
        } else {
          itemContent.itemName = items.itemName;
          itemContent.contractText = items.contractText;
          contractDetailSetList[contractDetailSetIndex - 1].itemContent.push(itemContent);
        }
      }
      //APIから「タイトル」が有る場合、タイトル様式を設定する
      //「契約文言」だけタイトル様式として表示する
      for (var _i = 0; _i < contractDetailSetList.length; _i++) {
        var items = contractDetailSetList[_i];
        if (items.title == "TITLE") {
          if (items.itemContent.length > 0) {
            items.title = items.itemContent[0].contractText;
            items.itemContent.splice(0, 1); //删除明细行和title重复的数据
          }
        }
      }
      return contractDetailSetList;
    },

    // 戻る処理
    back_click: function back_click() {
      // var returnC0001Param = JSON.parse(localStorage.getItem('C0001search_condition'));
      // var vm = this;
      // vm.$router.push({ path: url.routerUrl_C0001, query: returnC0001Param  })
      //返回之前页面
      //var returnParam = JSON.parse(localStorage.getItem('search_condition'));
      //var routerUrl = JSON.parse(localStorage.getItem('routerUrl'));
      //var vm = this;
      //vm.$router.push({ path: routerUrl, query: returnParam });
      this.$router.go(-1);
    },

    //労働条件通知書の印刷
    createdPDF: function createdPDF() {
      var _this2 = this;

      this.set_loading();

      var params = {};
      params.jobDate = this.$route.query.jobDate;
      params.fieldCd = this.$route.query.fieldCd;
      params.fieldUserCd = this.$route.query.userCd;
      params.storePositionCd = this.$route.query.storePositionCd;

      c_0003_getLaborNoticeOutput(params).then(function (res) {
        if (res.type == 'application/json') {
          var that = _this2;
          var reader = new FileReader();
          reader.readAsText(res, 'utf-8');
          reader.onload = function (e) {
            var readerres = reader.result;
            var parseObj = JSON.parse(readerres);
            if (parseObj.code == 300) {
              //該当データはありません。
              that.$message.warning({ message: that.$t('COMMON.NO_TARGET_DATA'), showClose: true });
            }
          };
        } else {
          var fileUrl = {};
          var blob = new Blob([res], { type: "application/pdf;charset=UTF-8" });
          var _url = window.URL.createObjectURL(blob);
          fileUrl.url = _url;
          //労働条件通知書.pdf
          fileUrl.name = _this2.$t('MODULE.C0003_PDF_NAME') + ".pdf";
          _this2.download(fileUrl);
        }
        _this2.close_loading();
      }).catch(function () {
        _this2.close_loading();
      });
    },
    pdfClose: function pdfClose() {
      this.viewVisible = false;
    },

    //pdfダウンロード
    download: function download(file) {
      this.pdfUrl = file;
      this.viewVisible = true;
    },

    //表格行样式
    c0003IsRowClass: function c0003IsRowClass(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return 'c0003IsRowClass';
    },

    //表格单元格样式
    c0003IsCellClass: function c0003IsCellClass(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      return 'c0003IsCellClass';
    },

    //表格第一列与第二列样式
    c0003IsCellStyle: function c0003IsCellStyle(_ref3) {
      var row = _ref3.row,
          colum = _ref3.colum,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;

      if (columnIndex == 0) {
        return 'text-align:right;background:#d2eef8;';
      } else {
        return 'background:#fafafa;';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54691fbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/c_0003.vue
var c_0003_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"10px"}},[_vm._l((_vm.list),function(item){return _c('div',{key:item.key},[_c('el-row',{staticStyle:{"background-color":"#3cc6fa","text-align":"center"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('el-table',{staticClass:"table-label",staticStyle:{"border-bottom":"1px solid #ccc"},attrs:{"data":item.itemContent,"show-header":false,"row-class-name":_vm.c0003IsRowClass,"cell-style":_vm.c0003IsCellStyle,"cell-class-name":_vm.c0003IsCellClass}},[_c('el-table-column',{attrs:{"width":"30px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.itemName))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.contractText))])]}}],null,true)})],1)],1)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pageShow),expression:"!pageShow"}],staticStyle:{"padding-top":"5px","padding-bottom":"5px","padding-left":"5px","font-size":"12pt"}},[_vm._v(_vm._s(_vm.consentText))]),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('MODULE.C0002_BTN_RETURN')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.createdPDF()}}},[_vm._v(_vm._s(_vm.$t('MODULE.C0003_BTN_PRINT')))])],1),_vm._v(" "),_c('el-dialog',{staticStyle:{"margin-top":"5%"},attrs:{"fullscreen":"","visible":_vm.viewVisible,"close-on-click-modal":false,"show-close":false,"width":"100%","top":"52px","height":"120%"},on:{"update:visible":function($event){_vm.viewVisible=$event}}},[_c('Pdf',{attrs:{"src":_vm.pdfUrl},on:{"pdfClose":_vm.pdfClose}})],1)],2)}
var c_0003_staticRenderFns = []
var c_0003_esExports = { render: c_0003_render, staticRenderFns: c_0003_staticRenderFns }
/* harmony default export */ var page_c_0003 = (c_0003_esExports);
// CONCATENATED MODULE: ./src/module/page/c_0003.vue
function c_0003_injectStyle (ssrContext) {
  __webpack_require__("EvRM")
}
var c_0003_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var c_0003___vue_template_functional__ = false
/* styles */
var c_0003___vue_styles__ = c_0003_injectStyle
/* scopeId */
var c_0003___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var c_0003___vue_module_identifier__ = null
var c_0003_Component = c_0003_normalizeComponent(
  c_0003,
  page_c_0003,
  c_0003___vue_template_functional__,
  c_0003___vue_styles__,
  c_0003___vue_scopeId__,
  c_0003___vue_module_identifier__
)

/* harmony default export */ var module_page_c_0003 = (c_0003_Component.exports);

// CONCATENATED MODULE: ./src/module/api/s_0001.js

var s_0001_apiUrl = __webpack_require__("kspH");


// tab1检索处理
var s_0001_s0001Tab1_search = function s0001Tab1_search(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet('api/v1/shiftInfo' + '?' + querys);
};
// tab1更新处理
var s_0001_s0001Tab1_update = function s0001Tab1_update(params) {
    return api_public.requestPost('api/v1/shiftInfo', params);
};
// tab2检索处理
var s_0001_s0001Tab2_search = function s0001Tab2_search(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet('api/v1/crewInfo' + '?' + querys);
};
// tab2更新处理
var s_0001_s0001Tab2_update = function s0001Tab2_update(params) {
    return api_public.requestPost('api/v1/crewInfo', params);
};
//tab3 检索处理 勤務実績情報検索
var s_0001_s0001Tab3_search = function s0001Tab3_search(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet('api/v1/attendenceInfo' + '?' + querys);
};
//tab3 检索处理 勤怠詳細情報検索
var s_0001_s0001Tab3_detail_search = function s0001Tab3_detail_search(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet('api/v1/attendenceDetailInfo' + '?' + querys);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/s_0001_tab1.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var s_0001_tab1_url = __webpack_require__("kspH");

/* harmony default export */ var s_0001_tab1 = ({
  // props: ['tabsIndex'],
  // name: "Map",
  data: function data() {
    return {
      currentDate: '',
      calenderDateList: [], //calender1表示用list
      calenderMode2DateList: [], //calender2表示用list
      selectedMonth: '', //当前月（字符串格式）
      selectedDay: '', //当前点击的日期（字符串格式）
      updateList: [], //编辑模式下的临时list(保存用)
      calenderMode: '1', //1：calender表示，2：list表示  全局用
      calenderMode_radio: '1', //1：calender表示，2：list表示  radio专用
      isEditMode: false, //false：非选择模式,true:选择模式
      readonlyTimeSet: false, //时间模块是否只读
      touchmoveFlag: false,
      firstEditClickFlg: true, //判断是否是编辑模式下第一次点击按钮
      hasEditedDateFlg: false, //是否有已经编辑数据flg
      blurErrorFlg: false,
      // isCurrentMonth: true,
      timeFrom: '',
      timeTo: '',
      remark: '',
      tabsIndex: '',
      login_officeCd: '', //登陆者所属officecd
      login_userCd: '', //登陆者cd
      icon_o: '〇',
      icon_x: '✖',
      shiftLockFlg: '0', //本月lock情况:1=lock
      shiftLockFlg_done: '0', //本月lock情况表示用（シフト申請対象外）
      shiftLockFlg_out_object: '0', //本月lock情况表示用（シフトロック済）
      weekStr: [], //一周的文言
      strToDay: '', //今日日期（yyyy/mm/dd）
      passedDateFlg: false, //编辑模式中，过去日判定用flg
      longPress: 'false' //触发长按标志位
    };
  },
  mounted: function mounted() {
    //カレンダーのセルセット
    var calendarThead = document.querySelector(".s0001tab1Class .el-calendar-table thead");
    calendarThead.childNodes[0].style.color = "red";
    calendarThead.childNodes[6].style.color = "blue";
    this.weekStr[0] = this.$t('MODULE.S0001_LBL_CALENDAR_SUN');
    this.weekStr[1] = this.$t('MODULE.S0001_LBL_CALENDAR_MON');
    this.weekStr[2] = this.$t('MODULE.S0001_LBL_CALENDAR_TUE');
    this.weekStr[3] = this.$t('MODULE.S0001_LBL_CALENDAR_WED');
    this.weekStr[4] = this.$t('MODULE.S0001_LBL_CALENDAR_THU');
    this.weekStr[5] = this.$t('MODULE.S0001_LBL_CALENDAR_FRI');
    this.weekStr[6] = this.$t('MODULE.S0001_LBL_CALENDAR_SAT');
    //周tittle设置
    for (var i = 0; i < 7; i++) {
      calendarThead.childNodes[i].innerHTML = this.weekStr[i];
    }

    var calendarTbody = document.querySelector(".s0001tab1Class .el-calendar-table tbody");
    var calendarTbodyChildren = calendarTbody.children;
    var calendarTbodyChildrenChildren;
    for (var i = 0; i < calendarTbodyChildren.length; i++) {
      calendarTbodyChildrenChildren = calendarTbody.children[i];
      if (i % 2 != 0) {
        //隔行变色处理
        calendarTbodyChildrenChildren.style.background = "#f7fbfc";
      }
    }
  },

  created: function created() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.login_officeCd = userInfo.officeCd;
    this.login_userCd = userInfo.userCd;
    this.selectedMonth = this.dateFormart(new Date(), 'yyyymm');
    this.strToDay = this.dateFormart(new Date(), 'yyyy/mm/dd');
    this.query();
  },
  methods: {
    //日期字符串转化为 年月日（星期）
    toStrToDay2: function toStrToDay2(thisDay) {
      var theDate = new Date(thisDay);
      var myddy = theDate.getDay();
      return thisDay + '(' + this.weekStr[myddy] + ')';
    },

    //获得tabsindex
    getTabsIndex: function getTabsIndex(val) {
      this.tabsIndex = val;
    },

    //calendar2下拉列表改变事件
    cal2_attendanceDivChangeEvent: function cal2_attendanceDivChangeEvent(e, item, jobDate, ItemIndex, targetVal) {
      //updateList保存
      this.saveupdateList(item, targetVal, jobDate);
      if (this.calenderMode2DateList[ItemIndex].attendanceDiv === '2') {
        this.calenderMode2DateList[ItemIndex].timeFrom = '';
        this.calenderMode2DateList[ItemIndex].timeTo = '';
      }
    },

    //calendar1时间入力失去焦点事件
    cal1_inputBlur: function cal1_inputBlur(e, item) {
      if (this.isEditMode == false) return;
      var retValue = '';
      if (item == 'remark') {
        retValue = e.target.value;
      } else {
        if (e.target.value !== '') {
          retValue = utils.timeFormatter(e.target.value);
        } else {
          retValue = '';
        }
        this[item] = retValue;
      }
      //updateList保存
      this.saveupdateList(item, retValue, this.selectedDay);
    },

    //calendar2时间入力失去焦点事件
    cal2_inputBlur: function cal2_inputBlur(e, item, jobDate, ItemIndex) {

      var retValue = '';
      if (item == 'remark') {
        retValue = e.target.value;
        this.calenderMode2DateList[ItemIndex][item] = retValue;
      } else {
        if (e.target.value !== '') {
          retValue = utils.timeFormatter(e.target.value);
        } else {
          retValue = '';
        }
        this.calenderMode2DateList[ItemIndex][item] = retValue;
      }
      //updateList保存
      this.saveupdateList(item, retValue, jobDate);
      return retValue;
    },

    // 时间入力check
    timeInputCheck: function timeInputCheck(e) {
      if (e.target.value === '') return;
      var reg = /^\d*(\:?\d{0,2})/g;
      var matchResult = e.target.value.match(reg);
      if (matchResult === null) {
        e.target.value = null;
      } else {
        e.target.value = matchResult[0];
      }
    },

    //input获取焦点时自动去掉','和':'
    focusInput: function focusInput(item, itemName) {
      item = item.toString().replace(/:|,/g, "");
      if (itemName === 'timeFrom') {
        this.timeFrom = item;
      }
      if (itemName === 'timeTo') {
        this.timeTo = item;
      }
    },

    //calender模式切换事件
    radioChange: function radioChange(val) {
      var _this = this;

      if (val === '2') {
        if (this.isEditMode == true) {
          if (this.updateList.length > 0) {
            this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
              confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
              cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
              center: true
            }).then(function () {
              _this.updateList = undefined;
              _this.updateList = new Array();
              _this.isEditMode = false;
              _this.firstEditClickFlg = true;
              _this.calenderMode2DateList = JSON.parse(stringify_default()(_this.calenderDateList));
              _this.calenderMode = '2';
            }).catch(function () {
              _this.calenderMode = '1';
              _this.calenderMode_radio = '1';
            });
          } else {
            this.updateList = undefined;
            this.updateList = new Array();
            this.isEditMode = false;
            this.firstEditClickFlg = true;
            this.calenderMode2DateList = JSON.parse(stringify_default()(this.calenderDateList));
            this.calenderMode = '2';
          }
        } else {
          this.isEditMode = false;
          this.firstEditClickFlg = true;
          this.calenderMode2DateList = JSON.parse(stringify_default()(this.calenderDateList));
          this.calenderMode = '2';
        }
      } else {
        if (this.updateList.length > 0) {
          this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true
          }).then(function () {
            //this.selectedDay=''
            _this.updateList = undefined;
            _this.updateList = new Array();
            _this.isEditMode = false;
            _this.firstEditClickFlg = true;
            _this.calenderMode2DateList = undefined;
            _this.calenderMode = '1';
          }).catch(function () {
            _this.calenderMode = '2';
            _this.calenderMode_radio = '2';
          });
        } else {
          //this.selectedDay=''
          this.isEditMode = false;
          this.firstEditClickFlg = true;
          this.calenderMode = '1';
        }
      }
    },


    //日期字符串转化为 日（星期）
    toStrToDay: function toStrToDay(thisDay) {
      var theDate = new Date(thisDay);
      var myddy = theDate.getDay();
      return thisDay.substring(8, 10) + '(' + this.weekStr[myddy] + ')';
    },

    // 検索
    query: function query() {
      var _this2 = this;

      var Params = {
        "salesOfficeCd": this.login_officeCd,
        "userId": this.login_userCd,
        "month": this.selectedMonth,
        "page": 1,
        "size": 100
      };
      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 2000);
      // 検索処理
      s_0001_s0001Tab1_search(Params).then(function (res) {
        // 戻るリスト
        //初始化前清空
        _this2.calenderDateList = undefined;
        _this2.calenderDateList = new Array();
        if (res.code === 300) {
          //this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          _this2.shiftLockFlg = '1';
          _this2.shiftLockFlg_out_object = '1';
          _this2.shiftLockFlg_done = '0';
          loading.close();
          return;
        } else {
          _this2.shiftLockFlg = res.items.shiftSet[0].shiftLockFlg;
          if (_this2.shiftLockFlg === '1') {
            _this2.shiftLockFlg_out_object = '0';
            _this2.shiftLockFlg_done = '1';
          } else {
            _this2.shiftLockFlg_out_object = '0';
            _this2.shiftLockFlg_done = '0';
          }
          //更新基本list
          _this2.calenderDateList = JSON.parse(stringify_default()(res.items.shiftSet[0].dateItems));
          //△-> ○
          _this2.calenderDateList.forEach(function (item) {
            if (item.attendanceDiv === '1') {
              item.attendanceDiv = '0';
            }
          });
          //更新cal2表示用list
          if (_this2.calenderMode === '2') {
            _this2.calenderMode2DateList = JSON.parse(stringify_default()(_this2.calenderDateList));
          }
        }
        loading.close();
      });
    },

    //日期转为字符串formartType='yyyymm'或'yyyy/mm/dd'或yyyy-mm-dd，
    dateFormart: function dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? '0' + M : M) + '-' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? '0' + M : M) + '/' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? '0' + M : M);
    },


    // TABLE单元格样式
    calenderMode2calendarCss: function calenderMode2calendarCss(_ref) {
      var row = _ref.row,
          colum = _ref.colum,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'text-align:center;';
    },


    //前月翌月今日综合处理
    monthChange: function monthChange(val) {
      var _this3 = this;

      //编辑模式或者cal2的场合，若更新list里有值，询问是否变更
      if ((this.isEditMode == true || this.calenderMode === '2') && this.updateList.length > 0) {
        this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(function () {
          _this3.updateList = undefined;
          _this3.updateList = new Array();
          _this3.isEditMode = false;
          _this3.firstEditClickFlg = true;
          var getEl = _this3.$refs.elCalendar.$children[0].$children[val];
          //触发调转事件
          getEl.$el.click();
          _this3.$nextTick(function () {
            var calendarTitle = document.querySelector(".s0001tab1Class .el-calendar__header .el-calendar__title");
            var monthStr = calendarTitle.innerHTML;
            if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
              _this3.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16);
            } else {
              _this3.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15);
            }
            //刷新数据
            _this3.query();
            if (document.querySelector(".is-selected") !== null) {
              document.querySelector(".is-selected").classList.remove('is-selected');
            }
            _this3.selectedDay = '';
          });
        }).catch(function () {
          // いいえ
        });
      } else {
        this.updateList = undefined;
        this.updateList = new Array();
        this.isEditMode = false;
        this.firstEditClickFlg = true;
        var getEl = this.$refs.elCalendar.$children[0].$children[val];
        //触发调转事件
        getEl.$el.click();
        this.$nextTick(function () {
          var calendarTitle = document.querySelector(".s0001tab1Class .el-calendar__header .el-calendar__title");
          var monthStr = calendarTitle.innerHTML;
          if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
            _this3.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16);
          } else {
            _this3.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15);
          }
          //刷新数据
          _this3.query();
          if (document.querySelector(".is-selected") !== null) {
            document.querySelector(".is-selected").classList.remove('is-selected');
          }
          _this3.selectedDay = '';
        });
      }
    },

    //前月
    preMonthClick: function preMonthClick() {
      this.monthChange(0);
    },

    //今日
    todayClick: function todayClick() {
      this.monthChange(1);
    },

    //翌月
    nextMonthClick: function nextMonthClick() {
      this.monthChange(2);
    },

    //出勤区分状态反向处理
    attendanceDivChangeStatus: function attendanceDivChangeStatus(attendanceDiv) {
      var ret = '';
      if (attendanceDiv === '0') {
        ret = '2';
      } else if (attendanceDiv === '') {
        ret = '0';
      } else {
        ret = '0';
      }
      return ret;
    },

    //根据不同区分改变相应的值，并保存在updateList里
    //参数：modify_type修改项目种别，targetVal修改后的值，selectedDay日期
    saveupdateList: function saveupdateList(modify_type, targetVal, selectedDay) {
      var changeFgl = false;
      var thisDayIndex = this.updateList.findIndex(function (item) {
        return item.jobDate === selectedDay;
      });
      //updateList里不存在的场合，先拷贝原始数据list，再将变更信息添加到updateList里
      if (thisDayIndex === -1) {
        var Index = this.calenderDateList.findIndex(function (item) {
          return item.jobDate === selectedDay;
        });
        var tempObj = JSON.parse(stringify_default()(this.calenderDateList[Index]));
        if (modify_type === 'attendanceDiv') {
          if (targetVal === -1) {
            //-1的场合，直接取反状态
            changeFgl = true;
            tempObj.attendanceDiv = this.attendanceDivChangeStatus(tempObj.attendanceDiv);
          } else {
            //-1以外的场合，正常修改新值
            if (tempObj.attendanceDiv !== targetVal) {
              tempObj.attendanceDiv = targetVal;
              changeFgl = true;
            }
          }
          //x的场合时间清空
          if (tempObj.attendanceDiv === '2') {
            tempObj.timeFrom = '';
            tempObj.timeTo = '';
          }
        } else if (modify_type === 'timeFrom') {
          if (tempObj.timeFrom !== targetVal) {
            tempObj.timeFrom = targetVal;
            changeFgl = true;
          }
        } else if (modify_type === 'timeTo') {
          if (tempObj.timeTo !== targetVal) {
            tempObj.timeTo = targetVal;
            changeFgl = true;
          }
        } else if (modify_type === 'remark') {
          if (tempObj.remark !== targetVal) {
            tempObj.remark = targetVal;
            changeFgl = true;
          }
        }
        if (changeFgl) {
          this.updateList.splice(0, 0, tempObj);
        }
      }
      //updateList里存在的场合，直接将变更信息更新updateList里
      else {
          var tempObj = JSON.parse(stringify_default()(this.updateList[thisDayIndex]));
          if (modify_type === 'attendanceDiv') {
            tempObj.attendanceDiv = this.attendanceDivChangeStatus(tempObj.attendanceDiv);
            //x的场合时间清空
            if (tempObj.attendanceDiv === '2') {
              tempObj.timeFrom = '';
              tempObj.timeTo = '';
            }
          } else if (modify_type === 'timeFrom') {
            tempObj.timeFrom = targetVal;
          } else if (modify_type === 'timeTo') {
            tempObj.timeTo = targetVal;
          } else if (modify_type === 'remark') {
            tempObj.remark = targetVal;
          }
          this.updateList.splice(thisDayIndex, 1, tempObj);
        }
    },

    //日期单元格点击事件。 
    dateCellClick: function dateCellClick(in_dateDay) {
      var _this4 = this;

      var selectedCellDay;
      if (in_dateDay !== '') {
        selectedCellDay = in_dateDay.replace(/-/g, '/');
        this.currentDate = new Date(selectedCellDay);
      } else {
        return;
      }
      //若为编辑模式，先将上次的日期内容失去焦点并保存（此处理必须在日期变换前）
      if (this.isEditMode) {
        this.$refs.timeFrom.blur();
        this.$refs.timeTo.blur();
        this.$refs.remark.blur();
      }
      //每个日期点击时，第一下只表示，第二下开始编辑
      if (this.selectedDay != selectedCellDay) {
        this.firstEditClickFlg = true;
        this.selectedDay = selectedCellDay; //日期变换
      }
      //编辑模式处理
      if (this.isEditMode) {
        if (this.selectedDay <= this.strToDay) {
          this.passedDateFlg = true;
        } else {
          this.passedDateFlg = false;
        }
        if (!this.firstEditClickFlg && !this.passedDateFlg) {
          this.saveupdateList('attendanceDiv', -1, this.selectedDay); //参数为-1表示直接取反
        }
        var Index = this.updateList.findIndex(function (item) {
          return item.jobDate === _this4.selectedDay;
        });
        if (Index === -1) {
          var Index_cal = this.calenderDateList.findIndex(function (item) {
            return item.jobDate === _this4.selectedDay;
          });
          if (Index_cal === -1) {
            this.timeFrom = '';
            this.timeTo = '';
            this.remark = '';
          } else {
            this.timeFrom = this.calenderDateList[Index_cal].timeFrom;
            this.timeTo = this.calenderDateList[Index_cal].timeTo;
            this.remark = this.calenderDateList[Index_cal].remark;
            //x的场合,时间设定只读
            if (this.calenderDateList[Index_cal].attendanceDiv === '2') {
              this.readonlyTimeSet = true;
            } else {
              this.readonlyTimeSet = false;
            }
          }
        } else {
          this.timeFrom = this.updateList[Index].timeFrom;
          this.timeTo = this.updateList[Index].timeTo;
          this.remark = this.updateList[Index].remark;
          //x的场合,时间设定只读
          if (this.updateList[Index].attendanceDiv === '2') {
            this.readonlyTimeSet = true;
          } else {
            this.readonlyTimeSet = false;
          }
        }
      } else {
        //非编辑模式处理
        var Index = this.calenderDateList.findIndex(function (item) {
          return item.jobDate === _this4.selectedDay;
        });
        if (Index === -1) {
          this.timeFrom = '';
          this.timeTo = '';
          this.remark = '';
          return;
        }
        this.timeFrom = this.calenderDateList[Index].timeFrom;
        this.timeTo = this.calenderDateList[Index].timeTo;
        this.remark = this.calenderDateList[Index].remark;
      }
      //第一次进入编辑模式时改变flg
      if (this.isEditMode == true && this.firstEditClickFlg) {
        this.firstEditClickFlg = false;
      }
    },

    //单元格内容表示
    calendarCellcharacters: function calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/');
      var ret = '';
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(function (item) {
        return item.jobDate === thisDay;
      });
      if (Index !== -1) {
        var attendanceDiv = this.calenderDateList[Index].attendanceDiv;
        if (attendanceDiv && attendanceDiv === '0') {
          ret = this.icon_o;
        } else if (attendanceDiv && attendanceDiv === '2') {
          ret = this.icon_x;
        } else {
          ret = '';
        }
      } else {
        ret = '';
      }
      //编辑模式的场合，若列表中存在，以编辑模式的列表为主
      if (this.isEditMode) {
        //编辑模式处理
        var editIndex = this.updateList.findIndex(function (item) {
          return item.jobDate === thisDay;
        });
        if (editIndex !== -1) {
          var attendanceDiv = this.updateList[editIndex].attendanceDiv;
          if (attendanceDiv && (attendanceDiv === '' || attendanceDiv === '0')) {
            ret = this.icon_o;
          } else if (attendanceDiv && attendanceDiv === '2') {
            ret = this.icon_x;
          } else {
            ret = '';
          }
        }
      }
      return ret;
    },

    //单元格样式
    calendarCellCss: function calendarCellCss(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/');
      var Index = this.calenderDateList.findIndex(function (item) {
        return item.jobDate === thisDay;
      });
      if (Index !== -1) {
        if (this.calenderDateList[Index].jobDate <= this.strToDay) {
          return "cell_status_3";
        } else {
          var crewing = this.calenderDateList[Index].crewing;
          var crewingConf = this.calenderDateList[Index].crewingConf;
          if (crewing && crewing === '1' && crewingConf && crewingConf === '0') {
            return "cell_status_1";
          } else if (crewingConf && crewingConf === '1') {
            return "cell_status_2";
          } else {
            // return "cell_status_3"
          }
        }
      } else {
          //white
        }
    },

    //申请イベント
    applyClick: function applyClick() {
      var _this5 = this;

      //没有更新数据的场合
      if (this.updateList.length <= 0) {
        //月別全入力チェック
        for (var i = 0; i < this.calenderDateList.length; i++) {
          var item = this.calenderDateList[i];
          if (item.attendanceDiv === '' && item.jobDate > this.strToDay) {
            this.$message.error({ message: this.$t('MODULE.S0001_TAB_MSG3'), showClose: true });
            return;
          }
        }
        // 保存处理
        this.$confirm(this.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(function () {
          _this5.$message.success({ message: _this5.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
          _this5.isEditMode = false;
          _this5.firstEditClickFlg = true;
          _this5.passedDateFlg = false;
        }).catch(function () {
          // いいえ
        });
      } else {
        var param = [];
        for (var i = 0; i < this.updateList.length; i++) {
          var item = this.updateList[i];
          //時間帯 46:00以上チェック
          if (item.timeFrom !== '' && item.timeFrom > '46:00' || item.timeTo !== '' && item.timeTo > '46:00') {
            this.$message.error({ message: this.toStrToDay(item.jobDate) + this.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true });
            return;
          }
          //時間帯 時間From＜時間Toチェック
          if (item.timeTo !== '' && item.timeFrom !== '' && item.timeFrom >= item.timeTo) {
            this.$message.error({ message: this.toStrToDay(item.jobDate) + this.$t('MODULE.S0001_TAB_MSG1'), showClose: true });
            return;
          }

          var tempObj = {
            "month": this.selectedMonth,
            "salesOfficeCd": this.login_officeCd,
            "userId": this.login_userCd,
            "jobDate": item.jobDate,
            "attendanceDiv": item.attendanceDiv !== '0' ? item.attendanceDiv : item.timeFrom !== '' || item.timeTo !== '' ? '1' : '0',
            "timeFrom": item.timeFrom,
            "timeTo": item.timeTo,
            "remark": item.remark
          };
          param.push(tempObj);
        }
        // var errorFgl=false
        //月別全入力チェック
        for (var i = 0; i < this.calenderDateList.length; i++) {
          var item = this.calenderDateList[i];
          if (item.attendanceDiv === '' && item.jobDate > this.strToDay) {
            var Index = this.updateList.findIndex(function (edititem) {
              return edititem.jobDate === item.jobDate;
            });
            if (Index === -1) {
              this.$message.error({ message: this.$t('MODULE.S0001_TAB_MSG3'), showClose: true });
              return;
            } else if (this.updateList[Index].attendanceDiv === '') {
              this.$message.error({ message: this.$t('MODULE.S0001_TAB_MSG3'), showClose: true });
              return;
            }
          }
        }
        // 保存处理
        this.$confirm(this.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(function () {
          // 更新処理
          s_0001_s0001Tab1_update(param).then(function (res) {
            if (res.code === 202) {
              //更新成功
              _this5.$message.success({ message: _this5.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
              _this5.updateList = undefined;
              _this5.updateList = new Array();
              _this5.isEditMode = false;
              _this5.firstEditClickFlg = true;
              _this5.passedDateFlg = false;
              _this5.query();
            } else if (res.code === 433) {
              //shift lock error
              _this5.$message.warning({ message: _this5.$t('COMMON.MSG_SHIFT_LOCK'), showClose: true });
            } else if (res.code === 311) {
              _this5.$message.error({ message: _this5.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
            }
            // this.res_code_back(res)
          });
        }).catch(function () {
          // いいえ
        });
      }
    },

    //キャンセルイベント
    strDoSelectClean: function strDoSelectClean() {
      var _this6 = this;

      if (this.isEditMode == true) {
        if (this.updateList.length > 0) {
          this.$confirm(this.$t('COMMON.MSG_TAB_CHANGE'), { // 変更があります。破棄しますか。
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true
          }).then(function () {
            _this6.updateList = undefined;
            _this6.updateList = new Array();
            _this6.isEditMode = false;
            _this6.firstEditClickFlg = true;
            _this6.passedDateFlg = false;
            if (document.querySelector(".calenderMode1-calendar .is-selected") !== null) {
              document.querySelector(".calenderMode1-calendar .is-selected").classList.remove('is-selected');
            }
            _this6.selectedDay = '';
          }).catch(function () {
            // いいえ
          });
        } else {
          this.updateList = undefined;
          this.updateList = new Array();
          this.isEditMode = false;
          this.firstEditClickFlg = true;
          this.passedDateFlg = false;
          if (document.querySelector(".calenderMode1-calendar .is-selected") !== null) {
            document.querySelector(".calenderMode1-calendar .is-selected").classList.remove('is-selected');
          }
          this.selectedDay = '';
        }
      }
    },

    //点击后失去焦点(用于按钮还原)
    handleClick: function handleClick(e) {
      var target = e.target;
      target.blur();
    },

    //リストで重複データを除く
    // unique(arr) {
    //   const res = new Map();
    //   return arr.filter((arr) => !res.has(arr.selectData) && res.set(arr.selectData, 1));
    // },
    //タッチstart
    touchStart: function touchStart(in_date) {
      var _this7 = this;

      this.longPress = false;
      // var thisDay = in_date.day
      // var thisDayType = in_date.type
      clearTimeout(this.loop); //再次清空定时器，防止重复注册定时器
      //编辑模式以外时进入计时器
      // if (this.isEditMode == false) {
      //   this.loop = setTimeout(() => {
      //     console.log('touchStart 1')
      //     //计时成功后再次判断是否是编辑模式
      //     if (this.isEditMode == false && this.shiftLockFlg === '0') {
      //        this.longPress=true
      //          console.log('touchStart 2')
      //     //  this.isEditMode = true
      //       return false
      //     } else {
      //       //无处理
      //     }
      //   }, 500);
      // }


      this.loop = setTimeout(function () {
        _this7.longPress = true;
      }, 500);
    },

    //タッチend
    touchEnd: function touchEnd(in_date) {
      clearTimeout(this.loop); //清空定时器，防止重复注册定时器
      if (this.touchmoveFlag == false) {
        if (this.isEditMode == false && this.longPress == true && this.shiftLockFlg === '0') {
          this.isEditMode = true;
        }
        this.longPress = false;
        this.dateCellClick(in_date.day);
      }
      this.touchmoveFlag = false;
    },

    //タッチmove
    touchMove: function touchMove() {
      this.touchmoveFlag = true;
    }
  },
  computed: {
    //selectedMonth->selectedMonthStr yyyymm->yyyy年mm月
    selectedMonthStr: function selectedMonthStr() {
      return this.selectedMonth.substring(0, 4) + '年' + this.selectedMonth.substring(4, 7) + '月';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e1a3170","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/s_0001_tab1.vue
var s_0001_tab1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s0001tab1Class",staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-row',{attrs:{"type":"flex","align":"bottom"}},[_c('el-col',{attrs:{"span":9,"align":"middle"}},[_c('span',[_vm._v(_vm._s(_vm.selectedMonthStr))])]),_vm._v(" "),_c('el-col',{staticStyle:{"font-size":"0"},attrs:{"span":14,"align":"right"}},[_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.preMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_PREMONTH')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.todayClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TODAY')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.nextMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_NEXTMONTH')))])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"6px"}},[_c('el-col',{attrs:{"span":8,"align":"left"}},[(_vm.shiftLockFlg_out_object=='1')?_c('span',{staticStyle:{"font-size":"10px","color":"red","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_LOCKED_OUT_OBJECT')))]):(_vm.shiftLockFlg_done=='1')?_c('span',{staticStyle:{"font-size":"10px","color":"red","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_LOCKED_DONE')))]):_c('span',[_vm._v("   ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":16,"align":"right"}},[_c('el-radio-group',{on:{"change":_vm.radioChange},model:{value:(_vm.calenderMode_radio),callback:function ($$v) {_vm.calenderMode_radio=$$v},expression:"calenderMode_radio"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_RADIO_CALENDER')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_RADIO_LIST')))])],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"6px"}},[_c('el-card',{staticStyle:{"border":"0px","margin-top":"4px","background-color":"#ffffff","font-size":"13px"},attrs:{"align":"left","shadow":"never","body-style":{ padding:'4px 2px 4px 2px' }}},[_c('span',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB1_LONG_ATTENTION')))])])],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.calenderMode==1),expression:"calenderMode==1"}],staticClass:"calenderMode1-calendar",staticStyle:{"text-align":"center","margin-top":"2px"}},[_c('div',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('el-calendar',{ref:"elCalendar",attrs:{"firstDayOfWeek":7},scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',{staticClass:"el-calendar-day",class:_vm.calendarCellCss(data),attrs:{"slot":"reference"},on:{"touchmove":function($event){return _vm.touchMove()},"touchstart":function($event){return _vm.touchStart(data)},"touchend":function($event){return _vm.touchEnd(data)}},slot:"reference"},[_c('div',{domProps:{"innerHTML":_vm._s(data.day.split('-')[2])}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.calendarCellcharacters(data))}})])]}}]),model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})],1),_vm._v(" "),_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDay),expression:"selectedDay"}],staticStyle:{"margin-top":"4px","background-color":"#23b2e8","color":"#ffffff"},attrs:{"align":"left","shadow":"always","body-style":{ padding:'4px 2px 4px 2px' }}},[_c('span',[_vm._v("・"+_vm._s(_vm.toStrToDay2(this.selectedDay)))])]),_vm._v(" "),_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.calenderMode==1&&_vm.selectedDay!==''),expression:"calenderMode==1&&selectedDay!==''"}],staticStyle:{"margin-top":"0px","background-color":"#f7fbfc"},attrs:{"shadow":"always","body-style":{ padding:'4px 2px 4px 2px' }}},[_c('el-row',[_c('el-col',{attrs:{"span":10,"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_TITTLE_ATTENTIMELONG')))])]),_vm._v(" "),_c('el-col',{attrs:{"span":6,"align":"left"}},[_c('el-input',{ref:"timeFrom",class:!_vm.isEditMode||_vm.readonlyTimeSet||_vm.passedDateFlg?'card-css-input-readonly':'card-css-input',attrs:{"size":"small","readonly":_vm.shiftLockFlg==='1'||!_vm.isEditMode||_vm.readonlyTimeSet||_vm.passedDateFlg,"pattern":"\\d*"},on:{"blur":function($event){return _vm.cal1_inputBlur($event,'timeFrom')}},nativeOn:{"input":function($event){return _vm.timeInputCheck($event)}},model:{value:(_vm.timeFrom),callback:function ($$v) {_vm.timeFrom=$$v},expression:"timeFrom"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":2,"align":"center"}},[_c('span',[_vm._v("~")])]),_vm._v(" "),_c('el-col',{attrs:{"span":6,"align":"right"}},[_c('el-input',{ref:"timeTo",class:!_vm.isEditMode||_vm.readonlyTimeSet||_vm.passedDateFlg?'card-css-input-readonly':'card-css-input',attrs:{"size":"small","readonly":_vm.shiftLockFlg==='1'||!_vm.isEditMode||_vm.readonlyTimeSet||_vm.passedDateFlg,"pattern":"\\d*"},on:{"blur":function($event){return _vm.cal1_inputBlur($event,'timeTo')}},nativeOn:{"input":function($event){return _vm.timeInputCheck($event)}},model:{value:(_vm.timeTo),callback:function ($$v) {_vm.timeTo=$$v},expression:"timeTo"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"3px"}},[_c('el-col',{attrs:{"span":4,"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_TITTLE_READY')))])]),_vm._v(" "),_c('el-col',{attrs:{"span":20,"align":"center"}},[_c('el-row',[_c('el-input',{ref:"remark",class:!_vm.isEditMode||_vm.passedDateFlg?'card-css-input-readonly':'card-css-input',attrs:{"maxlength":"200","type":"textarea","rows":2,"size":"small","readonly":_vm.shiftLockFlg==='1'||!_vm.isEditMode||_vm.passedDateFlg},on:{"blur":function($event){return _vm.cal1_inputBlur($event,'remark')}},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.calenderMode==2),expression:"calenderMode==2"}],ref:"calenderMode2calendar",staticClass:"calenderMode2-calendar",staticStyle:{"text-align":"center","margin-top":"2px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.calenderMode2DateList,"border":"","stripe":"","row-style":_vm.calenderMode2calendarCss}},[_c('el-table-column',{attrs:{"prop":"jobDate","label":_vm.$t('MODULE.S0001_LBL_JOBDATE'),"width":"60","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.toStrToDay(scope.row.jobDate)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"attendanceDiv","label":_vm.$t('MODULE.S0001_LBL_ATTENDANCEDIV'),"width":"60"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.shiftLockFlg==='0'&&scope.row.jobDate>_vm.strToDay)?_c('el-select',{on:{"change":function($event){return _vm.cal2_attendanceDivChangeEvent($event,'attendanceDiv',scope.row.jobDate,scope.$index,scope.row.attendanceDiv)}},model:{value:(scope.row.attendanceDiv),callback:function ($$v) {_vm.$set(scope.row, "attendanceDiv", $$v)},expression:"scope.row.attendanceDiv"}},[_c('el-option',{attrs:{"label":_vm.icon_o,"value":"0"}},[_vm._v(_vm._s(_vm.icon_o))]),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.icon_x,"value":"2"}},[_vm._v(_vm._s(_vm.icon_x))])],1):_c('span',[(scope.row.attendanceDiv=='0')?_c('span',[_vm._v(_vm._s(_vm.icon_o))]):_vm._e(),_vm._v(" "),(scope.row.attendanceDiv=='2')?_c('span',[_vm._v(_vm._s(_vm.icon_x))]):_vm._e()])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('MODULE.S0001_LBL_TIMELONG'),"prop":"timeLong","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.shiftLockFlg==='0'&&scope.row.jobDate>_vm.strToDay)?_c('el-input',{staticStyle:{"width":"40%"},attrs:{"disabled":scope.row.attendanceDiv==='2',"pattern":"\\d*"},on:{"blur":function($event){return _vm.cal2_inputBlur($event,'timeFrom',scope.row.jobDate,scope.$index)}},nativeOn:{"input":function($event){return _vm.timeInputCheck($event)}},model:{value:(scope.row.timeFrom),callback:function ($$v) {_vm.$set(scope.row, "timeFrom", $$v)},expression:"scope.row.timeFrom"}}):_c('span',[_vm._v(_vm._s(scope.row.timeFrom))]),_vm._v(" "),_c('span',[_vm._v("~")]),_vm._v(" "),(_vm.shiftLockFlg==='0'&&scope.row.jobDate>_vm.strToDay)?_c('el-input',{staticStyle:{"width":"40%"},attrs:{"disabled":scope.row.attendanceDiv==='2',"pattern":"\\d*"},on:{"blur":function($event){return _vm.cal2_inputBlur($event,'timeTo',scope.row.jobDate,scope.$index)}},nativeOn:{"input":function($event){return _vm.timeInputCheck($event)}},model:{value:(scope.row.timeTo),callback:function ($$v) {_vm.$set(scope.row, "timeTo", $$v)},expression:"scope.row.timeTo"}}):_c('span',[_vm._v(_vm._s(scope.row.timeTo))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('MODULE.S0001_LBL_READY'),"prop":"remark"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.shiftLockFlg==='0'&&scope.row.jobDate>_vm.strToDay)?_c('el-input',{on:{"blur":function($event){return _vm.cal2_inputBlur($event,'remark',scope.row.jobDate,scope.$index)}},model:{value:(scope.row.remark),callback:function ($$v) {_vm.$set(scope.row, "remark", $$v)},expression:"scope.row.remark"}}):_c('span',[_vm._v(_vm._s(scope.row.remark))])]}}])})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"8px"}},[_c('el-col',{staticStyle:{"margin-left":"15px"},attrs:{"span":24,"align":"center"}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.passedDateFlg&&_vm.shiftLockFlg==='0'&&((this.calenderMode === '2')||_vm.isEditMode)),expression:"!passedDateFlg&&shiftLockFlg==='0'&&((this.calenderMode === '2')||isEditMode)"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.handleClick},nativeOn:{"click":function($event){return _vm.applyClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_APPLY')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEditMode&&(this.calenderMode === '1')),expression:"isEditMode&&(this.calenderMode === '1')"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"30%"},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.strDoSelectClean.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_CANCEL')))])],1)],1)],1)}
var s_0001_tab1_staticRenderFns = []
var s_0001_tab1_esExports = { render: s_0001_tab1_render, staticRenderFns: s_0001_tab1_staticRenderFns }
/* harmony default export */ var page_s_0001_tab1 = (s_0001_tab1_esExports);
// CONCATENATED MODULE: ./src/module/page/s_0001_tab1.vue
function s_0001_tab1_injectStyle (ssrContext) {
  __webpack_require__("vSyV")
}
var s_0001_tab1_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var s_0001_tab1___vue_template_functional__ = false
/* styles */
var s_0001_tab1___vue_styles__ = s_0001_tab1_injectStyle
/* scopeId */
var s_0001_tab1___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var s_0001_tab1___vue_module_identifier__ = null
var s_0001_tab1_Component = s_0001_tab1_normalizeComponent(
  s_0001_tab1,
  page_s_0001_tab1,
  s_0001_tab1___vue_template_functional__,
  s_0001_tab1___vue_styles__,
  s_0001_tab1___vue_scopeId__,
  s_0001_tab1___vue_module_identifier__
)

/* harmony default export */ var module_page_s_0001_tab1 = (s_0001_tab1_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/s_0001_tab2.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var s_0001_tab2_url = __webpack_require__("kspH");

/* harmony default export */ var s_0001_tab2 = ({
  // name: "Map",
  data: function data() {
    return {
      calenderDateList: [], //calender1表示用list
      selectedMonth: '', //当前月（字符串格式）
      selectedDay: '', //当前点击的日期（字符串格式）
      calenderMode: '1', //1：calender表示，2：list表示
      login_officeCd: '', //登陆者所属officecd
      login_userCd: '', //登陆者cd
      icon_o: '〇',
      icon_v: '✔',
      weekStr: [], //一周的文言
      tabsIndex: '',
      //add
      showConfirmBtn: false,
      clickDayInfo: [] //点击一天的详细list
    };
  },
  mounted: function mounted() {

    //カレンダーのセルセット
    var calendarThead = document.querySelector(".s0001tab2Class .el-calendar-table thead");
    calendarThead.childNodes[0].style.color = "red";
    calendarThead.childNodes[6].style.color = "blue";
    this.weekStr[0] = this.$t('MODULE.S0001_LBL_CALENDAR_SUN');
    this.weekStr[1] = this.$t('MODULE.S0001_LBL_CALENDAR_MON');
    this.weekStr[2] = this.$t('MODULE.S0001_LBL_CALENDAR_TUE');
    this.weekStr[3] = this.$t('MODULE.S0001_LBL_CALENDAR_WED');
    this.weekStr[4] = this.$t('MODULE.S0001_LBL_CALENDAR_THU');
    this.weekStr[5] = this.$t('MODULE.S0001_LBL_CALENDAR_FRI');
    this.weekStr[6] = this.$t('MODULE.S0001_LBL_CALENDAR_SAT');

    for (var i = 0; i < 7; i++) {
      calendarThead.childNodes[i].innerHTML = this.weekStr[i];
    }

    var calendarTbody = document.querySelector(".s0001tab2Class .el-calendar-table tbody");
    var calendarTbodyChildren = calendarTbody.children;
    var calendarTbodyChildrenChildren;
    for (var i = 0; i < calendarTbodyChildren.length; i++) {
      calendarTbodyChildrenChildren = calendarTbody.children[i];
      if (i % 2 != 0) {
        calendarTbodyChildrenChildren.style.background = "#f7fbfc";
      }
    }
  },

  created: function created() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.login_officeCd = userInfo.officeCd;
    this.login_userCd = userInfo.userCd;
    this.selectedMonth = this.dateFormart(new Date(), 'yyyymm');
    this.query();
  },
  methods: {
    refreshTab: function refreshTab() {
      console.log(111);
    },


    //获得tabsindex
    getTabsIndex: function getTabsIndex(val) {
      this.tabsIndex = val;
    },

    //calender模式切换事件
    radioChange: function radioChange(val) {
      this.selectedDay = '';
      this.showConfirmBtn = false;
      this.clickDayInfo = undefined;
    },


    //日期字符串转化为 日（星期）
    toStrToDay: function toStrToDay(thisDay) {
      var theDate = new Date(thisDay);
      var myddy = theDate.getDay();
      return thisDay.substring(8, 10) + '(' + this.weekStr[myddy] + ')';
    },

    //日期字符串转化为 年月日（星期）
    toStrToDay2: function toStrToDay2(thisDay) {
      var theDate = new Date(thisDay);
      var myddy = theDate.getDay();
      return thisDay + '(' + this.weekStr[myddy] + ')';
    },

    // 検索
    query: function query() {
      var _this = this;

      var Params = {
        "month": this.selectedMonth,
        "page": 1,
        "size": 100
      };
      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 2000);
      // 検索処理
      s_0001_s0001Tab2_search(Params).then(function (res) {

        //初始化前清空
        _this.calenderDateList = undefined;
        _this.calenderDateList = new Array();
        _this.selectedDay = '';
        _this.showConfirmBtn = false;
        _this.clickDayInfo = undefined;
        if (res.code === 300) {
          //  this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          loading.close();
          return;
        } else {
          //更新基本list
          _this.calenderDateList = JSON.parse(stringify_default()(res.items.crewingSet));
        }
        loading.close();
      });
    },

    //日期转为字符串formartType='yyyymm'或'yyyymmdd'，
    dateFormart: function dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? '0' + M : M) + '-' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? '0' + M : M) + '/' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? '0' + M : M);
    },


    //前月翌月今日综合处理
    monthChange: function monthChange(val) {
      var _this2 = this;

      var getEl = this.$refs.elCalendar.$children[0].$children[val];
      //触发调转事件
      getEl.$el.click();
      this.$nextTick(function () {
        var calendarTitle = document.querySelector(".s0001tab2Class .el-calendar__header .el-calendar__title");
        var monthStr = calendarTitle.innerHTML;
        if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
          _this2.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16);
        } else {
          _this2.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15);
        }
        //刷新数据
        _this2.query();
        if (document.querySelector(".is-selected") !== null) {
          document.querySelector(".is-selected").classList.remove('is-selected');
        }
      });
    },

    //前月
    preMonthClick: function preMonthClick() {
      this.monthChange(0);
    },

    //今日
    todayClick: function todayClick() {
      this.monthChange(1);
    },

    //翌月
    nextMonthClick: function nextMonthClick() {
      this.monthChange(2);
    },


    //日期单元格点击事件。  参数空的场合，直接使用this.selectedDay
    dateCellClick: function dateCellClick(in_dateDay) {
      if (in_dateDay !== '') {
        this.selectedDay = in_dateDay.replace(/-/g, '/');
      }
      this.showConfirmBtn = false;
      this.clickDayInfo = undefined;
      this.clickDayInfo = new Array();
      var strToday = this.dateFormart(new Date(), 'yyyy/mm/dd');
      for (var i = 0; i < this.calenderDateList.length; i++) {
        var item = this.calenderDateList[i];
        if (item.jobDate === this.selectedDay) {
          this.clickDayInfo.push(item);
          if (this.selectedDay > strToday) {
            this.showConfirmBtn = true;
          }
        }
      }
    },

    //单元格内容表示
    calendarCellcharacters: function calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/');
      var ret = '';
      var set_icon_o = false;
      var set_icon_v = false;
      var count = 0;
      ////从数据表中检索这一天的数据
      this.calenderDateList.forEach(function (item) {
        if (item.jobDate === thisDay) {
          count = count + 1;
          if (item.crewingConf === '1') {
            set_icon_v = true;
          }
          if (item.crewing === '1') {
            set_icon_o = true;
          }
        }
      });
      if (count > 0) {
        if (set_icon_v == true) {
          ret = this.icon_v;
        } else if (set_icon_o == true) {
          ret = this.icon_o;
        } else {
          ret = '';
        }
      } else {
        ret = '';
      }
      return ret;
    },

    //cal2的cell样式
    HeaderClass: function HeaderClass(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return 'HeaderClass';
    },

    //cal2的head样式
    IsCellStyle: function IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return 'text-align:center;';
    },

    //cal2的head样式
    IsCellClass: function IsCellClass(_ref3) {
      var row = _ref3.row,
          rowIndex = _ref3.rowIndex;

      return 'IsCellClass';
    },

    //申请イベント
    applyClick: function applyClick() {
      var _this3 = this;

      var param = [];
      for (var i = 0; i < this.clickDayInfo.length; i++) {
        var item = this.clickDayInfo[i];
        var tempObj = {
          "jobDate": item.jobDate,
          "recNo": item.recNo
        };
        param.push(tempObj);
      }
      // 保存处理
      this.$confirm(this.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか。
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
        center: true
      }).then(function () {
        // 更新処理
        s_0001_s0001Tab2_update(param).then(function (res) {
          if (res.code === 202) {
            //更新成功
            _this3.$message.success({ message: _this3.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
            _this3.query();
          } else if (res.code === 433) {
            //shift lock error
            _this3.$message.warning({ message: _this3.$t('COMMON.MSG_SHIFT_LOCK'), showClose: true });
          } else if (res.code === 311) {
            _this3.$message.error({ message: _this3.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
          }
          // this.res_code_back(res)
        });
      }).catch(function () {
        // いいえ
      });
    }
  },
  computed: {
    //selectedMonth->selectedMonthStr yyyymm->yyyy年mm月
    selectedMonthStr: function selectedMonthStr() {
      return this.selectedMonth.substring(0, 4) + '年' + this.selectedMonth.substring(4, 7) + '月';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4201947a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/s_0001_tab2.vue
var s_0001_tab2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s0001tab2Class",staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-row',{attrs:{"type":"flex","align":"bottom"}},[_c('el-col',{attrs:{"span":9,"align":"middle"}},[_c('span',[_vm._v(_vm._s(_vm.selectedMonthStr))])]),_vm._v(" "),_c('el-col',{staticStyle:{"font-size":"0"},attrs:{"span":14,"align":"right"}},[_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.preMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_PREMONTH')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.todayClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TODAY')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.nextMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_NEXTMONTH')))])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"6px"}},[_c('el-col',{attrs:{"span":24,"align":"right"}},[_c('el-radio-group',{on:{"change":_vm.radioChange},model:{value:(_vm.calenderMode),callback:function ($$v) {_vm.calenderMode=$$v},expression:"calenderMode"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_RADIO_CALENDER')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_RADIO_LIST')))])],1)],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.calenderMode==1),expression:"calenderMode==1"}],staticClass:"calenderMode1-calendar",staticStyle:{"text-align":"center","margin-top":"8px"}},[_c('div',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('el-calendar',{ref:"elCalendar",attrs:{"firstDayOfWeek":7},scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',{staticClass:"el-calendar-day",attrs:{"slot":"reference"},on:{"click":function($event){return _vm.dateCellClick(data.day)}},slot:"reference"},[_c('div',{domProps:{"innerHTML":_vm._s(data.day.split('-')[2])}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.calendarCellcharacters(data))}})])]}}])})],1),_vm._v(" "),_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDay),expression:"selectedDay"}],staticStyle:{"margin-top":"4px","background-color":"#23b2e8","color":"#ffffff"},attrs:{"align":"left","shadow":"always","body-style":{ padding:'4px 2px 4px 2px' }}},[_c('span',[_vm._v("・"+_vm._s(_vm.toStrToDay2(this.selectedDay)))])]),_vm._v(" "),_vm._l((_vm.clickDayInfo),function(item,index){return [_c('el-card',{staticStyle:{"margin-top":"6px","background-color":"#f7fbfc"},attrs:{"shadow":"always","body-style":{ padding:'4px 2px 4px 2px' }}},[_c('table',{staticClass:"detailTable",attrs:{"width":"100%","border":"0","cellspacing":"0","cellpadding":"0"}},[_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_COMPANY_NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.companyName))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_STORE_NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.fieldName))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_STORE_IN')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.storeIn))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',{staticStyle:{"width":"70px"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_STORE_OUT')))]),_vm._v(" "),_c('td',{staticStyle:{"width":"90px"}},[_vm._v(_vm._s(item.storeOut))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_STORE_ADDRESS')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.storeAddress))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_BUSINESS_NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.serviceName))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_GATHER_PLACE')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.gatherPlace))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_STORE_MEMO')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.memo))])])])])]})],2),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.calenderMode==2),expression:"calenderMode==2"}],ref:"calenderMode2calendar",staticClass:"calenderMode2-calendar",staticStyle:{"margin-top":"8px"}},[_c('el-table',{attrs:{"data":_vm.calenderDateList,"border":"","stripe":"","cell-style":_vm.IsCellStyle,"header-row-class-name":_vm.HeaderClass,"cell-class-name":_vm.IsCellClass}},[_c('el-table-column',{attrs:{"prop":"jobDate","label":_vm.$t('MODULE.S0001_LBL_JOBDATE_BUSINESS_NAME'),"width":"110","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.toStrToDay(scope.row.jobDate))),_c('br'),_vm._v(_vm._s(scope.row.serviceName))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"attendanceDiv","align":"left","label":_vm.$t('MODULE.S0001_LBL_COMPANY_STORE_NAME')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"left"}},[_c('span',[_vm._v(_vm._s(scope.row.companyName)),_c('br'),_vm._v(_vm._s(scope.row.fieldName))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('MODULE.S0001_LBL_STORE_IN_OUT'),"prop":"timeLong","width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.storeIn)),_c('br'),_vm._v(_vm._s(scope.row.storeOut))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('MODULE.S0001_LBL_STORE_MEMO'),"prop":"remark","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"left"}},[_c('span',[_vm._v(_vm._s(scope.row.memo))])])]}}])})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"8px"}},[_c('el-col',{attrs:{"span":24,"align":"center"}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConfirmBtn),expression:"showConfirmBtn"}],staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.applyClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_CONFIRM')))])],1)],1)],1)}
var s_0001_tab2_staticRenderFns = []
var s_0001_tab2_esExports = { render: s_0001_tab2_render, staticRenderFns: s_0001_tab2_staticRenderFns }
/* harmony default export */ var page_s_0001_tab2 = (s_0001_tab2_esExports);
// CONCATENATED MODULE: ./src/module/page/s_0001_tab2.vue
function s_0001_tab2_injectStyle (ssrContext) {
  __webpack_require__("qjLl")
}
var s_0001_tab2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var s_0001_tab2___vue_template_functional__ = false
/* styles */
var s_0001_tab2___vue_styles__ = s_0001_tab2_injectStyle
/* scopeId */
var s_0001_tab2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var s_0001_tab2___vue_module_identifier__ = null
var s_0001_tab2_Component = s_0001_tab2_normalizeComponent(
  s_0001_tab2,
  page_s_0001_tab2,
  s_0001_tab2___vue_template_functional__,
  s_0001_tab2___vue_styles__,
  s_0001_tab2___vue_scopeId__,
  s_0001_tab2___vue_module_identifier__
)

/* harmony default export */ var module_page_s_0001_tab2 = (s_0001_tab2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/s_0001_tab3.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var s_0001_tab3_url = __webpack_require__("kspH");

/* harmony default export */ var s_0001_tab3 = ({
  // name: "Map",
  data: function data() {
    return {
      tabsIndex: '',
      calenderDateList: [], //calender1表示用list
      selectedMonth: '', //当前月（字符串格式）
      selectedDay: '', //当前点击的日期（字符串格式）
      calenderMode: '1', //1：calender表示，2：list表示
      login_officeCd: '', //登陆者所属officecd
      login_userCd: '', //登陆者cd
      icon_o: '〇',
      icon_v: '✔',
      weekStr: [], //一周的文言
      clickDayInfo: [], //点击一天的详细list
      detailDialogVisible: false, //详细dialog表示flg
      detailList: [] //详细dialog表示的list
    };
  },
  mounted: function mounted() {
    //カレンダーのセルセット
    var calendarThead = document.querySelector(".s0001tab3Class .el-calendar-table thead");
    calendarThead.childNodes[0].style.color = "red";
    calendarThead.childNodes[6].style.color = "blue";
    this.weekStr[0] = this.$t('MODULE.S0001_LBL_CALENDAR_SUN');
    this.weekStr[1] = this.$t('MODULE.S0001_LBL_CALENDAR_MON');
    this.weekStr[2] = this.$t('MODULE.S0001_LBL_CALENDAR_TUE');
    this.weekStr[3] = this.$t('MODULE.S0001_LBL_CALENDAR_WED');
    this.weekStr[4] = this.$t('MODULE.S0001_LBL_CALENDAR_THU');
    this.weekStr[5] = this.$t('MODULE.S0001_LBL_CALENDAR_FRI');
    this.weekStr[6] = this.$t('MODULE.S0001_LBL_CALENDAR_SAT');

    for (var i = 0; i < 7; i++) {
      calendarThead.childNodes[i].innerHTML = this.weekStr[i];
    }

    var calendarTbody = document.querySelector(".s0001tab3Class .el-calendar-table tbody");
    var calendarTbodyChildren = calendarTbody.children;
    var calendarTbodyChildrenChildren;
    for (var i = 0; i < calendarTbodyChildren.length; i++) {
      calendarTbodyChildrenChildren = calendarTbody.children[i];
      if (i % 2 != 0) {
        calendarTbodyChildrenChildren.style.background = "#f7fbfc";
      }
    }
  },

  created: function created() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.login_officeCd = userInfo.officeCd;
    this.login_userCd = userInfo.userCd;
    this.selectedMonth = this.dateFormart(new Date(), 'yyyymm');
    this.query();
  },
  methods: {
    //获得tabsindex
    getTabsIndex: function getTabsIndex(val) {
      this.tabsIndex = val;
    },

    //cal2 行点击事件
    calender2RowClick: function calender2RowClick(row) {
      var _this = this;

      this.detailDialogVisible = true;
      var Params = {
        "recNo": row.recNo,
        "month": this.selectedMonth,
        "jobDate": row.jobDate,
        "page": 1,
        "size": 100
        // 検索処理
      };s_0001_s0001Tab3_detail_search(Params).then(function (res) {
        // 初始化前清空
        _this.detailList = undefined;
        _this.detailList = new Array();
        // this.selectedDay = ''
        // this.clickDayInfo = undefined;
        if (res.code === 300) {
          //  this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          // loading.close()
          return;
        } else {

          //更新基本list
          _this.detailList = JSON.parse(stringify_default()(res.items.attendanceDetailSet));
        }
        // loading.close()
      });
    },

    //calender模式切换事件
    radioChange: function radioChange(val) {
      this.selectedDay = '';
      this.clickDayInfo = undefined;
    },


    //日期字符串转化为 日（星期）
    toStrToDay: function toStrToDay(thisDay) {
      var theDate = new Date(thisDay);
      var myddy = theDate.getDay();
      return thisDay.substring(8, 10) + '(' + this.weekStr[myddy] + ')';
    },

    //日期字符串转化为 年月日（星期）
    toStrToDay2: function toStrToDay2(thisDay) {
      var theDate = new Date(thisDay);
      var myddy = theDate.getDay();
      return thisDay + '(' + this.weekStr[myddy] + ')';
    },

    // 検索
    query: function query() {
      var _this2 = this;

      var Params = {
        "month": this.selectedMonth,
        "page": 1,
        "size": 100
      };
      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 2000);
      // 検索処理
      s_0001_s0001Tab3_search(Params).then(function (res) {
        // 初始化前清空
        _this2.calenderDateList = undefined;
        _this2.calenderDateList = new Array();
        _this2.selectedDay = '';
        _this2.clickDayInfo = undefined;
        if (res.code === 300) {
          //  this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          loading.close();
          return;
        } else {
          //更新基本list
          _this2.calenderDateList = JSON.parse(stringify_default()(res.items.attendanceSet));
        }
        loading.close();
      });
    },

    //日期转为字符串formartType='yyyymm'或'yyyymmdd'，
    dateFormart: function dateFormart(val, formartType) {
      var y = val.getFullYear();
      var M = val.getMonth() + 1;
      var d = val.getDate();
      if (formartType == 'yyyy-mm-dd') return y + '-' + (M < 10 ? '0' + M : M) + '-' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyy/mm/dd') return y + '/' + (M < 10 ? '0' + M : M) + '/' + (d < 10 ? '0' + d : d);
      if (formartType == 'yyyymm') return y + '' + (M < 10 ? '0' + M : M);
    },

    //详细情报格式化
    itemValueFormart: function itemValueFormart(item) {
      var ret;
      if (item.itemValue === null || item.itemValue === '') {
        ret = '0';
      } else {
        if (item.itemStyle === 'money') {
          //数字格式化为三位一个逗号
          ret = this.valueThreeFormart(item.itemValue);
        } else if (item.itemStyle === 'minute') {
          //分钟转时刻
          ret = this.minutesIntoTime(parseInt(item.itemValue));
        } else {
          ret = item.itemValue;
        }
      }
      return ret;
    },

    // 分钟转换成時刻
    minutesIntoTime: function minutesIntoTime(minutes) {
      var h = Math.floor(minutes / 60) < 10 ? '0' + Math.floor(minutes / 60) : Math.floor(minutes / 60);
      var m = minutes % 60 < 10 ? '0' + minutes % 60 : minutes % 60;
      return h + ':' + m;
    },

    //数字格式化为三位一个逗号
    valueThreeFormart: function valueThreeFormart(value) {
      if (value === '' || value === null) return '';
      var s = value;
      s = parseFloat(value).toLocaleString();
      return s;
    },

    //前月翌月今日综合处理
    monthChange: function monthChange(val) {
      var _this3 = this;

      var getEl = this.$refs.elCalendar.$children[0].$children[val];
      //触发调转事件
      getEl.$el.click();
      this.$nextTick(function () {
        var calendarTitle = document.querySelector(".s0001tab3Class .el-calendar__header .el-calendar__title");
        var monthStr = calendarTitle.innerHTML;
        if (monthStr.substring(15, 16) === '0' || monthStr.substring(15, 16) === '1' || monthStr.substring(15, 16) === '2') {
          _this3.selectedMonth = monthStr.substring(7, 11) + monthStr.substring(14, 16);
        } else {
          _this3.selectedMonth = monthStr.substring(7, 11) + '0' + monthStr.substring(14, 15);
        }
        //刷新数据
        _this3.query();
        if (document.querySelector(".is-selected") !== null) {
          document.querySelector(".is-selected").classList.remove('is-selected');
        }
      });
    },

    //前月
    preMonthClick: function preMonthClick() {
      this.monthChange(0);
    },

    //今日
    todayClick: function todayClick() {
      this.monthChange(1);
    },

    //翌月
    nextMonthClick: function nextMonthClick() {
      this.monthChange(2);
    },


    //日期单元格点击事件。  参数空的场合，直接使用this.selectedDay
    dateCellClick: function dateCellClick(in_dateDay) {
      if (in_dateDay !== '') {
        this.selectedDay = in_dateDay.replace(/-/g, '/');
      }
      this.clickDayInfo = undefined;
      this.clickDayInfo = new Array();
      for (var i = 0; i < this.calenderDateList.length; i++) {
        var item = this.calenderDateList[i];
        if (item.jobDate === this.selectedDay) {
          this.clickDayInfo.push(item);
        }
      }
    },

    //单元格内容表示
    calendarCellcharacters: function calendarCellcharacters(in_date) {
      var thisDay = in_date.day.replace(/-/g, '/');
      var ret = '';
      ////从数据表中检索这一天的数据
      var Index = this.calenderDateList.findIndex(function (item) {
        return item.jobDate === thisDay;
      });
      if (Index !== -1) {
        ret = this.icon_o;
      } else {
        ret = '';
      }
      return ret;
    },

    //cal2的cell样式
    HeaderClass: function HeaderClass(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return 'HeaderClass';
    },

    //cal2的head样式
    IsCellStyle: function IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return 'text-align:center;';
    },

    //cal2的head样式
    IsCellClass: function IsCellClass(_ref3) {
      var row = _ref3.row,
          rowIndex = _ref3.rowIndex;

      return 'IsCellClass';
    }
  },
  computed: {
    //selectedMonth->selectedMonthStr yyyymm->yyyy年mm月
    selectedMonthStr: function selectedMonthStr() {
      return this.selectedMonth.substring(0, 4) + '年' + this.selectedMonth.substring(4, 7) + '月';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a4978f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/s_0001_tab3.vue
var s_0001_tab3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s0001tab3Class",staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-row',{attrs:{"type":"flex","align":"bottom"}},[_c('el-col',{attrs:{"span":9,"align":"middle"}},[_c('span',[_vm._v(_vm._s(_vm.selectedMonthStr))])]),_vm._v(" "),_c('el-col',{staticStyle:{"font-size":"0"},attrs:{"span":14,"align":"right"}},[_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.preMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_PREMONTH')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.todayClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TODAY')))]),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#f7fbfc","margin-left":"0px","border-radius":"0px"},attrs:{"size":"small"},nativeOn:{"click":function($event){return _vm.nextMonthClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_NEXTMONTH')))])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"6px"}},[_c('el-col',{attrs:{"span":24,"align":"right"}},[_c('el-radio-group',{on:{"change":_vm.radioChange},model:{value:(_vm.calenderMode),callback:function ($$v) {_vm.calenderMode=$$v},expression:"calenderMode"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_RADIO_CALENDER')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_RADIO_LIST')))])],1)],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.calenderMode==1),expression:"calenderMode==1"}],staticClass:"calenderMode1-calendar",staticStyle:{"text-align":"center","margin-top":"8px"}},[_c('div',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('el-calendar',{ref:"elCalendar",attrs:{"firstDayOfWeek":7},scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',{staticClass:"el-calendar-day",attrs:{"slot":"reference"},on:{"click":function($event){return _vm.dateCellClick(data.day)}},slot:"reference"},[_c('div',{domProps:{"innerHTML":_vm._s(data.day.split('-')[2])}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.calendarCellcharacters(data))}})])]}}])})],1),_vm._v(" "),_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDay),expression:"selectedDay"}],staticStyle:{"margin-top":"4px","background-color":"#23b2e8","color":"#ffffff"},attrs:{"align":"left","shadow":"always","body-style":{ padding:'4px 2px 4px 2px' }}},[_c('span',[_vm._v("・"+_vm._s(_vm.toStrToDay2(this.selectedDay)))])]),_vm._v(" "),_vm._l((_vm.clickDayInfo),function(item,index){return [_c('el-card',{staticStyle:{"margin-top":"6px","background-color":"#f7fbfc"},attrs:{"shadow":"always","body-style":{ padding:'4px 2px 4px 2px' }}},[_c('table',{staticClass:"detailTable",attrs:{"width":"100%","border":"0","cellspacing":"0","cellpadding":"0"}},[_c('tr',{attrs:{"align":"left"}},[_c('td',{staticStyle:{"width":"50%"}},[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB3_STORE_IN')))]),_vm._v(" "),_c('td',{staticStyle:{"width":"50%"}},[_vm._v(_vm._s(item.storeIn))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB3_STORE_OUT')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.storeOut))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB3_BREAK_TIME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.breakTime))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB3_LATENIGHT_BREAK_TIME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.latenightBreakTime))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB3_WORK_TIME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.workTime))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB3_OVER_TIME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.overTime))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB3_HOURLY_WAGE')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.valueThreeFormart(item.hourlyWage)))])]),_vm._v(" "),_c('tr',{attrs:{"align":"left"}},[_c('td',[_vm._v(_vm._s(_vm.$t('MODULE.S0001_LBL_TAB3_TRANSPORT_FEE')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.valueThreeFormart(item.transportFee)))])])])])]})],2),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.calenderMode==2),expression:"calenderMode==2"}],ref:"calenderMode2calendar",staticClass:"calenderMode2-calendar",staticStyle:{"text-align":"center","margin-top":"8px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.calenderDateList,"border":"","stripe":"","cell-style":_vm.IsCellStyle,"header-row-class-name":_vm.HeaderClass,"cell-class-name":_vm.IsCellClass},on:{"row-click":_vm.calender2RowClick}},[_c('el-table-column',{attrs:{"prop":"jobDate","label":_vm.$t('MODULE.S0001_LBL_TAB3_JOBDATE'),"width":"60","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.toStrToDay(scope.row.jobDate)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"attendanceDiv","label":_vm.$t('MODULE.S0001_LBL_TAB3_STORE_IN_OUT'),"width":"65"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_c('span',[_vm._v(_vm._s(scope.row.storeIn)),_c('br'),_vm._v(_vm._s(scope.row.storeOut))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('MODULE.S0001_LBL_TAB3_LATENIGHT_AND_BREAK'),"prop":"timeLong","width":"68"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.breakTime)),_c('br'),_vm._v(_vm._s(scope.row.latenightBreakTime))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('MODULE.S0001_LBL_TAB3_WORK_OVER_TIME'),"prop":"remark","width":"68"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.workTime)),_c('br'),_vm._v(_vm._s(scope.row.overTime))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('MODULE.S0001_LBL_TAB3_HOURLY_WAGE_TRANSPORT_FEE'),"prop":"remark"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.valueThreeFormart(scope.row.hourlyWage))),_c('br'),_vm._v(_vm._s(_vm.valueThreeFormart(scope.row.transportFee)))])]}}])})],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"s0001tab3Dialog",attrs:{"title":"詳細情報","visible":_vm.detailDialogVisible,"width":"90%","append-to-body":true},on:{"update:visible":function($event){_vm.detailDialogVisible=$event}}},[_c('table',{staticClass:"cal2DetailTable",attrs:{"width":"100%","border":"0","cellspacing":"0","cellpadding":"0"}},[_vm._l((_vm.detailList),function(item,index){return [_c('tr',{attrs:{"align":"left"}},[_c('td',{staticStyle:{"width":"70%"}},[_vm._v(_vm._s(item.itemName))]),_vm._v(" "),_c('td',{staticStyle:{"width":"30%"}},[_vm._v(_vm._s(_vm.itemValueFormart(item)))])])]})],2)])],1)}
var s_0001_tab3_staticRenderFns = []
var s_0001_tab3_esExports = { render: s_0001_tab3_render, staticRenderFns: s_0001_tab3_staticRenderFns }
/* harmony default export */ var page_s_0001_tab3 = (s_0001_tab3_esExports);
// CONCATENATED MODULE: ./src/module/page/s_0001_tab3.vue
function s_0001_tab3_injectStyle (ssrContext) {
  __webpack_require__("+7Ds")
}
var s_0001_tab3_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var s_0001_tab3___vue_template_functional__ = false
/* styles */
var s_0001_tab3___vue_styles__ = s_0001_tab3_injectStyle
/* scopeId */
var s_0001_tab3___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var s_0001_tab3___vue_module_identifier__ = null
var s_0001_tab3_Component = s_0001_tab3_normalizeComponent(
  s_0001_tab3,
  page_s_0001_tab3,
  s_0001_tab3___vue_template_functional__,
  s_0001_tab3___vue_styles__,
  s_0001_tab3___vue_scopeId__,
  s_0001_tab3___vue_module_identifier__
)

/* harmony default export */ var module_page_s_0001_tab3 = (s_0001_tab3_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/s_0001.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var s_0001_url = __webpack_require__("kspH");
/* harmony default export */ var s_0001 = ({
  components: {
    s_0001tab1: module_page_s_0001_tab1,
    s_0001tab2: module_page_s_0001_tab2,
    s_0001tab3: module_page_s_0001_tab3
  },
  name: "Map",

  data: function data() {
    return {
      changePage: true,
      tabsIndex: 0,
      currentTabsIndex: 0

    };
  },
  mounted: function mounted() {
    // window.addEventListener("orientationchange", this.renderResize)//监控横竖屏事件
  },

  methods: {
    // renderResize() {
    //     if (window.orientation === 90 || window.orientation === -90) {
    //     // 横屏处理      
    //     } else {
    //     // 竖屏处理
    //     } 
    //     // 注意：renderResize方法执行时虚拟dom尚未渲染挂载，如果要操作vue实例，最好在this.$nextTick()里进行。
    // },
    tabChange: function tabChange(currentIndex, b) {
      this.currentTabsIndex = currentIndex;
      //tab切换后，隐藏其他tab的内容
      if (currentIndex == 0 && this.$refs.s_0001tab1) {
        this.$refs.s_0001tab1.getTabsIndex(currentIndex);
        this.$refs.s_0001tab1.$el.hidden = false;
        if (this.$refs.s_0001tab2) this.$refs.s_0001tab2.$el.hidden = true;
        if (this.$refs.s_0001tab3) this.$refs.s_0001tab3.$el.hidden = true;
      } else if (currentIndex == 1) {
        this.$refs.s_0001tab2.$el.hidden = false;
        if (this.$refs.s_0001tab1) this.$refs.s_0001tab1.$el.hidden = true;
        if (this.$refs.s_0001tab3) this.$refs.s_0001tab3.$el.hidden = true;
      } else if (currentIndex == 2) {
        this.$refs.s_0001tab3.$el.hidden = false;
        if (this.$refs.s_0001tab1) this.$refs.s_0001tab1.$el.hidden = true;
        if (this.$refs.s_0001tab2) this.$refs.s_0001tab2.$el.hidden = true;
      } else {
        //無処理
      }
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b059e3b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/s_0001.vue
var s_0001_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s0001Class",staticStyle:{"border":"0px solid red","height":"100%"}},[_c('vue-tabs-swiper',{ref:"tabSwiper",on:{"change":_vm.tabChange},model:{value:(_vm.tabsIndex),callback:function ($$v) {_vm.tabsIndex=$$v},expression:"tabsIndex"}},[_c('div',{attrs:{"tab-label":_vm.$t('MODULE.S0001_MAIN_TITTLE_TAB1')}},[_c('s_0001tab1',{ref:"s_0001tab1"})],1),_vm._v(" "),_c('div',{attrs:{"tab-label":_vm.$t('MODULE.S0001_MAIN_TITTLE_TAB2')}},[_c('s_0001tab2',{ref:"s_0001tab2"})],1),_vm._v(" "),_c('div',{attrs:{"tab-label":_vm.$t('MODULE.S0001_MAIN_TITTLE_TAB3')}},[_c('s_0001tab3',{ref:"s_0001tab3"})],1)])],1)}
var s_0001_staticRenderFns = []
var s_0001_esExports = { render: s_0001_render, staticRenderFns: s_0001_staticRenderFns }
/* harmony default export */ var page_s_0001 = (s_0001_esExports);
// CONCATENATED MODULE: ./src/module/page/s_0001.vue
function s_0001_injectStyle (ssrContext) {
  __webpack_require__("9UvG")
}
var s_0001_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var s_0001___vue_template_functional__ = false
/* styles */
var s_0001___vue_styles__ = s_0001_injectStyle
/* scopeId */
var s_0001___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var s_0001___vue_module_identifier__ = null
var s_0001_Component = s_0001_normalizeComponent(
  s_0001,
  page_s_0001,
  s_0001___vue_template_functional__,
  s_0001___vue_styles__,
  s_0001___vue_scopeId__,
  s_0001___vue_module_identifier__
)

/* harmony default export */ var module_page_s_0001 = (s_0001_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/d_0001.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var d_0001 = ({
  data: function data() {
    return {};
  },

  methods: {
    PdfDnld: function PdfDnld() {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0829d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/d_0001.vue
var d_0001_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"text-align":"left"}},[_c('el-col',[_c('p',{staticClass:"d0001_info"},[_vm._v(_vm._s(_vm.$t('MODULE.K0013_LBL_MESSAGE')))])])],1),_vm._v(" "),_c('table',{staticClass:"table_d0001",staticStyle:{"border-collapse":"collapse"}},[_c('tr',{staticClass:"d0001_table_title"},[_c('td',{staticClass:"d0001_table_header",staticStyle:{"border-right":"1px solid #dfdfdf","width":"20%"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0013_LBL_TITTLE')))]),_vm._v(" "),_c('td',{staticClass:"d0001_table_header",staticStyle:{"border-right":"1px solid #dfdfdf","width":"40%"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0013_LBL_FILE')))]),_vm._v(" "),_c('td',{staticClass:"d0001_table_header",staticStyle:{"border-left":"1px solid #dfdfdf","border-right":"1px solid #dfdfdf","width":"40%"}},[_vm._v(_vm._s(_vm.$t('MODULE.K0013_LBL_MEMO')))])]),_vm._v(" "),_c('tr',{staticClass:"d0001_table_list"},[_c('td',{staticClass:"input_d0001_table",staticStyle:{"border-left":"1px solid #dfdfdf","border-bottom":"1px solid #dfdfdf","border-right":"1px solid #dfdfdf","width":"20%"}},[_vm._v("test")]),_vm._v(" "),_c('td',{staticClass:"input_d0001_table",staticStyle:{"border-bottom":"1px solid #dfdfdf","border-right":"1px solid #dfdfdf","width":"40%"}},[_c('a',{attrs:{"href":"/static/test.pdf","download":"test.pdf"},on:{"click":_vm.PdfDnld}},[_vm._v("test")])]),_vm._v(" "),_c('td',{staticClass:"input_d0001_table",staticStyle:{"border-bottom":"1px solid #dfdfdf","border-right":"1px solid #dfdfdf","width":"40%"}},[_vm._v("test")])])])],1)}
var d_0001_staticRenderFns = []
var d_0001_esExports = { render: d_0001_render, staticRenderFns: d_0001_staticRenderFns }
/* harmony default export */ var page_d_0001 = (d_0001_esExports);
// CONCATENATED MODULE: ./src/module/page/d_0001.vue
function d_0001_injectStyle (ssrContext) {
  __webpack_require__("GYi8")
}
var d_0001_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var d_0001___vue_template_functional__ = false
/* styles */
var d_0001___vue_styles__ = d_0001_injectStyle
/* scopeId */
var d_0001___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var d_0001___vue_module_identifier__ = null
var d_0001_Component = d_0001_normalizeComponent(
  d_0001,
  page_d_0001,
  d_0001___vue_template_functional__,
  d_0001___vue_styles__,
  d_0001___vue_scopeId__,
  d_0001___vue_module_identifier__
)

/* harmony default export */ var module_page_d_0001 = (d_0001_Component.exports);

// CONCATENATED MODULE: ./src/module/api/p_0001.js


var p_0001_apiUrl = __webpack_require__("kspH");

// 給与照会 检索
var p_0001_p_0001 = function p_0001(params) {
  return api_public.requestQuickGet(p_0001_apiUrl.apiUrl_PaymentStatus + '?year=' + params.year + '&userCd=' + params.userCd);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/p_0001.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var p_0001_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var page_p_0001 = ({
  mixins: [css],
  data: function data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      list: [],
      fullscreenLoading: false,
      yearOpt: ''
    };
  },
  created: function created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // 初期化
    this.init();
    // 期間より検索
    this.query();
  },
  mounted: function mounted() {},

  methods: {
    // 初期化
    init: function init() {
      if (!(stringify_default()(this.$route.query) == "{}")) {
        this.yearOpt = JSON.parse(localStorage.getItem('P0001search_condition'));
      } else {
        var dt = new Date();
        this.yearOpt = dt.getFullYear().toString();
      }
      localStorage.setItem("P0001search_condition", stringify_default()(this.yearOpt));
    },
    query_btn_l: function query_btn_l(e) {
      var target = e.target;
      target.blur();
      this.yearOpt = (parseInt(this.yearOpt) - 1).toString();
      localStorage.setItem("P0001search_condition", stringify_default()(this.yearOpt));
      this.query();
    },
    query_btn_n: function query_btn_n(e) {
      var target = e.target;
      target.blur();
      this.yearOpt = (parseInt(this.yearOpt) + 1).toString();
      localStorage.setItem("P0001search_condition", stringify_default()(this.yearOpt));
      this.query();
    },
    changeYear: function changeYear() {
      localStorage.setItem("P0001search_condition", stringify_default()(this.yearOpt));
      this.query();
    },

    // 検索
    query: function query() {
      var _this = this;

      var params = {
        year: this.yearOpt,
        userCd: JSON.parse(localStorage.getItem('userInfo')).userCd
      };
      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // 検索処理
      p_0001_p_0001(params).then(function (res) {

        if (res.code == 300) {
          _this.$message.warning({ message: _this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
          _this.list = [];
        } else if (res.code == 204) {

          _this.list = res.items.paymentStatusSet;
          for (var i = 0; i < _this.list.length; i++) {
            if (_this.list[i].confirmDate == null || _this.list[i].confirmDate == "") {
              _this.list[i].confirmDate = "";
            }
          }
        }
        loading.close();
      }).catch(function (error) {
        loading.close();
      });
    },

    // TABLEHeader样式
    p0001HeaderStyle: function p0001HeaderStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:15px;text-align:center ';
    },

    // TABLE单元格样式
    p0001IsCellStyle: function p0001IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return 'text-align:center;fontSize:13px';
    },

    // 单击行事件
    p0001RowOnClick: function p0001RowOnClick(thisRowDate, column, cell, event) {
      if (thisRowDate.type == this.$t('MODULE.P0001_LBL_SALARY')) {
        //給与
        localStorage.setItem('obj', stringify_default()(thisRowDate));
        localStorage.setItem(p_0001_url.routerUrl_P0002, stringify_default()(true));
        this.$router.push({ path: p_0001_url.routerUrl_P0002 });
      } else if (thisRowDate.type == this.$t('MODULE.P0001_LBL_BONUS')) {
        //賞与
        localStorage.setItem('obj', stringify_default()(thisRowDate));
        localStorage.setItem(p_0001_url.routerUrl_P0003, stringify_default()(true));
        this.$router.push({ path: p_0001_url.routerUrl_P0003 });
      } else if (thisRowDate.type == this.$t('MODULE.P0001_LBL_SOURCE')) {
        //源泉
        localStorage.setItem('obj', stringify_default()(thisRowDate));
        localStorage.setItem(p_0001_url.routerUrl_P0004, stringify_default()(true));
        this.$router.push({ path: p_0001_url.routerUrl_P0004 });
      }
    },

    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    //前年按钮按下
    handleClickLastYear: function handleClickLastYear(e) {
      var target = e.target;
      target.blur();
    },

    //翌年按钮按下
    handleClickNextYear: function handleClickNextYear(e) {
      var target = e.target;
      target.blur();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e258796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/p_0001.vue
var p_0001_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-container',{staticStyle:{"padding":"0px","width":"100%","height":"100%"}},[_c('el-main',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('div',{staticClass:"search-module-k"},[_c('el-row',{staticStyle:{"padding-top":"5px","padding-left":"5px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('el-date-picker',{staticClass:"year_select",attrs:{"type":"year","value-format":"yyyy","size":"mini","clearable":false,"editable":false},on:{"change":_vm.changeYear},model:{value:(_vm.yearOpt),callback:function ($$v) {_vm.yearOpt=$$v},expression:"yearOpt"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"padding-left":"10px","padding-right":"10px"},attrs:{"span":6}},[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"css-button_p0001 css-btn_p0001",attrs:{"type":"primary","id":"last_year","size":"mini"},on:{"click":[_vm.handleClickLastYear,function($event){$event.stopPropagation();return _vm.query_btn_l.apply(null, arguments)}]}},[_vm._v(_vm._s(_vm.$t('MODULE.P0001_LBL_LASTYEAR')))])],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"padding-left":"10px","padding-right":"10px"},attrs:{"span":6}},[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"css-button_p0001 css-btn_p0001",attrs:{"type":"primary","id":"next_year","size":"mini"},on:{"click":[_vm.handleClickNextYear,function($event){$event.stopPropagation();return _vm.query_btn_n.apply(null, arguments)}]}},[_vm._v(_vm._s(_vm.$t('MODULE.P0001_LBL_NEXTYEAR')))])],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"3px","padding-bottom":"5px"}}),_vm._v(" "),_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA"},attrs:{"header-cell-style":_vm.p0001HeaderStyle,"cell-style":_vm.p0001IsCellStyle,"data":_vm.list,"border":"","size":"mini"},on:{"row-click":_vm.p0001RowOnClick}},[_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.P0001_LBL_COLUMN1'),"min-width":"40px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.paidDate.substring(scope.row.paidDate.indexOf('-')+1,scope.row.paidDate.length-3) + "月"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.P0001_LBL_COLUMN2'),"min-width":"50px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.type))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","label":_vm.$t('MODULE.P0001_LBL_COLUMN3'),"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.confirmDate.substring(0, 16).replace(new RegExp("-",'g'),"/")))])]}}])})],1)],1)],1)],1)}
var p_0001_staticRenderFns = []
var p_0001_esExports = { render: p_0001_render, staticRenderFns: p_0001_staticRenderFns }
/* harmony default export */ var module_page_p_0001 = (p_0001_esExports);
// CONCATENATED MODULE: ./src/module/page/p_0001.vue
function p_0001_injectStyle (ssrContext) {
  __webpack_require__("u4ma")
}
var p_0001_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_0001___vue_template_functional__ = false
/* styles */
var p_0001___vue_styles__ = p_0001_injectStyle
/* scopeId */
var p_0001___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var p_0001___vue_module_identifier__ = null
var p_0001_Component = p_0001_normalizeComponent(
  page_p_0001,
  module_page_p_0001,
  p_0001___vue_template_functional__,
  p_0001___vue_styles__,
  p_0001___vue_scopeId__,
  p_0001___vue_module_identifier__
)

/* harmony default export */ var src_module_page_p_0001 = (p_0001_Component.exports);

// CONCATENATED MODULE: ./src/module/api/p_0002.js


var p_0002_apiUrl = __webpack_require__("kspH");

// 給与明細 检索
var p_0002_p_0002Query = function p_0002Query(params) {
  return api_public.requestQuickGet(p_0002_apiUrl.apiUrl_PaymentDetail + '?type=' + params.type + '&paidDate=' + params.paidDate + '&userCd=' + params.userCd);
};
// 給与明細 確認情報保存
var p_0002_p_0002Save = function p_0002Save(params, userCd) {
  return api_public.requestPost(p_0002_apiUrl.apiUrl_PaymentStatus + '?userCd=' + userCd, params);
};
//PDFダウンロード
var p_0002_p_0002GetFile = function p_0002GetFile(photoPath) {
  return api_public.requestQuickGetImage(p_0002_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0');
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/p_0002.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var p_0002_url = __webpack_require__("kspH");
/* harmony default export */ var p_0002 = ({
  mixins: [css],
  components: {
    Pdf: components_page_pdf
  },
  data: function data() {
    return {
      title: '',
      type: '',
      yearMonthDay: '',
      itemsList: [],
      tableList: [],
      pdfFileUrl: '',
      //PDF
      viewVisible: false,
      pdfUrl: ''
    };
  },

  methods: {
    // 戻る処理
    back_click: function back_click() {
      var returnP0001Param = JSON.parse(localStorage.getItem('P0001search_condition'));
      var vm = this;
      vm.$router.push({ path: p_0002_url.routerUrl_P0001, query: returnP0001Param });
    },

    //PDFダウンロード
    download_click: function download_click() {
      var _this = this;

      if (this.pdfFileUrl != null && this.pdfFileUrl.length != 0) {
        this.set_loading();
        p_0002_p_0002GetFile(this.pdfFileUrl).then(function (res_file) {
          var fileUrl = {};
          var blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' });
          var url = window.URL.createObjectURL(blob);
          fileUrl.url = url;
          fileUrl.name = _this.pdfFileUrl;
          for (var index = 0; index < 2; index++) {
            fileUrl.name = fileUrl.name.substring(fileUrl.name.indexOf('/') + 1);
          }
          _this.download(fileUrl);
          _this.close_loading();
        }).catch(function (err) {
          //关闭loading
          _this.close_loading();
        });
      }
    },
    pdfClose: function pdfClose() {
      this.viewVisible = false;
    },

    //pdfダウンロード
    download: function download(file) {
      this.pdfUrl = file;
      this.viewVisible = true;
    }
  },
  // 初期化
  created: function created() {
    var _this2 = this;

    this.obj = JSON.parse(localStorage.getItem('obj'));
    //給与
    this.type = "1";
    this.title = this.obj.paidDate.slice(0, 4) + "年" + this.obj.paidDate.slice(5, 7) + "月" + " " + this.$t('MODULE.P0002_TITLE');
    this.yearMonthDay = JSON.parse(stringify_default()(this.obj.paidDate.replace(new RegExp("-", 'g'), "/")));

    var params = {
      paidDate: this.yearMonthDay,
      type: this.type,
      userCd: JSON.parse(localStorage.getItem('userInfo')).userCd
      //給与明細検索
    };p_0002_p_0002Query(params).then(function (res) {
      if (res.code == 300) {
        _this2.$message.warning({ message: _this2.$t('COMMON.NO_TARGET_DATA'), showClose: true });
        _this2.itemsList = [];
        return;
      } else if (res.code == 204) {
        _this2.itemsList = res.items.paymentDetailSet;
        _this2.pdfFileUrl = res.items.paymentPathSet[0].formPath;
        _this2.tableList = [];
        for (var i = 0; i < _this2.itemsList.length; i++) {
          var items_T = {
            itemId: _this2.itemsList[i].itemId,
            itemName: _this2.itemsList[i].itemTitle,
            itemValue: "TITLE"
          };
          _this2.tableList.push(items_T);
          for (var j = 0; j < _this2.itemsList[i].itemContent.length; j++) {
            //APIから「様式」には、「day」が場合、APIから「項目値」の後に、【日】を付ける
            if (_this2.itemsList[i].itemContent[j].itemStyle == "day" && _this2.itemsList[i].itemContent[j].itemValue != "" && _this2.itemsList[i].itemContent[j].itemValue != null) {
              _this2.itemsList[i].itemContent[j].itemValue = _this2.itemsList[i].itemContent[j].itemValue + "日";
            }
            //APIから「様式」には、「money」が場合、APIから「項目値」は、【999,999,999】
            if (_this2.itemsList[i].itemContent[j].itemStyle == "money" && _this2.itemsList[i].itemContent[j].itemValue != "" && _this2.itemsList[i].itemContent[j].itemValue != null && _this2.itemsList[i].itemContent[j].itemValue.toString().length > 3) {
              _this2.itemsList[i].itemContent[j].itemValue = _this2.itemsList[i].itemContent[j].itemValue.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            }
            var items_V = {
              itemId: _this2.itemsList[i].itemContent[j].itemId,
              itemName: _this2.itemsList[i].itemContent[j].itemName,
              itemValue: _this2.itemsList[i].itemContent[j].itemValue
            };
            _this2.tableList.push(items_V);
          }
        }
        //給与確認情報保存
        p_0002_p_0002Save(params, JSON.parse(localStorage.getItem('userInfo')).userCd).then(function (res) {
          if (res.code != 202) {
            _this2.$message.error({ message: _this2.$t('COMMON.CURD_ERROR'), showClose: true });
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ccb78d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/p_0002.vue
var p_0002_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_p0002"},[_c('div',{staticClass:"search-module_p0002"}),_vm._v(" "),_c('div',{staticClass:"el-detail_p0002"},[_c('el-row',[_c('div',{staticClass:"table-header"},[_c('span',[_vm._v(_vm._s(this.title))])])]),_vm._v(" "),_c('el-row',{staticStyle:{"padding-bottom":"10px"}},[_c('table',{staticClass:"p0002-table table-label"},_vm._l((_vm.tableList),function(item,index){return _c('tr',[(item.itemValue == 'TITLE')?_c('td',{staticClass:"table-header",attrs:{"colspan":"3"}},[_vm._v(_vm._s(item.itemName))]):_vm._e(),_vm._v(" "),(item.itemValue != 'TITLE')?_c('td',{staticClass:"p0002-form-label"},[_vm._v(_vm._s(item.itemName))]):_vm._e(),_vm._v(" "),((item.itemValue == null || item.itemValue == '') && item.itemValue != 'TITLE')?_c('td',{staticClass:"p0002-form-value"}):_vm._e(),_vm._v(" "),((item.itemValue != null && item.itemValue != '') && item.itemValue != 'TITLE')?_c('td',{staticClass:"p0002-form-value"},[_vm._v(_vm._s(item.itemValue))]):_vm._e()])}),0)])],1),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-left":"25px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))]),_vm._v(" "),(this.pdfFileUrl)?_c('i',{staticClass:"el-icon-document",staticStyle:{"margin-top":"4px","margin-right":"10px","font-size":"30px","color":"#409eff","float":"right"},on:{"click":_vm.download_click}}):_vm._e()],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"fullscreen":"","visible":_vm.viewVisible,"close-on-click-modal":false,"show-close":false,"width":"100%","top":"52px","height":"120%"},on:{"update:visible":function($event){_vm.viewVisible=$event}}},[_c('Pdf',{attrs:{"src":_vm.pdfUrl},on:{"pdfClose":_vm.pdfClose}})],1)],1)}
var p_0002_staticRenderFns = []
var p_0002_esExports = { render: p_0002_render, staticRenderFns: p_0002_staticRenderFns }
/* harmony default export */ var page_p_0002 = (p_0002_esExports);
// CONCATENATED MODULE: ./src/module/page/p_0002.vue
function p_0002_injectStyle (ssrContext) {
  __webpack_require__("71Nj")
}
var p_0002_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_0002___vue_template_functional__ = false
/* styles */
var p_0002___vue_styles__ = p_0002_injectStyle
/* scopeId */
var p_0002___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var p_0002___vue_module_identifier__ = null
var p_0002_Component = p_0002_normalizeComponent(
  p_0002,
  page_p_0002,
  p_0002___vue_template_functional__,
  p_0002___vue_styles__,
  p_0002___vue_scopeId__,
  p_0002___vue_module_identifier__
)

/* harmony default export */ var module_page_p_0002 = (p_0002_Component.exports);

// CONCATENATED MODULE: ./src/module/api/p_0003.js


var p_0003_apiUrl = __webpack_require__("kspH");

// 賞与明細 检索
var p_0003_p_0003Query = function p_0003Query(params) {
  return api_public.requestQuickGet(p_0003_apiUrl.apiUrl_PaymentDetail + '?type=' + params.type + '&paidDate=' + params.paidDate + '&userCd=' + params.userCd);
};
// 賞与明細 確認情報保存
var p_0003_p_0003Save = function p_0003Save(params, userCd) {
  return api_public.requestPost(p_0003_apiUrl.apiUrl_PaymentStatus + '?userCd=' + userCd, params);
};
//PDFダウンロード
var p_0003_p_0003GetFile = function p_0003GetFile(photoPath) {
  return api_public.requestQuickGetImage(p_0003_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0');
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/p_0003.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var p_0003_url = __webpack_require__("kspH");
/* harmony default export */ var p_0003 = ({
  mixins: [css],
  components: {
    Pdf: components_page_pdf
  },
  data: function data() {
    return {
      title: '',
      type: '',
      yearMonthDay: '',
      itemsList: [],
      tableList: [],
      pdfFileUrl: '',
      //PDF
      viewVisible: false,
      pdfUrl: ''
    };
  },

  methods: {
    // 戻る処理
    back_click: function back_click() {
      var returnP0001Param = JSON.parse(localStorage.getItem('P0001search_condition'));
      var vm = this;
      vm.$router.push({ path: p_0003_url.routerUrl_P0001, query: returnP0001Param });
    },

    //PDFダウンロード
    download_click: function download_click() {
      var _this = this;

      if (this.pdfFileUrl != null && this.pdfFileUrl.length != 0) {
        this.set_loading();
        p_0003_p_0003GetFile(this.pdfFileUrl).then(function (res_file) {
          var fileUrl = {};
          var blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' });
          var url = window.URL.createObjectURL(blob);
          fileUrl.url = url;
          fileUrl.name = _this.pdfFileUrl;
          for (var index = 0; index < 2; index++) {
            fileUrl.name = fileUrl.name.substring(fileUrl.name.indexOf('/') + 1);
          }
          _this.download(fileUrl);
          _this.close_loading();
        }).catch(function (err) {
          //关闭loading
          _this.close_loading();
        });
      }
    },
    pdfClose: function pdfClose() {
      this.viewVisible = false;
    },

    //pdfダウンロード
    download: function download(file) {
      this.pdfUrl = file;
      this.viewVisible = true;
    }
  },
  // 初期化
  created: function created() {
    var _this2 = this;

    this.obj = JSON.parse(localStorage.getItem('obj'));
    //賞与
    this.type = "2";
    this.title = this.obj.paidDate.slice(0, 4) + "年" + this.obj.paidDate.slice(5, 7) + "月" + " " + this.$t('MODULE.P0003_TITLE');
    this.yearMonthDay = JSON.parse(stringify_default()(this.obj.paidDate.replace(new RegExp("-", 'g'), "/")));

    var params = {
      paidDate: this.yearMonthDay,
      type: this.type,
      userCd: JSON.parse(localStorage.getItem('userInfo')).userCd

      //給与明細検索
    };p_0003_p_0003Query(params).then(function (res) {
      if (res.code == 300) {
        _this2.$message.warning({ message: _this2.$t('COMMON.NO_TARGET_DATA'), showClose: true });
        _this2.itemsList = [];
        return;
      } else if (res.code == 204) {
        _this2.itemsList = res.items.paymentDetailSet;
        _this2.pdfFileUrl = res.items.paymentPathSet[0].formPath;
        _this2.tableList = [];
        for (var i = 0; i < _this2.itemsList.length; i++) {
          var items_T = {
            itemId: _this2.itemsList[i].itemId,
            itemName: _this2.itemsList[i].itemTitle,
            itemValue: "TITLE"
          };
          _this2.tableList.push(items_T);
          for (var j = 0; j < _this2.itemsList[i].itemContent.length; j++) {
            //APIから「様式」には、「day」が場合、APIから「項目値」の後に、【日】を付ける
            if (_this2.itemsList[i].itemContent[j].itemStyle == "day" && _this2.itemsList[i].itemContent[j].itemValue != "" && _this2.itemsList[i].itemContent[j].itemValue != null) {
              _this2.itemsList[i].itemContent[j].itemValue = _this2.itemsList[i].itemContent[j].itemValue + "日";
            }
            //APIから「様式」には、「money」が場合、APIから「項目値」は、【999,999,999】
            if (_this2.itemsList[i].itemContent[j].itemStyle == "money" && _this2.itemsList[i].itemContent[j].itemValue != "" && _this2.itemsList[i].itemContent[j].itemValue != null && _this2.itemsList[i].itemContent[j].itemValue.toString().length > 3) {
              _this2.itemsList[i].itemContent[j].itemValue = _this2.itemsList[i].itemContent[j].itemValue.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            }
            var items_V = {
              itemId: _this2.itemsList[i].itemContent[j].itemId,
              itemName: _this2.itemsList[i].itemContent[j].itemName,
              itemValue: _this2.itemsList[i].itemContent[j].itemValue
            };
            _this2.tableList.push(items_V);
          }
        }
        //給与確認情報保存
        p_0003_p_0003Save(params, JSON.parse(localStorage.getItem('userInfo')).userCd).then(function (res) {
          if (res.code != 202) {
            _this2.$message.error({ message: _this2.$t('COMMON.CURD_ERROR'), showClose: true });
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a051f10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/p_0003.vue
var p_0003_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_p0003"},[_c('div',{staticClass:"search-module_p0003"}),_vm._v(" "),_c('div',{staticClass:"el-detail_p0003"},[_c('el-row',[_c('div',{staticClass:"table-header"},[_c('span',[_vm._v(_vm._s(this.title))])])]),_vm._v(" "),_c('el-row',{staticStyle:{"padding-bottom":"10px"}},[_c('table',{staticClass:"p0003-table table-label"},_vm._l((_vm.tableList),function(item,index){return _c('tr',[(item.itemValue == 'TITLE')?_c('td',{staticClass:"table-header",attrs:{"colspan":"3"}},[_vm._v(_vm._s(item.itemName))]):_vm._e(),_vm._v(" "),(item.itemValue != 'TITLE')?_c('td',{staticClass:"p0003-form-label"},[_vm._v(_vm._s(item.itemName))]):_vm._e(),_vm._v(" "),((item.itemValue == null || item.itemValue == '') && item.itemValue != 'TITLE')?_c('td',{staticClass:"p0003-form-value"}):_vm._e(),_vm._v(" "),((item.itemValue != null && item.itemValue != '') && item.itemValue != 'TITLE')?_c('td',{staticClass:"p0003-form-value"},[_vm._v(_vm._s(item.itemValue))]):_vm._e()])}),0)])],1),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-left":"25px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))]),_vm._v(" "),(this.pdfFileUrl)?_c('i',{staticClass:"el-icon-document",staticStyle:{"margin-top":"4px","margin-right":"10px","font-size":"30px","color":"#409eff","float":"right"},on:{"click":_vm.download_click}}):_vm._e()],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"fullscreen":"","visible":_vm.viewVisible,"close-on-click-modal":false,"show-close":false,"width":"100%","top":"52px","height":"120%"},on:{"update:visible":function($event){_vm.viewVisible=$event}}},[_c('Pdf',{attrs:{"src":_vm.pdfUrl},on:{"pdfClose":_vm.pdfClose}})],1)],1)}
var p_0003_staticRenderFns = []
var p_0003_esExports = { render: p_0003_render, staticRenderFns: p_0003_staticRenderFns }
/* harmony default export */ var page_p_0003 = (p_0003_esExports);
// CONCATENATED MODULE: ./src/module/page/p_0003.vue
function p_0003_injectStyle (ssrContext) {
  __webpack_require__("V57n")
}
var p_0003_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_0003___vue_template_functional__ = false
/* styles */
var p_0003___vue_styles__ = p_0003_injectStyle
/* scopeId */
var p_0003___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var p_0003___vue_module_identifier__ = null
var p_0003_Component = p_0003_normalizeComponent(
  p_0003,
  page_p_0003,
  p_0003___vue_template_functional__,
  p_0003___vue_styles__,
  p_0003___vue_scopeId__,
  p_0003___vue_module_identifier__
)

/* harmony default export */ var module_page_p_0003 = (p_0003_Component.exports);

// CONCATENATED MODULE: ./src/module/api/p_0004.js


var p_0004_apiUrl = __webpack_require__("kspH");

// 源泉明細 检索
var p_0004_p_0004Query = function p_0004Query(params) {
  return api_public.requestQuickGet(p_0004_apiUrl.apiUrl_PaymentDetail + '?type=' + params.type + '&paidDate=' + params.paidDate + '&userCd=' + params.userCd);
};
// 源泉明細 確認情報保存
var p_0004_p_0004Save = function p_0004Save(params, userCd) {
  return api_public.requestPost(p_0004_apiUrl.apiUrl_PaymentStatus + '?userCd=' + userCd, params);
};
//PDFダウンロード
var p_0004_p_0004GetFile = function p_0004GetFile(photoPath) {
  return api_public.requestQuickGetImage(p_0004_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0');
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/p_0004.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var p_0004_url = __webpack_require__("kspH");
/* harmony default export */ var p_0004 = ({
  mixins: [css],
  components: {
    Pdf: components_page_pdf
  },
  data: function data() {
    return {
      title: '',
      type: '',
      yearMonthDay: '',
      itemsList: [],
      tableList: [],
      pdfFileUrl: '',
      //PDF
      viewVisible: false,
      pdfUrl: ''
    };
  },

  methods: {
    // 戻る処理
    back_click: function back_click() {
      var returnP0001Param = JSON.parse(localStorage.getItem('P0001search_condition'));
      var vm = this;
      vm.$router.push({ path: p_0004_url.routerUrl_P0001, query: returnP0001Param });
    },

    //PDFダウンロード
    download_click: function download_click() {
      var _this = this;

      if (this.pdfFileUrl != null && this.pdfFileUrl.length != 0) {
        this.set_loading();
        p_0004_p_0004GetFile(this.pdfFileUrl).then(function (res_file) {
          var fileUrl = {};
          var blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' });
          var url = window.URL.createObjectURL(blob);
          fileUrl.url = url;
          fileUrl.name = _this.pdfFileUrl;
          for (var index = 0; index < 2; index++) {
            fileUrl.name = fileUrl.name.substring(fileUrl.name.indexOf('/') + 1);
          }
          _this.download(fileUrl);
          _this.close_loading();
        }).catch(function (err) {
          //关闭loading
          _this.close_loading();
        });
      }
    },
    pdfClose: function pdfClose() {
      this.viewVisible = false;
    },

    //pdfダウンロード
    download: function download(file) {
      this.pdfUrl = file;
      this.viewVisible = true;
    }
  },
  // 初期化
  created: function created() {
    var _this2 = this;

    this.obj = JSON.parse(localStorage.getItem('obj'));
    //源泉
    this.type = "3";
    this.title = this.obj.paidDate.slice(0, 4) + "年" + this.obj.paidDate.slice(5, 7) + "月" + " " + this.$t('MODULE.P0004_TITLE');
    this.yearMonthDay = JSON.parse(stringify_default()(this.obj.paidDate.replace(new RegExp("-", 'g'), "/")));

    var params = {
      paidDate: this.yearMonthDay,
      type: this.type,
      userCd: JSON.parse(localStorage.getItem('userInfo')).userCd
      //給与明細検索
    };p_0004_p_0004Query(params).then(function (res) {
      if (res.code == 300) {
        _this2.$message.warning({ message: _this2.$t('COMMON.NO_TARGET_DATA'), showClose: true });
        _this2.itemsList = [];
        return;
      } else if (res.code == 204) {
        _this2.itemsList = res.items.paymentDetailSet;
        _this2.pdfFileUrl = res.items.paymentPathSet[0].formPath;
        _this2.tableList = [];
        for (var i = 0; i < _this2.itemsList.length; i++) {
          //源泉無TITLE
          for (var j = 0; j < _this2.itemsList[i].itemContent.length; j++) {
            //APIから「様式」には、「day」が場合、APIから「項目値」の後に、【日】を付ける
            if (_this2.itemsList[i].itemContent[j].itemStyle == "day" && _this2.itemsList[i].itemContent[j].itemValue != "" && _this2.itemsList[i].itemContent[j].itemValue != null) {
              _this2.itemsList[i].itemContent[j].itemValue = _this2.itemsList[i].itemContent[j].itemValue + "日";
            }
            //APIから「様式」には、「money」が場合、APIから「項目値」は、【999,999,999】
            if (_this2.itemsList[i].itemContent[j].itemStyle == "money" && _this2.itemsList[i].itemContent[j].itemValue != "" && _this2.itemsList[i].itemContent[j].itemValue != null && _this2.itemsList[i].itemContent[j].itemValue.toString().length > 3) {
              _this2.itemsList[i].itemContent[j].itemValue = _this2.itemsList[i].itemContent[j].itemValue.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            }
            var items_V = {
              itemId: _this2.itemsList[i].itemContent[j].itemId,
              itemName: _this2.itemsList[i].itemContent[j].itemName,
              itemValue: _this2.itemsList[i].itemContent[j].itemValue
            };
            _this2.tableList.push(items_V);
          }
        }
        //給与確認情報保存
        p_0004_p_0004Save(params, JSON.parse(localStorage.getItem('userInfo')).userCd).then(function (res) {
          if (res.code != 202) {
            _this2.$message.error({ message: _this2.$t('COMMON.CURD_ERROR'), showClose: true });
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1728f3b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/p_0004.vue
var p_0004_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_p0004"},[_c('div',{staticClass:"search-module_p0004"}),_vm._v(" "),_c('div',{staticClass:"el-detail_p0004"},[_c('el-row',[_c('div',{staticClass:"table-header"},[_c('span',[_vm._v(_vm._s(this.title))])])]),_vm._v(" "),_c('el-row',{staticStyle:{"padding-bottom":"10px"}},[_c('table',{staticClass:"p0004-table table-label"},_vm._l((_vm.tableList),function(item,index){return _c('tr',[(item.itemValue == 'TITLE')?_c('td',{staticClass:"table-header",attrs:{"colspan":"3"}},[_vm._v(_vm._s(item.itemName))]):_vm._e(),_vm._v(" "),(item.itemValue != 'TITLE')?_c('td',{staticClass:"p0004-form-label"},[_vm._v(_vm._s(item.itemName))]):_vm._e(),_vm._v(" "),((item.itemValue == null || item.itemValue == '') && item.itemValue != 'TITLE')?_c('td',{staticClass:"p0004-form-value"}):_vm._e(),_vm._v(" "),((item.itemValue != null && item.itemValue != '') && item.itemValue != 'TITLE')?_c('td',{staticClass:"p0004-form-value"},[_vm._v(_vm._s(item.itemValue))]):_vm._e()])}),0)])],1),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-left":"25px","font-size":"13px","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))]),_vm._v(" "),(this.pdfFileUrl)?_c('i',{staticClass:"el-icon-document",staticStyle:{"margin-top":"4px","margin-right":"10px","font-size":"30px","color":"#409eff","float":"right"},on:{"click":_vm.download_click}}):_vm._e()],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"fullscreen":"","visible":_vm.viewVisible,"close-on-click-modal":false,"show-close":false,"width":"100%","top":"52px","height":"120%"},on:{"update:visible":function($event){_vm.viewVisible=$event}}},[_c('Pdf',{attrs:{"src":_vm.pdfUrl},on:{"pdfClose":_vm.pdfClose}})],1)],1)}
var p_0004_staticRenderFns = []
var p_0004_esExports = { render: p_0004_render, staticRenderFns: p_0004_staticRenderFns }
/* harmony default export */ var page_p_0004 = (p_0004_esExports);
// CONCATENATED MODULE: ./src/module/page/p_0004.vue
function p_0004_injectStyle (ssrContext) {
  __webpack_require__("zl0I")
}
var p_0004_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var p_0004___vue_template_functional__ = false
/* styles */
var p_0004___vue_styles__ = p_0004_injectStyle
/* scopeId */
var p_0004___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var p_0004___vue_module_identifier__ = null
var p_0004_Component = p_0004_normalizeComponent(
  p_0004,
  page_p_0004,
  p_0004___vue_template_functional__,
  p_0004___vue_styles__,
  p_0004___vue_scopeId__,
  p_0004___vue_module_identifier__
)

/* harmony default export */ var module_page_p_0004 = (p_0004_Component.exports);

// CONCATENATED MODULE: ./src/module/api/b_0002.js




var b_0002_apiUrl = __webpack_require__("kspH");
// 検索
var b_0002_noticeDetailGet = function noticeDetailGet(userCd, noticeCd) {
    return api_public.requestGet(b_0002_apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd + '&noticeCd=' + noticeCd);
};

//文件查询
var b_0002_b_0002_getFile = function b_0002_getFile(params) {
    return api_public.requestQuickGetImage(b_0002_apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(params.filePath) + '&resizeCd=' + params.resizeCd);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/b_0002.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var b_0002 = ({
  mixins: [css],
  name: '',
  components: {},
  data: function data() {
    return {
      userCd: '',
      noticeCd: '',
      tNoticeDetail: {
        mailContents: ''
      },
      fileList: [],
      pdfUrl: '',
      linkHeight: 27,
      linkRow: 1,
      attachmentLinkShow: '',
      alinkColor: 'blue'
    };
  },
  created: function created() {
    this.userCd = this.$route.query.userCd;
    this.noticeCd = this.$route.query.noticeCd;
    this.query();
  },

  methods: {
    query: function query() {
      var _this = this;

      //实现Loading 加载方法
      this.set_loading();
      b_0002_noticeDetailGet(this.userCd, this.noticeCd).then(function (res) {
        _this.tNoticeDetail = res.items.tNoticeDetail[0];
        if (!_this.tNoticeDetail) {
          return;
        }
        if (_this.tNoticeDetail.attachmentLink) {
          _this.linkRow = Math.ceil(_this.tNoticeDetail.attachmentLink.length / 30);
          if (_this.tNoticeDetail.attachmentLink.length >= 90) {
            _this.attachmentLinkShow = _this.tNoticeDetail.attachmentLink.substring(0, 90) + '...';
            _this.linkRow = 3;
          } else {
            _this.attachmentLinkShow = _this.tNoticeDetail.attachmentLink;
          }
        }
        if (_this.tNoticeDetail.mailDate) {
          _this.tNoticeDetail.mailDate = utils.timeDefault(_this.tNoticeDetail.mailDate);
        }
        _this.fileList = [];
        if (_this.tNoticeDetail.mailAttachment) {
          _this.fileQuery();
        } else {
          _this.close_loading();
        }
      }).catch(function (err) {
        _this.close_loading();
      });
    },

    // 打开URL栏中入力的连接
    checkUrl: function checkUrl(val) {
      if (val) {
        var addr1 = val.substr(0, 7).toLowerCase();
        var addr2 = val.substr(0, 8).toLowerCase();
        if (addr1 == 'http://' || addr2 == 'https://') {
          return val;
        } else {
          return 'http://' + val;
        }
      }
    },

    // 点击URL后将URL颜色调整为紫色
    hrefColorChange: function hrefColorChange() {
      this.alinkColor = '#551A8B';
    },

    //文件查询
    fileQuery: function fileQuery() {
      var _this2 = this;

      var _fileList = [];
      this.blobFile = {};
      // 获取文件名_fileList，并去重
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.tNoticeDetail.mailAttachment.split(',')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (_fileList.indexOf(item) == -1) {
            _fileList.push(item);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      for (var i = 0; i < _fileList.length; i++) {
        //ファイル名取得
        var fileName = _fileList[i].split('/')[_fileList[i].split('/').length - 1];
        var PathfileName = _fileList[i];
        this.blobFile[fileName] = PathfileName;
      }
      var photoSum = 0;

      var _loop = function _loop() {
        getFileImageParams = {};

        getFileImageParams.filePath = _this2.blobFile[key];
        getFileImageParams.resizeCd = '0';
        var fileUrl = {};
        fileUrl.name = key;
        b_0002_b_0002_getFile(getFileImageParams).then(function (res_file) {
          var blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' });
          var url = window.URL.createObjectURL(blob);
          fileUrl.url = url;
          fileUrl.file = res_file;
          if (fileUrl.name.indexOf("%26") !== -1) {
            fileUrl.name = fileUrl.name.replace('%26', '&');
          }
          if (fileUrl.name.indexOf("%2F") !== -1) {
            fileUrl.name = fileUrl.name.replace('%2F', '/');
          }
          if (fileUrl.name.indexOf("%3F") !== -1) {
            fileUrl.name = fileUrl.name.replace('%3F', '?');
          }
          if (fileUrl.name.indexOf("%23") !== -1) {
            fileUrl.name = fileUrl.name.replace('%23', '#');
          }
          if (fileUrl.name.indexOf("%25") !== -1) {
            fileUrl.name = fileUrl.name.replace('%25', '%');
          }
          _this2.fileList.push(fileUrl);

          photoSum += 1;
          if (photoSum == _fileList.length) {
            _this2.close_loading();
          }
        }).catch(function (err) {
          //关闭loading
          _this2.close_loading();
        });
      };

      for (var key in this.blobFile) {
        var getFileImageParams;

        _loop();
      }
    },


    //ファイルをダウンロード
    download: function download(file) {
      var fileTypeMime = ''; // 文件mime类型
      var fileName = file.name;
      var suffix = fileName.substring(fileName.lastIndexOf('.') + 1); //获得文件后缀
      switch (suffix) {// switch获取后缀对应的mime
        case 'png':
          fileTypeMime = 'image/png';break;
        case 'doc':
          fileTypeMime = 'application/msword';break;
        case 'docx':
          fileTypeMime = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';break;
        case 'jpg':case 'jpeg':
          fileTypeMime = 'image/jpeg';break;
        case 'gif':
          fileTypeMime = 'image/gif';break;
        case 'svg':
          fileTypeMime = 'image/svg+xml';break;
        case 'txt':
          fileTypeMime = 'text/plain';break;
        case 'ppt':
          fileTypeMime = 'application/vnd.ms-powerpoint';break;
        case 'xls':
          fileTypeMime = 'application/vnd.ms-excel';break;
        case 'xlsx':
          fileTypeMime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';break;
        case 'pdf':
          fileTypeMime = 'application/pdf';break;
      }
      var content = file.file; //arraybuffer类型数据
      var resBlob = new Blob([content]);
      var reader = new FileReader();
      reader.readAsText(resBlob, 'UTF-8');
      reader.onload = function (evt) {
        var blob = void 0;
        if (suffix == 'txt') {
          blob = new Blob(["\uFEFF" + evt.target.result], { type: fileTypeMime });
        } else {
          blob = new Blob([file.file], { type: fileTypeMime });
        }
        var blobUrl = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.style.display = 'none';
        a.download = file.name;
        a.href = blobUrl;
        a.click();
      };
    },


    //返回
    back: function back() {
      this.$router.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-337df638","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/b_0002.vue
var b_0002_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-top":"8px"},attrs:{"gutter":0}},[_c('div',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.$t('MODULE.B0001_LBL_INFORM')))])]),_vm._v(" "),_c('table',{staticClass:"b0002-table table-label"},[_c('tr',[_c('td',{staticClass:"b0002-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.B0002_LBL_MAILSENDUSER'))+" ")]),_vm._v(" "),_c('td',{staticClass:"b0002-form-value"},[_c('span',[_vm._v(_vm._s(_vm.tNoticeDetail.mailSendUserName))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"b0002-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.B0002_LBL_MAILDATE'))+" ")]),_vm._v(" "),_c('td',{staticClass:"b0002-form-value"},[_c('span',[_vm._v(_vm._s(_vm.tNoticeDetail.mailDate))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"b0002-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.B0002_LBL_MAILTITLE'))+" ")]),_vm._v(" "),_c('td',{staticClass:"b0002-form-value"},[_c('span',[_vm._v(_vm._s(_vm.tNoticeDetail.mailTitle))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"b0002-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.B0002_LBL_MAILATTACHMENT'))+" ")]),_vm._v(" "),_c('td',{staticClass:"b0002-form-value"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.tNoticeDetail.mailContents.replaceAll('\n','<br />'))}})])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"b0002-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.B0002_LBL_LINK'))+" ")]),_vm._v(" "),_c('td',{staticClass:"b0002-form-value"},[_c('div',{style:({height:_vm.linkHeight*_vm.linkRow+'px'})},[_c('a',{style:({color:_vm.alinkColor}),attrs:{"href":_vm.checkUrl(_vm.tNoticeDetail.attachmentLink),"target":"blank"},on:{"click":_vm.hrefColorChange}},[_vm._v(_vm._s(_vm.attachmentLinkShow))])])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"b0002-form-label"},[_vm._v(_vm._s(_vm.$t('MODULE.B0002_LBL_FILE'))+" ")]),_vm._v(" "),_c('td',{staticClass:"b0002-form-value"},_vm._l((_vm.fileList),function(item,key){return _c('div',{key:item.key},[_c('div',{staticClass:"b0002-mailAttachment",on:{"click":function($event){return _vm.download(item)}}},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(item.name))])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"b0002btn-center"},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt"},attrs:{"type":"primary"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('MODULE.B0002_LBL_BACK')))])],1)],1)}
var b_0002_staticRenderFns = []
var b_0002_esExports = { render: b_0002_render, staticRenderFns: b_0002_staticRenderFns }
/* harmony default export */ var page_b_0002 = (b_0002_esExports);
// CONCATENATED MODULE: ./src/module/page/b_0002.vue
function b_0002_injectStyle (ssrContext) {
  __webpack_require__("KYqx")
}
var b_0002_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var b_0002___vue_template_functional__ = false
/* styles */
var b_0002___vue_styles__ = b_0002_injectStyle
/* scopeId */
var b_0002___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var b_0002___vue_module_identifier__ = null
var b_0002_Component = b_0002_normalizeComponent(
  b_0002,
  page_b_0002,
  b_0002___vue_template_functional__,
  b_0002___vue_styles__,
  b_0002___vue_scopeId__,
  b_0002___vue_module_identifier__
)

/* harmony default export */ var module_page_b_0002 = (b_0002_Component.exports);

// CONCATENATED MODULE: ./src/module/api/w_0001.js

var w_0001_apiUrl = __webpack_require__("kspH");


// 初期化
var w_0001_home = function home() {
    return api_public.requestQuickGet(w_0001_apiUrl.apiUrl_Initialization);
};

// 作業量一覧検索
var w_0001_w0001_query = function w0001_query(params) {
    var querys = querystring_es3_default.a.stringify(params);
    return api_public.requestGet(w_0001_apiUrl.apiUrl_workAmountList + '?' + querys);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/w_0001.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var w_0001_url = __webpack_require__("kspH");
vue_esm["default"].use(element_ui_common_default.a, { locale: ja_default.a });
/* harmony default export */ var w_0001 = ({
  data: function data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      imgIconComplete: __webpack_require__("NFlY"),
      imgIconPlan: __webpack_require__("dP0d"),
      imgIconUnderway: __webpack_require__("/fmQ"),
      imgIconCloseComplete: __webpack_require__("OBZi"),
      imgIconGoComplete: __webpack_require__("XuR1"),
      list: [],
      queryParams: {
        siteId: '' //サイトid
      },
      kikanVal1: '',
      kikanVal2: '',
      fullscreenLoading: false
    };
  },

  methods: {
    // 初期化
    init_query: function init_query() {
      var _this = this;

      // 期間初期化
      var search_condition = JSON.parse(localStorage.getItem('search_condition'));
      if (search_condition == null) {
        var today = new Date();
        var torrom = new Date();
        this.kikanVal1 = today;
        var torrom = torrom.setDate(torrom.getDate() + 1);
        torrom = new Date(torrom);
        this.kikanVal2 = torrom;
        var search_condition = {};
        search_condition.fromDate = this.dateToString(this.kikanVal1, '0');
        search_condition.toDate = this.dateToString(this.kikanVal2, '0');
        localStorage.setItem("search_condition", stringify_default()(search_condition));
      } else {
        var fromDate = search_condition.fromDate;
        var toDate = search_condition.toDate;
        if (search_condition.fromDate != null) {
          this.kikanVal1 = new Date(fromDate.substring(0, 4) + '/' + fromDate.substring(4, 6) + '/' + fromDate.substring(6, 8));
        } else {
          this.kikanVal1 = null;
        }
        if (search_condition.toDate != null) {
          this.kikanVal2 = new Date(toDate.substring(0, 4) + '/' + toDate.substring(4, 6) + '/' + toDate.substring(6, 8));
        } else {
          this.kikanVal2 = null;
        }
      }
      w_0001_home().then(function (res) {
        _this.userInfo = res.items.userInfo;
        localStorage.setItem("userInfo", stringify_default()(_this.userInfo));
      });
    },

    // 検索ボタン
    query_btn: function query_btn() {
      var search_condition = {};
      search_condition.fromDate = this.dateToString(this.kikanVal1, '0');
      search_condition.toDate = this.dateToString(this.kikanVal2, '0');
      localStorage.setItem("search_condition", stringify_default()(search_condition));
      this.query();
    },

    // 検索
    query: function query() {
      var _this2 = this;

      var dateFrom = '';
      var dateTo = '';
      if (this.dateToString(this.kikanVal1, '0') !== null) {
        dateFrom = this.dateToString(this.kikanVal1, '0');
      } else {
        dateFrom = null;
      }
      if (this.dateToString(this.kikanVal2, '0') !== null) {
        dateTo = this.dateToString(this.kikanVal2, '0');
      } else {
        dateTo = null;
      }
      if (dateFrom != null && dateTo != null && dateFrom > dateTo) {
        // 終了日は開始日と同じか後の日付を設定してください。
        this.$message.error({ message: this.$t('COMMON.MSG_MESSAGE_ERROR_FROMDATE'), showClose: true });
      } else {
        var Params = {
          "jobDateFrom": dateFrom.slice(0, 4) + '/' + dateFrom.slice(4, 6) + '/' + dateFrom.slice(6, 8),
          "jobDateTo": dateTo.slice(0, 4) + '/' + dateTo.slice(4, 6) + '/' + dateTo.slice(6, 8),
          "page": 1,
          "size": 999
        };
        var loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        setTimeout(function () {
          loading.close();
        }, 2000);
        w_0001_w0001_query(Params).then(function (res) {
          // 戻るリスト
          _this2.total = res.total;
          if (res.code === 300) {
            _this2.$message.warning({ message: _this2.$t('COMMON.NO_TARGET_DATA'), showClose: true });
          }
          _this2.list = res.items.workAmountList;
          loading.close();
        });
      }
    },

    // TABLEHeader样式
    w0001HeaderStyle: function w0001HeaderStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; ';
    },

    // TABLE单元格样式
    w0001IsCellStyle: function w0001IsCellStyle(_ref2) {
      var row = _ref2.row,
          colum = _ref2.colum,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return 'text-align:center;fontSize:10pt';
    },

    // 单击行事件
    w0001RowOnClick: function w0001RowOnClick(thisRowDate, column, cell, event) {
      localStorage.setItem('obj', stringify_default()(thisRowDate));
      this.$router.push({ path: w_0001_url.routerUrl_W0002 });
    },
    w0001HeaderClass: function w0001HeaderClass(_ref3) {
      var row = _ref3.row,
          rowIndex = _ref3.rowIndex;

      return 'w0001HeaderClass';
    },
    w0001IsCellClass: function w0001IsCellClass(_ref4) {
      var row = _ref4.row,
          rowIndex = _ref4.rowIndex;

      return 'w0001IsCellClass';
    },

    // ログアウト処理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    // 戻る処理
    back_click: function back_click() {
      var vm = this;
      vm.$router.push({ path: w_0001_url.routerUrl_Menu });
    },

    // date->string(yyyy/mm/dd  yyyymmdd) 変化
    dateToString: function dateToString(dateTime, changeType) {
      var strTime = '';
      if (dateTime == null) {
        return null;
      }
      var year = dateTime.getFullYear();
      var month = (dateTime.getMonth() + 1).toString();
      var day = dateTime.getDate().toString();
      if (month.length === 1) {
        month = '0' + month;
      }
      if (day.length === 1) {
        day = '0' + day;
      }
      if (changeType === '0') {
        strTime = year + month + day;
      } else if (changeType === '1') {
        strTime = year + '/' + month + '/' + day;
      } else {
        strTime = year + month + day;
      }
      return strTime;
    },

    // date->string(HH:MM) 変化
    dateToStringHHMM: function dateToStringHHMM(dateTime, addHour) {
      var strTime = '';
      if (dateTime == null) {
        return '';
      }
      var hours = dateTime.getHours() + addHour;
      var minutes = dateTime.getMinutes();
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      strTime = hours + ':' + minutes;
      return strTime;
    },

    // 時刻(分) str->num (00:00->num)
    stringToMin: function stringToMin(time) {
      if (time === null || time === '') {
        return 0;
      } else {
        return Number(time.substring(0, 2)) * 60 + Number(time.substring(3, 5));
      }
    }
  },
  created: function created() {
    // 初期化
    this.init_query();
    // 期間より検索
    this.query();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-979d998e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/w_0001.vue
var w_0001_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"0px solid red","height":"100%"}},[_c('el-container',{staticStyle:{"padding":"0px","width":"100%","height":"100%"}},[_c('el-main',{staticStyle:{"padding":"0px 0px 0px 0px","width":"100%","height":"100%"}},[_c('div',{staticClass:"search-module-w0001 "},[_c('el-row',{staticStyle:{"padding-top":"5px","padding-left":"5px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":7}},[_c('div',[_c('el-date-picker',{staticStyle:{"width":"130px","font-size":"12px"},attrs:{"size":"mini","type":"date","editable":false,"clearable":false,"format":"yyyy/MM/dd"},model:{value:(_vm.kikanVal1),callback:function ($$v) {_vm.kikanVal1=$$v},expression:"kikanVal1"}})],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"padding-left":"2px","padding-right":"10px"},attrs:{"span":2}},[_c('div',[_vm._v("\n               \n            ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('div',[_c('el-date-picker',{staticStyle:{"width":"130px","font-size":"12px"},attrs:{"size":"mini","type":"date","editable":false,"clearable":false,"format":"yyyy/MM/dd"},model:{value:(_vm.kikanVal2),callback:function ($$v) {_vm.kikanVal2=$$v},expression:"kikanVal2"}})],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('div',[_vm._v("\n               \n            ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('div',[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"css-button_w0001 css-btn_w0001",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.query_btn}},[_vm._v(_vm._s(_vm.$t('COMMON.LBL_SEARCH')))])],1)])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"border":"0px solid #AAAAAA"},attrs:{"header-cell-style":_vm.w0001HeaderStyle,"cell-style":_vm.w0001IsCellStyle,"header-row-class-name":_vm.w0001HeaderClass,"cell-class-name":_vm.w0001IsCellClass,"data":_vm.list,"border":"","size":"mini"},on:{"row-click":_vm.w0001RowOnClick}},[_c('el-table-column',{attrs:{"fixed":"left","prop":"col1","label":_vm.$t('MODULE.W0001_LBL_COL1'),"width":"100","text-align":"center","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.jobDate)+"\n            "),_vm._v(" "),_c('div',[(scope.row.jobState=='0')?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconPlan,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.jobState=='1')?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconUnderway,"alt":""}}):_vm._e(),_vm._v(" "),(scope.row.jobState=='2')?_c('el-image',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.imgIconComplete,"alt":""}}):_vm._e(),_vm._v(" "),[_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(scope.row.jobStateName))])]],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","prop":"col2","label":_vm.$t('MODULE.W0001_LBL_COL2'),"width":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.companyName)),_c('br'),_vm._v("\n            "+_vm._s(scope.row.fieldName)),_c('br'),_vm._v("\n            "+_vm._s(scope.row.serviceNameAbbr)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","prop":"col3","label":_vm.$t('MODULE.W0001_LBL_COL3'),"width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.fieldCd))])]}}])})],1)],1)],1)],1)}
var w_0001_staticRenderFns = []
var w_0001_esExports = { render: w_0001_render, staticRenderFns: w_0001_staticRenderFns }
/* harmony default export */ var page_w_0001 = (w_0001_esExports);
// CONCATENATED MODULE: ./src/module/page/w_0001.vue
function w_0001_injectStyle (ssrContext) {
  __webpack_require__("zQ9H")
}
var w_0001_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var w_0001___vue_template_functional__ = false
/* styles */
var w_0001___vue_styles__ = w_0001_injectStyle
/* scopeId */
var w_0001___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var w_0001___vue_module_identifier__ = null
var w_0001_Component = w_0001_normalizeComponent(
  w_0001,
  page_w_0001,
  w_0001___vue_template_functional__,
  w_0001___vue_styles__,
  w_0001___vue_scopeId__,
  w_0001___vue_module_identifier__
)

/* harmony default export */ var module_page_w_0001 = (w_0001_Component.exports);

// EXTERNAL MODULE: ./node_modules/constants-browserify/constants.json
var constants = __webpack_require__("RYcG");
var constants_default = /*#__PURE__*/__webpack_require__.n(constants);

// CONCATENATED MODULE: ./src/module/api/w_0002.js




var w_0002_apiUrl = __webpack_require__("kspH");
// 検索
var w_0002_w_0002_search = function w_0002_search(params) {
  var querys = querystring_es3_default.a.stringify(params);
  return api_public.requestGet(w_0002_apiUrl.apiUrl_WorksCwSelect + '?' + querys);
};
// 更新
var w_0002_w_0002_update = function w_0002_update(params) {
  return api_public.requestPost(w_0002_apiUrl.apiUrl_WorksCwSelect, params);
};
//图片取得
var w_0002_w_0002_getImage = function w_0002_getImage(params) {
  return api_public.requestQuickGetImage('/api/v1/files?filePath=' + encodeURIComponent(params) + '&resizeCd=0');
};
//图片更新
var w_0002_w_0002_saveImage = function w_0002_saveImage(formData) {
  return api_public.requestPostFormData(w_0002_apiUrl.apiUrl_filesUpdate, formData);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/module/page/w_0002.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var w_0002_url = __webpack_require__("kspH");

/* harmony default export */ var w_0002 = ({
  mixins: [css],
  components: {
    ElImageViewer: image_src_image_viewer
  },
  data: function data() {
    return {
      companyName: '',
      fieldName: '',
      jobDate: '', //作業日
      userInfo: '',
      crewCd: '', // クルーコード
      jobState: '', //  作業状態
      cwNotices: '', // 特記事項
      cwStoreSign: '', //店舗責任者サイン
      week: '', // 曜日
      fieldCd: '', // 現場CD
      salesOfficeCd: '',
      receiptPhoto: '', // 受領書写真(pathです)
      obj: [],
      photoUid: '', //fileUid
      receiptPhoto1Url: '', //图片1预览用的单张图片
      storeWorkCwProductList: [], // 商品情報リスト
      receiptPhoto1ImageList: [], //图片1初始化时的list
      updateReceiptPhotoList: [], //update用PhotoList
      receiptPhoto1LongClick: false, //是否为图片1长按模式（true=长按模式）。
      has_UpdateLoadedDel: false, //是否上传成功过
      w0002btn2CheckBox: false, // 作業量入力無しnoAmountInput
      w0002btn3CheckBox: false, // 受領書無しnoReceipt
      receiptPhoto1Visible: false, //图片1dialog是否显示flag
      receiptPhoto1Show: true, //是否显示假图片框1
      changeFgl: false,
      transmitFlag: '',
      updateParams: {},
      photoFormData: {}
    };
  },

  methods: {
    // 検索
    query: function query() {
      var _this = this;

      var Params = {
        'crewCd': this.crewCd,
        'week': this.week
        // 検索処理
      };this.set_loading();
      w_0002_w_0002_search(Params).then(function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
          var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.storeWorkCwProductList = res.items.storeWorkCwProductList;
                  _this.transmitFlag = res.items.transmitFlag;
                  _this.salesOfficeCd = res.items.salesOfficeCd;
                  _this.jobState = res.items.jobState;
                  if (_this.jobState == '1') {
                    _this.jobState_working = true;
                  } else {
                    _this.jobState_working = false;
                  }
                  _this.cwNotices = res.items.cwNotices;
                  _this.w0002btn2CheckBox = res.items.noAmountInput == '0' ? false : true;
                  _this.w0002btn3CheckBox = res.items.noReceipt == '0' ? false : true;
                  // 写真检索

                  if (!res.items.receiptPhoto) {
                    _context.next = 35;
                    break;
                  }

                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context.prev = 12;
                  _iterator = get_iterator_default()(res.items.receiptPhoto.split(','));

                case 14:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context.next = 21;
                    break;
                  }

                  item = _step.value;
                  _context.next = 18;
                  return _this.download_Get(item, '1');

                case 18:
                  _iteratorNormalCompletion = true;
                  _context.next = 14;
                  break;

                case 21:
                  _context.next = 27;
                  break;

                case 23:
                  _context.prev = 23;
                  _context.t0 = _context["catch"](12);
                  _didIteratorError = true;
                  _iteratorError = _context.t0;

                case 27:
                  _context.prev = 27;
                  _context.prev = 28;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 30:
                  _context.prev = 30;

                  if (!_didIteratorError) {
                    _context.next = 33;
                    break;
                  }

                  throw _iteratorError;

                case 33:
                  return _context.finish(30);

                case 34:
                  return _context.finish(27);

                case 35:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this, [[12, 23, 27, 35], [28,, 30, 34]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.close_loading();
    },
    btn2CheckChange: function btn2CheckChange() {
      var _this2 = this;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.storeWorkCwProductList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.productNumbers !== null && item.productNumbers !== '') {
            this.$confirm(this.$t('COMMON.MSG_WORK_AMOUNT_CLR'), { // 作業数量をリセットします、よろしいですか？
              confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
              cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
              center: true
            }).then(function () {
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(_this2.storeWorkCwProductList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var _item = _step3.value;

                  _item.productNumbers = null;
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }

              _this2.w0002btn2CheckBox = true;
            }).catch(function () {
              _this2.w0002btn2CheckBox = false;
            });
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.changeFgl = true;
    },

    // 保存按钮事件
    save_click: function save_click() {
      var _this3 = this;

      this.$confirm(this.$t('COMMON.MSG_SAVE'), { // 保存します。よろしいでしょうか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(function () {
        _this3.set_loading();
        _this3.updateParams.div = '0';
        _this3.updateParams.crewCd = _this3.crewCd;
        _this3.updateParams.jobState = '1';
        _this3.updateParams.cwNotices = _this3.cwNotices;
        _this3.updateParams.cwStoreSign = '';
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = get_iterator_default()(_this3.storeWorkCwProductList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;

            item.productNumbers = item.productNumbers == '' ? null : item.productNumbers;
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this3.updateParams.productList = _this3.storeWorkCwProductList;
        _this3.updateParams.week = _this3.week;
        _this3.updateParams.salesOfficeCd = _this3.salesOfficeCd;
        _this3.updateParams.fieldCd = _this3.fieldCd;
        _this3.updateParams.jobDate = _this3.jobDate;
        _this3.updateParams.noAmountInput = _this3.w0002btn2CheckBox == false ? '0' : '1';
        _this3.updateParams.noReceipt = _this3.w0002btn3CheckBox == false ? '0' : '1';
        // Image更新
        _this3.receiptPhoto = '';
        // 初始receiptPhoto変化判断
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = get_iterator_default()(_this3.$refs.upload1.uploadFiles), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _item2 = _step5.value;

            if (_item2.filePath) {
              if (_this3.receiptPhoto !== '') {
                _this3.receiptPhoto = _this3.receiptPhoto + _item2.filePath + ',';
              } else {
                _this3.receiptPhoto = _item2.filePath + ',';
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        console.log(_this3.receiptPhoto);
        _this3.photoFormData = new FormData();
        // 新receiptPhoto保存
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = get_iterator_default()(_this3.updateReceiptPhotoList), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var _item3 = _step6.value;

            _this3.photoFormData.append('files', _item3.files, _item3.photoPath);
            _this3.receiptPhoto = _this3.receiptPhoto + _item3.photoPath + ',';
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        _this3.receiptPhoto = _this3.receiptPhoto.slice(0, -1);
        if (_this3.updateReceiptPhotoList.length > 0) {
          _this3.updateParams.receiptPhoto = _this3.receiptPhoto;
          var that = _this3;
          w_0002_w_0002_saveImage(_this3.photoFormData).then(function (res) {
            if (res.code == 205) {
              w_0002_w_0002_update(_this3.updateParams).then(function (res) {
                _this3.res_code_back(res);
              });
            } else if (res.code == 311) {
              that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }); // 更新失敗
            }
          });
        } else {
          _this3.updateParams.receiptPhoto = _this3.receiptPhoto;
          w_0002_w_0002_update(_this3.updateParams).then(function (res) {
            _this3.res_code_back(res);
          });
        }
        _this3.close_loading();
      }).catch(function () {});
    },

    //「作業開始／作業完了／戻す」ボタン処理
    clickWork: function clickWork() {
      var _this4 = this;

      var param = {};
      param.jobDate = this.jobDate;
      param.crewCd = this.crewCd;
      param.gamenId = 'W_0002';
      if (this.jobState == '0') {
        param.checkFlg = '1';
        param.btnType = '1';
        this.$confirm(this.$t('COMMON.MSG_STOREIN_COMFIRM'), this.$t('COMMON.CONFIRM'), { // 作業開始します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true,
          customClass: 'w0002_confirmStyle',
          type: 'warning'
        }).then(function () {
          utils.jobStateEdit(param).then(function (res) {
            if (res.code == 406) {
              //システム時刻がパラメータ.最小の入店より1時間以上早い場合
              _this4.$confirm(_this4.$t('COMMON.MINSTOREIN_CHECK'), _this4.$t('COMMON.CONFIRM'), { // クルーイングより1時間以上早いです。開始してよろしいでしょうか。"
                confirmButtonText: _this4.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                cancelButtonText: _this4.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
                center: true,
                customClass: 'w0002_confirmStyle',
                type: 'warning'
              }).then(function () {
                param.checkFlg = '0';
                utils.jobStateEdit(param).then(function (res2) {
                  _this4.res_code_back(res2);
                });
              }).catch(function () {
                // いいえ
              });
            } else {
              //その他
              _this4.res_code_back(res);
            }
          });
        }).catch(function () {
          // いいえ
        });
      } else if (this.jobState == '1') {
        param.checkFlg = '1';
        param.btnType = '2';
        utils.jobStateEdit(param).then(function (res) {
          if (res.code == 405) {
            // 店舗サインがありません。作業完了してもよろしいですか？
            setTimeout(function () {
              _this4.$confirm(_this4.$t('COMMON.SOTRESIGN_NOT_INPUT'), _this4.$t('COMMON.CONFIRM'), {
                confirmButtonText: _this4.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                cancelButtonText: _this4.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
                center: true,
                customClass: 'w0002_confirmStyle',
                type: 'warning'
              }).then(function () {
                param.checkFlg = '0';
                utils.jobStateEdit(param).then(function (res) {
                  _this4.res_code_back(res);
                });
                // this.changeFgl = false
                // var vm = this
                // vm.$router.push({ path: url.routerUrl_W0001 })
              }).catch(function () {});
            }, 500);
          } else {
            setTimeout(function () {
              _this4.$confirm(_this4.$t('COMMON.MSG_STOREOUT_COMFIRM_MSG'), _this4.$t('COMMON.CONFIRM'), { // 作業完了します。よろしいですか？
                confirmButtonText: _this4.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                cancelButtonText: _this4.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
                center: true,
                customClass: 'w0002_confirmStyle',
                type: 'warning'
              }).then(function () {
                param.checkFlg = '0';
                utils.jobStateEdit(param).then(function (res) {
                  _this4.res_code_back(res);
                });
              }).catch(function () {
                // いいえ
              });
            }, 500);
          }
        });
      } else if (this.jobState == '2') {
        param.checkFlg = '0';
        param.btnType = '3';
        this.$confirm(this.$t('COMMON.MSG_STOREOUT_BACK_MSG'), this.$t('COMMON.CONFIRM'), { // 作業中に戻ります。よろしいですか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true,
          customClass: 'w0002_confirmStyle',
          type: 'warning'
        }).then(function () {
          utils.jobStateEdit(param).then(function (res) {
            _this4.res_code_back(res);
          });
        }).catch(function () {
          // いいえ
        });
      }
    },

    //readonly判定
    NeedReadonly: function NeedReadonly(flag) {
      var readonlyReturn = true;
      switch (flag) {
        //作業開始・完了・戻すReadonly
        case "BTN1":
          if (this.transmitFlag !== '1') {
            readonlyReturn = false;
          }
          break;
        //作業量入力無しReadonly/productNumbersReadonly
        case "BTN2":
          if (this.jobState === '1' && this.jobDate === utils.timeDefault()) {
            readonlyReturn = false;
          }
          break;
        // 受領書無しReadonly/受領書写真Readonly/特記事項Readonly
        case "BTN3":
          if (this.jobState === '1') {
            readonlyReturn = false;
          }
          break;
        // 保存Readonly
        case "BTN4":
          if (this.jobState === '1') {
            readonlyReturn = false;
          }
          break;
      }
      return readonlyReturn;
    },
    numberChk: function numberChk(val) {
      this.changeFgl = true;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = get_iterator_default()(this.storeWorkCwProductList), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var item = _step7.value;

          var tempVal = utils.validitMoney(val, 9, 2);
          if (tempVal !== null && tempVal !== '') {
            this.w0002btn2CheckBox = false;
            break;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      val = utils.validitMoney(val, 9, 2);
      return val;
    },

    //图片删除
    fileRemove: function fileRemove() {
      var _this5 = this;

      this.changeFgl = true;
      if (this.$refs.upload1.uploadFiles.length !== 0) {
        this.$confirm(this.$t('COMMON.MSG_WORK_PIC_DEL'), { // 作業数量をリセットします、よろしいですか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: true
        }).then(function () {
          //组件表示图片清空
          _this5.$refs.upload1.clearFiles();
          //上传用list清空
          _this5.updateReceiptPhotoList = [];
          _this5.receiptPhoto1Show = true;
          _this5.has_UpdateLoadedDel = true;
          _this5.changeFgl = true;
          _this5.w0002btn3CheckBox = true;
        }).catch(function () {
          _this5.w0002btn3CheckBox = false;
        });
      }
    },

    //单张图片点击
    handlePictureCardPreview: function handlePictureCardPreview(file, itemName) {
      this[itemName + 'Url'] = file.url;
      this[itemName + 'Visible'] = true;
      this.photoUid = file.uid;
    },

    // 画像上传成功后处理
    handleChange: function handleChange(file, fileList, itemName, type) {
      var _this6 = this;

      var file_type = file.raw.type;
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpeg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(fileList.length - 1, 1);
        }
      } else {
        //变更flg设定
        this.changeFgl = true;
        //假图片框若有的话，隐藏
        if (this[itemName + 'Show'] == true) {
          this[itemName + 'Show'] = false;
        }
        //执行过图片操作处理
        this.has_UpdateLoadedDel = true;
        this.w0002btn3CheckBox = false;
        var that = this;
        this.getBase64(file.raw).then(function () {
          var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(res) {
            var photo, files, timenumber, exhibitionName, photoPath;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return that.compressImg(that.base64ToBlob(res));

                  case 2:
                    photo = _context2.sent;
                    files = new window.File([photo], file.name, { type: file.type });
                    timenumber = utils.timeNumberGet();
                    //拡張子

                    exhibitionName = file.name.split('.')[1];
                    photoPath = 'image/workreceipt/' + that.crewCd + '/workreceipt' + '_' + timenumber + '.' + exhibitionName;

                    _this6.updateReceiptPhotoList.push({
                      'uid': file.uid,
                      'files': files,
                      'photoPath': photoPath
                    });

                  case 8:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this6);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    },


    // 图片转base64
    getBase64: function getBase64(file) {
      return new promise_default.a(function (resolve, reject) {
        var reader = new FileReader();
        var imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },


    // base转blob
    base64ToBlob: function base64ToBlob(file) {
      var byteString = void 0;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1]);
      } else {
        byteString = unescape(file.split(',')[1]);
      }
      var mimeString = file.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },


    // 压缩图片
    compressImg: function compressImg(file) {
      var that = this;
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new promise_default.a(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
                h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);

            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files);
          };
        };
      });
    },

    // 关闭查看器
    closeViewer1: function closeViewer1() {
      var _this7 = this;

      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), { // 写真を削除します。よろしいですか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(function () {
        //this.$refs.upload1.clearFiles()
        _this7.$refs.upload1.uploadFiles = _this7.$refs.upload1.uploadFiles.filter(function (item) {
          return item.uid !== _this7.photoUid;
        });
        _this7.updateReceiptPhotoList = _this7.updateReceiptPhotoList.filter(function (item) {
          return item.uid !== _this7.photoUid;
        });
        _this7.receiptPhoto1Show = _this7.$refs.upload1.uploadFiles.length == 0 ? true : false;
        _this7.receiptPhoto1Visible = false;
        _this7.has_UpdateLoadedDel = true;
        _this7.changeFgl = true;
      }).catch(function () {});
    },

    /* 图片压缩方法-canvas压缩 */
    compressUpload: function compressUpload(image, file) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var initSize = image.src.length;
      var width = image.width,
          height = image.height;
      canvas.width = width;
      canvas.height = height;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);
      // 进行最小压缩0.5
      var isLt2M = file.size / 1024 / 1024;
      var compressData = void 0;
      if (5 < isLt2M < 10) {
        compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.1);
      } else {
        compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.5);
      }
      //压缩后调用方法进行base64转Blob，方法写在下边
      var blobImg = this.dataURItoBlob(compressData);
      return blobImg;
    },

    // 写真检索
    download_Get: function download_Get(filePath, type) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this8['receiptPhoto' + type + 'ImageList'] = [];
                w_0002_w_0002_getImage(filePath).then(function (res_photo) {
                  var blob = new Blob([res_photo], { type: 'image/jpeg' });
                  var url = window.URL.createObjectURL(blob);

                  _this8['receiptPhoto' + type + 'ImageList'].push({ url: url, filePath: filePath });
                  _this8['receiptPhoto' + type + 'Show'] = false;
                }).catch(function (err) {});

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this8);
      }))();
    },

    // 退出登录处理
    log_out: function log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },

    // 戻る処理
    back_click: function back_click() {
      var _this9 = this;

      // this.$alert(this.$t('COMMON.UPDATED'), this.$t('COMMON.CONFIRM'), {//更新しました。
      //   confirmButtonText: this.$t('COMMON.CONFIRM'), // 確認
      //   center: true,
      //   customClass: 'w0002_confirmStyle',
      //   type: 'success'
      // }).then(() => {
      //   var vm = this
      //   vm.$router.push({ path: url.routerUrl_W0001 })
      // })
      if (this.changeFgl === true) {
        this.$confirm(this.$t('COMMON.MSG_RETRUN'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: true
        }).then(function () {
          var vm = _this9;
          vm.$router.push({ path: w_0002_url.routerUrl_W0001 });
        }).catch(function () {});
      } else {
        var vm = this;
        vm.$router.push({ path: w_0002_url.routerUrl_W0001 });
      }
    },

    // 数据保存的返回值（res_code）処理
    res_code_back: function res_code_back(res) {
      var _this10 = this;

      if (res.code == 201 || res.code === 202) {
        this.changeFgl = false;
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }); // 更新成功
        //更新成功的场合，图片操作初始化false
        this.has_UpdateLoadedDel = false;
        this.updateReceiptPhotoList = [];
        this.query();
      } else if (res.code === 308) {
        setTimeout(function () {
          _this10.$confirm(_this10.$t('COMMON.EXCLUSIVE'), _this10.$t('COMMON.CONFIRM'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this10.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this10.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(function () {
            _this10.changeFgl = false;
            var vm = _this10;
            vm.$router.push({ path: w_0002_url.routerUrl_W0001 });
          }).catch(function () {});
        }, 500);
      } else if (res.code == 310) {
        //システム日（yyyy/MM/dd）がパラメータ.作業日と異なる場合
        this.$message.error({ message: this.$t('COMMON.MSG_STOREIN_CHECK'), showClose: true });
      } else if (res.code == 311) {
        // 戻り値コードが「311」の場合、戻り値メッセージを表示し、処理失敗。
        //保存失敗
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });
        this.close_loading();
      } else if (res.code === 408) {
        setTimeout(function () {
          _this10.$confirm(_this10.$t('COMMON.MSG_ERROR_STATE_OVER'), _this10.$t('COMMON.CONFIRM'), { // 作業状態はもう作業完了でした。他の人が先に更新した可能性があります。最新情報を取得しますか？
            confirmButtonText: _this10.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this10.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(function () {
            _this10.changeFgl = false;
            var vm = _this10;
            vm.$router.push({ path: w_0002_url.routerUrl_W0001 });
          }).catch(function () {});
        }, 500);
      } else if (res.code == 417) {
        setTimeout(function () {
          // 戻り値コードが「417」（店舗サイン済確認）の場合、戻り値メッセージを表示する。メッセージ種類：確認メッセージ
          _this10.$confirm(_this10.$t('COMMON.STORE_SIGN_CHECK'), _this10.$t('COMMON.CONFIRM'), {
            confirmButtonText: _this10.$t('COMMON.MSG_DELETE_CONFIRM'),
            cancelButtonText: _this10.$t('COMMON.MSG_DELETE_CANCEL'),
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(function () {
            //はい
            _this10.updateFunction_b();
          }).catch(function () {
            //いいえ
          });
        }, 500);
      } else if (res.code == 426) {
        // 戻り値コードが「426」の場合、MH予測(カゴ車)更新失敗、戻り値メッセージを表示する。
        //商品数量が大きいすぎます。ご確認ください。
        this.$message.error({ message: this.$t('MODULE.W0002_NO_MHCHECK'), showClose: true });
      } else if (res.code == 618) {
        //処理コードが「618」の場合、入力必須の商品数量は入力していない、エラーメッセージを表示する。
        //商品CD({0})の数量は入力必須です。
        this.$message.error({ message: this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK3').replace('{0}', res.items.errorData.description[0].itemName), showClose: true });
      } else if (res.code == 449) {
        //処理コードが「449」の場合、商品数量＞最大値、エラーメッセージを表示する。
        //商品CD({0})は数量＜＝{1}で入力してください。
        this.$message.error({ message: this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK1').replace('{0}', res.items.errorData.description[0].itemName).replace('{1}', res.items.errorData.description[0].itemValue), showClose: true });
      } else if (res.code == 450) {
        //処理コードが「450」の場合、商品数量は最小単位の整数倍ではない、エラーメッセージを表示する。
        //商品CD({0})は数量が{1}の整数倍で入力してください。
        this.$message.error({ message: this.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK2').replace('{0}', res.items.errorData.description[0].itemName).replace('{1}', res.items.errorData.description[0].itemValue), showClose: true });
      } else if (res.code == 412) {
        // 既に「作業中」です。他の人が先に更新した可能性があります。最新情報を取得しますか？
        setTimeout(function () {
          _this10.$confirm(_this10.$t('COMMON.STATE_ING'), _this10.$t('COMMON.CONFIRM'), {
            confirmButtonText: _this10.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this10.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(function () {
            _this10.changeFgl = false;
            var vm = _this10;
            vm.$router.push({ path: w_0002_url.routerUrl_W0001 });
          }).catch(function () {});
        }, 500);
      } else if (res.code == 614) {
        //ステータスが「クルー確定」以外のスケジュールは開始できません。
        this.$message.error({ message: this.$t('COMMON.MSG_STATUS_ERROR'), showClose: true });
      } else if (res.code == 428) {
        // 店舗サインがありません。作業完了してもよろしいですか？
        setTimeout(function () {
          _this10.$confirm(_this10.$t('COMMON.MSG_TRANSMIT'), _this10.$t('COMMON.CONFIRM'), {
            confirmButtonText: _this10.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: _this10.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true,
            customClass: 'w0002_confirmStyle',
            type: 'warning'
          }).then(function () {
            _this10.changeFgl = false;
            var vm = _this10;
            vm.$router.push({ path: w_0002_url.routerUrl_W0001 });
          }).catch(function () {});
        }, 500);
      } else if (res.code == 402) {
        //入店・退店時刻は未入力の勤怠があるため
        this.$message.error({ message: this.$t('COMMON.STORETIME_NOT_INPUT'), showClose: true });
      } else if (res.code == 424) {
        //作業実績がないため
        this.$message.error({ message: this.$t('COMMON.WORK_NOT_INPUT'), showClose: true });
      } else if (res.code == 632) {
        //現場曜日別商品が変更されました。作業実績を再保存してください。
        this.$message.error({ message: this.$t('COMMON.MSG_PRODUCT_UNMATCH'), showClose: true });
      }
    },
    updateFunction_b: function updateFunction_b() {
      var _this11 = this;

      this.updateParams.div = '2';
      //调用服务端接口
      w_0002_w_0002_update(this.updateParams).then(function (res) {
        var code = res.code;
        switch (code) {
          case 202:
            //戻り値コードが「202」の場合、戻り値メッセージを表示し、画面をリフレッシュし、処理完了。
            _this11.$message.success({ message: _this11.$t('COMMON.UPDATED'), showClose: true }); //保存成功
            _this11.changeFgl = false;
            _this11.has_UpdateLoadedDel = false;
            _this11.updateReceiptPhotoList = [];
            _this11.query();
            break;
          case 308:
            // 戻り値コードが「308」の場合、排他エラーになり、戻り値メッセージを表示する
            //処理が失敗しました。他の人が先に更新した可能性があります。最新情報を取得しますか。
            setTimeout(function () {
              _this11.$confirm(_this11.$t('COMMON.EXCLUSIVE'), _this11.$t('COMMON.CONFIRM'), { //排他発生になる
                confirmButtonText: _this11.$t('COMMON.MSG_DELETE_CONFIRM'), //を選択します
                cancelButtonText: _this11.$t('COMMON.MSG_DELETE_CANCEL'), //キャンセル
                center: true,
                customClass: 'w0002_confirmStyle',
                type: 'warning'
              }).then(function () {
                //はい
                _this11.changeFgl = false;
                _this11.query();
              }).catch(function () {
                //いいえ
              });
            }, 500);
            break;
          case 311:
            // 戻り値コードが「311」の場合、戻り値メッセージを表示し、処理失敗。
            _this11.$message.error({ message: _this11.$t('COMMON.CURD_ERROR'), showClose: true }); //保存失敗
            break;
          case 426:
            // 戻り値コードが「426」の場合、MH予測(カゴ車)更新失敗、戻り値メッセージを表示する。
            _this11.$message.error({ message: _this11.$t('MODULE.W0002_NO_MHCHECK'), showClose: true }); //商品数量が大きいすぎます。ご確認ください。
            break;
          case 618:
            //処理コードが「618」の場合、入力必須の商品数量は入力していない、エラーメッセージを表示する。
            //商品CD({0})の数量は入力必須です。
            _this11.$message.error({ message: _this11.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK3').replace('{0}', res.items.errorData.description[0].itemName), showClose: true });
            break;
          case 449:
            //処理コードが「449」の場合、商品数量＞最大値、エラーメッセージを表示する。
            //商品CD({0})は数量＜＝{1}で入力してください。
            _this11.$message.error({ message: _this11.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK1').replace('{0}', res.items.errorData.description[0].itemName).replace('{1}', res.items.errorData.description[0].itemValue), showClose: true });
            break;
          case 450:
            //処理コードが「450」の場合、商品数量は最小単位の整数倍ではない、エラーメッセージを表示する。
            //商品CD({0})は数量が{1}の整数倍で入力してください。
            _this11.$message.error({ message: _this11.$t('COMMON.MSG_PRODUCT_NUMBERS_CHECK2').replace('{0}', res.items.errorData.description[0].itemName).replace('{1}', res.items.errorData.description[0].itemValue), showClose: true });
            break;
        }
      });
    }
  },
  // 初期化自动调用
  created: function created() {
    this.obj = JSON.parse(localStorage.getItem('obj'));
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.crewCd = this.obj.crewCd;
    this.jobDate = this.obj.jobDate;
    this.fieldCd = this.obj.fieldCd;
    this.fieldName = this.obj.fieldName;
    this.companyName = this.obj.companyName;
    this.jobState = this.obj.jobState;
    this.week = utils.getWeek(this.jobDate);
    this.query();
    if (this.jobState == '1') {
      this.jobState_working = true;
    } else {
      this.jobState_working = false;
    }
  },
  mounted: function mounted() {
    //点击删除按钮之外的地方退出长按模式
    var that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.receiptPhoto1LongClick = false; //是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions' && e.target.className != 'el-icon-refresh-left' && e.target.className != 'el-icon-refresh-right' && e.target.className != 'el-icon-c-scale-to-original' && e.target.className != 'el-icon-zoom-in' && e.target.className != 'el-icon-zoom-out' && e.target.className != 'el-image-viewer__actions__inner' && e.target.className != 'el-icon-full-screen' && e.target.className != 'el-icon-circle-close' && e.target.className != 'el-button el-button--default el-button--small') {
        that.receiptPhoto1Visible = false;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95ffed12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/page/w_0002.vue
var w_0002_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all_area_w0002 "},[_c('div',{staticClass:"search-module_w0002"},[_c('el-row',[_c('el-col',{staticClass:"el-col_w0002",attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple readonly_input"},[_c('span',{staticClass:"span_search_condition_w0002 "},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_CORPORATION_NAME')))]),_vm._v(" "),_c('el-input',{staticClass:" css-input-width_w0002 ",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","readonly":true},model:{value:(_vm.companyName),callback:function ($$v) {_vm.companyName=$$v},expression:"companyName"}})],1)]),_vm._v(" "),_c('el-col',{staticClass:"el-col_w0002",attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple readonly_input"},[_c('span',{staticClass:"span_search_condition_w0002",attrs:{"size":"small"}},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_STORE_NAME')))]),_vm._v(" "),_c('el-input',{staticClass:"css-input-width_w0002",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","readonly":true},model:{value:(_vm.fieldName),callback:function ($$v) {_vm.fieldName=$$v},expression:"fieldName"}})],1)]),_vm._v(" "),_c('el-col',{staticClass:"el-col_w0002",attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple readonly_input"},[_c('span',{staticClass:"span_search_condition_w0002"},[_vm._v(_vm._s(_vm.$t('COMMON.LBL_WORKDAY')))]),_vm._v(" "),_c('el-input',{staticClass:"css-input-width_w0002 ",staticStyle:{"margin-top":"8px","margin-left":"10px"},attrs:{"size":"small","readonly":true},model:{value:(_vm.jobDate),callback:function ($$v) {_vm.jobDate=$$v},expression:"jobDate"}})],1)])],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.jobState=='0'),expression:"jobState=='0'"}],staticStyle:{"text-align":"right"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-bottom":"10px","margin-right":"5px","font-size":"10pt","width":"34%"},attrs:{"type":"primary","disabled":_vm.NeedReadonly('BTN1')},on:{"click":_vm.clickWork}},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_BTN1_1')))])],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.jobState=='1'),expression:"jobState=='1'"}],staticStyle:{"text-align":"right"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-bottom":"10px","margin-right":"5px","font-size":"10pt","width":"34%"},attrs:{"type":"primary","disabled":_vm.NeedReadonly('BTN1')},on:{"click":_vm.clickWork}},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_BTN1_2')))])],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.jobState=='2'),expression:"jobState=='2'"}],staticStyle:{"text-align":"right"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-bottom":"10px","margin-right":"5px","font-size":"10pt","width":"34%"},attrs:{"type":"primary","disabled":_vm.NeedReadonly('BTN1')},on:{"click":_vm.clickWork}},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_BTN1_3')))])],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.jobState=='0'),expression:"jobState=='0'"}]},[_c('el-checkbox',{staticClass:"checkbox_w0002",staticStyle:{"margin-left":"10px"},attrs:{"disabled":_vm.NeedReadonly('BTN2')},on:{"change":_vm.btn2CheckChange},model:{value:(_vm.w0002btn2CheckBox),callback:function ($$v) {_vm.w0002btn2CheckBox=$$v},expression:"w0002btn2CheckBox"}},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_BTN2')))])],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.jobState=='1'),expression:"jobState=='1'"}]},[_c('el-checkbox',{staticClass:"checkbox_w0002",staticStyle:{"margin-left":"10px"},attrs:{"disabled":_vm.NeedReadonly('BTN2')},on:{"change":_vm.btn2CheckChange},model:{value:(_vm.w0002btn2CheckBox),callback:function ($$v) {_vm.w0002btn2CheckBox=$$v},expression:"w0002btn2CheckBox"}},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_BTN2')))])],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.jobState=='2'),expression:"jobState=='2'"}]},[_c('el-checkbox',{staticClass:"checkbox_w0002",staticStyle:{"margin-left":"10px"},attrs:{"disabled":_vm.NeedReadonly('BTN2')},on:{"change":_vm.btn2CheckChange},model:{value:(_vm.w0002btn2CheckBox),callback:function ($$v) {_vm.w0002btn2CheckBox=$$v},expression:"w0002btn2CheckBox"}},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_BTN2')))])],1),_vm._v(" "),_c('div',{staticClass:"el-detail_w0002"},[_vm._l((_vm.storeWorkCwProductList),function(item,index){return [(index % 2 === 0 && index < _vm.storeWorkCwProductList.length - 1)?_c('el-row',[_c('div',{staticClass:"div_span_w0002 "},[_c('span',{staticClass:"input_span_w0002"},[_vm._v(_vm._s(item.productCd)+" "),_c('br'),_vm._v(_vm._s(item.productName))]),_vm._v(" "),_c('span',{staticClass:"input_span_w0002"},[_vm._v(_vm._s(_vm.storeWorkCwProductList[index+1].productCd)+" "),_c('br'),_vm._v(_vm._s(_vm.storeWorkCwProductList[index+1].productName))])])]):_vm._e(),_vm._v(" "),(index % 2 === 0 &&  index === _vm.storeWorkCwProductList.length - 1)?_c('el-row',[_c('div',{staticClass:"div_span_w0002 "},[_c('span',{staticClass:"input_span_w0002"},[_vm._v(_vm._s(item.productCd)+" "),_c('br'),_vm._v(_vm._s(item.productName))])])]):_vm._e(),_vm._v(" "),(index % 2 === 0 && index < _vm.storeWorkCwProductList.length - 1)?_c('el-row',[_c('div',{staticClass:"div_input_w0002 "},[_c('el-input',{staticClass:"input_input1_w0002",attrs:{"readonly":_vm.NeedReadonly('BTN2')},on:{"input":function($event){item.productNumbers = _vm.numberChk(item.productNumbers)}},model:{value:(item.productNumbers),callback:function ($$v) {_vm.$set(item, "productNumbers", $$v)},expression:"item.productNumbers"}}),_vm._v(" "),_c('el-input',{staticClass:"input_input1_w0002",attrs:{"readonly":_vm.NeedReadonly('BTN2')},on:{"input":function($event){_vm.storeWorkCwProductList[index+1].productNumbers = _vm.numberChk(_vm.storeWorkCwProductList[index+1].productNumbers)}},model:{value:(_vm.storeWorkCwProductList[index+1].productNumbers),callback:function ($$v) {_vm.$set(_vm.storeWorkCwProductList[index+1], "productNumbers", $$v)},expression:"storeWorkCwProductList[index+1].productNumbers"}})],1)]):_vm._e(),_vm._v(" "),(index % 2 === 0 && index === _vm.storeWorkCwProductList.length - 1)?_c('el-row',[_c('div',{staticClass:"div_input_w0002 "},[_c('el-input',{staticClass:"input_input1_w0002",attrs:{"readonly":_vm.NeedReadonly('BTN2')},on:{"input":function($event){item.productNumbers = _vm.numberChk(item.productNumbers)}},model:{value:(item.productNumbers),callback:function ($$v) {_vm.$set(item, "productNumbers", $$v)},expression:"item.productNumbers"}})],1)]):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"div_span2_w0002"},[_c('span',{staticClass:"input_span_w0002"},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_TEXTERA1')))])]),_vm._v(" "),_c('el-row',[_c('el-input',{staticClass:"input_textarea_w0002",attrs:{"type":"textarea","maxlength":"500","rows":2,"readonly":_vm.NeedReadonly('BTN3')},on:{"input":function($event){_vm.changeFgl = true}},model:{value:(_vm.cwNotices),callback:function ($$v) {_vm.cwNotices=$$v},expression:"cwNotices"}})],1),_vm._v(" "),_c('el-row'),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"div_span2_w0002"},[_c('span',{staticClass:"input_span_w0002"},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_PHOTO_INFO')))])])]),_vm._v(" "),_c('el-row',[_c('div',{staticStyle:{"background-color":"#d2eef8"}},[_c('el-checkbox',{staticClass:"checkbox_w0002",staticStyle:{"margin-left":"10px"},attrs:{"disabled":_vm.NeedReadonly('BTN3')},on:{"change":_vm.fileRemove},model:{value:(_vm.w0002btn3CheckBox),callback:function ($$v) {_vm.w0002btn3CheckBox=$$v},expression:"w0002btn3CheckBox"}},[_vm._v(_vm._s(_vm.$t('MODULE.W0002_LBL_BTN3')))])],1),_vm._v(" "),_c('div',{staticClass:"photo_div"},[(_vm.receiptPhoto1Show)?_c('div',{staticClass:"image_border"}):_vm._e(),_vm._v(" "),_c('el-upload',{ref:"upload1",attrs:{"disabled":_vm.NeedReadonly('BTN3'),"show-file-list":true,"file-list":_vm.receiptPhoto1ImageList,"list-type":"picture-card","limit":5,"accept":"image/jpeg,image/gif,image/png,image/bmp,image/jpeg","action":"#","on-change":function (file, fileList){_vm.handleChange(file, fileList,'receiptPhoto1','1')},"auto-upload":false},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return _c('div',{},[_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"id":"receiptPhoto1","src":file.url,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions",on:{"click":function($event){return _vm.handlePictureCardPreview(file,'receiptPhoto1')}}},[(false)?_c('span',{staticClass:"el-upload-list__item-delete"}):_vm._e()])])}}])},[_c('i',{staticClass:"el-icon-camera-solid avatar-uploader-icon",staticStyle:{"font-size":"28px"}})]),_vm._v(" "),(_vm.receiptPhoto1Visible)?_c('el-image-viewer',{class:{image_view_red:_vm.jobState_working,image_view_hidden:!_vm.jobState_working},attrs:{"on-close":_vm.closeViewer1,"url-list":[_vm.receiptPhoto1Url]}}):_vm._e()],1)])],2),_vm._v(" "),_c('div',[_c('el-row',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary","disabled":_vm.NeedReadonly('BTN4')},on:{"click":_vm.save_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_SAVE')))]),_vm._v(" "),_c('el-button',{staticClass:"css-btn css-button",staticStyle:{"margin-top":"8px","font-size":"10pt","width":"20%"},attrs:{"type":"primary"},on:{"click":_vm.back_click}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))])],1)],1)],1)])}
var w_0002_staticRenderFns = []
var w_0002_esExports = { render: w_0002_render, staticRenderFns: w_0002_staticRenderFns }
/* harmony default export */ var page_w_0002 = (w_0002_esExports);
// CONCATENATED MODULE: ./src/module/page/w_0002.vue
function w_0002_injectStyle (ssrContext) {
  __webpack_require__("JH3r")
}
var w_0002_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var w_0002___vue_template_functional__ = false
/* styles */
var w_0002___vue_styles__ = w_0002_injectStyle
/* scopeId */
var w_0002___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var w_0002___vue_module_identifier__ = null
var w_0002_Component = w_0002_normalizeComponent(
  w_0002,
  page_w_0002,
  w_0002___vue_template_functional__,
  w_0002___vue_styles__,
  w_0002___vue_scopeId__,
  w_0002___vue_module_identifier__
)

/* harmony default export */ var module_page_w_0002 = (w_0002_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/error.vue
//
//
//
//
//
//


var error_url = __webpack_require__("kspH");
/* harmony default export */ var page_error = ({
  mixins: [css],
  data: function data() {
    return {
      imgUrl: __webpack_require__("UPca")
    };
  },

  methods: {
    to_login: function to_login() {
      var vm = this;
      //this.$router.push({ path: "/login"});
      window.location.reload(true);
    }
  },
  created: function created() {
    this.close_loading();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cefd587","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/error.vue
var error_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('el-button',{staticClass:"back",staticStyle:{"display":"block"},on:{"click":_vm.to_login}},[_vm._v(_vm._s(_vm.$t('COMMON.BTN_BACK')))])],1)}
var error_staticRenderFns = []
var error_esExports = { render: error_render, staticRenderFns: error_staticRenderFns }
/* harmony default export */ var components_page_error = (error_esExports);
// CONCATENATED MODULE: ./src/components/page/error.vue
function error_injectStyle (ssrContext) {
  __webpack_require__("LIDY")
}
var error_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var error___vue_template_functional__ = false
/* styles */
var error___vue_styles__ = error_injectStyle
/* scopeId */
var error___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var error___vue_module_identifier__ = null
var error_Component = error_normalizeComponent(
  page_error,
  components_page_error,
  error___vue_template_functional__,
  error___vue_styles__,
  error___vue_scopeId__,
  error___vue_module_identifier__
)

/* harmony default export */ var src_components_page_error = (error_Component.exports);

// CONCATENATED MODULE: ./src/base/router/index.js


var router_url = __webpack_require__("kspH");
//ログイン

//ログイン2

//パスワードリセット

//ログイン

//メニュー

//k_0001_勤怠入力

//k_0002_勤怠詳細

//k_0003_スキル確認

//k_0005_問合せ

//k_0006_経費一覧

//k_0007_経費詳細

//k_0008_オフィス事務センター


//i_0001_プロフィール基本

//i_0002_本人確認書類申請

//i_0003_給与振込口座申請

//i_0004_緊急連絡先申請


//i_0005_マイナンバー申請

//i_0006_マイナンバー

//i_0007_在留カード番号申請

//i_0008_マイカー通勤申請

//i_0009_本人確認書類選択

//i_0010_国籍確認

//i_0011_誓約・同意

//i_0012_初期ログイン_パスワード変更

//i_0013_マイカー通勤申請確認

//i_0014_初期トレーニング

//i_0015_有休一覧

//i_0016_有休詳細

//i_0017_お仕事紹介





//c_0001_契約照会 一覧

//c_0002_契約照会 詳細

//c_0003_労働条件通知書


// s_0001_出勤可能日申請


//d_0001_源泉徴収票


// p_0001_支給照会 一覧

// p_0002_支給照会 賃金詳細

// p_0003_支給照会 賃金内訳一覧

// p_0004_支給照会 賃金内訳詳細


// お知らせ一覧

// お知らせ詳細

// 作業量一覧

// 作業量詳細


// error


vue_esm["default"].use(vue_router_esm["a" /* default */]);

// メニュー配置
/* harmony default export */ var router = ([{ path: '/', redirect: router_url.routerUrl_Login }, {
  path: router_url.routerUrl_Login, name: 'ログイン', component: src_components_page_login,
  meta: {
    requireAuth: false
  }
}, {
  path: '/Home',
  component: src_components_page_home,
  children: [{
    path: router_url.routerUrl_Top,
    name: 'ホーム',
    component: src_components_page_top
  }, {
    path: router_url.routerUrl_PasswordReset,
    name: 'パスワードリセット',
    component: src_components_page_passwordReset
  }, {
    path: router_url.routerUrl_PasswordResetDeliver,
    name: 'PasswordResetDeliver',
    component: components_page_passwordResetDeliver
  }, {
    path: router_url.routerUrl_K0001,
    name: '勤怠入力',
    component: src_module_page_k_0001
  }, {
    path: router_url.routerUrl_K0002,
    name: '勤怠詳細',
    component: src_module_page_k_0002
  }, {
    path: router_url.routerUrl_K0003,
    name: 'スキル確認',
    component: module_page_k_0003
  }, {
    path: router_url.routerUrl_K0005,
    name: '問合せ',
    component: module_page_k_0005
  }, {
    path: router_url.routerUrl_K0006,
    name: '経費一覧',
    component: src_module_page_k_0006
  }, {
    path: router_url.routerUrl_K0007,
    name: '経費詳細',
    component: src_module_page_k_0007
  }, {
    path: router_url.routerUrl_K0008,
    name: 'オフィス事務センター',
    component: module_page_k_0008
  }, {
    path: router_url.routerUrl_I0001,
    name: 'スタッフ基本情報',
    component: module_page_i_0001
  }, {
    path: router_url.routerUrl_I0002,
    name: '本人確認書類申請',
    component: module_page_i_0002
  }, {
    path: router_url.routerUrl_I0003,
    name: '給与振込口座申請',
    component: module_page_i_0003
  }, {
    path: router_url.routerUrl_I0004,
    name: '緊急連絡先申請',
    component: module_page_i_0004
  }, {
    path: router_url.routerUrl_DialogAddress,
    name: '共通住所',
    component: components_page_dialogAddress
  }, {
    path: router_url.routerUrl_I0005,
    name: 'マイナンバー申請確認',
    component: module_page_i_0005
  }, {
    path: router_url.routerUrl_I0006,
    name: 'マイナンバー申請',
    component: module_page_i_0006
  }, {
    path: router_url.routerUrl_I0007,
    name: '在留カード番号申請',
    component: module_page_i_0007
  }, {
    path: router_url.routerUrl_I0008,
    name: 'マイカー通勤･業務使用申請',
    component: module_page_i_0008
  }, {
    path: router_url.routerUrl_I0009,
    name: '本人確認書類選択',
    component: module_page_i_0009
  }, {
    path: router_url.routerUrl_I0010,
    name: '国籍確認',
    component: module_page_i_0010
  }, {
    path: router_url.routerUrl_I0011,
    name: '告知書兼同意書及び誓約書',
    component: module_page_i_0011
  }, {
    path: router_url.routerUrl_I0012,
    name: '初回ログイン',
    component: module_page_i_0012
  }, {
    path: router_url.routerUrl_I0013,
    name: 'マイカー通勤･業務使用申請確認',
    component: module_page_i_0013
  }, {
    path: router_url.routerUrl_I0014,
    name: '初期トレーニング',
    component: module_page_i_0014
  }, {
    path: router_url.routerUrl_I0015,
    name: '有休一覧',
    component: module_page_i_0015
  }, {
    path: router_url.routerUrl_I0016,
    name: '有休詳細',
    component: module_page_i_0016
  }, {
    path: router_url.routerUrl_I0017,
    name: 'お仕事案内',
    component: module_page_i_0017
  }, {
    path: router_url.routerUrl_I0018,
    name: 'お仕事選択',
    component: module_page_i_0018
  }, {
    path: router_url.routerUrl_I0019,
    name: 'お仕事詳細',
    component: module_page_i_0019
  }, {
    path: router_url.routerUrl_I0020,
    name: 'お仕事申請',
    component: module_page_i_0020
  }, {
    path: router_url.routerUrl_C0001,
    name: '契約照会',
    component: src_module_page_c_0001
  }, {
    path: router_url.routerUrl_C0002,
    name: '契約詳細',
    component: src_module_page_c_0002
  }, {
    path: router_url.routerUrl_C0003,
    name: '労働条件通知書',
    component: module_page_c_0003
  }, {
    path: router_url.routerUrl_S0001,
    name: 'スケジュール',
    component: module_page_s_0001
  }, {
    path: router_url.routerUrl_D0001,
    name: '源泉徴収票',
    component: module_page_d_0001
  }, {
    path: router_url.routerUrl_P0001,
    name: '給与照会',
    component: src_module_page_p_0001
  }, {
    path: router_url.routerUrl_P0002,
    name: '給与明細',
    component: module_page_p_0002
  }, {
    path: router_url.routerUrl_P0003,
    name: '賞与明細',
    component: module_page_p_0003
  }, {
    path: router_url.routerUrl_P0004,
    name: '源泉明細',
    component: module_page_p_0004
  }, {
    path: router_url.routerUrl_B0001,
    name: 'お知らせ一覧',
    component: module_page_b_0001
  }, {
    path: router_url.routerUrl_B0002,
    name: 'お知らせ詳細',
    component: module_page_b_0002
  }, {
    path: router_url.routerUrl_W0001,
    name: '作業量一覧',
    component: module_page_w_0001
  }, {
    path: router_url.routerUrl_W0002,
    name: '作業量詳細',
    component: module_page_w_0002
  }]
}, {
  path: router_url.routerUrl_Error,
  name: '勤怠Error画面',
  component: src_components_page_error
}, {
  path: '*', redirect: router_url.routerUrl_Login
}]);
// EXTERNAL MODULE: ./src/statics/css/site.css
var site = __webpack_require__("j1MG");
var site_default = /*#__PURE__*/__webpack_require__.n(site);

// EXTERNAL MODULE: ./node_modules/vue-cookies/vue-cookies.js
var vue_cookies = __webpack_require__("ppUw");
var vue_cookies_default = /*#__PURE__*/__webpack_require__.n(vue_cookies);

// EXTERNAL MODULE: ./src/statics/icon/iconfont.js
var iconfont = __webpack_require__("6pZO");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// EXTERNAL MODULE: ./src/statics/fileIcon/iconfont.js
var fileIcon_iconfont = __webpack_require__("I5KZ");
var fileIcon_iconfont_default = /*#__PURE__*/__webpack_require__.n(fileIcon_iconfont);

// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.css
var swiper_bundle = __webpack_require__("wNQb");
var swiper_bundle_default = /*#__PURE__*/__webpack_require__.n(swiper_bundle);

// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("7QTg");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// EXTERNAL MODULE: ./node_modules/vue-tabs-swiper/component/index.js
var vue_tabs_swiper_component = __webpack_require__("Ef5k");
var component_default = /*#__PURE__*/__webpack_require__.n(vue_tabs_swiper_component);

// CONCATENATED MODULE: ./src/common/plugin.js


/* harmony default export */ var common_plugin = ({
  install: function install() {
    vue_esm["default"].mixin({
      methods: {
        // 成功信息提示
        $msg_sus: function $msg_sus(message) {
          var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

          this.$msg_close();
          this.$message({
            showClose: true,
            message: message,
            duration: duration,
            type: 'success'
          });
        },


        // 警告信息提示
        $msg_war: function $msg_war(message) {
          var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

          this.$msg_close();
          this.$message({
            showClose: true,
            message: message,
            duration: duration,
            type: 'warning'
          });
        },


        // 错误信息提示
        $msg_err: function $msg_err(message) {
          var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

          this.$msg_close();
          this.$message({
            showClose: true,
            message: message,
            duration: duration,
            type: 'error'
          });
        },


        // 关闭message
        $msg_close: function $msg_close() {
          this.$message.closeAll();
        },


        /* 
          1.确认提示框(移动端改)
          2.message：提示信息
          3.confirmButtonText默认值："はい"、cancelButtonText默认值："いいえ"，如需改成其他，直接传参即可
          4.确认时返回true,取消时返回false
        */
        $confirm_hint: function $confirm_hint(message) {
          var _this = this;

          var confirmButtonText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$t('COMMON.MSG_DELETE_CONFIRM');
          var cancelButtonText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$t('COMMON.MSG_DELETE_CANCEL');

          return new promise_default.a(function (resolve, reject) {
            _this.$confirm(message, _this.$t('COMMON.CONFIRM'), {
              confirmButtonText: confirmButtonText,
              cancelButtonText: cancelButtonText,
              type: 'warning',
              center: true,
              showClose: false,
              customClass: 'confirmStyle'
            }).then(function () {
              resolve(true);
            }).catch(function () {
              resolve(false);
            });
          });
        }
      }
    });
  }
});
// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("8+8L");

// CONCATENATED MODULE: ./src/main.js



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















// 引入自定义插件

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(component_default.a);
vue_esm["default"].use(vue_awesome_swiper_default.a);
// 在Vue中全局使用mintui
vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].use(vuex_esm["a" /* default */]);
vue_esm["default"].use(vue_router_esm["a" /* default */]);
vue_esm["default"].use(vue_cookies_default.a);
vue_esm["default"].use(iconfont_default.a);
vue_esm["default"].use(fileIcon_iconfont_default.a);
// 在Vue中全局使用自定义插件
vue_esm["default"].use(common_plugin);
//  将vue-resource在vue中绑定，自动在vue对象实例上注入一个$http对象就可以使用ajax方法了

vue_esm["default"].use(vue_resource_esm["a" /* default */]);
/* eslint-disable no-new */
var main_router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  // change url by qiujing 20200228
  base: '/amsMobAttWeb/',
  //base: '/amsMoAttWeb/',
  routes: router
});

//全局实现避免消息提示多次弹出
// 为了实现Class的私有属性
var showMessage = symbol_default()('showMessage');
/**
 *  重写ElementUI的Message
 *  single默认值true，因为项目需求，默认只弹出一个，可以根据实际需要设置
 */

var main_DonMessage = function () {
  function DonMessage() {
    classCallCheck_default()(this, DonMessage);
  }

  createClass_default()(DonMessage, [{
    key: 'success',
    value: function success(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this[showMessage]('success', options, single);
    }
  }, {
    key: 'warning',
    value: function warning(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this[showMessage]('warning', options, single);
    }
  }, {
    key: 'info',
    value: function info(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this[showMessage]('info', options, single);
    }
  }, {
    key: 'error',
    value: function error(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this[showMessage]('error', options, single);
    }
  }, {
    key: showMessage,
    value: function value(type, options, single) {
      if (single) {
        // 判断是否已存在Message
        if (document.getElementsByClassName('el-message').length === 0) {
          element_ui_common["Message"][type](options);
        }
      } else {
        element_ui_common["Message"][type](options);
      }
    }
  }]);

  return DonMessage;
}();
// 命名根据需要，DonMessage只是在文章中使用


vue_esm["default"].prototype.$message = new main_DonMessage();
main_router.beforeEach(function (to, from, next) {
  if (to.meta.name || to.name != null) {
    var routeName = (to.meta.name || to.name).split('>');
    routeName = routeName[routeName.length - 1];
    window.document.title = (routeName ? routeName + ' - ' : '') + 'RMSAスタッフアプリ';
    next();
  } else {
    window.document.title = 'RMSAスタッフアプリ';
  }
});

vue_esm["default"].prototype.$message.close = function (id, userOnClose) {
  return element_ui_common_default.a.Message.close(id, userOnClose);
};
vue_esm["default"].prototype.$message.closeAll = function () {
  return element_ui_common_default.a.Message.closeAll();
};

new vue_esm["default"]({
  el: '#app',
  i18n: message_i18n,
  router: main_router,
  store: store,
  render: function render(c) {
    return c(src_App);
  }
});

/***/ }),

/***/ "NVQd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O3N8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OBZi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAB0klEQVQ4je2TT0tUURjGf+fOdRqvd5ywlAEjs6BVuBFyqVkQiItoUaTLcNk3aDkfIAhq00KEEjduglZFgpv+4EKpdgrTFeH2z2ZG5545M+fcFnNH7lzs+gV84Nk8533e9zmH98ApxO9XW0ltArgP3ARGgCbgAWvACvCxq8GvpaMG/UAJeAg4/xkYAC+Ax0AVwDZNiAwvgdkTEvcCj4DRKGXdMoqMUZSMYtYoSGPoFjC5PFFtySgyllaMa8WCVpDGVibHwMww5LIdbUErxm0jxTzgpuUOsShMFalvB6jtCiIURJ55W0umTrg3PaMFnKsue893CAMdP7pha8lIXLHyWdAhpt5+Xc5kuXCniL/q0/oZJHtftLWkGVfyk+fovezwY3kXXVEM3B5C7jU43Nynu7IN20jhAec7Qu3DX5xLDkP3hjn4dkj/mEv5iYepGUAk/d8tLVnXEjqUZcnuM49WRVO8O4j/+g/KqxOvifG92Jr7ch14C+S7op3toe+aS/VzlbChk5MBasAt2zTYABZpb9gRlN9E+fvHGTtYBDZs3RCa9m5fAWbSHDG8iTzaita0ahRzRvHUKIKUdQ6imgeRB/Fp+muye/I7A5SBdxzznU8B/wC/0/cmZc1iMAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "POKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-resize-sensor/src/resize-sensor.vue
//
//
//
//
//
//



/* harmony default export */ var resize_sensor = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-resize-sensor/src/resize-sensor.vue
function injectStyle (ssrContext) {
  __webpack_require__("8Y90")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  resize_sensor,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_resize_sensor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pd1n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QOO/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RYcG":
/***/ (function(module, exports) {

module.exports = {"O_RDONLY":0,"O_WRONLY":1,"O_RDWR":2,"S_IFMT":61440,"S_IFREG":32768,"S_IFDIR":16384,"S_IFCHR":8192,"S_IFBLK":24576,"S_IFIFO":4096,"S_IFLNK":40960,"S_IFSOCK":49152,"O_CREAT":512,"O_EXCL":2048,"O_NOCTTY":131072,"O_TRUNC":1024,"O_APPEND":8,"O_DIRECTORY":1048576,"O_NOFOLLOW":256,"O_SYNC":128,"O_SYMLINK":2097152,"O_NONBLOCK":4,"S_IRWXU":448,"S_IRUSR":256,"S_IWUSR":128,"S_IXUSR":64,"S_IRWXG":56,"S_IRGRP":32,"S_IWGRP":16,"S_IXGRP":8,"S_IRWXO":7,"S_IROTH":4,"S_IWOTH":2,"S_IXOTH":1,"E2BIG":7,"EACCES":13,"EADDRINUSE":48,"EADDRNOTAVAIL":49,"EAFNOSUPPORT":47,"EAGAIN":35,"EALREADY":37,"EBADF":9,"EBADMSG":94,"EBUSY":16,"ECANCELED":89,"ECHILD":10,"ECONNABORTED":53,"ECONNREFUSED":61,"ECONNRESET":54,"EDEADLK":11,"EDESTADDRREQ":39,"EDOM":33,"EDQUOT":69,"EEXIST":17,"EFAULT":14,"EFBIG":27,"EHOSTUNREACH":65,"EIDRM":90,"EILSEQ":92,"EINPROGRESS":36,"EINTR":4,"EINVAL":22,"EIO":5,"EISCONN":56,"EISDIR":21,"ELOOP":62,"EMFILE":24,"EMLINK":31,"EMSGSIZE":40,"EMULTIHOP":95,"ENAMETOOLONG":63,"ENETDOWN":50,"ENETRESET":52,"ENETUNREACH":51,"ENFILE":23,"ENOBUFS":55,"ENODATA":96,"ENODEV":19,"ENOENT":2,"ENOEXEC":8,"ENOLCK":77,"ENOLINK":97,"ENOMEM":12,"ENOMSG":91,"ENOPROTOOPT":42,"ENOSPC":28,"ENOSR":98,"ENOSTR":99,"ENOSYS":78,"ENOTCONN":57,"ENOTDIR":20,"ENOTEMPTY":66,"ENOTSOCK":38,"ENOTSUP":45,"ENOTTY":25,"ENXIO":6,"EOPNOTSUPP":102,"EOVERFLOW":84,"EPERM":1,"EPIPE":32,"EPROTO":100,"EPROTONOSUPPORT":43,"EPROTOTYPE":41,"ERANGE":34,"EROFS":30,"ESPIPE":29,"ESRCH":3,"ESTALE":70,"ETIME":101,"ETIMEDOUT":60,"ETXTBSY":26,"EWOULDBLOCK":35,"EXDEV":18,"SIGHUP":1,"SIGINT":2,"SIGQUIT":3,"SIGILL":4,"SIGTRAP":5,"SIGABRT":6,"SIGIOT":6,"SIGBUS":10,"SIGFPE":8,"SIGKILL":9,"SIGUSR1":30,"SIGSEGV":11,"SIGUSR2":31,"SIGPIPE":13,"SIGALRM":14,"SIGTERM":15,"SIGCHLD":20,"SIGCONT":19,"SIGSTOP":17,"SIGTSTP":18,"SIGTTIN":21,"SIGTTOU":22,"SIGURG":16,"SIGXCPU":24,"SIGXFSZ":25,"SIGVTALRM":26,"SIGPROF":27,"SIGWINCH":28,"SIGIO":23,"SIGSYS":12,"SSL_OP_ALL":2147486719,"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION":262144,"SSL_OP_CIPHER_SERVER_PREFERENCE":4194304,"SSL_OP_CISCO_ANYCONNECT":32768,"SSL_OP_COOKIE_EXCHANGE":8192,"SSL_OP_CRYPTOPRO_TLSEXT_BUG":2147483648,"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS":2048,"SSL_OP_EPHEMERAL_RSA":0,"SSL_OP_LEGACY_SERVER_CONNECT":4,"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER":32,"SSL_OP_MICROSOFT_SESS_ID_BUG":1,"SSL_OP_MSIE_SSLV2_RSA_PADDING":0,"SSL_OP_NETSCAPE_CA_DN_BUG":536870912,"SSL_OP_NETSCAPE_CHALLENGE_BUG":2,"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG":1073741824,"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG":8,"SSL_OP_NO_COMPRESSION":131072,"SSL_OP_NO_QUERY_MTU":4096,"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION":65536,"SSL_OP_NO_SSLv2":16777216,"SSL_OP_NO_SSLv3":33554432,"SSL_OP_NO_TICKET":16384,"SSL_OP_NO_TLSv1":67108864,"SSL_OP_NO_TLSv1_1":268435456,"SSL_OP_NO_TLSv1_2":134217728,"SSL_OP_PKCS1_CHECK_1":0,"SSL_OP_PKCS1_CHECK_2":0,"SSL_OP_SINGLE_DH_USE":1048576,"SSL_OP_SINGLE_ECDH_USE":524288,"SSL_OP_SSLEAY_080_CLIENT_DH_BUG":128,"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG":0,"SSL_OP_TLS_BLOCK_PADDING_BUG":512,"SSL_OP_TLS_D5_BUG":256,"SSL_OP_TLS_ROLLBACK_BUG":8388608,"ENGINE_METHOD_DSA":2,"ENGINE_METHOD_DH":4,"ENGINE_METHOD_RAND":8,"ENGINE_METHOD_ECDH":16,"ENGINE_METHOD_ECDSA":32,"ENGINE_METHOD_CIPHERS":64,"ENGINE_METHOD_DIGESTS":128,"ENGINE_METHOD_STORE":256,"ENGINE_METHOD_PKEY_METHS":512,"ENGINE_METHOD_PKEY_ASN1_METHS":1024,"ENGINE_METHOD_ALL":65535,"ENGINE_METHOD_NONE":0,"DH_CHECK_P_NOT_SAFE_PRIME":2,"DH_CHECK_P_NOT_PRIME":1,"DH_UNABLE_TO_CHECK_GENERATOR":4,"DH_NOT_SUITABLE_GENERATOR":8,"NPN_ENABLED":1,"RSA_PKCS1_PADDING":1,"RSA_SSLV23_PADDING":2,"RSA_NO_PADDING":3,"RSA_PKCS1_OAEP_PADDING":4,"RSA_X931_PADDING":5,"RSA_PKCS1_PSS_PADDING":6,"POINT_CONVERSION_COMPRESSED":2,"POINT_CONVERSION_UNCOMPRESSED":4,"POINT_CONVERSION_HYBRID":6,"F_OK":0,"R_OK":4,"W_OK":2,"X_OK":1,"UV_UDP_REUSEADDR":4}

/***/ }),

/***/ "S+WE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S8+E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U0rC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return imageCompression; });
/**
 * Browser Image Compression
 * v1.0.17
 * by Donald <donaldcwl@gmail.com>
 * https://github.com/Donaldcwl/browser-image-compression
 */

function _mergeNamespaces(e,r){return r.forEach((function(r){Object.keys(r).forEach((function(t){if("default"!==t&&!(t in e)){var a=Object.getOwnPropertyDescriptor(r,t);Object.defineProperty(e,t,a.get?a:{enumerable:!0,get:function(){return r[t]}})}}))})),Object.freeze(e)}function ownKeys$1(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);r&&(a=a.filter((function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable}))),t.push.apply(t,a)}return t}function _objectSpread2(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys$1(Object(t),!0).forEach((function(r){_defineProperty(e,r,t[r])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys$1(Object(t)).forEach((function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r))}))}return e}function _defineProperty(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}function _slicedToArray(e,r){return _arrayWithHoles(e)||_iterableToArrayLimit(e,r)||_unsupportedIterableToArray(e,r)||_nonIterableRest()}function _arrayWithHoles(e){if(Array.isArray(e))return e}function _iterableToArrayLimit(e,r){var t=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=t){var a,i,s=[],c=!0,l=!1;try{for(t=t.call(e);!(c=(a=t.next()).done)&&(s.push(a.value),!r||s.length!==r);c=!0);}catch(e){l=!0,i=e}finally{try{c||null==t.return||t.return()}finally{if(l)throw i}}return s}}function _unsupportedIterableToArray(e,r){if(e){if("string"==typeof e)return _arrayLikeToArray(e,r);var t=Object.prototype.toString.call(e).slice(8,-1);return"Object"===t&&e.constructor&&(t=e.constructor.name),"Map"===t||"Set"===t?Array.from(e):"Arguments"===t||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)?_arrayLikeToArray(e,r):void 0}}function _arrayLikeToArray(e,r){(null==r||r>e.length)&&(r=e.length);for(var t=0,a=new Array(r);t<r;t++)a[t]=e[t];return a}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function createCommonjsModule(e){var r={exports:{}};return e(r,r.exports),r.exports}var check=function(e){return e&&e.Math==Math&&e},global$1=check("object"==typeof globalThis&&globalThis)||check("object"==typeof window&&window)||check("object"==typeof self&&self)||check("object"==typeof commonjsGlobal&&commonjsGlobal)||function(){return this}()||Function("return this")(),isPure=!1,setGlobal=function(e,r){try{Object.defineProperty(global$1,e,{value:r,configurable:!0,writable:!0})}catch(t){global$1[e]=r}return r},SHARED="__core-js_shared__",store$1=global$1[SHARED]||setGlobal(SHARED,{}),sharedStore=store$1,shared=createCommonjsModule((function(e){(e.exports=function(e,r){return sharedStore[e]||(sharedStore[e]=void 0!==r?r:{})})("versions",[]).push({version:"3.18.0",mode:"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"})})),requireObjectCoercible=function(e){if(null==e)throw TypeError("Can't call method on "+e);return e},toObject=function(e){return Object(requireObjectCoercible(e))},hasOwnProperty={}.hasOwnProperty,has$1=Object.hasOwn||function hasOwn(e,r){return hasOwnProperty.call(toObject(e),r)},id=0,postfix=Math.random(),uid=function(e){return"Symbol("+String(void 0===e?"":e)+")_"+(++id+postfix).toString(36)},isCallable=function(e){return"function"==typeof e},aFunction=function(e){return isCallable(e)?e:void 0},getBuiltIn=function(e,r){return arguments.length<2?aFunction(global$1[e]):global$1[e]&&global$1[e][r]},engineUserAgent=getBuiltIn("navigator","userAgent")||"",process$3=global$1.process,Deno=global$1.Deno,versions=process$3&&process$3.versions||Deno&&Deno.version,v8=versions&&versions.v8,match,version;v8?(match=v8.split("."),version=match[0]<4?1:match[0]+match[1]):engineUserAgent&&(match=engineUserAgent.match(/Edge\/(\d+)/),(!match||match[1]>=74)&&(match=engineUserAgent.match(/Chrome\/(\d+)/),match&&(version=match[1])));var engineV8Version=version&&+version,fails=function(e){try{return!!e()}catch(e){return!0}},nativeSymbol=!!Object.getOwnPropertySymbols&&!fails((function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&engineV8Version&&engineV8Version<41})),useSymbolAsUid=nativeSymbol&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,WellKnownSymbolsStore=shared("wks"),Symbol$1=global$1.Symbol,createWellKnownSymbol=useSymbolAsUid?Symbol$1:Symbol$1&&Symbol$1.withoutSetter||uid,wellKnownSymbol=function(e){return has$1(WellKnownSymbolsStore,e)&&(nativeSymbol||"string"==typeof WellKnownSymbolsStore[e])||(nativeSymbol&&has$1(Symbol$1,e)?WellKnownSymbolsStore[e]=Symbol$1[e]:WellKnownSymbolsStore[e]=createWellKnownSymbol("Symbol."+e)),WellKnownSymbolsStore[e]},TO_STRING_TAG$4=wellKnownSymbol("toStringTag"),test$1={};test$1[TO_STRING_TAG$4]="z";var toStringTagSupport="[object z]"===String(test$1),descriptors=!fails((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),isObject=function(e){return"object"==typeof e?null!==e:isCallable(e)},document$3=global$1.document,EXISTS$1=isObject(document$3)&&isObject(document$3.createElement),documentCreateElement=function(e){return EXISTS$1?document$3.createElement(e):{}},ie8DomDefine=!descriptors&&!fails((function(){return 7!=Object.defineProperty(documentCreateElement("div"),"a",{get:function(){return 7}}).a})),anObject=function(e){if(isObject(e))return e;throw TypeError(String(e)+" is not an object")},isSymbol=useSymbolAsUid?function(e){return"symbol"==typeof e}:function(e){var r=getBuiltIn("Symbol");return isCallable(r)&&Object(e)instanceof r},tryToString=function(e){try{return String(e)}catch(e){return"Object"}},aCallable=function(e){if(isCallable(e))return e;throw TypeError(tryToString(e)+" is not a function")},getMethod=function(e,r){var t=e[r];return null==t?void 0:aCallable(t)},ordinaryToPrimitive=function(e,r){var t,a;if("string"===r&&isCallable(t=e.toString)&&!isObject(a=t.call(e)))return a;if(isCallable(t=e.valueOf)&&!isObject(a=t.call(e)))return a;if("string"!==r&&isCallable(t=e.toString)&&!isObject(a=t.call(e)))return a;throw TypeError("Can't convert object to primitive value")},TO_PRIMITIVE=wellKnownSymbol("toPrimitive"),toPrimitive=function(e,r){if(!isObject(e)||isSymbol(e))return e;var t,a=getMethod(e,TO_PRIMITIVE);if(a){if(void 0===r&&(r="default"),t=a.call(e,r),!isObject(t)||isSymbol(t))return t;throw TypeError("Can't convert object to primitive value")}return void 0===r&&(r="number"),ordinaryToPrimitive(e,r)},toPropertyKey=function(e){var r=toPrimitive(e,"string");return isSymbol(r)?r:String(r)},$defineProperty=Object.defineProperty,f$5=descriptors?$defineProperty:function defineProperty(e,r,t){if(anObject(e),r=toPropertyKey(r),anObject(t),ie8DomDefine)try{return $defineProperty(e,r,t)}catch(e){}if("get"in t||"set"in t)throw TypeError("Accessors not supported");return"value"in t&&(e[r]=t.value),e},objectDefineProperty={f:f$5},createPropertyDescriptor=function(e,r){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:r}},createNonEnumerableProperty=descriptors?function(e,r,t){return objectDefineProperty.f(e,r,createPropertyDescriptor(1,t))}:function(e,r,t){return e[r]=t,e},functionToString=Function.toString;isCallable(sharedStore.inspectSource)||(sharedStore.inspectSource=function(e){return functionToString.call(e)});var inspectSource=sharedStore.inspectSource,WeakMap$1=global$1.WeakMap,nativeWeakMap=isCallable(WeakMap$1)&&/native code/.test(inspectSource(WeakMap$1)),keys$2=shared("keys"),sharedKey=function(e){return keys$2[e]||(keys$2[e]=uid(e))},hiddenKeys$1={},OBJECT_ALREADY_INITIALIZED="Object already initialized",WeakMap=global$1.WeakMap,set$2,get$1,has,enforce=function(e){return has(e)?get$1(e):set$2(e,{})},getterFor=function(e){return function(r){var t;if(!isObject(r)||(t=get$1(r)).type!==e)throw TypeError("Incompatible receiver, "+e+" required");return t}};if(nativeWeakMap||sharedStore.state){var store=sharedStore.state||(sharedStore.state=new WeakMap),wmget=store.get,wmhas=store.has,wmset=store.set;set$2=function(e,r){if(wmhas.call(store,e))throw new TypeError(OBJECT_ALREADY_INITIALIZED);return r.facade=e,wmset.call(store,e,r),r},get$1=function(e){return wmget.call(store,e)||{}},has=function(e){return wmhas.call(store,e)}}else{var STATE=sharedKey("state");hiddenKeys$1[STATE]=!0,set$2=function(e,r){if(has$1(e,STATE))throw new TypeError(OBJECT_ALREADY_INITIALIZED);return r.facade=e,createNonEnumerableProperty(e,STATE,r),r},get$1=function(e){return has$1(e,STATE)?e[STATE]:{}},has=function(e){return has$1(e,STATE)}}var internalState={set:set$2,get:get$1,has:has,enforce:enforce,getterFor:getterFor},FunctionPrototype$1=Function.prototype,getDescriptor=descriptors&&Object.getOwnPropertyDescriptor,EXISTS=has$1(FunctionPrototype$1,"name"),PROPER=EXISTS&&"something"===function something(){}.name,CONFIGURABLE=EXISTS&&(!descriptors||descriptors&&getDescriptor(FunctionPrototype$1,"name").configurable),functionName={EXISTS:EXISTS,PROPER:PROPER,CONFIGURABLE:CONFIGURABLE},redefine=createCommonjsModule((function(e){var r=functionName.CONFIGURABLE,t=internalState.get,a=internalState.enforce,i=String(String).split("String");(e.exports=function(e,t,s,c){var l,u=!!c&&!!c.unsafe,p=!!c&&!!c.enumerable,d=!!c&&!!c.noTargetGet,h=c&&void 0!==c.name?c.name:t;isCallable(s)&&("Symbol("===String(h).slice(0,7)&&(h="["+String(h).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!has$1(s,"name")||r&&s.name!==h)&&createNonEnumerableProperty(s,"name",h),(l=a(s)).source||(l.source=i.join("string"==typeof h?h:""))),e!==global$1?(u?!d&&e[t]&&(p=!0):delete e[t],p?e[t]=s:createNonEnumerableProperty(e,t,s)):p?e[t]=s:setGlobal(t,s)})(Function.prototype,"toString",(function toString(){return isCallable(this)&&t(this).source||inspectSource(this)}))})),toString$1={}.toString,classofRaw=function(e){return toString$1.call(e).slice(8,-1)},TO_STRING_TAG$3=wellKnownSymbol("toStringTag"),CORRECT_ARGUMENTS="Arguments"==classofRaw(function(){return arguments}()),tryGet=function(e,r){try{return e[r]}catch(e){}},classof=toStringTagSupport?classofRaw:function(e){var r,t,a;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(t=tryGet(r=Object(e),TO_STRING_TAG$3))?t:CORRECT_ARGUMENTS?classofRaw(r):"Object"==(a=classofRaw(r))&&isCallable(r.callee)?"Arguments":a},objectToString=toStringTagSupport?{}.toString:function toString(){return"[object "+classof(this)+"]"};toStringTagSupport||redefine(Object.prototype,"toString",objectToString,{unsafe:!0});var $propertyIsEnumerable={}.propertyIsEnumerable,getOwnPropertyDescriptor$4=Object.getOwnPropertyDescriptor,NASHORN_BUG=getOwnPropertyDescriptor$4&&!$propertyIsEnumerable.call({1:2},1),f$4=NASHORN_BUG?function propertyIsEnumerable(e){var r=getOwnPropertyDescriptor$4(this,e);return!!r&&r.enumerable}:$propertyIsEnumerable,objectPropertyIsEnumerable={f:f$4},split="".split,indexedObject=fails((function(){return!Object("z").propertyIsEnumerable(0)}))?function(e){return"String"==classofRaw(e)?split.call(e,""):Object(e)}:Object,toIndexedObject=function(e){return indexedObject(requireObjectCoercible(e))},$getOwnPropertyDescriptor=Object.getOwnPropertyDescriptor,f$3=descriptors?$getOwnPropertyDescriptor:function getOwnPropertyDescriptor(e,r){if(e=toIndexedObject(e),r=toPropertyKey(r),ie8DomDefine)try{return $getOwnPropertyDescriptor(e,r)}catch(e){}if(has$1(e,r))return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(e,r),e[r])},objectGetOwnPropertyDescriptor={f:f$3},ceil=Math.ceil,floor$7=Math.floor,toInteger=function(e){return isNaN(e=+e)?0:(e>0?floor$7:ceil)(e)},min$6=Math.min,toLength=function(e){return e>0?min$6(toInteger(e),9007199254740991):0},max$2=Math.max,min$5=Math.min,toAbsoluteIndex=function(e,r){var t=toInteger(e);return t<0?max$2(t+r,0):min$5(t,r)},createMethod$5=function(e){return function(r,t,a){var i,s=toIndexedObject(r),c=toLength(s.length),l=toAbsoluteIndex(a,c);if(e&&t!=t){for(;c>l;)if((i=s[l++])!=i)return!0}else for(;c>l;l++)if((e||l in s)&&s[l]===t)return e||l||0;return!e&&-1}},arrayIncludes={includes:createMethod$5(!0),indexOf:createMethod$5(!1)},indexOf=arrayIncludes.indexOf,objectKeysInternal=function(e,r){var t,a=toIndexedObject(e),i=0,s=[];for(t in a)!has$1(hiddenKeys$1,t)&&has$1(a,t)&&s.push(t);for(;r.length>i;)has$1(a,t=r[i++])&&(~indexOf(s,t)||s.push(t));return s},enumBugKeys=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],hiddenKeys=enumBugKeys.concat("length","prototype"),f$2=Object.getOwnPropertyNames||function getOwnPropertyNames(e){return objectKeysInternal(e,hiddenKeys)},objectGetOwnPropertyNames={f:f$2},f$1=Object.getOwnPropertySymbols,objectGetOwnPropertySymbols={f:f$1},ownKeys=getBuiltIn("Reflect","ownKeys")||function ownKeys(e){var r=objectGetOwnPropertyNames.f(anObject(e)),t=objectGetOwnPropertySymbols.f;return t?r.concat(t(e)):r},copyConstructorProperties=function(e,r){for(var t=ownKeys(r),a=objectDefineProperty.f,i=objectGetOwnPropertyDescriptor.f,s=0;s<t.length;s++){var c=t[s];has$1(e,c)||a(e,c,i(r,c))}},replacement=/#|\.prototype\./,isForced=function(e,r){var t=data[normalize(e)];return t==POLYFILL||t!=NATIVE&&(isCallable(r)?fails(r):!!r)},normalize=isForced.normalize=function(e){return String(e).replace(replacement,".").toLowerCase()},data=isForced.data={},NATIVE=isForced.NATIVE="N",POLYFILL=isForced.POLYFILL="P",isForced_1=isForced,getOwnPropertyDescriptor$3=objectGetOwnPropertyDescriptor.f,_export=function(e,r){var t,a,i,s,c,l=e.target,u=e.global,p=e.stat;if(t=u?global$1:p?global$1[l]||setGlobal(l,{}):(global$1[l]||{}).prototype)for(a in r){if(s=r[a],i=e.noTargetGet?(c=getOwnPropertyDescriptor$3(t,a))&&c.value:t[a],!isForced_1(u?a:l+(p?".":"#")+a,e.forced)&&void 0!==i){if(typeof s==typeof i)continue;copyConstructorProperties(s,i)}(e.sham||i&&i.sham)&&createNonEnumerableProperty(s,"sham",!0),redefine(t,a,s,e)}},nativePromiseConstructor=global$1.Promise,redefineAll=function(e,r,t){for(var a in r)redefine(e,a,r[a],t);return e},aPossiblePrototype=function(e){if("object"==typeof e||isCallable(e))return e;throw TypeError("Can't set "+String(e)+" as a prototype")},objectSetPrototypeOf=Object.setPrototypeOf||("__proto__"in{}?function(){var e,r=!1,t={};try{(e=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(t,[]),r=t instanceof Array}catch(e){}return function setPrototypeOf(t,a){return anObject(t),aPossiblePrototype(a),r?e.call(t,a):t.__proto__=a,t}}():void 0),defineProperty$5=objectDefineProperty.f,TO_STRING_TAG$2=wellKnownSymbol("toStringTag"),setToStringTag=function(e,r,t){e&&!has$1(e=t?e:e.prototype,TO_STRING_TAG$2)&&defineProperty$5(e,TO_STRING_TAG$2,{configurable:!0,value:r})},SPECIES$6=wellKnownSymbol("species"),setSpecies=function(e){var r=getBuiltIn(e),t=objectDefineProperty.f;descriptors&&r&&!r[SPECIES$6]&&t(r,SPECIES$6,{configurable:!0,get:function(){return this}})},anInstance=function(e,r,t){if(e instanceof r)return e;throw TypeError("Incorrect "+(t?t+" ":"")+"invocation")},iterators={},ITERATOR$8=wellKnownSymbol("iterator"),ArrayPrototype$1=Array.prototype,isArrayIteratorMethod=function(e){return void 0!==e&&(iterators.Array===e||ArrayPrototype$1[ITERATOR$8]===e)},functionBindContext=function(e,r,t){if(aCallable(e),void 0===r)return e;switch(t){case 0:return function(){return e.call(r)};case 1:return function(t){return e.call(r,t)};case 2:return function(t,a){return e.call(r,t,a)};case 3:return function(t,a,i){return e.call(r,t,a,i)}}return function(){return e.apply(r,arguments)}},ITERATOR$7=wellKnownSymbol("iterator"),getIteratorMethod=function(e){if(null!=e)return getMethod(e,ITERATOR$7)||getMethod(e,"@@iterator")||iterators[classof(e)]},getIterator=function(e,r){var t=arguments.length<2?getIteratorMethod(e):r;if(aCallable(t))return anObject(t.call(e));throw TypeError(String(e)+" is not iterable")},iteratorClose=function(e,r,t){var a,i;anObject(e);try{if(!(a=getMethod(e,"return"))){if("throw"===r)throw t;return t}a=a.call(e)}catch(e){i=!0,a=e}if("throw"===r)throw t;if(i)throw a;return anObject(a),t},Result=function(e,r){this.stopped=e,this.result=r},iterate=function(e,r,t){var a,i,s,c,l,u,p,d=t&&t.that,h=!(!t||!t.AS_ENTRIES),y=!(!t||!t.IS_ITERATOR),A=!(!t||!t.INTERRUPTED),g=functionBindContext(r,d,1+h+A),stop=function(e){return a&&iteratorClose(a,"normal",e),new Result(!0,e)},callFn=function(e){return h?(anObject(e),A?g(e[0],e[1],stop):g(e[0],e[1])):A?g(e,stop):g(e)};if(y)a=e;else{if(!(i=getIteratorMethod(e)))throw TypeError(String(e)+" is not iterable");if(isArrayIteratorMethod(i)){for(s=0,c=toLength(e.length);c>s;s++)if((l=callFn(e[s]))&&l instanceof Result)return l;return new Result(!1)}a=getIterator(e,i)}for(u=a.next;!(p=u.call(a)).done;){try{l=callFn(p.value)}catch(e){iteratorClose(a,"throw",e)}if("object"==typeof l&&l&&l instanceof Result)return l}return new Result(!1)},ITERATOR$6=wellKnownSymbol("iterator"),SAFE_CLOSING=!1;try{var called=0,iteratorWithReturn={next:function(){return{done:!!called++}},return:function(){SAFE_CLOSING=!0}};iteratorWithReturn[ITERATOR$6]=function(){return this},Array.from(iteratorWithReturn,(function(){throw 2}))}catch(e){}var checkCorrectnessOfIteration=function(e,r){if(!r&&!SAFE_CLOSING)return!1;var t=!1;try{var a={};a[ITERATOR$6]=function(){return{next:function(){return{done:t=!0}}}},e(a)}catch(e){}return t},empty=[],construct=getBuiltIn("Reflect","construct"),constructorRegExp=/^\s*(?:class|function)\b/,exec=constructorRegExp.exec,INCORRECT_TO_STRING=!constructorRegExp.exec((function(){})),isConstructorModern=function(e){if(!isCallable(e))return!1;try{return construct(Object,empty,e),!0}catch(e){return!1}},isConstructorLegacy=function(e){if(!isCallable(e))return!1;switch(classof(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}return INCORRECT_TO_STRING||!!exec.call(constructorRegExp,inspectSource(e))},isConstructor=!construct||fails((function(){var e;return isConstructorModern(isConstructorModern.call)||!isConstructorModern(Object)||!isConstructorModern((function(){e=!0}))||e}))?isConstructorLegacy:isConstructorModern,aConstructor=function(e){if(isConstructor(e))return e;throw TypeError(tryToString(e)+" is not a constructor")},SPECIES$5=wellKnownSymbol("species"),speciesConstructor=function(e,r){var t,a=anObject(e).constructor;return void 0===a||null==(t=anObject(a)[SPECIES$5])?r:aConstructor(t)},html=getBuiltIn("document","documentElement"),engineIsIos=/(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent),engineIsNode="process"==classofRaw(global$1.process),set$1=global$1.setImmediate,clear=global$1.clearImmediate,process$2=global$1.process,MessageChannel=global$1.MessageChannel,Dispatch=global$1.Dispatch,counter=0,queue={},ONREADYSTATECHANGE="onreadystatechange",location,defer,channel,port;try{location=global$1.location}catch(e){}var run=function(e){if(queue.hasOwnProperty(e)){var r=queue[e];delete queue[e],r()}},runner=function(e){return function(){run(e)}},listener=function(e){run(e.data)},post=function(e){global$1.postMessage(String(e),location.protocol+"//"+location.host)};set$1&&clear||(set$1=function setImmediate(e){for(var r=[],t=arguments.length,a=1;t>a;)r.push(arguments[a++]);return queue[++counter]=function(){(isCallable(e)?e:Function(e)).apply(void 0,r)},defer(counter),counter},clear=function clearImmediate(e){delete queue[e]},engineIsNode?defer=function(e){process$2.nextTick(runner(e))}:Dispatch&&Dispatch.now?defer=function(e){Dispatch.now(runner(e))}:MessageChannel&&!engineIsIos?(channel=new MessageChannel,port=channel.port2,channel.port1.onmessage=listener,defer=functionBindContext(port.postMessage,port,1)):global$1.addEventListener&&isCallable(global$1.postMessage)&&!global$1.importScripts&&location&&"file:"!==location.protocol&&!fails(post)?(defer=post,global$1.addEventListener("message",listener,!1)):defer=ONREADYSTATECHANGE in documentCreateElement("script")?function(e){html.appendChild(documentCreateElement("script"))[ONREADYSTATECHANGE]=function(){html.removeChild(this),run(e)}}:function(e){setTimeout(runner(e),0)});var task$1={set:set$1,clear:clear},engineIsIosPebble=/ipad|iphone|ipod/i.test(engineUserAgent)&&void 0!==global$1.Pebble,engineIsWebosWebkit=/web0s(?!.*chrome)/i.test(engineUserAgent),getOwnPropertyDescriptor$2=objectGetOwnPropertyDescriptor.f,macrotask=task$1.set,MutationObserver=global$1.MutationObserver||global$1.WebKitMutationObserver,document$2=global$1.document,process$1=global$1.process,Promise$1=global$1.Promise,queueMicrotaskDescriptor=getOwnPropertyDescriptor$2(global$1,"queueMicrotask"),queueMicrotask=queueMicrotaskDescriptor&&queueMicrotaskDescriptor.value,flush,head,last,notify$1,toggle,node,promise,then;queueMicrotask||(flush=function(){var e,r;for(engineIsNode&&(e=process$1.domain)&&e.exit();head;){r=head.fn,head=head.next;try{r()}catch(e){throw head?notify$1():last=void 0,e}}last=void 0,e&&e.enter()},engineIsIos||engineIsNode||engineIsWebosWebkit||!MutationObserver||!document$2?!engineIsIosPebble&&Promise$1&&Promise$1.resolve?(promise=Promise$1.resolve(void 0),promise.constructor=Promise$1,then=promise.then,notify$1=function(){then.call(promise,flush)}):notify$1=engineIsNode?function(){process$1.nextTick(flush)}:function(){macrotask.call(global$1,flush)}:(toggle=!0,node=document$2.createTextNode(""),new MutationObserver(flush).observe(node,{characterData:!0}),notify$1=function(){node.data=toggle=!toggle}));var microtask=queueMicrotask||function(e){var r={fn:e,next:void 0};last&&(last.next=r),head||(head=r,notify$1()),last=r},PromiseCapability=function(e){var r,t;this.promise=new e((function(e,a){if(void 0!==r||void 0!==t)throw TypeError("Bad Promise constructor");r=e,t=a})),this.resolve=aCallable(r),this.reject=aCallable(t)},f=function(e){return new PromiseCapability(e)},newPromiseCapability$1={f:f},promiseResolve=function(e,r){if(anObject(e),isObject(r)&&r.constructor===e)return r;var t=newPromiseCapability$1.f(e);return(0,t.resolve)(r),t.promise},hostReportErrors=function(e,r){var t=global$1.console;t&&t.error&&(1===arguments.length?t.error(e):t.error(e,r))},perform=function(e){try{return{error:!1,value:e()}}catch(e){return{error:!0,value:e}}},engineIsBrowser="object"==typeof window,task=task$1.set,SPECIES$4=wellKnownSymbol("species"),PROMISE="Promise",getInternalState$4=internalState.get,setInternalState$5=internalState.set,getInternalPromiseState=internalState.getterFor(PROMISE),NativePromisePrototype=nativePromiseConstructor&&nativePromiseConstructor.prototype,PromiseConstructor=nativePromiseConstructor,PromiseConstructorPrototype=NativePromisePrototype,TypeError$1=global$1.TypeError,document$1=global$1.document,process=global$1.process,newPromiseCapability=newPromiseCapability$1.f,newGenericPromiseCapability=newPromiseCapability,DISPATCH_EVENT=!!(document$1&&document$1.createEvent&&global$1.dispatchEvent),NATIVE_REJECTION_EVENT=isCallable(global$1.PromiseRejectionEvent),UNHANDLED_REJECTION="unhandledrejection",REJECTION_HANDLED="rejectionhandled",PENDING=0,FULFILLED=1,REJECTED=2,HANDLED=1,UNHANDLED=2,SUBCLASSING=!1,Internal,OwnPromiseCapability,PromiseWrapper,nativeThen,FORCED$6=isForced_1(PROMISE,(function(){var e=inspectSource(PromiseConstructor),r=e!==String(PromiseConstructor);if(!r&&66===engineV8Version)return!0;if(engineV8Version>=51&&/native code/.test(e))return!1;var t=new PromiseConstructor((function(e){e(1)})),FakePromise=function(e){e((function(){}),(function(){}))};return(t.constructor={})[SPECIES$4]=FakePromise,!(SUBCLASSING=t.then((function(){}))instanceof FakePromise)||!r&&engineIsBrowser&&!NATIVE_REJECTION_EVENT})),INCORRECT_ITERATION=FORCED$6||!checkCorrectnessOfIteration((function(e){PromiseConstructor.all(e).catch((function(){}))})),isThenable=function(e){var r;return!(!isObject(e)||!isCallable(r=e.then))&&r},notify=function(e,r){if(!e.notified){e.notified=!0;var t=e.reactions;microtask((function(){for(var a=e.value,i=e.state==FULFILLED,s=0;t.length>s;){var c,l,u,p=t[s++],d=i?p.ok:p.fail,h=p.resolve,y=p.reject,A=p.domain;try{d?(i||(e.rejection===UNHANDLED&&onHandleUnhandled(e),e.rejection=HANDLED),!0===d?c=a:(A&&A.enter(),c=d(a),A&&(A.exit(),u=!0)),c===p.promise?y(TypeError$1("Promise-chain cycle")):(l=isThenable(c))?l.call(c,h,y):h(c)):y(a)}catch(e){A&&!u&&A.exit(),y(e)}}e.reactions=[],e.notified=!1,r&&!e.rejection&&onUnhandled(e)}))}},dispatchEvent=function(e,r,t){var a,i;DISPATCH_EVENT?((a=document$1.createEvent("Event")).promise=r,a.reason=t,a.initEvent(e,!1,!0),global$1.dispatchEvent(a)):a={promise:r,reason:t},!NATIVE_REJECTION_EVENT&&(i=global$1["on"+e])?i(a):e===UNHANDLED_REJECTION&&hostReportErrors("Unhandled promise rejection",t)},onUnhandled=function(e){task.call(global$1,(function(){var r,t=e.facade,a=e.value;if(isUnhandled(e)&&(r=perform((function(){engineIsNode?process.emit("unhandledRejection",a,t):dispatchEvent(UNHANDLED_REJECTION,t,a)})),e.rejection=engineIsNode||isUnhandled(e)?UNHANDLED:HANDLED,r.error))throw r.value}))},isUnhandled=function(e){return e.rejection!==HANDLED&&!e.parent},onHandleUnhandled=function(e){task.call(global$1,(function(){var r=e.facade;engineIsNode?process.emit("rejectionHandled",r):dispatchEvent(REJECTION_HANDLED,r,e.value)}))},bind=function(e,r,t){return function(a){e(r,a,t)}},internalReject=function(e,r,t){e.done||(e.done=!0,t&&(e=t),e.value=r,e.state=REJECTED,notify(e,!0))},internalResolve=function(e,r,t){if(!e.done){e.done=!0,t&&(e=t);try{if(e.facade===r)throw TypeError$1("Promise can't be resolved itself");var a=isThenable(r);a?microtask((function(){var t={done:!1};try{a.call(r,bind(internalResolve,t,e),bind(internalReject,t,e))}catch(r){internalReject(t,r,e)}})):(e.value=r,e.state=FULFILLED,notify(e,!1))}catch(r){internalReject({done:!1},r,e)}}};if(FORCED$6&&(PromiseConstructor=function Promise(e){anInstance(this,PromiseConstructor,PROMISE),aCallable(e),Internal.call(this);var r=getInternalState$4(this);try{e(bind(internalResolve,r),bind(internalReject,r))}catch(e){internalReject(r,e)}},PromiseConstructorPrototype=PromiseConstructor.prototype,Internal=function Promise(e){setInternalState$5(this,{type:PROMISE,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:PENDING,value:void 0})},Internal.prototype=redefineAll(PromiseConstructorPrototype,{then:function then(e,r){var t=getInternalPromiseState(this),a=newPromiseCapability(speciesConstructor(this,PromiseConstructor));return a.ok=!isCallable(e)||e,a.fail=isCallable(r)&&r,a.domain=engineIsNode?process.domain:void 0,t.parent=!0,t.reactions.push(a),t.state!=PENDING&&notify(t,!1),a.promise},catch:function(e){return this.then(void 0,e)}}),OwnPromiseCapability=function(){var e=new Internal,r=getInternalState$4(e);this.promise=e,this.resolve=bind(internalResolve,r),this.reject=bind(internalReject,r)},newPromiseCapability$1.f=newPromiseCapability=function(e){return e===PromiseConstructor||e===PromiseWrapper?new OwnPromiseCapability(e):newGenericPromiseCapability(e)},isCallable(nativePromiseConstructor)&&NativePromisePrototype!==Object.prototype)){nativeThen=NativePromisePrototype.then,SUBCLASSING||(redefine(NativePromisePrototype,"then",(function then(e,r){var t=this;return new PromiseConstructor((function(e,r){nativeThen.call(t,e,r)})).then(e,r)}),{unsafe:!0}),redefine(NativePromisePrototype,"catch",PromiseConstructorPrototype.catch,{unsafe:!0}));try{delete NativePromisePrototype.constructor}catch(e){}objectSetPrototypeOf&&objectSetPrototypeOf(NativePromisePrototype,PromiseConstructorPrototype)}_export({global:!0,wrap:!0,forced:FORCED$6},{Promise:PromiseConstructor}),setToStringTag(PromiseConstructor,PROMISE,!1),setSpecies(PROMISE),PromiseWrapper=getBuiltIn(PROMISE),_export({target:PROMISE,stat:!0,forced:FORCED$6},{reject:function reject(e){var r=newPromiseCapability(this);return r.reject.call(void 0,e),r.promise}}),_export({target:PROMISE,stat:!0,forced:FORCED$6},{resolve:function resolve(e){return promiseResolve(this,e)}}),_export({target:PROMISE,stat:!0,forced:INCORRECT_ITERATION},{all:function all(e){var r=this,t=newPromiseCapability(r),a=t.resolve,i=t.reject,s=perform((function(){var t=aCallable(r.resolve),s=[],c=0,l=1;iterate(e,(function(e){var u=c++,p=!1;s.push(void 0),l++,t.call(r,e).then((function(e){p||(p=!0,s[u]=e,--l||a(s))}),i)})),--l||a(s)}));return s.error&&i(s.value),t.promise},race:function race(e){var r=this,t=newPromiseCapability(r),a=t.reject,i=perform((function(){var i=aCallable(r.resolve);iterate(e,(function(e){i.call(r,e).then(t.resolve,a)}))}));return i.error&&a(i.value),t.promise}});var inheritIfRequired=function(e,r,t){var a,i;return objectSetPrototypeOf&&isCallable(a=r.constructor)&&a!==t&&isObject(i=a.prototype)&&i!==t.prototype&&objectSetPrototypeOf(e,i),e},objectKeys=Object.keys||function keys(e){return objectKeysInternal(e,enumBugKeys)},objectDefineProperties=descriptors?Object.defineProperties:function defineProperties(e,r){anObject(e);for(var t,a=objectKeys(r),i=a.length,s=0;i>s;)objectDefineProperty.f(e,t=a[s++],r[t]);return e},GT=">",LT="<",PROTOTYPE$1="prototype",SCRIPT="script",IE_PROTO$1=sharedKey("IE_PROTO"),EmptyConstructor=function(){},scriptTag=function(e){return LT+SCRIPT+GT+e+LT+"/"+SCRIPT+GT},NullProtoObjectViaActiveX=function(e){e.write(scriptTag("")),e.close();var r=e.parentWindow.Object;return e=null,r},NullProtoObjectViaIFrame=function(){var e,r=documentCreateElement("iframe"),t="java"+SCRIPT+":";return r.style.display="none",html.appendChild(r),r.src=String(t),(e=r.contentWindow.document).open(),e.write(scriptTag("document.F=Object")),e.close(),e.F},activeXDocument,NullProtoObject=function(){try{activeXDocument=new ActiveXObject("htmlfile")}catch(e){}NullProtoObject="undefined"!=typeof document?document.domain&&activeXDocument?NullProtoObjectViaActiveX(activeXDocument):NullProtoObjectViaIFrame():NullProtoObjectViaActiveX(activeXDocument);for(var e=enumBugKeys.length;e--;)delete NullProtoObject[PROTOTYPE$1][enumBugKeys[e]];return NullProtoObject()};hiddenKeys$1[IE_PROTO$1]=!0;var objectCreate=Object.create||function create(e,r){var t;return null!==e?(EmptyConstructor[PROTOTYPE$1]=anObject(e),t=new EmptyConstructor,EmptyConstructor[PROTOTYPE$1]=null,t[IE_PROTO$1]=e):t=NullProtoObject(),void 0===r?t:objectDefineProperties(t,r)},toString=function(e){if("Symbol"===classof(e))throw TypeError("Cannot convert a Symbol value to a string");return String(e)},whitespaces="\t\n\v\f\r                　\u2028\u2029\ufeff",whitespace="["+whitespaces+"]",ltrim=RegExp("^"+whitespace+whitespace+"*"),rtrim=RegExp(whitespace+whitespace+"*$"),createMethod$4=function(e){return function(r){var t=toString(requireObjectCoercible(r));return 1&e&&(t=t.replace(ltrim,"")),2&e&&(t=t.replace(rtrim,"")),t}},stringTrim={start:createMethod$4(1),end:createMethod$4(2),trim:createMethod$4(3)},getOwnPropertyNames$1=objectGetOwnPropertyNames.f,getOwnPropertyDescriptor$1=objectGetOwnPropertyDescriptor.f,defineProperty$4=objectDefineProperty.f,trim=stringTrim.trim,NUMBER="Number",NativeNumber=global$1[NUMBER],NumberPrototype=NativeNumber.prototype,BROKEN_CLASSOF=classofRaw(objectCreate(NumberPrototype))==NUMBER,toNumber=function(e){if(isSymbol(e))throw TypeError("Cannot convert a Symbol value to a number");var r,t,a,i,s,c,l,u,p=toPrimitive(e,"number");if("string"==typeof p&&p.length>2)if(43===(r=(p=trim(p)).charCodeAt(0))||45===r){if(88===(t=p.charCodeAt(2))||120===t)return NaN}else if(48===r){switch(p.charCodeAt(1)){case 66:case 98:a=2,i=49;break;case 79:case 111:a=8,i=55;break;default:return+p}for(c=(s=p.slice(2)).length,l=0;l<c;l++)if((u=s.charCodeAt(l))<48||u>i)return NaN;return parseInt(s,a)}return+p};if(isForced_1(NUMBER,!NativeNumber(" 0o1")||!NativeNumber("0b1")||NativeNumber("+0x1"))){for(var NumberWrapper=function Number(e){var r=arguments.length<1?0:e,t=this;return t instanceof NumberWrapper&&(BROKEN_CLASSOF?fails((function(){NumberPrototype.valueOf.call(t)})):classofRaw(t)!=NUMBER)?inheritIfRequired(new NativeNumber(toNumber(r)),t,NumberWrapper):toNumber(r)},keys$1=descriptors?getOwnPropertyNames$1(NativeNumber):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,fromString,range".split(","),j$1=0,key$1;keys$1.length>j$1;j$1++)has$1(NativeNumber,key$1=keys$1[j$1])&&!has$1(NumberWrapper,key$1)&&defineProperty$4(NumberWrapper,key$1,getOwnPropertyDescriptor$1(NativeNumber,key$1));NumberWrapper.prototype=NumberPrototype,NumberPrototype.constructor=NumberWrapper,redefine(global$1,NUMBER,NumberWrapper)}var FUNCTION_NAME_EXISTS=functionName.EXISTS,defineProperty$3=objectDefineProperty.f,FunctionPrototype=Function.prototype,FunctionPrototypeToString=FunctionPrototype.toString,nameRE=/^\s*function ([^ (]*)/,NAME$1="name";descriptors&&!FUNCTION_NAME_EXISTS&&defineProperty$3(FunctionPrototype,NAME$1,{configurable:!0,get:function(){try{return FunctionPrototypeToString.call(this).match(nameRE)[1]}catch(e){return""}}}),_export({global:!0},{globalThis:global$1});var $assign=Object.assign,defineProperty$2=Object.defineProperty,objectAssign=!$assign||fails((function(){if(descriptors&&1!==$assign({b:1},$assign(defineProperty$2({},"a",{enumerable:!0,get:function(){defineProperty$2(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var e={},r={},t=Symbol();return e[t]=7,"abcdefghijklmnopqrst".split("").forEach((function(e){r[e]=e})),7!=$assign({},e)[t]||"abcdefghijklmnopqrst"!=objectKeys($assign({},r)).join("")}))?function assign(e,r){for(var t=toObject(e),a=arguments.length,i=1,s=objectGetOwnPropertySymbols.f,c=objectPropertyIsEnumerable.f;a>i;)for(var l,u=indexedObject(arguments[i++]),p=s?objectKeys(u).concat(s(u)):objectKeys(u),d=p.length,h=0;d>h;)l=p[h++],descriptors&&!c.call(u,l)||(t[l]=u[l]);return t}:$assign;_export({target:"Object",stat:!0,forced:Object.assign!==objectAssign},{assign:objectAssign});var path=global$1;path.Object.assign;var regexpFlags=function(){var e=anObject(this),r="";return e.global&&(r+="g"),e.ignoreCase&&(r+="i"),e.multiline&&(r+="m"),e.dotAll&&(r+="s"),e.unicode&&(r+="u"),e.sticky&&(r+="y"),r},$RegExp$2=global$1.RegExp,UNSUPPORTED_Y$2=fails((function(){var e=$RegExp$2("a","y");return e.lastIndex=2,null!=e.exec("abcd")})),BROKEN_CARET=fails((function(){var e=$RegExp$2("^r","gy");return e.lastIndex=2,null!=e.exec("str")})),regexpStickyHelpers={UNSUPPORTED_Y:UNSUPPORTED_Y$2,BROKEN_CARET:BROKEN_CARET},$RegExp$1=global$1.RegExp,regexpUnsupportedDotAll=fails((function(){var e=$RegExp$1(".","s");return!(e.dotAll&&e.exec("\n")&&"s"===e.flags)})),$RegExp=global$1.RegExp,regexpUnsupportedNcg=fails((function(){var e=$RegExp("(?<a>b)","g");return"b"!==e.exec("b").groups.a||"bc"!=="b".replace(e,"$<a>c")})),getInternalState$3=internalState.get,nativeExec=RegExp.prototype.exec,nativeReplace=shared("native-string-replace",String.prototype.replace),patchedExec=nativeExec,UPDATES_LAST_INDEX_WRONG=(re1=/a/,re2=/b*/g,nativeExec.call(re1,"a"),nativeExec.call(re2,"a"),0!==re1.lastIndex||0!==re2.lastIndex),re1,re2,UNSUPPORTED_Y$1=regexpStickyHelpers.UNSUPPORTED_Y||regexpStickyHelpers.BROKEN_CARET,NPCG_INCLUDED=void 0!==/()??/.exec("")[1],PATCH=UPDATES_LAST_INDEX_WRONG||NPCG_INCLUDED||UNSUPPORTED_Y$1||regexpUnsupportedDotAll||regexpUnsupportedNcg;PATCH&&(patchedExec=function exec(e){var r,t,a,i,s,c,l,u=this,p=getInternalState$3(u),d=toString(e),h=p.raw;if(h)return h.lastIndex=u.lastIndex,r=patchedExec.call(h,d),u.lastIndex=h.lastIndex,r;var y=p.groups,A=UNSUPPORTED_Y$1&&u.sticky,g=regexpFlags.call(u),E=u.source,v=0,m=d;if(A&&(-1===(g=g.replace("y","")).indexOf("g")&&(g+="g"),m=d.slice(u.lastIndex),u.lastIndex>0&&(!u.multiline||u.multiline&&"\n"!==d.charAt(u.lastIndex-1))&&(E="(?: "+E+")",m=" "+m,v++),t=new RegExp("^(?:"+E+")",g)),NPCG_INCLUDED&&(t=new RegExp("^"+E+"$(?!\\s)",g)),UPDATES_LAST_INDEX_WRONG&&(a=u.lastIndex),i=nativeExec.call(A?t:u,m),A?i?(i.input=i.input.slice(v),i[0]=i[0].slice(v),i.index=u.lastIndex,u.lastIndex+=i[0].length):u.lastIndex=0:UPDATES_LAST_INDEX_WRONG&&i&&(u.lastIndex=u.global?i.index+i[0].length:a),NPCG_INCLUDED&&i&&i.length>1&&nativeReplace.call(i[0],t,(function(){for(s=1;s<arguments.length-2;s++)void 0===arguments[s]&&(i[s]=void 0)})),i&&y)for(i.groups=c=objectCreate(null),s=0;s<y.length;s++)c[(l=y[s])[0]]=i[l[1]];return i});var regexpExec=patchedExec;_export({target:"RegExp",proto:!0,forced:/./.exec!==regexpExec},{exec:regexpExec});var SPECIES$3=wellKnownSymbol("species"),RegExpPrototype$1=RegExp.prototype,fixRegexpWellKnownSymbolLogic=function(e,r,t,a){var i=wellKnownSymbol(e),s=!fails((function(){var r={};return r[i]=function(){return 7},7!=""[e](r)})),c=s&&!fails((function(){var r=!1,t=/a/;return"split"===e&&((t={}).constructor={},t.constructor[SPECIES$3]=function(){return t},t.flags="",t[i]=/./[i]),t.exec=function(){return r=!0,null},t[i](""),!r}));if(!s||!c||t){var l=/./[i],u=r(i,""[e],(function(e,r,t,a,i){var c=r.exec;return c===regexpExec||c===RegExpPrototype$1.exec?s&&!i?{done:!0,value:l.call(r,t,a)}:{done:!0,value:e.call(t,r,a)}:{done:!1}}));redefine(String.prototype,e,u[0]),redefine(RegExpPrototype$1,i,u[1])}a&&createNonEnumerableProperty(RegExpPrototype$1[i],"sham",!0)},MATCH$1=wellKnownSymbol("match"),isRegexp=function(e){var r;return isObject(e)&&(void 0!==(r=e[MATCH$1])?!!r:"RegExp"==classofRaw(e))},createMethod$3=function(e){return function(r,t){var a,i,s=toString(requireObjectCoercible(r)),c=toInteger(t),l=s.length;return c<0||c>=l?e?"":void 0:(a=s.charCodeAt(c))<55296||a>56319||c+1===l||(i=s.charCodeAt(c+1))<56320||i>57343?e?s.charAt(c):a:e?s.slice(c,c+2):i-56320+(a-55296<<10)+65536}},stringMultibyte={codeAt:createMethod$3(!1),charAt:createMethod$3(!0)},charAt$1=stringMultibyte.charAt,advanceStringIndex=function(e,r,t){return r+(t?charAt$1(e,r).length:1)},regexpExecAbstract=function(e,r){var t=e.exec;if(isCallable(t)){var a=t.call(e,r);return null!==a&&anObject(a),a}if("RegExp"===classofRaw(e))return regexpExec.call(e,r);throw TypeError("RegExp#exec called on incompatible receiver")},UNSUPPORTED_Y=regexpStickyHelpers.UNSUPPORTED_Y,arrayPush=[].push,min$4=Math.min,MAX_UINT32=4294967295,SPLIT_WORKS_WITH_OVERWRITTEN_EXEC=!fails((function(){var e=/(?:)/,r=e.exec;e.exec=function(){return r.apply(this,arguments)};var t="ab".split(e);return 2!==t.length||"a"!==t[0]||"b"!==t[1]}));fixRegexpWellKnownSymbolLogic("split",(function(e,r,t){var a;return a="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(e,t){var a=toString(requireObjectCoercible(this)),i=void 0===t?MAX_UINT32:t>>>0;if(0===i)return[];if(void 0===e)return[a];if(!isRegexp(e))return r.call(a,e,i);for(var s,c,l,u=[],p=(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.unicode?"u":"")+(e.sticky?"y":""),d=0,h=new RegExp(e.source,p+"g");(s=regexpExec.call(h,a))&&!((c=h.lastIndex)>d&&(u.push(a.slice(d,s.index)),s.length>1&&s.index<a.length&&arrayPush.apply(u,s.slice(1)),l=s[0].length,d=c,u.length>=i));)h.lastIndex===s.index&&h.lastIndex++;return d===a.length?!l&&h.test("")||u.push(""):u.push(a.slice(d)),u.length>i?u.slice(0,i):u}:"0".split(void 0,0).length?function(e,t){return void 0===e&&0===t?[]:r.call(this,e,t)}:r,[function split(r,t){var i=requireObjectCoercible(this),s=null==r?void 0:getMethod(r,e);return s?s.call(r,i,t):a.call(toString(i),r,t)},function(e,i){var s=anObject(this),c=toString(e),l=t(a,s,c,i,a!==r);if(l.done)return l.value;var u=speciesConstructor(s,RegExp),p=s.unicode,d=(s.ignoreCase?"i":"")+(s.multiline?"m":"")+(s.unicode?"u":"")+(UNSUPPORTED_Y?"g":"y"),h=new u(UNSUPPORTED_Y?"^(?:"+s.source+")":s,d),y=void 0===i?MAX_UINT32:i>>>0;if(0===y)return[];if(0===c.length)return null===regexpExecAbstract(h,c)?[c]:[];for(var A=0,g=0,E=[];g<c.length;){h.lastIndex=UNSUPPORTED_Y?0:g;var v,m=regexpExecAbstract(h,UNSUPPORTED_Y?c.slice(g):c);if(null===m||(v=min$4(toLength(h.lastIndex+(UNSUPPORTED_Y?g:0)),c.length))===A)g=advanceStringIndex(c,g,p);else{if(E.push(c.slice(A,g)),E.length===y)return E;for(var I=1;I<=m.length-1;I++)if(E.push(m[I]),E.length===y)return E;g=A=v}}return E.push(c.slice(A)),E}]}),!SPLIT_WORKS_WITH_OVERWRITTEN_EXEC,UNSUPPORTED_Y),fixRegexpWellKnownSymbolLogic("match",(function(e,r,t){return[function match(r){var t=requireObjectCoercible(this),a=null==r?void 0:getMethod(r,e);return a?a.call(r,t):new RegExp(r)[e](toString(t))},function(e){var a=anObject(this),i=toString(e),s=t(r,a,i);if(s.done)return s.value;if(!a.global)return regexpExecAbstract(a,i);var c=a.unicode;a.lastIndex=0;for(var l,u=[],p=0;null!==(l=regexpExecAbstract(a,i));){var d=toString(l[0]);u[p]=d,""===d&&(a.lastIndex=advanceStringIndex(i,toLength(a.lastIndex),c)),p++}return 0===p?null:u}]}));var UNSCOPABLES=wellKnownSymbol("unscopables"),ArrayPrototype=Array.prototype;null==ArrayPrototype[UNSCOPABLES]&&objectDefineProperty.f(ArrayPrototype,UNSCOPABLES,{configurable:!0,value:objectCreate(null)});var addToUnscopables=function(e){ArrayPrototype[UNSCOPABLES][e]=!0},correctPrototypeGetter=!fails((function(){function F(){}return F.prototype.constructor=null,Object.getPrototypeOf(new F)!==F.prototype})),IE_PROTO=sharedKey("IE_PROTO"),ObjectPrototype$2=Object.prototype,objectGetPrototypeOf=correctPrototypeGetter?Object.getPrototypeOf:function(e){var r=toObject(e);if(has$1(r,IE_PROTO))return r[IE_PROTO];var t=r.constructor;return isCallable(t)&&r instanceof t?t.prototype:r instanceof Object?ObjectPrototype$2:null},ITERATOR$5=wellKnownSymbol("iterator"),BUGGY_SAFARI_ITERATORS$1=!1,IteratorPrototype$2,PrototypeOfArrayIteratorPrototype,arrayIterator;[].keys&&(arrayIterator=[].keys(),"next"in arrayIterator?(PrototypeOfArrayIteratorPrototype=objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator)),PrototypeOfArrayIteratorPrototype!==Object.prototype&&(IteratorPrototype$2=PrototypeOfArrayIteratorPrototype)):BUGGY_SAFARI_ITERATORS$1=!0);var NEW_ITERATOR_PROTOTYPE=null==IteratorPrototype$2||fails((function(){var e={};return IteratorPrototype$2[ITERATOR$5].call(e)!==e}));NEW_ITERATOR_PROTOTYPE&&(IteratorPrototype$2={}),isCallable(IteratorPrototype$2[ITERATOR$5])||redefine(IteratorPrototype$2,ITERATOR$5,(function(){return this}));var iteratorsCore={IteratorPrototype:IteratorPrototype$2,BUGGY_SAFARI_ITERATORS:BUGGY_SAFARI_ITERATORS$1},IteratorPrototype$1=iteratorsCore.IteratorPrototype,returnThis$1=function(){return this},createIteratorConstructor=function(e,r,t){var a=r+" Iterator";return e.prototype=objectCreate(IteratorPrototype$1,{next:createPropertyDescriptor(1,t)}),setToStringTag(e,a,!1),iterators[a]=returnThis$1,e},PROPER_FUNCTION_NAME$3=functionName.PROPER,CONFIGURABLE_FUNCTION_NAME$1=functionName.CONFIGURABLE,IteratorPrototype=iteratorsCore.IteratorPrototype,BUGGY_SAFARI_ITERATORS=iteratorsCore.BUGGY_SAFARI_ITERATORS,ITERATOR$4=wellKnownSymbol("iterator"),KEYS="keys",VALUES="values",ENTRIES="entries",returnThis=function(){return this},defineIterator=function(e,r,t,a,i,s,c){createIteratorConstructor(t,r,a);var l,u,p,getIterationMethod=function(e){if(e===i&&g)return g;if(!BUGGY_SAFARI_ITERATORS&&e in y)return y[e];switch(e){case KEYS:return function keys(){return new t(this,e)};case VALUES:return function values(){return new t(this,e)};case ENTRIES:return function entries(){return new t(this,e)}}return function(){return new t(this)}},d=r+" Iterator",h=!1,y=e.prototype,A=y[ITERATOR$4]||y["@@iterator"]||i&&y[i],g=!BUGGY_SAFARI_ITERATORS&&A||getIterationMethod(i),E="Array"==r&&y.entries||A;if(E&&(l=objectGetPrototypeOf(E.call(new e)))!==Object.prototype&&l.next&&(objectGetPrototypeOf(l)!==IteratorPrototype&&(objectSetPrototypeOf?objectSetPrototypeOf(l,IteratorPrototype):isCallable(l[ITERATOR$4])||redefine(l,ITERATOR$4,returnThis)),setToStringTag(l,d,!0)),PROPER_FUNCTION_NAME$3&&i==VALUES&&A&&A.name!==VALUES&&(CONFIGURABLE_FUNCTION_NAME$1?createNonEnumerableProperty(y,"name",VALUES):(h=!0,g=function values(){return A.call(this)})),i)if(u={values:getIterationMethod(VALUES),keys:s?g:getIterationMethod(KEYS),entries:getIterationMethod(ENTRIES)},c)for(p in u)(BUGGY_SAFARI_ITERATORS||h||!(p in y))&&redefine(y,p,u[p]);else _export({target:r,proto:!0,forced:BUGGY_SAFARI_ITERATORS||h},u);return y[ITERATOR$4]!==g&&redefine(y,ITERATOR$4,g,{name:i}),iterators[r]=g,u},ARRAY_ITERATOR="Array Iterator",setInternalState$4=internalState.set,getInternalState$2=internalState.getterFor(ARRAY_ITERATOR),es_array_iterator=defineIterator(Array,"Array",(function(e,r){setInternalState$4(this,{type:ARRAY_ITERATOR,target:toIndexedObject(e),index:0,kind:r})}),(function(){var e=getInternalState$2(this),r=e.target,t=e.kind,a=e.index++;return!r||a>=r.length?(e.target=void 0,{value:void 0,done:!0}):"keys"==t?{value:a,done:!1}:"values"==t?{value:r[a],done:!1}:{value:[a,r[a]],done:!1}}),"values");iterators.Arguments=iterators.Array,addToUnscopables("keys"),addToUnscopables("values"),addToUnscopables("entries");var arrayBufferNative="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof DataView,defineProperty$1=objectDefineProperty.f,Int8Array$3=global$1.Int8Array,Int8ArrayPrototype=Int8Array$3&&Int8Array$3.prototype,Uint8ClampedArray=global$1.Uint8ClampedArray,Uint8ClampedArrayPrototype=Uint8ClampedArray&&Uint8ClampedArray.prototype,TypedArray=Int8Array$3&&objectGetPrototypeOf(Int8Array$3),TypedArrayPrototype=Int8ArrayPrototype&&objectGetPrototypeOf(Int8ArrayPrototype),ObjectPrototype$1=Object.prototype,isPrototypeOf=ObjectPrototype$1.isPrototypeOf,TO_STRING_TAG$1=wellKnownSymbol("toStringTag"),TYPED_ARRAY_TAG=uid("TYPED_ARRAY_TAG"),TYPED_ARRAY_CONSTRUCTOR$1=uid("TYPED_ARRAY_CONSTRUCTOR"),NATIVE_ARRAY_BUFFER_VIEWS$1=arrayBufferNative&&!!objectSetPrototypeOf&&"Opera"!==classof(global$1.opera),TYPED_ARRAY_TAG_REQIRED=!1,NAME,Constructor,Prototype,TypedArrayConstructorsList={Int8Array:1,Uint8Array:1,Uint8ClampedArray:1,Int16Array:2,Uint16Array:2,Int32Array:4,Uint32Array:4,Float32Array:4,Float64Array:8},BigIntArrayConstructorsList={BigInt64Array:8,BigUint64Array:8},isView=function isView(e){if(!isObject(e))return!1;var r=classof(e);return"DataView"===r||has$1(TypedArrayConstructorsList,r)||has$1(BigIntArrayConstructorsList,r)},isTypedArray=function(e){if(!isObject(e))return!1;var r=classof(e);return has$1(TypedArrayConstructorsList,r)||has$1(BigIntArrayConstructorsList,r)},aTypedArray$m=function(e){if(isTypedArray(e))return e;throw TypeError("Target is not a typed array")},aTypedArrayConstructor$2=function(e){if(isCallable(e)&&(!objectSetPrototypeOf||isPrototypeOf.call(TypedArray,e)))return e;throw TypeError(tryToString(e)+" is not a typed array constructor")},exportTypedArrayMethod$n=function(e,r,t){if(descriptors){if(t)for(var a in TypedArrayConstructorsList){var i=global$1[a];if(i&&has$1(i.prototype,e))try{delete i.prototype[e]}catch(e){}}TypedArrayPrototype[e]&&!t||redefine(TypedArrayPrototype,e,t?r:NATIVE_ARRAY_BUFFER_VIEWS$1&&Int8ArrayPrototype[e]||r)}},exportTypedArrayStaticMethod=function(e,r,t){var a,i;if(descriptors){if(objectSetPrototypeOf){if(t)for(a in TypedArrayConstructorsList)if((i=global$1[a])&&has$1(i,e))try{delete i[e]}catch(e){}if(TypedArray[e]&&!t)return;try{return redefine(TypedArray,e,t?r:NATIVE_ARRAY_BUFFER_VIEWS$1&&TypedArray[e]||r)}catch(e){}}for(a in TypedArrayConstructorsList)!(i=global$1[a])||i[e]&&!t||redefine(i,e,r)}};for(NAME in TypedArrayConstructorsList)Constructor=global$1[NAME],Prototype=Constructor&&Constructor.prototype,Prototype?createNonEnumerableProperty(Prototype,TYPED_ARRAY_CONSTRUCTOR$1,Constructor):NATIVE_ARRAY_BUFFER_VIEWS$1=!1;for(NAME in BigIntArrayConstructorsList)Constructor=global$1[NAME],Prototype=Constructor&&Constructor.prototype,Prototype&&createNonEnumerableProperty(Prototype,TYPED_ARRAY_CONSTRUCTOR$1,Constructor);if((!NATIVE_ARRAY_BUFFER_VIEWS$1||!isCallable(TypedArray)||TypedArray===Function.prototype)&&(TypedArray=function TypedArray(){throw TypeError("Incorrect invocation")},NATIVE_ARRAY_BUFFER_VIEWS$1))for(NAME in TypedArrayConstructorsList)global$1[NAME]&&objectSetPrototypeOf(global$1[NAME],TypedArray);if((!NATIVE_ARRAY_BUFFER_VIEWS$1||!TypedArrayPrototype||TypedArrayPrototype===ObjectPrototype$1)&&(TypedArrayPrototype=TypedArray.prototype,NATIVE_ARRAY_BUFFER_VIEWS$1))for(NAME in TypedArrayConstructorsList)global$1[NAME]&&objectSetPrototypeOf(global$1[NAME].prototype,TypedArrayPrototype);if(NATIVE_ARRAY_BUFFER_VIEWS$1&&objectGetPrototypeOf(Uint8ClampedArrayPrototype)!==TypedArrayPrototype&&objectSetPrototypeOf(Uint8ClampedArrayPrototype,TypedArrayPrototype),descriptors&&!has$1(TypedArrayPrototype,TO_STRING_TAG$1))for(NAME in TYPED_ARRAY_TAG_REQIRED=!0,defineProperty$1(TypedArrayPrototype,TO_STRING_TAG$1,{get:function(){return isObject(this)?this[TYPED_ARRAY_TAG]:void 0}}),TypedArrayConstructorsList)global$1[NAME]&&createNonEnumerableProperty(global$1[NAME],TYPED_ARRAY_TAG,NAME);var arrayBufferViewCore={NATIVE_ARRAY_BUFFER_VIEWS:NATIVE_ARRAY_BUFFER_VIEWS$1,TYPED_ARRAY_CONSTRUCTOR:TYPED_ARRAY_CONSTRUCTOR$1,TYPED_ARRAY_TAG:TYPED_ARRAY_TAG_REQIRED&&TYPED_ARRAY_TAG,aTypedArray:aTypedArray$m,aTypedArrayConstructor:aTypedArrayConstructor$2,exportTypedArrayMethod:exportTypedArrayMethod$n,exportTypedArrayStaticMethod:exportTypedArrayStaticMethod,isView:isView,isTypedArray:isTypedArray,TypedArray:TypedArray,TypedArrayPrototype:TypedArrayPrototype},NATIVE_ARRAY_BUFFER_VIEWS=arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS,ArrayBuffer$1=global$1.ArrayBuffer,Int8Array$2=global$1.Int8Array,typedArrayConstructorsRequireWrappers=!NATIVE_ARRAY_BUFFER_VIEWS||!fails((function(){Int8Array$2(1)}))||!fails((function(){new Int8Array$2(-1)}))||!checkCorrectnessOfIteration((function(e){new Int8Array$2,new Int8Array$2(null),new Int8Array$2(1.5),new Int8Array$2(e)}),!0)||fails((function(){return 1!==new Int8Array$2(new ArrayBuffer$1(2),1,void 0).length})),toIndex=function(e){if(void 0===e)return 0;var r=toInteger(e),t=toLength(r);if(r!==t)throw RangeError("Wrong length or index");return t},abs=Math.abs,pow$1=Math.pow,floor$6=Math.floor,log=Math.log,LN2=Math.LN2,pack=function(e,r,t){var a,i,s,c=new Array(t),l=8*t-r-1,u=(1<<l)-1,p=u>>1,d=23===r?pow$1(2,-24)-pow$1(2,-77):0,h=e<0||0===e&&1/e<0?1:0,y=0;for((e=abs(e))!=e||e===1/0?(i=e!=e?1:0,a=u):(a=floor$6(log(e)/LN2),e*(s=pow$1(2,-a))<1&&(a--,s*=2),(e+=a+p>=1?d/s:d*pow$1(2,1-p))*s>=2&&(a++,s/=2),a+p>=u?(i=0,a=u):a+p>=1?(i=(e*s-1)*pow$1(2,r),a+=p):(i=e*pow$1(2,p-1)*pow$1(2,r),a=0));r>=8;c[y++]=255&i,i/=256,r-=8);for(a=a<<r|i,l+=r;l>0;c[y++]=255&a,a/=256,l-=8);return c[--y]|=128*h,c},unpack=function(e,r){var t,a=e.length,i=8*a-r-1,s=(1<<i)-1,c=s>>1,l=i-7,u=a-1,p=e[u--],d=127&p;for(p>>=7;l>0;d=256*d+e[u],u--,l-=8);for(t=d&(1<<-l)-1,d>>=-l,l+=r;l>0;t=256*t+e[u],u--,l-=8);if(0===d)d=1-c;else{if(d===s)return t?NaN:p?-1/0:1/0;t+=pow$1(2,r),d-=c}return(p?-1:1)*t*pow$1(2,d-r)},ieee754={pack:pack,unpack:unpack},arrayFill=function fill(e){for(var r=toObject(this),t=toLength(r.length),a=arguments.length,i=toAbsoluteIndex(a>1?arguments[1]:void 0,t),s=a>2?arguments[2]:void 0,c=void 0===s?t:toAbsoluteIndex(s,t);c>i;)r[i++]=e;return r},getOwnPropertyNames=objectGetOwnPropertyNames.f,defineProperty=objectDefineProperty.f,PROPER_FUNCTION_NAME$2=functionName.PROPER,CONFIGURABLE_FUNCTION_NAME=functionName.CONFIGURABLE,getInternalState$1=internalState.get,setInternalState$3=internalState.set,ARRAY_BUFFER="ArrayBuffer",DATA_VIEW="DataView",PROTOTYPE="prototype",WRONG_LENGTH="Wrong length",WRONG_INDEX="Wrong index",NativeArrayBuffer=global$1[ARRAY_BUFFER],$ArrayBuffer=NativeArrayBuffer,$DataView=global$1[DATA_VIEW],$DataViewPrototype=$DataView&&$DataView[PROTOTYPE],ObjectPrototype=Object.prototype,RangeError$1=global$1.RangeError,packIEEE754=ieee754.pack,unpackIEEE754=ieee754.unpack,packInt8=function(e){return[255&e]},packInt16=function(e){return[255&e,e>>8&255]},packInt32=function(e){return[255&e,e>>8&255,e>>16&255,e>>24&255]},unpackInt32=function(e){return e[3]<<24|e[2]<<16|e[1]<<8|e[0]},packFloat32=function(e){return packIEEE754(e,23,4)},packFloat64=function(e){return packIEEE754(e,52,8)},addGetter=function(e,r){defineProperty(e[PROTOTYPE],r,{get:function(){return getInternalState$1(this)[r]}})},get=function(e,r,t,a){var i=toIndex(t),s=getInternalState$1(e);if(i+r>s.byteLength)throw RangeError$1(WRONG_INDEX);var c=getInternalState$1(s.buffer).bytes,l=i+s.byteOffset,u=c.slice(l,l+r);return a?u:u.reverse()},set=function(e,r,t,a,i,s){var c=toIndex(t),l=getInternalState$1(e);if(c+r>l.byteLength)throw RangeError$1(WRONG_INDEX);for(var u=getInternalState$1(l.buffer).bytes,p=c+l.byteOffset,d=a(+i),h=0;h<r;h++)u[p+h]=d[s?h:r-h-1]};if(arrayBufferNative){var INCORRECT_ARRAY_BUFFER_NAME=PROPER_FUNCTION_NAME$2&&NativeArrayBuffer.name!==ARRAY_BUFFER;if(fails((function(){NativeArrayBuffer(1)}))&&fails((function(){new NativeArrayBuffer(-1)}))&&!fails((function(){return new NativeArrayBuffer,new NativeArrayBuffer(1.5),new NativeArrayBuffer(NaN),INCORRECT_ARRAY_BUFFER_NAME&&!CONFIGURABLE_FUNCTION_NAME})))INCORRECT_ARRAY_BUFFER_NAME&&CONFIGURABLE_FUNCTION_NAME&&createNonEnumerableProperty(NativeArrayBuffer,"name",ARRAY_BUFFER);else{$ArrayBuffer=function ArrayBuffer(e){return anInstance(this,$ArrayBuffer),new NativeArrayBuffer(toIndex(e))};for(var ArrayBufferPrototype=$ArrayBuffer[PROTOTYPE]=NativeArrayBuffer[PROTOTYPE],keys=getOwnPropertyNames(NativeArrayBuffer),j=0,key;keys.length>j;)(key=keys[j++])in $ArrayBuffer||createNonEnumerableProperty($ArrayBuffer,key,NativeArrayBuffer[key]);ArrayBufferPrototype.constructor=$ArrayBuffer}objectSetPrototypeOf&&objectGetPrototypeOf($DataViewPrototype)!==ObjectPrototype&&objectSetPrototypeOf($DataViewPrototype,ObjectPrototype);var testView=new $DataView(new $ArrayBuffer(2)),$setInt8=$DataViewPrototype.setInt8;testView.setInt8(0,2147483648),testView.setInt8(1,2147483649),!testView.getInt8(0)&&testView.getInt8(1)||redefineAll($DataViewPrototype,{setInt8:function setInt8(e,r){$setInt8.call(this,e,r<<24>>24)},setUint8:function setUint8(e,r){$setInt8.call(this,e,r<<24>>24)}},{unsafe:!0})}else $ArrayBuffer=function ArrayBuffer(e){anInstance(this,$ArrayBuffer,ARRAY_BUFFER);var r=toIndex(e);setInternalState$3(this,{bytes:arrayFill.call(new Array(r),0),byteLength:r}),descriptors||(this.byteLength=r)},$DataView=function DataView(e,r,t){anInstance(this,$DataView,DATA_VIEW),anInstance(e,$ArrayBuffer,DATA_VIEW);var a=getInternalState$1(e).byteLength,i=toInteger(r);if(i<0||i>a)throw RangeError$1("Wrong offset");if(i+(t=void 0===t?a-i:toLength(t))>a)throw RangeError$1(WRONG_LENGTH);setInternalState$3(this,{buffer:e,byteLength:t,byteOffset:i}),descriptors||(this.buffer=e,this.byteLength=t,this.byteOffset=i)},descriptors&&(addGetter($ArrayBuffer,"byteLength"),addGetter($DataView,"buffer"),addGetter($DataView,"byteLength"),addGetter($DataView,"byteOffset")),redefineAll($DataView[PROTOTYPE],{getInt8:function getInt8(e){return get(this,1,e)[0]<<24>>24},getUint8:function getUint8(e){return get(this,1,e)[0]},getInt16:function getInt16(e){var r=get(this,2,e,arguments.length>1?arguments[1]:void 0);return(r[1]<<8|r[0])<<16>>16},getUint16:function getUint16(e){var r=get(this,2,e,arguments.length>1?arguments[1]:void 0);return r[1]<<8|r[0]},getInt32:function getInt32(e){return unpackInt32(get(this,4,e,arguments.length>1?arguments[1]:void 0))},getUint32:function getUint32(e){return unpackInt32(get(this,4,e,arguments.length>1?arguments[1]:void 0))>>>0},getFloat32:function getFloat32(e){return unpackIEEE754(get(this,4,e,arguments.length>1?arguments[1]:void 0),23)},getFloat64:function getFloat64(e){return unpackIEEE754(get(this,8,e,arguments.length>1?arguments[1]:void 0),52)},setInt8:function setInt8(e,r){set(this,1,e,packInt8,r)},setUint8:function setUint8(e,r){set(this,1,e,packInt8,r)},setInt16:function setInt16(e,r){set(this,2,e,packInt16,r,arguments.length>2?arguments[2]:void 0)},setUint16:function setUint16(e,r){set(this,2,e,packInt16,r,arguments.length>2?arguments[2]:void 0)},setInt32:function setInt32(e,r){set(this,4,e,packInt32,r,arguments.length>2?arguments[2]:void 0)},setUint32:function setUint32(e,r){set(this,4,e,packInt32,r,arguments.length>2?arguments[2]:void 0)},setFloat32:function setFloat32(e,r){set(this,4,e,packFloat32,r,arguments.length>2?arguments[2]:void 0)},setFloat64:function setFloat64(e,r){set(this,8,e,packFloat64,r,arguments.length>2?arguments[2]:void 0)}});setToStringTag($ArrayBuffer,ARRAY_BUFFER),setToStringTag($DataView,DATA_VIEW);var arrayBuffer={ArrayBuffer:$ArrayBuffer,DataView:$DataView},floor$5=Math.floor,isInteger=function isInteger(e){return!isObject(e)&&isFinite(e)&&floor$5(e)===e},toPositiveInteger=function(e){var r=toInteger(e);if(r<0)throw RangeError("The argument can't be less than 0");return r},toOffset=function(e,r){var t=toPositiveInteger(e);if(t%r)throw RangeError("Wrong offset");return t},aTypedArrayConstructor$1=arrayBufferViewCore.aTypedArrayConstructor,typedArrayFrom=function from(e){var r,t,a,i,s,c,l=aConstructor(this),u=toObject(e),p=arguments.length,d=p>1?arguments[1]:void 0,h=void 0!==d,y=getIteratorMethod(u);if(y&&!isArrayIteratorMethod(y))for(c=(s=getIterator(u,y)).next,u=[];!(i=c.call(s)).done;)u.push(i.value);for(h&&p>2&&(d=functionBindContext(d,arguments[2],2)),t=toLength(u.length),a=new(aTypedArrayConstructor$1(l))(t),r=0;t>r;r++)a[r]=h?d(u[r],r):u[r];return a},isArray=Array.isArray||function isArray(e){return"Array"==classofRaw(e)},SPECIES$2=wellKnownSymbol("species"),arraySpeciesConstructor=function(e){var r;return isArray(e)&&(r=e.constructor,(isConstructor(r)&&(r===Array||isArray(r.prototype))||isObject(r)&&null===(r=r[SPECIES$2]))&&(r=void 0)),void 0===r?Array:r},arraySpeciesCreate=function(e,r){return new(arraySpeciesConstructor(e))(0===r?0:r)},push=[].push,createMethod$2=function(e){var r=1==e,t=2==e,a=3==e,i=4==e,s=6==e,c=7==e,l=5==e||s;return function(u,p,d,h){for(var y,A,g=toObject(u),E=indexedObject(g),v=functionBindContext(p,d,3),m=toLength(E.length),I=0,R=h||arraySpeciesCreate,P=r?R(u,m):t||c?R(u,0):void 0;m>I;I++)if((l||I in E)&&(A=v(y=E[I],I,g),e))if(r)P[I]=A;else if(A)switch(e){case 3:return!0;case 5:return y;case 6:return I;case 2:push.call(P,y)}else switch(e){case 4:return!1;case 7:push.call(P,y)}return s?-1:a||i?i:P}},arrayIteration={forEach:createMethod$2(0),map:createMethod$2(1),filter:createMethod$2(2),some:createMethod$2(3),every:createMethod$2(4),find:createMethod$2(5),findIndex:createMethod$2(6),filterReject:createMethod$2(7)},typedArrayConstructor=createCommonjsModule((function(e){var r=objectGetOwnPropertyNames.f,t=arrayIteration.forEach,a=internalState.get,i=internalState.set,s=objectDefineProperty.f,c=objectGetOwnPropertyDescriptor.f,l=Math.round,u=global$1.RangeError,p=arrayBuffer.ArrayBuffer,d=arrayBuffer.DataView,h=arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS,y=arrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR,A=arrayBufferViewCore.TYPED_ARRAY_TAG,g=arrayBufferViewCore.TypedArray,E=arrayBufferViewCore.TypedArrayPrototype,v=arrayBufferViewCore.aTypedArrayConstructor,m=arrayBufferViewCore.isTypedArray,fromList=function(e,r){for(var t=0,a=r.length,i=new(v(e))(a);a>t;)i[t]=r[t++];return i},addGetter=function(e,r){s(e,r,{get:function(){return a(this)[r]}})},isArrayBuffer=function(e){var r;return e instanceof p||"ArrayBuffer"==(r=classof(e))||"SharedArrayBuffer"==r},isTypedArrayIndex=function(e,r){return m(e)&&!isSymbol(r)&&r in e&&isInteger(+r)&&r>=0},I=function getOwnPropertyDescriptor(e,r){return r=toPropertyKey(r),isTypedArrayIndex(e,r)?createPropertyDescriptor(2,e[r]):c(e,r)},R=function defineProperty(e,r,t){return r=toPropertyKey(r),!(isTypedArrayIndex(e,r)&&isObject(t)&&has$1(t,"value"))||has$1(t,"get")||has$1(t,"set")||t.configurable||has$1(t,"writable")&&!t.writable||has$1(t,"enumerable")&&!t.enumerable?s(e,r,t):(e[r]=t.value,e)};descriptors?(h||(objectGetOwnPropertyDescriptor.f=I,objectDefineProperty.f=R,addGetter(E,"buffer"),addGetter(E,"byteOffset"),addGetter(E,"byteLength"),addGetter(E,"length")),_export({target:"Object",stat:!0,forced:!h},{getOwnPropertyDescriptor:I,defineProperty:R}),e.exports=function(e,c,v){var I=e.match(/\d+$/)[0]/8,R=e+(v?"Clamped":"")+"Array",P="get"+e,S="set"+e,b=global$1[R],T=b,_=T&&T.prototype,O={},addElement=function(e,r){s(e,r,{get:function(){return function(e,r){var t=a(e);return t.view[P](r*I+t.byteOffset,!0)}(this,r)},set:function(e){return function(e,r,t){var i=a(e);v&&(t=(t=l(t))<0?0:t>255?255:255&t),i.view[S](r*I+i.byteOffset,t,!0)}(this,r,e)},enumerable:!0})};h?typedArrayConstructorsRequireWrappers&&(T=c((function(e,r,t,a){return anInstance(e,T,R),inheritIfRequired(isObject(r)?isArrayBuffer(r)?void 0!==a?new b(r,toOffset(t,I),a):void 0!==t?new b(r,toOffset(t,I)):new b(r):m(r)?fromList(T,r):typedArrayFrom.call(T,r):new b(toIndex(r)),e,T)})),objectSetPrototypeOf&&objectSetPrototypeOf(T,g),t(r(b),(function(e){e in T||createNonEnumerableProperty(T,e,b[e])})),T.prototype=_):(T=c((function(e,r,t,a){anInstance(e,T,R);var s,c,l,h=0,y=0;if(isObject(r)){if(!isArrayBuffer(r))return m(r)?fromList(T,r):typedArrayFrom.call(T,r);s=r,y=toOffset(t,I);var A=r.byteLength;if(void 0===a){if(A%I)throw u("Wrong length");if((c=A-y)<0)throw u("Wrong length")}else if((c=toLength(a)*I)+y>A)throw u("Wrong length");l=c/I}else l=toIndex(r),s=new p(c=l*I);for(i(e,{buffer:s,byteOffset:y,byteLength:c,length:l,view:new d(s)});h<l;)addElement(e,h++)})),objectSetPrototypeOf&&objectSetPrototypeOf(T,g),_=T.prototype=objectCreate(E)),_.constructor!==T&&createNonEnumerableProperty(_,"constructor",T),createNonEnumerableProperty(_,y,T),A&&createNonEnumerableProperty(_,A,R),O[R]=T,_export({global:!0,forced:T!=b,sham:!h},O),"BYTES_PER_ELEMENT"in T||createNonEnumerableProperty(T,"BYTES_PER_ELEMENT",I),"BYTES_PER_ELEMENT"in _||createNonEnumerableProperty(_,"BYTES_PER_ELEMENT",I),setSpecies(R)}):e.exports=function(){}}));typedArrayConstructor("Uint8",(function(e){return function Uint8Array(r,t,a){return e(this,r,t,a)}}));var min$3=Math.min,arrayCopyWithin=[].copyWithin||function copyWithin(e,r){var t=toObject(this),a=toLength(t.length),i=toAbsoluteIndex(e,a),s=toAbsoluteIndex(r,a),c=arguments.length>2?arguments[2]:void 0,l=min$3((void 0===c?a:toAbsoluteIndex(c,a))-s,a-i),u=1;for(s<i&&i<s+l&&(u=-1,s+=l-1,i+=l-1);l-- >0;)s in t?t[i]=t[s]:delete t[i],i+=u,s+=u;return t},aTypedArray$l=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$m=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$m("copyWithin",(function copyWithin(e,r){return arrayCopyWithin.call(aTypedArray$l(this),e,r,arguments.length>2?arguments[2]:void 0)}));var $every=arrayIteration.every,aTypedArray$k=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$l=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$l("every",(function every(e){return $every(aTypedArray$k(this),e,arguments.length>1?arguments[1]:void 0)}));var aTypedArray$j=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$k=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$k("fill",(function fill(e){return arrayFill.apply(aTypedArray$j(this),arguments)}));var arrayFromConstructorAndList=function(e,r){for(var t=0,a=r.length,i=new e(a);a>t;)i[t]=r[t++];return i},TYPED_ARRAY_CONSTRUCTOR=arrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR,aTypedArrayConstructor=arrayBufferViewCore.aTypedArrayConstructor,typedArraySpeciesConstructor=function(e){return aTypedArrayConstructor(speciesConstructor(e,e[TYPED_ARRAY_CONSTRUCTOR]))},typedArrayFromSpeciesAndList=function(e,r){return arrayFromConstructorAndList(typedArraySpeciesConstructor(e),r)},$filter$1=arrayIteration.filter,aTypedArray$i=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$j=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$j("filter",(function filter(e){var r=$filter$1(aTypedArray$i(this),e,arguments.length>1?arguments[1]:void 0);return typedArrayFromSpeciesAndList(this,r)}));var $find=arrayIteration.find,aTypedArray$h=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$i=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$i("find",(function find(e){return $find(aTypedArray$h(this),e,arguments.length>1?arguments[1]:void 0)}));var $findIndex=arrayIteration.findIndex,aTypedArray$g=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$h=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$h("findIndex",(function findIndex(e){return $findIndex(aTypedArray$g(this),e,arguments.length>1?arguments[1]:void 0)}));var $forEach$1=arrayIteration.forEach,aTypedArray$f=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$g=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$g("forEach",(function forEach(e){$forEach$1(aTypedArray$f(this),e,arguments.length>1?arguments[1]:void 0)}));var $includes$1=arrayIncludes.includes,aTypedArray$e=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$f=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$f("includes",(function includes(e){return $includes$1(aTypedArray$e(this),e,arguments.length>1?arguments[1]:void 0)}));var $indexOf=arrayIncludes.indexOf,aTypedArray$d=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$e=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$e("indexOf",(function indexOf(e){return $indexOf(aTypedArray$d(this),e,arguments.length>1?arguments[1]:void 0)}));var PROPER_FUNCTION_NAME$1=functionName.PROPER,ITERATOR$3=wellKnownSymbol("iterator"),Uint8Array$2=global$1.Uint8Array,arrayValues=es_array_iterator.values,arrayKeys=es_array_iterator.keys,arrayEntries=es_array_iterator.entries,aTypedArray$c=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$d=arrayBufferViewCore.exportTypedArrayMethod,nativeTypedArrayIterator=Uint8Array$2&&Uint8Array$2.prototype[ITERATOR$3],PROPER_ARRAY_VALUES_NAME=!!nativeTypedArrayIterator&&"values"===nativeTypedArrayIterator.name,typedArrayValues=function values(){return arrayValues.call(aTypedArray$c(this))};exportTypedArrayMethod$d("entries",(function entries(){return arrayEntries.call(aTypedArray$c(this))})),exportTypedArrayMethod$d("keys",(function keys(){return arrayKeys.call(aTypedArray$c(this))})),exportTypedArrayMethod$d("values",typedArrayValues,PROPER_FUNCTION_NAME$1&&!PROPER_ARRAY_VALUES_NAME),exportTypedArrayMethod$d(ITERATOR$3,typedArrayValues,PROPER_FUNCTION_NAME$1&&!PROPER_ARRAY_VALUES_NAME);var aTypedArray$b=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$c=arrayBufferViewCore.exportTypedArrayMethod,$join=[].join;exportTypedArrayMethod$c("join",(function join(e){return $join.apply(aTypedArray$b(this),arguments)}));var arrayMethodIsStrict=function(e,r){var t=[][e];return!!t&&fails((function(){t.call(null,r||function(){throw 1},1)}))},min$2=Math.min,$lastIndexOf=[].lastIndexOf,NEGATIVE_ZERO=!!$lastIndexOf&&1/[1].lastIndexOf(1,-0)<0,STRICT_METHOD$2=arrayMethodIsStrict("lastIndexOf"),FORCED$5=NEGATIVE_ZERO||!STRICT_METHOD$2,arrayLastIndexOf=FORCED$5?function lastIndexOf(e){if(NEGATIVE_ZERO)return $lastIndexOf.apply(this,arguments)||0;var r=toIndexedObject(this),t=toLength(r.length),a=t-1;for(arguments.length>1&&(a=min$2(a,toInteger(arguments[1]))),a<0&&(a=t+a);a>=0;a--)if(a in r&&r[a]===e)return a||0;return-1}:$lastIndexOf,aTypedArray$a=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$b=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$b("lastIndexOf",(function lastIndexOf(e){return arrayLastIndexOf.apply(aTypedArray$a(this),arguments)}));var $map=arrayIteration.map,aTypedArray$9=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$a=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$a("map",(function map(e){return $map(aTypedArray$9(this),e,arguments.length>1?arguments[1]:void 0,(function(e,r){return new(typedArraySpeciesConstructor(e))(r)}))}));var createMethod$1=function(e){return function(r,t,a,i){aCallable(t);var s=toObject(r),c=indexedObject(s),l=toLength(s.length),u=e?l-1:0,p=e?-1:1;if(a<2)for(;;){if(u in c){i=c[u],u+=p;break}if(u+=p,e?u<0:l<=u)throw TypeError("Reduce of empty array with no initial value")}for(;e?u>=0:l>u;u+=p)u in c&&(i=t(i,c[u],u,s));return i}},arrayReduce={left:createMethod$1(!1),right:createMethod$1(!0)},$reduce=arrayReduce.left,aTypedArray$8=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$9=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$9("reduce",(function reduce(e){return $reduce(aTypedArray$8(this),e,arguments.length,arguments.length>1?arguments[1]:void 0)}));var $reduceRight=arrayReduce.right,aTypedArray$7=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$8=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$8("reduceRight",(function reduceRight(e){return $reduceRight(aTypedArray$7(this),e,arguments.length,arguments.length>1?arguments[1]:void 0)}));var aTypedArray$6=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$7=arrayBufferViewCore.exportTypedArrayMethod,floor$4=Math.floor;exportTypedArrayMethod$7("reverse",(function reverse(){for(var e,r=aTypedArray$6(this).length,t=floor$4(r/2),a=0;a<t;)e=this[a],this[a++]=this[--r],this[r]=e;return this}));var aTypedArray$5=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$6=arrayBufferViewCore.exportTypedArrayMethod,FORCED$4=fails((function(){new Int8Array(1).set({})}));exportTypedArrayMethod$6("set",(function set(e){aTypedArray$5(this);var r=toOffset(arguments.length>1?arguments[1]:void 0,1),t=this.length,a=toObject(e),i=toLength(a.length),s=0;if(i+r>t)throw RangeError("Wrong length");for(;s<i;)this[r+s]=a[s++]}),FORCED$4);var aTypedArray$4=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$5=arrayBufferViewCore.exportTypedArrayMethod,$slice$1=[].slice,FORCED$3=fails((function(){new Int8Array(1).slice()}));exportTypedArrayMethod$5("slice",(function slice(e,r){for(var t=$slice$1.call(aTypedArray$4(this),e,r),a=typedArraySpeciesConstructor(this),i=0,s=t.length,c=new a(s);s>i;)c[i]=t[i++];return c}),FORCED$3);var $some=arrayIteration.some,aTypedArray$3=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$4=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$4("some",(function some(e){return $some(aTypedArray$3(this),e,arguments.length>1?arguments[1]:void 0)}));var floor$3=Math.floor,mergeSort=function(e,r){var t=e.length,a=floor$3(t/2);return t<8?insertionSort(e,r):merge(mergeSort(e.slice(0,a),r),mergeSort(e.slice(a),r),r)},insertionSort=function(e,r){for(var t,a,i=e.length,s=1;s<i;){for(a=s,t=e[s];a&&r(e[a-1],t)>0;)e[a]=e[--a];a!==s++&&(e[a]=t)}return e},merge=function(e,r,t){for(var a=e.length,i=r.length,s=0,c=0,l=[];s<a||c<i;)s<a&&c<i?l.push(t(e[s],r[c])<=0?e[s++]:r[c++]):l.push(s<a?e[s++]:r[c++]);return l},arraySort=mergeSort,firefox=engineUserAgent.match(/firefox\/(\d+)/i),engineFfVersion=!!firefox&&+firefox[1],engineIsIeOrEdge=/MSIE|Trident/.test(engineUserAgent),webkit=engineUserAgent.match(/AppleWebKit\/(\d+)\./),engineWebkitVersion=!!webkit&&+webkit[1],aTypedArray$2=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$3=arrayBufferViewCore.exportTypedArrayMethod,Uint16Array$1=global$1.Uint16Array,nativeSort$1=Uint16Array$1&&Uint16Array$1.prototype.sort,ACCEPT_INCORRECT_ARGUMENTS=!!nativeSort$1&&!fails((function(){var e=new Uint16Array$1(2);e.sort(null),e.sort({})})),STABLE_SORT$1=!!nativeSort$1&&!fails((function(){if(engineV8Version)return engineV8Version<74;if(engineFfVersion)return engineFfVersion<67;if(engineIsIeOrEdge)return!0;if(engineWebkitVersion)return engineWebkitVersion<602;var e,r,t=new Uint16Array$1(516),a=Array(516);for(e=0;e<516;e++)r=e%4,t[e]=515-e,a[e]=e-2*r+3;for(t.sort((function(e,r){return(e/4|0)-(r/4|0)})),e=0;e<516;e++)if(t[e]!==a[e])return!0})),getSortCompare$1=function(e){return function(r,t){return void 0!==e?+e(r,t)||0:t!=t?-1:r!=r?1:0===r&&0===t?1/r>0&&1/t<0?1:-1:r>t}};exportTypedArrayMethod$3("sort",(function sort(e){if(void 0!==e&&aCallable(e),STABLE_SORT$1)return nativeSort$1.call(this,e);aTypedArray$2(this);var r,t=toLength(this.length),a=Array(t);for(r=0;r<t;r++)a[r]=this[r];for(a=arraySort(this,getSortCompare$1(e)),r=0;r<t;r++)this[r]=a[r];return this}),!STABLE_SORT$1||ACCEPT_INCORRECT_ARGUMENTS);var aTypedArray$1=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$2=arrayBufferViewCore.exportTypedArrayMethod;exportTypedArrayMethod$2("subarray",(function subarray(e,r){var t=aTypedArray$1(this),a=t.length,i=toAbsoluteIndex(e,a);return new(typedArraySpeciesConstructor(t))(t.buffer,t.byteOffset+i*t.BYTES_PER_ELEMENT,toLength((void 0===r?a:toAbsoluteIndex(r,a))-i))}));var Int8Array$1=global$1.Int8Array,aTypedArray=arrayBufferViewCore.aTypedArray,exportTypedArrayMethod$1=arrayBufferViewCore.exportTypedArrayMethod,$toLocaleString=[].toLocaleString,$slice=[].slice,TO_LOCALE_STRING_BUG=!!Int8Array$1&&fails((function(){$toLocaleString.call(new Int8Array$1(1))})),FORCED$2=fails((function(){return[1,2].toLocaleString()!=new Int8Array$1([1,2]).toLocaleString()}))||!fails((function(){Int8Array$1.prototype.toLocaleString.call([1,2])}));exportTypedArrayMethod$1("toLocaleString",(function toLocaleString(){return $toLocaleString.apply(TO_LOCALE_STRING_BUG?$slice.call(aTypedArray(this)):aTypedArray(this),arguments)}),FORCED$2);var exportTypedArrayMethod=arrayBufferViewCore.exportTypedArrayMethod,Uint8Array$1=global$1.Uint8Array,Uint8ArrayPrototype=Uint8Array$1&&Uint8Array$1.prototype||{},arrayToString=[].toString,arrayJoin=[].join;fails((function(){arrayToString.call({})}))&&(arrayToString=function toString(){return arrayJoin.call(this)});var IS_NOT_ARRAY_METHOD=Uint8ArrayPrototype.toString!=arrayToString;exportTypedArrayMethod("toString",arrayToString,IS_NOT_ARRAY_METHOD);var $includes=arrayIncludes.includes;_export({target:"Array",proto:!0},{includes:function includes(e){return $includes(this,e,arguments.length>1?arguments[1]:void 0)}}),addToUnscopables("includes");var notARegexp=function(e){if(isRegexp(e))throw TypeError("The method doesn't accept regular expressions");return e},MATCH=wellKnownSymbol("match"),correctIsRegexpLogic=function(e){var r=/./;try{"/./"[e](r)}catch(t){try{return r[MATCH]=!1,"/./"[e](r)}catch(e){}}return!1};_export({target:"String",proto:!0,forced:!correctIsRegexpLogic("includes")},{includes:function includes(e){return!!~toString(requireObjectCoercible(this)).indexOf(toString(notARegexp(e)),arguments.length>1?arguments[1]:void 0)}});var createProperty=function(e,r,t){var a=toPropertyKey(r);a in e?objectDefineProperty.f(e,a,createPropertyDescriptor(0,t)):e[a]=t},SPECIES$1=wellKnownSymbol("species"),arrayMethodHasSpeciesSupport=function(e){return engineV8Version>=51||!fails((function(){var r=[];return(r.constructor={})[SPECIES$1]=function(){return{foo:1}},1!==r[e](Boolean).foo}))},HAS_SPECIES_SUPPORT$1=arrayMethodHasSpeciesSupport("slice"),SPECIES=wellKnownSymbol("species"),nativeSlice=[].slice,max$1=Math.max;_export({target:"Array",proto:!0,forced:!HAS_SPECIES_SUPPORT$1},{slice:function slice(e,r){var t,a,i,s=toIndexedObject(this),c=toLength(s.length),l=toAbsoluteIndex(e,c),u=toAbsoluteIndex(void 0===r?c:r,c);if(isArray(s)&&(t=s.constructor,(isConstructor(t)&&(t===Array||isArray(t.prototype))||isObject(t)&&null===(t=t[SPECIES]))&&(t=void 0),t===Array||void 0===t))return nativeSlice.call(s,l,u);for(a=new(void 0===t?Array:t)(max$1(u-l,0)),i=0;l<u;l++,i++)l in s&&createProperty(a,i,s[l]);return a.length=i,a}}),typedArrayConstructor("Uint32",(function(e){return function Uint32Array(r,t,a){return e(this,r,t,a)}})),typedArrayConstructor("Uint16",(function(e){return function Uint16Array(r,t,a){return e(this,r,t,a)}}));var $filter=arrayIteration.filter,HAS_SPECIES_SUPPORT=arrayMethodHasSpeciesSupport("filter");_export({target:"Array",proto:!0,forced:!HAS_SPECIES_SUPPORT},{filter:function filter(e){return $filter(this,e,arguments.length>1?arguments[1]:void 0)}});var PROPER_FUNCTION_NAME=functionName.PROPER,TO_STRING="toString",RegExpPrototype=RegExp.prototype,nativeToString=RegExpPrototype[TO_STRING],NOT_GENERIC=fails((function(){return"/a/b"!=nativeToString.call({source:"a",flags:"b"})})),INCORRECT_NAME=PROPER_FUNCTION_NAME&&nativeToString.name!=TO_STRING;(NOT_GENERIC||INCORRECT_NAME)&&redefine(RegExp.prototype,TO_STRING,(function toString$1(){var e=anObject(this),r=toString(e.source),t=e.flags;return"/"+r+"/"+toString(void 0===t&&e instanceof RegExp&&!("flags"in RegExpPrototype)?regexpFlags.call(e):t)}),{unsafe:!0});var test=[],nativeSort=test.sort,FAILS_ON_UNDEFINED=fails((function(){test.sort(void 0)})),FAILS_ON_NULL=fails((function(){test.sort(null)})),STRICT_METHOD$1=arrayMethodIsStrict("sort"),STABLE_SORT=!fails((function(){if(engineV8Version)return engineV8Version<70;if(!(engineFfVersion&&engineFfVersion>3)){if(engineIsIeOrEdge)return!0;if(engineWebkitVersion)return engineWebkitVersion<603;var e,r,t,a,i="";for(e=65;e<76;e++){switch(r=String.fromCharCode(e),e){case 66:case 69:case 70:case 72:t=3;break;case 68:case 71:t=4;break;default:t=2}for(a=0;a<47;a++)test.push({k:r+a,v:t})}for(test.sort((function(e,r){return r.v-e.v})),a=0;a<test.length;a++)r=test[a].k.charAt(0),i.charAt(i.length-1)!==r&&(i+=r);return"DGBEFHACIJK"!==i}})),FORCED$1=FAILS_ON_UNDEFINED||!FAILS_ON_NULL||!STRICT_METHOD$1||!STABLE_SORT,getSortCompare=function(e){return function(r,t){return void 0===t?-1:void 0===r?1:void 0!==e?+e(r,t)||0:toString(r)>toString(t)?1:-1}};_export({target:"Array",proto:!0,forced:FORCED$1},{sort:function sort(e){void 0!==e&&aCallable(e);var r=toObject(this);if(STABLE_SORT)return void 0===e?nativeSort.call(r):nativeSort.call(r,e);var t,a,i=[],s=toLength(r.length);for(a=0;a<s;a++)a in r&&i.push(r[a]);for(t=(i=arraySort(i,getSortCompare(e))).length,a=0;a<t;)r[a]=i[a++];for(;a<s;)delete r[a++];return r}});var UZIP_1=createCommonjsModule((function(e){var r,t,UZIP={};e.exports=UZIP,UZIP.parse=function(e,r){for(var t=UZIP.bin.readUshort,a=UZIP.bin.readUint,i=0,s={},c=new Uint8Array(e),l=c.length-4;101010256!=a(c,l);)l--;i=l;i+=4;var u=t(c,i+=4);t(c,i+=2);var p=a(c,i+=2),d=a(c,i+=4);i+=4,i=d;for(var h=0;h<u;h++){a(c,i),i+=4,i+=4,i+=4,a(c,i+=4);p=a(c,i+=4);var y=a(c,i+=4),A=t(c,i+=4),g=t(c,i+2),E=t(c,i+4);i+=6;var v=a(c,i+=8);i+=4,i+=A+g+E,UZIP._readLocal(c,v,s,p,y,r)}return s},UZIP._readLocal=function(e,r,t,a,i,s){var c=UZIP.bin.readUshort,l=UZIP.bin.readUint;l(e,r),c(e,r+=4),c(e,r+=2);var u=c(e,r+=2);l(e,r+=2),l(e,r+=4),r+=4;var p=c(e,r+=8),d=c(e,r+=2);r+=2;var h=UZIP.bin.readUTF8(e,r,p);if(r+=p,r+=d,s)t[h]={size:i,csize:a};else{var y=new Uint8Array(e.buffer,r);if(0==u)t[h]=new Uint8Array(y.buffer.slice(r,r+a));else{if(8!=u)throw"unknown compression method: "+u;var A=new Uint8Array(i);UZIP.inflateRaw(y,A),t[h]=A}}},UZIP.inflateRaw=function(e,r){return UZIP.F.inflate(e,r)},UZIP.inflate=function(e,r){return e[0],e[1],UZIP.inflateRaw(new Uint8Array(e.buffer,e.byteOffset+2,e.length-6),r)},UZIP.deflate=function(e,r){null==r&&(r={level:6});var t=0,a=new Uint8Array(50+Math.floor(1.1*e.length));a[t]=120,a[t+1]=156,t+=2,t=UZIP.F.deflateRaw(e,a,t,r.level);var i=UZIP.adler(e,0,e.length);return a[t+0]=i>>>24&255,a[t+1]=i>>>16&255,a[t+2]=i>>>8&255,a[t+3]=i>>>0&255,new Uint8Array(a.buffer,0,t+4)},UZIP.deflateRaw=function(e,r){null==r&&(r={level:6});var t=new Uint8Array(50+Math.floor(1.1*e.length)),a=UZIP.F.deflateRaw(e,t,a,r.level);return new Uint8Array(t.buffer,0,a)},UZIP.encode=function(e,r){null==r&&(r=!1);var t=0,a=UZIP.bin.writeUint,i=UZIP.bin.writeUshort,s={};for(var c in e){var l=!UZIP._noNeed(c)&&!r,u=e[c],p=UZIP.crc.crc(u,0,u.length);s[c]={cpr:l,usize:u.length,crc:p,file:l?UZIP.deflateRaw(u):u}}for(var c in s)t+=s[c].file.length+30+46+2*UZIP.bin.sizeUTF8(c);t+=22;var d=new Uint8Array(t),h=0,y=[];for(var c in s){var A=s[c];y.push(h),h=UZIP._writeHeader(d,h,c,A,0)}var g=0,E=h;for(var c in s){A=s[c];y.push(h),h=UZIP._writeHeader(d,h,c,A,1,y[g++])}var v=h-E;return a(d,h,101010256),h+=4,i(d,h+=4,g),i(d,h+=2,g),a(d,h+=2,v),a(d,h+=4,E),h+=4,h+=2,d.buffer},UZIP._noNeed=function(e){var r=e.split(".").pop().toLowerCase();return-1!="png,jpg,jpeg,zip".indexOf(r)},UZIP._writeHeader=function(e,r,t,a,i,s){var c=UZIP.bin.writeUint,l=UZIP.bin.writeUshort,u=a.file;return c(e,r,0==i?67324752:33639248),r+=4,1==i&&(r+=2),l(e,r,20),l(e,r+=2,0),l(e,r+=2,a.cpr?8:0),c(e,r+=2,0),c(e,r+=4,a.crc),c(e,r+=4,u.length),c(e,r+=4,a.usize),l(e,r+=4,UZIP.bin.sizeUTF8(t)),l(e,r+=2,0),r+=2,1==i&&(r+=2,r+=2,c(e,r+=6,s),r+=4),r+=UZIP.bin.writeUTF8(e,r,t),0==i&&(e.set(u,r),r+=u.length),r},UZIP.crc={table:function(){for(var e=new Uint32Array(256),r=0;r<256;r++){for(var t=r,a=0;a<8;a++)1&t?t=3988292384^t>>>1:t>>>=1;e[r]=t}return e}(),update:function(e,r,t,a){for(var i=0;i<a;i++)e=UZIP.crc.table[255&(e^r[t+i])]^e>>>8;return e},crc:function(e,r,t){return 4294967295^UZIP.crc.update(4294967295,e,r,t)}},UZIP.adler=function(e,r,t){for(var a=1,i=0,s=r,c=r+t;s<c;){for(var l=Math.min(s+5552,c);s<l;)i+=a+=e[s++];a%=65521,i%=65521}return i<<16|a},UZIP.bin={readUshort:function(e,r){return e[r]|e[r+1]<<8},writeUshort:function(e,r,t){e[r]=255&t,e[r+1]=t>>8&255},readUint:function(e,r){return 16777216*e[r+3]+(e[r+2]<<16|e[r+1]<<8|e[r])},writeUint:function(e,r,t){e[r]=255&t,e[r+1]=t>>8&255,e[r+2]=t>>16&255,e[r+3]=t>>24&255},readASCII:function(e,r,t){for(var a="",i=0;i<t;i++)a+=String.fromCharCode(e[r+i]);return a},writeASCII:function(e,r,t){for(var a=0;a<t.length;a++)e[r+a]=t.charCodeAt(a)},pad:function(e){return e.length<2?"0"+e:e},readUTF8:function(e,r,t){for(var a,i="",s=0;s<t;s++)i+="%"+UZIP.bin.pad(e[r+s].toString(16));try{a=decodeURIComponent(i)}catch(a){return UZIP.bin.readASCII(e,r,t)}return a},writeUTF8:function(e,r,t){for(var a=t.length,i=0,s=0;s<a;s++){var c=t.charCodeAt(s);if(0==(4294967168&c))e[r+i]=c,i++;else if(0==(4294965248&c))e[r+i]=192|c>>6,e[r+i+1]=128|c>>0&63,i+=2;else if(0==(4294901760&c))e[r+i]=224|c>>12,e[r+i+1]=128|c>>6&63,e[r+i+2]=128|c>>0&63,i+=3;else{if(0!=(4292870144&c))throw"e";e[r+i]=240|c>>18,e[r+i+1]=128|c>>12&63,e[r+i+2]=128|c>>6&63,e[r+i+3]=128|c>>0&63,i+=4}}return i},sizeUTF8:function(e){for(var r=e.length,t=0,a=0;a<r;a++){var i=e.charCodeAt(a);if(0==(4294967168&i))t++;else if(0==(4294965248&i))t+=2;else if(0==(4294901760&i))t+=3;else{if(0!=(4292870144&i))throw"e";t+=4}}return t}},UZIP.F={},UZIP.F.deflateRaw=function(e,r,t,a){var i=[[0,0,0,0,0],[4,4,8,4,0],[4,5,16,8,0],[4,6,16,16,0],[4,10,16,32,0],[8,16,32,32,0],[8,16,128,128,0],[8,32,128,256,0],[32,128,258,1024,1],[32,258,258,4096,1]][a],s=UZIP.F.U,c=UZIP.F._goodIndex;UZIP.F._hash;var l=UZIP.F._putsE,u=0,p=t<<3,d=0,h=e.length;if(0==a){for(;u<h;){l(r,p,u+(T=Math.min(65535,h-u))==h?1:0),p=UZIP.F._copyExact(e,u,T,r,p+8),u+=T}return p>>>3}var y=s.lits,A=s.strt,g=s.prev,E=0,v=0,m=0,I=0,R=0,P=0;for(h>2&&(A[P=UZIP.F._hash(e,0)]=0),u=0;u<h;u++){if(R=P,u+1<h-2){P=UZIP.F._hash(e,u+1);var S=u+1&32767;g[S]=A[P],A[P]=S}if(d<=u){(E>14e3||v>26697)&&h-u>100&&(d<u&&(y[E]=u-d,E+=2,d=u),p=UZIP.F._writeBlock(u==h-1||d==h?1:0,y,E,I,e,m,u-m,r,p),E=v=I=0,m=u);var b=0;u<h-2&&(b=UZIP.F._bestMatch(e,u,g,R,Math.min(i[2],h-u),i[3]));var T=b>>>16,_=65535&b;if(0!=b){_=65535&b;var O=c(T=b>>>16,s.of0);s.lhst[257+O]++;var w=c(_,s.df0);s.dhst[w]++,I+=s.exb[O]+s.dxb[w],y[E]=T<<23|u-d,y[E+1]=_<<16|O<<8|w,E+=2,d=u+T}else s.lhst[e[u]]++;v++}}for(m==u&&0!=e.length||(d<u&&(y[E]=u-d,E+=2,d=u),p=UZIP.F._writeBlock(1,y,E,I,e,m,u-m,r,p),E=0,v=0,E=v=I=0,m=u);0!=(7&p);)p++;return p>>>3},UZIP.F._bestMatch=function(e,r,t,a,i,s){var c=32767&r,l=t[c],u=c-l+32768&32767;if(l==c||a!=UZIP.F._hash(e,r-u))return 0;for(var p=0,d=0,h=Math.min(32767,r);u<=h&&0!=--s&&l!=c;){if(0==p||e[r+p]==e[r+p-u]){var y=UZIP.F._howLong(e,r,u);if(y>p){if(d=u,(p=y)>=i)break;u+2<y&&(y=u+2);for(var A=0,g=0;g<y-2;g++){var E=r-u+g+32768&32767,v=E-t[E]+32768&32767;v>A&&(A=v,l=E)}}}u+=(c=l)-(l=t[c])+32768&32767}return p<<16|d},UZIP.F._howLong=function(e,r,t){if(e[r]!=e[r-t]||e[r+1]!=e[r+1-t]||e[r+2]!=e[r+2-t])return 0;var a=r,i=Math.min(e.length,r+258);for(r+=3;r<i&&e[r]==e[r-t];)r++;return r-a},UZIP.F._hash=function(e,r){return(e[r]<<8|e[r+1])+(e[r+2]<<4)&65535},UZIP.saved=0,UZIP.F._writeBlock=function(e,r,t,a,i,s,c,l,u){var p,d,h,y,A,g,E,v,m,I=UZIP.F.U,R=UZIP.F._putsF,P=UZIP.F._putsE;I.lhst[256]++,d=(p=UZIP.F.getTrees())[0],h=p[1],y=p[2],A=p[3],g=p[4],E=p[5],v=p[6],m=p[7];var S=32+(0==(u+3&7)?0:8-(u+3&7))+(c<<3),b=a+UZIP.F.contSize(I.fltree,I.lhst)+UZIP.F.contSize(I.fdtree,I.dhst),T=a+UZIP.F.contSize(I.ltree,I.lhst)+UZIP.F.contSize(I.dtree,I.dhst);T+=14+3*E+UZIP.F.contSize(I.itree,I.ihst)+(2*I.ihst[16]+3*I.ihst[17]+7*I.ihst[18]);for(var _=0;_<286;_++)I.lhst[_]=0;for(_=0;_<30;_++)I.dhst[_]=0;for(_=0;_<19;_++)I.ihst[_]=0;var O=S<b&&S<T?0:b<T?1:2;if(R(l,u,e),R(l,u+1,O),u+=3,0==O){for(;0!=(7&u);)u++;u=UZIP.F._copyExact(i,s,c,l,u)}else{var w,U;if(1==O&&(w=I.fltree,U=I.fdtree),2==O){UZIP.F.makeCodes(I.ltree,d),UZIP.F.revCodes(I.ltree,d),UZIP.F.makeCodes(I.dtree,h),UZIP.F.revCodes(I.dtree,h),UZIP.F.makeCodes(I.itree,y),UZIP.F.revCodes(I.itree,y),w=I.ltree,U=I.dtree,P(l,u,A-257),P(l,u+=5,g-1),P(l,u+=5,E-4),u+=4;for(var C=0;C<E;C++)P(l,u+3*C,I.itree[1+(I.ordr[C]<<1)]);u+=3*E,u=UZIP.F._codeTiny(v,I.itree,l,u),u=UZIP.F._codeTiny(m,I.itree,l,u)}for(var $=s,L=0;L<t;L+=2){for(var M=r[L],x=M>>>23,B=$+(8388607&M);$<B;)u=UZIP.F._writeLit(i[$++],w,l,u);if(0!=x){var D=r[L+1],G=D>>16,V=D>>8&255,k=255&D;P(l,u=UZIP.F._writeLit(257+V,w,l,u),x-I.of0[V]),u+=I.exb[V],R(l,u=UZIP.F._writeLit(k,U,l,u),G-I.df0[k]),u+=I.dxb[k],$+=x}}u=UZIP.F._writeLit(256,w,l,u)}return u},UZIP.F._copyExact=function(e,r,t,a,i){var s=i>>>3;return a[s]=t,a[s+1]=t>>>8,a[s+2]=255-a[s],a[s+3]=255-a[s+1],s+=4,a.set(new Uint8Array(e.buffer,r,t),s),i+(t+4<<3)},UZIP.F.getTrees=function(){for(var e=UZIP.F.U,r=UZIP.F._hufTree(e.lhst,e.ltree,15),t=UZIP.F._hufTree(e.dhst,e.dtree,15),a=[],i=UZIP.F._lenCodes(e.ltree,a),s=[],c=UZIP.F._lenCodes(e.dtree,s),l=0;l<a.length;l+=2)e.ihst[a[l]]++;for(l=0;l<s.length;l+=2)e.ihst[s[l]]++;for(var u=UZIP.F._hufTree(e.ihst,e.itree,7),p=19;p>4&&0==e.itree[1+(e.ordr[p-1]<<1)];)p--;return[r,t,u,i,c,p,a,s]},UZIP.F.getSecond=function(e){for(var r=[],t=0;t<e.length;t+=2)r.push(e[t+1]);return r},UZIP.F.nonZero=function(e){for(var r="",t=0;t<e.length;t+=2)0!=e[t+1]&&(r+=(t>>1)+",");return r},UZIP.F.contSize=function(e,r){for(var t=0,a=0;a<r.length;a++)t+=r[a]*e[1+(a<<1)];return t},UZIP.F._codeTiny=function(e,r,t,a){for(var i=0;i<e.length;i+=2){var s=e[i],c=e[i+1];a=UZIP.F._writeLit(s,r,t,a);var l=16==s?2:17==s?3:7;s>15&&(UZIP.F._putsE(t,a,c,l),a+=l)}return a},UZIP.F._lenCodes=function(e,r){for(var t=e.length;2!=t&&0==e[t-1];)t-=2;for(var a=0;a<t;a+=2){var i=e[a+1],s=a+3<t?e[a+3]:-1,c=a+5<t?e[a+5]:-1,l=0==a?-1:e[a-1];if(0==i&&s==i&&c==i){for(var u=a+5;u+2<t&&e[u+2]==i;)u+=2;(p=Math.min(u+1-a>>>1,138))<11?r.push(17,p-3):r.push(18,p-11),a+=2*p-2}else if(i==l&&s==i&&c==i){for(u=a+5;u+2<t&&e[u+2]==i;)u+=2;var p=Math.min(u+1-a>>>1,6);r.push(16,p-3),a+=2*p-2}else r.push(i,0)}return t>>>1},UZIP.F._hufTree=function(e,r,t){var a=[],i=e.length,s=r.length,c=0;for(c=0;c<s;c+=2)r[c]=0,r[c+1]=0;for(c=0;c<i;c++)0!=e[c]&&a.push({lit:c,f:e[c]});var l=a.length,u=a.slice(0);if(0==l)return 0;if(1==l){var p=a[0].lit;u=0==p?1:0;return r[1+(p<<1)]=1,r[1+(u<<1)]=1,1}a.sort((function(e,r){return e.f-r.f}));var d=a[0],h=a[1],y=0,A=1,g=2;for(a[0]={lit:-1,f:d.f+h.f,l:d,r:h,d:0};A!=l-1;)d=y!=A&&(g==l||a[y].f<a[g].f)?a[y++]:a[g++],h=y!=A&&(g==l||a[y].f<a[g].f)?a[y++]:a[g++],a[A++]={lit:-1,f:d.f+h.f,l:d,r:h};var E=UZIP.F.setDepth(a[A-1],0);for(E>t&&(UZIP.F.restrictDepth(u,t,E),E=t),c=0;c<l;c++)r[1+(u[c].lit<<1)]=u[c].d;return E},UZIP.F.setDepth=function(e,r){return-1!=e.lit?(e.d=r,r):Math.max(UZIP.F.setDepth(e.l,r+1),UZIP.F.setDepth(e.r,r+1))},UZIP.F.restrictDepth=function(e,r,t){var a=0,i=1<<t-r,s=0;for(e.sort((function(e,r){return r.d==e.d?e.f-r.f:r.d-e.d})),a=0;a<e.length&&e[a].d>r;a++){var c=e[a].d;e[a].d=r,s+=i-(1<<t-c)}for(s>>>=t-r;s>0;){(c=e[a].d)<r?(e[a].d++,s-=1<<r-c-1):a++}for(;a>=0;a--)e[a].d==r&&s<0&&(e[a].d--,s++);0!=s&&console.log("debt left")},UZIP.F._goodIndex=function(e,r){var t=0;return r[16|t]<=e&&(t|=16),r[8|t]<=e&&(t|=8),r[4|t]<=e&&(t|=4),r[2|t]<=e&&(t|=2),r[1|t]<=e&&(t|=1),t},UZIP.F._writeLit=function(e,r,t,a){return UZIP.F._putsF(t,a,r[e<<1]),a+r[1+(e<<1)]},UZIP.F.inflate=function(e,r){var t=Uint8Array;if(3==e[0]&&0==e[1])return r||new t(0);var a=UZIP.F,i=a._bitsF,s=a._bitsE,c=a._decodeTiny,l=a.makeCodes,u=a.codes2map,p=a._get17,d=a.U,h=null==r;h&&(r=new t(e.length>>>2<<3));for(var y,A,g=0,E=0,v=0,m=0,I=0,R=0,P=0,S=0,b=0;0==g;)if(g=i(e,b,1),E=i(e,b+1,2),b+=3,0!=E){if(h&&(r=UZIP.F._check(r,S+(1<<17))),1==E&&(y=d.flmap,A=d.fdmap,R=511,P=31),2==E){v=s(e,b,5)+257,m=s(e,b+5,5)+1,I=s(e,b+10,4)+4,b+=14;for(var T=0;T<38;T+=2)d.itree[T]=0,d.itree[T+1]=0;var _=1;for(T=0;T<I;T++){var O=s(e,b+3*T,3);d.itree[1+(d.ordr[T]<<1)]=O,O>_&&(_=O)}b+=3*I,l(d.itree,_),u(d.itree,_,d.imap),y=d.lmap,A=d.dmap,b=c(d.imap,(1<<_)-1,v+m,e,b,d.ttree);var w=a._copyOut(d.ttree,0,v,d.ltree);R=(1<<w)-1;var U=a._copyOut(d.ttree,v,m,d.dtree);P=(1<<U)-1,l(d.ltree,w),u(d.ltree,w,y),l(d.dtree,U),u(d.dtree,U,A)}for(;;){var C=y[p(e,b)&R];b+=15&C;var $=C>>>4;if($>>>8==0)r[S++]=$;else{if(256==$)break;var L=S+$-254;if($>264){var M=d.ldef[$-257];L=S+(M>>>3)+s(e,b,7&M),b+=7&M}var x=A[p(e,b)&P];b+=15&x;var B=x>>>4,D=d.ddef[B],G=(D>>>4)+i(e,b,15&D);for(b+=15&D,h&&(r=UZIP.F._check(r,S+(1<<17)));S<L;)r[S]=r[S++-G],r[S]=r[S++-G],r[S]=r[S++-G],r[S]=r[S++-G];S=L}}}else{0!=(7&b)&&(b+=8-(7&b));var V=4+(b>>>3),k=e[V-4]|e[V-3]<<8;h&&(r=UZIP.F._check(r,S+k)),r.set(new t(e.buffer,e.byteOffset+V,k),S),b=V+k<<3,S+=k}return r.length==S?r:r.slice(0,S)},UZIP.F._check=function(e,r){var t=e.length;if(r<=t)return e;var a=new Uint8Array(Math.max(t<<1,r));return a.set(e,0),a},UZIP.F._decodeTiny=function(e,r,t,a,i,s){for(var c=UZIP.F._bitsE,l=UZIP.F._get17,u=0;u<t;){var p=e[l(a,i)&r];i+=15&p;var d=p>>>4;if(d<=15)s[u]=d,u++;else{var h=0,y=0;16==d?(y=3+c(a,i,2),i+=2,h=s[u-1]):17==d?(y=3+c(a,i,3),i+=3):18==d&&(y=11+c(a,i,7),i+=7);for(var A=u+y;u<A;)s[u]=h,u++}}return i},UZIP.F._copyOut=function(e,r,t,a){for(var i=0,s=0,c=a.length>>>1;s<t;){var l=e[s+r];a[s<<1]=0,a[1+(s<<1)]=l,l>i&&(i=l),s++}for(;s<c;)a[s<<1]=0,a[1+(s<<1)]=0,s++;return i},UZIP.F.makeCodes=function(e,r){for(var t,a,i,s,c=UZIP.F.U,l=e.length,u=c.bl_count,p=0;p<=r;p++)u[p]=0;for(p=1;p<l;p+=2)u[e[p]]++;var d=c.next_code;for(t=0,u[0]=0,a=1;a<=r;a++)t=t+u[a-1]<<1,d[a]=t;for(i=0;i<l;i+=2)0!=(s=e[i+1])&&(e[i]=d[s],d[s]++)},UZIP.F.codes2map=function(e,r,t){for(var a=e.length,i=UZIP.F.U.rev15,s=0;s<a;s+=2)if(0!=e[s+1])for(var c=s>>1,l=e[s+1],u=c<<4|l,p=r-l,d=e[s]<<p,h=d+(1<<p);d!=h;){t[i[d]>>>15-r]=u,d++}},UZIP.F.revCodes=function(e,r){for(var t=UZIP.F.U.rev15,a=15-r,i=0;i<e.length;i+=2){var s=e[i]<<r-e[i+1];e[i]=t[s]>>>a}},UZIP.F._putsE=function(e,r,t){t<<=7&r;var a=r>>>3;e[a]|=t,e[a+1]|=t>>>8},UZIP.F._putsF=function(e,r,t){t<<=7&r;var a=r>>>3;e[a]|=t,e[a+1]|=t>>>8,e[a+2]|=t>>>16},UZIP.F._bitsE=function(e,r,t){return(e[r>>>3]|e[1+(r>>>3)]<<8)>>>(7&r)&(1<<t)-1},UZIP.F._bitsF=function(e,r,t){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16)>>>(7&r)&(1<<t)-1},UZIP.F._get17=function(e,r){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16)>>>(7&r)},UZIP.F._get25=function(e,r){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16|e[3+(r>>>3)]<<24)>>>(7&r)},UZIP.F.U=(r=Uint16Array,t=Uint32Array,{next_code:new r(16),bl_count:new r(16),ordr:[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],of0:[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,999,999,999],exb:[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0],ldef:new r(32),df0:[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,65535,65535],dxb:[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0],ddef:new t(32),flmap:new r(512),fltree:[],fdmap:new r(32),fdtree:[],lmap:new r(32768),ltree:[],ttree:[],dmap:new r(32768),dtree:[],imap:new r(512),itree:[],rev15:new r(32768),lhst:new t(286),dhst:new t(30),ihst:new t(19),lits:new t(15e3),strt:new r(65536),prev:new r(32768)}),function(){for(var e=UZIP.F.U,r=0;r<32768;r++){var t=r;t=(4278255360&(t=(4042322160&(t=(3435973836&(t=(2863311530&t)>>>1|(1431655765&t)<<1))>>>2|(858993459&t)<<2))>>>4|(252645135&t)<<4))>>>8|(16711935&t)<<8,e.rev15[r]=(t>>>16|t<<16)>>>17}function pushV(e,r,t){for(;0!=r--;)e.push(0,t)}for(r=0;r<32;r++)e.ldef[r]=e.of0[r]<<3|e.exb[r],e.ddef[r]=e.df0[r]<<4|e.dxb[r];pushV(e.fltree,144,8),pushV(e.fltree,112,9),pushV(e.fltree,24,7),pushV(e.fltree,8,8),UZIP.F.makeCodes(e.fltree,9),UZIP.F.codes2map(e.fltree,9,e.flmap),UZIP.F.revCodes(e.fltree,9),pushV(e.fdtree,32,5),UZIP.F.makeCodes(e.fdtree,5),UZIP.F.codes2map(e.fdtree,5,e.fdmap),UZIP.F.revCodes(e.fdtree,5),pushV(e.itree,19,0),pushV(e.ltree,286,0),pushV(e.dtree,30,0),pushV(e.ttree,320,0)}()})),UZIP=Object.freeze(_mergeNamespaces({__proto__:null,default:UZIP_1},[UZIP_1])),UPNG={},N,W,H;UPNG.toRGBA8=function(e){var r=e.width,t=e.height;if(null==e.tabs.acTL)return[UPNG.toRGBA8.decodeImage(e.data,r,t,e).buffer];var a=[];null==e.frames[0].data&&(e.frames[0].data=e.data);for(var i=r*t*4,s=new Uint8Array(i),c=new Uint8Array(i),l=new Uint8Array(i),u=0;u<e.frames.length;u++){var p=e.frames[u],d=p.rect.x,h=p.rect.y,y=p.rect.width,A=p.rect.height,g=UPNG.toRGBA8.decodeImage(p.data,y,A,e);if(0!=u)for(var E=0;E<i;E++)l[E]=s[E];if(0==p.blend?UPNG._copyTile(g,y,A,s,r,t,d,h,0):1==p.blend&&UPNG._copyTile(g,y,A,s,r,t,d,h,1),a.push(s.buffer.slice(0)),0==p.dispose);else if(1==p.dispose)UPNG._copyTile(c,y,A,s,r,t,d,h,0);else if(2==p.dispose)for(E=0;E<i;E++)s[E]=l[E]}return a},UPNG.toRGBA8.decodeImage=function(e,r,t,a){var i=r*t,s=UPNG.decode._getBPP(a),c=Math.ceil(r*s/8),l=new Uint8Array(4*i),u=new Uint32Array(l.buffer),p=a.ctype,d=a.depth,h=UPNG._bin.readUshort;if(6==p){var y=i<<2;if(8==d)for(var A=0;A<y;A+=4)l[A]=e[A],l[A+1]=e[A+1],l[A+2]=e[A+2],l[A+3]=e[A+3];if(16==d)for(A=0;A<y;A++)l[A]=e[A<<1]}else if(2==p){var g=a.tabs.tRNS;if(null==g){if(8==d)for(A=0;A<i;A++){var E=3*A;u[A]=255<<24|e[E+2]<<16|e[E+1]<<8|e[E]}if(16==d)for(A=0;A<i;A++){E=6*A;u[A]=255<<24|e[E+4]<<16|e[E+2]<<8|e[E]}}else{var v=g[0],m=g[1],I=g[2];if(8==d)for(A=0;A<i;A++){var R=A<<2;E=3*A;u[A]=255<<24|e[E+2]<<16|e[E+1]<<8|e[E],e[E]==v&&e[E+1]==m&&e[E+2]==I&&(l[R+3]=0)}if(16==d)for(A=0;A<i;A++){R=A<<2,E=6*A;u[A]=255<<24|e[E+4]<<16|e[E+2]<<8|e[E],h(e,E)==v&&h(e,E+2)==m&&h(e,E+4)==I&&(l[R+3]=0)}}}else if(3==p){var P=a.tabs.PLTE,S=a.tabs.tRNS,b=S?S.length:0;if(1==d)for(var T=0;T<t;T++){var _=T*c,O=T*r;for(A=0;A<r;A++){R=O+A<<2;var w=3*(U=e[_+(A>>3)]>>7-((7&A)<<0)&1);l[R]=P[w],l[R+1]=P[w+1],l[R+2]=P[w+2],l[R+3]=U<b?S[U]:255}}if(2==d)for(T=0;T<t;T++)for(_=T*c,O=T*r,A=0;A<r;A++){R=O+A<<2,w=3*(U=e[_+(A>>2)]>>6-((3&A)<<1)&3);l[R]=P[w],l[R+1]=P[w+1],l[R+2]=P[w+2],l[R+3]=U<b?S[U]:255}if(4==d)for(T=0;T<t;T++)for(_=T*c,O=T*r,A=0;A<r;A++){R=O+A<<2,w=3*(U=e[_+(A>>1)]>>4-((1&A)<<2)&15);l[R]=P[w],l[R+1]=P[w+1],l[R+2]=P[w+2],l[R+3]=U<b?S[U]:255}if(8==d)for(A=0;A<i;A++){var U;R=A<<2,w=3*(U=e[A]);l[R]=P[w],l[R+1]=P[w+1],l[R+2]=P[w+2],l[R+3]=U<b?S[U]:255}}else if(4==p){if(8==d)for(A=0;A<i;A++){R=A<<2;var C=e[$=A<<1];l[R]=C,l[R+1]=C,l[R+2]=C,l[R+3]=e[$+1]}if(16==d)for(A=0;A<i;A++){var $;R=A<<2,C=e[$=A<<2];l[R]=C,l[R+1]=C,l[R+2]=C,l[R+3]=e[$+2]}}else if(0==p)for(v=a.tabs.tRNS?a.tabs.tRNS:-1,T=0;T<t;T++){var L=T*c,M=T*r;if(1==d)for(var x=0;x<r;x++){var B=(C=255*(e[L+(x>>>3)]>>>7-(7&x)&1))==255*v?0:255;u[M+x]=B<<24|C<<16|C<<8|C}else if(2==d)for(x=0;x<r;x++){B=(C=85*(e[L+(x>>>2)]>>>6-((3&x)<<1)&3))==85*v?0:255;u[M+x]=B<<24|C<<16|C<<8|C}else if(4==d)for(x=0;x<r;x++){B=(C=17*(e[L+(x>>>1)]>>>4-((1&x)<<2)&15))==17*v?0:255;u[M+x]=B<<24|C<<16|C<<8|C}else if(8==d)for(x=0;x<r;x++){B=(C=e[L+x])==v?0:255;u[M+x]=B<<24|C<<16|C<<8|C}else if(16==d)for(x=0;x<r;x++){C=e[L+(x<<1)],B=h(e,L+(x<<A))==v?0:255;u[M+x]=B<<24|C<<16|C<<8|C}}return l},UPNG.decode=function(e){for(var r,t=new Uint8Array(e),a=8,i=UPNG._bin,s=i.readUshort,c=i.readUint,l={tabs:{},frames:[]},u=new Uint8Array(t.length),p=0,d=0,h=[137,80,78,71,13,10,26,10],y=0;y<8;y++)if(t[y]!=h[y])throw"The input is not a PNG file!";for(;a<t.length;){var A=i.readUint(t,a);a+=4;var g=i.readASCII(t,a,4);if(a+=4,"IHDR"==g)UPNG.decode._IHDR(t,a,l);else if("CgBI"==g)l.tabs[g]=t.slice(a,a+4);else if("IDAT"==g){for(y=0;y<A;y++)u[p+y]=t[a+y];p+=A}else if("acTL"==g)l.tabs[g]={num_frames:c(t,a),num_plays:c(t,a+4)},r=new Uint8Array(t.length);else if("fcTL"==g){var E;if(0!=d)(E=l.frames[l.frames.length-1]).data=UPNG.decode._decompress(l,r.slice(0,d),E.rect.width,E.rect.height),d=0;var v={x:c(t,a+12),y:c(t,a+16),width:c(t,a+4),height:c(t,a+8)},m=s(t,a+22);m=s(t,a+20)/(0==m?100:m);var I={rect:v,delay:Math.round(1e3*m),dispose:t[a+24],blend:t[a+25]};l.frames.push(I)}else if("fdAT"==g){for(y=0;y<A-4;y++)r[d+y]=t[a+y+4];d+=A-4}else if("pHYs"==g)l.tabs[g]=[i.readUint(t,a),i.readUint(t,a+4),t[a+8]];else if("cHRM"==g){l.tabs[g]=[];for(y=0;y<8;y++)l.tabs[g].push(i.readUint(t,a+4*y))}else if("tEXt"==g||"zTXt"==g){null==l.tabs[g]&&(l.tabs[g]={});var R=i.nextZero(t,a),P=i.readASCII(t,a,R-a),S=a+A-R-1;if("tEXt"==g)_=i.readASCII(t,R+1,S);else{var b=UPNG.decode._inflate(t.slice(R+2,R+2+S));_=i.readUTF8(b,0,b.length)}l.tabs[g][P]=_}else if("iTXt"==g){null==l.tabs[g]&&(l.tabs[g]={});R=0;var T=a;R=i.nextZero(t,T);P=i.readASCII(t,T,R-T);var _,O=t[T=R+1];t[T+1],T+=2,R=i.nextZero(t,T),i.readASCII(t,T,R-T),T=R+1,R=i.nextZero(t,T),i.readUTF8(t,T,R-T);S=A-((T=R+1)-a);if(0==O)_=i.readUTF8(t,T,S);else{b=UPNG.decode._inflate(t.slice(T,T+S));_=i.readUTF8(b,0,b.length)}l.tabs[g][P]=_}else if("PLTE"==g)l.tabs[g]=i.readBytes(t,a,A);else if("hIST"==g){var w=l.tabs.PLTE.length/3;l.tabs[g]=[];for(y=0;y<w;y++)l.tabs[g].push(s(t,a+2*y))}else if("tRNS"==g)3==l.ctype?l.tabs[g]=i.readBytes(t,a,A):0==l.ctype?l.tabs[g]=s(t,a):2==l.ctype&&(l.tabs[g]=[s(t,a),s(t,a+2),s(t,a+4)]);else if("gAMA"==g)l.tabs[g]=i.readUint(t,a)/1e5;else if("sRGB"==g)l.tabs[g]=t[a];else if("bKGD"==g)0==l.ctype||4==l.ctype?l.tabs[g]=[s(t,a)]:2==l.ctype||6==l.ctype?l.tabs[g]=[s(t,a),s(t,a+2),s(t,a+4)]:3==l.ctype&&(l.tabs[g]=t[a]);else if("IEND"==g)break;a+=A,i.readUint(t,a),a+=4}0!=d&&((E=l.frames[l.frames.length-1]).data=UPNG.decode._decompress(l,r.slice(0,d),E.rect.width,E.rect.height),d=0);return l.data=UPNG.decode._decompress(l,u,l.width,l.height),delete l.compress,delete l.interlace,delete l.filter,l},UPNG.decode._decompress=function(e,r,t,a){var i=UPNG.decode._getBPP(e),s=Math.ceil(t*i/8),c=new Uint8Array((s+1+e.interlace)*a);return r=e.tabs.CgBI?UPNG.inflateRaw(r,c):UPNG.decode._inflate(r,c),0==e.interlace?r=UPNG.decode._filterZero(r,e,0,t,a):1==e.interlace&&(r=UPNG.decode._readInterlace(r,e)),r},UPNG.decode._inflate=function(e,r){return UPNG.inflateRaw(new Uint8Array(e.buffer,2,e.length-6),r)},UPNG.inflateRaw=(H={},H.H={},H.H.N=function(e,r){var t,a,i=Uint8Array,s=0,c=0,l=0,u=0,p=0,d=0,h=0,y=0,A=0;if(3==e[0]&&0==e[1])return r||new i(0);var g=H.H,E=g.b,v=g.e,m=g.R,I=g.n,R=g.A,P=g.Z,S=g.m,b=null==r;for(b&&(r=new i(e.length>>>2<<5));0==s;)if(s=E(e,A,1),c=E(e,A+1,2),A+=3,0!=c){if(b&&(r=H.H.W(r,y+(1<<17))),1==c&&(t=S.J,a=S.h,d=511,h=31),2==c){l=v(e,A,5)+257,u=v(e,A+5,5)+1,p=v(e,A+10,4)+4,A+=14;for(var T=1,_=0;_<38;_+=2)S.Q[_]=0,S.Q[_+1]=0;for(_=0;_<p;_++){var O=v(e,A+3*_,3);S.Q[1+(S.X[_]<<1)]=O,O>T&&(T=O)}A+=3*p,I(S.Q,T),R(S.Q,T,S.u),t=S.w,a=S.d,A=m(S.u,(1<<T)-1,l+u,e,A,S.v);var w=g.V(S.v,0,l,S.C);d=(1<<w)-1;var U=g.V(S.v,l,u,S.D);h=(1<<U)-1,I(S.C,w),R(S.C,w,t),I(S.D,U),R(S.D,U,a)}for(;;){var C=t[P(e,A)&d];A+=15&C;var $=C>>>4;if($>>>8==0)r[y++]=$;else{if(256==$)break;var L=y+$-254;if($>264){var M=S.q[$-257];L=y+(M>>>3)+v(e,A,7&M),A+=7&M}var x=a[P(e,A)&h];A+=15&x;var B=x>>>4,D=S.c[B],G=(D>>>4)+E(e,A,15&D);for(A+=15&D;y<L;)r[y]=r[y++-G],r[y]=r[y++-G],r[y]=r[y++-G],r[y]=r[y++-G];y=L}}}else{0!=(7&A)&&(A+=8-(7&A));var V=4+(A>>>3),k=e[V-4]|e[V-3]<<8;b&&(r=H.H.W(r,y+k)),r.set(new i(e.buffer,e.byteOffset+V,k),y),A=V+k<<3,y+=k}return r.length==y?r:r.slice(0,y)},H.H.W=function(e,r){var t=e.length;if(r<=t)return e;var a=new Uint8Array(t<<1);return a.set(e,0),a},H.H.R=function(e,r,t,a,i,s){for(var c=H.H.e,l=H.H.Z,u=0;u<t;){var p=e[l(a,i)&r];i+=15&p;var d=p>>>4;if(d<=15)s[u]=d,u++;else{var h=0,y=0;16==d?(y=3+c(a,i,2),i+=2,h=s[u-1]):17==d?(y=3+c(a,i,3),i+=3):18==d&&(y=11+c(a,i,7),i+=7);for(var A=u+y;u<A;)s[u]=h,u++}}return i},H.H.V=function(e,r,t,a){for(var i=0,s=0,c=a.length>>>1;s<t;){var l=e[s+r];a[s<<1]=0,a[1+(s<<1)]=l,l>i&&(i=l),s++}for(;s<c;)a[s<<1]=0,a[1+(s<<1)]=0,s++;return i},H.H.n=function(e,r){for(var t,a,i,s,c=H.H.m,l=e.length,u=c.j,p=0;p<=r;p++)u[p]=0;for(p=1;p<l;p+=2)u[e[p]]++;var d=c.K;for(t=0,u[0]=0,a=1;a<=r;a++)t=t+u[a-1]<<1,d[a]=t;for(i=0;i<l;i+=2)0!=(s=e[i+1])&&(e[i]=d[s],d[s]++)},H.H.A=function(e,r,t){for(var a=e.length,i=H.H.m.r,s=0;s<a;s+=2)if(0!=e[s+1])for(var c=s>>1,l=e[s+1],u=c<<4|l,p=r-l,d=e[s]<<p,h=d+(1<<p);d!=h;)t[i[d]>>>15-r]=u,d++},H.H.l=function(e,r){for(var t=H.H.m.r,a=15-r,i=0;i<e.length;i+=2){var s=e[i]<<r-e[i+1];e[i]=t[s]>>>a}},H.H.M=function(e,r,t){t<<=7&r;var a=r>>>3;e[a]|=t,e[a+1]|=t>>>8},H.H.I=function(e,r,t){t<<=7&r;var a=r>>>3;e[a]|=t,e[a+1]|=t>>>8,e[a+2]|=t>>>16},H.H.e=function(e,r,t){return(e[r>>>3]|e[1+(r>>>3)]<<8)>>>(7&r)&(1<<t)-1},H.H.b=function(e,r,t){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16)>>>(7&r)&(1<<t)-1},H.H.Z=function(e,r){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16)>>>(7&r)},H.H.i=function(e,r){return(e[r>>>3]|e[1+(r>>>3)]<<8|e[2+(r>>>3)]<<16|e[3+(r>>>3)]<<24)>>>(7&r)},H.H.m=(N=Uint16Array,W=Uint32Array,{K:new N(16),j:new N(16),X:[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],S:[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,999,999,999],T:[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0],q:new N(32),p:[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,65535,65535],z:[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0],c:new W(32),J:new N(512),_:[],h:new N(32),$:[],w:new N(32768),C:[],v:[],d:new N(32768),D:[],u:new N(512),Q:[],r:new N(32768),s:new W(286),Y:new W(30),a:new W(19),t:new W(15e3),k:new N(65536),g:new N(32768)}),function(){for(var e=H.H.m,r=0;r<32768;r++){var t=r;t=(4278255360&(t=(4042322160&(t=(3435973836&(t=(2863311530&t)>>>1|(1431655765&t)<<1))>>>2|(858993459&t)<<2))>>>4|(252645135&t)<<4))>>>8|(16711935&t)<<8,e.r[r]=(t>>>16|t<<16)>>>17}function n(e,r,t){for(;0!=r--;)e.push(0,t)}for(r=0;r<32;r++)e.q[r]=e.S[r]<<3|e.T[r],e.c[r]=e.p[r]<<4|e.z[r];n(e._,144,8),n(e._,112,9),n(e._,24,7),n(e._,8,8),H.H.n(e._,9),H.H.A(e._,9,e.J),H.H.l(e._,9),n(e.$,32,5),H.H.n(e.$,5),H.H.A(e.$,5,e.h),H.H.l(e.$,5),n(e.Q,19,0),n(e.C,286,0),n(e.D,30,0),n(e.v,320,0)}(),H.H.N),UPNG.decode._readInterlace=function(e,r){for(var t=r.width,a=r.height,i=UPNG.decode._getBPP(r),s=i>>3,c=Math.ceil(t*i/8),l=new Uint8Array(a*c),u=0,p=[0,0,4,0,2,0,1],d=[0,4,0,2,0,1,0],h=[8,8,8,4,4,2,2],y=[8,8,4,4,2,2,1],A=0;A<7;){for(var g=h[A],E=y[A],v=0,m=0,I=p[A];I<a;)I+=g,m++;for(var R=d[A];R<t;)R+=E,v++;var P=Math.ceil(v*i/8);UPNG.decode._filterZero(e,r,u,v,m);for(var S=0,b=p[A];b<a;){for(var T=d[A],_=u+S*P<<3;T<t;){var O;if(1==i)O=(O=e[_>>3])>>7-(7&_)&1,l[b*c+(T>>3)]|=O<<7-((7&T)<<0);if(2==i)O=(O=e[_>>3])>>6-(7&_)&3,l[b*c+(T>>2)]|=O<<6-((3&T)<<1);if(4==i)O=(O=e[_>>3])>>4-(7&_)&15,l[b*c+(T>>1)]|=O<<4-((1&T)<<2);if(i>=8)for(var w=b*c+T*s,U=0;U<s;U++)l[w+U]=e[(_>>3)+U];_+=i,T+=E}S++,b+=g}v*m!=0&&(u+=m*(1+P)),A+=1}return l},UPNG.decode._getBPP=function(e){return[1,null,3,1,2,null,4][e.ctype]*e.depth},UPNG.decode._filterZero=function(e,r,t,a,i){var s=UPNG.decode._getBPP(r),c=Math.ceil(a*s/8),l=UPNG.decode._paeth;s=Math.ceil(s/8);var u=0,p=1,d=e[t],h=0;if(d>1&&(e[t]=[0,0,1][d-2]),3==d)for(h=s;h<c;h++)e[h+1]=e[h+1]+(e[h+1-s]>>>1)&255;for(var y=0;y<i;y++)if(h=0,0==(d=e[(p=(u=t+y*c)+y+1)-1]))for(;h<c;h++)e[u+h]=e[p+h];else if(1==d){for(;h<s;h++)e[u+h]=e[p+h];for(;h<c;h++)e[u+h]=e[p+h]+e[u+h-s]}else if(2==d)for(;h<c;h++)e[u+h]=e[p+h]+e[u+h-c];else if(3==d){for(;h<s;h++)e[u+h]=e[p+h]+(e[u+h-c]>>>1);for(;h<c;h++)e[u+h]=e[p+h]+(e[u+h-c]+e[u+h-s]>>>1)}else{for(;h<s;h++)e[u+h]=e[p+h]+l(0,e[u+h-c],0);for(;h<c;h++)e[u+h]=e[p+h]+l(e[u+h-s],e[u+h-c],e[u+h-s-c])}return e},UPNG.decode._paeth=function(e,r,t){var a=e+r-t,i=a-e,s=a-r,c=a-t;return i*i<=s*s&&i*i<=c*c?e:s*s<=c*c?r:t},UPNG.decode._IHDR=function(e,r,t){var a=UPNG._bin;t.width=a.readUint(e,r),r+=4,t.height=a.readUint(e,r),r+=4,t.depth=e[r],r++,t.ctype=e[r],r++,t.compress=e[r],r++,t.filter=e[r],r++,t.interlace=e[r],r++},UPNG._bin={nextZero:function nextZero(e,r){for(;0!=e[r];)r++;return r},readUshort:function readUshort(e,r){return e[r]<<8|e[r+1]},writeUshort:function writeUshort(e,r,t){e[r]=t>>8&255,e[r+1]=255&t},readUint:function readUint(e,r){return 16777216*e[r]+(e[r+1]<<16|e[r+2]<<8|e[r+3])},writeUint:function writeUint(e,r,t){e[r]=t>>24&255,e[r+1]=t>>16&255,e[r+2]=t>>8&255,e[r+3]=255&t},readASCII:function readASCII(e,r,t){for(var a="",i=0;i<t;i++)a+=String.fromCharCode(e[r+i]);return a},writeASCII:function writeASCII(e,r,t){for(var a=0;a<t.length;a++)e[r+a]=t.charCodeAt(a)},readBytes:function readBytes(e,r,t){for(var a=[],i=0;i<t;i++)a.push(e[r+i]);return a},pad:function pad(e){return e.length<2?"0".concat(e):e},readUTF8:function readUTF8(e,r,t){for(var a,i="",s=0;s<t;s++)i+="%".concat(UPNG._bin.pad(e[r+s].toString(16)));try{a=decodeURIComponent(i)}catch(a){return UPNG._bin.readASCII(e,r,t)}return a}},UPNG._copyTile=function(e,r,t,a,i,s,c,l,u){for(var p=Math.min(r,i),d=Math.min(t,s),h=0,y=0,A=0;A<d;A++)for(var g=0;g<p;g++)if(c>=0&&l>=0?(h=A*r+g<<2,y=(l+A)*i+c+g<<2):(h=(-l+A)*r-c+g<<2,y=A*i+g<<2),0==u)a[y]=e[h],a[y+1]=e[h+1],a[y+2]=e[h+2],a[y+3]=e[h+3];else if(1==u){var E=e[h+3]*(1/255),v=e[h]*E,m=e[h+1]*E,I=e[h+2]*E,R=a[y+3]*(1/255),P=a[y]*R,S=a[y+1]*R,b=a[y+2]*R,T=1-E,_=E+R*T,O=0==_?0:1/_;a[y+3]=255*_,a[y+0]=(v+P*T)*O,a[y+1]=(m+S*T)*O,a[y+2]=(I+b*T)*O}else if(2==u){E=e[h+3],v=e[h],m=e[h+1],I=e[h+2],R=a[y+3],P=a[y],S=a[y+1],b=a[y+2];E==R&&v==P&&m==S&&I==b?(a[y]=0,a[y+1]=0,a[y+2]=0,a[y+3]=0):(a[y]=v,a[y+1]=m,a[y+2]=I,a[y+3]=E)}else if(3==u){E=e[h+3],v=e[h],m=e[h+1],I=e[h+2],R=a[y+3],P=a[y],S=a[y+1],b=a[y+2];if(E==R&&v==P&&m==S&&I==b)continue;if(E<220&&R>20)return!1}return!0},UPNG.encode=function(e,r,t,a,i,s,c){null==a&&(a=0),null==c&&(c=!1);var l=UPNG.encode.compress(e,r,t,a,[!1,!1,!1,0,c]);return UPNG.encode.compressPNG(l,-1),UPNG.encode._main(l,r,t,i,s)},UPNG.encodeLL=function(e,r,t,a,i,s,c,l){for(var u={ctype:0+(1==a?0:2)+(0==i?0:4),depth:s,frames:[]},p=(a+i)*s,d=p*r,h=0;h<e.length;h++)u.frames.push({rect:{x:0,y:0,width:r,height:t},img:new Uint8Array(e[h]),blend:0,dispose:1,bpp:Math.ceil(p/8),bpl:Math.ceil(d/8)});return UPNG.encode.compressPNG(u,0,!0),UPNG.encode._main(u,r,t,c,l)},UPNG.encode._main=function(e,r,t,a,i){null==i&&(i={});var s=UPNG.crc.crc,c=UPNG._bin.writeUint,l=UPNG._bin.writeUshort,u=UPNG._bin.writeASCII,p=8,d=e.frames.length>1,h=!1,y=33+(d?20:0);if(null!=i.sRGB&&(y+=13),null!=i.pHYs&&(y+=21),3==e.ctype){for(var A=e.plte.length,g=0;g<A;g++)e.plte[g]>>>24!=255&&(h=!0);y+=8+3*A+4+(h?8+1*A+4:0)}for(var E=0;E<e.frames.length;E++){d&&(y+=38),y+=(_=e.frames[E]).cimg.length+12,0!=E&&(y+=4)}y+=12;var v=new Uint8Array(y),m=[137,80,78,71,13,10,26,10];for(g=0;g<8;g++)v[g]=m[g];if(c(v,p,13),u(v,p+=4,"IHDR"),c(v,p+=4,r),c(v,p+=4,t),v[p+=4]=e.depth,v[++p]=e.ctype,v[++p]=0,v[++p]=0,v[++p]=0,c(v,++p,s(v,p-17,17)),p+=4,null!=i.sRGB&&(c(v,p,1),u(v,p+=4,"sRGB"),v[p+=4]=i.sRGB,c(v,++p,s(v,p-5,5)),p+=4),null!=i.pHYs&&(c(v,p,9),u(v,p+=4,"pHYs"),c(v,p+=4,i.pHYs[0]),c(v,p+=4,i.pHYs[1]),v[p+=4]=i.pHYs[2],c(v,++p,s(v,p-13,13)),p+=4),d&&(c(v,p,8),u(v,p+=4,"acTL"),c(v,p+=4,e.frames.length),c(v,p+=4,null!=i.loop?i.loop:0),c(v,p+=4,s(v,p-12,12)),p+=4),3==e.ctype){c(v,p,3*(A=e.plte.length)),u(v,p+=4,"PLTE"),p+=4;for(g=0;g<A;g++){var I=3*g,R=e.plte[g],P=255&R,S=R>>>8&255,b=R>>>16&255;v[p+I+0]=P,v[p+I+1]=S,v[p+I+2]=b}if(c(v,p+=3*A,s(v,p-3*A-4,3*A+4)),p+=4,h){c(v,p,A),u(v,p+=4,"tRNS"),p+=4;for(g=0;g<A;g++)v[p+g]=e.plte[g]>>>24&255;c(v,p+=A,s(v,p-A-4,A+4)),p+=4}}var T=0;for(E=0;E<e.frames.length;E++){var _=e.frames[E];d&&(c(v,p,26),u(v,p+=4,"fcTL"),c(v,p+=4,T++),c(v,p+=4,_.rect.width),c(v,p+=4,_.rect.height),c(v,p+=4,_.rect.x),c(v,p+=4,_.rect.y),l(v,p+=4,a[E]),l(v,p+=2,1e3),v[p+=2]=_.dispose,v[++p]=_.blend,c(v,++p,s(v,p-30,30)),p+=4);var O=_.cimg;c(v,p,(A=O.length)+(0==E?0:4));var w=p+=4;u(v,p,0==E?"IDAT":"fdAT"),p+=4,0!=E&&(c(v,p,T++),p+=4),v.set(O,p),c(v,p+=A,s(v,w,p-w)),p+=4}return c(v,p,0),u(v,p+=4,"IEND"),c(v,p+=4,s(v,p-4,4)),p+=4,v.buffer},UPNG.encode.compressPNG=function(e,r,t){for(var a=0;a<e.frames.length;a++){var i=e.frames[a];i.rect.width;var s=i.rect.height,c=new Uint8Array(s*i.bpl+s);i.cimg=UPNG.encode._filterZero(i.img,s,i.bpp,i.bpl,c,r,t)}},UPNG.encode.compress=function(e,r,t,a,i){for(var s=i[0],c=i[1],l=i[2],u=i[3],p=i[4],d=6,h=8,y=255,A=0;A<e.length;A++)for(var g=new Uint8Array(e[A]),E=g.length,v=0;v<E;v+=4)y&=g[v+3];var m=255!=y,I=UPNG.encode.framize(e,r,t,s,c,l),R={},P=[],S=[];if(0!=a){var b=[];for(v=0;v<I.length;v++)b.push(I[v].img.buffer);var T=UPNG.encode.concatRGBA(b),_=UPNG.quantize(T,a),O=0,w=new Uint8Array(_.abuf);for(v=0;v<I.length;v++){var U=(J=I[v].img).length;S.push(new Uint8Array(_.inds.buffer,O>>2,U>>2));for(A=0;A<U;A+=4)J[A]=w[O+A],J[A+1]=w[O+A+1],J[A+2]=w[O+A+2],J[A+3]=w[O+A+3];O+=U}for(v=0;v<_.plte.length;v++)P.push(_.plte[v].est.rgba)}else for(A=0;A<I.length;A++){var C=I[A],$=new Uint32Array(C.img.buffer),L=C.rect.width,M=(E=$.length,new Uint8Array(E));S.push(M);for(v=0;v<E;v++){var x=$[v];if(0!=v&&x==$[v-1])M[v]=M[v-1];else if(v>L&&x==$[v-L])M[v]=M[v-L];else{var B=R[x];if(null==B&&(R[x]=B=P.length,P.push(x),P.length>=300))break;M[v]=B}}}var D=P.length;D<=256&&0==p&&(h=D<=2?1:D<=4?2:D<=16?4:8,h=Math.max(h,u));for(A=0;A<I.length;A++){(C=I[A]).rect.x,C.rect.y;L=C.rect.width;var G=C.rect.height,V=C.img;new Uint32Array(V.buffer);var k=4*L,Y=4;if(D<=256&&0==p){k=Math.ceil(h*L/8);for(var Z=new Uint8Array(k*G),q=S[A],Q=0;Q<G;Q++){v=Q*k;var K=Q*L;if(8==h)for(var z=0;z<L;z++)Z[v+z]=q[K+z];else if(4==h)for(z=0;z<L;z++)Z[v+(z>>1)]|=q[K+z]<<4-4*(1&z);else if(2==h)for(z=0;z<L;z++)Z[v+(z>>2)]|=q[K+z]<<6-2*(3&z);else if(1==h)for(z=0;z<L;z++)Z[v+(z>>3)]|=q[K+z]<<7-1*(7&z)}V=Z,d=3,Y=1}else if(0==m&&1==I.length){Z=new Uint8Array(L*G*3);var X=L*G;for(v=0;v<X;v++){var J,ee=4*v;Z[J=3*v]=V[ee],Z[J+1]=V[ee+1],Z[J+2]=V[ee+2]}V=Z,d=2,Y=3,k=3*L}C.img=V,C.bpl=k,C.bpp=Y}return{ctype:d,depth:h,plte:P,frames:I}},UPNG.encode.framize=function(e,r,t,a,i,s){for(var c=[],l=0;l<e.length;l++){var u,p=new Uint8Array(e[l]),d=new Uint32Array(p.buffer),h=0,y=0,A=r,g=t,E=a?1:0;if(0!=l){for(var v=s||a||1==l||0!=c[l-2].dispose?1:2,m=0,I=1e9,R=0;R<v;R++){for(var P=new Uint8Array(e[l-1-R]),S=new Uint32Array(e[l-1-R]),b=r,T=t,_=-1,O=-1,w=0;w<t;w++)for(var U=0;U<r;U++){d[D=w*r+U]!=S[D]&&(U<b&&(b=U),U>_&&(_=U),w<T&&(T=w),w>O&&(O=w))}-1==_&&(b=T=_=O=0),i&&(1==(1&b)&&b--,1==(1&T)&&T--);var C=(_-b+1)*(O-T+1);C<I&&(I=C,m=R,h=b,y=T,A=_-b+1,g=O-T+1)}P=new Uint8Array(e[l-1-m]);1==m&&(c[l-1].dispose=2),u=new Uint8Array(A*g*4),UPNG._copyTile(P,r,t,u,A,g,-h,-y,0),1==(E=UPNG._copyTile(p,r,t,u,A,g,-h,-y,3)?1:0)?UPNG.encode._prepareDiff(p,r,t,u,{x:h,y:y,width:A,height:g}):UPNG._copyTile(p,r,t,u,A,g,-h,-y,0)}else u=p.slice(0);c.push({rect:{x:h,y:y,width:A,height:g},img:u,blend:E,dispose:0})}if(a)for(l=0;l<c.length;l++){if(1!=(G=c[l]).blend){var $=G.rect,L=c[l-1].rect,M=Math.min($.x,L.x),x=Math.min($.y,L.y),B={x:M,y:x,width:Math.max($.x+$.width,L.x+L.width)-M,height:Math.max($.y+$.height,L.y+L.height)-x};c[l-1].dispose=1,l-1!=0&&UPNG.encode._updateFrame(e,r,t,c,l-1,B,i),UPNG.encode._updateFrame(e,r,t,c,l,B,i)}}if(1!=e.length)for(var D=0;D<c.length;D++){var G;(G=c[D]).rect.width*G.rect.height}return c},UPNG.encode._updateFrame=function(e,r,t,a,i,s,c){for(var l=Uint8Array,u=Uint32Array,p=new l(e[i-1]),d=new u(e[i-1]),h=i+1<e.length?new l(e[i+1]):null,y=new l(e[i]),A=new u(y.buffer),g=r,E=t,v=-1,m=-1,I=0;I<s.height;I++)for(var R=0;R<s.width;R++){var P=s.x+R,S=s.y+I,b=S*r+P,T=A[b];0==T||0==a[i-1].dispose&&d[b]==T&&(null==h||0!=h[4*b+3])||(P<g&&(g=P),P>v&&(v=P),S<E&&(E=S),S>m&&(m=S))}-1==v&&(g=E=v=m=0),c&&(1==(1&g)&&g--,1==(1&E)&&E--),s={x:g,y:E,width:v-g+1,height:m-E+1};var _=a[i];_.rect=s,_.blend=1,_.img=new Uint8Array(s.width*s.height*4),0==a[i-1].dispose?(UPNG._copyTile(p,r,t,_.img,s.width,s.height,-s.x,-s.y,0),UPNG.encode._prepareDiff(y,r,t,_.img,s)):UPNG._copyTile(y,r,t,_.img,s.width,s.height,-s.x,-s.y,0)},UPNG.encode._prepareDiff=function(e,r,t,a,i){UPNG._copyTile(e,r,t,a,i.width,i.height,-i.x,-i.y,2)},UPNG.encode._filterZero=function(e,r,t,a,i,s,c){var l,u=[],p=[0,1,2,3,4];-1!=s?p=[s]:(r*a>5e5||1==t)&&(p=[0]),c&&(l={level:0});for(var d,h=UZIP,y=0;y<p.length;y++){for(var A=0;A<r;A++)UPNG.encode._filterLine(i,e,A,a,t,p[y]);u.push(h.deflate(i,l))}var g=1e9;for(y=0;y<u.length;y++)u[y].length<g&&(d=y,g=u[y].length);return u[d]},UPNG.encode._filterLine=function(e,r,t,a,i,s){var c=t*a,l=c+t,u=UPNG.decode._paeth;if(e[l]=s,l++,0==s)if(a<500)for(var p=0;p<a;p++)e[l+p]=r[c+p];else e.set(new Uint8Array(r.buffer,c,a),l);else if(1==s){for(p=0;p<i;p++)e[l+p]=r[c+p];for(p=i;p<a;p++)e[l+p]=r[c+p]-r[c+p-i]+256&255}else if(0==t){for(p=0;p<i;p++)e[l+p]=r[c+p];if(2==s)for(p=i;p<a;p++)e[l+p]=r[c+p];if(3==s)for(p=i;p<a;p++)e[l+p]=r[c+p]-(r[c+p-i]>>1)+256&255;if(4==s)for(p=i;p<a;p++)e[l+p]=r[c+p]-u(r[c+p-i],0,0)+256&255}else{if(2==s)for(p=0;p<a;p++)e[l+p]=r[c+p]+256-r[c+p-a]&255;if(3==s){for(p=0;p<i;p++)e[l+p]=r[c+p]+256-(r[c+p-a]>>1)&255;for(p=i;p<a;p++)e[l+p]=r[c+p]+256-(r[c+p-a]+r[c+p-i]>>1)&255}if(4==s){for(p=0;p<i;p++)e[l+p]=r[c+p]+256-u(0,r[c+p-a],0)&255;for(p=i;p<a;p++)e[l+p]=r[c+p]+256-u(r[c+p-i],r[c+p-a],r[c+p-i-a])&255}}},UPNG.crc={table:function(){for(var e=new Uint32Array(256),r=0;r<256;r++){for(var t=r,a=0;a<8;a++)1&t?t=3988292384^t>>>1:t>>>=1;e[r]=t}return e}(),update:function update(e,r,t,a){for(var i=0;i<a;i++)e=UPNG.crc.table[255&(e^r[t+i])]^e>>>8;return e},crc:function crc(e,r,t){return 4294967295^UPNG.crc.update(4294967295,e,r,t)}},UPNG.quantize=function(e,r){var t,a=new Uint8Array(e),i=a.slice(0),s=new Uint32Array(i.buffer),c=UPNG.quantize.getKDtree(i,r),l=c[0],u=c[1],p=UPNG.quantize.planeDst,d=a,h=s,y=d.length,A=new Uint8Array(a.length>>2);if(a.length<2e7)for(var g=0;g<y;g+=4){var E=d[g]*(1/255),v=d[g+1]*(1/255),m=d[g+2]*(1/255),I=d[g+3]*(1/255);t=UPNG.quantize.getNearest(l,E,v,m,I),A[g>>2]=t.ind,h[g>>2]=t.est.rgba}else for(g=0;g<y;g+=4){E=d[g]*(1/255),v=d[g+1]*(1/255),m=d[g+2]*(1/255),I=d[g+3]*(1/255);for(t=l;t.left;)t=p(t.est,E,v,m,I)<=0?t.left:t.right;A[g>>2]=t.ind,h[g>>2]=t.est.rgba}return{abuf:i.buffer,inds:A,plte:u}},UPNG.quantize.getKDtree=function(e,r,t){null==t&&(t=1e-4);var a=new Uint32Array(e.buffer),i={i0:0,i1:e.length,bst:null,est:null,tdst:0,left:null,right:null};i.bst=UPNG.quantize.stats(e,i.i0,i.i1),i.est=UPNG.quantize.estats(i.bst);for(var s=[i];s.length<r;){for(var c=0,l=0,u=0;u<s.length;u++)s[u].est.L>c&&(c=s[u].est.L,l=u);if(c<t)break;var p=s[l],d=UPNG.quantize.splitPixels(e,a,p.i0,p.i1,p.est.e,p.est.eMq255);if(p.i0>=d||p.i1<=d)p.est.L=0;else{var h={i0:p.i0,i1:d,bst:null,est:null,tdst:0,left:null,right:null};h.bst=UPNG.quantize.stats(e,h.i0,h.i1),h.est=UPNG.quantize.estats(h.bst);var y={i0:d,i1:p.i1,bst:null,est:null,tdst:0,left:null,right:null};y.bst={R:[],m:[],N:p.bst.N-h.bst.N};for(u=0;u<16;u++)y.bst.R[u]=p.bst.R[u]-h.bst.R[u];for(u=0;u<4;u++)y.bst.m[u]=p.bst.m[u]-h.bst.m[u];y.est=UPNG.quantize.estats(y.bst),p.left=h,p.right=y,s[l]=h,s.push(y)}}s.sort((function(e,r){return r.bst.N-e.bst.N}));for(u=0;u<s.length;u++)s[u].ind=u;return[i,s]},UPNG.quantize.getNearest=function(e,r,t,a,i){if(null==e.left)return e.tdst=UPNG.quantize.dist(e.est.q,r,t,a,i),e;var s=UPNG.quantize.planeDst(e.est,r,t,a,i),c=e.left,l=e.right;s>0&&(c=e.right,l=e.left);var u=UPNG.quantize.getNearest(c,r,t,a,i);if(u.tdst<=s*s)return u;var p=UPNG.quantize.getNearest(l,r,t,a,i);return p.tdst<u.tdst?p:u},UPNG.quantize.planeDst=function(e,r,t,a,i){var s=e.e;return s[0]*r+s[1]*t+s[2]*a+s[3]*i-e.eMq},UPNG.quantize.dist=function(e,r,t,a,i){var s=r-e[0],c=t-e[1],l=a-e[2],u=i-e[3];return s*s+c*c+l*l+u*u},UPNG.quantize.splitPixels=function(e,r,t,a,i,s){var c=UPNG.quantize.vecDot;for(a-=4;t<a;){for(;c(e,t,i)<=s;)t+=4;for(;c(e,a,i)>s;)a-=4;if(t>=a)break;var l=r[t>>2];r[t>>2]=r[a>>2],r[a>>2]=l,t+=4,a-=4}for(;c(e,t,i)>s;)t-=4;return t+4},UPNG.quantize.vecDot=function(e,r,t){return e[r]*t[0]+e[r+1]*t[1]+e[r+2]*t[2]+e[r+3]*t[3]},UPNG.quantize.stats=function(e,r,t){for(var a=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],i=[0,0,0,0],s=t-r>>2,c=r;c<t;c+=4){var l=e[c]*(1/255),u=e[c+1]*(1/255),p=e[c+2]*(1/255),d=e[c+3]*(1/255);i[0]+=l,i[1]+=u,i[2]+=p,i[3]+=d,a[0]+=l*l,a[1]+=l*u,a[2]+=l*p,a[3]+=l*d,a[5]+=u*u,a[6]+=u*p,a[7]+=u*d,a[10]+=p*p,a[11]+=p*d,a[15]+=d*d}return a[4]=a[1],a[8]=a[2],a[9]=a[6],a[12]=a[3],a[13]=a[7],a[14]=a[11],{R:a,m:i,N:s}},UPNG.quantize.estats=function(e){var r=e.R,t=e.m,a=e.N,i=t[0],s=t[1],c=t[2],l=t[3],u=0==a?0:1/a,p=[r[0]-i*i*u,r[1]-i*s*u,r[2]-i*c*u,r[3]-i*l*u,r[4]-s*i*u,r[5]-s*s*u,r[6]-s*c*u,r[7]-s*l*u,r[8]-c*i*u,r[9]-c*s*u,r[10]-c*c*u,r[11]-c*l*u,r[12]-l*i*u,r[13]-l*s*u,r[14]-l*c*u,r[15]-l*l*u],d=p,h=UPNG.M4,y=[Math.random(),Math.random(),Math.random(),Math.random()],A=0,g=0;if(0!=a)for(var E=0;E<16&&(y=h.multVec(d,y),g=Math.sqrt(h.dot(y,y)),y=h.sml(1/g,y),!(0!=E&&Math.abs(g-A)<1e-9));E++)A=g;var v=[i*u,s*u,c*u,l*u];return{Cov:p,q:v,e:y,L:A,eMq255:h.dot(h.sml(255,v),y),eMq:h.dot(y,v),rgba:(Math.round(255*v[3])<<24|Math.round(255*v[2])<<16|Math.round(255*v[1])<<8|Math.round(255*v[0])<<0)>>>0}},UPNG.M4={multVec:function multVec(e,r){return[e[0]*r[0]+e[1]*r[1]+e[2]*r[2]+e[3]*r[3],e[4]*r[0]+e[5]*r[1]+e[6]*r[2]+e[7]*r[3],e[8]*r[0]+e[9]*r[1]+e[10]*r[2]+e[11]*r[3],e[12]*r[0]+e[13]*r[1]+e[14]*r[2]+e[15]*r[3]]},dot:function dot(e,r){return e[0]*r[0]+e[1]*r[1]+e[2]*r[2]+e[3]*r[3]},sml:function sml(e,r){return[e*r[0],e*r[1],e*r[2],e*r[3]]}},UPNG.encode.concatRGBA=function(e){for(var r=0,t=0;t<e.length;t++)r+=e[t].byteLength;var a=new Uint8Array(r),i=0;for(t=0;t<e.length;t++){for(var s=new Uint8Array(e[t]),c=s.length,l=0;l<c;l+=4){var u=s[l],p=s[l+1],d=s[l+2],h=s[l+3];0==h&&(u=p=d=0),a[i+l]=u,a[i+l+1]=p,a[i+l+2]=d,a[i+l+3]=h}i+=c}return a.buffer};var BROWSER_NAME={CHROME:"CHROME",FIREFOX:"FIREFOX",DESKTOP_SAFARI:"DESKTOP_SAFARI",IE:"IE",MOBILE_SAFARI:"MOBILE_SAFARI",ETC:"ETC"},_BROWSER_NAME$CHROME$,MAX_CANVAS_SIZE=(_BROWSER_NAME$CHROME$={},_defineProperty(_BROWSER_NAME$CHROME$,BROWSER_NAME.CHROME,16384),_defineProperty(_BROWSER_NAME$CHROME$,BROWSER_NAME.FIREFOX,11180),_defineProperty(_BROWSER_NAME$CHROME$,BROWSER_NAME.DESKTOP_SAFARI,16384),_defineProperty(_BROWSER_NAME$CHROME$,BROWSER_NAME.IE,8192),_defineProperty(_BROWSER_NAME$CHROME$,BROWSER_NAME.MOBILE_SAFARI,4096),_defineProperty(_BROWSER_NAME$CHROME$,BROWSER_NAME.ETC,8192),_BROWSER_NAME$CHROME$),isBrowser="undefined"!=typeof window,moduleMapper=isBrowser&&window.cordova&&window.cordova.require&&window.cordova.require("cordova/modulemapper"),CustomFile=isBrowser&&(moduleMapper&&moduleMapper.getOriginalSymbol(window,"File")||void 0!==window.File&&File),CustomFileReader=isBrowser&&(moduleMapper&&moduleMapper.getOriginalSymbol(window,"FileReader")||void 0!==window.FileReader&&FileReader);function getFilefromDataUrl(e,r){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Date.now();return new Promise((function(a){for(var i=e.split(","),s=i[0].match(/:(.*?);/)[1],c=globalThis.atob(i[1]),l=c.length,u=new Uint8Array(l);l--;)u[l]=c.charCodeAt(l);var p=new Blob([u],{type:s});p.name=r,p.lastModified=t,a(p)}))}function getDataUrlFromFile(e){return new Promise((function(r,t){var a=new CustomFileReader;a.onload=function(){return r(a.result)},a.onerror=function(e){return t(e)},a.readAsDataURL(e)}))}function loadImage(e){return new Promise((function(r,t){var a=new Image;a.onload=function(){return r(a)},a.onerror=function(e){return t(e)},a.src=e}))}function getBrowserName(){if(void 0!==getBrowserName.cachedResult)return getBrowserName.cachedResult;var e=BROWSER_NAME.ETC,r=navigator.userAgent;return/Chrom(e|ium)/i.test(r)?e=BROWSER_NAME.CHROME:/iP(ad|od|hone)/i.test(r)&&/WebKit/i.test(r)&&!/(CriOS|FxiOS|OPiOS|mercury)/i.test(r)?e=BROWSER_NAME.MOBILE_SAFARI:/Safari/i.test(r)?e=BROWSER_NAME.DESKTOP_SAFARI:/Firefox/i.test(r)?e=BROWSER_NAME.FIREFOX:(/MSIE/i.test(r)||!0==!!document.documentMode)&&(e=BROWSER_NAME.IE),getBrowserName.cachedResult=e,getBrowserName.cachedResult}function approximateBelowMaximumCanvasSizeOfBrowser(e,r){for(var t=getBrowserName(),a=MAX_CANVAS_SIZE[t],i=e,s=r,c=i*s,l=i>s?s/i:i/s;c>a*a;){var u=(a+i)/2,p=(a+s)/2;u<p?(s=p,i=p*l):(s=u*l,i=u),c=i*s}return{width:i,height:s}}function getNewCanvasAndCtx(e,r){var t,a;try{if(null===(a=(t=new OffscreenCanvas(e,r)).getContext("2d")))throw new Error("getContext of OffscreenCanvas returns null")}catch(e){a=(t=document.createElement("canvas")).getContext("2d")}return t.width=e,t.height=r,[t,a]}function drawImageInCanvas(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0,t=approximateBelowMaximumCanvasSizeOfBrowser(e.width,e.height),a=t.width,i=t.height,s=getNewCanvasAndCtx(a,i),c=_slicedToArray(s,2),l=c[0],u=c[1];return r&&/jpe?g/.test(r)&&(u.fillStyle="white",u.fillRect(0,0,l.width,l.height)),u.drawImage(e,0,0,l.width,l.height),l}function isIOS(){return void 0!==isIOS.cachedResult||(isIOS.cachedResult=["iPad Simulator","iPhone Simulator","iPod Simulator","iPad","iPhone","iPod"].includes(navigator.platform)||navigator.userAgent.includes("Mac")&&"ontouchend"in document),isIOS.cachedResult}function drawFileInCanvas(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return new Promise((function(t,a){var i,s,c=function $Try_2_Post(){try{return s=drawImageInCanvas(i,r.fileType||e.type),t([i,s])}catch(e){return a(e)}},l=function $Try_2_Catch(r){try{0;var t=function $Try_3_Catch(e){try{throw e}catch(e){return a(e)}};try{return getDataUrlFromFile(e).then((function(e){try{return loadImage(e).then((function(e){try{return i=e,function $Try_3_Post(){try{return c()}catch(e){return a(e)}}()}catch(e){return t(e)}}),t)}catch(e){return t(e)}}),t)}catch(e){t(e)}}catch(e){return a(e)}};try{if(isIOS()||[BROWSER_NAME.DESKTOP_SAFARI,BROWSER_NAME.MOBILE_SAFARI].includes(getBrowserName()))throw new Error("Skip createImageBitmap on IOS and Safari");return createImageBitmap(e).then((function(e){try{return i=e,c()}catch(e){return l()}}),l)}catch(e){l()}}))}function canvasToFile(e,r,t,a){var i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:1;return new Promise((function(s,c){var l,u,p;if("image/png"===r)return u=e.getContext("2d").getImageData(0,0,e.width,e.height).data,p=UPNG.encode([u],e.width,e.height,256*i),(l=new Blob([p],{type:r})).name=t,l.lastModified=a,$If_4.call(this);{return"function"==typeof OffscreenCanvas&&e instanceof OffscreenCanvas?e.convertToBlob({type:r,quality:i}).then(function(e){try{return(l=e).name=t,l.lastModified=a,$If_5.call(this)}catch(e){return c(e)}}.bind(this),c):getFilefromDataUrl(e.toDataURL(r,i),t,a).then(function(e){try{return l=e,$If_5.call(this)}catch(e){return c(e)}}.bind(this),c);function $If_5(){return $If_4.call(this)}}function $If_4(){return s(l)}}))}function cleanupCanvasMemory(e){e.width=0,e.height=0}function isAutoOrientationInBrowser(){return new Promise((function(e,r){var t,a,i,s;return void 0!==isAutoOrientationInBrowser.cachedResult?e(isAutoOrientationInBrowser.cachedResult):("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==",getFilefromDataUrl("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==","test.jpg",Date.now()).then((function(c){try{return drawFileInCanvas(t=c).then((function(c){try{return canvasToFile(a=c[1],t.type,t.name,t.lastModified).then((function(t){try{return i=t,cleanupCanvasMemory(a),drawFileInCanvas(i).then((function(t){try{return s=t[0],isAutoOrientationInBrowser.cachedResult=1===s.width&&2===s.height,e(isAutoOrientationInBrowser.cachedResult)}catch(e){return r(e)}}),r)}catch(e){return r(e)}}),r)}catch(e){return r(e)}}),r)}catch(e){return r(e)}}),r))}))}function getExifOrientation(e){return new Promise((function(r,t){var a=new CustomFileReader;a.onload=function(e){var t=new DataView(e.target.result);if(65496!=t.getUint16(0,!1))return r(-2);for(var a=t.byteLength,i=2;i<a;){if(t.getUint16(i+2,!1)<=8)return r(-1);var s=t.getUint16(i,!1);if(i+=2,65505==s){if(1165519206!=t.getUint32(i+=2,!1))return r(-1);var c=18761==t.getUint16(i+=6,!1);i+=t.getUint32(i+4,c);var l=t.getUint16(i,c);i+=2;for(var u=0;u<l;u++)if(274==t.getUint16(i+12*u,c))return r(t.getUint16(i+12*u+8,c))}else{if(65280!=(65280&s))break;i+=t.getUint16(i,!1)}}return r(-1)},a.onerror=function(e){return t(e)},a.readAsArrayBuffer(e)}))}function handleMaxWidthOrHeight(e,r){var t,a=e.width,i=e.height,s=r.maxWidthOrHeight,c=e;if(isFinite(s)&&(a>s||i>s)){var l=_slicedToArray(getNewCanvasAndCtx(a,i),2);c=l[0],t=l[1],a>i?(c.width=s,c.height=i/a*s):(c.width=a/i*s,c.height=s),t.drawImage(e,0,0,c.width,c.height),cleanupCanvasMemory(e)}return c}function followExifOrientation(e,r){var t=e.width,a=e.height,i=_slicedToArray(getNewCanvasAndCtx(t,a),2),s=i[0],c=i[1];switch(r>4&&r<9?(s.width=a,s.height=t):(s.width=t,s.height=a),r){case 2:c.transform(-1,0,0,1,t,0);break;case 3:c.transform(-1,0,0,-1,t,a);break;case 4:c.transform(1,0,0,-1,0,a);break;case 5:c.transform(0,1,1,0,0,0);break;case 6:c.transform(0,1,-1,0,a,0);break;case 7:c.transform(0,-1,-1,0,a,t);break;case 8:c.transform(0,-1,1,0,0,t)}return c.drawImage(e,0,0,t,a),cleanupCanvasMemory(e),s}function compress(e,r){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;return new Promise((function(a,i){var s,c,l,u,p,d,h,y,A,g,E,v,m,I,R,P,S,b;function incProgress(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:5;s+=e,r.onProgress(Math.min(s,100))}function setProgress(e){s=Math.min(Math.max(e,s),100),r.onProgress(s)}return s=t,c=r.maxIteration||10,l=1024*r.maxSizeMB*1024,incProgress(),drawFileInCanvas(e,r).then(function(t){try{var s=_slicedToArray(t,2);return u=s[1],incProgress(),p=handleMaxWidthOrHeight(u,r),incProgress(),new Promise((function(t,a){var i;if(!(i=r.exifOrientation))return getExifOrientation(e).then(function(e){try{return i=e,$If_2.call(this)}catch(e){return a(e)}}.bind(this),a);function $If_2(){return t(i)}return $If_2.call(this)})).then(function(t){try{return d=t,incProgress(),isAutoOrientationInBrowser().then(function(t){try{return h=t?p:followExifOrientation(p,d),incProgress(),y=r.initialQuality||1,A=r.fileType||e.type,canvasToFile(h,A,e.name,e.lastModified,y).then(function(r){try{{if(g=r,incProgress(),E=g.size>l,v=g.size>e.size,!E&&!v)return setProgress(100),a(g);var t;function $Loop_3(){if(c--&&(R>l||R>m)){var r,t,a=_slicedToArray(getNewCanvasAndCtx(r=E?.95*b.width:b.width,t=E?.95*b.height:b.height),2);return S=a[0],a[1].drawImage(b,0,0,r,t),y*=.95,canvasToFile(S,A,e.name,e.lastModified,y).then((function(e){try{return P=e,cleanupCanvasMemory(b),b=S,R=P.size,setProgress(Math.min(99,Math.floor((I-R)/(I-l)*100))),$Loop_3}catch(e){return i(e)}}),i)}return[1]}return m=e.size,I=g.size,R=I,b=h,(t=function(e){for(;e;){if(e.then)return void e.then(t,i);try{if(e.pop){if(e.length)return e.pop()?$Loop_3_exit.call(this):e;e=$Loop_3}else e=e.call(this)}catch(e){return i(e)}}}.bind(this))($Loop_3);function $Loop_3_exit(){return cleanupCanvasMemory(b),cleanupCanvasMemory(S),cleanupCanvasMemory(p),cleanupCanvasMemory(h),cleanupCanvasMemory(u),setProgress(100),a(P)}}}catch(e){return i(e)}}.bind(this),i)}catch(e){return i(e)}}.bind(this),i)}catch(e){return i(e)}}.bind(this),i)}catch(e){return i(e)}}.bind(this),i)}))}var charAt=stringMultibyte.charAt,STRING_ITERATOR="String Iterator",setInternalState$2=internalState.set,getInternalState=internalState.getterFor(STRING_ITERATOR);defineIterator(String,"String",(function(e){setInternalState$2(this,{type:STRING_ITERATOR,string:toString(e),index:0})}),(function next(){var e,r=getInternalState(this),t=r.string,a=r.index;return a>=t.length?{value:void 0,done:!0}:(e=charAt(t,a),r.index+=e.length,{value:e,done:!1})}));var domIterables={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},classList=documentCreateElement("span").classList,DOMTokenListPrototype=classList&&classList.constructor&&classList.constructor.prototype,domTokenListPrototype=DOMTokenListPrototype===Object.prototype?void 0:DOMTokenListPrototype,ITERATOR$2=wellKnownSymbol("iterator"),TO_STRING_TAG=wellKnownSymbol("toStringTag"),ArrayValues=es_array_iterator.values,handlePrototype$1=function(e,r){if(e){if(e[ITERATOR$2]!==ArrayValues)try{createNonEnumerableProperty(e,ITERATOR$2,ArrayValues)}catch(r){e[ITERATOR$2]=ArrayValues}if(e[TO_STRING_TAG]||createNonEnumerableProperty(e,TO_STRING_TAG,r),domIterables[r])for(var t in es_array_iterator)if(e[t]!==es_array_iterator[t])try{createNonEnumerableProperty(e,t,es_array_iterator[t])}catch(r){e[t]=es_array_iterator[t]}}};for(var COLLECTION_NAME$1 in domIterables)handlePrototype$1(global$1[COLLECTION_NAME$1]&&global$1[COLLECTION_NAME$1].prototype,COLLECTION_NAME$1);handlePrototype$1(domTokenListPrototype,"DOMTokenList");var ITERATOR$1=wellKnownSymbol("iterator"),nativeUrl=!fails((function(){var e=new URL("b?a=1&b=2&c=3","http://a"),r=e.searchParams,t="";return e.pathname="c%20d",r.forEach((function(e,a){r.delete("b"),t+=a+e})),isPure&&!e.toJSON||!r.sort||"http://a/c%20d?a=1&c=3"!==e.href||"3"!==r.get("c")||"a=1"!==String(new URLSearchParams("?a=1"))||!r[ITERATOR$1]||"a"!==new URL("https://a@b").username||"b"!==new URLSearchParams(new URLSearchParams("a=b")).get("a")||"xn--e1aybc"!==new URL("http://тест").host||"#%D0%B1"!==new URL("http://a#б").hash||"a1c3"!==t||"x"!==new URL("http://x",void 0).host})),callWithSafeIterationClosing=function(e,r,t,a){try{return a?r(anObject(t)[0],t[1]):r(t)}catch(r){iteratorClose(e,"throw",r)}},arrayFrom=function from(e){var r=toObject(e),t=isConstructor(this),a=arguments.length,i=a>1?arguments[1]:void 0,s=void 0!==i;s&&(i=functionBindContext(i,a>2?arguments[2]:void 0,2));var c,l,u,p,d,h,y=getIteratorMethod(r),A=0;if(!y||this==Array&&isArrayIteratorMethod(y))for(c=toLength(r.length),l=t?new this(c):Array(c);c>A;A++)h=s?i(r[A],A):r[A],createProperty(l,A,h);else for(d=(p=getIterator(r,y)).next,l=t?new this:[];!(u=d.call(p)).done;A++)h=s?callWithSafeIterationClosing(p,i,[u.value,A],!0):u.value,createProperty(l,A,h);return l.length=A,l},maxInt=2147483647,base=36,tMin=1,tMax=26,skew=38,damp=700,initialBias=72,initialN=128,delimiter="-",regexNonASCII=/[^\0-\u007E]/,regexSeparators=/[.\u3002\uFF0E\uFF61]/g,OVERFLOW_ERROR="Overflow: input needs wider integers to process",baseMinusTMin=base-tMin,floor$2=Math.floor,stringFromCharCode=String.fromCharCode,ucs2decode=function(e){for(var r=[],t=0,a=e.length;t<a;){var i=e.charCodeAt(t++);if(i>=55296&&i<=56319&&t<a){var s=e.charCodeAt(t++);56320==(64512&s)?r.push(((1023&i)<<10)+(1023&s)+65536):(r.push(i),t--)}else r.push(i)}return r},digitToBasic=function(e){return e+22+75*(e<26)},adapt=function(e,r,t){var a=0;for(e=t?floor$2(e/damp):e>>1,e+=floor$2(e/r);e>baseMinusTMin*tMax>>1;a+=base)e=floor$2(e/baseMinusTMin);return floor$2(a+(baseMinusTMin+1)*e/(e+skew))},encode=function(e){var r,t,a=[],i=(e=ucs2decode(e)).length,s=initialN,c=0,l=initialBias;for(r=0;r<e.length;r++)(t=e[r])<128&&a.push(stringFromCharCode(t));var u=a.length,p=u;for(u&&a.push(delimiter);p<i;){var d=maxInt;for(r=0;r<e.length;r++)(t=e[r])>=s&&t<d&&(d=t);var h=p+1;if(d-s>floor$2((maxInt-c)/h))throw RangeError(OVERFLOW_ERROR);for(c+=(d-s)*h,s=d,r=0;r<e.length;r++){if((t=e[r])<s&&++c>maxInt)throw RangeError(OVERFLOW_ERROR);if(t==s){for(var y=c,A=base;;A+=base){var g=A<=l?tMin:A>=l+tMax?tMax:A-l;if(y<g)break;var E=y-g,v=base-g;a.push(stringFromCharCode(digitToBasic(g+E%v))),y=floor$2(E/v)}a.push(stringFromCharCode(digitToBasic(y))),l=adapt(c,h,p==u),c=0,++p}}++c,++s}return a.join("")},stringPunycodeToAscii=function(e){var r,t,a=[],i=e.toLowerCase().replace(regexSeparators,".").split(".");for(r=0;r<i.length;r++)t=i[r],a.push(regexNonASCII.test(t)?"xn--"+encode(t):t);return a.join(".")},nativeFetch=getBuiltIn("fetch"),NativeRequest=getBuiltIn("Request"),RequestPrototype=NativeRequest&&NativeRequest.prototype,Headers=getBuiltIn("Headers"),ITERATOR=wellKnownSymbol("iterator"),URL_SEARCH_PARAMS="URLSearchParams",URL_SEARCH_PARAMS_ITERATOR=URL_SEARCH_PARAMS+"Iterator",setInternalState$1=internalState.set,getInternalParamsState=internalState.getterFor(URL_SEARCH_PARAMS),getInternalIteratorState=internalState.getterFor(URL_SEARCH_PARAMS_ITERATOR),plus=/\+/g,sequences=Array(4),percentSequence=function(e){return sequences[e-1]||(sequences[e-1]=RegExp("((?:%[\\da-f]{2}){"+e+"})","gi"))},percentDecode=function(e){try{return decodeURIComponent(e)}catch(r){return e}},deserialize=function(e){var r=e.replace(plus," "),t=4;try{return decodeURIComponent(r)}catch(e){for(;t;)r=r.replace(percentSequence(t--),percentDecode);return r}},find=/[!'()~]|%20/g,replace$1={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+"},replacer=function(e){return replace$1[e]},serialize=function(e){return encodeURIComponent(e).replace(find,replacer)},parseSearchParams=function(e,r){if(r)for(var t,a,i=r.split("&"),s=0;s<i.length;)(t=i[s++]).length&&(a=t.split("="),e.push({key:deserialize(a.shift()),value:deserialize(a.join("="))}))},updateSearchParams=function(e){this.entries.length=0,parseSearchParams(this.entries,e)},validateArgumentsLength=function(e,r){if(e<r)throw TypeError("Not enough arguments")},URLSearchParamsIterator=createIteratorConstructor((function Iterator(e,r){setInternalState$1(this,{type:URL_SEARCH_PARAMS_ITERATOR,iterator:getIterator(getInternalParamsState(e).entries),kind:r})}),"Iterator",(function next(){var e=getInternalIteratorState(this),r=e.kind,t=e.iterator.next(),a=t.value;return t.done||(t.value="keys"===r?a.key:"values"===r?a.value:[a.key,a.value]),t})),URLSearchParamsConstructor=function URLSearchParams(){anInstance(this,URLSearchParamsConstructor,URL_SEARCH_PARAMS);var e,r,t,a,i,s,c,l,u,p=arguments.length>0?arguments[0]:void 0,d=this,h=[];if(setInternalState$1(d,{type:URL_SEARCH_PARAMS,entries:h,updateURL:function(){},updateSearchParams:updateSearchParams}),void 0!==p)if(isObject(p))if(e=getIteratorMethod(p))for(t=(r=getIterator(p,e)).next;!(a=t.call(r)).done;){if((c=(s=(i=getIterator(anObject(a.value))).next).call(i)).done||(l=s.call(i)).done||!s.call(i).done)throw TypeError("Expected sequence with length 2");h.push({key:toString(c.value),value:toString(l.value)})}else for(u in p)has$1(p,u)&&h.push({key:u,value:toString(p[u])});else parseSearchParams(h,"string"==typeof p?"?"===p.charAt(0)?p.slice(1):p:toString(p))},URLSearchParamsPrototype=URLSearchParamsConstructor.prototype;if(redefineAll(URLSearchParamsPrototype,{append:function append(e,r){validateArgumentsLength(arguments.length,2);var t=getInternalParamsState(this);t.entries.push({key:toString(e),value:toString(r)}),t.updateURL()},delete:function(e){validateArgumentsLength(arguments.length,1);for(var r=getInternalParamsState(this),t=r.entries,a=toString(e),i=0;i<t.length;)t[i].key===a?t.splice(i,1):i++;r.updateURL()},get:function get(e){validateArgumentsLength(arguments.length,1);for(var r=getInternalParamsState(this).entries,t=toString(e),a=0;a<r.length;a++)if(r[a].key===t)return r[a].value;return null},getAll:function getAll(e){validateArgumentsLength(arguments.length,1);for(var r=getInternalParamsState(this).entries,t=toString(e),a=[],i=0;i<r.length;i++)r[i].key===t&&a.push(r[i].value);return a},has:function has(e){validateArgumentsLength(arguments.length,1);for(var r=getInternalParamsState(this).entries,t=toString(e),a=0;a<r.length;)if(r[a++].key===t)return!0;return!1},set:function set(e,r){validateArgumentsLength(arguments.length,1);for(var t,a=getInternalParamsState(this),i=a.entries,s=!1,c=toString(e),l=toString(r),u=0;u<i.length;u++)(t=i[u]).key===c&&(s?i.splice(u--,1):(s=!0,t.value=l));s||i.push({key:c,value:l}),a.updateURL()},sort:function sort(){var e,r,t,a=getInternalParamsState(this),i=a.entries,s=i.slice();for(i.length=0,t=0;t<s.length;t++){for(e=s[t],r=0;r<t;r++)if(i[r].key>e.key){i.splice(r,0,e);break}r===t&&i.push(e)}a.updateURL()},forEach:function forEach(e){for(var r,t=getInternalParamsState(this).entries,a=functionBindContext(e,arguments.length>1?arguments[1]:void 0,3),i=0;i<t.length;)a((r=t[i++]).value,r.key,this)},keys:function keys(){return new URLSearchParamsIterator(this,"keys")},values:function values(){return new URLSearchParamsIterator(this,"values")},entries:function entries(){return new URLSearchParamsIterator(this,"entries")}},{enumerable:!0}),redefine(URLSearchParamsPrototype,ITERATOR,URLSearchParamsPrototype.entries,{name:"entries"}),redefine(URLSearchParamsPrototype,"toString",(function toString(){for(var e,r=getInternalParamsState(this).entries,t=[],a=0;a<r.length;)e=r[a++],t.push(serialize(e.key)+"="+serialize(e.value));return t.join("&")}),{enumerable:!0}),setToStringTag(URLSearchParamsConstructor,URL_SEARCH_PARAMS),_export({global:!0,forced:!nativeUrl},{URLSearchParams:URLSearchParamsConstructor}),!nativeUrl&&isCallable(Headers)){var wrapRequestOptions=function(e){if(isObject(e)){var r,t=e.body;if(classof(t)===URL_SEARCH_PARAMS)return(r=e.headers?new Headers(e.headers):new Headers).has("content-type")||r.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"),objectCreate(e,{body:createPropertyDescriptor(0,String(t)),headers:createPropertyDescriptor(0,r)})}return e};if(isCallable(nativeFetch)&&_export({global:!0,enumerable:!0,forced:!0},{fetch:function fetch(e){return nativeFetch(e,arguments.length>1?wrapRequestOptions(arguments[1]):{})}}),isCallable(NativeRequest)){var RequestConstructor=function Request(e){return anInstance(this,RequestConstructor,"Request"),new NativeRequest(e,arguments.length>1?wrapRequestOptions(arguments[1]):{})};RequestPrototype.constructor=RequestConstructor,RequestConstructor.prototype=RequestPrototype,_export({global:!0,forced:!0},{Request:RequestConstructor})}}var web_urlSearchParams={URLSearchParams:URLSearchParamsConstructor,getState:getInternalParamsState},codeAt=stringMultibyte.codeAt,NativeURL=global$1.URL,URLSearchParams$1=web_urlSearchParams.URLSearchParams,getInternalSearchParamsState=web_urlSearchParams.getState,setInternalState=internalState.set,getInternalURLState=internalState.getterFor("URL"),floor$1=Math.floor,pow=Math.pow,INVALID_AUTHORITY="Invalid authority",INVALID_SCHEME="Invalid scheme",INVALID_HOST="Invalid host",INVALID_PORT="Invalid port",ALPHA=/[A-Za-z]/,ALPHANUMERIC=/[\d+-.A-Za-z]/,DIGIT=/\d/,HEX_START=/^0x/i,OCT=/^[0-7]+$/,DEC=/^\d+$/,HEX=/^[\dA-Fa-f]+$/,FORBIDDEN_HOST_CODE_POINT=/[\0\t\n\r #%/:<>?@[\\\]^|]/,FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT=/[\0\t\n\r #/:<>?@[\\\]^|]/,LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE=/^[\u0000-\u0020]+|[\u0000-\u0020]+$/g,TAB_AND_NEW_LINE=/[\t\n\r]/g,EOF,parseHost=function(e,r){var t,a,i;if("["==r.charAt(0)){if("]"!=r.charAt(r.length-1))return INVALID_HOST;if(!(t=parseIPv6(r.slice(1,-1))))return INVALID_HOST;e.host=t}else if(isSpecial(e)){if(r=stringPunycodeToAscii(r),FORBIDDEN_HOST_CODE_POINT.test(r))return INVALID_HOST;if(null===(t=parseIPv4(r)))return INVALID_HOST;e.host=t}else{if(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(r))return INVALID_HOST;for(t="",a=arrayFrom(r),i=0;i<a.length;i++)t+=percentEncode(a[i],C0ControlPercentEncodeSet);e.host=t}},parseIPv4=function(e){var r,t,a,i,s,c,l,u=e.split(".");if(u.length&&""==u[u.length-1]&&u.pop(),(r=u.length)>4)return e;for(t=[],a=0;a<r;a++){if(""==(i=u[a]))return e;if(s=10,i.length>1&&"0"==i.charAt(0)&&(s=HEX_START.test(i)?16:8,i=i.slice(8==s?1:2)),""===i)c=0;else{if(!(10==s?DEC:8==s?OCT:HEX).test(i))return e;c=parseInt(i,s)}t.push(c)}for(a=0;a<r;a++)if(c=t[a],a==r-1){if(c>=pow(256,5-r))return null}else if(c>255)return null;for(l=t.pop(),a=0;a<t.length;a++)l+=t[a]*pow(256,3-a);return l},parseIPv6=function(e){var r,t,a,i,s,c,l,u=[0,0,0,0,0,0,0,0],p=0,d=null,h=0,chr=function(){return e.charAt(h)};if(":"==chr()){if(":"!=e.charAt(1))return;h+=2,d=++p}for(;chr();){if(8==p)return;if(":"!=chr()){for(r=t=0;t<4&&HEX.test(chr());)r=16*r+parseInt(chr(),16),h++,t++;if("."==chr()){if(0==t)return;if(h-=t,p>6)return;for(a=0;chr();){if(i=null,a>0){if(!("."==chr()&&a<4))return;h++}if(!DIGIT.test(chr()))return;for(;DIGIT.test(chr());){if(s=parseInt(chr(),10),null===i)i=s;else{if(0==i)return;i=10*i+s}if(i>255)return;h++}u[p]=256*u[p]+i,2!=++a&&4!=a||p++}if(4!=a)return;break}if(":"==chr()){if(h++,!chr())return}else if(chr())return;u[p++]=r}else{if(null!==d)return;h++,d=++p}}if(null!==d)for(c=p-d,p=7;0!=p&&c>0;)l=u[p],u[p--]=u[d+c-1],u[d+--c]=l;else if(8!=p)return;return u},findLongestZeroSequence=function(e){for(var r=null,t=1,a=null,i=0,s=0;s<8;s++)0!==e[s]?(i>t&&(r=a,t=i),a=null,i=0):(null===a&&(a=s),++i);return i>t&&(r=a,t=i),r},serializeHost=function(e){var r,t,a,i;if("number"==typeof e){for(r=[],t=0;t<4;t++)r.unshift(e%256),e=floor$1(e/256);return r.join(".")}if("object"==typeof e){for(r="",a=findLongestZeroSequence(e),t=0;t<8;t++)i&&0===e[t]||(i&&(i=!1),a===t?(r+=t?":":"::",i=!0):(r+=e[t].toString(16),t<7&&(r+=":")));return"["+r+"]"}return e},C0ControlPercentEncodeSet={},fragmentPercentEncodeSet=objectAssign({},C0ControlPercentEncodeSet,{" ":1,'"':1,"<":1,">":1,"`":1}),pathPercentEncodeSet=objectAssign({},fragmentPercentEncodeSet,{"#":1,"?":1,"{":1,"}":1}),userinfoPercentEncodeSet=objectAssign({},pathPercentEncodeSet,{"/":1,":":1,";":1,"=":1,"@":1,"[":1,"\\":1,"]":1,"^":1,"|":1}),percentEncode=function(e,r){var t=codeAt(e,0);return t>32&&t<127&&!has$1(r,e)?e:encodeURIComponent(e)},specialSchemes={ftp:21,file:null,http:80,https:443,ws:80,wss:443},isSpecial=function(e){return has$1(specialSchemes,e.scheme)},includesCredentials=function(e){return""!=e.username||""!=e.password},cannotHaveUsernamePasswordPort=function(e){return!e.host||e.cannotBeABaseURL||"file"==e.scheme},isWindowsDriveLetter=function(e,r){var t;return 2==e.length&&ALPHA.test(e.charAt(0))&&(":"==(t=e.charAt(1))||!r&&"|"==t)},startsWithWindowsDriveLetter=function(e){var r;return e.length>1&&isWindowsDriveLetter(e.slice(0,2))&&(2==e.length||"/"===(r=e.charAt(2))||"\\"===r||"?"===r||"#"===r)},shortenURLsPath=function(e){var r=e.path,t=r.length;!t||"file"==e.scheme&&1==t&&isWindowsDriveLetter(r[0],!0)||r.pop()},isSingleDot=function(e){return"."===e||"%2e"===e.toLowerCase()},isDoubleDot=function(e){return".."===(e=e.toLowerCase())||"%2e."===e||".%2e"===e||"%2e%2e"===e},SCHEME_START={},SCHEME={},NO_SCHEME={},SPECIAL_RELATIVE_OR_AUTHORITY={},PATH_OR_AUTHORITY={},RELATIVE={},RELATIVE_SLASH={},SPECIAL_AUTHORITY_SLASHES={},SPECIAL_AUTHORITY_IGNORE_SLASHES={},AUTHORITY={},HOST={},HOSTNAME={},PORT={},FILE={},FILE_SLASH={},FILE_HOST={},PATH_START={},PATH={},CANNOT_BE_A_BASE_URL_PATH={},QUERY={},FRAGMENT={},parseURL=function(e,r,t,a){var i,s,c,l,u=t||SCHEME_START,p=0,d="",h=!1,y=!1,A=!1;for(t||(e.scheme="",e.username="",e.password="",e.host=null,e.port=null,e.path=[],e.query=null,e.fragment=null,e.cannotBeABaseURL=!1,r=r.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE,"")),r=r.replace(TAB_AND_NEW_LINE,""),i=arrayFrom(r);p<=i.length;){switch(s=i[p],u){case SCHEME_START:if(!s||!ALPHA.test(s)){if(t)return INVALID_SCHEME;u=NO_SCHEME;continue}d+=s.toLowerCase(),u=SCHEME;break;case SCHEME:if(s&&(ALPHANUMERIC.test(s)||"+"==s||"-"==s||"."==s))d+=s.toLowerCase();else{if(":"!=s){if(t)return INVALID_SCHEME;d="",u=NO_SCHEME,p=0;continue}if(t&&(isSpecial(e)!=has$1(specialSchemes,d)||"file"==d&&(includesCredentials(e)||null!==e.port)||"file"==e.scheme&&!e.host))return;if(e.scheme=d,t)return void(isSpecial(e)&&specialSchemes[e.scheme]==e.port&&(e.port=null));d="","file"==e.scheme?u=FILE:isSpecial(e)&&a&&a.scheme==e.scheme?u=SPECIAL_RELATIVE_OR_AUTHORITY:isSpecial(e)?u=SPECIAL_AUTHORITY_SLASHES:"/"==i[p+1]?(u=PATH_OR_AUTHORITY,p++):(e.cannotBeABaseURL=!0,e.path.push(""),u=CANNOT_BE_A_BASE_URL_PATH)}break;case NO_SCHEME:if(!a||a.cannotBeABaseURL&&"#"!=s)return INVALID_SCHEME;if(a.cannotBeABaseURL&&"#"==s){e.scheme=a.scheme,e.path=a.path.slice(),e.query=a.query,e.fragment="",e.cannotBeABaseURL=!0,u=FRAGMENT;break}u="file"==a.scheme?FILE:RELATIVE;continue;case SPECIAL_RELATIVE_OR_AUTHORITY:if("/"!=s||"/"!=i[p+1]){u=RELATIVE;continue}u=SPECIAL_AUTHORITY_IGNORE_SLASHES,p++;break;case PATH_OR_AUTHORITY:if("/"==s){u=AUTHORITY;break}u=PATH;continue;case RELATIVE:if(e.scheme=a.scheme,s==EOF)e.username=a.username,e.password=a.password,e.host=a.host,e.port=a.port,e.path=a.path.slice(),e.query=a.query;else if("/"==s||"\\"==s&&isSpecial(e))u=RELATIVE_SLASH;else if("?"==s)e.username=a.username,e.password=a.password,e.host=a.host,e.port=a.port,e.path=a.path.slice(),e.query="",u=QUERY;else{if("#"!=s){e.username=a.username,e.password=a.password,e.host=a.host,e.port=a.port,e.path=a.path.slice(),e.path.pop(),u=PATH;continue}e.username=a.username,e.password=a.password,e.host=a.host,e.port=a.port,e.path=a.path.slice(),e.query=a.query,e.fragment="",u=FRAGMENT}break;case RELATIVE_SLASH:if(!isSpecial(e)||"/"!=s&&"\\"!=s){if("/"!=s){e.username=a.username,e.password=a.password,e.host=a.host,e.port=a.port,u=PATH;continue}u=AUTHORITY}else u=SPECIAL_AUTHORITY_IGNORE_SLASHES;break;case SPECIAL_AUTHORITY_SLASHES:if(u=SPECIAL_AUTHORITY_IGNORE_SLASHES,"/"!=s||"/"!=d.charAt(p+1))continue;p++;break;case SPECIAL_AUTHORITY_IGNORE_SLASHES:if("/"!=s&&"\\"!=s){u=AUTHORITY;continue}break;case AUTHORITY:if("@"==s){h&&(d="%40"+d),h=!0,c=arrayFrom(d);for(var g=0;g<c.length;g++){var E=c[g];if(":"!=E||A){var v=percentEncode(E,userinfoPercentEncodeSet);A?e.password+=v:e.username+=v}else A=!0}d=""}else if(s==EOF||"/"==s||"?"==s||"#"==s||"\\"==s&&isSpecial(e)){if(h&&""==d)return INVALID_AUTHORITY;p-=arrayFrom(d).length+1,d="",u=HOST}else d+=s;break;case HOST:case HOSTNAME:if(t&&"file"==e.scheme){u=FILE_HOST;continue}if(":"!=s||y){if(s==EOF||"/"==s||"?"==s||"#"==s||"\\"==s&&isSpecial(e)){if(isSpecial(e)&&""==d)return INVALID_HOST;if(t&&""==d&&(includesCredentials(e)||null!==e.port))return;if(l=parseHost(e,d))return l;if(d="",u=PATH_START,t)return;continue}"["==s?y=!0:"]"==s&&(y=!1),d+=s}else{if(""==d)return INVALID_HOST;if(l=parseHost(e,d))return l;if(d="",u=PORT,t==HOSTNAME)return}break;case PORT:if(!DIGIT.test(s)){if(s==EOF||"/"==s||"?"==s||"#"==s||"\\"==s&&isSpecial(e)||t){if(""!=d){var m=parseInt(d,10);if(m>65535)return INVALID_PORT;e.port=isSpecial(e)&&m===specialSchemes[e.scheme]?null:m,d=""}if(t)return;u=PATH_START;continue}return INVALID_PORT}d+=s;break;case FILE:if(e.scheme="file","/"==s||"\\"==s)u=FILE_SLASH;else{if(!a||"file"!=a.scheme){u=PATH;continue}if(s==EOF)e.host=a.host,e.path=a.path.slice(),e.query=a.query;else if("?"==s)e.host=a.host,e.path=a.path.slice(),e.query="",u=QUERY;else{if("#"!=s){startsWithWindowsDriveLetter(i.slice(p).join(""))||(e.host=a.host,e.path=a.path.slice(),shortenURLsPath(e)),u=PATH;continue}e.host=a.host,e.path=a.path.slice(),e.query=a.query,e.fragment="",u=FRAGMENT}}break;case FILE_SLASH:if("/"==s||"\\"==s){u=FILE_HOST;break}a&&"file"==a.scheme&&!startsWithWindowsDriveLetter(i.slice(p).join(""))&&(isWindowsDriveLetter(a.path[0],!0)?e.path.push(a.path[0]):e.host=a.host),u=PATH;continue;case FILE_HOST:if(s==EOF||"/"==s||"\\"==s||"?"==s||"#"==s){if(!t&&isWindowsDriveLetter(d))u=PATH;else if(""==d){if(e.host="",t)return;u=PATH_START}else{if(l=parseHost(e,d))return l;if("localhost"==e.host&&(e.host=""),t)return;d="",u=PATH_START}continue}d+=s;break;case PATH_START:if(isSpecial(e)){if(u=PATH,"/"!=s&&"\\"!=s)continue}else if(t||"?"!=s)if(t||"#"!=s){if(s!=EOF&&(u=PATH,"/"!=s))continue}else e.fragment="",u=FRAGMENT;else e.query="",u=QUERY;break;case PATH:if(s==EOF||"/"==s||"\\"==s&&isSpecial(e)||!t&&("?"==s||"#"==s)){if(isDoubleDot(d)?(shortenURLsPath(e),"/"==s||"\\"==s&&isSpecial(e)||e.path.push("")):isSingleDot(d)?"/"==s||"\\"==s&&isSpecial(e)||e.path.push(""):("file"==e.scheme&&!e.path.length&&isWindowsDriveLetter(d)&&(e.host&&(e.host=""),d=d.charAt(0)+":"),e.path.push(d)),d="","file"==e.scheme&&(s==EOF||"?"==s||"#"==s))for(;e.path.length>1&&""===e.path[0];)e.path.shift();"?"==s?(e.query="",u=QUERY):"#"==s&&(e.fragment="",u=FRAGMENT)}else d+=percentEncode(s,pathPercentEncodeSet);break;case CANNOT_BE_A_BASE_URL_PATH:"?"==s?(e.query="",u=QUERY):"#"==s?(e.fragment="",u=FRAGMENT):s!=EOF&&(e.path[0]+=percentEncode(s,C0ControlPercentEncodeSet));break;case QUERY:t||"#"!=s?s!=EOF&&("'"==s&&isSpecial(e)?e.query+="%27":e.query+="#"==s?"%23":percentEncode(s,C0ControlPercentEncodeSet)):(e.fragment="",u=FRAGMENT);break;case FRAGMENT:s!=EOF&&(e.fragment+=percentEncode(s,fragmentPercentEncodeSet))}p++}},URLConstructor=function URL(e){var r,t,a=anInstance(this,URLConstructor,"URL"),i=arguments.length>1?arguments[1]:void 0,s=toString(e),c=setInternalState(a,{type:"URL"});if(void 0!==i)if(i instanceof URLConstructor)r=getInternalURLState(i);else if(t=parseURL(r={},toString(i)))throw TypeError(t);if(t=parseURL(c,s,null,r))throw TypeError(t);var l=c.searchParams=new URLSearchParams$1,u=getInternalSearchParamsState(l);u.updateSearchParams(c.query),u.updateURL=function(){c.query=String(l)||null},descriptors||(a.href=serializeURL.call(a),a.origin=getOrigin.call(a),a.protocol=getProtocol.call(a),a.username=getUsername.call(a),a.password=getPassword.call(a),a.host=getHost.call(a),a.hostname=getHostname.call(a),a.port=getPort.call(a),a.pathname=getPathname.call(a),a.search=getSearch.call(a),a.searchParams=getSearchParams.call(a),a.hash=getHash.call(a))},URLPrototype=URLConstructor.prototype,serializeURL=function(){var e=getInternalURLState(this),r=e.scheme,t=e.username,a=e.password,i=e.host,s=e.port,c=e.path,l=e.query,u=e.fragment,p=r+":";return null!==i?(p+="//",includesCredentials(e)&&(p+=t+(a?":"+a:"")+"@"),p+=serializeHost(i),null!==s&&(p+=":"+s)):"file"==r&&(p+="//"),p+=e.cannotBeABaseURL?c[0]:c.length?"/"+c.join("/"):"",null!==l&&(p+="?"+l),null!==u&&(p+="#"+u),p},getOrigin=function(){var e=getInternalURLState(this),r=e.scheme,t=e.port;if("blob"==r)try{return new URLConstructor(r.path[0]).origin}catch(e){return"null"}return"file"!=r&&isSpecial(e)?r+"://"+serializeHost(e.host)+(null!==t?":"+t:""):"null"},getProtocol=function(){return getInternalURLState(this).scheme+":"},getUsername=function(){return getInternalURLState(this).username},getPassword=function(){return getInternalURLState(this).password},getHost=function(){var e=getInternalURLState(this),r=e.host,t=e.port;return null===r?"":null===t?serializeHost(r):serializeHost(r)+":"+t},getHostname=function(){var e=getInternalURLState(this).host;return null===e?"":serializeHost(e)},getPort=function(){var e=getInternalURLState(this).port;return null===e?"":String(e)},getPathname=function(){var e=getInternalURLState(this),r=e.path;return e.cannotBeABaseURL?r[0]:r.length?"/"+r.join("/"):""},getSearch=function(){var e=getInternalURLState(this).query;return e?"?"+e:""},getSearchParams=function(){return getInternalURLState(this).searchParams},getHash=function(){var e=getInternalURLState(this).fragment;return e?"#"+e:""},accessorDescriptor=function(e,r){return{get:e,set:r,configurable:!0,enumerable:!0}};if(descriptors&&objectDefineProperties(URLPrototype,{href:accessorDescriptor(serializeURL,(function(e){var r=getInternalURLState(this),t=toString(e),a=parseURL(r,t);if(a)throw TypeError(a);getInternalSearchParamsState(r.searchParams).updateSearchParams(r.query)})),origin:accessorDescriptor(getOrigin),protocol:accessorDescriptor(getProtocol,(function(e){var r=getInternalURLState(this);parseURL(r,toString(e)+":",SCHEME_START)})),username:accessorDescriptor(getUsername,(function(e){var r=getInternalURLState(this),t=arrayFrom(toString(e));if(!cannotHaveUsernamePasswordPort(r)){r.username="";for(var a=0;a<t.length;a++)r.username+=percentEncode(t[a],userinfoPercentEncodeSet)}})),password:accessorDescriptor(getPassword,(function(e){var r=getInternalURLState(this),t=arrayFrom(toString(e));if(!cannotHaveUsernamePasswordPort(r)){r.password="";for(var a=0;a<t.length;a++)r.password+=percentEncode(t[a],userinfoPercentEncodeSet)}})),host:accessorDescriptor(getHost,(function(e){var r=getInternalURLState(this);r.cannotBeABaseURL||parseURL(r,toString(e),HOST)})),hostname:accessorDescriptor(getHostname,(function(e){var r=getInternalURLState(this);r.cannotBeABaseURL||parseURL(r,toString(e),HOSTNAME)})),port:accessorDescriptor(getPort,(function(e){var r=getInternalURLState(this);cannotHaveUsernamePasswordPort(r)||(""==(e=toString(e))?r.port=null:parseURL(r,e,PORT))})),pathname:accessorDescriptor(getPathname,(function(e){var r=getInternalURLState(this);r.cannotBeABaseURL||(r.path=[],parseURL(r,toString(e),PATH_START))})),search:accessorDescriptor(getSearch,(function(e){var r=getInternalURLState(this);""==(e=toString(e))?r.query=null:("?"==e.charAt(0)&&(e=e.slice(1)),r.query="",parseURL(r,e,QUERY)),getInternalSearchParamsState(r.searchParams).updateSearchParams(r.query)})),searchParams:accessorDescriptor(getSearchParams),hash:accessorDescriptor(getHash,(function(e){var r=getInternalURLState(this);""!=(e=toString(e))?("#"==e.charAt(0)&&(e=e.slice(1)),r.fragment="",parseURL(r,e,FRAGMENT)):r.fragment=null}))}),redefine(URLPrototype,"toJSON",(function toJSON(){return serializeURL.call(this)}),{enumerable:!0}),redefine(URLPrototype,"toString",(function toString(){return serializeURL.call(this)}),{enumerable:!0}),NativeURL){var nativeCreateObjectURL=NativeURL.createObjectURL,nativeRevokeObjectURL=NativeURL.revokeObjectURL;nativeCreateObjectURL&&redefine(URLConstructor,"createObjectURL",(function createObjectURL(e){return nativeCreateObjectURL.apply(NativeURL,arguments)})),nativeRevokeObjectURL&&redefine(URLConstructor,"revokeObjectURL",(function revokeObjectURL(e){return nativeRevokeObjectURL.apply(NativeURL,arguments)}))}setToStringTag(URLConstructor,"URL"),_export({global:!0,forced:!nativeUrl,sham:!descriptors},{URL:URLConstructor});var $forEach=arrayIteration.forEach,STRICT_METHOD=arrayMethodIsStrict("forEach"),arrayForEach=STRICT_METHOD?[].forEach:function forEach(e){return $forEach(this,e,arguments.length>1?arguments[1]:void 0)},handlePrototype=function(e){if(e&&e.forEach!==arrayForEach)try{createNonEnumerableProperty(e,"forEach",arrayForEach)}catch(r){e.forEach=arrayForEach}};for(var COLLECTION_NAME in domIterables)handlePrototype(global$1[COLLECTION_NAME]&&global$1[COLLECTION_NAME].prototype);handlePrototype(domTokenListPrototype);var propertyIsEnumerable=objectPropertyIsEnumerable.f,createMethod=function(e){return function(r){for(var t,a=toIndexedObject(r),i=objectKeys(a),s=i.length,c=0,l=[];s>c;)t=i[c++],descriptors&&!propertyIsEnumerable.call(a,t)||l.push(e?[t,a[t]]:a[t]);return l}},objectToArray={entries:createMethod(!0),values:createMethod(!1)},$entries=objectToArray.entries;_export({target:"Object",stat:!0},{entries:function entries(e){return $entries(e)}});var getOwnPropertyDescriptor=objectGetOwnPropertyDescriptor.f,$startsWith="".startsWith,min$1=Math.min,CORRECT_IS_REGEXP_LOGIC=correctIsRegexpLogic("startsWith"),MDN_POLYFILL_BUG=!(CORRECT_IS_REGEXP_LOGIC||(descriptor=getOwnPropertyDescriptor(String.prototype,"startsWith"),!descriptor||descriptor.writable)),descriptor;_export({target:"String",proto:!0,forced:!MDN_POLYFILL_BUG&&!CORRECT_IS_REGEXP_LOGIC},{startsWith:function startsWith(e){var r=toString(requireObjectCoercible(this));notARegexp(e);var t=toLength(min$1(arguments.length>1?arguments[1]:void 0,r.length)),a=toString(e);return $startsWith?$startsWith.call(r,a,t):r.slice(t,t+a.length)===a}});var floor=Math.floor,replace="".replace,SUBSTITUTION_SYMBOLS=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,SUBSTITUTION_SYMBOLS_NO_NAMED=/\$([$&'`]|\d{1,2})/g,getSubstitution=function(e,r,t,a,i,s){var c=t+e.length,l=a.length,u=SUBSTITUTION_SYMBOLS_NO_NAMED;return void 0!==i&&(i=toObject(i),u=SUBSTITUTION_SYMBOLS),replace.call(s,u,(function(s,u){var p;switch(u.charAt(0)){case"$":return"$";case"&":return e;case"`":return r.slice(0,t);case"'":return r.slice(c);case"<":p=i[u.slice(1,-1)];break;default:var d=+u;if(0===d)return s;if(d>l){var h=floor(d/10);return 0===h?s:h<=l?void 0===a[h-1]?u.charAt(1):a[h-1]+u.charAt(1):s}p=a[d-1]}return void 0===p?"":p}))},REPLACE=wellKnownSymbol("replace"),max=Math.max,min=Math.min,maybeToString=function(e){return void 0===e?e:String(e)},REPLACE_KEEPS_$0="$0"==="a".replace(/./,"$0"),REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE=!!/./[REPLACE]&&""===/./[REPLACE]("a","$0"),REPLACE_SUPPORTS_NAMED_GROUPS=!fails((function(){var e=/./;return e.exec=function(){var e=[];return e.groups={a:"7"},e},"7"!=="".replace(e,"$<a>")}));fixRegexpWellKnownSymbolLogic("replace",(function(e,r,t){var a=REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE?"$":"$0";return[function replace(e,t){var a=requireObjectCoercible(this),i=null==e?void 0:getMethod(e,REPLACE);return i?i.call(e,a,t):r.call(toString(a),e,t)},function(e,i){var s=anObject(this),c=toString(e);if("string"==typeof i&&-1===i.indexOf(a)&&-1===i.indexOf("$<")){var l=t(r,s,c,i);if(l.done)return l.value}var u=isCallable(i);u||(i=toString(i));var p=s.global;if(p){var d=s.unicode;s.lastIndex=0}for(var h=[];;){var y=regexpExecAbstract(s,c);if(null===y)break;if(h.push(y),!p)break;""===toString(y[0])&&(s.lastIndex=advanceStringIndex(c,toLength(s.lastIndex),d))}for(var A="",g=0,E=0;E<h.length;E++){y=h[E];for(var v=toString(y[0]),m=max(min(toInteger(y.index),c.length),0),I=[],R=1;R<y.length;R++)I.push(maybeToString(y[R]));var P=y.groups;if(u){var S=[v].concat(I,m,c);void 0!==P&&S.push(P);var b=toString(i.apply(void 0,S))}else b=getSubstitution(v,c,m,I,P,i);m>=g&&(A+=c.slice(g,m)+b,g=m+v.length)}return A+c.slice(g)}]}),!REPLACE_SUPPORTS_NAMED_GROUPS||!REPLACE_KEEPS_$0||REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);var IS_CONCAT_SPREADABLE=wellKnownSymbol("isConcatSpreadable"),MAX_SAFE_INTEGER=9007199254740991,MAXIMUM_ALLOWED_INDEX_EXCEEDED="Maximum allowed index exceeded",IS_CONCAT_SPREADABLE_SUPPORT=engineV8Version>=51||!fails((function(){var e=[];return e[IS_CONCAT_SPREADABLE]=!1,e.concat()[0]!==e})),SPECIES_SUPPORT=arrayMethodHasSpeciesSupport("concat"),isConcatSpreadable=function(e){if(!isObject(e))return!1;var r=e[IS_CONCAT_SPREADABLE];return void 0!==r?!!r:isArray(e)},FORCED=!IS_CONCAT_SPREADABLE_SUPPORT||!SPECIES_SUPPORT;_export({target:"Array",proto:!0,forced:FORCED},{concat:function concat(e){var r,t,a,i,s,c=toObject(this),l=arraySpeciesCreate(c,0),u=0;for(r=-1,a=arguments.length;r<a;r++)if(isConcatSpreadable(s=-1===r?c:arguments[r])){if(u+(i=toLength(s.length))>MAX_SAFE_INTEGER)throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);for(t=0;t<i;t++,u++)t in s&&createProperty(l,u,s[t])}else{if(u>=MAX_SAFE_INTEGER)throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);createProperty(l,u++,s)}return l.length=u,l}});var cnt=0,imageCompressionLibUrl,worker;function createWorker(e){var r=[];return"function"==typeof e?r.push("(".concat(e,")()")):r.push(e),new Worker(URL.createObjectURL(new Blob(r)))}function createSourceObject(e){return URL.createObjectURL(new Blob([e],{type:"application/javascript"}))}function stringify(e){return JSON.stringify(e,(function(e,r){return"function"==typeof r?"BIC_FN:::(function () { return ".concat(r.toString()," })()"):r}))}function parse(o){if("string"==typeof o)return o;var result={};return Object.entries(o).forEach((function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];if("string"==typeof value&&value.startsWith("BIC_FN:::"))try{result[key]=eval(value.replace(/^BIC_FN:::/,""))}catch(e){throw e}else result[key]=parse(value)})),result}function generateLib(){return createSourceObject("\n    // reconstruct library\n    function imageCompression (){return (".concat(imageCompression,").apply(null, arguments)}\n\n    imageCompression.getDataUrlFromFile = ").concat(imageCompression.getDataUrlFromFile,"\n    imageCompression.getFilefromDataUrl = ").concat(imageCompression.getFilefromDataUrl,"\n    imageCompression.loadImage = ").concat(imageCompression.loadImage,"\n    imageCompression.drawImageInCanvas = ").concat(imageCompression.drawImageInCanvas,"\n    imageCompression.drawFileInCanvas = ").concat(imageCompression.drawFileInCanvas,"\n    imageCompression.canvasToFile = ").concat(imageCompression.canvasToFile,"\n    imageCompression.getExifOrientation = ").concat(imageCompression.getExifOrientation,"\n    imageCompression.handleMaxWidthOrHeight = ").concat(imageCompression.handleMaxWidthOrHeight,"\n    imageCompression.followExifOrientation = ").concat(imageCompression.followExifOrientation,"\n    imageCompression.cleanupCanvasMemory = ").concat(imageCompression.cleanupCanvasMemory,"\n    imageCompression.isAutoOrientationInBrowser = ").concat(imageCompression.isAutoOrientationInBrowser,"\n    imageCompression.approximateBelowMaximumCanvasSizeOfBrowser = ").concat(imageCompression.approximateBelowMaximumCanvasSizeOfBrowser,"\n    imageCompression.getBrowserName = ").concat(imageCompression.getBrowserName,"\n\n    // functions / objects\n    getDataUrlFromFile = imageCompression.getDataUrlFromFile\n    getFilefromDataUrl = imageCompression.getFilefromDataUrl\n    loadImage = imageCompression.loadImage\n    drawImageInCanvas = imageCompression.drawImageInCanvas\n    drawFileInCanvas = imageCompression.drawFileInCanvas\n    canvasToFile = imageCompression.canvasToFile\n    getExifOrientation = imageCompression.getExifOrientation\n    handleMaxWidthOrHeight = imageCompression.handleMaxWidthOrHeight\n    followExifOrientation = imageCompression.followExifOrientation\n    cleanupCanvasMemory = imageCompression.cleanupCanvasMemory\n    isAutoOrientationInBrowser = imageCompression.isAutoOrientationInBrowser\n    approximateBelowMaximumCanvasSizeOfBrowser = imageCompression.approximateBelowMaximumCanvasSizeOfBrowser\n    getBrowserName = imageCompression.getBrowserName\n    isIOS = ").concat(isIOS,"\n    \n    getNewCanvasAndCtx = ").concat(getNewCanvasAndCtx,"\n    CustomFileReader = FileReader\n    CustomFile = File\n    MAX_CANVAS_SIZE = ").concat(JSON.stringify(MAX_CANVAS_SIZE),"\n    BROWSER_NAME = ").concat(JSON.stringify(BROWSER_NAME),"\n    function compress (){return (").concat(compress,").apply(null, arguments)}\n\n    // core-js\n    function _slicedToArray(arr, n) { return arr }\n    function _typeof(a) { return typeof a }\n    function _objectSpread2(target) {\n      for (var i = 1; i < arguments.length; i++) {\n        var source = arguments[i] != null ? arguments[i] : {};\n  \n        Object.assign(target, source)\n      }\n  \n      return target;\n    }\n\n    // Libraries\n    const parse = ").concat(parse,"\n    const UPNG = {}\n    UPNG.toRGBA8 = ").concat(UPNG.toRGBA8,"\n    UPNG.toRGBA8.decodeImage = ").concat(UPNG.toRGBA8.decodeImage,"\n    UPNG.decode = ").concat(UPNG.decode,"\n    UPNG.decode._decompress = ").concat(UPNG.decode._decompress,"\n    UPNG.decode._inflate = ").concat(UPNG.decode._inflate,"\n    UPNG.decode._readInterlace = ").concat(UPNG.decode._readInterlace,"\n    UPNG.decode._getBPP = ").concat(UPNG.decode._getBPP," \n    UPNG.decode._filterZero = ").concat(UPNG.decode._filterZero,"\n    UPNG.decode._paeth = ").concat(UPNG.decode._paeth,"\n    UPNG.decode._IHDR = ").concat(UPNG.decode._IHDR,"\n    UPNG._bin = parse(").concat(stringify(UPNG._bin),")\n    UPNG._copyTile = ").concat(UPNG._copyTile,"\n    UPNG.encode = ").concat(UPNG.encode,"\n    UPNG.encodeLL = ").concat(UPNG.encodeLL," \n    UPNG.encode._main = ").concat(UPNG.encode._main,"\n    UPNG.encode.compressPNG = ").concat(UPNG.encode.compressPNG," \n    UPNG.encode.compress = ").concat(UPNG.encode.compress,"\n    UPNG.encode.framize = ").concat(UPNG.encode.framize," \n    UPNG.encode._updateFrame = ").concat(UPNG.encode._updateFrame," \n    UPNG.encode._prepareDiff = ").concat(UPNG.encode._prepareDiff," \n    UPNG.encode._filterZero = ").concat(UPNG.encode._filterZero," \n    UPNG.encode._filterLine = ").concat(UPNG.encode._filterLine,"\n    UPNG.encode.concatRGBA = ").concat(UPNG.encode.concatRGBA,"\n    UPNG.crc = parse(").concat(stringify(UPNG.crc),")\n    UPNG.crc.table = ( function() {\n    var tab = new Uint32Array(256);\n    for (var n=0; n<256; n++) {\n      var c = n;\n      for (var k=0; k<8; k++) {\n        if (c & 1)  c = 0xedb88320 ^ (c >>> 1);\n        else        c = c >>> 1;\n      }\n      tab[n] = c;  }\n    return tab;  })()\n    UPNG.quantize = ").concat(UPNG.quantize," \n    UPNG.quantize.getKDtree = ").concat(UPNG.quantize.getKDtree," \n    UPNG.quantize.getNearest = ").concat(UPNG.quantize.getNearest," \n    UPNG.quantize.planeDst = ").concat(UPNG.quantize.planeDst," \n    UPNG.quantize.dist = ").concat(UPNG.quantize.dist,"     \n    UPNG.quantize.splitPixels = ").concat(UPNG.quantize.splitPixels," \n    UPNG.quantize.vecDot = ").concat(UPNG.quantize.vecDot," \n    UPNG.quantize.stats = ").concat(UPNG.quantize.stats," \n    UPNG.quantize.estats = ").concat(UPNG.quantize.estats,"\n    UPNG.M4 = parse(").concat(stringify(UPNG.M4),")\n    UPNG.encode.concatRGBA = ").concat(UPNG.encode.concatRGBA,'\n    UPNG.inflateRaw=function(){\n    var H={};H.H={};H.H.N=function(N,W){var R=Uint8Array,i=0,m=0,J=0,h=0,Q=0,X=0,u=0,w=0,d=0,v,C;\n      if(N[0]==3&&N[1]==0)return W?W:new R(0);var V=H.H,n=V.b,A=V.e,l=V.R,M=V.n,I=V.A,e=V.Z,b=V.m,Z=W==null;\n      if(Z)W=new R(N.length>>>2<<5);while(i==0){i=n(N,d,1);m=n(N,d+1,2);d+=3;if(m==0){if((d&7)!=0)d+=8-(d&7);\n        var D=(d>>>3)+4,q=N[D-4]|N[D-3]<<8;if(Z)W=H.H.W(W,w+q);W.set(new R(N.buffer,N.byteOffset+D,q),w);d=D+q<<3;\n        w+=q;continue}if(Z)W=H.H.W(W,w+(1<<17));if(m==1){v=b.J;C=b.h;X=(1<<9)-1;u=(1<<5)-1}if(m==2){J=A(N,d,5)+257;\n        h=A(N,d+5,5)+1;Q=A(N,d+10,4)+4;d+=14;var E=d,j=1;for(var c=0;c<38;c+=2){b.Q[c]=0;b.Q[c+1]=0}for(var c=0;\n                                                                                                        c<Q;c++){var K=A(N,d+c*3,3);b.Q[(b.X[c]<<1)+1]=K;if(K>j)j=K}d+=3*Q;M(b.Q,j);I(b.Q,j,b.u);v=b.w;C=b.d;\n        d=l(b.u,(1<<j)-1,J+h,N,d,b.v);var r=V.V(b.v,0,J,b.C);X=(1<<r)-1;var S=V.V(b.v,J,h,b.D);u=(1<<S)-1;M(b.C,r);\n        I(b.C,r,v);M(b.D,S);I(b.D,S,C)}while(!0){var T=v[e(N,d)&X];d+=T&15;var p=T>>>4;if(p>>>8==0){W[w++]=p}else if(p==256){break}else{var z=w+p-254;\n        if(p>264){var _=b.q[p-257];z=w+(_>>>3)+A(N,d,_&7);d+=_&7}var $=C[e(N,d)&u];d+=$&15;var s=$>>>4,Y=b.c[s],a=(Y>>>4)+n(N,d,Y&15);\n        d+=Y&15;while(w<z){W[w]=W[w++-a];W[w]=W[w++-a];W[w]=W[w++-a];W[w]=W[w++-a]}w=z}}}return W.length==w?W:W.slice(0,w)};\n      H.H.W=function(N,W){var R=N.length;if(W<=R)return N;var V=new Uint8Array(R<<1);V.set(N,0);return V};\n      H.H.R=function(N,W,R,V,n,A){var l=H.H.e,M=H.H.Z,I=0;while(I<R){var e=N[M(V,n)&W];n+=e&15;var b=e>>>4;\n        if(b<=15){A[I]=b;I++}else{var Z=0,m=0;if(b==16){m=3+l(V,n,2);n+=2;Z=A[I-1]}else if(b==17){m=3+l(V,n,3);\n          n+=3}else if(b==18){m=11+l(V,n,7);n+=7}var J=I+m;while(I<J){A[I]=Z;I++}}}return n};H.H.V=function(N,W,R,V){var n=0,A=0,l=V.length>>>1;\n        while(A<R){var M=N[A+W];V[A<<1]=0;V[(A<<1)+1]=M;if(M>n)n=M;A++}while(A<l){V[A<<1]=0;V[(A<<1)+1]=0;A++}return n};\n      H.H.n=function(N,W){var R=H.H.m,V=N.length,n,A,l,M,I,e=R.j;for(var M=0;M<=W;M++)e[M]=0;for(M=1;M<V;M+=2)e[N[M]]++;\n        var b=R.K;n=0;e[0]=0;for(A=1;A<=W;A++){n=n+e[A-1]<<1;b[A]=n}for(l=0;l<V;l+=2){I=N[l+1];if(I!=0){N[l]=b[I];\n          b[I]++}}};H.H.A=function(N,W,R){var V=N.length,n=H.H.m,A=n.r;for(var l=0;l<V;l+=2)if(N[l+1]!=0){var M=l>>1,I=N[l+1],e=M<<4|I,b=W-I,Z=N[l]<<b,m=Z+(1<<b);\n        while(Z!=m){var J=A[Z]>>>15-W;R[J]=e;Z++}}};H.H.l=function(N,W){var R=H.H.m.r,V=15-W;for(var n=0;n<N.length;\n                                                                                                 n+=2){var A=N[n]<<W-N[n+1];N[n]=R[A]>>>V}};H.H.M=function(N,W,R){R=R<<(W&7);var V=W>>>3;N[V]|=R;N[V+1]|=R>>>8};\n      H.H.I=function(N,W,R){R=R<<(W&7);var V=W>>>3;N[V]|=R;N[V+1]|=R>>>8;N[V+2]|=R>>>16};H.H.e=function(N,W,R){return(N[W>>>3]|N[(W>>>3)+1]<<8)>>>(W&7)&(1<<R)-1};\n      H.H.b=function(N,W,R){return(N[W>>>3]|N[(W>>>3)+1]<<8|N[(W>>>3)+2]<<16)>>>(W&7)&(1<<R)-1};H.H.Z=function(N,W){return(N[W>>>3]|N[(W>>>3)+1]<<8|N[(W>>>3)+2]<<16)>>>(W&7)};\n      H.H.i=function(N,W){return(N[W>>>3]|N[(W>>>3)+1]<<8|N[(W>>>3)+2]<<16|N[(W>>>3)+3]<<24)>>>(W&7)};H.H.m=function(){var N=Uint16Array,W=Uint32Array;\n        return{K:new N(16),j:new N(16),X:[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],S:[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,999,999,999],T:[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0],q:new N(32),p:[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,65535,65535],z:[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0],c:new W(32),J:new N(512),_:[],h:new N(32),$:[],w:new N(32768),C:[],v:[],d:new N(32768),D:[],u:new N(512),Q:[],r:new N(1<<15),s:new W(286),Y:new W(30),a:new W(19),t:new W(15e3),k:new N(1<<16),g:new N(1<<15)}}();\n      (function(){var N=H.H.m,W=1<<15;for(var R=0;R<W;R++){var V=R;V=(V&2863311530)>>>1|(V&1431655765)<<1;\n        V=(V&3435973836)>>>2|(V&858993459)<<2;V=(V&4042322160)>>>4|(V&252645135)<<4;V=(V&4278255360)>>>8|(V&16711935)<<8;\n        N.r[R]=(V>>>16|V<<16)>>>17}function n(A,l,M){while(l--!=0)A.push(0,M)}for(var R=0;R<32;R++){N.q[R]=N.S[R]<<3|N.T[R];\n        N.c[R]=N.p[R]<<4|N.z[R]}n(N._,144,8);n(N._,255-143,9);n(N._,279-255,7);n(N._,287-279,8);H.H.n(N._,9);\n        H.H.A(N._,9,N.J);H.H.l(N._,9);n(N.$,32,5);H.H.n(N.$,5);H.H.A(N.$,5,N.h);H.H.l(N.$,5);n(N.Q,19,0);n(N.C,286,0);\n        n(N.D,30,0);n(N.v,320,0)}());return H.H.N}()\n    \n    const UZIP = {}\n    UZIP["parse"] = ').concat(UZIP_1.parse,"\n    UZIP._readLocal = ").concat(UZIP_1._readLocal,"\n    UZIP.inflateRaw = ").concat(UZIP_1.inflateRaw,"\n    UZIP.inflate = ").concat(UZIP_1.inflate,"\n    UZIP.deflate = ").concat(UZIP_1.deflate,"\n    UZIP.deflateRaw = ").concat(UZIP_1.deflateRaw,"\n    UZIP.encode = ").concat(UZIP_1.encode,"\n    UZIP._noNeed = ").concat(UZIP_1._noNeed,"\n    UZIP._writeHeader = ").concat(UZIP_1._writeHeader,"\n    UZIP.crc = parse(").concat(stringify(UZIP_1.crc),")\n    UZIP.crc.table = ( function() {\n      var tab = new Uint32Array(256);\n      for (var n=0; n<256; n++) {\n        var c = n;\n        for (var k=0; k<8; k++) {\n          if (c & 1)  c = 0xedb88320 ^ (c >>> 1);\n          else        c = c >>> 1;\n        }\n        tab[n] = c;  }\n      return tab;  })()\n    \n    UZIP.adler = ").concat(UZIP_1.adler,"\n    UZIP.bin = parse(").concat(stringify(UZIP_1.bin),")\n    UZIP.F = {}\n    UZIP.F.deflateRaw = ").concat(UZIP_1.F.deflateRaw,"\n    UZIP.F._bestMatch = ").concat(UZIP_1.F._bestMatch,"\n    UZIP.F._howLong = ").concat(UZIP_1.F._howLong,"\n    UZIP.F._hash = ").concat(UZIP_1.F._hash,"\n    UZIP.saved = ").concat(UZIP_1.saved,"\n    UZIP.F._writeBlock = ").concat(UZIP_1.F._writeBlock,"\n    UZIP.F._copyExact = ").concat(UZIP_1.F._copyExact,"\n    UZIP.F.getTrees = ").concat(UZIP_1.F.getTrees,"\n    UZIP.F.getSecond = ").concat(UZIP_1.F.getSecond,"\n    UZIP.F.nonZero = ").concat(UZIP_1.F.nonZero,"\n    UZIP.F.contSize = ").concat(UZIP_1.F.contSize,"\n    UZIP.F._codeTiny = ").concat(UZIP_1.F._codeTiny," \n    UZIP.F._lenCodes = ").concat(UZIP_1.F._lenCodes," \n    UZIP.F._hufTree = ").concat(UZIP_1.F._hufTree," \n    UZIP.F.setDepth = ").concat(UZIP_1.F.setDepth," \n    UZIP.F.restrictDepth = ").concat(UZIP_1.F.restrictDepth,"\n    UZIP.F._goodIndex = ").concat(UZIP_1.F._goodIndex," \n    UZIP.F._writeLit = ").concat(UZIP_1.F._writeLit," \n    UZIP.F.inflate = ").concat(UZIP_1.F.inflate," \n    UZIP.F._check = ").concat(UZIP_1.F._check," \n    UZIP.F._decodeTiny = ").concat(UZIP_1.F._decodeTiny," \n    UZIP.F._copyOut = ").concat(UZIP_1.F._copyOut," \n    UZIP.F.makeCodes = ").concat(UZIP_1.F.makeCodes," \n    UZIP.F.codes2map = ").concat(UZIP_1.F.codes2map," \n    UZIP.F.revCodes = ").concat(UZIP_1.F.revCodes," \n\n    // used only in deflate\n    UZIP.F._putsE = ").concat(UZIP_1.F._putsE,"\n    UZIP.F._putsF = ").concat(UZIP_1.F._putsF,"\n  \n    UZIP.F._bitsE = ").concat(UZIP_1.F._bitsE,"\n    UZIP.F._bitsF = ").concat(UZIP_1.F._bitsF,"\n\n    UZIP.F._get17 = ").concat(UZIP_1.F._get17,"\n    UZIP.F._get25 = ").concat(UZIP_1.F._get25,"\n    UZIP.F.U = function(){\n      var u16=Uint16Array, u32=Uint32Array;\n      return {\n        next_code : new u16(16),\n        bl_count  : new u16(16),\n        ordr : [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ],\n        of0  : [3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,999,999,999],\n        exb  : [0,0,0,0,0,0,0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4,  4,  5,  5,  5,  5,  0,  0,  0,  0],\n        ldef : new u16(32),\n        df0  : [1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577, 65535, 65535],\n        dxb  : [0,0,0,0,1,1,2, 2, 3, 3, 4, 4, 5, 5,  6,  6,  7,  7,  8,  8,   9,   9,  10,  10,  11,  11,  12,   12,   13,   13,     0,     0],\n        ddef : new u32(32),\n        flmap: new u16(  512),  fltree: [],\n        fdmap: new u16(   32),  fdtree: [],\n        lmap : new u16(32768),  ltree : [],  ttree:[],\n        dmap : new u16(32768),  dtree : [],\n        imap : new u16(  512),  itree : [],\n        //rev9 : new u16(  512)\n        rev15: new u16(1<<15),\n        lhst : new u32(286), dhst : new u32( 30), ihst : new u32(19),\n        lits : new u32(15000),\n        strt : new u16(1<<16),\n        prev : new u16(1<<15)\n      };\n    } ();\n\n    (function(){\n      var U = UZIP.F.U;\n      var len = 1<<15;\n      for(var i=0; i<len; i++) {\n        var x = i;\n        x = (((x & 0xaaaaaaaa) >>> 1) | ((x & 0x55555555) << 1));\n        x = (((x & 0xcccccccc) >>> 2) | ((x & 0x33333333) << 2));\n        x = (((x & 0xf0f0f0f0) >>> 4) | ((x & 0x0f0f0f0f) << 4));\n        x = (((x & 0xff00ff00) >>> 8) | ((x & 0x00ff00ff) << 8));\n        U.rev15[i] = (((x >>> 16) | (x << 16)))>>>17;\n      }\n  \n      function pushV(tgt, n, sv) {  while(n--!=0) tgt.push(0,sv);  }\n  \n      for(var i=0; i<32; i++) {  U.ldef[i]=(U.of0[i]<<3)|U.exb[i];  U.ddef[i]=(U.df0[i]<<4)|U.dxb[i];  }\n  \n      pushV(U.fltree, 144, 8);  pushV(U.fltree, 255-143, 9);  pushV(U.fltree, 279-255, 7);  pushV(U.fltree,287-279,8);\n      /*\n        var i = 0;\n        for(; i<=143; i++) U.fltree.push(0,8);\n        for(; i<=255; i++) U.fltree.push(0,9);\n        for(; i<=279; i++) U.fltree.push(0,7);\n        for(; i<=287; i++) U.fltree.push(0,8);\n        */\n      UZIP.F.makeCodes(U.fltree, 9);\n      UZIP.F.codes2map(U.fltree, 9, U.flmap);\n      UZIP.F.revCodes (U.fltree, 9)\n  \n      pushV(U.fdtree,32,5);\n      //for(i=0;i<32; i++) U.fdtree.push(0,5);\n      UZIP.F.makeCodes(U.fdtree, 5);\n      UZIP.F.codes2map(U.fdtree, 5, U.fdmap);\n      UZIP.F.revCodes (U.fdtree, 5)\n  \n      pushV(U.itree,19,0);  pushV(U.ltree,286,0);  pushV(U.dtree,30,0);  pushV(U.ttree,320,0);\n      /*\n        for(var i=0; i< 19; i++) U.itree.push(0,0);\n        for(var i=0; i<286; i++) U.ltree.push(0,0);\n        for(var i=0; i< 30; i++) U.dtree.push(0,0);\n        for(var i=0; i<320; i++) U.ttree.push(0,0);\n        */\n    })()\n    "))}function generateWorkerScript(){return createWorker("\n    let scriptImported = false\n    self.addEventListener('message', async (e) => {\n      const { file, id, imageCompressionLibUrl, options } = e.data\n      options.onProgress = (progress) => self.postMessage({ progress, id })\n      try {\n        if (!scriptImported) {\n          // console.log('[worker] importScripts', imageCompressionLibUrl)\n          self.importScripts(imageCompressionLibUrl)\n          scriptImported = true\n        }\n        // console.log('[worker] self', self)\n        const compressedFile = await imageCompression(file, options)\n        self.postMessage({ file: compressedFile, id })\n      } catch (e) {\n        // console.error('[worker] error', e)\n        self.postMessage({ error: e.message + '\\n' + e.stack, id })\n      }\n    })\n  ")}function compressOnWebWorker(e,r){return new Promise((function(t,a){var i=cnt+=1;imageCompressionLibUrl||(imageCompressionLibUrl=generateLib()),worker||(worker=generateWorkerScript()),worker.addEventListener("message",(function handler(e){if(e.data.id===i){if(void 0!==e.data.progress)return void r.onProgress(e.data.progress);worker.removeEventListener("message",handler),e.data.error&&a(new Error(e.data.error)),t(e.data.file)}})),worker.addEventListener("error",a),worker.postMessage({file:e,id:i,imageCompressionLibUrl:imageCompressionLibUrl,options:_objectSpread2(_objectSpread2({},r),{},{onProgress:void 0})})}))}function imageCompression(e,r){return new Promise((function(t,a){var i,s,c,l,u,p;if(i=_objectSpread2({},r),c=0,l=i.onProgress,i.maxSizeMB=i.maxSizeMB||Number.POSITIVE_INFINITY,u="boolean"!=typeof i.useWebWorker||i.useWebWorker,delete i.useWebWorker,i.onProgress=function(e){c=e,"function"==typeof l&&l(c)},!(e instanceof Blob||e instanceof CustomFile))return a(new Error("The file given is not an instance of Blob or File"));if(!/^image/.test(e.type))return a(new Error("The file given is not an image"));if(p="undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope,!u||"function"!=typeof Worker||p)return compress(e,i).then(function(e){try{return s=e,$If_3.call(this)}catch(e){return a(e)}}.bind(this),a);var d=function(){try{return $If_3.call(this)}catch(e){return a(e)}}.bind(this),h=function $Try_1_Catch(r){try{return compress(e,i).then((function(e){try{return s=e,d()}catch(e){return a(e)}}),a)}catch(e){return a(e)}};try{return compressOnWebWorker(e,i).then((function(e){try{return s=e,d()}catch(e){return h()}}),h)}catch(e){h()}function $If_3(){try{s.name=e.name,s.lastModified=e.lastModified}catch(e){}return t(s)}}))}imageCompression.getDataUrlFromFile=getDataUrlFromFile,imageCompression.getFilefromDataUrl=getFilefromDataUrl,imageCompression.loadImage=loadImage,imageCompression.drawImageInCanvas=drawImageInCanvas,imageCompression.drawFileInCanvas=drawFileInCanvas,imageCompression.canvasToFile=canvasToFile,imageCompression.getExifOrientation=getExifOrientation,imageCompression.handleMaxWidthOrHeight=handleMaxWidthOrHeight,imageCompression.followExifOrientation=followExifOrientation,imageCompression.cleanupCanvasMemory=cleanupCanvasMemory,imageCompression.isAutoOrientationInBrowser=isAutoOrientationInBrowser,imageCompression.approximateBelowMaximumCanvasSizeOfBrowser=approximateBelowMaximumCanvasSizeOfBrowser,imageCompression.getBrowserName=getBrowserName,imageCompression.version="1.0.17";
//# sourceMappingURL=browser-image-compression.mjs.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "UPca":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/error.6df8266.png";

/***/ }),

/***/ "V57n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wb2M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginlogo.6a71028.png";

/***/ }),

/***/ "XW2A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XuR1":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAACEklEQVQ4je2TP2hUQRDGf7tvn5ozif9yJJqQPxhIYeORIhYRDNeIxkYL0WAlARsL+5TpBdPaBpTrFLQSlWhhYWGhxXGCJpKgqLkk5+XuvbczFvfuDEdA7TMw7PLNfN/OsDOwZ6Z27107NgFcBfLAEBADK8AL4CHwZmeyI5HmvRuYB24CmTbRHiAH3ALuA3PA5k6BDLAITP+l4g7gNjCSVlm1RBIQyTyRTBMJTTeZEHemD9t7EIMhnOwnGOhqxqdTTuA0knFgtvWGNbhclmCiF/3yC5cfQJYr2NPH8MUyGrVangUeOCI/A3RiwGYzuItDmMASF0rIaqVRSX4AMNij+/ElJW27E5hx1P05ADvYRXhjDP9yleTVaqsgrXniQgn/9hvhlVFcLDvjU466DAFQ8/ilNeT9T8JLI0hxAymuE5w9AdagKxWSR58gE0C91cagI5YYQH/U0a/b2OFugql+TGiRUplg8jgcCNAP6/jXa+hGHeKWAI5YVoAeVBtI5NNTGomS4l6hyfsjsOyIZQnI4RUjCmpav0ElISl8hNCi32uY0LYLPLeayKImsmWGuzCnjmDGDqPlOmQ7sJN9KIrGAof2Ycez2NFuNBE0kS1NZNFULz8NgLvphP2PLQB3HIl6GrN9Erjwj+QnKcdbvICXTbxcx8sCXrZTbDffTnOupRxM9fzjdvX2dQb4DDxjl3XeM/gNvHQBdiOoNO8AAAAASUVORK5CYII="

/***/ }),

/***/ "ZTT/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dP0d":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "e+7C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f08t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gu/3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j1MG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jlC0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ke1e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kspH":
/***/ (function(module, exports) {

var url = {
    apiUrl_LoginCheck: '/mobile/j_spring_security_check',
    apiUrl_PwFlag: '/api/v1/pwFlag',
    apiurl_MenuStateManager: '/api/v1/menuStateManager',
    apiurl_Data: '/api/v1/Data',
    apiurl_masterData: '/api/v1/masterdata',
    apiUrl_LoginSearch: '/api/v1/LoginSearch',
    apiUrl_MenuSearch: '/api/v1/MenuSearch',
    apiUrl_Initialization: '/api/v1/initialization',
    apiUrl_AttendExpenseAttendancesExpense: 'api/v1/attendances/expense',
    apiUrl_AttendExpenseAttendances: 'api/v1/attendances',
    apiUrl_StaffAttendances: 'api/v1/staff/attendances',
    apiUrl_StaffTargetYm: 'api/v1/staff/targetYm',
    apiUrl_StaffHourwage: 'api/v1/staff/hourwage',//スタッフ時給取得
    apiUrl_StaffTypeAllowance: 'api/v1/staff/typeAllowance',//各手当時給情報取得
    apiUrl_StaffTotalAllowance: 'api/v1/staff/totalAllowance',//時給合計情報取得
    apiUrl_StaffAllowance: 'api/v1/staff/allowance',//スタッフ案件手当取得
    apiUrl_WorkJobstate: 'api/v1/work/jobstate',//作業開始・終了・戻す
    apiUrl_Check: 'api/v1/check',//チェック
    apiUrl_filesUpdate: '/api/v1/files',
    apiUrl_FilesSearch: '/api/v1/files',
    apiUrl_AttendPhotoInfo: '/api/v1/photoInfo',
    apiUrl_NoticeDetailSearch: '/api/v1/noticeDetail',
    apiUrl_Notice: '/api/v1/notice',
    apiUrl_PwChange: '/api/v1/pwChange',
    apiUrl_PaymentStatus: '/api/v1/paymentStatus',
    apiUrl_PaymentDetail: '/api/v1/paymentDetail',
    apiUrl_MyNoInfo: '/api/v1/myNoInfo',
    apiUrl_ContractStatus: '/api/v1/contractStatus',//契約状況
    apiUrl_ContractStatusNew: '/api/v1/contractStatusNew',//新契約確認情報保存
    apiUrl_ContractDetail: '/api/v1/contractDetail',//契約明細検索
    apiUrl_ContractDetailNew: '/api/v1/contractDetailNew',//新契約明細検索
    apiUrl_SalaryAccountInfo: '/api/v1/salaryAccountInfo',//給与振込口座申請
    apiUrl_BankInfo: '/api/v1/bankInfo',//銀行検索
    apiUrl_BranchInfo: '/api/v1/branchInfo',//支店検索
    apiUrl_ReadFlag: '/api/v1/readFlag',//誓約・同意既読フラグ検索
    apiUrl_PrivateCarInfo: '/api/v1/privateCarInfo',//マイカー通勤申請
    apiUrl_SelfDoc: '/api/v1/selfDoc',//本人確認書類検索
    apiUrl_ResidentCard: '/api/v1/residentCard',//在留カード
    apiUrl_StaffApplyConfirmLog: '/api/v1/staffApplyConfirmLog',//スタッフ申請確認ログ保存
    apiUrl_EmergencyContact: '/api/v1/emergencyContact',//緊急連絡先申請
    apiUrl_AddressData: '/api/v1/bo/addressdata', //共通住所
    apiUrl_BasicStaffInfo: '/api/v1/basicStaffInfo',//スタッフ基本情報申請
    apiUrl_UserInfo: '/api/v1/userInfo',//社員情報検索
    apiUrl_PwReset: '/api/v1/pwReset',//パスワードリセット用社員情報検索
    apiUrl_TempCode: '/api/v1/tempCode',//パスワードリセット認証コード
    apiUrl_myCarUseInfo: '/api/v1/myCarUseInfo',//マイカー使用有無検索
    apiUrl_holidaySearch: '/api/v1/bo/holiday',//有休申請一覧検索
    apiUrl_holidayDetailSearch: '/api/v1/bo/holidayDetail',//有休申請詳細検索 
    apiUrl_holidaySave: '/api/v1/bo/holidayDetail',//有休申請一覧検索
    apiUrl_jobIntroSearch: '/api/v1/bo/jobIntro',//お仕事案内一覧検索
    apiUrl_jobSelectSearch: '/api/v1/bo/jobSelect',//お仕事選択一覧検索
    apiUrl_jobDetailSearch: '/api/v1/bo/jobDetail',//お仕事詳細一覧検索
    apiUrl_jobApplySearch: '/api/v1/bo/jobApply',//お仕事申請一覧検索
    apiUrl_jobApplyUpdate: '/api/v1/bo/jobApply',//お仕事申請保存
    apiUrl_storeFieldInfo: '/api/v1/storeFieldInfo',//店舗現場情報-検索
    apiUrl_googleapis: '/api/v1/googleapis',//googleapis-検索
    apiUrl_expcgi: '/api/v1/expcgi',//ekispert-検索
    apiUrl_laberNoticeInfo: '/api/v1/bo/laberNoticeInfo',// 労働条件通知書検索
    apiUrl_laborNoticeOutput: '/api/v1/bo/laborNoticeOutput',// 労働条件通知書PDF
    apiUrl_workAmountList: '/api/v1/bo/workAmountList',// 作業量一覧検索
    apiUrl_WorksCwSelect: 'api/v1/works/cw',//作業実績情報（通常）-検索

    routerUrl_Login: '/login',
    routerUrl_PasswordReset: '/passwordReset',
    routerUrl_PasswordResetDeliver: '/passwordResetDeliver',
    routerUrl_Top: '/top',
    routerUrl_Menu: '/Menu',
    routerUrl_K0001: '/k0001',
    routerUrl_K0002: '/k0002',
    routerUrl_K0003: '/k0003',
    routerUrl_K0005: '/k0005',
    routerUrl_K0006: '/k0006',
    routerUrl_K0007: '/k0007',
    routerUrl_K0008: '/k0008',
    routerUrl_I0001: '/i0001',
    routerUrl_I0002: '/i0002',
    routerUrl_I0003: '/i0003',
    routerUrl_I0004: '/i0004',
    routerUrl_DialogAddress: '/DialogAddress',
    routerUrl_I0005: '/i0005',
    routerUrl_I0006: '/i0006',
    routerUrl_I0007: '/i0007',
    routerUrl_I0008: '/i0008',
    routerUrl_I0009: '/i0009',
    routerUrl_I0010: '/i0010',
    routerUrl_I0011: '/i0011',
    routerUrl_I0012: '/i0012',
    routerUrl_I0013: '/i0013',

    routerUrl_I0014: '/i0014',
    routerUrl_I0015: '/i0015',
    routerUrl_I0016: '/i0016',
    routerUrl_I0017: '/i0017',
    routerUrl_I0018: '/i0018',
    routerUrl_I0019: '/i0019',
    routerUrl_I0020: '/i0020',

    routerUrl_C0001: '/c0001',
    routerUrl_C0002: '/c0002',
    routerUrl_C0003: '/c0003',
    routerUrl_S0001: '/s0001',
    routerUrl_D0001: '/d0001',
    routerUrl_P0001: '/p0001',
    routerUrl_P0002: '/p0002',
    routerUrl_P0003: '/p0003',
    routerUrl_P0004: '/p0004',
    routerUrl_B0001: '/b0001',
    routerUrl_B0002: '/b0002',
    routerUrl_W0001: '/w0001',
    routerUrl_W0002: '/w0002',
    routerUrl_Error: '/error',

    imgUrl_UserInfo: 'image/userInfo/',//写真path

    axiosBaseURL: 'https://rmsa-s.ajis-group.com',
    routerUrl_K0006_btn1URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUN1JIVFhYTUFPMkJEV0YyMzROVEw1N09HSy4u',
    routerUrl_K0006_btn2URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUNUhaQU5RRlZPNlVFQ0NSWUMxUkRJWDZJSi4u',
    routerUrl_K0006_btn3URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUMzVLODNPQUQxVlRYTE8wMlU5MkU4MDFWVC4u',
    routerUrl_K0006_btn4URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUQlBEMzAyMUxSUE5VUjJCWDFHTENCNDVRMi4u',
    routerUrl_K0006_btn5URL: 'https://teachme.jp/81935/manuals/9882163/',
    routerUrl_K0008_btn1URL: 'https://teachme.jp/81935/manuals/11145917/',
    routerUrl_K0005_btn1URL: 'https://cloud.staffexpress.jp/ajis/neo/index.php',
    routerUrl_K0005_btn2URL: 'http://www.ajis-mds.co.jp/corporate/branches/',
    routerUrl_K0005_btn3URL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm-z1cK7MiIJLkAt28D4VRDRUOURBNkFaVUdNUjlYMlBGSUxRTVlWRURXNSQlQCN0PWcu',
    routerUrl_paid_apply: 'https://forms.office.com/Pages/ResponsePage.aspx?id=4BSUQiHSVECyFSho-oAHm9TFrTuNbhdNvCjtOrjqVUJUQ1BYVDFPRTM2VEFVWkpLWTAyNE1ZUURFVS4u',
    routerUrl_I0011_btn1URL: 'image/workRule/嘱託社員就業規則＆ハラスメント防止規程&育児・介護休業等に関する規則.pdf',
    routerUrl_I0011_btn2URL: 'image/workRule/個人情報取得及び取扱い明示.pdf',
    routerUrl_I0011_btn3URL: 'image/workRule/給与支払方法の明示.pdf',
    routerUrl_I0011_btn4URL: 'image/workRule/雇用契約書の電磁的交付による明示.pdf',
    routerUrl_I0011_btn5URL: 'image/workRule/給与明細等の電磁的交付による明示書.pdf',
    routerUrl_I0014_btn1URL: 'https://teachme.jp/81935/manuals/9734936/',
    routerUrl_I0014_btn2URL: 'https://teachme.jp/81935/manuals/7692119/',

    routerUrl_immediate_payment: 'https://amsit.ajis-group.com/search-job/',//メニュー - タイムシート - お仕事紹介 （本番環境）
    routerUrl_job_introduction: 'https://amsit.ajis-group.com/payment/',//メニュー - タイムシート - 即払い （本番環境）
}

module.exports = url

/***/ }),

/***/ "l5D2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l7Pl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "muAb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o8uO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p9DJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pQD1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qjLl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sMHB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u4ma":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vSyV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wNQb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x55n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zHK8":
/***/ (function(module, exports) {

module.exports = {"COMMON":{"LBL_VER":"Ver.3.0.11","LBL_DATE":"期間","LBL_CORPORATION":"企業","LBL_STORE":"店舗","LBL_SALES_PLACE":"営業所","LBL_STATE":"状態","LBL_PERSON":"担当者","LBL_CLASSIFICATION":"中分類","LBL_PROFESSION":"職種","LBL_ATTENDANCE":"勤怠","LBL_WORK_PW":"作業PW","LBL_WORK_CW":"作業CW","LBL_REPORT":"報告","LBL_WORKDAY":"作業日","LBL_SEARCH":"検索","LBL_USER_NAME":"氏名","BTN_SAVE":"保存","BTN_UPDATE":"更新","BTN_CANCEL":"キャンセル","BTN_BACK":"戻る","BTN_CONFIRM":"確認","BTN_CONTINUE":"継続","BTN_CHANGE":"修正","BTN_REGIST":"登録","BTN_APPLY":"申請","BTN_PREVIOUS_PAGE":"前のページ","BTN_NEXT_PAGE":"次のページ","MSG_DELETE_CONFIRM":"はい","MSG_DELETE_CANCEL":"いいえ","CONFIRM":"確認","PLACEHOLDER_SELECT":"選択してください","LOGIN_LBL_USER":"ログインID","LOGIN_LBL_PASWD":"パスワード","LOGIN_LBL_LOGIN":"ログイン","LOGIN_LBL_LOGINING":"ログイン...","LOGIN_LBL_USERCD_CHECK":"ログインIDを入力してください。","LOGIN_LBL_PASSWORD_CHECK":"パスワードを入力してください。","LOGIN_LBL_LOGINCHECK_ERROR":"ログインID、またはパスワードが違います。","LOGIN_BUTTON":"パスワードリセット","NO_TARGET_DATA":"該当データがありません。","ERROR_LBL_MODORU":"戻る","ERROR_LBL_MSG1":"不正な処理が行われました。","ERROR_LBL_MSG2":"多発するようであれば、状況をｼｽﾃﾑ部に連絡してください。","UPDATED":"更新しました。","CURD_ERROR":"予期せぬトラブルが発生しました。多発するようであれば状況をｼｽﾃﾑ部に連絡してください。","EXCLUSIVE":"処理が失敗しました。他の人が先に更新した可能性があります。最新情報を取得しますか。","MSG_TIME_VALIDITY":"0000～4600までの数値4桁で入力してください。最大46：00まで。","MSG_TIME_VALIDITY_24":"0000～2359までの数値4桁で入力してください。最大23：59まで。","MSG_SAVE":"保存します。よろしいですか？","CHECK_ERROR":"チェックエラ―","MSG_AMOUNT_VALIDITY":"{0}は{1}桁以下の整数を入力してください。","STORE_INOUT_MSG_EQUIRED_VALIDITY":"入店と退店は入力必須です。","STORE_IN_MSG_EQUIRED_VALIDITY":"入店は入力必須です。","STORE_OUT_MSG_EQUIRED_VALIDITY":"退店は入力必須です。","MSG_STORE_INOUT_VALIDITY":"退店時刻は入店時刻より後の時刻を入力してください。","MSG_STORE_INOUT_SA_VALIDITY":"退店時刻－入店時刻＜24時間で入力してください。","MSG_RESTTIME_VALIDITY":"休憩時間を正しく入力してください。","MSG_GOODS_INPUT_VALIDITY":"移動KMは整数部6桁以下、小数部1桁以下で入力してください。","MSG_ERROR_STATE_OVER":"既に「作業完了」です。他の人が先に更新した可能性があります。最新情報を取得しますか？","MSG_ERROR_STORE_INOUT_JOBDATE":"作業日が異なります。退店できません。","MSG_MESSAGE_INSTORE":"入店します。よろしいですか？","MSG_MESSAGE_OUTSTORE":"退店します。よろしいですか？","MSG_MESSAGE_ERROR_INSTORE":"退店時刻は入店時刻より後の時刻を入力してください。","MSG_MESSAGE_ERROR_FROMDATE":"終了日は開始日と同じか後の日付を設定してください。","MSG_ERROR_INSTORE_JOBDATE":"作業日が異なります。入店できません。","MSG_ERROR_OUTSTORE_INSTORE_NULL":"入店していないため、退店できません。","MSG_ERROR_OUTSTORE_24":"退店時刻を入力できるのは最大46：00までです。","MSG_MESSAGE_CHANGE_BACK":"変更があります。破棄して一覧に戻りますか？","MSG_RETRUN":"変更があります。破棄しますか？","MSG_KINTAITIME_VALIDITY":"「入退店：{0}」と「入退店：{1}」の勤怠時間が重複しています。","MSG_ERROR_TIMEOUT":"タイムアウトが発生しました。","MSG_NETWORK_ERROR":"ネットワークエラーが発生しました。","MSG_APPROVAL":"既に勤怠承認済です。他の人が先に更新した可能性があります。最新情報を取得しますか？","MSG_TRANSMIT":"既に連携済です。他の人が先に更新した可能性があります。最新情報を取得しますか？","MSG_NO_SUBJECT":"スキル賃金制度対象外です。","MSG_TARGETYM":"対象年月データが不正です。","MSG_JOBSTATE":"作業開始します。よろしいですか？","MSG_EXPENSE_CHECK1":"入力額を再確認してください。（{0}の{1}円超）","MSG_EXPENSE_CHECK3":"入力額を再確認してください。（電車バスとガソリンが同時申請）","MSG_EXPENSE_CHECK5":"入力額を再確認してください。（移動、運転手当の入力）","MSG_EXPENSE_CHECK6":"入力額を再確認してください。（移動手当と移動運転手当が同時申請）","MSG_EXPENSE_CHECK7":"入力額を再確認してください。（食事補助と出張手当の同時申請）","MSG_ERROR_DEPART_JOBDATE":"作業日が異なるため開始できません。","MSG_ERROR_QIUT_CHECK":"作業終了します。よろしいでしょうか。","MSG_KINTAI_CHECK1":"配置と実績の時間に大きな差異があります。","MSG_KINTAI_CHECK2":"休憩時間を再確認してください。（実働8H超で休憩1H未満）","MSG_KINTAI_CHECK3":"休憩時間を再確認してください。（実働6H超で休憩0.75H未満）","MSG_KINTAI_CHECK4":"残業時間を再確認してください。（残業4H超過）","MSG_KINTAI_CHECK5":"勤怠を確認してください。","MSG_KINTAI_CHECK_TITTLE":"下記の警告を確認してください。","MSG_PERSONAL_PHOTO":"経費金額が0の箇所に貼付されている写真を削除します。よろしいですか？","MSG_INSERTED":"保存しました。","MSG_CURD_ERROR":"処理が失敗しました。","MSG_SIGN_NOT_INPUT":"本人サイン未記入の勤怠があるため、作業完了できません。","MSG_UPDATED":"更新しました。","MSG_STOREOUT_EXPENSE":"退店が押下されていなければ保存できません。","MSG_IMAGE_DEL":"写真を削除します。よろしいですか？","MSG_PICTURE_FORMAT":"保存できる画像ファイル形式は「jpg, png, bmp, gif,jpeg」のみです。","MSG_STAFF_NOT_EXIST":"該当するスタッフCDがありません。","MSG_ADDRESS_EXIST":"該当スタッフNoのメールアドレスが空白。","MSG_PWRESET_INFO_ERROR":"生年月日、または電話番号が違います。","MSG_PWRESET_OK":"ワンタイムパスワードを送信しました、メールをご確認ください。","MSG_STAFF_NO_VALIDITY":"スタッフNoが8桁の半角数字で入力してください。","MSG_BIRTHDAY_VALIDITY":"生年月日が8桁の半角数字で入力してください。","MSG_PWRESET_VALIDITY":"パスワードは半角英数字を混在させて、6～10桁で入力してください。","MSG_NEWPW_VALIDITY":"新しいパスワードと確認パスワードが一致しません。もう一度入力してください。","MSG_SHIFT_LOCK":"選択した社員は既にシフトロックされています。最新情報を取得してください。","MSG_NO_BANK":"候補に該当する銀行が登録されていません。","MSG_NO_BRANCH":"候補に該当する支店が存在しません。","MSG_APPROVED":"既に承認済です。他の人が先に更新した可能性があります。最新情報を取得しますか？","MSG_EQUIRED_VALIDITY":"{1}は入力必須です。","MSG_TAB_CHANGE":"変更があります。破棄しますか？","MSG_CONFIRM_CHANGE":"データを保存します。よろしいですか？","MSG_CONFIRM_WARNING":"下記の警告を確認してください。","MSG_PHOTO_CHECK":"領収書写真を添付してください。","MSG_APPLY_CONFIRM":"申請します。よろしいですか？","MSG_MESSAGE_DEPARTURE_CALL":"出発記録します。よろしいですか？","MSG_TEMPCODE_ERROR":"認証コードが違います。","MSG_TEMPCODE_OK":"認証しました。","MSG_MESSAGETIMESHEET_PHOTO_CHECK":"タイムシート写真を添付してください。","MSG_MESSAGE_RETURN_SAVE_OVER":"お疲れ様でした。気を付けてお帰りください。経費入力があれば忘れずに入力をお願いします。","MSG_MESSAGE_RETURN_CALL_MEMO":"退店コール時メモを保存します。よろしいですか？","MSG_MESSAGE_DEPARTURE_CALL_MEMO":"出発コール時メモを保存します。よろしいですか？","MSG_EMAIL_NOT_EXIST":"該当スタッフCDはメール未登録のため送信できません。","MSG_DEPARTURE_CALL_IN_VALIDITY":"入店は出発コールより後の時刻を入力してください。","MSG_RETURN_CALL_OUT_VALIDITY":"退店コールは退店より後の時刻を入力してください。","MSG_MYNO_VALIDITY":"申請(12桁)は12桁の数字を入力してください。","MSG_MYCAR_USE_CHE":"マイカー使用無のため、入力画面へ遷移できません。","MSG_MYCAR_PERIOD_CHECK":"マイカー通勤・業務使用必要書類に有効期限が切れているものがあります。申請を行ってください。","MSG_PASTDATE_SELECT":"過去年月が申請できません。","MSG_HOLIDAY_NOT_ENOUGH":"有休残日数が不足しています。申請できません。","MSG_ERROR_MAIL_ADDRESS":"正確なメールアドレスを入力してください。","MSG_JOB_ALREADY_APPLY":"別の現場を申請しました、申請できません。","MSG_SHIFT_APPLY_END_TIME_VALIDITY":"出勤終了時間を入力してください。","MSG_SHIFT_APPLY_START_TIME_VALIDITY":"出勤開始時間を入力してください。","MSG_SHIFT_APPLY_PERIOD_VALIDITY":"終了は開始より後に設定してください。","MSG_KINTAI_INPUT":"出勤区分が{0}の場合、{1}は入力できません。","MSG_JOB_DATE_ALREADY_APPLY":"{1}に別の現場を申請しました、申請できません。","MSG_DUPLICATE_VALIDITY":"{0}が重複しています。","MSG_KINTAI_DIV_CHK1":"出勤区分が{0}の場合、2件以上の勤怠は入力できません。","MSG_KINTAI_DIV_CHK2":"複数の勤怠を入力する場合、出勤区分は一致させる必要があります。","MSG_NO_AUTHORITY":"権限がありません。","MSG_EXPENSE_CHECK11":"自動計算結果を削除します。※交通費直接入力はラウンダー業務、宿泊地出発、自動計算不可ルートのみ使用してください。","MSG_EXPENSE_CHECK12":"交通費直接入力を削除します。よろしいですか？","MSG_EXPENSE_CHECK13":"別現場より移動をチェックした場合、現場は入力必須です。","MSG_ZERO_RESULTS":"緯度或いは経度が無効です。ご確認ください。","MSG_EXPENSE_CHECK14":"移動手段検索条件を変更したため、交通費を再検索してください。","MSG_EXPCGI_ERROR":"出発駅或いは目的駅が無効です。ご確認ください。","MSG_VER_UPDATE_CONFIRM":"バージョンアップしたので、再度ログインしてください。","MSG_WORK_AMOUNT_CLR":"作業数量をリセットします、よろしいですか？","MSG_WORK_PIC_DEL":"受領書写真を削除します、よろしいですか？","MSG_PRODUCT_NUMBERS_CHECK1":"商品CD({0})は数量＜＝{1}で入力してください。","MSG_PRODUCT_NUMBERS_CHECK2":"商品CD({0})は数量が{1}の整数倍で入力してください。","MSG_PRODUCT_NUMBERS_CHECK3":"商品CD({0})の数量は入力必須です。","STORE_SIGN_CHECK":"店舗サイン済です。変更しますか？","MINSTOREIN_CHECK":"クルーイングより1時間以上早いです。開始してよろしいですか？","STATE_ING":"既に「作業中」です。他の人が先に更新した可能性があります。最新情報を取得しますか？","MSG_STATUS_ERROR":"ステータスが「クルー確定」以外のスケジュールは開始できません。","SOTRESIGN_NOT_INPUT":"店舗サインがありません。作業完了してもよろしいですか？","STORETIME_NOT_INPUT":"入店または退店時刻が未入力の勤怠があるため作業完了できません。","WORK_NOT_INPUT":"作業実績がないため作業完了できません。","MSG_PRODUCT_UNMATCH":"現場曜日別商品が変更されました。作業実績を再保存してください。","MSG_STOREIN_CHECK":"作業日が異なるため開始できません。","MSG_STOREIN_COMFIRM":"作業開始します。よろしいですか？","MSG_STOREOUT_COMFIRM_MSG":"作業完了します。よろしいですか？","MSG_STOREOUT_BACK_MSG":"作業中に戻ります。よろしいですか？","":""},"MODULE":{"MENU_LBL_STAFFINFO":"スタッフ情報","MENU_LBL_SHUKKINN":"シフト申請","MENU_LBL_KINTAI":"勤怠入力","MENU_LBL_KEIHI":"経費入力","MENU_LBL_HOURLYWAGE":"スキル確認","MENU_LBL_TOIAWASE":"問合せ","MENU_LBL_PROFILE":"プロフィール申請","MENU_LBL_TEMPORARYPAYMENT":"仮払申請","MENU_LBL_PAYROLL":"給与明細","MENU_LBL_SOURCEVOTE":"源泉徴収票","MENU_LBL_MYNANBAR":"マイナンバー","MENU_LBL_SCHEDULE":"スケジュール","MENU_LBL_PAIDAPPLY":"有休申請","MENU_LBL_WORKBAG":"お仕事案内","MENU_LBL_JOB_INTRODUCTION":"ジョブ☆リターン","MENU_LBL_IMMEDIATE_PAYMENT":"即払い","MENU_LBL_MYNANBAR_APPLICATION":"マイナンバー申請","MENU_LBL_CONTRACT_INQUIRY":"契約照会","MENU_LBL_PAY_INQUIRY":"給与照会","MENU_LBL_BASIC_STAFF_INFO":"スタッフ基本情報","MENU_LBL_IDENTITY_DOCUMENT":"本人確認書類","MENU_LBL_NATIONALITY_CONFIRM":"国籍確認","MENU_LBL_SALARY_ACCOUNT":"給与振込口座","MENU_LBL_EMERGENCY_CONTACT":"緊急連絡先","MENU_LBL_RESID_CARDNUM":"在留カード番号","MENU_LBL_CAR_WORK":"マイカー通勤<br />・業務使用","MENU_LBL_OATH_AGREE":"誓約·同意","MENU_LBL_TRAINING":"初期トレーニング","MENU_LBL_TIMESHEET":"タイムシート","MENU_LBL_AMOUNT":"作業量一覧","B0001_LBL_INFORM":"お知らせ","B0001_LBL_CLOSE":"閉じる","B0002_LBL_MAILSENDUSER":"配信者","B0002_LBL_HEIGHT":"高","B0002_LBL_MAILDATE":"配信日","B0002_LBL_MAILTITLE":"タイトル","B0002_LBL_MAILATTACHMENT":"内容","B0002_LBL_LINK":"リンク","B0002_LBL_FILE":"ファイル","B0002_LBL_BACK":"戻る","I0001_LBL_BASIC_INFO":"基本情報","I0001_LBL_STAFF_CD":"スタッフCD","I0001_LBL_USERNAME":"氏名","I0001_LBL_BIRTHDAY":"生年月日","I0001_LBL_GENDER":"性別","I0001_LBL_ZIPCODE":"郵便番号","I0001_LBL_GET_ADDRESS":"住所取得","I0001_LBL_ADDRESS":"住所","I0001_LBL_ADDRESS_KANA":"住所カナ","I0001_LBL_NEAREST_STATION":"最寄り駅","I0001_LBL_NEAREST_STATION_BUS":"最寄りバス停","I0001_LBL_TEL_NUMBER":"携帯番号","I0001_LBL_HOME_NUMBER":"電話番号","I0001_LBL_PC_MAIL":"PCメール","I0001_LBL_TEL_MAIL":"携帯メール","I0001_LBL_SALESOFFICE":"営業所","I0001_LBL_APPLY":"申請","I0001_MSG_WHICH_VALIDITY":"「{1}」あるいは「{2}」のいずれを入力してください。","I0001_MSG_ADDRESS1":"住所1","I0001_MSG_CELL_PHONE_FORMAT":"携帯番号形式が「XX-XXXX-XXXX」のみ指定してください","I0001_MSG_PHONE_FORMAT":"電話番号形式が「XXXX-XX-XXXX」のみ指定してください","I0001_MSG_GENDERA":"男","I0001_MSG_GENDERB":"女","I0001_LBL_MYCAR_USE":"マイカー使用","I0001_RDO_YU":"有","I0001_RDO_MU":"無","I0002_LBL_TITLE":"本人確認書類の利用目的","I0002_LBL_TEXT1":"給与所得・退職所得の源泉徴収票作成事務","I0002_LBL_TEXT2":"給与所得者の扶養控除等(異動)申告書作成事務","I0002_LBL_TEXT3":"給与所得者の保険料控除申告書作成事務","I0002_LBL_TEXT4":"給与所得者の配偶者特別控除申告書作成事務","I0002_LBL_TEXT5":"地方税に関する事務","I0002_LBL_TEXT6":"労働保険(労災保険・雇用保険)に関する事務","I0002_LBL_TEXT7":"健康保険・厚生年金保険法に関する事務","I0002_LBL_TEXT8":"国民健康保険法の第3号被保険者制度に関する事務","I0002_LBL_ABOVE_AGREE":"上記内容に同意します。","I0002_LBL_INPUT_PAGE":"入力画面","I0002_LBL_BACK":"戻る","I0003_LBL_TEXT1":"口座は、従業員本人のものに限ります。親族、法人等名義の口座への振込はできません。(普通口座のみ)<br />※別人の名義の口座は、見つけ次第削除いたしますので、再登録をして頂くタイミングによっては入金が遅れる事があります。","I0003_LBL_TEXT2":"登録された口座には、給与、立替経費、仮払金、還付金の振込を行い、それ以外の用途では使用しません。","I0003_LBL_TEXT3":"内容に変更があった場合は、すみやかに登録内容を修正してください。給与締め後の変更に関しては次回からの変更になる場合があります。","I0003_LBL_TEXT4":"※入力した文字を含む銀行名が候補として表示されます。","I0003_LBL_TEXT5":" ※入力した文字を含む支店名が候補として表示されます。<br />※支店名のみの入力はできません。銀行名入力後に支店名を入力してください。","I0003_LBL_SUPPLY_INFO":"支給情報","I0003_LBL_BANKNAME":"銀行名","I0003_LBL_BRANCHNAME":"支店名","I0003_LBL_ACCOUNT_CLASSIFICATION":"口座区分","I0003_LBL_NORMAL":"普通","I0003_LBL_OVERDRAFT":"当座","I0003_LBL_ACCOUNT_NUMBER":"口座番号","I0003_LBL_NOMINAL_NAME":"名義人名","I0003_LBL_NOMINAL_KANA":"名義人ｶﾅ","I0003_LBL_TEXT6":"※半角で入力ください。","I0003_LBL_APPLY":"申請","I0003_LBL_APPLYING":"申請中","I0005_LBL_PURPOSE":"利用目的","I0005_LBL_TITLE":"マイナンバー取得の利用目的","I0005_LBL_TEXT1":"給与所得・退職所得の源泉徴収票作成事務","I0005_LBL_TEXT2":"給与所得者の扶養控除等(異動)申告書作成事務","I0005_LBL_TEXT3":"給与所得者の保険料控除申告書作成事務","I0005_LBL_TEXT4":"給与所得者の配偶者特別控除申告書作成事務","I0005_LBL_TEXT5":"地方税に関する事務","I0005_LBL_TEXT6":"労働保険(労災保険・雇用保険)に関する事務","I0005_LBL_TEXT7":"健康保険・厚生年金保険法に関する事務","I0005_LBL_TEXT8":"国民健康保険法の第3号被保険者制度に関する事務","I0005_LBL_ABOVE_AGREE":"上記内容に同意します。","I0005_BTN_TEXT1":"入力画面","I0005_LBL_CONSENT":"マイナンバー提出を拒否します。","I0005_BTN_TEXT2":"確定","I0005_MSG_MYNO_AGREE_REFUSE":"同意・拒否は同時にチェックできません。","I0005_LBL_TEXT":"マイナンバーを就業先への届出を拒むことは出来ますが、法定調書作成などに際し、個人番号の記載は国税通則法および所得税法で定められた義務となります。","I0006_LBL_TITLE":"本人のマイナンバー申請","I0006_LBL_LABEL1":"申請(12桁)","I0006_LBL_LABEL2":"確認(12桁)","I0006_LBL_SELF_CONFIRM":"本人の確認資料","I0006_LBL_DATA_CONFIRM":"確認資料","I0006_LBL_FRONT_SIDE":"表面","I0006_LBL_FRONTPHOTO_SIDE":"表面写真","I0006_LBL_BACK_SIDE":"裏面","I0006_LBL_BACKPHOTO_SIDE":"裏面写真","I0006_LBL_SELECTED":"選択","I0006_LBL_APPLY":"申請","I0006_LBL_BACK":"戻る","I0006_LBL_APPLYING":"申請中","I0006_LBL_TEXT":"※裏面に何も記載無くても、記載なしの証明として必要です。","I0006_ERR_MSG2":"不正のコードがあります","I0006_ERR_MSG3":"申請(12桁)と確認(12桁)の入力値が一致していません。","I0007_LBL_TITLE":"在留カード・特別永住者証明書情報","I0007_LBL_FULLNAME":"氏名<br />(Full Name)","I0007_LBL_NATIONALITY":"国籍<br />(Nationality)","I0007_LBL_RESIDENCE_CARD_NO":"在留カード番号<br />(Residence Card No.)","I0007_LBL_RESIDENCE_CARD_EXP":"在留カード期限<br />(Residence Card Exp Date)","I0007_LBL_RESIDENCE_CARD_FRONTSIDEPHOTO":"在留カード写真<br />(Residence Card FrontsidePhoto)","I0007_LBL_RESIDENCE_CARD_BACKSIDEPHOTO":"在留カード裏写真<br />(Residence Card BacksidePhoto)","I0007_LBL_APPLY":"申請","I0007_LBL_BACK":"戻る","I0007_MSG_UPLOAD_PHOTO_FRONT":"写真（表面）をアップロードしてください。","I0007_MSG_UPLOAD_PHOTO_BACK":"写真（裏面）をアップロードしてください。","I0009_LBL_SELF_CONFIRM":"本人確認","I0009_LBL_DATA_CONFIRM":"確認資料","I0009_LBL_FRONT_SIDE":"表面","I0009_LBL_BACK_SIDE":"裏面","I0009_LBL_TEXT":"※裏面に何も記載無くても、記載なしの証明として必要です","I0009_LBL_APPLY":"申請","I0009_LBL_BACK":"戻る","I0009_MSG_SELECT_CHANGE":"変更があります。キャンセルしますか。","I0009_MSG_SELF":"確認資料を選択してください。","I0009_MSG_PHOTO1":"写真（表面）をアップロードしてください。","I0009_MSG_PHOTO2":"写真（裏面）をアップロードしてください。","I0010_LBL_TEXT":"国籍の確認は、外国籍の方の在留資格や就労制限の有無を確認するために必要となります。当社での就労に対し適切な就労許可があるかの確認となり、外国籍差別を助長するものではありません。","I0010_LBL_BTN1":"日本国籍の方","I0010_LBL_BTN2":"外国籍の方","I0011_LBL_BTN1":"嘱託社員就業規則、<br/><br/>ハラスメント防止規程、<br/><br/>育児・介護休業等に関する規則","I0011_LBL_BTN2":"個人情報の取<br/><br/>扱いに関する<br/><br/>告知","I0011_LBL_BTN3":"勤務をするに<br/><br/>あたっての<br/><br/>誓約","I0011_LBL_BTN4":"給与支払方法<br/><br/>に付いての<br/><br/>明示","I0011_LBL_BTN5":"雇用契約書の電<br/><br/>磁的交付による<br/><br/>明示","I0011_LBL_BTN6":"給与明細等の電<br/><br/>磁的交付による<br/><br/>明示","I0011_LBL_CONSENT":"上記内容を誓約・同意します。","I0011_LBL_APPLY":"雇用契約締結へ","I0011_LBL_TITLE":"各項目について確認してください。","I0012_LBL_PASSWORD_CHANGE":"パスワード変更","I0012_LBL_NEW_PASSWORD":"新パスワード","I0012_LBL_NEW_PASSWORD_CONFIRM":"新パスワード(確認)","I0012_LBL_CHANGE":"変更","I0012_LBL_TOP_WARN":"仮パスワードのため、パスワード変更が必要です。新しいパスワードを入力してください。","I0012_LBL_BOTTOM_WARN":"※パスワードは半角英数字を混在させて、6桁以上10桁以内で入力してください。","I0013_LBL_NAME":"氏名","I0013_LBL_NUMBER":"スタッフCD","I0013_LBL_ADDRESS":"営業所","I0013_LBL_TEXT_A":"全ての項目を入力・申請後に確認ができてからの許可となります。","I0013_LBL_TEXT_B":"【必要な書類】（このアプリにて撮影します）","I0013_LBL_TEXT_C":"1．車検証の写し","I0013_LBL_TEXT_D":"2．任意保険証の写し","I0013_LBL_TEXT_E":"3．運転免許証の写し（表面・裏面）","I0013_LBL_TEXT_F":"通勤許可申請条件への承諾","I0013_LBL_TEXT_G":"使用車両が申請者本人","I0013_LBL_TEXT_H":"(もしくは同居親族所有)","I0013_LBL_TEXT_I":"「業務・通勤」（現場から現場への異動、自宅から現場及び現場から自宅への移動等）において、私有車を使用する場合は常に安全運転を心掛け、道路交通法を遵守することを誓約します。","I0013_LBL_TEXT_J":"また、使用する私有車は任意保険（対人：無制限・対物：無制限・人身傷害保険に加入し、交通事故及び駐車場内での事故が発生した場合には、自己の自賠責保険、任意保険で対応する事に同意いたします。","I0013_LBL_TEXT_O":"上記内容に同意します。","I0013_LBL_TEXT_P":"誓約","I0013_BTN_INPUT_PICTURE":"入力画面","I0013_BTN_YES":"はい","I0013_BTN_NO":"いいえ","I0014_LBL_BTN1":"初期トレーニング","I0014_LBL_BTN2":"コンプライアンス","I0015_BTN_ADD":"追加","I0015_LBL_APPLY_DATE":"申請日","I0015_LBL_STATE":"状態","I0015_LBL_ADMINISTRATOR":"承認者","I0015_LBL_HOLIDAY_APPLY":"有休申請","I0015_LBL_TODAY_APPLY":"当日申請","I0016_LBL_REMAND_REASON":"差戻理由","I0008_LBL_TEXT_A":"登録番号(ナンバープレート)","I0008_LBL_TEXT_REI":"例）幕張500あ-123","I0008_LBL_TEXT_C":"運転免許証期限","I0008_LBL_TEXT_D":"車検証期限","I0008_LBL_TEXT_E":"任意保険期限","I0008_LBL_TEXT_PHOTO":"写真","I0008_LBL_TEXT_FRONT":"表面","I0008_LBL_TEXT_BACK":"裏面","I0008_LBL_TEXT_I":"裏面に何も記載がなくても、記載なしの証明として必要です。","I0008_LBL_TEXT_J":"2輪車に関しては下記届出を対象とする。","I0008_LBL_TEXT_50":"50cc～125cc：標識交付証明書","I0008_LBL_TEXT_125":"125cc～250cc：軽自動車届出済証","I0008_LBL_TEXT_250":"250cc：自動車検査証","I0008_LBL_TEXT_KEIYAKUSHAMEI":"契約者名・有効期限・車両番号・補償内容(対人・対物・障害補償)の確認を行います。記載が2枚もしくは表裏にわたっている場合はそれぞれ写真を撮影してください。","I0008_LBL_TEXT_N":"任意保険条件内容","I0008_LBL_TEXT_O":"1．対人保証：無制限","I0008_LBL_TEXT_P":"2．対物保証：無制限","I0008_LBL_TEXT_Q":"3．人身傷害補償または搭乗者傷害補償加入","I0008_BTN_YES":"はい","I0008_BTN_NO":"いいえ","I0008_LBL_APPLICATIONING":"申請中","I0008_BTN_APPLICATION":"申請","I0008_MSG_EQUIRED_VALIDITY":"{0}は入力必須です。","I0008_MSG_FILE_VALIDITY":"保険ファイル","I0008_MSG_WHICH_VALIDITY":"「{1}」あるいは「{2}」のいずれを入力してください。","I0008_MSG_RADIO_VALIDITY":"{0}が「はい」以外の場合、申請できません。","I0008_MSG_A_VALIDITY":"登録番号","I0008_MSG_B_VALIDITY":"運転免許証期限","I0008_MSG_C_VALIDITY":"免許証表面写真","I0008_MSG_D_VALIDITY":"免許証裏面写真","I0008_MSG_E_VALIDITY":"車検証期限","I0008_MSG_F_VALIDITY":"車検証写真","I0008_MSG_G_VALIDITY":"任意保険期限","I0008_MSG_H_VALIDITY":"保険写真","I0008_MSG_I_VALIDITY":"対人保証 ： 無制限","I0008_MSG_J_VALIDITY":"対物保証 ： 無制限","I0008_MSG_K_VALIDITY":"人身傷害補償または搭乗者傷害補償加入","I0016_LBL_CANCLE":"取消し","I0017_LBL_REQUEST":"申請","I0017_LBL_RECRUIT":"募集","I0017_LBL_START_AND_END":"開始終了","I0017_LBL_OVER":"終了","I0017_LBL_COL1":"作業日","I0017_LBL_COL2":"店舗","I0017_LBL_COL3":"お仕事内容","I0017_LBL_COL4":"開始","I0017_LBL_COL5":"終了","I0017_LBL_COL6":"勤務希望","I0017_LBL_COL7":"備考","I0018_LBL_BASIC_INFO":"お仕事紹介","I0018_LBL_COL1":"作業日","I0018_LBL_COL2":"店舗","I0018_LBL_COL3":"住所","I0018_LBL_COL4":"お仕事内容","I0018_LBL_COL5":"開始時刻","I0018_LBL_COL6":"終了時刻","I0018_LBL_COL7":"休憩時間","I0018_LBL_COL8":"勤務時間","I0018_LBL_COL9":"時給単価","I0018_LBL_COL10":"担当者","I0018_LBL_COL11":"連絡先","I0018_LBL_COL12":"集合場所","I0018_LBL_COL13":"集合時刻","I0018_LBL_COL14":"勤務希望","I0018_LBL_COL15":"備考","I0018_LBL_BTN1":"保存","I0018_LBL_BTN2":"キャンセル","I0019_LBL_WORK_AREA":"作業場所","I0019_LBL_WORK_DATE":"作業期間","I0019_LBL_TRAFFIC_COST":"交通費","I0019_LBL_DETAIL_TITLE":"お仕事詳細","I0020_LBL_MARU":"〇","I0020_LBL_CROSS":"×","I0020_LBL_WORK_TIME":"出勤可能時間帯","I0008_BTN_FILE":"選択ファイル","I0008_MSG_SIZECHECK":"添付ファイルのサイズが大きすぎます。合計10MB以内にしてください。","I0008_MSG_PDF":"PDFファイルを選択してください。","I0008_MSG_VIEW":"保存前はプレビューできません。","K0001_LBL_TITTLE":"勤怠一覧","K0001_LBL_col1":"作業日\nステータス\n出勤区分","K0001_LBL_col2":"企業名\n現場名\nサービス名","K0001_LBL_col3":"入店予定\n入店実績","K0001_LBL_col4":"退店予定\n退店実績","K0001_LBL_col5":"労働\n条件\n通知書","K0001_LBL_YO":"(予)","K0001_LBL_JI":"(実)","K0001_BTN_INSTORE":"入店","K0001_BTN_OUTSTORE":"退店","K0001_BTN_DEPART":"出発コール","K0001_BTN_QUIT":"退店コール","K0002_LBL_ATTENDANCE":"出勤区分","K0002_LBL_TITTLE":"勤怠詳細","K0002_LBL_WORKDAY":"作業日","K0002_LBL_CORPORATION_NAME":"企業名","K0002_LBL_STORE_NAME":"現場名","K0002_LBL_USER_NAME":"氏名","K0002_LBL_POSITION":"役職","K0002_LBL_DAY_TEAM":"当日チーム","K0002_LBL_IN_STORE":"入店時刻","K0002_LBL_OUT_STORE":"退店時刻","K0002_LBL_NORMAL_REST":"普通休憩","K0002_LBL_DARK_REST":"深夜休憩","K0002_LBL_TRANSPORT_EXPENSE":"交通費実費","K0002_LBL_CATEGORY_GAS_EXPENSE":"移動km ｶﾞｿﾘﾝ精算","K0002_LBL_CATEGORY_EXPENSE":"移動km","K0002_LBL_GAS_EXPENSE":"ｶﾞｿﾘﾝ精算","K0002_LBL_TRAVEL_ALLOWANCE":"移動・移動運転手当","K0002_LBL_COMMUTION_COSTS":"通勤費","K0002_LBL_TRIP_TRANSPORT_EXPENSE":"交通費(出張)","K0002_LBL_LODGING":"宿泊費","K0002_LBL_TRIP_ALLOWANCE":"食事補助・出張日当","K0002_LBL_CONSUMABLES":"消耗・通信・破損","K0002_LBL_DAMAGED_PURCHASE":"オリテン費用","K0002_LBL_ECOAS_TRANSPORT_EXPENSE":"ECOAS精算（旅費)","K0002_LBL_ECOAS_GAS":"ECOAS精算(燃料)","K0002_LBL_WORK_TIME":"実働時間","K0002_LBL_LATENIGHT_WORK_TIEM":"⇒内深夜実働時間","K0002_LBL_ALL_REST_TIME":"全休憩時間","K0002_LBL_INLATE_BREAK":"⇒内深夜休憩","K0002_LBL_DEPART":"出発コール時メモ","K0002_LBL_QUIT":"退店コール時メモ","K0002_LBL_PHOTO_INFO":"タイムシート写真","K0002_MSG_NO_STOREOUT":"退店時刻が入力されていません。仮保存しますか？","K0002_MSG_PHOTO_FORMART":"写真形式が「jpg, png, bmp, gif」のみ指定してください","K0002_MSG_PHOTO_SIZE":"タイムシートのサイズを1M以内にしてください。","K0003_LBL_TITTLE":"スキル確認","K0003_LBL_MONTH":"月","K0003_LBL_YEAR":"年","K0003_LBL_NAME":"氏名","K0003_LBL_USERID":"スタッフCD","K0003_LBL_POINT":"勤務営業所","K0003_LBL_HOURWAGE":"営業所時給","K0003_LBL_SUMWORKTIME":"累積勤務時間","K0003_LBL_LEVEL":"判定レベル","K0003_LBL_SKILL":"スキル手当","K0003_LBL_ST":"ST処遇","K0003_LBL_CR":"CR処遇","K0003_LBL_MD":"MD処遇","K0003_LBL_GYOUMU":"業務","K0003_LBL_KIGYO":"企業名\n現場CD","K0003_LBL_STORE":"店舗名\n店舗役職名","K0003_LBL_ALLOWANCE":"案件手当\n支払時給","K0003_LBL_BUSINESSTYPE":"業務形態","K0003_LBL_BUSINESSTYPE_ALLOWANCE":"手当名","K0003_LBL_BUSINESSTYPE_SKILLLEVEL":"レベル","K0003_LBL_BUSINESSTYPE_HOURWAGE":"金額","K0003_LBL_BUSINESSTYPE_TOTALALLOWANCE":"手当合計名","K0003_LBL_BUSINESSTYPE_TOTALHOURWAGE":"金額合計","K0004_LBL_TITTLE":"経費フォーム","K0004_LBL_BTN1":"MD東日本","K0004_LBL_BTN2":"MD首都圏","K0004_LBL_BTN3":"MD中日本","K0004_LBL_BTN4":"MD西日本","K0004_LBL_BTN5":"経費マニュアル","K0005_LBL_TITTLE":"問合せ","K0005_LBL_BTN1":"問合せ連絡先<br/>(オフィス事務センター)","K0005_LBL_BTN2":"ハラスメント相談窓口<br/>(社内相談フォーム)","K0005_LBL_BTN3":"ハラスメント相談窓口<br/>(社外メール相談)","K0005_LBL_BTN4":"StaffExpressNEO<br/>ログイン","K0006_LBL_TITTLE":"経費一覧","K0006_LBL_col1":"作業日\nステータス\n出勤区分","K0006_LBL_col2":"企業名\n現場名\nサービス名","K0006_LBL_col3":"入店予定\n入店実績","K0006_LBL_col4":"退店予定\n退店実績","K0006_LBL_YO":"（予）","K0006_LBL_JI":"（実）","K0007_LBL_TITTLE":"経費詳細","K0007_LBL_FIELDNAME":"現場名","K0007_LBL_KMPRICE":"ガソリン","K0007_LBL_TRAINBUS":"電車・バス","K0007_LBL_PARKINGFEE":"駐車代","K0007_LBL_RECEIPTPHOTO":"領収書写真","K0007_LBL_ROADFEE":"有料道路代","K0007_LBL_MOVEALLOWANCE":"移動手当","K0007_LBL_DRIVERALLOWANCE":"移動運転手当","K0007_LBL_OTHERSEXPENSES":"消耗・通信・破損・運搬","K0007_LBL_TRANSPORTEXPENSESTRIP":"公共移動(出張)","K0007_LBL_ACCOMMODATION":"宿泊費","K0007_LBL_ALLOWANCETRIP":"食事補助","K0007_LBL_TRIPALLOWANCEMANAGER":"出張手当(管理職以上)","K0007_LBL_ACTUALCOSTTOTAL":"実費計","K0007_LBL_TOTAL":"合計","K0007_LBL_TRANSPORTEXPENSE_AUTO":"交通費自動計算","K0007_LBL_TRANSPORTEXPENSE_MANUAL":"交通費直接入力","K0007_LBL_TRANSPORTFLAG":"移動手段検索条件","K0007_LBL_TRANSPORTFLAG_NO":"なし","K0007_LBL_TRANSPORTFLAG_MYCAR":"マイカー","K0007_LBL_TRANSPORTFLAG_BUS":"電車・バス","K0007_LBL_OTHERFIELDFLAG_OK":"作業終了後帰宅","K0007_LBL_OTHERFIELDFLAG_NO":"帰宅せず別現場へ","K0007_LBL_INITIALLYFIELDFLAG":"別現場より移動","K0007_LBL_FIELDCODE":"現場コード","K0007_LBL_KM":"移動km","K0007_LBL_KMPRICE_FEE":"ｶﾞｿﾘﾝ精算","K0007_LBL_ROUTE":"経路詳細","K0007_BTN_YES":"はい","K0007_BTN_NO":"いいえ","K0008_LBL_TITTLE":"オフィス事務センター","K0008_LBL_BTN1":"オフィス事務センター<br/>問合せ方法","K0008_LBL_BTN2":"オフィス事務センター<br/>に電話する","K0009_LBL_TITLE":"運行日報一覧","K0009_LBL_CARNUMBER":"車台番号","K0009_LBL_COL1":"出発時間\n到着時間","K0009_LBL_COL2":"出発地\n行き先","K0009_LBL_COL3":"走行距離(㎞)\n給油(ℓ)","W0001_LBL_COL1":"作業日\nステータス","W0001_LBL_COL2":"企業名\n現場名\nサービス名","W0001_LBL_COL3":"現場CD","W0002_LBL_CORPORATION_NAME":"企業名","W0002_LBL_STORE_NAME":"現場名","W0002_LBL_PHOTO_INFO":"受領書写真","W0002_LBL_BTN1_1":"作業開始","W0002_LBL_BTN1_2":"作業完了","W0002_LBL_BTN1_3":"作業中へ戻す","W0002_LBL_BTN2":"作業量入力無し","W0002_LBL_BTN3":"受領書無し","W0002_LBL_TEXTERA1":"特記事項","W0002_NO_MHCHECK":"商品数量が大きすぎます。確認してください。 ","K0010_LBL_TITLE":"運行日報入力","K0010_LBL_DEPARTURE_TIME":"出発時間","K0010_LBL_ARRIVAL_TIME":"到着時間","K0010_LBL_DEPARTURE_POINT":"出発地","K0010_LBL_DESTINATION":"行き先","K0010_LBL_DISTANCE":"走行距離(㎞)","K0010_LBL_REFUEL":"給油(ℓ)","K0010_LBL_OPERATION_INSPECTION":"運行前点検","K0010_LBL_EXPENSE_DEPARTMENT":"経費負担部署","K0011_LBL_TITLE":"各項目について確認してください。","K0011_LBL_COLUMN1":"選択","K0011_LBL_COLUMN2":"就業日","K0011_LBL_COLUMN3":"就業現場名\n業務名","K0011_LBL_COLUMN4":"仮払対象金額\n仮払金額(80％)","K0011_LBL_MSG1":"申請状況一覧","K0011_LBL_MSG2":"仮払い希望日と仮払方法を選び、勤務実績の行を選択してください","K0011_LBL_MSG3":"仮払方法","K0011_LBL_MSG4":"現金","K0011_LBL_MSG5":"銀行振込","K0011_LBL_MSG6":"コメント","K0011_LBL_MSG7":"申請","K0011_LBL_MSG8":"希望日:","K0016_LBL_COLUMN1":"仮払日","K0016_LBL_COLUMN2":"就業日","K0016_LBL_COLUMN3":"申請金額","K0016_LBL_COLUMN4":"仮払合計","K0016_LBL_COLUMN5":"状況","K0016_LBL_MSG1":"前月","K0016_LBL_MSG2":"翌月","K0016_LBL_MSG3":"新規申請","K0016_LBL_MSG4":"※詳細は行をクリックしてください。","P0001_LBL_COLUMN1":"月","P0001_LBL_COLUMN2":"種類","P0001_LBL_COLUMN3":"確認日時","P0001_LBL_LASTYEAR":"前年","P0001_LBL_NEXTYEAR":"翌年","P0001_LBL_SALARY":"給与","P0001_LBL_BONUS":"賞与","P0001_LBL_SOURCE":"源泉","P0002_LBL_MONTH":"年","P0002_LBL_YEAR":"月","P0002_TITLE":"給与明細","P0003_TITLE":"賞与明細","P0004_TITLE":"源泉明細","K0013_LBL_MESSAGE":"ファイル名をクリックするとダウンロードできます。","K0013_LBL_TITTLE":"タイトル","K0013_LBL_FILE":"ファイル名","K0013_LBL_MEMO":"メモ","C0001_LBL_COLUMN1":"月","C0001_LBL_COLUMN2":"種類","C0001_LBL_COLUMN3":"同意日時","C0001_LBL_MSG1":"前年","C0001_LBL_MSG2":"翌年","C0001_LBL_MSG3":"※詳細は行をクリックしてください","C0002_LBL_CHECKBOX1":"上記各誓約内容を確認し、</br>誠実に勤務することを誓約します。","C0002_LBL_CHECKBOX2":"上記内容に同意します。","C0002_BTN_APPLY":"同意","C0002_BTN_RETURN":"戻る","C0002_BTN_PRINT":"印刷","C0003_TITLE":"労働条件通知書","C0003_BTN_PRINT":"印刷","C0003_PDF_NAME":"労働条件通知書","I0004_LBL_TITLE":"緊急連絡先情報","I0004_LBL_POSTCODE":"郵便番号","I0004_LBL_GETHOME":"住所取得","I0004_LBL_HOME":"住所","I0004_LBL_CARRYCODE":"携帯番号","I0004_LBL_TELCODE":"電話番号","I0004_LBL_CALLNAME":"連絡先名","I0004_LBL_RELAT":"続柄","I0004_LBL_APPLY":"申請","I0004_LBL_BACK":"戻る","I0004_MSG_WHICH_VALIDITY":"「{1}」あるいは「{2}」のいずれを入力してください。","I0004_MSG_ADDRESS1":"住所1","I0004_MSG_CELL_PHONE_FORMAT":"携帯番号形式が「XX-XXXX-XXXX」のみ指定してください","I0004_MSG_PHONE_FORMAT":"電話番号形式が「XXXX-XX-XXXX」のみ指定してください","S0001_MAIN_TITTLE_TAB1":"シフト申請","S0001_MAIN_TITTLE_TAB2":"配置表示","S0001_MAIN_TITTLE_TAB3":"勤務実績表示","S0001_LBL_RADIO_CALENDER":"カレンダー表示","S0001_LBL_RADIO_LIST":"リスト表示","S0001_LBL_PREMONTH":"前月","S0001_LBL_TODAY":"今月","S0001_LBL_NEXTMONTH":"翌月","S0001_TITTLE_ATTENTIMELONG":"出勤可能時間帯：","S0001_TITTLE_READY":"備考：","S0001_LBL_JOBDATE":"日付","S0001_LBL_ATTENDANCEDIV":"区分","S0001_LBL_TIMELONG":"出勤可能時間帯","S0001_LBL_READY":"備考","S0001_LBL_CALENDAR_SUN":"日","S0001_LBL_CALENDAR_MON":"月","S0001_LBL_CALENDAR_TUE":"火","S0001_LBL_CALENDAR_WED":"水","S0001_LBL_CALENDAR_THU":"木","S0001_LBL_CALENDAR_FRI":"金","S0001_LBL_CALENDAR_SAT":"土","S0001_LBL_JOBDATE_BUSINESS_NAME":"日付\nサービス名","S0001_LBL_COMPANY_STORE_NAME":"企業名\n現場名","S0001_LBL_STORE_IN_OUT":"開始時刻\n終了時刻","S0001_LBL_BUSINESS_NAME":"サービス名","S0001_LBL_COMPANY_NAME":"企業名","S0001_LBL_STORE_NAME":"現場名","S0001_LBL_STORE_IN":"開始時刻","S0001_LBL_STORE_OUT":"終了時刻","S0001_LBL_STORE_ADDRESS":"現場住所","S0001_LBL_GATHER_PLACE":"集合場所","S0001_LBL_STORE_MEMO":"メモ","S0001_LBL_LOCKED_DONE":"シフトロック済","S0001_LBL_LOCKED_OUT_OBJECT":"シフト申請対象外","S0001_LBL_TAB1_LONG_ATTENTION":"出勤可能時間帯は、時間指定のある場合のみ入力ください","S0001_LBL_TAB3_STORE_IN":"出勤時刻","S0001_LBL_TAB3_STORE_OUT":"退勤時刻","S0001_LBL_TAB3_BREAK_TIME":"総休憩時間","S0001_LBL_TAB3_LATENIGHT_BREAK_TIME":"深夜休憩時間","S0001_LBL_TAB3_WORK_TIME":"総勤務時間","S0001_LBL_TAB3_OVER_TIME":"残業時間","S0001_LBL_TAB3_HOURLY_WAGE":"契約時給","S0001_LBL_TAB3_TRANSPORT_FEE":"交通費合計","S0001_LBL_TAB3_JOBDATE":"日付","S0001_LBL_TAB3_STORE_IN_OUT":"出勤\n退勤","S0001_LBL_TAB3_LATENIGHT_AND_BREAK":"総休憩\n深夜休憩","S0001_LBL_TAB3_WORK_OVER_TIME":"総勤務\n残業","S0001_LBL_TAB3_HOURLY_WAGE_TRANSPORT_FEE":"時給\n交通費","S0001_TAB_MSG1":"終了は開始より後に設定してください。","S0001_TAB_MSG2":"全ての日付を設定してください。","S0001_TAB_MSG3":"明日以降の日付を全て設定してください。","S0001_TAB_MSG4":"過去日付のシフトを更新することができません。","PASSWORDRESET_MSG_MSG":"初めてログインする方、パスワード<br/>を失念された方は、","PASSWORDRESET_MSG_MSG1":"下のパスワードリセットボタンを<br/>押して下さい。","PASSWORDRESET_MSG_MSG2":"例)　7月1日　⇒　0701","PASSWORDRESET_MSG_MSG3":"パスワードを失念された方は、<br/>下のパスワードリセットボタンを</br>押して下さい。","PASSWORDRESET_MSG_MSG4":"その他の問合せは、<br/>オフィス事務センターへ","PASSWORDRESET_MSG_MSG5":"パスワードリセットのご案内","PASSWORDRESET_MSG_MSG6":"認証コードが作成されている<br/>メールアドレス宛に送信します。","PASSWORDRESET_MSG_MSG7":"送信された認証コードにより<br/>ログインして下さい。<br/>その後、新しいパスワードを登<br/>録してください。","PASSWORDRESET_MSG_MSG8":"30分後に認証コードは無効と<br/>なりますのでご注意下さい。","PASSWORDRESET_MSG_MSG9":"なりすまし防止のため、登録されたメール<br/>アドレス宛にのみ送信されます。","PASSWORDRESET_MSG_MSG10":"スタッフCD（8桁以下は頭0埋め）<br/>生年月日（例：19650101）<br/>電話番号（&quot-&quotは不要）<br/>を入力して送信ボタンをタップして下さい。","PASSWORDRESET_BUTTON_NAME":"パスワードリセット","PASSWORDRESET_BUTTON_NAME1":"問合せ連絡先<br/><br/>(オフィス事務センター)","PASSWORDRESET_DIALOG_TITLE":"パスワードリセット","PASSWORDRESET_LBL_BACK":"送信","PASSWORDRESET_LBL_STAFF_NO":"スタッフCD","PASSWORDRESET_LBL_PHONE_NO":"電話番号","PASSWORDRESET_LBL_BIRTHDAY":"生年月日","PASSWORDRESET_LBL_STAFF_NO_DIALOG":"スタッフCD:","PASSWORDRESET_LBL_CONFIRM_DIALOG":"メールに載っている認証コードを入力してください：","DIALOG_LBL_ADDRESS_CONDITIONS":"住所検索","DIALOG_LBL_TOTAL_PAGE":"件/ページ","DIALOG_LBL_TOTAL":"合計","DIALOG_LBL_TOTAL_PIECE":"件","DIALOG_LBL_STATE":"都道府県","DIALOG_LBL_CITY":"市区町村","DIALOG_LBL_OAZAMA_CHICHOME":"大字町丁目","DIALOG_LBL_ADDRESS_BANCHI":"番地","DIALOG_TBL_CHOOSE":"選択","DIALOG_LBL_LONGITUDE":"経度","DIALOG_LBL_LATITUDE":"緯度"}}

/***/ }),

/***/ "zQ9H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zQWP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zl0I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c374fa7e8b3ebae8531f.js